(typeof document !== "undefined") && (typeof navigator !== "undefined") && (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.lottie = factory());
})(this, (function () { 'use strict';

  var svgNS = 'http://www.w3.org/2000/svg';
  var locationHref = '';
  var _useWebWorker = false;
  var initialDefaultFrame = -999999;
  var setWebWorker = function setWebWorker(flag) {
    _useWebWorker = !!flag;
  };
  var getWebWorker = function getWebWorker() {
    return _useWebWorker;
  };
  var setLocationHref = function setLocationHref(value) {
    locationHref = value;
  };
  var getLocationHref = function getLocationHref() {
    return locationHref;
  };

  function createTag(type) {
    // return {appendChild:function(){},setAttribute:function(){},style:{}}
    return document.createElement(type);
  }

  function extendPrototype(sources, destination) {
    var i;
    var len = sources.length;
    var sourcePrototype;
    for (i = 0; i < len; i += 1) {
      sourcePrototype = sources[i].prototype;
      for (var attr in sourcePrototype) {
        if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
      }
    }
  }
  function getDescriptor(object, prop) {
    return Object.getOwnPropertyDescriptor(object, prop);
  }
  function createProxyFunction(prototype) {
    function ProxyFunction() {}
    ProxyFunction.prototype = prototype;
    return ProxyFunction;
  }

  // import Howl from '../../3rd_party/howler';

  var audioControllerFactory = function () {
    function AudioController(audioFactory) {
      this.audios = [];
      this.audioFactory = audioFactory;
      this._volume = 1;
      this._isMuted = false;
    }
    AudioController.prototype = {
      addAudio: function addAudio(audio) {
        this.audios.push(audio);
      },
      pause: function pause() {
        var i;
        var len = this.audios.length;
        for (i = 0; i < len; i += 1) {
          this.audios[i].pause();
        }
      },
      resume: function resume() {
        var i;
        var len = this.audios.length;
        for (i = 0; i < len; i += 1) {
          this.audios[i].resume();
        }
      },
      setRate: function setRate(rateValue) {
        var i;
        var len = this.audios.length;
        for (i = 0; i < len; i += 1) {
          this.audios[i].setRate(rateValue);
        }
      },
      createAudio: function createAudio(assetPath) {
        if (this.audioFactory) {
          return this.audioFactory(assetPath);
        }
        if (window.Howl) {
          return new window.Howl({
            src: [assetPath]
          });
        }
        return {
          isPlaying: false,
          play: function play() {
            this.isPlaying = true;
          },
          seek: function seek() {
            this.isPlaying = false;
          },
          playing: function playing() {},
          rate: function rate() {},
          setVolume: function setVolume() {}
        };
      },
      setAudioFactory: function setAudioFactory(audioFactory) {
        this.audioFactory = audioFactory;
      },
      setVolume: function setVolume(value) {
        this._volume = value;
        this._updateVolume();
      },
      mute: function mute() {
        this._isMuted = true;
        this._updateVolume();
      },
      unmute: function unmute() {
        this._isMuted = false;
        this._updateVolume();
      },
      getVolume: function getVolume() {
        return this._volume;
      },
      _updateVolume: function _updateVolume() {
        var i;
        var len = this.audios.length;
        for (i = 0; i < len; i += 1) {
          this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }
    };
    return function () {
      return new AudioController();
    };
  }();

  var createTypedArray = function () {
    function createRegularArray(type, len) {
      var i = 0;
      var arr = [];
      var value;
      switch (type) {
        case 'int16':
        case 'uint8c':
          value = 1;
          break;
        default:
          value = 1.1;
          break;
      }
      for (i = 0; i < len; i += 1) {
        arr.push(value);
      }
      return arr;
    }
    function createTypedArrayFactory(type, len) {
      if (type === 'float32') {
        return new Float32Array(len);
      }
      if (type === 'int16') {
        return new Int16Array(len);
      }
      if (type === 'uint8c') {
        return new Uint8ClampedArray(len);
      }
      return createRegularArray(type, len);
    }
    if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
      return createTypedArrayFactory;
    }
    return createRegularArray;
  }();
  function createSizedArray(len) {
    return Array.apply(null, {
      length: len
    });
  }

  function _typeof$6(o) { "@babel/helpers - typeof"; return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$6(o); }
  var subframeEnabled = true;
  var expressionsPlugin = null;
  var expressionsInterfaces = null;
  var idPrefix$1 = '';
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var _shouldRoundValues = false;
  var bmPow = Math.pow;
  var bmSqrt = Math.sqrt;
  var bmFloor = Math.floor;
  var bmMax = Math.max;
  var bmMin = Math.min;
  var BMMath = {};
  (function () {
    var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
    var i;
    var len = propertyNames.length;
    for (i = 0; i < len; i += 1) {
      BMMath[propertyNames[i]] = Math[propertyNames[i]];
    }
  })();
  function ProjectInterface$1() {
    return {};
  }
  BMMath.random = Math.random;
  BMMath.abs = function (val) {
    var tOfVal = _typeof$6(val);
    if (tOfVal === 'object' && val.length) {
      var absArr = createSizedArray(val.length);
      var i;
      var len = val.length;
      for (i = 0; i < len; i += 1) {
        absArr[i] = Math.abs(val[i]);
      }
      return absArr;
    }
    return Math.abs(val);
  };
  var defaultCurveSegments = 150;
  var degToRads = Math.PI / 180;
  var roundCorner = 0.5519;
  function roundValues(flag) {
    _shouldRoundValues = !!flag;
  }
  function bmRnd(value) {
    if (_shouldRoundValues) {
      return Math.round(value);
    }
    return value;
  }
  function styleDiv(element) {
    element.style.position = 'absolute';
    element.style.top = 0;
    element.style.left = 0;
    element.style.display = 'block';
    element.style.transformOrigin = '0 0';
    element.style.webkitTransformOrigin = '0 0';
    element.style.backfaceVisibility = 'visible';
    element.style.webkitBackfaceVisibility = 'visible';
    element.style.transformStyle = 'preserve-3d';
    element.style.webkitTransformStyle = 'preserve-3d';
    element.style.mozTransformStyle = 'preserve-3d';
  }
  function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
    this.type = type;
    this.currentTime = currentTime;
    this.totalTime = totalTime;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }
  function BMCompleteEvent(type, frameMultiplier) {
    this.type = type;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }
  function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
    this.type = type;
    this.currentLoop = currentLoop;
    this.totalLoops = totalLoops;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }
  function BMSegmentStartEvent(type, firstFrame, totalFrames) {
    this.type = type;
    this.firstFrame = firstFrame;
    this.totalFrames = totalFrames;
  }
  function BMDestroyEvent(type, target) {
    this.type = type;
    this.target = target;
  }
  function BMRenderFrameErrorEvent(nativeError, currentTime) {
    this.type = 'renderFrameError';
    this.nativeError = nativeError;
    this.currentTime = currentTime;
  }
  function BMConfigErrorEvent(nativeError) {
    this.type = 'configError';
    this.nativeError = nativeError;
  }
  function BMAnimationConfigErrorEvent(type, nativeError) {
    this.type = type;
    this.nativeError = nativeError;
  }
  var createElementID = function () {
    var _count = 0;
    return function createID() {
      _count += 1;
      return idPrefix$1 + '__lottie_element_' + _count;
    };
  }();
  function HSVtoRGB(h, s, v) {
    var r;
    var g;
    var b;
    var i;
    var f;
    var p;
    var q;
    var t;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch (i % 6) {
      case 0:
        r = v;
        g = t;
        b = p;
        break;
      case 1:
        r = q;
        g = v;
        b = p;
        break;
      case 2:
        r = p;
        g = v;
        b = t;
        break;
      case 3:
        r = p;
        g = q;
        b = v;
        break;
      case 4:
        r = t;
        g = p;
        b = v;
        break;
      case 5:
        r = v;
        g = p;
        b = q;
        break;
      default:
        break;
    }
    return [r, g, b];
  }
  function RGBtoHSV(r, g, b) {
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    var h;
    var s = max === 0 ? 0 : d / max;
    var v = max / 255;
    switch (max) {
      case min:
        h = 0;
        break;
      case r:
        h = g - b + d * (g < b ? 6 : 0);
        h /= 6 * d;
        break;
      case g:
        h = b - r + d * 2;
        h /= 6 * d;
        break;
      case b:
        h = r - g + d * 4;
        h /= 6 * d;
        break;
      default:
        break;
    }
    return [h, s, v];
  }
  function addSaturationToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[1] += offset;
    if (hsv[1] > 1) {
      hsv[1] = 1;
    } else if (hsv[1] <= 0) {
      hsv[1] = 0;
    }
    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }
  function addBrightnessToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[2] += offset;
    if (hsv[2] > 1) {
      hsv[2] = 1;
    } else if (hsv[2] < 0) {
      hsv[2] = 0;
    }
    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }
  function addHueToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[0] += offset / 360;
    if (hsv[0] > 1) {
      hsv[0] -= 1;
    } else if (hsv[0] < 0) {
      hsv[0] += 1;
    }
    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }
  var rgbToHex = function () {
    var colorMap = [];
    var i;
    var hex;
    for (i = 0; i < 256; i += 1) {
      hex = i.toString(16);
      colorMap[i] = hex.length === 1 ? '0' + hex : hex;
    }
    return function (r, g, b) {
      if (r < 0) {
        r = 0;
      }
      if (g < 0) {
        g = 0;
      }
      if (b < 0) {
        b = 0;
      }
      return '#' + colorMap[r] + colorMap[g] + colorMap[b];
    };
  }();
  var setSubframeEnabled = function setSubframeEnabled(flag) {
    subframeEnabled = !!flag;
  };
  var getSubframeEnabled = function getSubframeEnabled() {
    return subframeEnabled;
  };
  var setExpressionsPlugin = function setExpressionsPlugin(value) {
    expressionsPlugin = value;
  };
  var getExpressionsPlugin = function getExpressionsPlugin() {
    return expressionsPlugin;
  };
  var setExpressionInterfaces = function setExpressionInterfaces(value) {
    expressionsInterfaces = value;
  };
  var getExpressionInterfaces = function getExpressionInterfaces() {
    return expressionsInterfaces;
  };
  var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
    defaultCurveSegments = value;
  };
  var getDefaultCurveSegments = function getDefaultCurveSegments() {
    return defaultCurveSegments;
  };
  var setIdPrefix = function setIdPrefix(value) {
    idPrefix$1 = value;
  };
  var getIdPrefix = function getIdPrefix() {
    return idPrefix$1;
  };

  function createNS(type) {
    // return {appendChild:function(){},setAttribute:function(){},style:{}}
    return document.createElementNS(svgNS, type);
  }

  function _typeof$5(o) { "@babel/helpers - typeof"; return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$5(o); }
  var dataManager = function () {
    var _counterId = 1;
    var processes = [];
    var workerFn;
    var workerInstance;
    var workerProxy = {
      onmessage: function onmessage() {},
      postMessage: function postMessage(path) {
        workerFn({
          data: path
        });
      }
    };
    var _workerSelf = {
      postMessage: function postMessage(data) {
        workerProxy.onmessage({
          data: data
        });
      }
    };
    function createWorker(fn) {
      if (window.Worker && window.Blob && getWebWorker()) {
        var blob = new Blob(['var _workerSelf = self; self.onmessage = ', fn.toString()], {
          type: 'text/javascript'
        });
        // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
        var url = URL.createObjectURL(blob);
        return new Worker(url);
      }
      workerFn = fn;
      return workerProxy;
    }
    function setupWorker() {
      if (!workerInstance) {
        workerInstance = createWorker(function workerStart(e) {
          function dataFunctionManager() {
            function completeLayers(layers, comps) {
              var layerData;
              var i;
              var len = layers.length;
              var j;
              var jLen;
              var k;
              var kLen;
              for (i = 0; i < len; i += 1) {
                layerData = layers[i];
                if ('ks' in layerData && !layerData.completed) {
                  layerData.completed = true;
                  if (layerData.hasMask) {
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;
                    for (j = 0; j < jLen; j += 1) {
                      if (maskProps[j].pt.k.i) {
                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
                      } else {
                        kLen = maskProps[j].pt.k.length;
                        for (k = 0; k < kLen; k += 1) {
                          if (maskProps[j].pt.k[k].s) {
                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                          }
                          if (maskProps[j].pt.k[k].e) {
                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                          }
                        }
                      }
                    }
                  }
                  if (layerData.ty === 0) {
                    layerData.layers = findCompLayers(layerData.refId, comps);
                    completeLayers(layerData.layers, comps);
                  } else if (layerData.ty === 4) {
                    completeShapes(layerData.shapes);
                  } else if (layerData.ty === 5) {
                    completeText(layerData);
                  }
                }
              }
            }
            function completeChars(chars, assets) {
              if (chars) {
                var i = 0;
                var len = chars.length;
                for (i = 0; i < len; i += 1) {
                  if (chars[i].t === 1) {
                    // var compData = findComp(chars[i].data.refId, assets);
                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets);
                    // chars[i].data.ip = 0;
                    // chars[i].data.op = 99999;
                    // chars[i].data.st = 0;
                    // chars[i].data.sr = 1;
                    // chars[i].w = compData.w;
                    // chars[i].data.ks = {
                    //   a: { k: [0, 0, 0], a: 0 },
                    //   p: { k: [0, -compData.h, 0], a: 0 },
                    //   r: { k: 0, a: 0 },
                    //   s: { k: [100, 100], a: 0 },
                    //   o: { k: 100, a: 0 },
                    // };
                    completeLayers(chars[i].data.layers, assets);
                  }
                }
              }
            }
            function findComp(id, comps) {
              var i = 0;
              var len = comps.length;
              while (i < len) {
                if (comps[i].id === id) {
                  return comps[i];
                }
                i += 1;
              }
              return null;
            }
            function findCompLayers(id, comps) {
              var comp = findComp(id, comps);
              if (comp) {
                if (!comp.layers.__used) {
                  comp.layers.__used = true;
                  return comp.layers;
                }
                return JSON.parse(JSON.stringify(comp.layers));
              }
              return null;
            }
            function completeShapes(arr) {
              var i;
              var len = arr.length;
              var j;
              var jLen;
              for (i = len - 1; i >= 0; i -= 1) {
                if (arr[i].ty === 'sh') {
                  if (arr[i].ks.k.i) {
                    convertPathsToAbsoluteValues(arr[i].ks.k);
                  } else {
                    jLen = arr[i].ks.k.length;
                    for (j = 0; j < jLen; j += 1) {
                      if (arr[i].ks.k[j].s) {
                        convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                      }
                      if (arr[i].ks.k[j].e) {
                        convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                      }
                    }
                  }
                } else if (arr[i].ty === 'gr') {
                  completeShapes(arr[i].it);
                }
              }
            }
            function convertPathsToAbsoluteValues(path) {
              var i;
              var len = path.i.length;
              for (i = 0; i < len; i += 1) {
                path.i[i][0] += path.v[i][0];
                path.i[i][1] += path.v[i][1];
                path.o[i][0] += path.v[i][0];
                path.o[i][1] += path.v[i][1];
              }
            }
            function checkVersion(minimum, animVersionString) {
              var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];
              if (minimum[0] > animVersion[0]) {
                return true;
              }
              if (animVersion[0] > minimum[0]) {
                return false;
              }
              if (minimum[1] > animVersion[1]) {
                return true;
              }
              if (animVersion[1] > minimum[1]) {
                return false;
              }
              if (minimum[2] > animVersion[2]) {
                return true;
              }
              if (animVersion[2] > minimum[2]) {
                return false;
              }
              return null;
            }
            var checkText = function () {
              var minimumVersion = [4, 4, 14];
              function updateTextLayer(textLayer) {
                var documentData = textLayer.t.d;
                textLayer.t.d = {
                  k: [{
                    s: documentData,
                    t: 0
                  }]
                };
              }
              function iterateLayers(layers) {
                var i;
                var len = layers.length;
                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 5) {
                    updateTextLayer(layers[i]);
                  }
                }
              }
              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);
                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;
                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();
            var checkChars = function () {
              var minimumVersion = [4, 7, 99];
              return function (animationData) {
                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                  var i;
                  var len = animationData.chars.length;
                  for (i = 0; i < len; i += 1) {
                    var charData = animationData.chars[i];
                    if (charData.data && charData.data.shapes) {
                      completeShapes(charData.data.shapes);
                      charData.data.ip = 0;
                      charData.data.op = 99999;
                      charData.data.st = 0;
                      charData.data.sr = 1;
                      charData.data.ks = {
                        p: {
                          k: [0, 0],
                          a: 0
                        },
                        s: {
                          k: [100, 100],
                          a: 0
                        },
                        a: {
                          k: [0, 0],
                          a: 0
                        },
                        r: {
                          k: 0,
                          a: 0
                        },
                        o: {
                          k: 100,
                          a: 0
                        }
                      };
                      if (!animationData.chars[i].t) {
                        charData.data.shapes.push({
                          ty: 'no'
                        });
                        charData.data.shapes[0].it.push({
                          p: {
                            k: [0, 0],
                            a: 0
                          },
                          s: {
                            k: [100, 100],
                            a: 0
                          },
                          a: {
                            k: [0, 0],
                            a: 0
                          },
                          r: {
                            k: 0,
                            a: 0
                          },
                          o: {
                            k: 100,
                            a: 0
                          },
                          sk: {
                            k: 0,
                            a: 0
                          },
                          sa: {
                            k: 0,
                            a: 0
                          },
                          ty: 'tr'
                        });
                      }
                    }
                  }
                }
              };
            }();
            var checkPathProperties = function () {
              var minimumVersion = [5, 7, 15];
              function updateTextLayer(textLayer) {
                var pathData = textLayer.t.p;
                if (typeof pathData.a === 'number') {
                  pathData.a = {
                    a: 0,
                    k: pathData.a
                  };
                }
                if (typeof pathData.p === 'number') {
                  pathData.p = {
                    a: 0,
                    k: pathData.p
                  };
                }
                if (typeof pathData.r === 'number') {
                  pathData.r = {
                    a: 0,
                    k: pathData.r
                  };
                }
              }
              function iterateLayers(layers) {
                var i;
                var len = layers.length;
                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 5) {
                    updateTextLayer(layers[i]);
                  }
                }
              }
              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);
                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;
                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();
            var checkColors = function () {
              var minimumVersion = [4, 1, 9];
              function iterateShapes(shapes) {
                var i;
                var len = shapes.length;
                var j;
                var jLen;
                for (i = 0; i < len; i += 1) {
                  if (shapes[i].ty === 'gr') {
                    iterateShapes(shapes[i].it);
                  } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                    if (shapes[i].c.k && shapes[i].c.k[0].i) {
                      jLen = shapes[i].c.k.length;
                      for (j = 0; j < jLen; j += 1) {
                        if (shapes[i].c.k[j].s) {
                          shapes[i].c.k[j].s[0] /= 255;
                          shapes[i].c.k[j].s[1] /= 255;
                          shapes[i].c.k[j].s[2] /= 255;
                          shapes[i].c.k[j].s[3] /= 255;
                        }
                        if (shapes[i].c.k[j].e) {
                          shapes[i].c.k[j].e[0] /= 255;
                          shapes[i].c.k[j].e[1] /= 255;
                          shapes[i].c.k[j].e[2] /= 255;
                          shapes[i].c.k[j].e[3] /= 255;
                        }
                      }
                    } else {
                      shapes[i].c.k[0] /= 255;
                      shapes[i].c.k[1] /= 255;
                      shapes[i].c.k[2] /= 255;
                      shapes[i].c.k[3] /= 255;
                    }
                  }
                }
              }
              function iterateLayers(layers) {
                var i;
                var len = layers.length;
                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 4) {
                    iterateShapes(layers[i].shapes);
                  }
                }
              }
              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);
                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;
                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();
            var checkShapes = function () {
              var minimumVersion = [4, 4, 18];
              function completeClosingShapes(arr) {
                var i;
                var len = arr.length;
                var j;
                var jLen;
                for (i = len - 1; i >= 0; i -= 1) {
                  if (arr[i].ty === 'sh') {
                    if (arr[i].ks.k.i) {
                      arr[i].ks.k.c = arr[i].closed;
                    } else {
                      jLen = arr[i].ks.k.length;
                      for (j = 0; j < jLen; j += 1) {
                        if (arr[i].ks.k[j].s) {
                          arr[i].ks.k[j].s[0].c = arr[i].closed;
                        }
                        if (arr[i].ks.k[j].e) {
                          arr[i].ks.k[j].e[0].c = arr[i].closed;
                        }
                      }
                    }
                  } else if (arr[i].ty === 'gr') {
                    completeClosingShapes(arr[i].it);
                  }
                }
              }
              function iterateLayers(layers) {
                var layerData;
                var i;
                var len = layers.length;
                var j;
                var jLen;
                var k;
                var kLen;
                for (i = 0; i < len; i += 1) {
                  layerData = layers[i];
                  if (layerData.hasMask) {
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;
                    for (j = 0; j < jLen; j += 1) {
                      if (maskProps[j].pt.k.i) {
                        maskProps[j].pt.k.c = maskProps[j].cl;
                      } else {
                        kLen = maskProps[j].pt.k.length;
                        for (k = 0; k < kLen; k += 1) {
                          if (maskProps[j].pt.k[k].s) {
                            maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                          }
                          if (maskProps[j].pt.k[k].e) {
                            maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                          }
                        }
                      }
                    }
                  }
                  if (layerData.ty === 4) {
                    completeClosingShapes(layerData.shapes);
                  }
                }
              }
              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);
                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;
                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();
            function completeData(animationData) {
              if (animationData.__complete) {
                return;
              }
              checkColors(animationData);
              checkText(animationData);
              checkChars(animationData);
              checkPathProperties(animationData);
              checkShapes(animationData);
              completeLayers(animationData.layers, animationData.assets);
              completeChars(animationData.chars, animationData.assets);
              animationData.__complete = true;
            }
            function completeText(data) {
              if (data.t.a.length === 0 && !('m' in data.t.p)) {
                // data.singleShape = true;
              }
            }
            var moduleOb = {};
            moduleOb.completeData = completeData;
            moduleOb.checkColors = checkColors;
            moduleOb.checkChars = checkChars;
            moduleOb.checkPathProperties = checkPathProperties;
            moduleOb.checkShapes = checkShapes;
            moduleOb.completeLayers = completeLayers;
            return moduleOb;
          }
          if (!_workerSelf.dataManager) {
            _workerSelf.dataManager = dataFunctionManager();
          }
          if (!_workerSelf.assetLoader) {
            _workerSelf.assetLoader = function () {
              function formatResponse(xhr) {
                // using typeof doubles the time of execution of this method,
                // so if available, it's better to use the header to validate the type
                var contentTypeHeader = xhr.getResponseHeader('content-type');
                if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) {
                  return xhr.response;
                }
                if (xhr.response && _typeof$5(xhr.response) === 'object') {
                  return xhr.response;
                }
                if (xhr.response && typeof xhr.response === 'string') {
                  return JSON.parse(xhr.response);
                }
                if (xhr.responseText) {
                  return JSON.parse(xhr.responseText);
                }
                return null;
              }
              function loadAsset(path, fullPath, callback, errorCallback) {
                var response;
                var xhr = new XMLHttpRequest();
                // set responseType after calling open or IE will break.
                try {
                  // This crashes on Android WebView prior to KitKat
                  xhr.responseType = 'json';
                } catch (err) {} // eslint-disable-line no-empty
                xhr.onreadystatechange = function () {
                  if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                      response = formatResponse(xhr);
                      callback(response);
                    } else {
                      try {
                        response = formatResponse(xhr);
                        callback(response);
                      } catch (err) {
                        if (errorCallback) {
                          errorCallback(err);
                        }
                      }
                    }
                  }
                };
                try {
                  // Hack to workaround banner validation
                  xhr.open(['G', 'E', 'T'].join(''), path, true);
                } catch (error) {
                  // Hack to workaround banner validation
                  xhr.open(['G', 'E', 'T'].join(''), fullPath + '/' + path, true);
                }
                xhr.send();
              }
              return {
                load: loadAsset
              };
            }();
          }
          if (e.data.type === 'loadAnimation') {
            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
              _workerSelf.dataManager.completeData(data);
              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success'
              });
            }, function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error'
              });
            });
          } else if (e.data.type === 'complete') {
            var animation = e.data.animation;
            _workerSelf.dataManager.completeData(animation);
            _workerSelf.postMessage({
              id: e.data.id,
              payload: animation,
              status: 'success'
            });
          } else if (e.data.type === 'loadData') {
            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success'
              });
            }, function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error'
              });
            });
          }
        });
        workerInstance.onmessage = function (event) {
          var data = event.data;
          var id = data.id;
          var process = processes[id];
          processes[id] = null;
          if (data.status === 'success') {
            process.onComplete(data.payload);
          } else if (process.onError) {
            process.onError();
          }
        };
      }
    }
    function createProcess(onComplete, onError) {
      _counterId += 1;
      var id = 'processId_' + _counterId;
      processes[id] = {
        onComplete: onComplete,
        onError: onError
      };
      return id;
    }
    function loadAnimation(path, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'loadAnimation',
        path: path,
        fullPath: window.location.origin + window.location.pathname,
        id: processId
      });
    }
    function loadData(path, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'loadData',
        path: path,
        fullPath: window.location.origin + window.location.pathname,
        id: processId
      });
    }
    function completeAnimation(anim, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'complete',
        animation: anim,
        id: processId
      });
    }
    return {
      loadAnimation: loadAnimation,
      loadData: loadData,
      completeAnimation: completeAnimation
    };
  }();

  var ImagePreloader = function () {
    var proxyImage = function () {
      var canvas = createTag('canvas');
      canvas.width = 1;
      canvas.height = 1;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = 'rgba(0,0,0,0)';
      ctx.fillRect(0, 0, 1, 1);
      return canvas;
    }();
    function imageLoaded() {
      this.loadedAssets += 1;
      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
        if (this.imagesLoadedCb) {
          this.imagesLoadedCb(null);
        }
      }
    }
    function footageLoaded() {
      this.loadedFootagesCount += 1;
      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
        if (this.imagesLoadedCb) {
          this.imagesLoadedCb(null);
        }
      }
    }
    function getAssetsPath(assetData, assetsPath, originalPath) {
      var path = '';
      if (assetData.e) {
        path = assetData.p;
      } else if (assetsPath) {
        var imagePath = assetData.p;
        if (imagePath.indexOf('images/') !== -1) {
          imagePath = imagePath.split('/')[1];
        }
        path = assetsPath + imagePath;
      } else {
        path = originalPath;
        path += assetData.u ? assetData.u : '';
        path += assetData.p;
      }
      return path;
    }
    function testImageLoaded(img) {
      var _count = 0;
      var intervalId = setInterval(function () {
        var box = img.getBBox();
        if (box.width || _count > 500) {
          this._imageLoaded();
          clearInterval(intervalId);
        }
        _count += 1;
      }.bind(this), 50);
    }
    function createImageData(assetData) {
      var path = getAssetsPath(assetData, this.assetsPath, this.path);
      var img = createNS('image');
      if (isSafari) {
        this.testImageLoaded(img);
      } else {
        img.addEventListener('load', this._imageLoaded, false);
      }
      img.addEventListener('error', function () {
        ob.img = proxyImage;
        this._imageLoaded();
      }.bind(this), false);
      img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
      if (this._elementHelper.append) {
        this._elementHelper.append(img);
      } else {
        this._elementHelper.appendChild(img);
      }
      var ob = {
        img: img,
        assetData: assetData
      };
      return ob;
    }
    function createImgData(assetData) {
      var path = getAssetsPath(assetData, this.assetsPath, this.path);
      var img = createTag('img');
      img.crossOrigin = 'anonymous';
      img.addEventListener('load', this._imageLoaded, false);
      img.addEventListener('error', function () {
        ob.img = proxyImage;
        this._imageLoaded();
      }.bind(this), false);
      img.src = path;
      var ob = {
        img: img,
        assetData: assetData
      };
      return ob;
    }
    function createFootageData(data) {
      var ob = {
        assetData: data
      };
      var path = getAssetsPath(data, this.assetsPath, this.path);
      dataManager.loadData(path, function (footageData) {
        ob.img = footageData;
        this._footageLoaded();
      }.bind(this), function () {
        ob.img = {};
        this._footageLoaded();
      }.bind(this));
      return ob;
    }
    function loadAssets(assets, cb) {
      this.imagesLoadedCb = cb;
      var i;
      var len = assets.length;
      for (i = 0; i < len; i += 1) {
        if (!assets[i].layers) {
          if (!assets[i].t || assets[i].t === 'seq') {
            this.totalImages += 1;
            this.images.push(this._createImageData(assets[i]));
          } else if (assets[i].t === 3) {
            this.totalFootages += 1;
            this.images.push(this.createFootageData(assets[i]));
          }
        }
      }
    }
    function setPath(path) {
      this.path = path || '';
    }
    function setAssetsPath(path) {
      this.assetsPath = path || '';
    }
    function getAsset(assetData) {
      var i = 0;
      var len = this.images.length;
      while (i < len) {
        if (this.images[i].assetData === assetData) {
          return this.images[i].img;
        }
        i += 1;
      }
      return null;
    }
    function destroy() {
      this.imagesLoadedCb = null;
      this.images.length = 0;
    }
    function loadedImages() {
      return this.totalImages === this.loadedAssets;
    }
    function loadedFootages() {
      return this.totalFootages === this.loadedFootagesCount;
    }
    function setCacheType(type, elementHelper) {
      if (type === 'svg') {
        this._elementHelper = elementHelper;
        this._createImageData = this.createImageData.bind(this);
      } else {
        this._createImageData = this.createImgData.bind(this);
      }
    }
    function ImagePreloaderFactory() {
      this._imageLoaded = imageLoaded.bind(this);
      this._footageLoaded = footageLoaded.bind(this);
      this.testImageLoaded = testImageLoaded.bind(this);
      this.createFootageData = createFootageData.bind(this);
      this.assetsPath = '';
      this.path = '';
      this.totalImages = 0;
      this.totalFootages = 0;
      this.loadedAssets = 0;
      this.loadedFootagesCount = 0;
      this.imagesLoadedCb = null;
      this.images = [];
    }
    ImagePreloaderFactory.prototype = {
      loadAssets: loadAssets,
      setAssetsPath: setAssetsPath,
      setPath: setPath,
      loadedImages: loadedImages,
      loadedFootages: loadedFootages,
      destroy: destroy,
      getAsset: getAsset,
      createImgData: createImgData,
      createImageData: createImageData,
      imageLoaded: imageLoaded,
      footageLoaded: footageLoaded,
      setCacheType: setCacheType
    };
    return ImagePreloaderFactory;
  }();

  function BaseEvent() {}
  BaseEvent.prototype = {
    triggerEvent: function triggerEvent(eventName, args) {
      if (this._cbs[eventName]) {
        var callbacks = this._cbs[eventName];
        for (var i = 0; i < callbacks.length; i += 1) {
          callbacks[i](args);
        }
      }
    },
    addEventListener: function addEventListener(eventName, callback) {
      if (!this._cbs[eventName]) {
        this._cbs[eventName] = [];
      }
      this._cbs[eventName].push(callback);
      return function () {
        this.removeEventListener(eventName, callback);
      }.bind(this);
    },
    removeEventListener: function removeEventListener(eventName, callback) {
      if (!callback) {
        this._cbs[eventName] = null;
      } else if (this._cbs[eventName]) {
        var i = 0;
        var len = this._cbs[eventName].length;
        while (i < len) {
          if (this._cbs[eventName][i] === callback) {
            this._cbs[eventName].splice(i, 1);
            i -= 1;
            len -= 1;
          }
          i += 1;
        }
        if (!this._cbs[eventName].length) {
          this._cbs[eventName] = null;
        }
      }
    }
  };

  var markerParser = function () {
    function parsePayloadLines(payload) {
      var lines = payload.split('\r\n');
      var keys = {};
      var line;
      var keysCount = 0;
      for (var i = 0; i < lines.length; i += 1) {
        line = lines[i].split(':');
        if (line.length === 2) {
          keys[line[0]] = line[1].trim();
          keysCount += 1;
        }
      }
      if (keysCount === 0) {
        throw new Error();
      }
      return keys;
    }
    return function (_markers) {
      var markers = [];
      for (var i = 0; i < _markers.length; i += 1) {
        var _marker = _markers[i];
        var markerData = {
          time: _marker.tm,
          duration: _marker.dr
        };
        try {
          markerData.payload = JSON.parse(_markers[i].cm);
        } catch (_) {
          try {
            markerData.payload = parsePayloadLines(_markers[i].cm);
          } catch (__) {
            markerData.payload = {
              name: _markers[i].cm
            };
          }
        }
        markers.push(markerData);
      }
      return markers;
    };
  }();

  var ProjectInterface = function () {
    function registerComposition(comp) {
      this.compositions.push(comp);
    }
    return function () {
      function _thisProjectFunction(name) {
        var i = 0;
        var len = this.compositions.length;
        while (i < len) {
          if (this.compositions[i].data && this.compositions[i].data.nm === name) {
            if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
              this.compositions[i].prepareFrame(this.currentFrame);
            }
            return this.compositions[i].compInterface;
          }
          i += 1;
        }
        return null;
      }
      _thisProjectFunction.compositions = [];
      _thisProjectFunction.currentFrame = 0;
      _thisProjectFunction.registerComposition = registerComposition;
      return _thisProjectFunction;
    };
  }();

  var renderers = {};
  var registerRenderer = function registerRenderer(key, value) {
    renderers[key] = value;
  };
  function getRenderer(key) {
    return renderers[key];
  }
  function getRegisteredRenderer() {
    // Returns canvas by default for compatibility
    if (renderers.canvas) {
      return 'canvas';
    }
    // Returns any renderer that is registered
    for (var key in renderers) {
      if (renderers[key]) {
        return key;
      }
    }
    return '';
  }

  function _typeof$4(o) { "@babel/helpers - typeof"; return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$4(o); }
  var AnimationItem = function AnimationItem() {
    this._cbs = [];
    this.name = '';
    this.path = '';
    this.isLoaded = false;
    this.currentFrame = 0;
    this.currentRawFrame = 0;
    this.firstFrame = 0;
    this.totalFrames = 0;
    this.frameRate = 0;
    this.frameMult = 0;
    this.playSpeed = 1;
    this.playDirection = 1;
    this.playCount = 0;
    this.animationData = {};
    this.assets = [];
    this.isPaused = true;
    this.autoplay = false;
    this.loop = true;
    this.renderer = null;
    this.animationID = createElementID();
    this.assetsPath = '';
    this.timeCompleted = 0;
    this.segmentPos = 0;
    this.isSubframeEnabled = getSubframeEnabled();
    this.segments = [];
    this._idle = true;
    this._completedLoop = false;
    this.projectInterface = ProjectInterface();
    this.imagePreloader = new ImagePreloader();
    this.audioController = audioControllerFactory();
    this.markers = [];
    this.configAnimation = this.configAnimation.bind(this);
    this.onSetupError = this.onSetupError.bind(this);
    this.onSegmentComplete = this.onSegmentComplete.bind(this);
    this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
    this.expressionsPlugin = getExpressionsPlugin();
  };
  extendPrototype([BaseEvent], AnimationItem);
  AnimationItem.prototype.setParams = function (params) {
    if (params.wrapper || params.container) {
      this.wrapper = params.wrapper || params.container;
    }
    var animType = 'svg';
    if (params.animType) {
      animType = params.animType;
    } else if (params.renderer) {
      animType = params.renderer;
    }
    var RendererClass = getRenderer(animType);
    this.renderer = new RendererClass(this, params.rendererSettings);
    this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
    this.renderer.setProjectInterface(this.projectInterface);
    this.animType = animType;
    if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) {
      this.loop = true;
    } else if (params.loop === false) {
      this.loop = false;
    } else {
      this.loop = parseInt(params.loop, 10);
    }
    this.autoplay = 'autoplay' in params ? params.autoplay : true;
    this.name = params.name ? params.name : '';
    this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
    this.assetsPath = params.assetsPath;
    this.initialSegment = params.initialSegment;
    if (params.audioFactory) {
      this.audioController.setAudioFactory(params.audioFactory);
    }
    if (params.animationData) {
      this.setupAnimation(params.animationData);
    } else if (params.path) {
      if (params.path.lastIndexOf('\\') !== -1) {
        this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
      } else {
        this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
      }
      this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
      this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
      dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
    }
  };
  AnimationItem.prototype.onSetupError = function () {
    this.trigger('data_failed');
  };
  AnimationItem.prototype.setupAnimation = function (data) {
    dataManager.completeAnimation(data, this.configAnimation);
  };
  AnimationItem.prototype.setData = function (wrapper, animationData) {
    if (animationData) {
      if (_typeof$4(animationData) !== 'object') {
        animationData = JSON.parse(animationData);
      }
    }
    var params = {
      wrapper: wrapper,
      animationData: animationData
    };
    var wrapperAttributes = wrapper.attributes;
    params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
    params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
    var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
    if (loop === 'false') {
      params.loop = false;
    } else if (loop === 'true') {
      params.loop = true;
    } else if (loop !== '') {
      params.loop = parseInt(loop, 10);
    }
    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
    params.autoplay = autoplay !== 'false';
    params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
    if (prerender === 'false') {
      params.prerender = false;
    }
    if (!params.path) {
      this.trigger('destroy');
    } else {
      this.setParams(params);
    }
  };
  AnimationItem.prototype.includeLayers = function (data) {
    if (data.op > this.animationData.op) {
      this.animationData.op = data.op;
      this.totalFrames = Math.floor(data.op - this.animationData.ip);
    }
    var layers = this.animationData.layers;
    var i;
    var len = layers.length;
    var newLayers = data.layers;
    var j;
    var jLen = newLayers.length;
    for (j = 0; j < jLen; j += 1) {
      i = 0;
      while (i < len) {
        if (layers[i].id === newLayers[j].id) {
          layers[i] = newLayers[j];
          break;
        }
        i += 1;
      }
    }
    if (data.chars || data.fonts) {
      this.renderer.globalData.fontManager.addChars(data.chars);
      this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
    }
    if (data.assets) {
      len = data.assets.length;
      for (i = 0; i < len; i += 1) {
        this.animationData.assets.push(data.assets[i]);
      }
    }
    this.animationData.__complete = false;
    dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
  };
  AnimationItem.prototype.onSegmentComplete = function (data) {
    this.animationData = data;
    var expressionsPlugin = getExpressionsPlugin();
    if (expressionsPlugin) {
      expressionsPlugin.initExpressions(this);
    }
    this.loadNextSegment();
  };
  AnimationItem.prototype.loadNextSegment = function () {
    var segments = this.animationData.segments;
    if (!segments || segments.length === 0 || !this.autoloadSegments) {
      this.trigger('data_ready');
      this.timeCompleted = this.totalFrames;
      return;
    }
    var segment = segments.shift();
    this.timeCompleted = segment.time * this.frameRate;
    var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
    this.segmentPos += 1;
    dataManager.loadData(segmentPath, this.includeLayers.bind(this), function () {
      this.trigger('data_failed');
    }.bind(this));
  };
  AnimationItem.prototype.loadSegments = function () {
    var segments = this.animationData.segments;
    if (!segments) {
      this.timeCompleted = this.totalFrames;
    }
    this.loadNextSegment();
  };
  AnimationItem.prototype.imagesLoaded = function () {
    this.trigger('loaded_images');
    this.checkLoaded();
  };
  AnimationItem.prototype.preloadImages = function () {
    this.imagePreloader.setAssetsPath(this.assetsPath);
    this.imagePreloader.setPath(this.path);
    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
  };
  AnimationItem.prototype.configAnimation = function (animData) {
    if (!this.renderer) {
      return;
    }
    try {
      this.animationData = animData;
      if (this.initialSegment) {
        this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
        this.firstFrame = Math.round(this.initialSegment[0]);
      } else {
        this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
        this.firstFrame = Math.round(this.animationData.ip);
      }
      this.renderer.configAnimation(animData);
      if (!animData.assets) {
        animData.assets = [];
      }
      this.assets = this.animationData.assets;
      this.frameRate = this.animationData.fr;
      this.frameMult = this.animationData.fr / 1000;
      this.renderer.searchExtraCompositions(animData.assets);
      this.markers = markerParser(animData.markers || []);
      this.trigger('config_ready');
      this.preloadImages();
      this.loadSegments();
      this.updaFrameModifier();
      this.waitForFontsLoaded();
      if (this.isPaused) {
        this.audioController.pause();
      }
    } catch (error) {
      this.triggerConfigError(error);
    }
  };
  AnimationItem.prototype.waitForFontsLoaded = function () {
    if (!this.renderer) {
      return;
    }
    if (this.renderer.globalData.fontManager.isLoaded) {
      this.checkLoaded();
    } else {
      setTimeout(this.waitForFontsLoaded.bind(this), 20);
    }
  };
  AnimationItem.prototype.checkLoaded = function () {
    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
      this.isLoaded = true;
      var expressionsPlugin = getExpressionsPlugin();
      if (expressionsPlugin) {
        expressionsPlugin.initExpressions(this);
      }
      this.renderer.initItems();
      setTimeout(function () {
        this.trigger('DOMLoaded');
      }.bind(this), 0);
      this.gotoFrame();
      if (this.autoplay) {
        this.play();
      }
    }
  };
  AnimationItem.prototype.resize = function (width, height) {
    // Adding this validation for backwards compatibility in case an event object was being passed down
    var _width = typeof width === 'number' ? width : undefined;
    var _height = typeof height === 'number' ? height : undefined;
    this.renderer.updateContainerSize(_width, _height);
  };
  AnimationItem.prototype.setSubframe = function (flag) {
    this.isSubframeEnabled = !!flag;
  };
  AnimationItem.prototype.gotoFrame = function () {
    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise

    if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
      this.currentFrame = this.timeCompleted;
    }
    this.trigger('enterFrame');
    this.renderFrame();
    this.trigger('drawnFrame');
  };
  AnimationItem.prototype.renderFrame = function () {
    if (this.isLoaded === false || !this.renderer) {
      return;
    }
    try {
      if (this.expressionsPlugin) {
        this.expressionsPlugin.resetFrame();
      }
      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
    } catch (error) {
      this.triggerRenderFrameError(error);
    }
  };
  AnimationItem.prototype.play = function (name) {
    if (name && this.name !== name) {
      return;
    }
    if (this.isPaused === true) {
      this.isPaused = false;
      this.trigger('_play');
      this.audioController.resume();
      if (this._idle) {
        this._idle = false;
        this.trigger('_active');
      }
    }
  };
  AnimationItem.prototype.pause = function (name) {
    if (name && this.name !== name) {
      return;
    }
    if (this.isPaused === false) {
      this.isPaused = true;
      this.trigger('_pause');
      this._idle = true;
      this.trigger('_idle');
      this.audioController.pause();
    }
  };
  AnimationItem.prototype.togglePause = function (name) {
    if (name && this.name !== name) {
      return;
    }
    if (this.isPaused === true) {
      this.play();
    } else {
      this.pause();
    }
  };
  AnimationItem.prototype.stop = function (name) {
    if (name && this.name !== name) {
      return;
    }
    this.pause();
    this.playCount = 0;
    this._completedLoop = false;
    this.setCurrentRawFrameValue(0);
  };
  AnimationItem.prototype.getMarkerData = function (markerName) {
    var marker;
    for (var i = 0; i < this.markers.length; i += 1) {
      marker = this.markers[i];
      if (marker.payload && marker.payload.name === markerName) {
        return marker;
      }
    }
    return null;
  };
  AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
    if (name && this.name !== name) {
      return;
    }
    var numValue = Number(value);
    if (isNaN(numValue)) {
      var marker = this.getMarkerData(value);
      if (marker) {
        this.goToAndStop(marker.time, true);
      }
    } else if (isFrame) {
      this.setCurrentRawFrameValue(value);
    } else {
      this.setCurrentRawFrameValue(value * this.frameModifier);
    }
    this.pause();
  };
  AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
    if (name && this.name !== name) {
      return;
    }
    var numValue = Number(value);
    if (isNaN(numValue)) {
      var marker = this.getMarkerData(value);
      if (marker) {
        if (!marker.duration) {
          this.goToAndStop(marker.time, true);
        } else {
          this.playSegments([marker.time, marker.time + marker.duration], true);
        }
      }
    } else {
      this.goToAndStop(numValue, isFrame, name);
    }
    this.play();
  };
  AnimationItem.prototype.advanceTime = function (value) {
    if (this.isPaused === true || this.isLoaded === false) {
      return;
    }
    var nextValue = this.currentRawFrame + value * this.frameModifier;
    var _isComplete = false;
    // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
      if (!this.loop || this.playCount === this.loop) {
        if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
          _isComplete = true;
          nextValue = this.totalFrames - 1;
        }
      } else if (nextValue >= this.totalFrames) {
        this.playCount += 1;
        if (!this.checkSegments(nextValue % this.totalFrames)) {
          this.setCurrentRawFrameValue(nextValue % this.totalFrames);
          this._completedLoop = true;
          this.trigger('loopComplete');
        }
      } else {
        this.setCurrentRawFrameValue(nextValue);
      }
    } else if (nextValue < 0) {
      if (!this.checkSegments(nextValue % this.totalFrames)) {
        if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
          // eslint-disable-line no-plusplus
          this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
          if (!this._completedLoop) {
            this._completedLoop = true;
          } else {
            this.trigger('loopComplete');
          }
        } else {
          _isComplete = true;
          nextValue = 0;
        }
      }
    } else {
      this.setCurrentRawFrameValue(nextValue);
    }
    if (_isComplete) {
      this.setCurrentRawFrameValue(nextValue);
      this.pause();
      this.trigger('complete');
    }
  };
  AnimationItem.prototype.adjustSegment = function (arr, offset) {
    this.playCount = 0;
    if (arr[1] < arr[0]) {
      if (this.frameModifier > 0) {
        if (this.playSpeed < 0) {
          this.setSpeed(-this.playSpeed);
        } else {
          this.setDirection(-1);
        }
      }
      this.totalFrames = arr[0] - arr[1];
      this.timeCompleted = this.totalFrames;
      this.firstFrame = arr[1];
      this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
    } else if (arr[1] > arr[0]) {
      if (this.frameModifier < 0) {
        if (this.playSpeed < 0) {
          this.setSpeed(-this.playSpeed);
        } else {
          this.setDirection(1);
        }
      }
      this.totalFrames = arr[1] - arr[0];
      this.timeCompleted = this.totalFrames;
      this.firstFrame = arr[0];
      this.setCurrentRawFrameValue(0.001 + offset);
    }
    this.trigger('segmentStart');
  };
  AnimationItem.prototype.setSegment = function (init, end) {
    var pendingFrame = -1;
    if (this.isPaused) {
      if (this.currentRawFrame + this.firstFrame < init) {
        pendingFrame = init;
      } else if (this.currentRawFrame + this.firstFrame > end) {
        pendingFrame = end - init;
      }
    }
    this.firstFrame = init;
    this.totalFrames = end - init;
    this.timeCompleted = this.totalFrames;
    if (pendingFrame !== -1) {
      this.goToAndStop(pendingFrame, true);
    }
  };
  AnimationItem.prototype.playSegments = function (arr, forceFlag) {
    if (forceFlag) {
      this.segments.length = 0;
    }
    if (_typeof$4(arr[0]) === 'object') {
      var i;
      var len = arr.length;
      for (i = 0; i < len; i += 1) {
        this.segments.push(arr[i]);
      }
    } else {
      this.segments.push(arr);
    }
    if (this.segments.length && forceFlag) {
      this.adjustSegment(this.segments.shift(), 0);
    }
    if (this.isPaused) {
      this.play();
    }
  };
  AnimationItem.prototype.resetSegments = function (forceFlag) {
    this.segments.length = 0;
    this.segments.push([this.animationData.ip, this.animationData.op]);
    if (forceFlag) {
      this.checkSegments(0);
    }
  };
  AnimationItem.prototype.checkSegments = function (offset) {
    if (this.segments.length) {
      this.adjustSegment(this.segments.shift(), offset);
      return true;
    }
    return false;
  };
  AnimationItem.prototype.destroy = function (name) {
    if (name && this.name !== name || !this.renderer) {
      return;
    }
    this.renderer.destroy();
    this.imagePreloader.destroy();
    this.trigger('destroy');
    this._cbs = null;
    this.onEnterFrame = null;
    this.onLoopComplete = null;
    this.onComplete = null;
    this.onSegmentStart = null;
    this.onDestroy = null;
    this.renderer = null;
    this.expressionsPlugin = null;
    this.imagePreloader = null;
    this.projectInterface = null;
  };
  AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
    this.currentRawFrame = value;
    this.gotoFrame();
  };
  AnimationItem.prototype.setSpeed = function (val) {
    this.playSpeed = val;
    this.updaFrameModifier();
  };
  AnimationItem.prototype.setDirection = function (val) {
    this.playDirection = val < 0 ? -1 : 1;
    this.updaFrameModifier();
  };
  AnimationItem.prototype.setLoop = function (isLooping) {
    this.loop = isLooping;
  };
  AnimationItem.prototype.setVolume = function (val, name) {
    if (name && this.name !== name) {
      return;
    }
    this.audioController.setVolume(val);
  };
  AnimationItem.prototype.getVolume = function () {
    return this.audioController.getVolume();
  };
  AnimationItem.prototype.mute = function (name) {
    if (name && this.name !== name) {
      return;
    }
    this.audioController.mute();
  };
  AnimationItem.prototype.unmute = function (name) {
    if (name && this.name !== name) {
      return;
    }
    this.audioController.unmute();
  };
  AnimationItem.prototype.updaFrameModifier = function () {
    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
    this.audioController.setRate(this.playSpeed * this.playDirection);
  };
  AnimationItem.prototype.getPath = function () {
    return this.path;
  };
  AnimationItem.prototype.getAssetsPath = function (assetData) {
    var path = '';
    if (assetData.e) {
      path = assetData.p;
    } else if (this.assetsPath) {
      var imagePath = assetData.p;
      if (imagePath.indexOf('images/') !== -1) {
        imagePath = imagePath.split('/')[1];
      }
      path = this.assetsPath + imagePath;
    } else {
      path = this.path;
      path += assetData.u ? assetData.u : '';
      path += assetData.p;
    }
    return path;
  };
  AnimationItem.prototype.getAssetData = function (id) {
    var i = 0;
    var len = this.assets.length;
    while (i < len) {
      if (id === this.assets[i].id) {
        return this.assets[i];
      }
      i += 1;
    }
    return null;
  };
  AnimationItem.prototype.hide = function () {
    this.renderer.hide();
  };
  AnimationItem.prototype.show = function () {
    this.renderer.show();
  };
  AnimationItem.prototype.getDuration = function (isFrame) {
    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
  };
  AnimationItem.prototype.updateDocumentData = function (path, documentData, index) {
    try {
      var element = this.renderer.getElementByPath(path);
      element.updateDocumentData(documentData, index);
    } catch (error) {
      // TODO: decide how to handle catch case
    }
  };
  AnimationItem.prototype.trigger = function (name) {
    if (this._cbs && this._cbs[name]) {
      switch (name) {
        case 'enterFrame':
          this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
          break;
        case 'drawnFrame':
          this.drawnFrameEvent.currentTime = this.currentFrame;
          this.drawnFrameEvent.totalTime = this.totalFrames;
          this.drawnFrameEvent.direction = this.frameModifier;
          this.triggerEvent(name, this.drawnFrameEvent);
          break;
        case 'loopComplete':
          this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
          break;
        case 'complete':
          this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
          break;
        case 'segmentStart':
          this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
          break;
        case 'destroy':
          this.triggerEvent(name, new BMDestroyEvent(name, this));
          break;
        default:
          this.triggerEvent(name);
      }
    }
    if (name === 'enterFrame' && this.onEnterFrame) {
      this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
    }
    if (name === 'loopComplete' && this.onLoopComplete) {
      this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
    }
    if (name === 'complete' && this.onComplete) {
      this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
    }
    if (name === 'segmentStart' && this.onSegmentStart) {
      this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
    }
    if (name === 'destroy' && this.onDestroy) {
      this.onDestroy.call(this, new BMDestroyEvent(name, this));
    }
  };
  AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
    var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
    this.triggerEvent('error', error);
    if (this.onError) {
      this.onError.call(this, error);
    }
  };
  AnimationItem.prototype.triggerConfigError = function (nativeError) {
    var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
    this.triggerEvent('error', error);
    if (this.onError) {
      this.onError.call(this, error);
    }
  };

  var animationManager = function () {
    var moduleOb = {};
    var registeredAnimations = [];
    var initTime = 0;
    var len = 0;
    var playingAnimationsNum = 0;
    var _stopped = true;
    var _isFrozen = false;
    function removeElement(ev) {
      var i = 0;
      var animItem = ev.target;
      while (i < len) {
        if (registeredAnimations[i].animation === animItem) {
          registeredAnimations.splice(i, 1);
          i -= 1;
          len -= 1;
          if (!animItem.isPaused) {
            subtractPlayingCount();
          }
        }
        i += 1;
      }
    }
    function registerAnimation(element, animationData) {
      if (!element) {
        return null;
      }
      var i = 0;
      while (i < len) {
        if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
          return registeredAnimations[i].animation;
        }
        i += 1;
      }
      var animItem = new AnimationItem();
      setupAnimation(animItem, element);
      animItem.setData(element, animationData);
      return animItem;
    }
    function getRegisteredAnimations() {
      var i;
      var lenAnims = registeredAnimations.length;
      var animations = [];
      for (i = 0; i < lenAnims; i += 1) {
        animations.push(registeredAnimations[i].animation);
      }
      return animations;
    }
    function addPlayingCount() {
      playingAnimationsNum += 1;
      activate();
    }
    function subtractPlayingCount() {
      playingAnimationsNum -= 1;
    }
    function setupAnimation(animItem, element) {
      animItem.addEventListener('destroy', removeElement);
      animItem.addEventListener('_active', addPlayingCount);
      animItem.addEventListener('_idle', subtractPlayingCount);
      registeredAnimations.push({
        elem: element,
        animation: animItem
      });
      len += 1;
    }
    function loadAnimation(params) {
      var animItem = new AnimationItem();
      setupAnimation(animItem, null);
      animItem.setParams(params);
      return animItem;
    }
    function setSpeed(val, animation) {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setSpeed(val, animation);
      }
    }
    function setDirection(val, animation) {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setDirection(val, animation);
      }
    }
    function play(animation) {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.play(animation);
      }
    }
    function resume(nowTime) {
      var elapsedTime = nowTime - initTime;
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.advanceTime(elapsedTime);
      }
      initTime = nowTime;
      if (playingAnimationsNum && !_isFrozen) {
        window.requestAnimationFrame(resume);
      } else {
        _stopped = true;
      }
    }
    function first(nowTime) {
      initTime = nowTime;
      window.requestAnimationFrame(resume);
    }
    function pause(animation) {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.pause(animation);
      }
    }
    function goToAndStop(value, isFrame, animation) {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
      }
    }
    function stop(animation) {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.stop(animation);
      }
    }
    function togglePause(animation) {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.togglePause(animation);
      }
    }
    function destroy(animation) {
      var i;
      for (i = len - 1; i >= 0; i -= 1) {
        registeredAnimations[i].animation.destroy(animation);
      }
    }
    function searchAnimations(animationData, standalone, renderer) {
      var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
      var i;
      var lenAnims = animElements.length;
      for (i = 0; i < lenAnims; i += 1) {
        if (renderer) {
          animElements[i].setAttribute('data-bm-type', renderer);
        }
        registerAnimation(animElements[i], animationData);
      }
      if (standalone && lenAnims === 0) {
        if (!renderer) {
          renderer = 'svg';
        }
        var body = document.getElementsByTagName('body')[0];
        body.innerText = '';
        var div = createTag('div');
        div.style.width = '100%';
        div.style.height = '100%';
        div.setAttribute('data-bm-type', renderer);
        body.appendChild(div);
        registerAnimation(div, animationData);
      }
    }
    function resize() {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.resize();
      }
    }
    function activate() {
      if (!_isFrozen && playingAnimationsNum) {
        if (_stopped) {
          window.requestAnimationFrame(first);
          _stopped = false;
        }
      }
    }
    function freeze() {
      _isFrozen = true;
    }
    function unfreeze() {
      _isFrozen = false;
      activate();
    }
    function setVolume(val, animation) {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setVolume(val, animation);
      }
    }
    function mute(animation) {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.mute(animation);
      }
    }
    function unmute(animation) {
      var i;
      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.unmute(animation);
      }
    }
    moduleOb.registerAnimation = registerAnimation;
    moduleOb.loadAnimation = loadAnimation;
    moduleOb.setSpeed = setSpeed;
    moduleOb.setDirection = setDirection;
    moduleOb.play = play;
    moduleOb.pause = pause;
    moduleOb.stop = stop;
    moduleOb.togglePause = togglePause;
    moduleOb.searchAnimations = searchAnimations;
    moduleOb.resize = resize;
    // moduleOb.start = start;
    moduleOb.goToAndStop = goToAndStop;
    moduleOb.destroy = destroy;
    moduleOb.freeze = freeze;
    moduleOb.unfreeze = unfreeze;
    moduleOb.setVolume = setVolume;
    moduleOb.mute = mute;
    moduleOb.unmute = unmute;
    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
    return moduleOb;
  }();

  /* eslint-disable */
  var BezierFactory = function () {
    /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */

    var ob = {};
    ob.getBezierEasing = getBezierEasing;
    var beziers = {};
    function getBezierEasing(a, b, c, d, nm) {
      var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
      if (beziers[str]) {
        return beziers[str];
      }
      var bezEasing = new BezierEasing([a, b, c, d]);
      beziers[str] = bezEasing;
      return bezEasing;
    }

    // These values are established by empiricism with tests (tradeoff: performance VS precision)
    var NEWTON_ITERATIONS = 4;
    var NEWTON_MIN_SLOPE = 0.001;
    var SUBDIVISION_PRECISION = 0.0000001;
    var SUBDIVISION_MAX_ITERATIONS = 10;
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    var float32ArraySupported = typeof Float32Array === 'function';
    function A(aA1, aA2) {
      return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
      return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
      return 3.0 * aA1;
    }

    // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
    function calcBezier(aT, aA1, aA2) {
      return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }

    // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
    function getSlope(aT, aA1, aA2) {
      return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function binarySubdivide(aX, aA, aB, mX1, mX2) {
      var currentX,
        currentT,
        i = 0;
      do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) {
          aB = currentT;
        } else {
          aA = currentT;
        }
      } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
      return currentT;
    }
    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
      for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
        var currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
      }
      return aGuessT;
    }

    /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */
    function BezierEasing(points) {
      this._p = points;
      this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
      this._precomputed = false;
      this.get = this.get.bind(this);
    }
    BezierEasing.prototype = {
      get: function get(x) {
        var mX1 = this._p[0],
          mY1 = this._p[1],
          mX2 = this._p[2],
          mY2 = this._p[3];
        if (!this._precomputed) this._precompute();
        if (mX1 === mY1 && mX2 === mY2) return x; // linear
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
        if (x === 0) return 0;
        if (x === 1) return 1;
        return calcBezier(this._getTForX(x), mY1, mY2);
      },
      // Private part

      _precompute: function _precompute() {
        var mX1 = this._p[0],
          mY1 = this._p[1],
          mX2 = this._p[2],
          mY2 = this._p[3];
        this._precomputed = true;
        if (mX1 !== mY1 || mX2 !== mY2) {
          this._calcSampleValues();
        }
      },
      _calcSampleValues: function _calcSampleValues() {
        var mX1 = this._p[0],
          mX2 = this._p[2];
        for (var i = 0; i < kSplineTableSize; ++i) {
          this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        }
      },
      /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */
      _getTForX: function _getTForX(aX) {
        var mX1 = this._p[0],
          mX2 = this._p[2],
          mSampleValues = this._mSampleValues;
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = kSplineTableSize - 1;
        for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
          intervalStart += kSampleStepSize;
        }
        --currentSample;

        // Interpolate to provide an initial guess for t
        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
        var guessForT = intervalStart + dist * kSampleStepSize;
        var initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= NEWTON_MIN_SLOPE) {
          return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        }
        if (initialSlope === 0.0) {
          return guessForT;
        }
        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }
    };
    return ob;
  }();

  var pooling = function () {
    function _double(arr) {
      return arr.concat(createSizedArray(arr.length));
    }
    return {
      "double": _double
    };
  }();

  var poolFactory = function () {
    return function (initialLength, _create, _release) {
      var _length = 0;
      var _maxLength = initialLength;
      var pool = createSizedArray(_maxLength);
      var ob = {
        newElement: newElement,
        release: release
      };
      function newElement() {
        var element;
        if (_length) {
          _length -= 1;
          element = pool[_length];
        } else {
          element = _create();
        }
        return element;
      }
      function release(element) {
        if (_length === _maxLength) {
          pool = pooling["double"](pool);
          _maxLength *= 2;
        }
        if (_release) {
          _release(element);
        }
        pool[_length] = element;
        _length += 1;
      }
      return ob;
    };
  }();

  var bezierLengthPool = function () {
    function create() {
      return {
        addedLength: 0,
        percents: createTypedArray('float32', getDefaultCurveSegments()),
        lengths: createTypedArray('float32', getDefaultCurveSegments())
      };
    }
    return poolFactory(8, create);
  }();

  var segmentsLengthPool = function () {
    function create() {
      return {
        lengths: [],
        totalLength: 0
      };
    }
    function release(element) {
      var i;
      var len = element.lengths.length;
      for (i = 0; i < len; i += 1) {
        bezierLengthPool.release(element.lengths[i]);
      }
      element.lengths.length = 0;
    }
    return poolFactory(8, create, release);
  }();

  function bezFunction() {
    var math = Math;
    function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
      var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
      return det1 > -0.001 && det1 < 0.001;
    }
    function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
      if (z1 === 0 && z2 === 0 && z3 === 0) {
        return pointOnLine2D(x1, y1, x2, y2, x3, y3);
      }
      var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
      var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
      var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
      var diffDist;
      if (dist1 > dist2) {
        if (dist1 > dist3) {
          diffDist = dist1 - dist2 - dist3;
        } else {
          diffDist = dist3 - dist2 - dist1;
        }
      } else if (dist3 > dist2) {
        diffDist = dist3 - dist2 - dist1;
      } else {
        diffDist = dist2 - dist1 - dist3;
      }
      return diffDist > -0.0001 && diffDist < 0.0001;
    }
    var getBezierLength = function () {
      return function (pt1, pt2, pt3, pt4) {
        var curveSegments = getDefaultCurveSegments();
        var k;
        var i;
        var len;
        var ptCoord;
        var perc;
        var addedLength = 0;
        var ptDistance;
        var point = [];
        var lastPoint = [];
        var lengthData = bezierLengthPool.newElement();
        len = pt3.length;
        for (k = 0; k < curveSegments; k += 1) {
          perc = k / (curveSegments - 1);
          ptDistance = 0;
          for (i = 0; i < len; i += 1) {
            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
            point[i] = ptCoord;
            if (lastPoint[i] !== null) {
              ptDistance += bmPow(point[i] - lastPoint[i], 2);
            }
            lastPoint[i] = point[i];
          }
          if (ptDistance) {
            ptDistance = bmSqrt(ptDistance);
            addedLength += ptDistance;
          }
          lengthData.percents[k] = perc;
          lengthData.lengths[k] = addedLength;
        }
        lengthData.addedLength = addedLength;
        return lengthData;
      };
    }();
    function getSegmentsLength(shapeData) {
      var segmentsLength = segmentsLengthPool.newElement();
      var closed = shapeData.c;
      var pathV = shapeData.v;
      var pathO = shapeData.o;
      var pathI = shapeData.i;
      var i;
      var len = shapeData._length;
      var lengths = segmentsLength.lengths;
      var totalLength = 0;
      for (i = 0; i < len - 1; i += 1) {
        lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
        totalLength += lengths[i].addedLength;
      }
      if (closed && len) {
        lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
        totalLength += lengths[i].addedLength;
      }
      segmentsLength.totalLength = totalLength;
      return segmentsLength;
    }
    function BezierData(length) {
      this.segmentLength = 0;
      this.points = new Array(length);
    }
    function PointData(partial, point) {
      this.partialLength = partial;
      this.point = point;
    }
    var buildBezierData = function () {
      var storedData = {};
      return function (pt1, pt2, pt3, pt4) {
        var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
        if (!storedData[bezierName]) {
          var curveSegments = getDefaultCurveSegments();
          var k;
          var i;
          var len;
          var ptCoord;
          var perc;
          var addedLength = 0;
          var ptDistance;
          var point;
          var lastPoint = null;
          if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
            curveSegments = 2;
          }
          var bezierData = new BezierData(curveSegments);
          len = pt3.length;
          for (k = 0; k < curveSegments; k += 1) {
            point = createSizedArray(len);
            perc = k / (curveSegments - 1);
            ptDistance = 0;
            for (i = 0; i < len; i += 1) {
              ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
              point[i] = ptCoord;
              if (lastPoint !== null) {
                ptDistance += bmPow(point[i] - lastPoint[i], 2);
              }
            }
            ptDistance = bmSqrt(ptDistance);
            addedLength += ptDistance;
            bezierData.points[k] = new PointData(ptDistance, point);
            lastPoint = point;
          }
          bezierData.segmentLength = addedLength;
          storedData[bezierName] = bezierData;
        }
        return storedData[bezierName];
      };
    }();
    function getDistancePerc(perc, bezierData) {
      var percents = bezierData.percents;
      var lengths = bezierData.lengths;
      var len = percents.length;
      var initPos = bmFloor((len - 1) * perc);
      var lengthPos = perc * bezierData.addedLength;
      var lPerc = 0;
      if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
        return percents[initPos];
      }
      var dir = lengths[initPos] > lengthPos ? -1 : 1;
      var flag = true;
      while (flag) {
        if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
          lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
          flag = false;
        } else {
          initPos += dir;
        }
        if (initPos < 0 || initPos >= len - 1) {
          // FIX for TypedArrays that don't store floating point values with enough accuracy
          if (initPos === len - 1) {
            return percents[initPos];
          }
          flag = false;
        }
      }
      return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
    }
    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
      var t1 = getDistancePerc(percent, bezierData);
      var u1 = 1 - t1;
      var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
      var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
      return [ptX, ptY];
    }
    var bezierSegmentPoints = createTypedArray('float32', 8);
    function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
      if (startPerc < 0) {
        startPerc = 0;
      } else if (startPerc > 1) {
        startPerc = 1;
      }
      var t0 = getDistancePerc(startPerc, bezierData);
      endPerc = endPerc > 1 ? 1 : endPerc;
      var t1 = getDistancePerc(endPerc, bezierData);
      var i;
      var len = pt1.length;
      var u0 = 1 - t0;
      var u1 = 1 - t1;
      var u0u0u0 = u0 * u0 * u0;
      var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
      var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
      var t0t0t0 = t0 * t0 * t0;
      //
      var u0u0u1 = u0 * u0 * u1;
      var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
      var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
      var t0t0t1 = t0 * t0 * t1;
      //
      var u0u1u1 = u0 * u1 * u1;
      var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
      var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
      var t0t1t1 = t0 * t1 * t1;
      //
      var u1u1u1 = u1 * u1 * u1;
      var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
      var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
      var t1t1t1 = t1 * t1 * t1;
      for (i = 0; i < len; i += 1) {
        bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
        bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
        bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
        bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      }
      return bezierSegmentPoints;
    }
    return {
      getSegmentsLength: getSegmentsLength,
      getNewSegment: getNewSegment,
      getPointInSegment: getPointInSegment,
      buildBezierData: buildBezierData,
      pointOnLine2D: pointOnLine2D,
      pointOnLine3D: pointOnLine3D
    };
  }
  var bez = bezFunction();

  var initFrame = initialDefaultFrame;
  var mathAbs = Math.abs;
  function interpolateValue(frameNum, caching) {
    var offsetTime = this.offsetTime;
    var newValue;
    if (this.propType === 'multidimensional') {
      newValue = createTypedArray('float32', this.pv.length);
    }
    var iterationIndex = caching.lastIndex;
    var i = iterationIndex;
    var len = this.keyframes.length - 1;
    var flag = true;
    var keyData;
    var nextKeyData;
    var keyframeMetadata;
    while (flag) {
      keyData = this.keyframes[i];
      nextKeyData = this.keyframes[i + 1];
      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
        if (keyData.h) {
          keyData = nextKeyData;
        }
        iterationIndex = 0;
        break;
      }
      if (nextKeyData.t - offsetTime > frameNum) {
        iterationIndex = i;
        break;
      }
      if (i < len - 1) {
        i += 1;
      } else {
        iterationIndex = 0;
        flag = false;
      }
    }
    keyframeMetadata = this.keyframesMetadata[i] || {};
    var k;
    var kLen;
    var perc;
    var jLen;
    var j;
    var fnc;
    var nextKeyTime = nextKeyData.t - offsetTime;
    var keyTime = keyData.t - offsetTime;
    var endValue;
    if (keyData.to) {
      if (!keyframeMetadata.bezierData) {
        keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
      }
      var bezierData = keyframeMetadata.bezierData;
      if (frameNum >= nextKeyTime || frameNum < keyTime) {
        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
        kLen = bezierData.points[ind].point.length;
        for (k = 0; k < kLen; k += 1) {
          newValue[k] = bezierData.points[ind].point[k];
        }
        // caching._lastKeyframeIndex = -1;
      } else {
        if (keyframeMetadata.__fnct) {
          fnc = keyframeMetadata.__fnct;
        } else {
          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
          keyframeMetadata.__fnct = fnc;
        }
        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
        var distanceInLine = bezierData.segmentLength * perc;
        var segmentPerc;
        var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
        j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
        flag = true;
        jLen = bezierData.points.length;
        while (flag) {
          addedLength += bezierData.points[j].partialLength;
          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
            kLen = bezierData.points[j].point.length;
            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k];
            }
            break;
          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
            kLen = bezierData.points[j].point.length;
            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
            }
            break;
          }
          if (j < jLen - 1) {
            j += 1;
          } else {
            flag = false;
          }
        }
        caching._lastPoint = j;
        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
        caching._lastKeyframeIndex = i;
      }
    } else {
      var outX;
      var outY;
      var inX;
      var inY;
      var keyValue;
      len = keyData.s.length;
      endValue = nextKeyData.s || keyData.e;
      if (this.sh && keyData.h !== 1) {
        if (frameNum >= nextKeyTime) {
          newValue[0] = endValue[0];
          newValue[1] = endValue[1];
          newValue[2] = endValue[2];
        } else if (frameNum <= keyTime) {
          newValue[0] = keyData.s[0];
          newValue[1] = keyData.s[1];
          newValue[2] = keyData.s[2];
        } else {
          var quatStart = createQuaternion(keyData.s);
          var quatEnd = createQuaternion(endValue);
          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
        }
      } else {
        for (i = 0; i < len; i += 1) {
          if (keyData.h !== 1) {
            if (frameNum >= nextKeyTime) {
              perc = 1;
            } else if (frameNum < keyTime) {
              perc = 0;
            } else {
              if (keyData.o.x.constructor === Array) {
                if (!keyframeMetadata.__fnct) {
                  keyframeMetadata.__fnct = [];
                }
                if (!keyframeMetadata.__fnct[i]) {
                  outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                  outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                  inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                  inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                  keyframeMetadata.__fnct[i] = fnc;
                } else {
                  fnc = keyframeMetadata.__fnct[i];
                }
              } else if (!keyframeMetadata.__fnct) {
                outX = keyData.o.x;
                outY = keyData.o.y;
                inX = keyData.i.x;
                inY = keyData.i.y;
                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                keyData.keyframeMetadata = fnc;
              } else {
                fnc = keyframeMetadata.__fnct;
              }
              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
            }
          }
          endValue = nextKeyData.s || keyData.e;
          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
          if (this.propType === 'multidimensional') {
            newValue[i] = keyValue;
          } else {
            newValue = keyValue;
          }
        }
      }
    }
    caching.lastIndex = iterationIndex;
    return newValue;
  }

  // based on @Toji's https://github.com/toji/gl-matrix/
  function slerp(a, b, t) {
    var out = [];
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    var bx = b[0];
    var by = b[1];
    var bz = b[2];
    var bw = b[3];
    var omega;
    var cosom;
    var sinom;
    var scale0;
    var scale1;
    cosom = ax * bx + ay * by + az * bz + aw * bw;
    if (cosom < 0.0) {
      cosom = -cosom;
      bx = -bx;
      by = -by;
      bz = -bz;
      bw = -bw;
    }
    if (1.0 - cosom > 0.000001) {
      omega = Math.acos(cosom);
      sinom = Math.sin(omega);
      scale0 = Math.sin((1.0 - t) * omega) / sinom;
      scale1 = Math.sin(t * omega) / sinom;
    } else {
      scale0 = 1.0 - t;
      scale1 = t;
    }
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
  }
  function quaternionToEuler(out, quat) {
    var qx = quat[0];
    var qy = quat[1];
    var qz = quat[2];
    var qw = quat[3];
    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
    out[0] = heading / degToRads;
    out[1] = attitude / degToRads;
    out[2] = bank / degToRads;
  }
  function createQuaternion(values) {
    var heading = values[0] * degToRads;
    var attitude = values[1] * degToRads;
    var bank = values[2] * degToRads;
    var c1 = Math.cos(heading / 2);
    var c2 = Math.cos(attitude / 2);
    var c3 = Math.cos(bank / 2);
    var s1 = Math.sin(heading / 2);
    var s2 = Math.sin(attitude / 2);
    var s3 = Math.sin(bank / 2);
    var w = c1 * c2 * c3 - s1 * s2 * s3;
    var x = s1 * s2 * c3 + c1 * c2 * s3;
    var y = s1 * c2 * c3 + c1 * s2 * s3;
    var z = c1 * s2 * c3 - s1 * c2 * s3;
    return [x, y, z, w];
  }
  function getValueAtCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
    if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
      if (this._caching.lastFrame >= frameNum) {
        this._caching._lastKeyframeIndex = -1;
        this._caching.lastIndex = 0;
      }
      var renderResult = this.interpolateValue(frameNum, this._caching);
      this.pv = renderResult;
    }
    this._caching.lastFrame = frameNum;
    return this.pv;
  }
  function setVValue(val) {
    var multipliedValue;
    if (this.propType === 'unidimensional') {
      multipliedValue = val * this.mult;
      if (mathAbs(this.v - multipliedValue) > 0.00001) {
        this.v = multipliedValue;
        this._mdf = true;
      }
    } else {
      var i = 0;
      var len = this.v.length;
      while (i < len) {
        multipliedValue = val[i] * this.mult;
        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
          this.v[i] = multipliedValue;
          this._mdf = true;
        }
        i += 1;
      }
    }
  }
  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
      return;
    }
    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }
    this.lock = true;
    this._mdf = this._isFirstFrame;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = this.kf ? this.pv : this.data.k;
    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }
    this.setVValue(finalValue);
    this._isFirstFrame = false;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }
  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }
  function ValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.mult = mult || 1;
    this.data = data;
    this.v = mult ? data.k * mult : data.k;
    this.pv = data.k;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.vel = 0;
    this.effectsSequence = [];
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }
  function MultiDimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    this.mult = mult || 1;
    this.data = data;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.frameId = -1;
    var i;
    var len = data.k.length;
    this.v = createTypedArray('float32', len);
    this.pv = createTypedArray('float32', len);
    this.vel = createTypedArray('float32', len);
    for (i = 0; i < len; i += 1) {
      this.v[i] = data.k[i] * this.mult;
      this.pv[i] = data.k[i];
    }
    this._isFirstFrame = true;
    this.effectsSequence = [];
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }
  function KeyframedValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.frameId = -1;
    this._caching = {
      lastFrame: initFrame,
      lastIndex: 0,
      value: 0,
      _lastKeyframeIndex: -1
    };
    this.k = true;
    this.kf = true;
    this.data = data;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.v = initFrame;
    this.pv = initFrame;
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.addEffect = addEffect;
  }
  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    var i;
    var len = data.k.length;
    var s;
    var e;
    var to;
    var ti;
    for (i = 0; i < len - 1; i += 1) {
      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
        s = data.k[i].s;
        e = data.k[i + 1].s;
        to = data.k[i].to;
        ti = data.k[i].ti;
        if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
          data.k[i].to = null;
          data.k[i].ti = null;
        }
        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
          if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
            data.k[i].to = null;
            data.k[i].ti = null;
          }
        }
      }
    }
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.data = data;
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.k = true;
    this.kf = true;
    this._isFirstFrame = true;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.frameId = -1;
    var arrLen = data.k[0].s.length;
    this.v = createTypedArray('float32', arrLen);
    this.pv = createTypedArray('float32', arrLen);
    for (i = 0; i < arrLen; i += 1) {
      this.v[i] = initFrame;
      this.pv[i] = initFrame;
    }
    this._caching = {
      lastFrame: initFrame,
      lastIndex: 0,
      value: createTypedArray('float32', arrLen)
    };
    this.addEffect = addEffect;
  }
  var PropertyFactory = function () {
    function getProp(elem, data, type, mult, container) {
      if (data.sid) {
        data = elem.globalData.slotManager.getProp(data);
      }
      var p;
      if (!data.k.length) {
        p = new ValueProperty(elem, data, mult, container);
      } else if (typeof data.k[0] === 'number') {
        p = new MultiDimensionalProperty(elem, data, mult, container);
      } else {
        switch (type) {
          case 0:
            p = new KeyframedValueProperty(elem, data, mult, container);
            break;
          case 1:
            p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
            break;
          default:
            break;
        }
      }
      if (p.effectsSequence.length) {
        container.addDynamicProperty(p);
      }
      return p;
    }
    var ob = {
      getProp: getProp
    };
    return ob;
  }();

  function DynamicPropertyContainer() {}
  DynamicPropertyContainer.prototype = {
    addDynamicProperty: function addDynamicProperty(prop) {
      if (this.dynamicProperties.indexOf(prop) === -1) {
        this.dynamicProperties.push(prop);
        this.container.addDynamicProperty(this);
        this._isAnimated = true;
      }
    },
    iterateDynamicProperties: function iterateDynamicProperties() {
      this._mdf = false;
      var i;
      var len = this.dynamicProperties.length;
      for (i = 0; i < len; i += 1) {
        this.dynamicProperties[i].getValue();
        if (this.dynamicProperties[i]._mdf) {
          this._mdf = true;
        }
      }
    },
    initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
      this.container = container;
      this.dynamicProperties = [];
      this._mdf = false;
      this._isAnimated = false;
    }
  };

  var pointPool = function () {
    function create() {
      return createTypedArray('float32', 2);
    }
    return poolFactory(8, create);
  }();

  function ShapePath() {
    this.c = false;
    this._length = 0;
    this._maxLength = 8;
    this.v = createSizedArray(this._maxLength);
    this.o = createSizedArray(this._maxLength);
    this.i = createSizedArray(this._maxLength);
  }
  ShapePath.prototype.setPathData = function (closed, len) {
    this.c = closed;
    this.setLength(len);
    var i = 0;
    while (i < len) {
      this.v[i] = pointPool.newElement();
      this.o[i] = pointPool.newElement();
      this.i[i] = pointPool.newElement();
      i += 1;
    }
  };
  ShapePath.prototype.setLength = function (len) {
    while (this._maxLength < len) {
      this.doubleArrayLength();
    }
    this._length = len;
  };
  ShapePath.prototype.doubleArrayLength = function () {
    this.v = this.v.concat(createSizedArray(this._maxLength));
    this.i = this.i.concat(createSizedArray(this._maxLength));
    this.o = this.o.concat(createSizedArray(this._maxLength));
    this._maxLength *= 2;
  };
  ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
    var arr;
    this._length = Math.max(this._length, pos + 1);
    if (this._length >= this._maxLength) {
      this.doubleArrayLength();
    }
    switch (type) {
      case 'v':
        arr = this.v;
        break;
      case 'i':
        arr = this.i;
        break;
      case 'o':
        arr = this.o;
        break;
      default:
        arr = [];
        break;
    }
    if (!arr[pos] || arr[pos] && !replace) {
      arr[pos] = pointPool.newElement();
    }
    arr[pos][0] = x;
    arr[pos][1] = y;
  };
  ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
    this.setXYAt(vX, vY, 'v', pos, replace);
    this.setXYAt(oX, oY, 'o', pos, replace);
    this.setXYAt(iX, iY, 'i', pos, replace);
  };
  ShapePath.prototype.reverse = function () {
    var newPath = new ShapePath();
    newPath.setPathData(this.c, this._length);
    var vertices = this.v;
    var outPoints = this.o;
    var inPoints = this.i;
    var init = 0;
    if (this.c) {
      newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
      init = 1;
    }
    var cnt = this._length - 1;
    var len = this._length;
    var i;
    for (i = init; i < len; i += 1) {
      newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
      cnt -= 1;
    }
    return newPath;
  };
  ShapePath.prototype.length = function () {
    return this._length;
  };

  var shapePool = function () {
    function create() {
      return new ShapePath();
    }
    function release(shapePath) {
      var len = shapePath._length;
      var i;
      for (i = 0; i < len; i += 1) {
        pointPool.release(shapePath.v[i]);
        pointPool.release(shapePath.i[i]);
        pointPool.release(shapePath.o[i]);
        shapePath.v[i] = null;
        shapePath.i[i] = null;
        shapePath.o[i] = null;
      }
      shapePath._length = 0;
      shapePath.c = false;
    }
    function clone(shape) {
      var cloned = factory.newElement();
      var i;
      var len = shape._length === undefined ? shape.v.length : shape._length;
      cloned.setLength(len);
      cloned.c = shape.c;
      for (i = 0; i < len; i += 1) {
        cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
      }
      return cloned;
    }
    var factory = poolFactory(4, create, release);
    factory.clone = clone;
    return factory;
  }();

  function ShapeCollection() {
    this._length = 0;
    this._maxLength = 4;
    this.shapes = createSizedArray(this._maxLength);
  }
  ShapeCollection.prototype.addShape = function (shapeData) {
    if (this._length === this._maxLength) {
      this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
      this._maxLength *= 2;
    }
    this.shapes[this._length] = shapeData;
    this._length += 1;
  };
  ShapeCollection.prototype.releaseShapes = function () {
    var i;
    for (i = 0; i < this._length; i += 1) {
      shapePool.release(this.shapes[i]);
    }
    this._length = 0;
  };

  var shapeCollectionPool = function () {
    var ob = {
      newShapeCollection: newShapeCollection,
      release: release
    };
    var _length = 0;
    var _maxLength = 4;
    var pool = createSizedArray(_maxLength);
    function newShapeCollection() {
      var shapeCollection;
      if (_length) {
        _length -= 1;
        shapeCollection = pool[_length];
      } else {
        shapeCollection = new ShapeCollection();
      }
      return shapeCollection;
    }
    function release(shapeCollection) {
      var i;
      var len = shapeCollection._length;
      for (i = 0; i < len; i += 1) {
        shapePool.release(shapeCollection.shapes[i]);
      }
      shapeCollection._length = 0;
      if (_length === _maxLength) {
        pool = pooling["double"](pool);
        _maxLength *= 2;
      }
      pool[_length] = shapeCollection;
      _length += 1;
    }
    return ob;
  }();

  var ShapePropertyFactory = function () {
    var initFrame = -999999;
    function interpolateShape(frameNum, previousValue, caching) {
      var iterationIndex = caching.lastIndex;
      var keyPropS;
      var keyPropE;
      var isHold;
      var j;
      var k;
      var jLen;
      var kLen;
      var perc;
      var vertexValue;
      var kf = this.keyframes;
      if (frameNum < kf[0].t - this.offsetTime) {
        keyPropS = kf[0].s[0];
        isHold = true;
        iterationIndex = 0;
      } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
        keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
        /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */
        isHold = true;
      } else {
        var i = iterationIndex;
        var len = kf.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while (flag) {
          keyData = kf[i];
          nextKeyData = kf[i + 1];
          if (nextKeyData.t - this.offsetTime > frameNum) {
            break;
          }
          if (i < len - 1) {
            i += 1;
          } else {
            flag = false;
          }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        isHold = keyData.h === 1;
        iterationIndex = i;
        if (!isHold) {
          if (frameNum >= nextKeyData.t - this.offsetTime) {
            perc = 1;
          } else if (frameNum < keyData.t - this.offsetTime) {
            perc = 0;
          } else {
            var fnc;
            if (keyframeMetadata.__fnct) {
              fnc = keyframeMetadata.__fnct;
            } else {
              fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
              keyframeMetadata.__fnct = fnc;
            }
            perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
          }
          keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
        }
        keyPropS = keyData.s[0];
      }
      jLen = previousValue._length;
      kLen = keyPropS.i[0].length;
      caching.lastIndex = iterationIndex;
      for (j = 0; j < jLen; j += 1) {
        for (k = 0; k < kLen; k += 1) {
          vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
          previousValue.i[j][k] = vertexValue;
          vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
          previousValue.o[j][k] = vertexValue;
          vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
          previousValue.v[j][k] = vertexValue;
        }
      }
    }
    function interpolateShapeCurrentTime() {
      var frameNum = this.comp.renderedFrame - this.offsetTime;
      var initTime = this.keyframes[0].t - this.offsetTime;
      var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      var lastFrame = this._caching.lastFrame;
      if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
        /// /
        this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
        this.interpolateShape(frameNum, this.pv, this._caching);
        /// /
      }
      this._caching.lastFrame = frameNum;
      return this.pv;
    }
    function resetShape() {
      this.paths = this.localShapeCollection;
    }
    function shapesEqual(shape1, shape2) {
      if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
        return false;
      }
      var i;
      var len = shape1._length;
      for (i = 0; i < len; i += 1) {
        if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) {
          return false;
        }
      }
      return true;
    }
    function setVValue(newPath) {
      if (!shapesEqual(this.v, newPath)) {
        this.v = shapePool.clone(newPath);
        this.localShapeCollection.releaseShapes();
        this.localShapeCollection.addShape(this.v);
        this._mdf = true;
        this.paths = this.localShapeCollection;
      }
    }
    function processEffectsSequence() {
      if (this.elem.globalData.frameId === this.frameId) {
        return;
      }
      if (!this.effectsSequence.length) {
        this._mdf = false;
        return;
      }
      if (this.lock) {
        this.setVValue(this.pv);
        return;
      }
      this.lock = true;
      this._mdf = false;
      var finalValue;
      if (this.kf) {
        finalValue = this.pv;
      } else if (this.data.ks) {
        finalValue = this.data.ks.k;
      } else {
        finalValue = this.data.pt.k;
      }
      var i;
      var len = this.effectsSequence.length;
      for (i = 0; i < len; i += 1) {
        finalValue = this.effectsSequence[i](finalValue);
      }
      this.setVValue(finalValue);
      this.lock = false;
      this.frameId = this.elem.globalData.frameId;
    }
    function ShapeProperty(elem, data, type) {
      this.propType = 'shape';
      this.comp = elem.comp;
      this.container = elem;
      this.elem = elem;
      this.data = data;
      this.k = false;
      this.kf = false;
      this._mdf = false;
      var pathData = type === 3 ? data.pt.k : data.ks.k;
      this.v = shapePool.clone(pathData);
      this.pv = shapePool.clone(this.v);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.paths.addShape(this.v);
      this.reset = resetShape;
      this.effectsSequence = [];
    }
    function addEffect(effectFunction) {
      this.effectsSequence.push(effectFunction);
      this.container.addDynamicProperty(this);
    }
    ShapeProperty.prototype.interpolateShape = interpolateShape;
    ShapeProperty.prototype.getValue = processEffectsSequence;
    ShapeProperty.prototype.setVValue = setVValue;
    ShapeProperty.prototype.addEffect = addEffect;
    function KeyframedShapeProperty(elem, data, type) {
      this.propType = 'shape';
      this.comp = elem.comp;
      this.elem = elem;
      this.container = elem;
      this.offsetTime = elem.data.st;
      this.keyframes = type === 3 ? data.pt.k : data.ks.k;
      this.keyframesMetadata = [];
      this.k = true;
      this.kf = true;
      var len = this.keyframes[0].s[0].i.length;
      this.v = shapePool.newElement();
      this.v.setPathData(this.keyframes[0].s[0].c, len);
      this.pv = shapePool.clone(this.v);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.paths.addShape(this.v);
      this.lastFrame = initFrame;
      this.reset = resetShape;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0
      };
      this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
    }
    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
    KeyframedShapeProperty.prototype.setVValue = setVValue;
    KeyframedShapeProperty.prototype.addEffect = addEffect;
    var EllShapeProperty = function () {
      var cPoint = roundCorner;
      function EllShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.setPathData(true, 4);
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.localShapeCollection.addShape(this.v);
        this.d = data.d;
        this.elem = elem;
        this.comp = elem.comp;
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertEllToPath();
        }
      }
      EllShapePropertyFactory.prototype = {
        reset: resetShape,
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }
          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();
          if (this._mdf) {
            this.convertEllToPath();
          }
        },
        convertEllToPath: function convertEllToPath() {
          var p0 = this.p.v[0];
          var p1 = this.p.v[1];
          var s0 = this.s.v[0] / 2;
          var s1 = this.s.v[1] / 2;
          var _cw = this.d !== 3;
          var _v = this.v;
          _v.v[0][0] = p0;
          _v.v[0][1] = p1 - s1;
          _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.v[1][1] = p1;
          _v.v[2][0] = p0;
          _v.v[2][1] = p1 + s1;
          _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.v[3][1] = p1;
          _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
          _v.i[0][1] = p1 - s1;
          _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.i[1][1] = p1 - s1 * cPoint;
          _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
          _v.i[2][1] = p1 + s1;
          _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.i[3][1] = p1 + s1 * cPoint;
          _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
          _v.o[0][1] = p1 - s1;
          _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.o[1][1] = p1 + s1 * cPoint;
          _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
          _v.o[2][1] = p1 + s1;
          _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.o[3][1] = p1 - s1 * cPoint;
        }
      };
      extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);
      return EllShapePropertyFactory;
    }();
    var StarShapeProperty = function () {
      function StarShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.setPathData(true, 0);
        this.elem = elem;
        this.comp = elem.comp;
        this.data = data;
        this.frameId = -1;
        this.d = data.d;
        this.initDynamicPropertyContainer(elem);
        if (data.sy === 1) {
          this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
          this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
          this.convertToPath = this.convertStarToPath;
        } else {
          this.convertToPath = this.convertPolygonToPath;
        }
        this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
        this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
        this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.localShapeCollection.addShape(this.v);
        this.paths = this.localShapeCollection;
        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertToPath();
        }
      }
      StarShapePropertyFactory.prototype = {
        reset: resetShape,
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }
          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();
          if (this._mdf) {
            this.convertToPath();
          }
        },
        convertStarToPath: function convertStarToPath() {
          var numPts = Math.floor(this.pt.v) * 2;
          var angle = Math.PI * 2 / numPts;
          /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */
          var longFlag = true;
          var longRad = this.or.v;
          var shortRad = this.ir.v;
          var longRound = this.os.v;
          var shortRound = this.is.v;
          var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
          var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
          var i;
          var rad;
          var roundness;
          var perimSegment;
          var currentAng = -Math.PI / 2;
          currentAng += this.r.v;
          var dir = this.data.d === 3 ? -1 : 1;
          this.v._length = 0;
          for (i = 0; i < numPts; i += 1) {
            rad = longFlag ? longRad : shortRad;
            roundness = longFlag ? longRound : shortRound;
            perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
            var x = rad * Math.cos(currentAng);
            var y = rad * Math.sin(currentAng);
            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
            x += +this.p.v[0];
            y += +this.p.v[1];
            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);

            /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */
            longFlag = !longFlag;
            currentAng += angle * dir;
          }
        },
        convertPolygonToPath: function convertPolygonToPath() {
          var numPts = Math.floor(this.pt.v);
          var angle = Math.PI * 2 / numPts;
          var rad = this.or.v;
          var roundness = this.os.v;
          var perimSegment = 2 * Math.PI * rad / (numPts * 4);
          var i;
          var currentAng = -Math.PI * 0.5;
          var dir = this.data.d === 3 ? -1 : 1;
          currentAng += this.r.v;
          this.v._length = 0;
          for (i = 0; i < numPts; i += 1) {
            var x = rad * Math.cos(currentAng);
            var y = rad * Math.sin(currentAng);
            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
            x += +this.p.v[0];
            y += +this.p.v[1];
            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
            currentAng += angle * dir;
          }
          this.paths.length = 0;
          this.paths[0] = this.v;
        }
      };
      extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);
      return StarShapePropertyFactory;
    }();
    var RectShapeProperty = function () {
      function RectShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.c = true;
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.localShapeCollection.addShape(this.v);
        this.paths = this.localShapeCollection;
        this.elem = elem;
        this.comp = elem.comp;
        this.frameId = -1;
        this.d = data.d;
        this.initDynamicPropertyContainer(elem);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
        this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertRectToPath();
        }
      }
      RectShapePropertyFactory.prototype = {
        convertRectToPath: function convertRectToPath() {
          var p0 = this.p.v[0];
          var p1 = this.p.v[1];
          var v0 = this.s.v[0] / 2;
          var v1 = this.s.v[1] / 2;
          var round = bmMin(v0, v1, this.r.v);
          var cPoint = round * (1 - roundCorner);
          this.v._length = 0;
          if (this.d === 2 || this.d === 1) {
            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
            if (round !== 0) {
              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
            } else {
              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
            }
          } else {
            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
            if (round !== 0) {
              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
              this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
            } else {
              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
              this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
            }
          }
        },
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }
          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();
          if (this._mdf) {
            this.convertRectToPath();
          }
        },
        reset: resetShape
      };
      extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);
      return RectShapePropertyFactory;
    }();
    function getShapeProp(elem, data, type) {
      var prop;
      if (type === 3 || type === 4) {
        var dataProp = type === 3 ? data.pt : data.ks;
        var keys = dataProp.k;
        if (keys.length) {
          prop = new KeyframedShapeProperty(elem, data, type);
        } else {
          prop = new ShapeProperty(elem, data, type);
        }
      } else if (type === 5) {
        prop = new RectShapeProperty(elem, data);
      } else if (type === 6) {
        prop = new EllShapeProperty(elem, data);
      } else if (type === 7) {
        prop = new StarShapeProperty(elem, data);
      }
      if (prop.k) {
        elem.addDynamicProperty(prop);
      }
      return prop;
    }
    function getConstructorFunction() {
      return ShapeProperty;
    }
    function getKeyframedConstructorFunction() {
      return KeyframedShapeProperty;
    }
    var ob = {};
    ob.getShapeProp = getShapeProp;
    ob.getConstructorFunction = getConstructorFunction;
    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
    return ob;
  }();

  /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */

  /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */

  var Matrix = function () {
    var _cos = Math.cos;
    var _sin = Math.sin;
    var _tan = Math.tan;
    var _rnd = Math.round;
    function reset() {
      this.props[0] = 1;
      this.props[1] = 0;
      this.props[2] = 0;
      this.props[3] = 0;
      this.props[4] = 0;
      this.props[5] = 1;
      this.props[6] = 0;
      this.props[7] = 0;
      this.props[8] = 0;
      this.props[9] = 0;
      this.props[10] = 1;
      this.props[11] = 0;
      this.props[12] = 0;
      this.props[13] = 0;
      this.props[14] = 0;
      this.props[15] = 1;
      return this;
    }
    function rotate(angle) {
      if (angle === 0) {
        return this;
      }
      var mCos = _cos(angle);
      var mSin = _sin(angle);
      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }
    function rotateX(angle) {
      if (angle === 0) {
        return this;
      }
      var mCos = _cos(angle);
      var mSin = _sin(angle);
      return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
    }
    function rotateY(angle) {
      if (angle === 0) {
        return this;
      }
      var mCos = _cos(angle);
      var mSin = _sin(angle);
      return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
    }
    function rotateZ(angle) {
      if (angle === 0) {
        return this;
      }
      var mCos = _cos(angle);
      var mSin = _sin(angle);
      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }
    function shear(sx, sy) {
      return this._t(1, sy, sx, 1, 0, 0);
    }
    function skew(ax, ay) {
      return this.shear(_tan(ax), _tan(ay));
    }
    function skewFromAxis(ax, angle) {
      var mCos = _cos(angle);
      var mSin = _sin(angle);
      return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
    }
    function scale(sx, sy, sz) {
      if (!sz && sz !== 0) {
        sz = 1;
      }
      if (sx === 1 && sy === 1 && sz === 1) {
        return this;
      }
      return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
    }
    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
      this.props[0] = a;
      this.props[1] = b;
      this.props[2] = c;
      this.props[3] = d;
      this.props[4] = e;
      this.props[5] = f;
      this.props[6] = g;
      this.props[7] = h;
      this.props[8] = i;
      this.props[9] = j;
      this.props[10] = k;
      this.props[11] = l;
      this.props[12] = m;
      this.props[13] = n;
      this.props[14] = o;
      this.props[15] = p;
      return this;
    }
    function translate(tx, ty, tz) {
      tz = tz || 0;
      if (tx !== 0 || ty !== 0 || tz !== 0) {
        return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
      }
      return this;
    }
    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
      var _p = this.props;
      if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
        // NOTE: commenting this condition because TurboFan deoptimizes code when present
        // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
        _p[12] = _p[12] * a2 + _p[15] * m2;
        _p[13] = _p[13] * f2 + _p[15] * n2;
        _p[14] = _p[14] * k2 + _p[15] * o2;
        _p[15] *= p2;
        // }
        this._identityCalculated = false;
        return this;
      }
      var a1 = _p[0];
      var b1 = _p[1];
      var c1 = _p[2];
      var d1 = _p[3];
      var e1 = _p[4];
      var f1 = _p[5];
      var g1 = _p[6];
      var h1 = _p[7];
      var i1 = _p[8];
      var j1 = _p[9];
      var k1 = _p[10];
      var l1 = _p[11];
      var m1 = _p[12];
      var n1 = _p[13];
      var o1 = _p[14];
      var p1 = _p[15];

      /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */
      _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
      _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
      _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
      _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
      _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
      _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
      _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
      _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
      _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
      _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
      _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
      _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
      _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
      _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
      _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
      _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
      this._identityCalculated = false;
      return this;
    }
    function multiply(matrix) {
      var matrixProps = matrix.props;
      return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
    }
    function isIdentity() {
      if (!this._identityCalculated) {
        this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
        this._identityCalculated = true;
      }
      return this._identity;
    }
    function equals(matr) {
      var i = 0;
      while (i < 16) {
        if (matr.props[i] !== this.props[i]) {
          return false;
        }
        i += 1;
      }
      return true;
    }
    function clone(matr) {
      var i;
      for (i = 0; i < 16; i += 1) {
        matr.props[i] = this.props[i];
      }
      return matr;
    }
    function cloneFromProps(props) {
      var i;
      for (i = 0; i < 16; i += 1) {
        this.props[i] = props[i];
      }
    }
    function applyToPoint(x, y, z) {
      return {
        x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
        y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
        z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
      };
      /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */
    }
    function applyToX(x, y, z) {
      return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
    }
    function applyToY(x, y, z) {
      return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
    }
    function applyToZ(x, y, z) {
      return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
    }
    function getInverseMatrix() {
      var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
      var a = this.props[5] / determinant;
      var b = -this.props[1] / determinant;
      var c = -this.props[4] / determinant;
      var d = this.props[0] / determinant;
      var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
      var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
      var inverseMatrix = new Matrix();
      inverseMatrix.props[0] = a;
      inverseMatrix.props[1] = b;
      inverseMatrix.props[4] = c;
      inverseMatrix.props[5] = d;
      inverseMatrix.props[12] = e;
      inverseMatrix.props[13] = f;
      return inverseMatrix;
    }
    function inversePoint(pt) {
      var inverseMatrix = this.getInverseMatrix();
      return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
    }
    function inversePoints(pts) {
      var i;
      var len = pts.length;
      var retPts = [];
      for (i = 0; i < len; i += 1) {
        retPts[i] = inversePoint(pts[i]);
      }
      return retPts;
    }
    function applyToTriplePoints(pt1, pt2, pt3) {
      var arr = createTypedArray('float32', 6);
      if (this.isIdentity()) {
        arr[0] = pt1[0];
        arr[1] = pt1[1];
        arr[2] = pt2[0];
        arr[3] = pt2[1];
        arr[4] = pt3[0];
        arr[5] = pt3[1];
      } else {
        var p0 = this.props[0];
        var p1 = this.props[1];
        var p4 = this.props[4];
        var p5 = this.props[5];
        var p12 = this.props[12];
        var p13 = this.props[13];
        arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
        arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
        arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
        arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
        arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
        arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
      }
      return arr;
    }
    function applyToPointArray(x, y, z) {
      var arr;
      if (this.isIdentity()) {
        arr = [x, y, z];
      } else {
        arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12], x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13], x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
      }
      return arr;
    }
    function applyToPointStringified(x, y) {
      if (this.isIdentity()) {
        return x + ',' + y;
      }
      var _p = this.props;
      return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
    }
    function toCSS() {
      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
      /* if(this.isIdentity()) {
              return '';
          } */
      var i = 0;
      var props = this.props;
      var cssValue = 'matrix3d(';
      var v = 10000;
      while (i < 16) {
        cssValue += _rnd(props[i] * v) / v;
        cssValue += i === 15 ? ')' : ',';
        i += 1;
      }
      return cssValue;
    }
    function roundMatrixProperty(val) {
      var v = 10000;
      if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) {
        return _rnd(val * v) / v;
      }
      return val;
    }
    function to2dCSS() {
      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
      /* if(this.isIdentity()) {
              return '';
          } */
      var props = this.props;
      var _a = roundMatrixProperty(props[0]);
      var _b = roundMatrixProperty(props[1]);
      var _c = roundMatrixProperty(props[4]);
      var _d = roundMatrixProperty(props[5]);
      var _e = roundMatrixProperty(props[12]);
      var _f = roundMatrixProperty(props[13]);
      return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
    }
    return function () {
      this.reset = reset;
      this.rotate = rotate;
      this.rotateX = rotateX;
      this.rotateY = rotateY;
      this.rotateZ = rotateZ;
      this.skew = skew;
      this.skewFromAxis = skewFromAxis;
      this.shear = shear;
      this.scale = scale;
      this.setTransform = setTransform;
      this.translate = translate;
      this.transform = transform;
      this.multiply = multiply;
      this.applyToPoint = applyToPoint;
      this.applyToX = applyToX;
      this.applyToY = applyToY;
      this.applyToZ = applyToZ;
      this.applyToPointArray = applyToPointArray;
      this.applyToTriplePoints = applyToTriplePoints;
      this.applyToPointStringified = applyToPointStringified;
      this.toCSS = toCSS;
      this.to2dCSS = to2dCSS;
      this.clone = clone;
      this.cloneFromProps = cloneFromProps;
      this.equals = equals;
      this.inversePoints = inversePoints;
      this.inversePoint = inversePoint;
      this.getInverseMatrix = getInverseMatrix;
      this._t = this.transform;
      this.isIdentity = isIdentity;
      this._identity = true;
      this._identityCalculated = false;
      this.props = createTypedArray('float32', 16);
      this.reset();
    };
  }();

  function _typeof$3(o) { "@babel/helpers - typeof"; return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$3(o); }
  var lottie = {};
  var standalone = '__[STANDALONE]__';
  var animationData = '__[ANIMATIONDATA]__';
  var renderer = '';
  function setLocation(href) {
    setLocationHref(href);
  }
  function searchAnimations() {
    if (standalone === true) {
      animationManager.searchAnimations(animationData, standalone, renderer);
    } else {
      animationManager.searchAnimations();
    }
  }
  function setSubframeRendering(flag) {
    setSubframeEnabled(flag);
  }
  function setPrefix(prefix) {
    setIdPrefix(prefix);
  }
  function loadAnimation(params) {
    if (standalone === true) {
      params.animationData = JSON.parse(animationData);
    }
    return animationManager.loadAnimation(params);
  }
  function setQuality(value) {
    if (typeof value === 'string') {
      switch (value) {
        case 'high':
          setDefaultCurveSegments(200);
          break;
        default:
        case 'medium':
          setDefaultCurveSegments(50);
          break;
        case 'low':
          setDefaultCurveSegments(10);
          break;
      }
    } else if (!isNaN(value) && value > 1) {
      setDefaultCurveSegments(value);
    }
    if (getDefaultCurveSegments() >= 50) {
      roundValues(false);
    } else {
      roundValues(true);
    }
  }
  function inBrowser() {
    return typeof navigator !== 'undefined';
  }
  function installPlugin(type, plugin) {
    if (type === 'expressions') {
      setExpressionsPlugin(plugin);
    }
  }
  function getFactory(name) {
    switch (name) {
      case 'propertyFactory':
        return PropertyFactory;
      case 'shapePropertyFactory':
        return ShapePropertyFactory;
      case 'matrix':
        return Matrix;
      default:
        return null;
    }
  }
  lottie.play = animationManager.play;
  lottie.pause = animationManager.pause;
  lottie.setLocationHref = setLocation;
  lottie.togglePause = animationManager.togglePause;
  lottie.setSpeed = animationManager.setSpeed;
  lottie.setDirection = animationManager.setDirection;
  lottie.stop = animationManager.stop;
  lottie.searchAnimations = searchAnimations;
  lottie.registerAnimation = animationManager.registerAnimation;
  lottie.loadAnimation = loadAnimation;
  lottie.setSubframeRendering = setSubframeRendering;
  lottie.resize = animationManager.resize;
  // lottie.start = start;
  lottie.goToAndStop = animationManager.goToAndStop;
  lottie.destroy = animationManager.destroy;
  lottie.setQuality = setQuality;
  lottie.inBrowser = inBrowser;
  lottie.installPlugin = installPlugin;
  lottie.freeze = animationManager.freeze;
  lottie.unfreeze = animationManager.unfreeze;
  lottie.setVolume = animationManager.setVolume;
  lottie.mute = animationManager.mute;
  lottie.unmute = animationManager.unmute;
  lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
  lottie.useWebWorker = setWebWorker;
  lottie.setIDPrefix = setPrefix;
  lottie.__getFactory = getFactory;
  lottie.version = '5.13.0';
  function checkReady() {
    if (document.readyState === 'complete') {
      clearInterval(readyStateCheckInterval);
      searchAnimations();
    }
  }
  function getQueryVariable(variable) {
    var vars = queryString.split('&');
    for (var i = 0; i < vars.length; i += 1) {
      var pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        // eslint-disable-line eqeqeq
        return decodeURIComponent(pair[1]);
      }
    }
    return null;
  }
  var queryString = '';
  if (standalone) {
    var scripts = document.getElementsByTagName('script');
    var index = scripts.length - 1;
    var myScript = scripts[index] || {
      src: ''
    };
    queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
    renderer = getQueryVariable('renderer');
  }
  var readyStateCheckInterval = setInterval(checkReady, 100);

  // this adds bodymovin to the window object for backwards compatibility
  try {
    if (!((typeof exports === "undefined" ? "undefined" : _typeof$3(exports)) === 'object' && typeof module !== 'undefined') && !(typeof define === 'function' && define.amd) // eslint-disable-line no-undef
    ) {
      window.bodymovin = lottie;
    }
  } catch (err) {
    //
  }

  var ShapeModifiers = function () {
    var ob = {};
    var modifiers = {};
    ob.registerModifier = registerModifier;
    ob.getModifier = getModifier;
    function registerModifier(nm, factory) {
      if (!modifiers[nm]) {
        modifiers[nm] = factory;
      }
    }
    function getModifier(nm, elem, data) {
      return new modifiers[nm](elem, data);
    }
    return ob;
  }();
  function ShapeModifier() {}
  ShapeModifier.prototype.initModifierProperties = function () {};
  ShapeModifier.prototype.addShapeToModifier = function () {};
  ShapeModifier.prototype.addShape = function (data) {
    if (!this.closed) {
      // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
      data.sh.container.addDynamicProperty(data.sh);
      var shapeData = {
        shape: data.sh,
        data: data,
        localShapeCollection: shapeCollectionPool.newShapeCollection()
      };
      this.shapes.push(shapeData);
      this.addShapeToModifier(shapeData);
      if (this._isAnimated) {
        data.setAsAnimated();
      }
    }
  };
  ShapeModifier.prototype.init = function (elem, data) {
    this.shapes = [];
    this.elem = elem;
    this.initDynamicPropertyContainer(elem);
    this.initModifierProperties(elem, data);
    this.frameId = initialDefaultFrame;
    this.closed = false;
    this.k = false;
    if (this.dynamicProperties.length) {
      this.k = true;
    } else {
      this.getValue(true);
    }
  };
  ShapeModifier.prototype.processKeys = function () {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    }
    this.frameId = this.elem.globalData.frameId;
    this.iterateDynamicProperties();
  };
  extendPrototype([DynamicPropertyContainer], ShapeModifier);

  function TrimModifier() {}
  extendPrototype([ShapeModifier], TrimModifier);
  TrimModifier.prototype.initModifierProperties = function (elem, data) {
    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
    this.sValue = 0;
    this.eValue = 0;
    this.getValue = this.processKeys;
    this.m = data.m;
    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
  };
  TrimModifier.prototype.addShapeToModifier = function (shapeData) {
    shapeData.pathsData = [];
  };
  TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
    var segments = [];
    if (e <= 1) {
      segments.push({
        s: s,
        e: e
      });
    } else if (s >= 1) {
      segments.push({
        s: s - 1,
        e: e - 1
      });
    } else {
      segments.push({
        s: s,
        e: 1
      });
      segments.push({
        s: 0,
        e: e - 1
      });
    }
    var shapeSegments = [];
    var i;
    var len = segments.length;
    var segmentOb;
    for (i = 0; i < len; i += 1) {
      segmentOb = segments[i];
      if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
        var shapeS;
        var shapeE;
        if (segmentOb.s * totalModifierLength <= addedLength) {
          shapeS = 0;
        } else {
          shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
        }
        if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
          shapeE = 1;
        } else {
          shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
        }
        shapeSegments.push([shapeS, shapeE]);
      }
    }
    if (!shapeSegments.length) {
      shapeSegments.push([0, 0]);
    }
    return shapeSegments;
  };
  TrimModifier.prototype.releasePathsData = function (pathsData) {
    var i;
    var len = pathsData.length;
    for (i = 0; i < len; i += 1) {
      segmentsLengthPool.release(pathsData[i]);
    }
    pathsData.length = 0;
    return pathsData;
  };
  TrimModifier.prototype.processShapes = function (_isFirstFrame) {
    var s;
    var e;
    if (this._mdf || _isFirstFrame) {
      var o = this.o.v % 360 / 360;
      if (o < 0) {
        o += 1;
      }
      if (this.s.v > 1) {
        s = 1 + o;
      } else if (this.s.v < 0) {
        s = 0 + o;
      } else {
        s = this.s.v + o;
      }
      if (this.e.v > 1) {
        e = 1 + o;
      } else if (this.e.v < 0) {
        e = 0 + o;
      } else {
        e = this.e.v + o;
      }
      if (s > e) {
        var _s = s;
        s = e;
        e = _s;
      }
      s = Math.round(s * 10000) * 0.0001;
      e = Math.round(e * 10000) * 0.0001;
      this.sValue = s;
      this.eValue = e;
    } else {
      s = this.sValue;
      e = this.eValue;
    }
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var pathsData;
    var pathData;
    var totalShapeLength;
    var totalModifierLength = 0;
    if (e === s) {
      for (i = 0; i < len; i += 1) {
        this.shapes[i].localShapeCollection.releaseShapes();
        this.shapes[i].shape._mdf = true;
        this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
        if (this._mdf) {
          this.shapes[i].pathsData.length = 0;
        }
      }
    } else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
      var segments = [];
      var shapeData;
      var localShapeCollection;
      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
        if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
          shapeData.shape.paths = shapeData.localShapeCollection;
        } else {
          shapePaths = shapeData.shape.paths;
          jLen = shapePaths._length;
          totalShapeLength = 0;
          if (!shapeData.shape._mdf && shapeData.pathsData.length) {
            totalShapeLength = shapeData.totalShapeLength;
          } else {
            pathsData = this.releasePathsData(shapeData.pathsData);
            for (j = 0; j < jLen; j += 1) {
              pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
              pathsData.push(pathData);
              totalShapeLength += pathData.totalLength;
            }
            shapeData.totalShapeLength = totalShapeLength;
            shapeData.pathsData = pathsData;
          }
          totalModifierLength += totalShapeLength;
          shapeData.shape._mdf = true;
        }
      }
      var shapeS = s;
      var shapeE = e;
      var addedLength = 0;
      var edges;
      for (i = len - 1; i >= 0; i -= 1) {
        shapeData = this.shapes[i];
        if (shapeData.shape._mdf) {
          localShapeCollection = shapeData.localShapeCollection;
          localShapeCollection.releaseShapes();
          // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
          if (this.m === 2 && len > 1) {
            edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
            addedLength += shapeData.totalShapeLength;
          } else {
            edges = [[shapeS, shapeE]];
          }
          jLen = edges.length;
          for (j = 0; j < jLen; j += 1) {
            shapeS = edges[j][0];
            shapeE = edges[j][1];
            segments.length = 0;
            if (shapeE <= 1) {
              segments.push({
                s: shapeData.totalShapeLength * shapeS,
                e: shapeData.totalShapeLength * shapeE
              });
            } else if (shapeS >= 1) {
              segments.push({
                s: shapeData.totalShapeLength * (shapeS - 1),
                e: shapeData.totalShapeLength * (shapeE - 1)
              });
            } else {
              segments.push({
                s: shapeData.totalShapeLength * shapeS,
                e: shapeData.totalShapeLength
              });
              segments.push({
                s: 0,
                e: shapeData.totalShapeLength * (shapeE - 1)
              });
            }
            var newShapesData = this.addShapes(shapeData, segments[0]);
            if (segments[0].s !== segments[0].e) {
              if (segments.length > 1) {
                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                if (lastShapeInCollection.c) {
                  var lastShape = newShapesData.pop();
                  this.addPaths(newShapesData, localShapeCollection);
                  newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                } else {
                  this.addPaths(newShapesData, localShapeCollection);
                  newShapesData = this.addShapes(shapeData, segments[1]);
                }
              }
              this.addPaths(newShapesData, localShapeCollection);
            }
          }
          shapeData.shape.paths = localShapeCollection;
        }
      }
    } else if (this._mdf) {
      for (i = 0; i < len; i += 1) {
        // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
        // Don't remove this even if it's losing cached info.
        this.shapes[i].pathsData.length = 0;
        this.shapes[i].shape._mdf = true;
      }
    }
  };
  TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
    var i;
    var len = newPaths.length;
    for (i = 0; i < len; i += 1) {
      localShapeCollection.addShape(newPaths[i]);
    }
  };
  TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
    if (newShape) {
      shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
    }
    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
  };
  TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
    shapePath.setXYAt(points[1], points[5], 'o', pos);
    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
    if (newShape) {
      shapePath.setXYAt(points[0], points[4], 'v', pos);
    }
    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
  };
  TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
    var pathsData = shapeData.pathsData;
    var shapePaths = shapeData.shape.paths.shapes;
    var i;
    var len = shapeData.shape.paths._length;
    var j;
    var jLen;
    var addedLength = 0;
    var currentLengthData;
    var segmentCount;
    var lengths;
    var segment;
    var shapes = [];
    var initPos;
    var newShape = true;
    if (!shapePath) {
      shapePath = shapePool.newElement();
      segmentCount = 0;
      initPos = 0;
    } else {
      segmentCount = shapePath._length;
      initPos = shapePath._length;
    }
    shapes.push(shapePath);
    for (i = 0; i < len; i += 1) {
      lengths = pathsData[i].lengths;
      shapePath.c = shapePaths[i].c;
      jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
      for (j = 1; j < jLen; j += 1) {
        currentLengthData = lengths[j - 1];
        if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
          addedLength += currentLengthData.addedLength;
          shapePath.c = false;
        } else if (addedLength > shapeSegment.e) {
          shapePath.c = false;
          break;
        } else {
          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
            newShape = false;
          } else {
            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
            // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
            newShape = false;
            shapePath.c = false;
          }
          addedLength += currentLengthData.addedLength;
          segmentCount += 1;
        }
      }
      if (shapePaths[i].c && lengths.length) {
        currentLengthData = lengths[j - 1];
        if (addedLength <= shapeSegment.e) {
          var segmentLength = lengths[j - 1].addedLength;
          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
            newShape = false;
          } else {
            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
            // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
            newShape = false;
            shapePath.c = false;
          }
        } else {
          shapePath.c = false;
        }
        addedLength += currentLengthData.addedLength;
        segmentCount += 1;
      }
      if (shapePath._length) {
        shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
        shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
      }
      if (addedLength > shapeSegment.e) {
        break;
      }
      if (i < len - 1) {
        shapePath = shapePool.newElement();
        newShape = true;
        shapes.push(shapePath);
        segmentCount = 0;
      }
    }
    return shapes;
  };

  function PuckerAndBloatModifier() {}
  extendPrototype([ShapeModifier], PuckerAndBloatModifier);
  PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
    this._isAnimated = !!this.amount.effectsSequence.length;
  };
  PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
    var percent = amount / 100;
    var centerPoint = [0, 0];
    var pathLength = path._length;
    var i = 0;
    for (i = 0; i < pathLength; i += 1) {
      centerPoint[0] += path.v[i][0];
      centerPoint[1] += path.v[i][1];
    }
    centerPoint[0] /= pathLength;
    centerPoint[1] /= pathLength;
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;
    var vX;
    var vY;
    var oX;
    var oY;
    var iX;
    var iY;
    for (i = 0; i < pathLength; i += 1) {
      vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
      vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
      oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
      oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
      iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
      iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
      clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
    }
    return clonedPath;
  };
  PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amount = this.amount.v;
    if (amount !== 0) {
      var shapeData;
      var localShapeCollection;
      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;
        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;
          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
          }
        }
        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }
    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  var TransformPropertyFactory = function () {
    var defaultVector = [0, 0];
    function applyToMatrix(mat) {
      var _mdf = this._mdf;
      this.iterateDynamicProperties();
      this._mdf = this._mdf || _mdf;
      if (this.a) {
        mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      }
      if (this.s) {
        mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      }
      if (this.sk) {
        mat.skewFromAxis(-this.sk.v, this.sa.v);
      }
      if (this.r) {
        mat.rotate(-this.r.v);
      } else {
        mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
      }
      if (this.data.p.s) {
        if (this.data.p.z) {
          mat.translate(this.px.v, this.py.v, -this.pz.v);
        } else {
          mat.translate(this.px.v, this.py.v, 0);
        }
      } else {
        mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
    }
    function processKeys(forceRender) {
      if (this.elem.globalData.frameId === this.frameId) {
        return;
      }
      if (this._isDirty) {
        this.precalculateMatrix();
        this._isDirty = false;
      }
      this.iterateDynamicProperties();
      if (this._mdf || forceRender) {
        var frameRate;
        this.v.cloneFromProps(this.pre.props);
        if (this.appliedTransformations < 1) {
          this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
        }
        if (this.appliedTransformations < 2) {
          this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
        }
        if (this.sk && this.appliedTransformations < 3) {
          this.v.skewFromAxis(-this.sk.v, this.sa.v);
        }
        if (this.r && this.appliedTransformations < 4) {
          this.v.rotate(-this.r.v);
        } else if (!this.r && this.appliedTransformations < 4) {
          this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
        }
        if (this.autoOriented) {
          var v1;
          var v2;
          frameRate = this.elem.globalData.frameRate;
          if (this.p && this.p.keyframes && this.p.getValueAtTime) {
            if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
              v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
              v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
            } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
              v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
              v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
            } else {
              v1 = this.p.pv;
              v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
            }
          } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
            v1 = [];
            v2 = [];
            var px = this.px;
            var py = this.py;
            if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
              v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
              v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
              v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
              v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
            } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
              v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
              v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
              v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
              v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
            } else {
              v1 = [px.pv, py.pv];
              v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
              v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
            }
          } else {
            v2 = defaultVector;
            v1 = v2;
          }
          this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
        }
        if (this.data.p && this.data.p.s) {
          if (this.data.p.z) {
            this.v.translate(this.px.v, this.py.v, -this.pz.v);
          } else {
            this.v.translate(this.px.v, this.py.v, 0);
          }
        } else {
          this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
      }
      this.frameId = this.elem.globalData.frameId;
    }
    function precalculateMatrix() {
      this.appliedTransformations = 0;
      this.pre.reset();
      if (!this.a.effectsSequence.length) {
        this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
        this.appliedTransformations = 1;
      } else {
        return;
      }
      if (!this.s.effectsSequence.length) {
        this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
        this.appliedTransformations = 2;
      } else {
        return;
      }
      if (this.sk) {
        if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
          this.pre.skewFromAxis(-this.sk.v, this.sa.v);
          this.appliedTransformations = 3;
        } else {
          return;
        }
      }
      if (this.r) {
        if (!this.r.effectsSequence.length) {
          this.pre.rotate(-this.r.v);
          this.appliedTransformations = 4;
        }
      } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
        this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
        this.appliedTransformations = 4;
      }
    }
    function autoOrient() {
      //
      // var prevP = this.getValueAtTime();
    }
    function addDynamicProperty(prop) {
      this._addDynamicProperty(prop);
      this.elem.addDynamicProperty(prop);
      this._isDirty = true;
    }
    function TransformProperty(elem, data, container) {
      this.elem = elem;
      this.frameId = -1;
      this.propType = 'transform';
      this.data = data;
      this.v = new Matrix();
      // Precalculated matrix with non animated properties
      this.pre = new Matrix();
      this.appliedTransformations = 0;
      this.initDynamicPropertyContainer(container || elem);
      if (data.p && data.p.s) {
        this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
        this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
        if (data.p.z) {
          this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
        }
      } else {
        this.p = PropertyFactory.getProp(elem, data.p || {
          k: [0, 0, 0]
        }, 1, 0, this);
      }
      if (data.rx) {
        this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
        this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
        this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
        if (data.or.k[0].ti) {
          var i;
          var len = data.or.k.length;
          for (i = 0; i < len; i += 1) {
            data.or.k[i].to = null;
            data.or.k[i].ti = null;
          }
        }
        this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
        // sh Indicates it needs to be capped between -180 and 180
        this.or.sh = true;
      } else {
        this.r = PropertyFactory.getProp(elem, data.r || {
          k: 0
        }, 0, degToRads, this);
      }
      if (data.sk) {
        this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
        this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
      }
      this.a = PropertyFactory.getProp(elem, data.a || {
        k: [0, 0, 0]
      }, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s || {
        k: [100, 100, 100]
      }, 1, 0.01, this);
      // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
      if (data.o) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
      } else {
        this.o = {
          _mdf: false,
          v: 1
        };
      }
      this._isDirty = true;
      if (!this.dynamicProperties.length) {
        this.getValue(true);
      }
    }
    TransformProperty.prototype = {
      applyToMatrix: applyToMatrix,
      getValue: processKeys,
      precalculateMatrix: precalculateMatrix,
      autoOrient: autoOrient
    };
    extendPrototype([DynamicPropertyContainer], TransformProperty);
    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
    function getTransformProperty(elem, data, container) {
      return new TransformProperty(elem, data, container);
    }
    return {
      getTransformProperty: getTransformProperty
    };
  }();

  function RepeaterModifier() {}
  extendPrototype([ShapeModifier], RepeaterModifier);
  RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
    this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
    this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
    this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
    this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
    this.data = data;
    if (!this.dynamicProperties.length) {
      this.getValue(true);
    }
    this._isAnimated = !!this.dynamicProperties.length;
    this.pMatrix = new Matrix();
    this.rMatrix = new Matrix();
    this.sMatrix = new Matrix();
    this.tMatrix = new Matrix();
    this.matrix = new Matrix();
  };
  RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
    var dir = inv ? -1 : 1;
    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    rMatrix.rotate(-transform.r.v * dir * perc);
    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
  };
  RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
    this.elem = elem;
    this.arr = arr;
    this.pos = pos;
    this.elemsData = elemsData;
    this._currentCopies = 0;
    this._elements = [];
    this._groups = [];
    this.frameId = -1;
    this.initDynamicPropertyContainer(elem);
    this.initModifierProperties(elem, arr[pos]);
    while (pos > 0) {
      pos -= 1;
      // this._elements.unshift(arr.splice(pos,1)[0]);
      this._elements.unshift(arr[pos]);
    }
    if (this.dynamicProperties.length) {
      this.k = true;
    } else {
      this.getValue(true);
    }
  };
  RepeaterModifier.prototype.resetElements = function (elements) {
    var i;
    var len = elements.length;
    for (i = 0; i < len; i += 1) {
      elements[i]._processed = false;
      if (elements[i].ty === 'gr') {
        this.resetElements(elements[i].it);
      }
    }
  };
  RepeaterModifier.prototype.cloneElements = function (elements) {
    var newElements = JSON.parse(JSON.stringify(elements));
    this.resetElements(newElements);
    return newElements;
  };
  RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
    var i;
    var len = elements.length;
    for (i = 0; i < len; i += 1) {
      elements[i]._render = renderFlag;
      if (elements[i].ty === 'gr') {
        this.changeGroupRender(elements[i].it, renderFlag);
      }
    }
  };
  RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
    var items;
    var itemsTransform;
    var i;
    var dir;
    var cont;
    var hasReloaded = false;
    if (this._mdf || _isFirstFrame) {
      var copies = Math.ceil(this.c.v);
      if (this._groups.length < copies) {
        while (this._groups.length < copies) {
          var group = {
            it: this.cloneElements(this._elements),
            ty: 'gr'
          };
          group.it.push({
            a: {
              a: 0,
              ix: 1,
              k: [0, 0]
            },
            nm: 'Transform',
            o: {
              a: 0,
              ix: 7,
              k: 100
            },
            p: {
              a: 0,
              ix: 2,
              k: [0, 0]
            },
            r: {
              a: 1,
              ix: 6,
              k: [{
                s: 0,
                e: 0,
                t: 0
              }, {
                s: 0,
                e: 0,
                t: 1
              }]
            },
            s: {
              a: 0,
              ix: 3,
              k: [100, 100]
            },
            sa: {
              a: 0,
              ix: 5,
              k: 0
            },
            sk: {
              a: 0,
              ix: 4,
              k: 0
            },
            ty: 'tr'
          });
          this.arr.splice(0, 0, group);
          this._groups.splice(0, 0, group);
          this._currentCopies += 1;
        }
        this.elem.reloadShapes();
        hasReloaded = true;
      }
      cont = 0;
      var renderFlag;
      for (i = 0; i <= this._groups.length - 1; i += 1) {
        renderFlag = cont < copies;
        this._groups[i]._render = renderFlag;
        this.changeGroupRender(this._groups[i].it, renderFlag);
        if (!renderFlag) {
          var elems = this.elemsData[i].it;
          var transformData = elems[elems.length - 1];
          if (transformData.transform.op.v !== 0) {
            transformData.transform.op._mdf = true;
            transformData.transform.op.v = 0;
          } else {
            transformData.transform.op._mdf = false;
          }
        }
        cont += 1;
      }
      this._currentCopies = copies;
      /// /

      var offset = this.o.v;
      var offsetModulo = offset % 1;
      var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
      var pProps = this.pMatrix.props;
      var rProps = this.rMatrix.props;
      var sProps = this.sMatrix.props;
      this.pMatrix.reset();
      this.rMatrix.reset();
      this.sMatrix.reset();
      this.tMatrix.reset();
      this.matrix.reset();
      var iteration = 0;
      if (offset > 0) {
        while (iteration < roundOffset) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
          iteration += 1;
        }
        if (offsetModulo) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
          iteration += offsetModulo;
        }
      } else if (offset < 0) {
        while (iteration > roundOffset) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
          iteration -= 1;
        }
        if (offsetModulo) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
          iteration -= offsetModulo;
        }
      }
      i = this.data.m === 1 ? 0 : this._currentCopies - 1;
      dir = this.data.m === 1 ? 1 : -1;
      cont = this._currentCopies;
      var j;
      var jLen;
      while (cont) {
        items = this.elemsData[i].it;
        itemsTransform = items[items.length - 1].transform.mProps.v.props;
        jLen = itemsTransform.length;
        items[items.length - 1].transform.mProps._mdf = true;
        items[items.length - 1].transform.op._mdf = true;
        items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
        if (iteration !== 0) {
          if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) {
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
          }
          this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
          this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
          this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
          for (j = 0; j < jLen; j += 1) {
            itemsTransform[j] = this.matrix.props[j];
          }
          this.matrix.reset();
        } else {
          this.matrix.reset();
          for (j = 0; j < jLen; j += 1) {
            itemsTransform[j] = this.matrix.props[j];
          }
        }
        iteration += 1;
        cont -= 1;
        i += dir;
      }
    } else {
      cont = this._currentCopies;
      i = 0;
      dir = 1;
      while (cont) {
        items = this.elemsData[i].it;
        itemsTransform = items[items.length - 1].transform.mProps.v.props;
        items[items.length - 1].transform.mProps._mdf = false;
        items[items.length - 1].transform.op._mdf = false;
        cont -= 1;
        i += dir;
      }
    }
    return hasReloaded;
  };
  RepeaterModifier.prototype.addShape = function () {};

  function RoundCornersModifier() {}
  extendPrototype([ShapeModifier], RoundCornersModifier);
  RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
    this._isAnimated = !!this.rd.effectsSequence.length;
  };
  RoundCornersModifier.prototype.processPath = function (path, round) {
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;
    var i;
    var len = path._length;
    var currentV;
    var currentI;
    var currentO;
    var closerV;
    var distance;
    var newPosPerc;
    var index = 0;
    var vX;
    var vY;
    var oX;
    var oY;
    var iX;
    var iY;
    for (i = 0; i < len; i += 1) {
      currentV = path.v[i];
      currentO = path.o[i];
      currentI = path.i[i];
      if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
        if ((i === 0 || i === len - 1) && !path.c) {
          clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
          /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */
          index += 1;
        } else {
          if (i === 0) {
            closerV = path.v[len - 1];
          } else {
            closerV = path.v[i - 1];
          }
          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
          iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
          vX = iX;
          iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
          vY = iY;
          oX = vX - (vX - currentV[0]) * roundCorner;
          oY = vY - (vY - currentV[1]) * roundCorner;
          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
          index += 1;
          if (i === len - 1) {
            closerV = path.v[0];
          } else {
            closerV = path.v[i + 1];
          }
          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
          oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
          vX = oX;
          oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
          vY = oY;
          iX = vX - (vX - currentV[0]) * roundCorner;
          iY = vY - (vY - currentV[1]) * roundCorner;
          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
          index += 1;
        }
      } else {
        clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
        index += 1;
      }
    }
    return clonedPath;
  };
  RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var rd = this.rd.v;
    if (rd !== 0) {
      var shapeData;
      var localShapeCollection;
      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;
        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;
          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
          }
        }
        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }
    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  function floatEqual(a, b) {
    return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
  }
  function floatZero(f) {
    return Math.abs(f) <= 0.00001;
  }
  function lerp(p0, p1, amount) {
    return p0 * (1 - amount) + p1 * amount;
  }
  function lerpPoint(p0, p1, amount) {
    return [lerp(p0[0], p1[0], amount), lerp(p0[1], p1[1], amount)];
  }
  function quadRoots(a, b, c) {
    // no root
    if (a === 0) return [];
    var s = b * b - 4 * a * c;
    // Complex roots
    if (s < 0) return [];
    var singleRoot = -b / (2 * a);
    // 1 root
    if (s === 0) return [singleRoot];
    var delta = Math.sqrt(s) / (2 * a);
    // 2 roots
    return [singleRoot - delta, singleRoot + delta];
  }
  function polynomialCoefficients(p0, p1, p2, p3) {
    return [-p0 + 3 * p1 - 3 * p2 + p3, 3 * p0 - 6 * p1 + 3 * p2, -3 * p0 + 3 * p1, p0];
  }
  function singlePoint(p) {
    return new PolynomialBezier(p, p, p, p, false);
  }
  function PolynomialBezier(p0, p1, p2, p3, linearize) {
    if (linearize && pointEqual(p0, p1)) {
      p1 = lerpPoint(p0, p3, 1 / 3);
    }
    if (linearize && pointEqual(p2, p3)) {
      p2 = lerpPoint(p0, p3, 2 / 3);
    }
    var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
    var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
    this.a = [coeffx[0], coeffy[0]];
    this.b = [coeffx[1], coeffy[1]];
    this.c = [coeffx[2], coeffy[2]];
    this.d = [coeffx[3], coeffy[3]];
    this.points = [p0, p1, p2, p3];
  }
  PolynomialBezier.prototype.point = function (t) {
    return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
  };
  PolynomialBezier.prototype.derivative = function (t) {
    return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
  };
  PolynomialBezier.prototype.tangentAngle = function (t) {
    var p = this.derivative(t);
    return Math.atan2(p[1], p[0]);
  };
  PolynomialBezier.prototype.normalAngle = function (t) {
    var p = this.derivative(t);
    return Math.atan2(p[0], p[1]);
  };
  PolynomialBezier.prototype.inflectionPoints = function () {
    var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
    if (floatZero(denom)) return [];
    var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
    var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
    if (square < 0) return [];
    var root = Math.sqrt(square);
    if (floatZero(root)) {
      if (root > 0 && root < 1) return [tcusp];
      return [];
    }
    return [tcusp - root, tcusp + root].filter(function (r) {
      return r > 0 && r < 1;
    });
  };
  PolynomialBezier.prototype.split = function (t) {
    if (t <= 0) return [singlePoint(this.points[0]), this];
    if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
    var p10 = lerpPoint(this.points[0], this.points[1], t);
    var p11 = lerpPoint(this.points[1], this.points[2], t);
    var p12 = lerpPoint(this.points[2], this.points[3], t);
    var p20 = lerpPoint(p10, p11, t);
    var p21 = lerpPoint(p11, p12, t);
    var p3 = lerpPoint(p20, p21, t);
    return [new PolynomialBezier(this.points[0], p10, p20, p3, true), new PolynomialBezier(p3, p21, p12, this.points[3], true)];
  };
  function extrema(bez, comp) {
    var min = bez.points[0][comp];
    var max = bez.points[bez.points.length - 1][comp];
    if (min > max) {
      var e = max;
      max = min;
      min = e;
    }
    // Derivative roots to find min/max
    var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
    for (var i = 0; i < f.length; i += 1) {
      if (f[i] > 0 && f[i] < 1) {
        var val = bez.point(f[i])[comp];
        if (val < min) min = val;else if (val > max) max = val;
      }
    }
    return {
      min: min,
      max: max
    };
  }
  PolynomialBezier.prototype.bounds = function () {
    return {
      x: extrema(this, 0),
      y: extrema(this, 1)
    };
  };
  PolynomialBezier.prototype.boundingBox = function () {
    var bounds = this.bounds();
    return {
      left: bounds.x.min,
      right: bounds.x.max,
      top: bounds.y.min,
      bottom: bounds.y.max,
      width: bounds.x.max - bounds.x.min,
      height: bounds.y.max - bounds.y.min,
      cx: (bounds.x.max + bounds.x.min) / 2,
      cy: (bounds.y.max + bounds.y.min) / 2
    };
  };
  function intersectData(bez, t1, t2) {
    var box = bez.boundingBox();
    return {
      cx: box.cx,
      cy: box.cy,
      width: box.width,
      height: box.height,
      bez: bez,
      t: (t1 + t2) / 2,
      t1: t1,
      t2: t2
    };
  }
  function splitData(data) {
    var split = data.bez.split(0.5);
    return [intersectData(split[0], data.t1, data.t), intersectData(split[1], data.t, data.t2)];
  }
  function boxIntersect(b1, b2) {
    return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
  }
  function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
    if (!boxIntersect(d1, d2)) return;
    if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
      intersections.push([d1.t, d2.t]);
      return;
    }
    var d1s = splitData(d1);
    var d2s = splitData(d2);
    intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
    intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
    intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
  }
  PolynomialBezier.prototype.intersections = function (other, tolerance, maxRecursion) {
    if (tolerance === undefined) tolerance = 2;
    if (maxRecursion === undefined) maxRecursion = 7;
    var intersections = [];
    intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
    return intersections;
  };
  PolynomialBezier.shapeSegment = function (shapePath, index) {
    var nextIndex = (index + 1) % shapePath.length();
    return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
  };
  PolynomialBezier.shapeSegmentInverted = function (shapePath, index) {
    var nextIndex = (index + 1) % shapePath.length();
    return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
  };
  function crossProduct(a, b) {
    return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
  }
  function lineIntersection(start1, end1, start2, end2) {
    var v1 = [start1[0], start1[1], 1];
    var v2 = [end1[0], end1[1], 1];
    var v3 = [start2[0], start2[1], 1];
    var v4 = [end2[0], end2[1], 1];
    var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
    if (floatZero(r[2])) return null;
    return [r[0] / r[2], r[1] / r[2]];
  }
  function polarOffset(p, angle, length) {
    return [p[0] + Math.cos(angle) * length, p[1] - Math.sin(angle) * length];
  }
  function pointDistance(p1, p2) {
    return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
  }
  function pointEqual(p1, p2) {
    return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
  }

  function ZigZagModifier() {}
  extendPrototype([ShapeModifier], ZigZagModifier);
  ZigZagModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
    this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
    this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
    this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
  };
  function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
    var angO = angle - Math.PI / 2;
    var angI = angle + Math.PI / 2;
    var px = point[0] + Math.cos(angle) * direction * amplitude;
    var py = point[1] - Math.sin(angle) * direction * amplitude;
    outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
  }
  function getPerpendicularVector(pt1, pt2) {
    var vector = [pt2[0] - pt1[0], pt2[1] - pt1[1]];
    var rot = -Math.PI * 0.5;
    var rotatedVector = [Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1], Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]];
    return rotatedVector;
  }
  function getProjectingAngle(path, cur) {
    var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
    var nextIndex = (cur + 1) % path.length();
    var prevPoint = path.v[prevIndex];
    var nextPoint = path.v[nextIndex];
    var pVector = getPerpendicularVector(prevPoint, nextPoint);
    return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
  }
  function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
    var angle = getProjectingAngle(path, cur);
    var point = path.v[cur % path._length];
    var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
    var nextPoint = path.v[(cur + 1) % path._length];
    var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
    var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
    setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
  }
  function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
    for (var i = 0; i < frequency; i += 1) {
      var t = (i + 1) / (frequency + 1);
      var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
      var angle = segment.normalAngle(t);
      var point = segment.point(t);
      setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
      direction = -direction;
    }
    return direction;
  }
  ZigZagModifier.prototype.processPath = function (path, amplitude, frequency, pointType) {
    var count = path._length;
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;
    if (!path.c) {
      count -= 1;
    }
    if (count === 0) return clonedPath;
    var direction = -1;
    var segment = PolynomialBezier.shapeSegment(path, 0);
    zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
    for (var i = 0; i < count; i += 1) {
      direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
      if (i === count - 1 && !path.c) {
        segment = null;
      } else {
        segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
      }
      zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
    }
    return clonedPath;
  };
  ZigZagModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amplitude = this.amplitude.v;
    var frequency = Math.max(0, Math.round(this.frequency.v));
    var pointType = this.pointsType.v;
    if (amplitude !== 0) {
      var shapeData;
      var localShapeCollection;
      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;
        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;
          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
          }
        }
        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }
    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  function linearOffset(p1, p2, amount) {
    var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
    return [polarOffset(p1, angle, amount), polarOffset(p2, angle, amount)];
  }
  function offsetSegment(segment, amount) {
    var p0;
    var p1a;
    var p1b;
    var p2b;
    var p2a;
    var p3;
    var e;
    e = linearOffset(segment.points[0], segment.points[1], amount);
    p0 = e[0];
    p1a = e[1];
    e = linearOffset(segment.points[1], segment.points[2], amount);
    p1b = e[0];
    p2b = e[1];
    e = linearOffset(segment.points[2], segment.points[3], amount);
    p2a = e[0];
    p3 = e[1];
    var p1 = lineIntersection(p0, p1a, p1b, p2b);
    if (p1 === null) p1 = p1a;
    var p2 = lineIntersection(p2a, p3, p1b, p2b);
    if (p2 === null) p2 = p2a;
    return new PolynomialBezier(p0, p1, p2, p3);
  }
  function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
    var p0 = seg1.points[3];
    var p1 = seg2.points[0];

    // Bevel
    if (lineJoin === 3) return p0;

    // Connected, they don't need a joint
    if (pointEqual(p0, p1)) return p0;

    // Round
    if (lineJoin === 2) {
      var angleOut = -seg1.tangentAngle(1);
      var angleIn = -seg2.tangentAngle(0) + Math.PI;
      var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
      var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
      var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
      outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
      tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
      outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
      return p1;
    }

    // Miter
    var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
    var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
    var intersection = lineIntersection(t0, p0, p1, t1);
    if (intersection && pointDistance(intersection, p0) < miterLimit) {
      outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
      return intersection;
    }
    return p0;
  }
  function getIntersection(a, b) {
    var intersect = a.intersections(b);
    if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
    if (intersect.length) return intersect[0];
    return null;
  }
  function pruneSegmentIntersection(a, b) {
    var outa = a.slice();
    var outb = b.slice();
    var intersect = getIntersection(a[a.length - 1], b[0]);
    if (intersect) {
      outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
      outb[0] = b[0].split(intersect[1])[1];
    }
    if (a.length > 1 && b.length > 1) {
      intersect = getIntersection(a[0], b[b.length - 1]);
      if (intersect) {
        return [[a[0].split(intersect[0])[0]], [b[b.length - 1].split(intersect[1])[1]]];
      }
    }
    return [outa, outb];
  }
  function pruneIntersections(segments) {
    var e;
    for (var i = 1; i < segments.length; i += 1) {
      e = pruneSegmentIntersection(segments[i - 1], segments[i]);
      segments[i - 1] = e[0];
      segments[i] = e[1];
    }
    if (segments.length > 1) {
      e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
      segments[segments.length - 1] = e[0];
      segments[0] = e[1];
    }
    return segments;
  }
  function offsetSegmentSplit(segment, amount) {
    /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
       (A cubic bezier can have none, one, or two inflection points)
    */
    var flex = segment.inflectionPoints();
    var left;
    var right;
    var split;
    var mid;
    if (flex.length === 0) {
      return [offsetSegment(segment, amount)];
    }
    if (flex.length === 1 || floatEqual(flex[1], 1)) {
      split = segment.split(flex[0]);
      left = split[0];
      right = split[1];
      return [offsetSegment(left, amount), offsetSegment(right, amount)];
    }
    split = segment.split(flex[0]);
    left = split[0];
    var t = (flex[1] - flex[0]) / (1 - flex[0]);
    split = split[1].split(t);
    mid = split[0];
    right = split[1];
    return [offsetSegment(left, amount), offsetSegment(mid, amount), offsetSegment(right, amount)];
  }
  function OffsetPathModifier() {}
  extendPrototype([ShapeModifier], OffsetPathModifier);
  OffsetPathModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
    this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
    this.lineJoin = data.lj;
    this._isAnimated = this.amount.effectsSequence.length !== 0;
  };
  OffsetPathModifier.prototype.processPath = function (inputBezier, amount, lineJoin, miterLimit) {
    var outputBezier = shapePool.newElement();
    outputBezier.c = inputBezier.c;
    var count = inputBezier.length();
    if (!inputBezier.c) {
      count -= 1;
    }
    var i;
    var j;
    var segment;
    var multiSegments = [];
    for (i = 0; i < count; i += 1) {
      segment = PolynomialBezier.shapeSegment(inputBezier, i);
      multiSegments.push(offsetSegmentSplit(segment, amount));
    }
    if (!inputBezier.c) {
      for (i = count - 1; i >= 0; i -= 1) {
        segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
        multiSegments.push(offsetSegmentSplit(segment, amount));
      }
    }
    multiSegments = pruneIntersections(multiSegments);

    // Add bezier segments to the output and apply line joints
    var lastPoint = null;
    var lastSeg = null;
    for (i = 0; i < multiSegments.length; i += 1) {
      var multiSegment = multiSegments[i];
      if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
      lastSeg = multiSegment[multiSegment.length - 1];
      for (j = 0; j < multiSegment.length; j += 1) {
        segment = multiSegment[j];
        if (lastPoint && pointEqual(segment.points[0], lastPoint)) {
          outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
        } else {
          outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
        }
        outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
        lastPoint = segment.points[3];
      }
    }
    if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
    return outputBezier;
  };
  OffsetPathModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amount = this.amount.v;
    var miterLimit = this.miterLimit.v;
    var lineJoin = this.lineJoin;
    if (amount !== 0) {
      var shapeData;
      var localShapeCollection;
      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;
        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;
          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
          }
        }
        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }
    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  function getFontProperties(fontData) {
    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
    var fWeight = 'normal';
    var fStyle = 'normal';
    var len = styles.length;
    var styleName;
    for (var i = 0; i < len; i += 1) {
      styleName = styles[i].toLowerCase();
      switch (styleName) {
        case 'italic':
          fStyle = 'italic';
          break;
        case 'bold':
          fWeight = '700';
          break;
        case 'black':
          fWeight = '900';
          break;
        case 'medium':
          fWeight = '500';
          break;
        case 'regular':
        case 'normal':
          fWeight = '400';
          break;
        case 'light':
        case 'thin':
          fWeight = '200';
          break;
        default:
          break;
      }
    }
    return {
      style: fStyle,
      weight: fontData.fWeight || fWeight
    };
  }

  var FontManager = function () {
    var maxWaitingTime = 5000;
    var emptyChar = {
      w: 0,
      size: 0,
      shapes: [],
      data: {
        shapes: []
      }
    };
    var combinedCharacters = [];
    // Hindi characters
    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
    var BLACK_FLAG_CODE_POINT = 127988;
    var CANCEL_TAG_CODE_POINT = 917631;
    var A_TAG_CODE_POINT = 917601;
    var Z_TAG_CODE_POINT = 917626;
    var VARIATION_SELECTOR_16_CODE_POINT = 65039;
    var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
    var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
    var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
    var surrogateModifiers = ['d83cdffb', 'd83cdffc', 'd83cdffd', 'd83cdffe', 'd83cdfff'];
    function trimFontOptions(font) {
      var familyArray = font.split(',');
      var i;
      var len = familyArray.length;
      var enabledFamilies = [];
      for (i = 0; i < len; i += 1) {
        if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
          enabledFamilies.push(familyArray[i]);
        }
      }
      return enabledFamilies.join(',');
    }
    function setUpNode(font, family) {
      var parentNode = createTag('span');
      // Node is invisible to screen readers.
      parentNode.setAttribute('aria-hidden', true);
      parentNode.style.fontFamily = family;
      var node = createTag('span');
      // Characters that vary significantly among different fonts
      node.innerText = 'giItT1WQy@!-/#';
      // Visible - so we can measure it - but not on the screen
      parentNode.style.position = 'absolute';
      parentNode.style.left = '-10000px';
      parentNode.style.top = '-10000px';
      // Large font size makes even subtle changes obvious
      parentNode.style.fontSize = '300px';
      // Reset any font properties
      parentNode.style.fontVariant = 'normal';
      parentNode.style.fontStyle = 'normal';
      parentNode.style.fontWeight = 'normal';
      parentNode.style.letterSpacing = '0';
      parentNode.appendChild(node);
      document.body.appendChild(parentNode);

      // Remember width with no applied web font
      var width = node.offsetWidth;
      node.style.fontFamily = trimFontOptions(font) + ', ' + family;
      return {
        node: node,
        w: width,
        parent: parentNode
      };
    }
    function checkLoadedFonts() {
      var i;
      var len = this.fonts.length;
      var node;
      var w;
      var loadedCount = len;
      for (i = 0; i < len; i += 1) {
        if (this.fonts[i].loaded) {
          loadedCount -= 1;
        } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
          this.fonts[i].loaded = true;
        } else {
          node = this.fonts[i].monoCase.node;
          w = this.fonts[i].monoCase.w;
          if (node.offsetWidth !== w) {
            loadedCount -= 1;
            this.fonts[i].loaded = true;
          } else {
            node = this.fonts[i].sansCase.node;
            w = this.fonts[i].sansCase.w;
            if (node.offsetWidth !== w) {
              loadedCount -= 1;
              this.fonts[i].loaded = true;
            }
          }
          if (this.fonts[i].loaded) {
            this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
            this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
          }
        }
      }
      if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
        setTimeout(this.checkLoadedFontsBinded, 20);
      } else {
        setTimeout(this.setIsLoadedBinded, 10);
      }
    }
    function createHelper(fontData, def) {
      var engine = document.body && def ? 'svg' : 'canvas';
      var helper;
      var fontProps = getFontProperties(fontData);
      if (engine === 'svg') {
        var tHelper = createNS('text');
        tHelper.style.fontSize = '100px';
        // tHelper.style.fontFamily = fontData.fFamily;
        tHelper.setAttribute('font-family', fontData.fFamily);
        tHelper.setAttribute('font-style', fontProps.style);
        tHelper.setAttribute('font-weight', fontProps.weight);
        tHelper.textContent = '1';
        if (fontData.fClass) {
          tHelper.style.fontFamily = 'inherit';
          tHelper.setAttribute('class', fontData.fClass);
        } else {
          tHelper.style.fontFamily = fontData.fFamily;
        }
        def.appendChild(tHelper);
        helper = tHelper;
      } else {
        var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
        tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
        helper = tCanvasHelper;
      }
      function measure(text) {
        if (engine === 'svg') {
          helper.textContent = text;
          return helper.getComputedTextLength();
        }
        return helper.measureText(text).width;
      }
      return {
        measureText: measure
      };
    }
    function addFonts(fontData, defs) {
      if (!fontData) {
        this.isLoaded = true;
        return;
      }
      if (this.chars) {
        this.isLoaded = true;
        this.fonts = fontData.list;
        return;
      }
      if (!document.body) {
        this.isLoaded = true;
        fontData.list.forEach(function (data) {
          data.helper = createHelper(data);
          data.cache = {};
        });
        this.fonts = fontData.list;
        return;
      }
      var fontArr = fontData.list;
      var i;
      var len = fontArr.length;
      var _pendingFonts = len;
      for (i = 0; i < len; i += 1) {
        var shouldLoadFont = true;
        var loadedSelector;
        var j;
        fontArr[i].loaded = false;
        fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
        fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
        if (!fontArr[i].fPath) {
          fontArr[i].loaded = true;
          _pendingFonts -= 1;
        } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
          loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
          if (loadedSelector.length > 0) {
            shouldLoadFont = false;
          }
          if (shouldLoadFont) {
            var s = createTag('style');
            s.setAttribute('f-forigin', fontArr[i].fOrigin);
            s.setAttribute('f-origin', fontArr[i].origin);
            s.setAttribute('f-family', fontArr[i].fFamily);
            s.type = 'text/css';
            s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
            defs.appendChild(s);
          }
        } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
          loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
          for (j = 0; j < loadedSelector.length; j += 1) {
            if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
              // Font is already loaded
              shouldLoadFont = false;
            }
          }
          if (shouldLoadFont) {
            var l = createTag('link');
            l.setAttribute('f-forigin', fontArr[i].fOrigin);
            l.setAttribute('f-origin', fontArr[i].origin);
            l.type = 'text/css';
            l.rel = 'stylesheet';
            l.href = fontArr[i].fPath;
            document.body.appendChild(l);
          }
        } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
          loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
          for (j = 0; j < loadedSelector.length; j += 1) {
            if (fontArr[i].fPath === loadedSelector[j].src) {
              // Font is already loaded
              shouldLoadFont = false;
            }
          }
          if (shouldLoadFont) {
            var sc = createTag('link');
            sc.setAttribute('f-forigin', fontArr[i].fOrigin);
            sc.setAttribute('f-origin', fontArr[i].origin);
            sc.setAttribute('rel', 'stylesheet');
            sc.setAttribute('href', fontArr[i].fPath);
            defs.appendChild(sc);
          }
        }
        fontArr[i].helper = createHelper(fontArr[i], defs);
        fontArr[i].cache = {};
        this.fonts.push(fontArr[i]);
      }
      if (_pendingFonts === 0) {
        this.isLoaded = true;
      } else {
        // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
        // Adding this timeout seems to fix it
        setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
    }
    function addChars(chars) {
      if (!chars) {
        return;
      }
      if (!this.chars) {
        this.chars = [];
      }
      var i;
      var len = chars.length;
      var j;
      var jLen = this.chars.length;
      var found;
      for (i = 0; i < len; i += 1) {
        j = 0;
        found = false;
        while (j < jLen) {
          if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
            found = true;
          }
          j += 1;
        }
        if (!found) {
          this.chars.push(chars[i]);
          jLen += 1;
        }
      }
    }
    function getCharData(_char, style, font) {
      var i = 0;
      var len = this.chars.length;
      while (i < len) {
        if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) {
          return this.chars[i];
        }
        i += 1;
      }
      if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
      && !this._warned) {
        this._warned = true;
        console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
      }
      return emptyChar;
    }
    function measureText(_char2, fontName, size) {
      var fontData = this.getFontByName(fontName);
      // Using the char instead of char.charCodeAt(0)
      // to avoid collisions between equal chars
      var index = _char2;
      if (!fontData.cache[index]) {
        var tHelper = fontData.helper;
        if (_char2 === ' ') {
          var doubleSize = tHelper.measureText('|' + _char2 + '|');
          var singleSize = tHelper.measureText('||');
          fontData.cache[index] = (doubleSize - singleSize) / 100;
        } else {
          fontData.cache[index] = tHelper.measureText(_char2) / 100;
        }
      }
      return fontData.cache[index] * size;
    }
    function getFontByName(name) {
      var i = 0;
      var len = this.fonts.length;
      while (i < len) {
        if (this.fonts[i].fName === name) {
          return this.fonts[i];
        }
        i += 1;
      }
      return this.fonts[0];
    }
    function getCodePoint(string) {
      var codePoint = 0;
      var first = string.charCodeAt(0);
      if (first >= 0xD800 && first <= 0xDBFF) {
        var second = string.charCodeAt(1);
        if (second >= 0xDC00 && second <= 0xDFFF) {
          codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
        }
      }
      return codePoint;
    }

    // Skin tone modifiers
    function isModifier(firstCharCode, secondCharCode) {
      var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
      return surrogateModifiers.indexOf(sum) !== -1;
    }
    function isZeroWidthJoiner(charCode) {
      return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
    }

    // This codepoint may change the appearance of the preceding character.
    // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
    // as a colorful image as compared to a monochrome text variant.
    function isVariationSelector(charCode) {
      return charCode === VARIATION_SELECTOR_16_CODE_POINT;
    }

    // The regional indicator symbols are a set of 26 alphabetic Unicode
    /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
    // two-letter country codes in a way that allows optional special treatment.
    function isRegionalCode(string) {
      var codePoint = getCodePoint(string);
      if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) {
        return true;
      }
      return false;
    }

    // Some Emoji implementations represent combinations of
    // two “regional indicator” letters as a single flag symbol.
    function isFlagEmoji(string) {
      return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
    }
    function isCombinedCharacter(_char3) {
      return combinedCharacters.indexOf(_char3) !== -1;
    }

    // Regional flags start with a BLACK_FLAG_CODE_POINT
    // folowed by 5 chars in the TAG range
    // and end with a CANCEL_TAG_CODE_POINT
    function isRegionalFlag(text, index) {
      var codePoint = getCodePoint(text.substr(index, 2));
      if (codePoint !== BLACK_FLAG_CODE_POINT) {
        return false;
      }
      var count = 0;
      index += 2;
      while (count < 5) {
        codePoint = getCodePoint(text.substr(index, 2));
        if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) {
          return false;
        }
        count += 1;
        index += 2;
      }
      return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
    }
    function setIsLoaded() {
      this.isLoaded = true;
    }
    var Font = function Font() {
      this.fonts = [];
      this.chars = null;
      this.typekitLoaded = 0;
      this.isLoaded = false;
      this._warned = false;
      this.initTime = Date.now();
      this.setIsLoadedBinded = this.setIsLoaded.bind(this);
      this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
    };
    Font.isModifier = isModifier;
    Font.isZeroWidthJoiner = isZeroWidthJoiner;
    Font.isFlagEmoji = isFlagEmoji;
    Font.isRegionalCode = isRegionalCode;
    Font.isCombinedCharacter = isCombinedCharacter;
    Font.isRegionalFlag = isRegionalFlag;
    Font.isVariationSelector = isVariationSelector;
    Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
    var fontPrototype = {
      addChars: addChars,
      addFonts: addFonts,
      getCharData: getCharData,
      getFontByName: getFontByName,
      measureText: measureText,
      checkLoadedFonts: checkLoadedFonts,
      setIsLoaded: setIsLoaded
    };
    Font.prototype = fontPrototype;
    return Font;
  }();

  function SlotManager(animationData) {
    this.animationData = animationData;
  }
  SlotManager.prototype.getProp = function (data) {
    if (this.animationData.slots && this.animationData.slots[data.sid]) {
      return Object.assign(data, this.animationData.slots[data.sid].p);
    }
    return data;
  };
  function slotFactory(animationData) {
    return new SlotManager(animationData);
  }

  function RenderableElement() {}
  RenderableElement.prototype = {
    initRenderable: function initRenderable() {
      // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
      this.isInRange = false;
      // layer's display state
      this.hidden = false;
      // If layer's transparency equals 0, it can be hidden
      this.isTransparent = false;
      // list of animated components
      this.renderableComponents = [];
    },
    addRenderableComponent: function addRenderableComponent(component) {
      if (this.renderableComponents.indexOf(component) === -1) {
        this.renderableComponents.push(component);
      }
    },
    removeRenderableComponent: function removeRenderableComponent(component) {
      if (this.renderableComponents.indexOf(component) !== -1) {
        this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
      }
    },
    prepareRenderableFrame: function prepareRenderableFrame(num) {
      this.checkLayerLimits(num);
    },
    checkTransparency: function checkTransparency() {
      if (this.finalTransform.mProp.o.v <= 0) {
        if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
          this.isTransparent = true;
          this.hide();
        }
      } else if (this.isTransparent) {
        this.isTransparent = false;
        this.show();
      }
    },
    /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */
    checkLayerLimits: function checkLayerLimits(num) {
      if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
        if (this.isInRange !== true) {
          this.globalData._mdf = true;
          this._mdf = true;
          this.isInRange = true;
          this.show();
        }
      } else if (this.isInRange !== false) {
        this.globalData._mdf = true;
        this.isInRange = false;
        this.hide();
      }
    },
    renderRenderable: function renderRenderable() {
      var i;
      var len = this.renderableComponents.length;
      for (i = 0; i < len; i += 1) {
        this.renderableComponents[i].renderFrame(this._isFirstFrame);
      }
      /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */
    },
    sourceRectAtTime: function sourceRectAtTime() {
      return {
        top: 0,
        left: 0,
        width: 100,
        height: 100
      };
    },
    getLayerSize: function getLayerSize() {
      if (this.data.ty === 5) {
        return {
          w: this.data.textData.width,
          h: this.data.textData.height
        };
      }
      return {
        w: this.data.width,
        h: this.data.height
      };
    }
  };

  var getBlendMode = function () {
    var blendModeEnums = {
      0: 'source-over',
      1: 'multiply',
      2: 'screen',
      3: 'overlay',
      4: 'darken',
      5: 'lighten',
      6: 'color-dodge',
      7: 'color-burn',
      8: 'hard-light',
      9: 'soft-light',
      10: 'difference',
      11: 'exclusion',
      12: 'hue',
      13: 'saturation',
      14: 'color',
      15: 'luminosity'
    };
    return function (mode) {
      return blendModeEnums[mode] || '';
    };
  }();

  function SliderEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }
  function AngleEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }
  function ColorEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
  }
  function PointEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
  }
  function LayerIndexEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }
  function MaskIndexEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }
  function CheckboxEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }
  function NoValueEffect() {
    this.p = {};
  }

  function EffectsManager(data, element) {
    var effects = data.ef || [];
    this.effectElements = [];
    var i;
    var len = effects.length;
    var effectItem;
    for (i = 0; i < len; i += 1) {
      effectItem = new GroupEffect(effects[i], element);
      this.effectElements.push(effectItem);
    }
  }
  function GroupEffect(data, element) {
    this.init(data, element);
  }
  extendPrototype([DynamicPropertyContainer], GroupEffect);
  GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
  GroupEffect.prototype.init = function (data, element) {
    this.data = data;
    this.effectElements = [];
    this.initDynamicPropertyContainer(element);
    var i;
    var len = this.data.ef.length;
    var eff;
    var effects = this.data.ef;
    for (i = 0; i < len; i += 1) {
      eff = null;
      switch (effects[i].ty) {
        case 0:
          eff = new SliderEffect(effects[i], element, this);
          break;
        case 1:
          eff = new AngleEffect(effects[i], element, this);
          break;
        case 2:
          eff = new ColorEffect(effects[i], element, this);
          break;
        case 3:
          eff = new PointEffect(effects[i], element, this);
          break;
        case 4:
        case 7:
          eff = new CheckboxEffect(effects[i], element, this);
          break;
        case 10:
          eff = new LayerIndexEffect(effects[i], element, this);
          break;
        case 11:
          eff = new MaskIndexEffect(effects[i], element, this);
          break;
        case 5:
          eff = new EffectsManager(effects[i], element, this);
          break;
        // case 6:
        default:
          eff = new NoValueEffect(effects[i], element, this);
          break;
      }
      if (eff) {
        this.effectElements.push(eff);
      }
    }
  };

  function BaseElement() {}
  BaseElement.prototype = {
    checkMasks: function checkMasks() {
      if (!this.data.hasMask) {
        return false;
      }
      var i = 0;
      var len = this.data.masksProperties.length;
      while (i < len) {
        if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) {
          return true;
        }
        i += 1;
      }
      return false;
    },
    initExpressions: function initExpressions() {
      var expressionsInterfaces = getExpressionInterfaces();
      if (!expressionsInterfaces) {
        return;
      }
      var LayerExpressionInterface = expressionsInterfaces('layer');
      var EffectsExpressionInterface = expressionsInterfaces('effects');
      var ShapeExpressionInterface = expressionsInterfaces('shape');
      var TextExpressionInterface = expressionsInterfaces('text');
      var CompExpressionInterface = expressionsInterfaces('comp');
      this.layerInterface = LayerExpressionInterface(this);
      if (this.data.hasMask && this.maskManager) {
        this.layerInterface.registerMaskInterface(this.maskManager);
      }
      var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
      this.layerInterface.registerEffectsInterface(effectsInterface);
      if (this.data.ty === 0 || this.data.xt) {
        this.compInterface = CompExpressionInterface(this);
      } else if (this.data.ty === 4) {
        this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
        this.layerInterface.content = this.layerInterface.shapeInterface;
      } else if (this.data.ty === 5) {
        this.layerInterface.textInterface = TextExpressionInterface(this);
        this.layerInterface.text = this.layerInterface.textInterface;
      }
    },
    setBlendMode: function setBlendMode() {
      var blendModeValue = getBlendMode(this.data.bm);
      var elem = this.baseElement || this.layerElement;
      elem.style['mix-blend-mode'] = blendModeValue;
    },
    initBaseData: function initBaseData(data, globalData, comp) {
      this.globalData = globalData;
      this.comp = comp;
      this.data = data;
      this.layerId = createElementID();

      // Stretch factor for old animations missing this property.
      if (!this.data.sr) {
        this.data.sr = 1;
      }
      // effects manager
      this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
    },
    getType: function getType() {
      return this.type;
    },
    sourceRectAtTime: function sourceRectAtTime() {}
  };

  /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */

  function FrameElement() {}
  FrameElement.prototype = {
    /**
       * @function
       * Initializes frame related properties.
       *
       */
    initFrame: function initFrame() {
      // set to true when inpoint is rendered
      this._isFirstFrame = false;
      // list of animated properties
      this.dynamicProperties = [];
      // If layer has been modified in current tick this will be true
      this._mdf = false;
    },
    /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */
    prepareProperties: function prepareProperties(num, isVisible) {
      var i;
      var len = this.dynamicProperties.length;
      for (i = 0; i < len; i += 1) {
        if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
          this.dynamicProperties[i].getValue();
          if (this.dynamicProperties[i]._mdf) {
            this.globalData._mdf = true;
            this._mdf = true;
          }
        }
      }
    },
    addDynamicProperty: function addDynamicProperty(prop) {
      if (this.dynamicProperties.indexOf(prop) === -1) {
        this.dynamicProperties.push(prop);
      }
    }
  };

  function FootageElement(data, globalData, comp) {
    this.initFrame();
    this.initRenderable();
    this.assetData = globalData.getAssetData(data.refId);
    this.footageData = globalData.imageLoader.getAsset(this.assetData);
    this.initBaseData(data, globalData, comp);
  }
  FootageElement.prototype.prepareFrame = function () {};
  extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);
  FootageElement.prototype.getBaseElement = function () {
    return null;
  };
  FootageElement.prototype.renderFrame = function () {};
  FootageElement.prototype.destroy = function () {};
  FootageElement.prototype.initExpressions = function () {
    var expressionsInterfaces = getExpressionInterfaces();
    if (!expressionsInterfaces) {
      return;
    }
    var FootageInterface = expressionsInterfaces('footage');
    this.layerInterface = FootageInterface(this);
  };
  FootageElement.prototype.getFootageData = function () {
    return this.footageData;
  };

  function AudioElement(data, globalData, comp) {
    this.initFrame();
    this.initRenderable();
    this.assetData = globalData.getAssetData(data.refId);
    this.initBaseData(data, globalData, comp);
    this._isPlaying = false;
    this._canPlay = false;
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.audio = this.globalData.audioController.createAudio(assetPath);
    this._currentTime = 0;
    this.globalData.audioController.addAudio(this);
    this._volumeMultiplier = 1;
    this._volume = 1;
    this._previousVolume = null;
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
    this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
      k: [100]
    }, 1, 0.01, this);
  }
  AudioElement.prototype.prepareFrame = function (num) {
    this.prepareRenderableFrame(num, true);
    this.prepareProperties(num, true);
    if (!this.tm._placeholder) {
      var timeRemapped = this.tm.v;
      this._currentTime = timeRemapped;
    } else {
      this._currentTime = num / this.data.sr;
    }
    this._volume = this.lv.v[0];
    var totalVolume = this._volume * this._volumeMultiplier;
    if (this._previousVolume !== totalVolume) {
      this._previousVolume = totalVolume;
      this.audio.volume(totalVolume);
    }
  };
  extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);
  AudioElement.prototype.renderFrame = function () {
    if (this.isInRange && this._canPlay) {
      if (!this._isPlaying) {
        this.audio.play();
        this.audio.seek(this._currentTime / this.globalData.frameRate);
        this._isPlaying = true;
      } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) {
        this.audio.seek(this._currentTime / this.globalData.frameRate);
      }
    }
  };
  AudioElement.prototype.show = function () {
    // this.audio.play()
  };
  AudioElement.prototype.hide = function () {
    this.audio.pause();
    this._isPlaying = false;
  };
  AudioElement.prototype.pause = function () {
    this.audio.pause();
    this._isPlaying = false;
    this._canPlay = false;
  };
  AudioElement.prototype.resume = function () {
    this._canPlay = true;
  };
  AudioElement.prototype.setRate = function (rateValue) {
    this.audio.rate(rateValue);
  };
  AudioElement.prototype.volume = function (volumeValue) {
    this._volumeMultiplier = volumeValue;
    this._previousVolume = volumeValue * this._volume;
    this.audio.volume(this._previousVolume);
  };
  AudioElement.prototype.getBaseElement = function () {
    return null;
  };
  AudioElement.prototype.destroy = function () {};
  AudioElement.prototype.sourceRectAtTime = function () {};
  AudioElement.prototype.initExpressions = function () {};

  function BaseRenderer() {}
  BaseRenderer.prototype.checkLayers = function (num) {
    var i;
    var len = this.layers.length;
    var data;
    this.completeLayers = true;
    for (i = len - 1; i >= 0; i -= 1) {
      if (!this.elements[i]) {
        data = this.layers[i];
        if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) {
          this.buildItem(i);
        }
      }
      this.completeLayers = this.elements[i] ? this.completeLayers : false;
    }
    this.checkPendingElements();
  };
  BaseRenderer.prototype.createItem = function (layer) {
    switch (layer.ty) {
      case 2:
        return this.createImage(layer);
      case 0:
        return this.createComp(layer);
      case 1:
        return this.createSolid(layer);
      case 3:
        return this.createNull(layer);
      case 4:
        return this.createShape(layer);
      case 5:
        return this.createText(layer);
      case 6:
        return this.createAudio(layer);
      case 13:
        return this.createCamera(layer);
      case 15:
        return this.createFootage(layer);
      default:
        return this.createNull(layer);
    }
  };
  BaseRenderer.prototype.createCamera = function () {
    throw new Error('You\'re using a 3d camera. Try the html renderer.');
  };
  BaseRenderer.prototype.createAudio = function (data) {
    return new AudioElement(data, this.globalData, this);
  };
  BaseRenderer.prototype.createFootage = function (data) {
    return new FootageElement(data, this.globalData, this);
  };
  BaseRenderer.prototype.buildAllItems = function () {
    var i;
    var len = this.layers.length;
    for (i = 0; i < len; i += 1) {
      this.buildItem(i);
    }
    this.checkPendingElements();
  };
  BaseRenderer.prototype.includeLayers = function (newLayers) {
    this.completeLayers = false;
    var i;
    var len = newLayers.length;
    var j;
    var jLen = this.layers.length;
    for (i = 0; i < len; i += 1) {
      j = 0;
      while (j < jLen) {
        if (this.layers[j].id === newLayers[i].id) {
          this.layers[j] = newLayers[i];
          break;
        }
        j += 1;
      }
    }
  };
  BaseRenderer.prototype.setProjectInterface = function (pInterface) {
    this.globalData.projectInterface = pInterface;
  };
  BaseRenderer.prototype.initItems = function () {
    if (!this.globalData.progressiveLoad) {
      this.buildAllItems();
    }
  };
  BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
    var elements = this.elements;
    var layers = this.layers;
    var i = 0;
    var len = layers.length;
    while (i < len) {
      if (layers[i].ind == parentName) {
        // eslint-disable-line eqeqeq
        if (!elements[i] || elements[i] === true) {
          this.buildItem(i);
          this.addPendingElement(element);
        } else {
          hierarchy.push(elements[i]);
          elements[i].setAsParent();
          if (layers[i].parent !== undefined) {
            this.buildElementParenting(element, layers[i].parent, hierarchy);
          } else {
            element.setHierarchy(hierarchy);
          }
        }
      }
      i += 1;
    }
  };
  BaseRenderer.prototype.addPendingElement = function (element) {
    this.pendingElements.push(element);
  };
  BaseRenderer.prototype.searchExtraCompositions = function (assets) {
    var i;
    var len = assets.length;
    for (i = 0; i < len; i += 1) {
      if (assets[i].xt) {
        var comp = this.createComp(assets[i]);
        comp.initExpressions();
        this.globalData.projectInterface.registerComposition(comp);
      }
    }
  };
  BaseRenderer.prototype.getElementById = function (ind) {
    var i;
    var len = this.elements.length;
    for (i = 0; i < len; i += 1) {
      if (this.elements[i].data.ind === ind) {
        return this.elements[i];
      }
    }
    return null;
  };
  BaseRenderer.prototype.getElementByPath = function (path) {
    var pathValue = path.shift();
    var element;
    if (typeof pathValue === 'number') {
      element = this.elements[pathValue];
    } else {
      var i;
      var len = this.elements.length;
      for (i = 0; i < len; i += 1) {
        if (this.elements[i].data.nm === pathValue) {
          element = this.elements[i];
          break;
        }
      }
    }
    if (path.length === 0) {
      return element;
    }
    return element.getElementByPath(path);
  };
  BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
    this.globalData.fontManager = new FontManager();
    this.globalData.slotManager = slotFactory(animData);
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.imageLoader = this.animationItem.imagePreloader;
    this.globalData.audioController = this.animationItem.audioController;
    this.globalData.frameId = 0;
    this.globalData.frameRate = animData.fr;
    this.globalData.nm = animData.nm;
    this.globalData.compSize = {
      w: animData.w,
      h: animData.h
    };
  };

  var effectTypes = {
    TRANSFORM_EFFECT: 'transformEFfect'
  };

  function TransformElement() {}
  TransformElement.prototype = {
    initTransform: function initTransform() {
      var mat = new Matrix();
      this.finalTransform = {
        mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
          o: 0
        },
        _matMdf: false,
        _localMatMdf: false,
        _opMdf: false,
        mat: mat,
        localMat: mat,
        localOpacity: 1
      };
      if (this.data.ao) {
        this.finalTransform.mProp.autoOriented = true;
      }

      // TODO: check TYPE 11: Guided elements
      if (this.data.ty !== 11) {
        // this.createElements();
      }
    },
    renderTransform: function renderTransform() {
      this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
      this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
      if (this.hierarchy) {
        var mat;
        var finalMat = this.finalTransform.mat;
        var i = 0;
        var len = this.hierarchy.length;
        // Checking if any of the transformation matrices in the hierarchy chain has changed.
        if (!this.finalTransform._matMdf) {
          while (i < len) {
            if (this.hierarchy[i].finalTransform.mProp._mdf) {
              this.finalTransform._matMdf = true;
              break;
            }
            i += 1;
          }
        }
        if (this.finalTransform._matMdf) {
          mat = this.finalTransform.mProp.v.props;
          finalMat.cloneFromProps(mat);
          for (i = 0; i < len; i += 1) {
            finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
          }
        }
      }
      if (!this.localTransforms || this.finalTransform._matMdf) {
        this.finalTransform._localMatMdf = this.finalTransform._matMdf;
      }
      if (this.finalTransform._opMdf) {
        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
      }
    },
    renderLocalTransform: function renderLocalTransform() {
      if (this.localTransforms) {
        var i = 0;
        var len = this.localTransforms.length;
        this.finalTransform._localMatMdf = this.finalTransform._matMdf;
        if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) {
          while (i < len) {
            if (this.localTransforms[i]._mdf) {
              this.finalTransform._localMatMdf = true;
            }
            if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
              this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
              this.finalTransform._opMdf = true;
            }
            i += 1;
          }
        }
        if (this.finalTransform._localMatMdf) {
          var localMat = this.finalTransform.localMat;
          this.localTransforms[0].matrix.clone(localMat);
          for (i = 1; i < len; i += 1) {
            var lmat = this.localTransforms[i].matrix;
            localMat.multiply(lmat);
          }
          localMat.multiply(this.finalTransform.mat);
        }
        if (this.finalTransform._opMdf) {
          var localOp = this.finalTransform.localOpacity;
          for (i = 0; i < len; i += 1) {
            localOp *= this.localTransforms[i].opacity * 0.01;
          }
          this.finalTransform.localOpacity = localOp;
        }
      }
    },
    searchEffectTransforms: function searchEffectTransforms() {
      if (this.renderableEffectsManager) {
        var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        if (transformEffects.length) {
          this.localTransforms = [];
          this.finalTransform.localMat = new Matrix();
          var i = 0;
          var len = transformEffects.length;
          for (i = 0; i < len; i += 1) {
            this.localTransforms.push(transformEffects[i]);
          }
        }
      }
    },
    globalToLocal: function globalToLocal(pt) {
      var transforms = [];
      transforms.push(this.finalTransform);
      var flag = true;
      var comp = this.comp;
      while (flag) {
        if (comp.finalTransform) {
          if (comp.data.hasMask) {
            transforms.splice(0, 0, comp.finalTransform);
          }
          comp = comp.comp;
        } else {
          flag = false;
        }
      }
      var i;
      var len = transforms.length;
      var ptNew;
      for (i = 0; i < len; i += 1) {
        ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
        // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
        pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
      }
      return pt;
    },
    mHelper: new Matrix()
  };

  function MaskElement(data, element, globalData) {
    this.data = data;
    this.element = element;
    this.globalData = globalData;
    this.storedData = [];
    this.masksProperties = this.data.masksProperties || [];
    this.maskElement = null;
    var defs = this.globalData.defs;
    var i;
    var len = this.masksProperties ? this.masksProperties.length : 0;
    this.viewData = createSizedArray(len);
    this.solidPath = '';
    var path;
    var properties = this.masksProperties;
    var count = 0;
    var currentMasks = [];
    var j;
    var jLen;
    var layerId = createElementID();
    var rect;
    var expansor;
    var feMorph;
    var x;
    var maskType = 'clipPath';
    var maskRef = 'clip-path';
    for (i = 0; i < len; i += 1) {
      if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
        maskType = 'mask';
        maskRef = 'mask';
      }
      if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
        rect = createNS('rect');
        rect.setAttribute('fill', '#ffffff');
        rect.setAttribute('width', this.element.comp.data.w || 0);
        rect.setAttribute('height', this.element.comp.data.h || 0);
        currentMasks.push(rect);
      } else {
        rect = null;
      }
      path = createNS('path');
      if (properties[i].mode === 'n') {
        // TODO move this to a factory or to a constructor
        this.viewData[i] = {
          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
          elem: path,
          lastPath: ''
        };
        defs.appendChild(path);
      } else {
        count += 1;
        path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
        path.setAttribute('clip-rule', 'nonzero');
        var filterID;
        if (properties[i].x.k !== 0) {
          maskType = 'mask';
          maskRef = 'mask';
          x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
          filterID = createElementID();
          expansor = createNS('filter');
          expansor.setAttribute('id', filterID);
          feMorph = createNS('feMorphology');
          feMorph.setAttribute('operator', 'erode');
          feMorph.setAttribute('in', 'SourceGraphic');
          feMorph.setAttribute('radius', '0');
          expansor.appendChild(feMorph);
          defs.appendChild(expansor);
          path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
        } else {
          feMorph = null;
          x = null;
        }

        // TODO move this to a factory or to a constructor
        this.storedData[i] = {
          elem: path,
          x: x,
          expan: feMorph,
          lastPath: '',
          lastOperator: '',
          filterId: filterID,
          lastRadius: 0
        };
        if (properties[i].mode === 'i') {
          jLen = currentMasks.length;
          var g = createNS('g');
          for (j = 0; j < jLen; j += 1) {
            g.appendChild(currentMasks[j]);
          }
          var mask = createNS('mask');
          mask.setAttribute('mask-type', 'alpha');
          mask.setAttribute('id', layerId + '_' + count);
          mask.appendChild(path);
          defs.appendChild(mask);
          g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
          currentMasks.length = 0;
          currentMasks.push(g);
        } else {
          currentMasks.push(path);
        }
        if (properties[i].inv && !this.solidPath) {
          this.solidPath = this.createLayerSolidPath();
        }
        // TODO move this to a factory or to a constructor
        this.viewData[i] = {
          elem: path,
          lastPath: '',
          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
          invRect: rect
        };
        if (!this.viewData[i].prop.k) {
          this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
        }
      }
    }
    this.maskElement = createNS(maskType);
    len = currentMasks.length;
    for (i = 0; i < len; i += 1) {
      this.maskElement.appendChild(currentMasks[i]);
    }
    if (count > 0) {
      this.maskElement.setAttribute('id', layerId);
      this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
      defs.appendChild(this.maskElement);
    }
    if (this.viewData.length) {
      this.element.addRenderableComponent(this);
    }
  }
  MaskElement.prototype.getMaskProperty = function (pos) {
    return this.viewData[pos].prop;
  };
  MaskElement.prototype.renderFrame = function (isFirstFrame) {
    var finalMat = this.element.finalTransform.mat;
    var i;
    var len = this.masksProperties.length;
    for (i = 0; i < len; i += 1) {
      if (this.viewData[i].prop._mdf || isFirstFrame) {
        this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
      }
      if (this.viewData[i].op._mdf || isFirstFrame) {
        this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
      }
      if (this.masksProperties[i].mode !== 'n') {
        if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
          this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
        }
        if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
          var feMorph = this.storedData[i].expan;
          if (this.storedData[i].x.v < 0) {
            if (this.storedData[i].lastOperator !== 'erode') {
              this.storedData[i].lastOperator = 'erode';
              this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
            }
            feMorph.setAttribute('radius', -this.storedData[i].x.v);
          } else {
            if (this.storedData[i].lastOperator !== 'dilate') {
              this.storedData[i].lastOperator = 'dilate';
              this.storedData[i].elem.setAttribute('filter', null);
            }
            this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
          }
        }
      }
    }
  };
  MaskElement.prototype.getMaskelement = function () {
    return this.maskElement;
  };
  MaskElement.prototype.createLayerSolidPath = function () {
    var path = 'M0,0 ';
    path += ' h' + this.globalData.compSize.w;
    path += ' v' + this.globalData.compSize.h;
    path += ' h-' + this.globalData.compSize.w;
    path += ' v-' + this.globalData.compSize.h + ' ';
    return path;
  };
  MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
    var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
    var i;
    var len;
    len = pathNodes._length;
    for (i = 1; i < len; i += 1) {
      // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
    }
    // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
    if (pathNodes.c && len > 1) {
      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
    }
    // pathNodes.__renderedString = pathString;

    if (viewData.lastPath !== pathString) {
      var pathShapeValue = '';
      if (viewData.elem) {
        if (pathNodes.c) {
          pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
        }
        viewData.elem.setAttribute('d', pathShapeValue);
      }
      viewData.lastPath = pathString;
    }
  };
  MaskElement.prototype.destroy = function () {
    this.element = null;
    this.globalData = null;
    this.maskElement = null;
    this.data = null;
    this.masksProperties = null;
  };

  var filtersFactory = function () {
    var ob = {};
    ob.createFilter = createFilter;
    ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
    function createFilter(filId, skipCoordinates) {
      var fil = createNS('filter');
      fil.setAttribute('id', filId);
      if (skipCoordinates !== true) {
        fil.setAttribute('filterUnits', 'objectBoundingBox');
        fil.setAttribute('x', '0%');
        fil.setAttribute('y', '0%');
        fil.setAttribute('width', '100%');
        fil.setAttribute('height', '100%');
      }
      return fil;
    }
    function createAlphaToLuminanceFilter() {
      var feColorMatrix = createNS('feColorMatrix');
      feColorMatrix.setAttribute('type', 'matrix');
      feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
      feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
      return feColorMatrix;
    }
    return ob;
  }();

  var featureSupport = function () {
    var ob = {
      maskType: true,
      svgLumaHidden: true,
      offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
    };
    if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
      ob.maskType = false;
    }
    if (/firefox/i.test(navigator.userAgent)) {
      ob.svgLumaHidden = false;
    }
    return ob;
  }();

  var registeredEffects$1 = {};
  var idPrefix = 'filter_result_';
  function SVGEffects(elem) {
    var i;
    var source = 'SourceGraphic';
    var len = elem.data.ef ? elem.data.ef.length : 0;
    var filId = createElementID();
    var fil = filtersFactory.createFilter(filId, true);
    var count = 0;
    this.filters = [];
    var filterManager;
    for (i = 0; i < len; i += 1) {
      filterManager = null;
      var type = elem.data.ef[i].ty;
      if (registeredEffects$1[type]) {
        var Effect = registeredEffects$1[type].effect;
        filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
        source = idPrefix + count;
        if (registeredEffects$1[type].countsAsEffect) {
          count += 1;
        }
      }
      if (filterManager) {
        this.filters.push(filterManager);
      }
    }
    if (count) {
      elem.globalData.defs.appendChild(fil);
      elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
    }
    if (this.filters.length) {
      elem.addRenderableComponent(this);
    }
  }
  SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
    var i;
    var len = this.filters.length;
    for (i = 0; i < len; i += 1) {
      this.filters[i].renderFrame(_isFirstFrame);
    }
  };
  SVGEffects.prototype.getEffects = function (type) {
    var i;
    var len = this.filters.length;
    var effects = [];
    for (i = 0; i < len; i += 1) {
      if (this.filters[i].type === type) {
        effects.push(this.filters[i]);
      }
    }
    return effects;
  };
  function registerEffect$1(id, effect, countsAsEffect) {
    registeredEffects$1[id] = {
      effect: effect,
      countsAsEffect: countsAsEffect
    };
  }

  function SVGBaseElement() {}
  SVGBaseElement.prototype = {
    initRendererElement: function initRendererElement() {
      this.layerElement = createNS('g');
    },
    createContainerElements: function createContainerElements() {
      this.matteElement = createNS('g');
      this.transformedElement = this.layerElement;
      this.maskedElement = this.layerElement;
      this._sizeChanged = false;
      var layerElementParent = null;
      // If this layer acts as a mask for the following layer
      if (this.data.td) {
        this.matteMasks = {};
        var gg = createNS('g');
        gg.setAttribute('id', this.layerId);
        gg.appendChild(this.layerElement);
        layerElementParent = gg;
        this.globalData.defs.appendChild(gg);
      } else if (this.data.tt) {
        this.matteElement.appendChild(this.layerElement);
        layerElementParent = this.matteElement;
        this.baseElement = this.matteElement;
      } else {
        this.baseElement = this.layerElement;
      }
      if (this.data.ln) {
        this.layerElement.setAttribute('id', this.data.ln);
      }
      if (this.data.cl) {
        this.layerElement.setAttribute('class', this.data.cl);
      }
      // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
      if (this.data.ty === 0 && !this.data.hd) {
        var cp = createNS('clipPath');
        var pt = createNS('path');
        pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
        var clipId = createElementID();
        cp.setAttribute('id', clipId);
        cp.appendChild(pt);
        this.globalData.defs.appendChild(cp);
        if (this.checkMasks()) {
          var cpGroup = createNS('g');
          cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
          cpGroup.appendChild(this.layerElement);
          this.transformedElement = cpGroup;
          if (layerElementParent) {
            layerElementParent.appendChild(this.transformedElement);
          } else {
            this.baseElement = this.transformedElement;
          }
        } else {
          this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
        }
      }
      if (this.data.bm !== 0) {
        this.setBlendMode();
      }
    },
    renderElement: function renderElement() {
      if (this.finalTransform._localMatMdf) {
        this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
      }
      if (this.finalTransform._opMdf) {
        this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
      }
    },
    destroyBaseElement: function destroyBaseElement() {
      this.layerElement = null;
      this.matteElement = null;
      this.maskManager.destroy();
    },
    getBaseElement: function getBaseElement() {
      if (this.data.hd) {
        return null;
      }
      return this.baseElement;
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
      this.renderableEffectsManager = new SVGEffects(this);
      this.searchEffectTransforms();
    },
    getMatte: function getMatte(matteType) {
      // This should not be a common case. But for backward compatibility, we'll create the matte object.
      // It solves animations that have two consecutive layers marked as matte masks.
      // Which is an undefined behavior in AE.
      if (!this.matteMasks) {
        this.matteMasks = {};
      }
      if (!this.matteMasks[matteType]) {
        var id = this.layerId + '_' + matteType;
        var filId;
        var fil;
        var useElement;
        var gg;
        if (matteType === 1 || matteType === 3) {
          var masker = createNS('mask');
          masker.setAttribute('id', id);
          masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
          useElement = createNS('use');
          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
          masker.appendChild(useElement);
          this.globalData.defs.appendChild(masker);
          if (!featureSupport.maskType && matteType === 1) {
            masker.setAttribute('mask-type', 'luminance');
            filId = createElementID();
            fil = filtersFactory.createFilter(filId);
            this.globalData.defs.appendChild(fil);
            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
            gg = createNS('g');
            gg.appendChild(useElement);
            masker.appendChild(gg);
            gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
          }
        } else if (matteType === 2) {
          var maskGroup = createNS('mask');
          maskGroup.setAttribute('id', id);
          maskGroup.setAttribute('mask-type', 'alpha');
          var maskGrouper = createNS('g');
          maskGroup.appendChild(maskGrouper);
          filId = createElementID();
          fil = filtersFactory.createFilter(filId);
          /// /
          var feCTr = createNS('feComponentTransfer');
          feCTr.setAttribute('in', 'SourceGraphic');
          fil.appendChild(feCTr);
          var feFunc = createNS('feFuncA');
          feFunc.setAttribute('type', 'table');
          feFunc.setAttribute('tableValues', '1.0 0.0');
          feCTr.appendChild(feFunc);
          /// /
          this.globalData.defs.appendChild(fil);
          var alphaRect = createNS('rect');
          alphaRect.setAttribute('width', this.comp.data.w);
          alphaRect.setAttribute('height', this.comp.data.h);
          alphaRect.setAttribute('x', '0');
          alphaRect.setAttribute('y', '0');
          alphaRect.setAttribute('fill', '#ffffff');
          alphaRect.setAttribute('opacity', '0');
          maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
          maskGrouper.appendChild(alphaRect);
          useElement = createNS('use');
          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
          maskGrouper.appendChild(useElement);
          if (!featureSupport.maskType) {
            maskGroup.setAttribute('mask-type', 'luminance');
            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
            gg = createNS('g');
            maskGrouper.appendChild(alphaRect);
            gg.appendChild(this.layerElement);
            maskGrouper.appendChild(gg);
          }
          this.globalData.defs.appendChild(maskGroup);
        }
        this.matteMasks[matteType] = id;
      }
      return this.matteMasks[matteType];
    },
    setMatte: function setMatte(id) {
      if (!this.matteElement) {
        return;
      }
      this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
    }
  };

  /**
   * @file
   * Handles AE's layer parenting property.
   *
   */

  function HierarchyElement() {}
  HierarchyElement.prototype = {
    /**
       * @function
       * Initializes hierarchy properties
       *
       */
    initHierarchy: function initHierarchy() {
      // element's parent list
      this.hierarchy = [];
      // if element is parent of another layer _isParent will be true
      this._isParent = false;
      this.checkParenting();
    },
    /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */
    setHierarchy: function setHierarchy(hierarchy) {
      this.hierarchy = hierarchy;
    },
    /**
       * @function
       * Sets layer as parent.
       *
       */
    setAsParent: function setAsParent() {
      this._isParent = true;
    },
    /**
       * @function
       * Searches layer's parenting chain
       *
       */
    checkParenting: function checkParenting() {
      if (this.data.parent !== undefined) {
        this.comp.buildElementParenting(this, this.data.parent, []);
      }
    }
  };

  function RenderableDOMElement() {}
  (function () {
    var _prototype = {
      initElement: function initElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
      },
      hide: function hide() {
        // console.log('HIDE', this);
        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
          var elem = this.baseElement || this.layerElement;
          elem.style.display = 'none';
          this.hidden = true;
        }
      },
      show: function show() {
        // console.log('SHOW', this);
        if (this.isInRange && !this.isTransparent) {
          if (!this.data.hd) {
            var elem = this.baseElement || this.layerElement;
            elem.style.display = 'block';
          }
          this.hidden = false;
          this._isFirstFrame = true;
        }
      },
      renderFrame: function renderFrame() {
        // If it is exported as hidden (data.hd === true) no need to render
        // If it is not visible no need to render
        if (this.data.hd || this.hidden) {
          return;
        }
        this.renderTransform();
        this.renderRenderable();
        this.renderLocalTransform();
        this.renderElement();
        this.renderInnerContent();
        if (this._isFirstFrame) {
          this._isFirstFrame = false;
        }
      },
      renderInnerContent: function renderInnerContent() {},
      prepareFrame: function prepareFrame(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        this.checkTransparency();
      },
      destroy: function destroy() {
        this.innerElem = null;
        this.destroyBaseElement();
      }
    };
    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
  })();

  function IImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);
    if (this.assetData && this.assetData.sid) {
      this.assetData = globalData.slotManager.getProp(this.assetData);
    }
    this.initElement(data, globalData, comp);
    this.sourceRect = {
      top: 0,
      left: 0,
      width: this.assetData.w,
      height: this.assetData.h
    };
  }
  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);
  IImageElement.prototype.createContent = function () {
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.innerElem = createNS('image');
    this.innerElem.setAttribute('width', this.assetData.w + 'px');
    this.innerElem.setAttribute('height', this.assetData.h + 'px');
    this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
    this.layerElement.appendChild(this.innerElem);
  };
  IImageElement.prototype.sourceRectAtTime = function () {
    return this.sourceRect;
  };

  function ProcessedElement(element, position) {
    this.elem = element;
    this.pos = position;
  }

  function IShapeElement() {}
  IShapeElement.prototype = {
    addShapeToModifiers: function addShapeToModifiers(data) {
      var i;
      var len = this.shapeModifiers.length;
      for (i = 0; i < len; i += 1) {
        this.shapeModifiers[i].addShape(data);
      }
    },
    isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
      var i = 0;
      var len = this.shapeModifiers.length;
      while (i < len) {
        if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
          return true;
        }
      }
      return false;
    },
    renderModifiers: function renderModifiers() {
      if (!this.shapeModifiers.length) {
        return;
      }
      var i;
      var len = this.shapes.length;
      for (i = 0; i < len; i += 1) {
        this.shapes[i].sh.reset();
      }
      len = this.shapeModifiers.length;
      var shouldBreakProcess;
      for (i = len - 1; i >= 0; i -= 1) {
        shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame);
        // workaround to fix cases where a repeater resets the shape so the following processes get called twice
        // TODO: find a better solution for this
        if (shouldBreakProcess) {
          break;
        }
      }
    },
    searchProcessedElement: function searchProcessedElement(elem) {
      var elements = this.processedElements;
      var i = 0;
      var len = elements.length;
      while (i < len) {
        if (elements[i].elem === elem) {
          return elements[i].pos;
        }
        i += 1;
      }
      return 0;
    },
    addProcessedElement: function addProcessedElement(elem, pos) {
      var elements = this.processedElements;
      var i = elements.length;
      while (i) {
        i -= 1;
        if (elements[i].elem === elem) {
          elements[i].pos = pos;
          return;
        }
      }
      elements.push(new ProcessedElement(elem, pos));
    },
    prepareFrame: function prepareFrame(num) {
      this.prepareRenderableFrame(num);
      this.prepareProperties(num, this.isInRange);
    }
  };

  var lineCapEnum = {
    1: 'butt',
    2: 'round',
    3: 'square'
  };
  var lineJoinEnum = {
    1: 'miter',
    2: 'round',
    3: 'bevel'
  };

  function SVGShapeData(transformers, level, shape) {
    this.caches = [];
    this.styles = [];
    this.transformers = transformers;
    this.lStr = '';
    this.sh = shape;
    this.lvl = level;
    // TODO find if there are some cases where _isAnimated can be false.
    // For now, since shapes add up with other shapes. They have to be calculated every time.
    // One way of finding out is checking if all styles associated to this shape depend only of this shape
    this._isAnimated = !!shape.k;
    // TODO: commenting this for now since all shapes are animated
    var i = 0;
    var len = transformers.length;
    while (i < len) {
      if (transformers[i].mProps.dynamicProperties.length) {
        this._isAnimated = true;
        break;
      }
      i += 1;
    }
  }
  SVGShapeData.prototype.setAsAnimated = function () {
    this._isAnimated = true;
  };

  function SVGStyleData(data, level) {
    this.data = data;
    this.type = data.ty;
    this.d = '';
    this.lvl = level;
    this._mdf = false;
    this.closed = data.hd === true;
    this.pElem = createNS('path');
    this.msElem = null;
  }
  SVGStyleData.prototype.reset = function () {
    this.d = '';
    this._mdf = false;
  };

  function DashProperty(elem, data, renderer, container) {
    this.elem = elem;
    this.frameId = -1;
    this.dataProps = createSizedArray(data.length);
    this.renderer = renderer;
    this.k = false;
    this.dashStr = '';
    this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
    this.dashoffset = createTypedArray('float32', 1);
    this.initDynamicPropertyContainer(container);
    var i;
    var len = data.length || 0;
    var prop;
    for (i = 0; i < len; i += 1) {
      prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
      this.k = prop.k || this.k;
      this.dataProps[i] = {
        n: data[i].n,
        p: prop
      };
    }
    if (!this.k) {
      this.getValue(true);
    }
    this._isAnimated = this.k;
  }
  DashProperty.prototype.getValue = function (forceRender) {
    if (this.elem.globalData.frameId === this.frameId && !forceRender) {
      return;
    }
    this.frameId = this.elem.globalData.frameId;
    this.iterateDynamicProperties();
    this._mdf = this._mdf || forceRender;
    if (this._mdf) {
      var i = 0;
      var len = this.dataProps.length;
      if (this.renderer === 'svg') {
        this.dashStr = '';
      }
      for (i = 0; i < len; i += 1) {
        if (this.dataProps[i].n !== 'o') {
          if (this.renderer === 'svg') {
            this.dashStr += ' ' + this.dataProps[i].p.v;
          } else {
            this.dashArray[i] = this.dataProps[i].p.v;
          }
        } else {
          this.dashoffset[0] = this.dataProps[i].p.v;
        }
      }
    }
  };
  extendPrototype([DynamicPropertyContainer], DashProperty);

  function SVGStrokeStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
    this.style = styleOb;
    this._isAnimated = !!this._isAnimated;
  }
  extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);

  function SVGFillStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
    this.style = styleOb;
  }
  extendPrototype([DynamicPropertyContainer], SVGFillStyleData);

  function SVGNoStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.style = styleOb;
  }
  extendPrototype([DynamicPropertyContainer], SVGNoStyleData);

  function GradientProperty(elem, data, container) {
    this.data = data;
    this.c = createTypedArray('uint8c', data.p * 4);
    var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
    this.o = createTypedArray('float32', cLength);
    this._cmdf = false;
    this._omdf = false;
    this._collapsable = this.checkCollapsable();
    this._hasOpacity = cLength;
    this.initDynamicPropertyContainer(container);
    this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
    this.k = this.prop.k;
    this.getValue(true);
  }
  GradientProperty.prototype.comparePoints = function (values, points) {
    var i = 0;
    var len = this.o.length / 2;
    var diff;
    while (i < len) {
      diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
      if (diff > 0.01) {
        return false;
      }
      i += 1;
    }
    return true;
  };
  GradientProperty.prototype.checkCollapsable = function () {
    if (this.o.length / 2 !== this.c.length / 4) {
      return false;
    }
    if (this.data.k.k[0].s) {
      var i = 0;
      var len = this.data.k.k.length;
      while (i < len) {
        if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
          return false;
        }
        i += 1;
      }
    } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
      return false;
    }
    return true;
  };
  GradientProperty.prototype.getValue = function (forceRender) {
    this.prop.getValue();
    this._mdf = false;
    this._cmdf = false;
    this._omdf = false;
    if (this.prop._mdf || forceRender) {
      var i;
      var len = this.data.p * 4;
      var mult;
      var val;
      for (i = 0; i < len; i += 1) {
        mult = i % 4 === 0 ? 100 : 255;
        val = Math.round(this.prop.v[i] * mult);
        if (this.c[i] !== val) {
          this.c[i] = val;
          this._cmdf = !forceRender;
        }
      }
      if (this.o.length) {
        len = this.prop.v.length;
        for (i = this.data.p * 4; i < len; i += 1) {
          mult = i % 2 === 0 ? 100 : 1;
          val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
          if (this.o[i - this.data.p * 4] !== val) {
            this.o[i - this.data.p * 4] = val;
            this._omdf = !forceRender;
          }
        }
      }
      this._mdf = !forceRender;
    }
  };
  extendPrototype([DynamicPropertyContainer], GradientProperty);

  function SVGGradientFillStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.initGradientData(elem, data, styleOb);
  }
  SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
    this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
    this.h = PropertyFactory.getProp(elem, data.h || {
      k: 0
    }, 0, 0.01, this);
    this.a = PropertyFactory.getProp(elem, data.a || {
      k: 0
    }, 0, degToRads, this);
    this.g = new GradientProperty(elem, data.g, this);
    this.style = styleOb;
    this.stops = [];
    this.setGradientData(styleOb.pElem, data);
    this.setGradientOpacity(data, styleOb);
    this._isAnimated = !!this._isAnimated;
  };
  SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
    var gradientId = createElementID();
    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
    gfill.setAttribute('id', gradientId);
    gfill.setAttribute('spreadMethod', 'pad');
    gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
    var stops = [];
    var stop;
    var j;
    var jLen;
    jLen = data.g.p * 4;
    for (j = 0; j < jLen; j += 4) {
      stop = createNS('stop');
      gfill.appendChild(stop);
      stops.push(stop);
    }
    pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
    this.gf = gfill;
    this.cst = stops;
  };
  SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
    if (this.g._hasOpacity && !this.g._collapsable) {
      var stop;
      var j;
      var jLen;
      var mask = createNS('mask');
      var maskElement = createNS('path');
      mask.appendChild(maskElement);
      var opacityId = createElementID();
      var maskId = createElementID();
      mask.setAttribute('id', maskId);
      var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
      opFill.setAttribute('id', opacityId);
      opFill.setAttribute('spreadMethod', 'pad');
      opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
      jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
      var stops = this.stops;
      for (j = data.g.p * 4; j < jLen; j += 2) {
        stop = createNS('stop');
        stop.setAttribute('stop-color', 'rgb(255,255,255)');
        opFill.appendChild(stop);
        stops.push(stop);
      }
      maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
      if (data.ty === 'gs') {
        maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
        maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
        if (data.lj === 1) {
          maskElement.setAttribute('stroke-miterlimit', data.ml);
        }
      }
      this.of = opFill;
      this.ms = mask;
      this.ost = stops;
      this.maskId = maskId;
      styleOb.msElem = maskElement;
    }
  };
  extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);

  function SVGGradientStrokeStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
    this.initGradientData(elem, data, styleOb);
    this._isAnimated = !!this._isAnimated;
  }
  extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);

  function ShapeGroupData() {
    this.it = [];
    this.prevViewData = [];
    this.gr = createNS('g');
  }

  function SVGTransformData(mProps, op, container) {
    this.transform = {
      mProps: mProps,
      op: op,
      container: container
    };
    this.elements = [];
    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
  }

  var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
    if (length === 0) {
      return '';
    }
    var _o = pathNodes.o;
    var _i = pathNodes.i;
    var _v = pathNodes.v;
    var i;
    var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
    for (i = 1; i < length; i += 1) {
      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
    }
    if (closed && length) {
      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
      shapeString += 'z';
    }
    return shapeString;
  };

  var SVGElementsRenderer = function () {
    var _identityMatrix = new Matrix();
    var _matrixHelper = new Matrix();
    var ob = {
      createRenderFunction: createRenderFunction
    };
    function createRenderFunction(data) {
      switch (data.ty) {
        case 'fl':
          return renderFill;
        case 'gf':
          return renderGradient;
        case 'gs':
          return renderGradientStroke;
        case 'st':
          return renderStroke;
        case 'sh':
        case 'el':
        case 'rc':
        case 'sr':
          return renderPath;
        case 'tr':
          return renderContentTransform;
        case 'no':
          return renderNoop;
        default:
          return null;
      }
    }
    function renderContentTransform(styleData, itemData, isFirstFrame) {
      if (isFirstFrame || itemData.transform.op._mdf) {
        itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
      }
      if (isFirstFrame || itemData.transform.mProps._mdf) {
        itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
      }
    }
    function renderNoop() {}
    function renderPath(styleData, itemData, isFirstFrame) {
      var j;
      var jLen;
      var pathStringTransformed;
      var redraw;
      var pathNodes;
      var l;
      var lLen = itemData.styles.length;
      var lvl = itemData.lvl;
      var paths;
      var mat;
      var iterations;
      var k;
      for (l = 0; l < lLen; l += 1) {
        redraw = itemData.sh._mdf || isFirstFrame;
        if (itemData.styles[l].lvl < lvl) {
          mat = _matrixHelper.reset();
          iterations = lvl - itemData.styles[l].lvl;
          k = itemData.transformers.length - 1;
          while (!redraw && iterations > 0) {
            redraw = itemData.transformers[k].mProps._mdf || redraw;
            iterations -= 1;
            k -= 1;
          }
          if (redraw) {
            iterations = lvl - itemData.styles[l].lvl;
            k = itemData.transformers.length - 1;
            while (iterations > 0) {
              mat.multiply(itemData.transformers[k].mProps.v);
              iterations -= 1;
              k -= 1;
            }
          }
        } else {
          mat = _identityMatrix;
        }
        paths = itemData.sh.paths;
        jLen = paths._length;
        if (redraw) {
          pathStringTransformed = '';
          for (j = 0; j < jLen; j += 1) {
            pathNodes = paths.shapes[j];
            if (pathNodes && pathNodes._length) {
              pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
            }
          }
          itemData.caches[l] = pathStringTransformed;
        } else {
          pathStringTransformed = itemData.caches[l];
        }
        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
      }
    }
    function renderFill(styleData, itemData, isFirstFrame) {
      var styleElem = itemData.style;
      if (itemData.c._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
      }
      if (itemData.o._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
      }
    }
    function renderGradientStroke(styleData, itemData, isFirstFrame) {
      renderGradient(styleData, itemData, isFirstFrame);
      renderStroke(styleData, itemData, isFirstFrame);
    }
    function renderGradient(styleData, itemData, isFirstFrame) {
      var gfill = itemData.gf;
      var hasOpacity = itemData.g._hasOpacity;
      var pt1 = itemData.s.v;
      var pt2 = itemData.e.v;
      if (itemData.o._mdf || isFirstFrame) {
        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
        itemData.style.pElem.setAttribute(attr, itemData.o.v);
      }
      if (itemData.s._mdf || isFirstFrame) {
        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
        gfill.setAttribute(attr1, pt1[0]);
        gfill.setAttribute(attr2, pt1[1]);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute(attr1, pt1[0]);
          itemData.of.setAttribute(attr2, pt1[1]);
        }
      }
      var stops;
      var i;
      var len;
      var stop;
      if (itemData.g._cmdf || isFirstFrame) {
        stops = itemData.cst;
        var cValues = itemData.g.c;
        len = stops.length;
        for (i = 0; i < len; i += 1) {
          stop = stops[i];
          stop.setAttribute('offset', cValues[i * 4] + '%');
          stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
        }
      }
      if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
        var oValues = itemData.g.o;
        if (itemData.g._collapsable) {
          stops = itemData.cst;
        } else {
          stops = itemData.ost;
        }
        len = stops.length;
        for (i = 0; i < len; i += 1) {
          stop = stops[i];
          if (!itemData.g._collapsable) {
            stop.setAttribute('offset', oValues[i * 2] + '%');
          }
          stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
        }
      }
      if (styleData.t === 1) {
        if (itemData.e._mdf || isFirstFrame) {
          gfill.setAttribute('x2', pt2[0]);
          gfill.setAttribute('y2', pt2[1]);
          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('x2', pt2[0]);
            itemData.of.setAttribute('y2', pt2[1]);
          }
        }
      } else {
        var rad;
        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
          gfill.setAttribute('r', rad);
          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('r', rad);
          }
        }
        if (itemData.s._mdf || itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
          if (!rad) {
            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
          }
          var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
          var percent = itemData.h.v;
          if (percent >= 1) {
            percent = 0.99;
          } else if (percent <= -1) {
            percent = -0.99;
          }
          var dist = rad * percent;
          var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
          var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
          gfill.setAttribute('fx', x);
          gfill.setAttribute('fy', y);
          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('fx', x);
            itemData.of.setAttribute('fy', y);
          }
        }
        // gfill.setAttribute('fy','200');
      }
    }
    function renderStroke(styleData, itemData, isFirstFrame) {
      var styleElem = itemData.style;
      var d = itemData.d;
      if (d && (d._mdf || isFirstFrame) && d.dashStr) {
        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
      }
      if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
        styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
      }
      if (itemData.o._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
      }
      if (itemData.w._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
        if (styleElem.msElem) {
          styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
        }
      }
    }
    return ob;
  }();

  function SVGShapeElement(data, globalData, comp) {
    // List of drawable elements
    this.shapes = [];
    // Full shape data
    this.shapesData = data.shapes;
    // List of styles that will be applied to shapes
    this.stylesList = [];
    // List of modifiers that will be applied to shapes
    this.shapeModifiers = [];
    // List of items in shape tree
    this.itemsData = [];
    // List of items in previous shape tree
    this.processedElements = [];
    // List of animated components
    this.animatedContents = [];
    this.initElement(data, globalData, comp);
    // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    // List of elements that have been created
    this.prevViewData = [];
    // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  }
  extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);
  SVGShapeElement.prototype.initSecondaryElement = function () {};
  SVGShapeElement.prototype.identityMatrix = new Matrix();
  SVGShapeElement.prototype.buildExpressionInterface = function () {};
  SVGShapeElement.prototype.createContent = function () {
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
    this.filterUniqueShapes();
  };

  /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */
  SVGShapeElement.prototype.filterUniqueShapes = function () {
    var i;
    var len = this.shapes.length;
    var shape;
    var j;
    var jLen = this.stylesList.length;
    var style;
    var tempShapes = [];
    var areAnimated = false;
    for (j = 0; j < jLen; j += 1) {
      style = this.stylesList[j];
      areAnimated = false;
      tempShapes.length = 0;
      for (i = 0; i < len; i += 1) {
        shape = this.shapes[i];
        if (shape.styles.indexOf(style) !== -1) {
          tempShapes.push(shape);
          areAnimated = shape._isAnimated || areAnimated;
        }
      }
      if (tempShapes.length > 1 && areAnimated) {
        this.setShapesAsAnimated(tempShapes);
      }
    }
  };
  SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
    var i;
    var len = shapes.length;
    for (i = 0; i < len; i += 1) {
      shapes[i].setAsAnimated();
    }
  };
  SVGShapeElement.prototype.createStyleElement = function (data, level) {
    // TODO: prevent drawing of hidden styles
    var elementData;
    var styleOb = new SVGStyleData(data, level);
    var pathElement = styleOb.pElem;
    if (data.ty === 'st') {
      elementData = new SVGStrokeStyleData(this, data, styleOb);
    } else if (data.ty === 'fl') {
      elementData = new SVGFillStyleData(this, data, styleOb);
    } else if (data.ty === 'gf' || data.ty === 'gs') {
      var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
      elementData = new GradientConstructor(this, data, styleOb);
      this.globalData.defs.appendChild(elementData.gf);
      if (elementData.maskId) {
        this.globalData.defs.appendChild(elementData.ms);
        this.globalData.defs.appendChild(elementData.of);
        pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
      }
    } else if (data.ty === 'no') {
      elementData = new SVGNoStyleData(this, data, styleOb);
    }
    if (data.ty === 'st' || data.ty === 'gs') {
      pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
      pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
      pathElement.setAttribute('fill-opacity', '0');
      if (data.lj === 1) {
        pathElement.setAttribute('stroke-miterlimit', data.ml);
      }
    }
    if (data.r === 2) {
      pathElement.setAttribute('fill-rule', 'evenodd');
    }
    if (data.ln) {
      pathElement.setAttribute('id', data.ln);
    }
    if (data.cl) {
      pathElement.setAttribute('class', data.cl);
    }
    if (data.bm) {
      pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
    }
    this.stylesList.push(styleOb);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };
  SVGShapeElement.prototype.createGroupElement = function (data) {
    var elementData = new ShapeGroupData();
    if (data.ln) {
      elementData.gr.setAttribute('id', data.ln);
    }
    if (data.cl) {
      elementData.gr.setAttribute('class', data.cl);
    }
    if (data.bm) {
      elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
    }
    return elementData;
  };
  SVGShapeElement.prototype.createTransformElement = function (data, container) {
    var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };
  SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
    var ty = 4;
    if (data.ty === 'rc') {
      ty = 5;
    } else if (data.ty === 'el') {
      ty = 6;
    } else if (data.ty === 'sr') {
      ty = 7;
    }
    var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
    this.shapes.push(elementData);
    this.addShapeToModifiers(elementData);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };
  SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
    var i = 0;
    var len = this.animatedContents.length;
    while (i < len) {
      if (this.animatedContents[i].element === element) {
        return;
      }
      i += 1;
    }
    this.animatedContents.push({
      fn: SVGElementsRenderer.createRenderFunction(data),
      element: element,
      data: data
    });
  };
  SVGShapeElement.prototype.setElementStyles = function (elementData) {
    var arr = elementData.styles;
    var j;
    var jLen = this.stylesList.length;
    for (j = 0; j < jLen; j += 1) {
      if (arr.indexOf(this.stylesList[j]) === -1 && !this.stylesList[j].closed) {
        arr.push(this.stylesList[j]);
      }
    }
  };
  SVGShapeElement.prototype.reloadShapes = function () {
    this._isFirstFrame = true;
    var i;
    var len = this.itemsData.length;
    for (i = 0; i < len; i += 1) {
      this.prevViewData[i] = this.itemsData[i];
    }
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
    this.filterUniqueShapes();
    len = this.dynamicProperties.length;
    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
    }
    this.renderModifiers();
  };
  SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
    var ownTransformers = [].concat(transformers);
    var i;
    var len = arr.length - 1;
    var j;
    var jLen;
    var ownStyles = [];
    var ownModifiers = [];
    var currentTransform;
    var modifier;
    var processedPos;
    for (i = len; i >= 0; i -= 1) {
      processedPos = this.searchProcessedElement(arr[i]);
      if (!processedPos) {
        arr[i]._render = render;
      } else {
        itemsData[i] = prevViewData[processedPos - 1];
      }
      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
        if (!processedPos) {
          itemsData[i] = this.createStyleElement(arr[i], level);
        } else {
          itemsData[i].style.closed = arr[i].hd;
        }
        if (arr[i]._render) {
          if (itemsData[i].style.pElem.parentNode !== container) {
            container.appendChild(itemsData[i].style.pElem);
          }
        }
        ownStyles.push(itemsData[i].style);
      } else if (arr[i].ty === 'gr') {
        if (!processedPos) {
          itemsData[i] = this.createGroupElement(arr[i]);
        } else {
          jLen = itemsData[i].it.length;
          for (j = 0; j < jLen; j += 1) {
            itemsData[i].prevViewData[j] = itemsData[i].it[j];
          }
        }
        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
        if (arr[i]._render) {
          if (itemsData[i].gr.parentNode !== container) {
            container.appendChild(itemsData[i].gr);
          }
        }
      } else if (arr[i].ty === 'tr') {
        if (!processedPos) {
          itemsData[i] = this.createTransformElement(arr[i], container);
        }
        currentTransform = itemsData[i].transform;
        ownTransformers.push(currentTransform);
      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
        if (!processedPos) {
          itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
        }
        this.setElementStyles(itemsData[i]);
      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          modifier.init(this, arr[i]);
          itemsData[i] = modifier;
          this.shapeModifiers.push(modifier);
        } else {
          modifier = itemsData[i];
          modifier.closed = false;
        }
        ownModifiers.push(modifier);
      } else if (arr[i].ty === 'rp') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          itemsData[i] = modifier;
          modifier.init(this, arr, i, itemsData);
          this.shapeModifiers.push(modifier);
          render = false;
        } else {
          modifier = itemsData[i];
          modifier.closed = true;
        }
        ownModifiers.push(modifier);
      }
      this.addProcessedElement(arr[i], i + 1);
    }
    len = ownStyles.length;
    for (i = 0; i < len; i += 1) {
      ownStyles[i].closed = true;
    }
    len = ownModifiers.length;
    for (i = 0; i < len; i += 1) {
      ownModifiers[i].closed = true;
    }
  };
  SVGShapeElement.prototype.renderInnerContent = function () {
    this.renderModifiers();
    var i;
    var len = this.stylesList.length;
    for (i = 0; i < len; i += 1) {
      this.stylesList[i].reset();
    }
    this.renderShape();
    for (i = 0; i < len; i += 1) {
      if (this.stylesList[i]._mdf || this._isFirstFrame) {
        if (this.stylesList[i].msElem) {
          this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
          // Adding M0 0 fixes same mask bug on all browsers
          this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
        }
        this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
      }
    }
  };
  SVGShapeElement.prototype.renderShape = function () {
    var i;
    var len = this.animatedContents.length;
    var animatedContent;
    for (i = 0; i < len; i += 1) {
      animatedContent = this.animatedContents[i];
      if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
        animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
      }
    }
  };
  SVGShapeElement.prototype.destroy = function () {
    this.destroyBaseElement();
    this.shapesData = null;
    this.itemsData = null;
  };

  function LetterProps(o, sw, sc, fc, m, p) {
    this.o = o;
    this.sw = sw;
    this.sc = sc;
    this.fc = fc;
    this.m = m;
    this.p = p;
    this._mdf = {
      o: true,
      sw: !!sw,
      sc: !!sc,
      fc: !!fc,
      m: true,
      p: true
    };
  }
  LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
    this._mdf.o = false;
    this._mdf.sw = false;
    this._mdf.sc = false;
    this._mdf.fc = false;
    this._mdf.m = false;
    this._mdf.p = false;
    var updated = false;
    if (this.o !== o) {
      this.o = o;
      this._mdf.o = true;
      updated = true;
    }
    if (this.sw !== sw) {
      this.sw = sw;
      this._mdf.sw = true;
      updated = true;
    }
    if (this.sc !== sc) {
      this.sc = sc;
      this._mdf.sc = true;
      updated = true;
    }
    if (this.fc !== fc) {
      this.fc = fc;
      this._mdf.fc = true;
      updated = true;
    }
    if (this.m !== m) {
      this.m = m;
      this._mdf.m = true;
      updated = true;
    }
    if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
      this.p = p;
      this._mdf.p = true;
      updated = true;
    }
    return updated;
  };

  function TextProperty(elem, data) {
    this._frameId = initialDefaultFrame;
    this.pv = '';
    this.v = '';
    this.kf = false;
    this._isFirstFrame = true;
    this._mdf = false;
    if (data.d && data.d.sid) {
      data.d = elem.globalData.slotManager.getProp(data.d);
    }
    this.data = data;
    this.elem = elem;
    this.comp = this.elem.comp;
    this.keysIndex = 0;
    this.canResize = false;
    this.minimumFontSize = 1;
    this.effectsSequence = [];
    this.currentData = {
      ascent: 0,
      boxWidth: this.defaultBoxWidth,
      f: '',
      fStyle: '',
      fWeight: '',
      fc: '',
      j: '',
      justifyOffset: '',
      l: [],
      lh: 0,
      lineWidths: [],
      ls: '',
      of: '',
      s: '',
      sc: '',
      sw: 0,
      t: 0,
      tr: 0,
      sz: 0,
      ps: null,
      fillColorAnim: false,
      strokeColorAnim: false,
      strokeWidthAnim: false,
      yOffset: 0,
      finalSize: 0,
      finalText: [],
      finalLineHeight: 0,
      __complete: false
    };
    this.copyData(this.currentData, this.data.d.k[0].s);
    if (!this.searchProperty()) {
      this.completeTextData(this.currentData);
    }
  }
  TextProperty.prototype.defaultBoxWidth = [0, 0];
  TextProperty.prototype.copyData = function (obj, data) {
    for (var s in data) {
      if (Object.prototype.hasOwnProperty.call(data, s)) {
        obj[s] = data[s];
      }
    }
    return obj;
  };
  TextProperty.prototype.setCurrentData = function (data) {
    if (!data.__complete) {
      this.completeTextData(data);
    }
    this.currentData = data;
    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
    this._mdf = true;
  };
  TextProperty.prototype.searchProperty = function () {
    return this.searchKeyframes();
  };
  TextProperty.prototype.searchKeyframes = function () {
    this.kf = this.data.d.k.length > 1;
    if (this.kf) {
      this.addEffect(this.getKeyframeValue.bind(this));
    }
    return this.kf;
  };
  TextProperty.prototype.addEffect = function (effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.elem.addDynamicProperty(this);
  };
  TextProperty.prototype.getValue = function (_finalValue) {
    if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
      return;
    }
    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
    var currentValue = this.currentData;
    var currentIndex = this.keysIndex;
    if (this.lock) {
      this.setCurrentData(this.currentData);
      return;
    }
    this.lock = true;
    this._mdf = false;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
    for (i = 0; i < len; i += 1) {
      // Checking if index changed to prevent creating a new object every time the expression updates.
      if (currentIndex !== this.keysIndex) {
        finalValue = this.effectsSequence[i](finalValue, finalValue.t);
      } else {
        finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
      }
    }
    if (currentValue !== finalValue) {
      this.setCurrentData(finalValue);
    }
    this.v = this.currentData;
    this.pv = this.v;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  };
  TextProperty.prototype.getKeyframeValue = function () {
    var textKeys = this.data.d.k;
    var frameNum = this.elem.comp.renderedFrame;
    var i = 0;
    var len = textKeys.length;
    while (i <= len - 1) {
      if (i === len - 1 || textKeys[i + 1].t > frameNum) {
        break;
      }
      i += 1;
    }
    if (this.keysIndex !== i) {
      this.keysIndex = i;
    }
    return this.data.d.k[this.keysIndex].s;
  };
  TextProperty.prototype.buildFinalText = function (text) {
    var charactersArray = [];
    var i = 0;
    var len = text.length;
    var charCode;
    var secondCharCode;
    var shouldCombine = false;
    var shouldCombineNext = false;
    var currentChars = '';
    while (i < len) {
      shouldCombine = shouldCombineNext;
      shouldCombineNext = false;
      charCode = text.charCodeAt(i);
      currentChars = text.charAt(i);
      if (FontManager.isCombinedCharacter(charCode)) {
        shouldCombine = true;
        // It's a potential surrogate pair (this is the High surrogate)
      } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        if (FontManager.isRegionalFlag(text, i)) {
          currentChars = text.substr(i, 14);
        } else {
          secondCharCode = text.charCodeAt(i + 1);
          // It's a surrogate pair (this is the Low surrogate)
          if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
            if (FontManager.isModifier(charCode, secondCharCode)) {
              currentChars = text.substr(i, 2);
              shouldCombine = true;
            } else if (FontManager.isFlagEmoji(text.substr(i, 4))) {
              currentChars = text.substr(i, 4);
            } else {
              currentChars = text.substr(i, 2);
            }
          }
        }
      } else if (charCode > 0xDBFF) {
        secondCharCode = text.charCodeAt(i + 1);
        if (FontManager.isVariationSelector(charCode)) {
          shouldCombine = true;
        }
      } else if (FontManager.isZeroWidthJoiner(charCode)) {
        shouldCombine = true;
        shouldCombineNext = true;
      }
      if (shouldCombine) {
        charactersArray[charactersArray.length - 1] += currentChars;
        shouldCombine = false;
      } else {
        charactersArray.push(currentChars);
      }
      i += currentChars.length;
    }
    return charactersArray;
  };
  TextProperty.prototype.completeTextData = function (documentData) {
    documentData.__complete = true;
    var fontManager = this.elem.globalData.fontManager;
    var data = this.data;
    var letters = [];
    var i;
    var len;
    var newLineFlag;
    var index = 0;
    var val;
    var anchorGrouping = data.m.g;
    var currentSize = 0;
    var currentPos = 0;
    var currentLine = 0;
    var lineWidths = [];
    var lineWidth = 0;
    var maxLineWidth = 0;
    var j;
    var jLen;
    var fontData = fontManager.getFontByName(documentData.f);
    var charData;
    var cLength = 0;
    var fontProps = getFontProperties(fontData);
    documentData.fWeight = fontProps.weight;
    documentData.fStyle = fontProps.style;
    documentData.finalSize = documentData.s;
    documentData.finalText = this.buildFinalText(documentData.t);
    len = documentData.finalText.length;
    documentData.finalLineHeight = documentData.lh;
    var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
    var charCode;
    if (documentData.sz) {
      var flag = true;
      var boxWidth = documentData.sz[0];
      var boxHeight = documentData.sz[1];
      var currentHeight;
      var finalText;
      while (flag) {
        finalText = this.buildFinalText(documentData.t);
        currentHeight = 0;
        lineWidth = 0;
        len = finalText.length;
        trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var lastSpaceIndex = -1;
        for (i = 0; i < len; i += 1) {
          charCode = finalText[i].charCodeAt(0);
          newLineFlag = false;
          if (finalText[i] === ' ') {
            lastSpaceIndex = i;
          } else if (charCode === 13 || charCode === 3) {
            lineWidth = 0;
            newLineFlag = true;
            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
          }
          if (fontManager.chars) {
            charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
            cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
          } else {
            // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
            cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
          }
          if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
            if (lastSpaceIndex === -1) {
              len += 1;
            } else {
              i = lastSpaceIndex;
            }
            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
            finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r');
            // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
            lastSpaceIndex = -1;
            lineWidth = 0;
          } else {
            lineWidth += cLength;
            lineWidth += trackingOffset;
          }
        }
        currentHeight += fontData.ascent * documentData.finalSize / 100;
        if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
          documentData.finalSize -= 1;
          documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
        } else {
          documentData.finalText = finalText;
          len = documentData.finalText.length;
          flag = false;
        }
      }
    }
    lineWidth = -trackingOffset;
    cLength = 0;
    var uncollapsedSpaces = 0;
    var currentChar;
    for (i = 0; i < len; i += 1) {
      newLineFlag = false;
      currentChar = documentData.finalText[i];
      charCode = currentChar.charCodeAt(0);
      if (charCode === 13 || charCode === 3) {
        uncollapsedSpaces = 0;
        lineWidths.push(lineWidth);
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidth = -2 * trackingOffset;
        val = '';
        newLineFlag = true;
        currentLine += 1;
      } else {
        val = currentChar;
      }
      if (fontManager.chars) {
        charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
      } else {
        // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
        // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
        cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
      }

      //
      if (currentChar === ' ') {
        uncollapsedSpaces += cLength + trackingOffset;
      } else {
        lineWidth += cLength + trackingOffset + uncollapsedSpaces;
        uncollapsedSpaces = 0;
      }
      letters.push({
        l: cLength,
        an: cLength,
        add: currentSize,
        n: newLineFlag,
        anIndexes: [],
        val: val,
        line: currentLine,
        animatorJustifyOffset: 0
      });
      if (anchorGrouping == 2) {
        // eslint-disable-line eqeqeq
        currentSize += cLength;
        if (val === '' || val === ' ' || i === len - 1) {
          if (val === '' || val === ' ') {
            currentSize -= cLength;
          }
          while (currentPos <= i) {
            letters[currentPos].an = currentSize;
            letters[currentPos].ind = index;
            letters[currentPos].extra = cLength;
            currentPos += 1;
          }
          index += 1;
          currentSize = 0;
        }
      } else if (anchorGrouping == 3) {
        // eslint-disable-line eqeqeq
        currentSize += cLength;
        if (val === '' || i === len - 1) {
          if (val === '') {
            currentSize -= cLength;
          }
          while (currentPos <= i) {
            letters[currentPos].an = currentSize;
            letters[currentPos].ind = index;
            letters[currentPos].extra = cLength;
            currentPos += 1;
          }
          currentSize = 0;
          index += 1;
        }
      } else {
        letters[index].ind = index;
        letters[index].extra = 0;
        index += 1;
      }
    }
    documentData.l = letters;
    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
    lineWidths.push(lineWidth);
    if (documentData.sz) {
      documentData.boxWidth = documentData.sz[0];
      documentData.justifyOffset = 0;
    } else {
      documentData.boxWidth = maxLineWidth;
      switch (documentData.j) {
        case 1:
          documentData.justifyOffset = -documentData.boxWidth;
          break;
        case 2:
          documentData.justifyOffset = -documentData.boxWidth / 2;
          break;
        default:
          documentData.justifyOffset = 0;
      }
    }
    documentData.lineWidths = lineWidths;
    var animators = data.a;
    var animatorData;
    var letterData;
    jLen = animators.length;
    var based;
    var ind;
    var indexes = [];
    for (j = 0; j < jLen; j += 1) {
      animatorData = animators[j];
      if (animatorData.a.sc) {
        documentData.strokeColorAnim = true;
      }
      if (animatorData.a.sw) {
        documentData.strokeWidthAnim = true;
      }
      if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
        documentData.fillColorAnim = true;
      }
      ind = 0;
      based = animatorData.s.b;
      for (i = 0; i < len; i += 1) {
        letterData = letters[i];
        letterData.anIndexes[j] = ind;
        if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
          // eslint-disable-line eqeqeq
          if (animatorData.s.rn === 1) {
            indexes.push(ind);
          }
          ind += 1;
        }
      }
      data.a[j].s.totalChars = ind;
      var currentInd = -1;
      var newInd;
      if (animatorData.s.rn === 1) {
        for (i = 0; i < len; i += 1) {
          letterData = letters[i];
          if (currentInd != letterData.anIndexes[j]) {
            // eslint-disable-line eqeqeq
            currentInd = letterData.anIndexes[j];
            newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
          }
          letterData.anIndexes[j] = newInd;
        }
      }
    }
    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
    documentData.ls = documentData.ls || 0;
    documentData.ascent = fontData.ascent * documentData.finalSize / 100;
  };
  TextProperty.prototype.updateDocumentData = function (newData, index) {
    index = index === undefined ? this.keysIndex : index;
    var dData = this.copyData({}, this.data.d.k[index].s);
    dData = this.copyData(dData, newData);
    this.data.d.k[index].s = dData;
    this.recalculate(index);
    this.setCurrentData(dData);
    this.elem.addDynamicProperty(this);
  };
  TextProperty.prototype.recalculate = function (index) {
    var dData = this.data.d.k[index].s;
    dData.__complete = false;
    this.keysIndex = 0;
    this._isFirstFrame = true;
    this.getValue(dData);
  };
  TextProperty.prototype.canResizeFont = function (_canResize) {
    this.canResize = _canResize;
    this.recalculate(this.keysIndex);
    this.elem.addDynamicProperty(this);
  };
  TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
    this.minimumFontSize = Math.floor(_fontValue) || 1;
    this.recalculate(this.keysIndex);
    this.elem.addDynamicProperty(this);
  };

  var TextSelectorProp = function () {
    var max = Math.max;
    var min = Math.min;
    var floor = Math.floor;
    function TextSelectorPropFactory(elem, data) {
      this._currentTextLength = -1;
      this.k = false;
      this.data = data;
      this.elem = elem;
      this.comp = elem.comp;
      this.finalS = 0;
      this.finalE = 0;
      this.initDynamicPropertyContainer(elem);
      this.s = PropertyFactory.getProp(elem, data.s || {
        k: 0
      }, 0, 0, this);
      if ('e' in data) {
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
      } else {
        this.e = {
          v: 100
        };
      }
      this.o = PropertyFactory.getProp(elem, data.o || {
        k: 0
      }, 0, 0, this);
      this.xe = PropertyFactory.getProp(elem, data.xe || {
        k: 0
      }, 0, 0, this);
      this.ne = PropertyFactory.getProp(elem, data.ne || {
        k: 0
      }, 0, 0, this);
      this.sm = PropertyFactory.getProp(elem, data.sm || {
        k: 100
      }, 0, 0, this);
      this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
      if (!this.dynamicProperties.length) {
        this.getValue();
      }
    }
    TextSelectorPropFactory.prototype = {
      getMult: function getMult(ind) {
        if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
          this.getValue();
        }
        var x1 = 0;
        var y1 = 0;
        var x2 = 1;
        var y2 = 1;
        if (this.ne.v > 0) {
          x1 = this.ne.v / 100.0;
        } else {
          y1 = -this.ne.v / 100.0;
        }
        if (this.xe.v > 0) {
          x2 = 1.0 - this.xe.v / 100.0;
        } else {
          y2 = 1.0 + this.xe.v / 100.0;
        }
        var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
        var mult = 0;
        var s = this.finalS;
        var e = this.finalE;
        var type = this.data.sh;
        if (type === 2) {
          if (e === s) {
            mult = ind >= e ? 1 : 0;
          } else {
            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          }
          mult = easer(mult);
        } else if (type === 3) {
          if (e === s) {
            mult = ind >= e ? 0 : 1;
          } else {
            mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          }
          mult = easer(mult);
        } else if (type === 4) {
          if (e === s) {
            mult = 0;
          } else {
            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
            if (mult < 0.5) {
              mult *= 2;
            } else {
              mult = 1 - 2 * (mult - 0.5);
            }
          }
          mult = easer(mult);
        } else if (type === 5) {
          if (e === s) {
            mult = 0;
          } else {
            var tot = e - s;
            /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */
            ind = min(max(0, ind + 0.5 - s), e - s);
            var x = -tot / 2 + ind;
            var a = tot / 2;
            mult = Math.sqrt(1 - x * x / (a * a));
          }
          mult = easer(mult);
        } else if (type === 6) {
          if (e === s) {
            mult = 0;
          } else {
            ind = min(max(0, ind + 0.5 - s), e - s);
            mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
          }
          mult = easer(mult);
        } else {
          if (ind >= floor(s)) {
            if (ind - s < 0) {
              mult = max(0, min(min(e, 1) - (s - ind), 1));
            } else {
              mult = max(0, min(e - ind, 1));
            }
          }
          mult = easer(mult);
        }
        // Smoothness implementation.
        // The smoothness represents a reduced range of the original [0; 1] range.
        // if smoothness is 25%, the new range will be [0.375; 0.625]
        // Steps are:
        // - find the lower value of the new range (threshold)
        // - if multiplier is smaller than that value, floor it to 0
        // - if it is larger,
        //     - subtract the threshold
        //     - divide it by the smoothness (this will return the range to [0; 1])
        // Note: If it doesn't work on some scenarios, consider applying it before the easer.
        if (this.sm.v !== 100) {
          var smoothness = this.sm.v * 0.01;
          if (smoothness === 0) {
            smoothness = 0.00000001;
          }
          var threshold = 0.5 - smoothness * 0.5;
          if (mult < threshold) {
            mult = 0;
          } else {
            mult = (mult - threshold) / smoothness;
            if (mult > 1) {
              mult = 1;
            }
          }
        }
        return mult * this.a.v;
      },
      getValue: function getValue(newCharsFlag) {
        this.iterateDynamicProperties();
        this._mdf = newCharsFlag || this._mdf;
        this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
        if (newCharsFlag && this.data.r === 2) {
          this.e.v = this._currentTextLength;
        }
        var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
        var o = this.o.v / divisor;
        var s = this.s.v / divisor + o;
        var e = this.e.v / divisor + o;
        if (s > e) {
          var _s = s;
          s = e;
          e = _s;
        }
        this.finalS = s;
        this.finalE = e;
      }
    };
    extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);
    function getTextSelectorProp(elem, data, arr) {
      return new TextSelectorPropFactory(elem, data, arr);
    }
    return {
      getTextSelectorProp: getTextSelectorProp
    };
  }();

  function TextAnimatorDataProperty(elem, animatorProps, container) {
    var defaultData = {
      propType: false
    };
    var getProp = PropertyFactory.getProp;
    var textAnimatorAnimatables = animatorProps.a;
    this.a = {
      r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
      rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
      ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
      sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
      sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
      s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
      a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
      o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
      p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
      sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
      sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
      fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
      fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
      fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
      fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
      t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
    };
    this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
    this.s.t = animatorProps.s.t;
  }

  function TextAnimatorProperty(textData, renderType, elem) {
    this._isFirstFrame = true;
    this._hasMaskedPath = false;
    this._frameId = -1;
    this._textData = textData;
    this._renderType = renderType;
    this._elem = elem;
    this._animatorsData = createSizedArray(this._textData.a.length);
    this._pathData = {};
    this._moreOptions = {
      alignment: {}
    };
    this.renderedLetters = [];
    this.lettersChangedFlag = false;
    this.initDynamicPropertyContainer(elem);
  }
  TextAnimatorProperty.prototype.searchProperties = function () {
    var i;
    var len = this._textData.a.length;
    var animatorProps;
    var getProp = PropertyFactory.getProp;
    for (i = 0; i < len; i += 1) {
      animatorProps = this._textData.a[i];
      this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
    }
    if (this._textData.p && 'm' in this._textData.p) {
      this._pathData = {
        a: getProp(this._elem, this._textData.p.a, 0, 0, this),
        f: getProp(this._elem, this._textData.p.f, 0, 0, this),
        l: getProp(this._elem, this._textData.p.l, 0, 0, this),
        r: getProp(this._elem, this._textData.p.r, 0, 0, this),
        p: getProp(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      };
      this._hasMaskedPath = true;
    } else {
      this._hasMaskedPath = false;
    }
    this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
  };
  TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
    this.lettersChangedFlag = lettersChangedFlag;
    if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
      return;
    }
    this._isFirstFrame = false;
    var alignment = this._moreOptions.alignment.v;
    var animators = this._animatorsData;
    var textData = this._textData;
    var matrixHelper = this.mHelper;
    var renderType = this._renderType;
    var renderedLettersCount = this.renderedLetters.length;
    var xPos;
    var yPos;
    var i;
    var len;
    var letters = documentData.l;
    var pathInfo;
    var currentLength;
    var currentPoint;
    var segmentLength;
    var flag;
    var pointInd;
    var segmentInd;
    var prevPoint;
    var points;
    var segments;
    var partialLength;
    var totalLength;
    var perc;
    var tanAngle;
    var mask;
    if (this._hasMaskedPath) {
      mask = this._pathData.m;
      if (!this._pathData.n || this._pathData._mdf) {
        var paths = mask.v;
        if (this._pathData.r.v) {
          paths = paths.reverse();
        }
        // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
        pathInfo = {
          tLength: 0,
          segments: []
        };
        len = paths._length - 1;
        var bezierData;
        totalLength = 0;
        for (i = 0; i < len; i += 1) {
          bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
          pathInfo.tLength += bezierData.segmentLength;
          pathInfo.segments.push(bezierData);
          totalLength += bezierData.segmentLength;
        }
        i = len;
        if (mask.v.c) {
          bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
          pathInfo.tLength += bezierData.segmentLength;
          pathInfo.segments.push(bezierData);
          totalLength += bezierData.segmentLength;
        }
        this._pathData.pi = pathInfo;
      }
      pathInfo = this._pathData.pi;
      currentLength = this._pathData.f.v;
      segmentInd = 0;
      pointInd = 1;
      segmentLength = 0;
      flag = true;
      segments = pathInfo.segments;
      if (currentLength < 0 && mask.v.c) {
        if (pathInfo.tLength < Math.abs(currentLength)) {
          currentLength = -Math.abs(currentLength) % pathInfo.tLength;
        }
        segmentInd = segments.length - 1;
        points = segments[segmentInd].points;
        pointInd = points.length - 1;
        while (currentLength < 0) {
          currentLength += points[pointInd].partialLength;
          pointInd -= 1;
          if (pointInd < 0) {
            segmentInd -= 1;
            points = segments[segmentInd].points;
            pointInd = points.length - 1;
          }
        }
      }
      points = segments[segmentInd].points;
      prevPoint = points[pointInd - 1];
      currentPoint = points[pointInd];
      partialLength = currentPoint.partialLength;
    }
    len = letters.length;
    xPos = 0;
    yPos = 0;
    var yOff = documentData.finalSize * 1.2 * 0.714;
    var firstLine = true;
    var animatorProps;
    var animatorSelector;
    var j;
    var jLen;
    var letterValue;
    jLen = animators.length;
    var mult;
    var ind = -1;
    var offf;
    var xPathPos;
    var yPathPos;
    var initPathPos = currentLength;
    var initSegmentInd = segmentInd;
    var initPointInd = pointInd;
    var currentLine = -1;
    var elemOpacity;
    var sc;
    var sw;
    var fc;
    var k;
    var letterSw;
    var letterSc;
    var letterFc;
    var letterM = '';
    var letterP = this.defaultPropsArray;
    var letterO;

    //
    if (documentData.j === 2 || documentData.j === 1) {
      var animatorJustifyOffset = 0;
      var animatorFirstCharOffset = 0;
      var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
      var lastIndex = 0;
      var isNewLine = true;
      for (i = 0; i < len; i += 1) {
        if (letters[i].n) {
          if (animatorJustifyOffset) {
            animatorJustifyOffset += animatorFirstCharOffset;
          }
          while (lastIndex < i) {
            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
            lastIndex += 1;
          }
          animatorJustifyOffset = 0;
          isNewLine = true;
        } else {
          for (j = 0; j < jLen; j += 1) {
            animatorProps = animators[j].a;
            if (animatorProps.t.propType) {
              if (isNewLine && documentData.j === 2) {
                animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
              }
              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
              if (mult.length) {
                animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
              } else {
                animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
              }
            }
          }
          isNewLine = false;
        }
      }
      if (animatorJustifyOffset) {
        animatorJustifyOffset += animatorFirstCharOffset;
      }
      while (lastIndex < i) {
        letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
        lastIndex += 1;
      }
    }
    //

    for (i = 0; i < len; i += 1) {
      matrixHelper.reset();
      elemOpacity = 1;
      if (letters[i].n) {
        xPos = 0;
        yPos += documentData.yOffset;
        yPos += firstLine ? 1 : 0;
        currentLength = initPathPos;
        firstLine = false;
        if (this._hasMaskedPath) {
          segmentInd = initSegmentInd;
          pointInd = initPointInd;
          points = segments[segmentInd].points;
          prevPoint = points[pointInd - 1];
          currentPoint = points[pointInd];
          partialLength = currentPoint.partialLength;
          segmentLength = 0;
        }
        letterM = '';
        letterFc = '';
        letterSw = '';
        letterO = '';
        letterP = this.defaultPropsArray;
      } else {
        if (this._hasMaskedPath) {
          if (currentLine !== letters[i].line) {
            switch (documentData.j) {
              case 1:
                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                break;
              case 2:
                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                break;
              default:
                break;
            }
            currentLine = letters[i].line;
          }
          if (ind !== letters[i].ind) {
            if (letters[ind]) {
              currentLength += letters[ind].extra;
            }
            currentLength += letters[i].an / 2;
            ind = letters[i].ind;
          }
          currentLength += alignment[0] * letters[i].an * 0.005;
          var animatorOffset = 0;
          for (j = 0; j < jLen; j += 1) {
            animatorProps = animators[j].a;
            if (animatorProps.p.propType) {
              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
              if (mult.length) {
                animatorOffset += animatorProps.p.v[0] * mult[0];
              } else {
                animatorOffset += animatorProps.p.v[0] * mult;
              }
            }
            if (animatorProps.a.propType) {
              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
              if (mult.length) {
                animatorOffset += animatorProps.a.v[0] * mult[0];
              } else {
                animatorOffset += animatorProps.a.v[0] * mult;
              }
            }
          }
          flag = true;
          // Force alignment only works with a single line for now
          if (this._pathData.a.v) {
            currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
            currentLength += this._pathData.f.v;
          }
          while (flag) {
            if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
              perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
              xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
              yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
              matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
              flag = false;
            } else if (points) {
              segmentLength += currentPoint.partialLength;
              pointInd += 1;
              if (pointInd >= points.length) {
                pointInd = 0;
                segmentInd += 1;
                if (!segments[segmentInd]) {
                  if (mask.v.c) {
                    pointInd = 0;
                    segmentInd = 0;
                    points = segments[segmentInd].points;
                  } else {
                    segmentLength -= currentPoint.partialLength;
                    points = null;
                  }
                } else {
                  points = segments[segmentInd].points;
                }
              }
              if (points) {
                prevPoint = currentPoint;
                currentPoint = points[pointInd];
                partialLength = currentPoint.partialLength;
              }
            }
          }
          offf = letters[i].an / 2 - letters[i].add;
          matrixHelper.translate(-offf, 0, 0);
        } else {
          offf = letters[i].an / 2 - letters[i].add;
          matrixHelper.translate(-offf, 0, 0);

          // Grouping alignment
          matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
        }
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.t.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
            if (xPos !== 0 || documentData.j !== 0) {
              if (this._hasMaskedPath) {
                if (mult.length) {
                  currentLength += animatorProps.t.v * mult[0];
                } else {
                  currentLength += animatorProps.t.v * mult;
                }
              } else if (mult.length) {
                xPos += animatorProps.t.v * mult[0];
              } else {
                xPos += animatorProps.t.v * mult;
              }
            }
          }
        }
        if (documentData.strokeWidthAnim) {
          sw = documentData.sw || 0;
        }
        if (documentData.strokeColorAnim) {
          if (documentData.sc) {
            sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
          } else {
            sc = [0, 0, 0];
          }
        }
        if (documentData.fillColorAnim && documentData.fc) {
          fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
        }
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.a.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
            } else {
              matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
            }
          }
        }
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.s.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
            } else {
              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
            }
          }
        }
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          if (animatorProps.sk.propType) {
            if (mult.length) {
              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
            } else {
              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
            }
          }
          if (animatorProps.r.propType) {
            if (mult.length) {
              matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
            } else {
              matrixHelper.rotateZ(-animatorProps.r.v * mult);
            }
          }
          if (animatorProps.ry.propType) {
            if (mult.length) {
              matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
            } else {
              matrixHelper.rotateY(animatorProps.ry.v * mult);
            }
          }
          if (animatorProps.rx.propType) {
            if (mult.length) {
              matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
            } else {
              matrixHelper.rotateX(animatorProps.rx.v * mult);
            }
          }
          if (animatorProps.o.propType) {
            if (mult.length) {
              elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
            } else {
              elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
            }
          }
          if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
            if (mult.length) {
              sw += animatorProps.sw.v * mult[0];
            } else {
              sw += animatorProps.sw.v * mult;
            }
          }
          if (documentData.strokeColorAnim && animatorProps.sc.propType) {
            for (k = 0; k < 3; k += 1) {
              if (mult.length) {
                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
              } else {
                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
              }
            }
          }
          if (documentData.fillColorAnim && documentData.fc) {
            if (animatorProps.fc.propType) {
              for (k = 0; k < 3; k += 1) {
                if (mult.length) {
                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                } else {
                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                }
              }
            }
            if (animatorProps.fh.propType) {
              if (mult.length) {
                fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
              } else {
                fc = addHueToRGB(fc, animatorProps.fh.v * mult);
              }
            }
            if (animatorProps.fs.propType) {
              if (mult.length) {
                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
              } else {
                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
              }
            }
            if (animatorProps.fb.propType) {
              if (mult.length) {
                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
              } else {
                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
              }
            }
          }
        }
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.p.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (this._hasMaskedPath) {
              if (mult.length) {
                matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
              } else {
                matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
              }
            } else if (mult.length) {
              matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
            } else {
              matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
            }
          }
        }
        if (documentData.strokeWidthAnim) {
          letterSw = sw < 0 ? 0 : sw;
        }
        if (documentData.strokeColorAnim) {
          letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
        }
        if (documentData.fillColorAnim && documentData.fc) {
          letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
        }
        if (this._hasMaskedPath) {
          matrixHelper.translate(0, -documentData.ls);
          matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
          if (this._pathData.p.v) {
            tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
            var rot = Math.atan(tanAngle) * 180 / Math.PI;
            if (currentPoint.point[0] < prevPoint.point[0]) {
              rot += 180;
            }
            matrixHelper.rotate(-rot * Math.PI / 180);
          }
          matrixHelper.translate(xPathPos, yPathPos, 0);
          currentLength -= alignment[0] * letters[i].an * 0.005;
          if (letters[i + 1] && ind !== letters[i + 1].ind) {
            currentLength += letters[i].an / 2;
            currentLength += documentData.tr * 0.001 * documentData.finalSize;
          }
        } else {
          matrixHelper.translate(xPos, yPos, 0);
          if (documentData.ps) {
            // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
            matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
          }
          switch (documentData.j) {
            case 1:
              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
              break;
            case 2:
              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
              break;
            default:
              break;
          }
          matrixHelper.translate(0, -documentData.ls);
          matrixHelper.translate(offf, 0, 0);
          matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
          xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
        }
        if (renderType === 'html') {
          letterM = matrixHelper.toCSS();
        } else if (renderType === 'svg') {
          letterM = matrixHelper.to2dCSS();
        } else {
          letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
        }
        letterO = elemOpacity;
      }
      if (renderedLettersCount <= i) {
        letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
        this.renderedLetters.push(letterValue);
        renderedLettersCount += 1;
        this.lettersChangedFlag = true;
      } else {
        letterValue = this.renderedLetters[i];
        this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
      }
    }
  };
  TextAnimatorProperty.prototype.getValue = function () {
    if (this._elem.globalData.frameId === this._frameId) {
      return;
    }
    this._frameId = this._elem.globalData.frameId;
    this.iterateDynamicProperties();
  };
  TextAnimatorProperty.prototype.mHelper = new Matrix();
  TextAnimatorProperty.prototype.defaultPropsArray = [];
  extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);

  function ITextElement() {}
  ITextElement.prototype.initElement = function (data, globalData, comp) {
    this.lettersChangedFlag = true;
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
    this.initTransform(data, globalData, comp);
    this.initHierarchy();
    this.initRenderable();
    this.initRendererElement();
    this.createContainerElements();
    this.createRenderableComponents();
    this.createContent();
    this.hide();
    this.textAnimator.searchProperties(this.dynamicProperties);
  };
  ITextElement.prototype.prepareFrame = function (num) {
    this._mdf = false;
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);
  };
  ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
    var j;
    var jLen = shapes.length;
    var pathNodes;
    var shapeStr = '';
    for (j = 0; j < jLen; j += 1) {
      if (shapes[j].ty === 'sh') {
        pathNodes = shapes[j].ks.k;
        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
      }
    }
    return shapeStr;
  };
  ITextElement.prototype.updateDocumentData = function (newData, index) {
    this.textProperty.updateDocumentData(newData, index);
  };
  ITextElement.prototype.canResizeFont = function (_canResize) {
    this.textProperty.canResizeFont(_canResize);
  };
  ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
    this.textProperty.setMinimumFontSize(_fontSize);
  };
  ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
    if (documentData.ps) {
      matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
    }
    matrixHelper.translate(0, -documentData.ls, 0);
    switch (documentData.j) {
      case 1:
        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
        break;
      case 2:
        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
        break;
      default:
        break;
    }
    matrixHelper.translate(xPos, yPos, 0);
  };
  ITextElement.prototype.buildColor = function (colorData) {
    return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
  };
  ITextElement.prototype.emptyProp = new LetterProps();
  ITextElement.prototype.destroy = function () {};
  ITextElement.prototype.validateText = function () {
    if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
      this.buildNewText();
      this.textProperty._isFirstFrame = false;
      this.textProperty._mdf = false;
    }
  };

  var emptyShapeData = {
    shapes: []
  };
  function SVGTextLottieElement(data, globalData, comp) {
    this.textSpans = [];
    this.renderType = 'svg';
    this.initElement(data, globalData, comp);
  }
  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);
  SVGTextLottieElement.prototype.createContent = function () {
    if (this.data.singleShape && !this.globalData.fontManager.chars) {
      this.textContainer = createNS('text');
    }
  };
  SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
    var i = 0;
    var len = textArray.length;
    var textContents = [];
    var currentTextContent = '';
    while (i < len) {
      if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
        textContents.push(currentTextContent);
        currentTextContent = '';
      } else {
        currentTextContent += textArray[i];
      }
      i += 1;
    }
    textContents.push(currentTextContent);
    return textContents;
  };
  SVGTextLottieElement.prototype.buildShapeData = function (data, scale) {
    // data should probably be cloned to apply scale separately to each instance of a text on different layers
    // but since text internal content gets only rendered once and then it's never rerendered,
    // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
    // Avoiding cloning is preferred since cloning each character shape data is expensive
    if (data.shapes && data.shapes.length) {
      var shape = data.shapes[0];
      if (shape.it) {
        var shapeItem = shape.it[shape.it.length - 1];
        if (shapeItem.s) {
          shapeItem.s.k[0] = scale;
          shapeItem.s.k[1] = scale;
        }
      }
    }
    return data;
  };
  SVGTextLottieElement.prototype.buildNewText = function () {
    this.addDynamicProperty(this);
    var i;
    var len;
    var documentData = this.textProperty.currentData;
    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
    if (documentData.fc) {
      this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
    } else {
      this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
    }
    if (documentData.sc) {
      this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
      this.layerElement.setAttribute('stroke-width', documentData.sw);
    }
    this.layerElement.setAttribute('font-size', documentData.finalSize);
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    if (fontData.fClass) {
      this.layerElement.setAttribute('class', fontData.fClass);
    } else {
      this.layerElement.setAttribute('font-family', fontData.fFamily);
      var fWeight = documentData.fWeight;
      var fStyle = documentData.fStyle;
      this.layerElement.setAttribute('font-style', fStyle);
      this.layerElement.setAttribute('font-weight', fWeight);
    }
    this.layerElement.setAttribute('aria-label', documentData.t);
    var letters = documentData.l || [];
    var usesGlyphs = !!this.globalData.fontManager.chars;
    len = letters.length;
    var tSpan;
    var matrixHelper = this.mHelper;
    var shapeStr = '';
    var singleShape = this.data.singleShape;
    var xPos = 0;
    var yPos = 0;
    var firstLine = true;
    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
    if (singleShape && !usesGlyphs && !documentData.sz) {
      var tElement = this.textContainer;
      var justify = 'start';
      switch (documentData.j) {
        case 1:
          justify = 'end';
          break;
        case 2:
          justify = 'middle';
          break;
        default:
          justify = 'start';
          break;
      }
      tElement.setAttribute('text-anchor', justify);
      tElement.setAttribute('letter-spacing', trackingOffset);
      var textContent = this.buildTextContents(documentData.finalText);
      len = textContent.length;
      yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
      for (i = 0; i < len; i += 1) {
        tSpan = this.textSpans[i].span || createNS('tspan');
        tSpan.textContent = textContent[i];
        tSpan.setAttribute('x', 0);
        tSpan.setAttribute('y', yPos);
        tSpan.style.display = 'inherit';
        tElement.appendChild(tSpan);
        if (!this.textSpans[i]) {
          this.textSpans[i] = {
            span: null,
            glyph: null
          };
        }
        this.textSpans[i].span = tSpan;
        yPos += documentData.finalLineHeight;
      }
      this.layerElement.appendChild(tElement);
    } else {
      var cachedSpansLength = this.textSpans.length;
      var charData;
      for (i = 0; i < len; i += 1) {
        if (!this.textSpans[i]) {
          this.textSpans[i] = {
            span: null,
            childSpan: null,
            glyph: null
          };
        }
        if (!usesGlyphs || !singleShape || i === 0) {
          tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
          if (cachedSpansLength <= i) {
            tSpan.setAttribute('stroke-linecap', 'butt');
            tSpan.setAttribute('stroke-linejoin', 'round');
            tSpan.setAttribute('stroke-miterlimit', '4');
            this.textSpans[i].span = tSpan;
            if (usesGlyphs) {
              var childSpan = createNS('g');
              tSpan.appendChild(childSpan);
              this.textSpans[i].childSpan = childSpan;
            }
            this.textSpans[i].span = tSpan;
            this.layerElement.appendChild(tSpan);
          }
          tSpan.style.display = 'inherit';
        }
        matrixHelper.reset();
        if (singleShape) {
          if (letters[i].n) {
            xPos = -trackingOffset;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            firstLine = false;
          }
          this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
          xPos += letters[i].l || 0;
          // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
          xPos += trackingOffset;
        }
        if (usesGlyphs) {
          charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
          var glyphElement;
          // t === 1 means the character has been replaced with an animated shaped
          if (charData.t === 1) {
            glyphElement = new SVGCompElement(charData.data, this.globalData, this);
          } else {
            var data = emptyShapeData;
            if (charData.data && charData.data.shapes) {
              data = this.buildShapeData(charData.data, documentData.finalSize);
            }
            glyphElement = new SVGShapeElement(data, this.globalData, this);
          }
          if (this.textSpans[i].glyph) {
            var glyph = this.textSpans[i].glyph;
            this.textSpans[i].childSpan.removeChild(glyph.layerElement);
            glyph.destroy();
          }
          this.textSpans[i].glyph = glyphElement;
          glyphElement._debug = true;
          glyphElement.prepareFrame(0);
          glyphElement.renderFrame();
          this.textSpans[i].childSpan.appendChild(glyphElement.layerElement);
          // when using animated shapes, the layer will be scaled instead of replacing the internal scale
          // this might have issues with strokes and might need a different solution
          if (charData.t === 1) {
            this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
          }
        } else {
          if (singleShape) {
            tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
          }
          tSpan.textContent = letters[i].val;
          tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
        }
        //
      }
      if (singleShape && tSpan) {
        tSpan.setAttribute('d', shapeStr);
      }
    }
    while (i < this.textSpans.length) {
      this.textSpans[i].span.style.display = 'none';
      i += 1;
    }
    this._sizeChanged = true;
  };
  SVGTextLottieElement.prototype.sourceRectAtTime = function () {
    this.prepareFrame(this.comp.renderedFrame - this.data.st);
    this.renderInnerContent();
    if (this._sizeChanged) {
      this._sizeChanged = false;
      var textBox = this.layerElement.getBBox();
      this.bbox = {
        top: textBox.y,
        left: textBox.x,
        width: textBox.width,
        height: textBox.height
      };
    }
    return this.bbox;
  };
  SVGTextLottieElement.prototype.getValue = function () {
    var i;
    var len = this.textSpans.length;
    var glyphElement;
    this.renderedFrame = this.comp.renderedFrame;
    for (i = 0; i < len; i += 1) {
      glyphElement = this.textSpans[i].glyph;
      if (glyphElement) {
        glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
        if (glyphElement._mdf) {
          this._mdf = true;
        }
      }
    }
  };
  SVGTextLottieElement.prototype.renderInnerContent = function () {
    this.validateText();
    if (!this.data.singleShape || this._mdf) {
      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
        this._sizeChanged = true;
        var i;
        var len;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var glyphElement;
        for (i = 0; i < len; i += 1) {
          if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            textSpan = this.textSpans[i].span;
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
              glyphElement.renderFrame();
            }
            if (renderedLetter._mdf.m) {
              textSpan.setAttribute('transform', renderedLetter.m);
            }
            if (renderedLetter._mdf.o) {
              textSpan.setAttribute('opacity', renderedLetter.o);
            }
            if (renderedLetter._mdf.sw) {
              textSpan.setAttribute('stroke-width', renderedLetter.sw);
            }
            if (renderedLetter._mdf.sc) {
              textSpan.setAttribute('stroke', renderedLetter.sc);
            }
            if (renderedLetter._mdf.fc) {
              textSpan.setAttribute('fill', renderedLetter.fc);
            }
          }
        }
      }
    }
  };

  function ISolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
  }
  extendPrototype([IImageElement], ISolidElement);
  ISolidElement.prototype.createContent = function () {
    var rect = createNS('rect');
    /// /rect.style.width = this.data.sw;
    /// /rect.style.height = this.data.sh;
    /// /rect.style.fill = this.data.sc;
    rect.setAttribute('width', this.data.sw);
    rect.setAttribute('height', this.data.sh);
    rect.setAttribute('fill', this.data.sc);
    this.layerElement.appendChild(rect);
  };

  function NullElement(data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initFrame();
    this.initTransform(data, globalData, comp);
    this.initHierarchy();
  }
  NullElement.prototype.prepareFrame = function (num) {
    this.prepareProperties(num, true);
  };
  NullElement.prototype.renderFrame = function () {};
  NullElement.prototype.getBaseElement = function () {
    return null;
  };
  NullElement.prototype.destroy = function () {};
  NullElement.prototype.sourceRectAtTime = function () {};
  NullElement.prototype.hide = function () {};
  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);

  function SVGRendererBase() {}
  extendPrototype([BaseRenderer], SVGRendererBase);
  SVGRendererBase.prototype.createNull = function (data) {
    return new NullElement(data, this.globalData, this);
  };
  SVGRendererBase.prototype.createShape = function (data) {
    return new SVGShapeElement(data, this.globalData, this);
  };
  SVGRendererBase.prototype.createText = function (data) {
    return new SVGTextLottieElement(data, this.globalData, this);
  };
  SVGRendererBase.prototype.createImage = function (data) {
    return new IImageElement(data, this.globalData, this);
  };
  SVGRendererBase.prototype.createSolid = function (data) {
    return new ISolidElement(data, this.globalData, this);
  };
  SVGRendererBase.prototype.configAnimation = function (animData) {
    this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    if (this.renderConfig.viewBoxSize) {
      this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
    } else {
      this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
    }
    if (!this.renderConfig.viewBoxOnly) {
      this.svgElement.setAttribute('width', animData.w);
      this.svgElement.setAttribute('height', animData.h);
      this.svgElement.style.width = '100%';
      this.svgElement.style.height = '100%';
      this.svgElement.style.transform = 'translate3d(0,0,0)';
      this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
    }
    if (this.renderConfig.width) {
      this.svgElement.setAttribute('width', this.renderConfig.width);
    }
    if (this.renderConfig.height) {
      this.svgElement.setAttribute('height', this.renderConfig.height);
    }
    if (this.renderConfig.className) {
      this.svgElement.setAttribute('class', this.renderConfig.className);
    }
    if (this.renderConfig.id) {
      this.svgElement.setAttribute('id', this.renderConfig.id);
    }
    if (this.renderConfig.focusable !== undefined) {
      this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
    }
    this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio);
    // this.layerElement.style.transform = 'translate3d(0,0,0)';
    // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
    this.animationItem.wrapper.appendChild(this.svgElement);
    // Mask animation
    var defs = this.globalData.defs;
    this.setupGlobalData(animData, defs);
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.data = animData;
    var maskElement = createNS('clipPath');
    var rect = createNS('rect');
    rect.setAttribute('width', animData.w);
    rect.setAttribute('height', animData.h);
    rect.setAttribute('x', 0);
    rect.setAttribute('y', 0);
    var maskId = createElementID();
    maskElement.setAttribute('id', maskId);
    maskElement.appendChild(rect);
    this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
    defs.appendChild(maskElement);
    this.layers = animData.layers;
    this.elements = createSizedArray(animData.layers.length);
  };
  SVGRendererBase.prototype.destroy = function () {
    if (this.animationItem.wrapper) {
      this.animationItem.wrapper.innerText = '';
    }
    this.layerElement = null;
    this.globalData.defs = null;
    var i;
    var len = this.layers ? this.layers.length : 0;
    for (i = 0; i < len; i += 1) {
      if (this.elements[i] && this.elements[i].destroy) {
        this.elements[i].destroy();
      }
    }
    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
  };
  SVGRendererBase.prototype.updateContainerSize = function () {};
  SVGRendererBase.prototype.findIndexByInd = function (ind) {
    var i = 0;
    var len = this.layers.length;
    for (i = 0; i < len; i += 1) {
      if (this.layers[i].ind === ind) {
        return i;
      }
    }
    return -1;
  };
  SVGRendererBase.prototype.buildItem = function (pos) {
    var elements = this.elements;
    if (elements[pos] || this.layers[pos].ty === 99) {
      return;
    }
    elements[pos] = true;
    var element = this.createItem(this.layers[pos]);
    elements[pos] = element;
    if (getExpressionsPlugin()) {
      if (this.layers[pos].ty === 0) {
        this.globalData.projectInterface.registerComposition(element);
      }
      element.initExpressions();
    }
    this.appendElementInPos(element, pos);
    if (this.layers[pos].tt) {
      var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
      if (elementIndex === -1) {
        return;
      }
      if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
        this.buildItem(elementIndex);
        this.addPendingElement(element);
      } else {
        var matteElement = elements[elementIndex];
        var matteMask = matteElement.getMatte(this.layers[pos].tt);
        element.setMatte(matteMask);
      }
    }
  };
  SVGRendererBase.prototype.checkPendingElements = function () {
    while (this.pendingElements.length) {
      var element = this.pendingElements.pop();
      element.checkParenting();
      if (element.data.tt) {
        var i = 0;
        var len = this.elements.length;
        while (i < len) {
          if (this.elements[i] === element) {
            var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
            var matteElement = this.elements[elementIndex];
            var matteMask = matteElement.getMatte(this.layers[i].tt);
            element.setMatte(matteMask);
            break;
          }
          i += 1;
        }
      }
    }
  };
  SVGRendererBase.prototype.renderFrame = function (num) {
    if (this.renderedFrame === num || this.destroyed) {
      return;
    }
    if (num === null) {
      num = this.renderedFrame;
    } else {
      this.renderedFrame = num;
    }
    // console.log('-------');
    // console.log('FRAME ',num);
    this.globalData.frameNum = num;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    this.globalData._mdf = false;
    var i;
    var len = this.layers.length;
    if (!this.completeLayers) {
      this.checkLayers(num);
    }
    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(num - this.layers[i].st);
      }
    }
    if (this.globalData._mdf) {
      for (i = 0; i < len; i += 1) {
        if (this.completeLayers || this.elements[i]) {
          this.elements[i].renderFrame();
        }
      }
    }
  };
  SVGRendererBase.prototype.appendElementInPos = function (element, pos) {
    var newElement = element.getBaseElement();
    if (!newElement) {
      return;
    }
    var i = 0;
    var nextElement;
    while (i < pos) {
      if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
        nextElement = this.elements[i].getBaseElement();
      }
      i += 1;
    }
    if (nextElement) {
      this.layerElement.insertBefore(newElement, nextElement);
    } else {
      this.layerElement.appendChild(newElement);
    }
  };
  SVGRendererBase.prototype.hide = function () {
    this.layerElement.style.display = 'none';
  };
  SVGRendererBase.prototype.show = function () {
    this.layerElement.style.display = 'block';
  };

  function ICompElement() {}
  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);
  ICompElement.prototype.initElement = function (data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initTransform(data, globalData, comp);
    this.initRenderable();
    this.initHierarchy();
    this.initRendererElement();
    this.createContainerElements();
    this.createRenderableComponents();
    if (this.data.xt || !globalData.progressiveLoad) {
      this.buildAllItems();
    }
    this.hide();
  };

  /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */

  ICompElement.prototype.prepareFrame = function (num) {
    this._mdf = false;
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);
    if (!this.isInRange && !this.data.xt) {
      return;
    }
    if (!this.tm._placeholder) {
      var timeRemapped = this.tm.v;
      if (timeRemapped === this.data.op) {
        timeRemapped = this.data.op - 1;
      }
      this.renderedFrame = timeRemapped;
    } else {
      this.renderedFrame = num / this.data.sr;
    }
    var i;
    var len = this.elements.length;
    if (!this.completeLayers) {
      this.checkLayers(this.renderedFrame);
    }
    // This iteration needs to be backwards because of how expressions connect between each other
    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
        if (this.elements[i]._mdf) {
          this._mdf = true;
        }
      }
    }
  };
  ICompElement.prototype.renderInnerContent = function () {
    var i;
    var len = this.layers.length;
    for (i = 0; i < len; i += 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  };
  ICompElement.prototype.setElements = function (elems) {
    this.elements = elems;
  };
  ICompElement.prototype.getElements = function () {
    return this.elements;
  };
  ICompElement.prototype.destroyElements = function () {
    var i;
    var len = this.layers.length;
    for (i = 0; i < len; i += 1) {
      if (this.elements[i]) {
        this.elements[i].destroy();
      }
    }
  };
  ICompElement.prototype.destroy = function () {
    this.destroyElements();
    this.destroyBaseElement();
  };

  function SVGCompElement(data, globalData, comp) {
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
  }
  extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement);
  SVGCompElement.prototype.createComp = function (data) {
    return new SVGCompElement(data, this.globalData, this);
  };

  function SVGRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.svgElement = createNS('svg');
    var ariaLabel = '';
    if (config && config.title) {
      var titleElement = createNS('title');
      var titleId = createElementID();
      titleElement.setAttribute('id', titleId);
      titleElement.textContent = config.title;
      this.svgElement.appendChild(titleElement);
      ariaLabel += titleId;
    }
    if (config && config.description) {
      var descElement = createNS('desc');
      var descId = createElementID();
      descElement.setAttribute('id', descId);
      descElement.textContent = config.description;
      this.svgElement.appendChild(descElement);
      ariaLabel += ' ' + descId;
    }
    if (ariaLabel) {
      this.svgElement.setAttribute('aria-labelledby', ariaLabel);
    }
    var defs = createNS('defs');
    this.svgElement.appendChild(defs);
    var maskElement = createNS('g');
    this.svgElement.appendChild(maskElement);
    this.layerElement = maskElement;
    this.renderConfig = {
      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      contentVisibility: config && config.contentVisibility || 'visible',
      progressiveLoad: config && config.progressiveLoad || false,
      hideOnTransparent: !(config && config.hideOnTransparent === false),
      viewBoxOnly: config && config.viewBoxOnly || false,
      viewBoxSize: config && config.viewBoxSize || false,
      className: config && config.className || '',
      id: config && config.id || '',
      focusable: config && config.focusable,
      filterSize: {
        width: config && config.filterSize && config.filterSize.width || '100%',
        height: config && config.filterSize && config.filterSize.height || '100%',
        x: config && config.filterSize && config.filterSize.x || '0%',
        y: config && config.filterSize && config.filterSize.y || '0%'
      },
      width: config && config.width,
      height: config && config.height,
      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
    };
    this.globalData = {
      _mdf: false,
      frameNum: -1,
      defs: defs,
      renderConfig: this.renderConfig
    };
    this.elements = [];
    this.pendingElements = [];
    this.destroyed = false;
    this.rendererType = 'svg';
  }
  extendPrototype([SVGRendererBase], SVGRenderer);
  SVGRenderer.prototype.createComp = function (data) {
    return new SVGCompElement(data, this.globalData, this);
  };

  function ShapeTransformManager() {
    this.sequences = {};
    this.sequenceList = [];
    this.transform_key_count = 0;
  }
  ShapeTransformManager.prototype = {
    addTransformSequence: function addTransformSequence(transforms) {
      var i;
      var len = transforms.length;
      var key = '_';
      for (i = 0; i < len; i += 1) {
        key += transforms[i].transform.key + '_';
      }
      var sequence = this.sequences[key];
      if (!sequence) {
        sequence = {
          transforms: [].concat(transforms),
          finalTransform: new Matrix(),
          _mdf: false
        };
        this.sequences[key] = sequence;
        this.sequenceList.push(sequence);
      }
      return sequence;
    },
    processSequence: function processSequence(sequence, isFirstFrame) {
      var i = 0;
      var len = sequence.transforms.length;
      var _mdf = isFirstFrame;
      while (i < len && !isFirstFrame) {
        if (sequence.transforms[i].transform.mProps._mdf) {
          _mdf = true;
          break;
        }
        i += 1;
      }
      if (_mdf) {
        sequence.finalTransform.reset();
        for (i = len - 1; i >= 0; i -= 1) {
          sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
        }
      }
      sequence._mdf = _mdf;
    },
    processSequences: function processSequences(isFirstFrame) {
      var i;
      var len = this.sequenceList.length;
      for (i = 0; i < len; i += 1) {
        this.processSequence(this.sequenceList[i], isFirstFrame);
      }
    },
    getNewKey: function getNewKey() {
      this.transform_key_count += 1;
      return '_' + this.transform_key_count;
    }
  };

  var lumaLoader = function lumaLoader() {
    var id = '__lottie_element_luma_buffer';
    var lumaBuffer = null;
    var lumaBufferCtx = null;
    var svg = null;

    // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
    // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
    // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
    // Naming it solution 2 to mark the extra comment lines.
    /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */

    function createLumaSvgFilter() {
      var _svg = createNS('svg');
      var fil = createNS('filter');
      var matrix = createNS('feColorMatrix');
      fil.setAttribute('id', id);
      matrix.setAttribute('type', 'matrix');
      matrix.setAttribute('color-interpolation-filters', 'sRGB');
      matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
      fil.appendChild(matrix);
      _svg.appendChild(fil);
      _svg.setAttribute('id', id + '_svg');
      if (featureSupport.svgLumaHidden) {
        _svg.style.display = 'none';
      }
      return _svg;
    }
    function loadLuma() {
      if (!lumaBuffer) {
        svg = createLumaSvgFilter();
        document.body.appendChild(svg);
        lumaBuffer = createTag('canvas');
        lumaBufferCtx = lumaBuffer.getContext('2d');
        // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
        lumaBufferCtx.filter = 'url(#' + id + ')';
        lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
        lumaBufferCtx.fillRect(0, 0, 1, 1);
      }
    }
    function getLuma(canvas) {
      if (!lumaBuffer) {
        loadLuma();
      }
      lumaBuffer.width = canvas.width;
      lumaBuffer.height = canvas.height;
      // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
      lumaBufferCtx.filter = 'url(#' + id + ')';
      return lumaBuffer;
    }
    return {
      load: loadLuma,
      get: getLuma
    };
  };
  function createCanvas(width, height) {
    if (featureSupport.offscreenCanvas) {
      return new OffscreenCanvas(width, height);
    }
    var canvas = createTag('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }
  var assetLoader = function () {
    return {
      loadLumaCanvas: lumaLoader.load,
      getLumaCanvas: lumaLoader.get,
      createCanvas: createCanvas
    };
  }();

  var registeredEffects = {};
  function CVEffects(elem) {
    var i;
    var len = elem.data.ef ? elem.data.ef.length : 0;
    this.filters = [];
    var filterManager;
    for (i = 0; i < len; i += 1) {
      filterManager = null;
      var type = elem.data.ef[i].ty;
      if (registeredEffects[type]) {
        var Effect = registeredEffects[type].effect;
        filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
      }
      if (filterManager) {
        this.filters.push(filterManager);
      }
    }
    if (this.filters.length) {
      elem.addRenderableComponent(this);
    }
  }
  CVEffects.prototype.renderFrame = function (_isFirstFrame) {
    var i;
    var len = this.filters.length;
    for (i = 0; i < len; i += 1) {
      this.filters[i].renderFrame(_isFirstFrame);
    }
  };
  CVEffects.prototype.getEffects = function (type) {
    var i;
    var len = this.filters.length;
    var effects = [];
    for (i = 0; i < len; i += 1) {
      if (this.filters[i].type === type) {
        effects.push(this.filters[i]);
      }
    }
    return effects;
  };
  function registerEffect(id, effect) {
    registeredEffects[id] = {
      effect: effect
    };
  }

  function CVMaskElement(data, element) {
    this.data = data;
    this.element = element;
    this.masksProperties = this.data.masksProperties || [];
    this.viewData = createSizedArray(this.masksProperties.length);
    var i;
    var len = this.masksProperties.length;
    var hasMasks = false;
    for (i = 0; i < len; i += 1) {
      if (this.masksProperties[i].mode !== 'n') {
        hasMasks = true;
      }
      this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
    }
    this.hasMasks = hasMasks;
    if (hasMasks) {
      this.element.addRenderableComponent(this);
    }
  }
  CVMaskElement.prototype.renderFrame = function () {
    if (!this.hasMasks) {
      return;
    }
    var transform = this.element.finalTransform.mat;
    var ctx = this.element.canvasContext;
    var i;
    var len = this.masksProperties.length;
    var pt;
    var pts;
    var data;
    ctx.beginPath();
    for (i = 0; i < len; i += 1) {
      if (this.masksProperties[i].mode !== 'n') {
        if (this.masksProperties[i].inv) {
          ctx.moveTo(0, 0);
          ctx.lineTo(this.element.globalData.compSize.w, 0);
          ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
          ctx.lineTo(0, this.element.globalData.compSize.h);
          ctx.lineTo(0, 0);
        }
        data = this.viewData[i].v;
        pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
        ctx.moveTo(pt[0], pt[1]);
        var j;
        var jLen = data._length;
        for (j = 1; j < jLen; j += 1) {
          pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
          ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }
        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
      }
    }
    this.element.globalData.renderer.save(true);
    ctx.clip();
  };
  CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
  CVMaskElement.prototype.destroy = function () {
    this.element = null;
  };

  function CVBaseElement() {}
  var operationsMap = {
    1: 'source-in',
    2: 'source-out',
    3: 'source-in',
    4: 'source-out'
  };
  CVBaseElement.prototype = {
    createElements: function createElements() {},
    initRendererElement: function initRendererElement() {},
    createContainerElements: function createContainerElements() {
      // If the layer is masked we will use two buffers to store each different states of the drawing
      // This solution is not ideal for several reason. But unfortunately, because of the recursive
      // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
      // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
      // It might be challenging because the layer most likely is transformed in some way
      if (this.data.tt >= 1) {
        this.buffers = [];
        var canvasContext = this.globalData.canvasContext;
        var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
        this.buffers.push(bufferCanvas);
        var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
        this.buffers.push(bufferCanvas2);
        if (this.data.tt >= 3 && !document._isProxy) {
          assetLoader.loadLumaCanvas();
        }
      }
      this.canvasContext = this.globalData.canvasContext;
      this.transformCanvas = this.globalData.transformCanvas;
      this.renderableEffectsManager = new CVEffects(this);
      this.searchEffectTransforms();
    },
    createContent: function createContent() {},
    setBlendMode: function setBlendMode() {
      var globalData = this.globalData;
      if (globalData.blendMode !== this.data.bm) {
        globalData.blendMode = this.data.bm;
        var blendModeValue = getBlendMode(this.data.bm);
        globalData.canvasContext.globalCompositeOperation = blendModeValue;
      }
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new CVMaskElement(this.data, this);
      this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
    },
    hideElement: function hideElement() {
      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
        this.hidden = true;
      }
    },
    showElement: function showElement() {
      if (this.isInRange && !this.isTransparent) {
        this.hidden = false;
        this._isFirstFrame = true;
        this.maskManager._isFirstFrame = true;
      }
    },
    clearCanvas: function clearCanvas(canvasContext) {
      canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
    },
    prepareLayer: function prepareLayer() {
      if (this.data.tt >= 1) {
        var buffer = this.buffers[0];
        var bufferCtx = buffer.getContext('2d');
        this.clearCanvas(bufferCtx);
        // on the first buffer we store the current state of the global drawing
        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
        // The next four lines are to clear the canvas
        // TODO: Check if there is a way to clear the canvas without resetting the transform
        this.currentTransform = this.canvasContext.getTransform();
        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
        this.clearCanvas(this.canvasContext);
        this.canvasContext.setTransform(this.currentTransform);
      }
    },
    exitLayer: function exitLayer() {
      if (this.data.tt >= 1) {
        var buffer = this.buffers[1];
        // On the second buffer we store the current state of the global drawing
        // that only contains the content of this layer
        // (if it is a composition, it also includes the nested layers)
        var bufferCtx = buffer.getContext('2d');
        this.clearCanvas(bufferCtx);
        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
        // We clear the canvas again
        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
        this.clearCanvas(this.canvasContext);
        this.canvasContext.setTransform(this.currentTransform);
        // We draw the mask
        var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
        mask.renderFrame(true);
        // We draw the second buffer (that contains the content of this layer)
        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);

        // If the mask is a Luma matte, we need to do two extra painting operations
        // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
        if (this.data.tt >= 3 && !document._isProxy) {
          // We copy the painted mask to a buffer that has a color matrix filter applied to it
          // that applies the rgb values to the alpha channel
          var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
          var lumaBufferCtx = lumaBuffer.getContext('2d');
          lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
          this.clearCanvas(this.canvasContext);
          // we repaint the context with the mask applied to it
          this.canvasContext.drawImage(lumaBuffer, 0, 0);
        }
        this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
        this.canvasContext.drawImage(buffer, 0, 0);
        // We finally draw the first buffer (that contains the content of the global drawing)
        // We use destination-over to draw the global drawing below the current layer
        this.canvasContext.globalCompositeOperation = 'destination-over';
        this.canvasContext.drawImage(this.buffers[0], 0, 0);
        this.canvasContext.setTransform(this.currentTransform);
        // We reset the globalCompositeOperation to source-over, the standard type of operation
        this.canvasContext.globalCompositeOperation = 'source-over';
      }
    },
    renderFrame: function renderFrame(forceRender) {
      if (this.hidden || this.data.hd) {
        return;
      }
      if (this.data.td === 1 && !forceRender) {
        return;
      }
      this.renderTransform();
      this.renderRenderable();
      this.renderLocalTransform();
      this.setBlendMode();
      var forceRealStack = this.data.ty === 0;
      this.prepareLayer();
      this.globalData.renderer.save(forceRealStack);
      this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
      this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
      this.renderInnerContent();
      this.globalData.renderer.restore(forceRealStack);
      this.exitLayer();
      if (this.maskManager.hasMasks) {
        this.globalData.renderer.restore(true);
      }
      if (this._isFirstFrame) {
        this._isFirstFrame = false;
      }
    },
    destroy: function destroy() {
      this.canvasContext = null;
      this.data = null;
      this.globalData = null;
      this.maskManager.destroy();
    },
    mHelper: new Matrix()
  };
  CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
  CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;

  function CVShapeData(element, data, styles, transformsManager) {
    this.styledShapes = [];
    this.tr = [0, 0, 0, 0, 0, 0];
    var ty = 4;
    if (data.ty === 'rc') {
      ty = 5;
    } else if (data.ty === 'el') {
      ty = 6;
    } else if (data.ty === 'sr') {
      ty = 7;
    }
    this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
    var i;
    var len = styles.length;
    var styledShape;
    for (i = 0; i < len; i += 1) {
      if (!styles[i].closed) {
        styledShape = {
          transforms: transformsManager.addTransformSequence(styles[i].transforms),
          trNodes: []
        };
        this.styledShapes.push(styledShape);
        styles[i].elements.push(styledShape);
      }
    }
  }
  CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;

  function CVShapeElement(data, globalData, comp) {
    this.shapes = [];
    this.shapesData = data.shapes;
    this.stylesList = [];
    this.itemsData = [];
    this.prevViewData = [];
    this.shapeModifiers = [];
    this.processedElements = [];
    this.transformsManager = new ShapeTransformManager();
    this.initElement(data, globalData, comp);
  }
  extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);
  CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
  CVShapeElement.prototype.transformHelper = {
    opacity: 1,
    _opMdf: false
  };
  CVShapeElement.prototype.dashResetter = [];
  CVShapeElement.prototype.createContent = function () {
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
  };
  CVShapeElement.prototype.createStyleElement = function (data, transforms) {
    var styleElem = {
      data: data,
      type: data.ty,
      preTransforms: this.transformsManager.addTransformSequence(transforms),
      transforms: [],
      elements: [],
      closed: data.hd === true
    };
    var elementData = {};
    if (data.ty === 'fl' || data.ty === 'st') {
      elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
      if (!elementData.c.k) {
        styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
      }
    } else if (data.ty === 'gf' || data.ty === 'gs') {
      elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
      elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
      elementData.h = PropertyFactory.getProp(this, data.h || {
        k: 0
      }, 0, 0.01, this);
      elementData.a = PropertyFactory.getProp(this, data.a || {
        k: 0
      }, 0, degToRads, this);
      elementData.g = new GradientProperty(this, data.g, this);
    }
    elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
    if (data.ty === 'st' || data.ty === 'gs') {
      styleElem.lc = lineCapEnum[data.lc || 2];
      styleElem.lj = lineJoinEnum[data.lj || 2];
      if (data.lj == 1) {
        // eslint-disable-line eqeqeq
        styleElem.ml = data.ml;
      }
      elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
      if (!elementData.w.k) {
        styleElem.wi = elementData.w.v;
      }
      if (data.d) {
        var d = new DashProperty(this, data.d, 'canvas', this);
        elementData.d = d;
        if (!elementData.d.k) {
          styleElem.da = elementData.d.dashArray;
          styleElem["do"] = elementData.d.dashoffset[0];
        }
      }
    } else {
      styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
    }
    this.stylesList.push(styleElem);
    elementData.style = styleElem;
    return elementData;
  };
  CVShapeElement.prototype.createGroupElement = function () {
    var elementData = {
      it: [],
      prevViewData: []
    };
    return elementData;
  };
  CVShapeElement.prototype.createTransformElement = function (data) {
    var elementData = {
      transform: {
        opacity: 1,
        _opMdf: false,
        key: this.transformsManager.getNewKey(),
        op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
        mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
      }
    };
    return elementData;
  };
  CVShapeElement.prototype.createShapeElement = function (data) {
    var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
    this.shapes.push(elementData);
    this.addShapeToModifiers(elementData);
    return elementData;
  };
  CVShapeElement.prototype.reloadShapes = function () {
    this._isFirstFrame = true;
    var i;
    var len = this.itemsData.length;
    for (i = 0; i < len; i += 1) {
      this.prevViewData[i] = this.itemsData[i];
    }
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    len = this.dynamicProperties.length;
    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
    }
    this.renderModifiers();
    this.transformsManager.processSequences(this._isFirstFrame);
  };
  CVShapeElement.prototype.addTransformToStyleList = function (transform) {
    var i;
    var len = this.stylesList.length;
    for (i = 0; i < len; i += 1) {
      if (!this.stylesList[i].closed) {
        this.stylesList[i].transforms.push(transform);
      }
    }
  };
  CVShapeElement.prototype.removeTransformFromStyleList = function () {
    var i;
    var len = this.stylesList.length;
    for (i = 0; i < len; i += 1) {
      if (!this.stylesList[i].closed) {
        this.stylesList[i].transforms.pop();
      }
    }
  };
  CVShapeElement.prototype.closeStyles = function (styles) {
    var i;
    var len = styles.length;
    for (i = 0; i < len; i += 1) {
      styles[i].closed = true;
    }
  };
  CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
    var i;
    var len = arr.length - 1;
    var j;
    var jLen;
    var ownStyles = [];
    var ownModifiers = [];
    var processedPos;
    var modifier;
    var currentTransform;
    var ownTransforms = [].concat(transforms);
    for (i = len; i >= 0; i -= 1) {
      processedPos = this.searchProcessedElement(arr[i]);
      if (!processedPos) {
        arr[i]._shouldRender = shouldRender;
      } else {
        itemsData[i] = prevViewData[processedPos - 1];
      }
      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
        if (!processedPos) {
          itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
        } else {
          itemsData[i].style.closed = false;
        }
        ownStyles.push(itemsData[i].style);
      } else if (arr[i].ty === 'gr') {
        if (!processedPos) {
          itemsData[i] = this.createGroupElement(arr[i]);
        } else {
          jLen = itemsData[i].it.length;
          for (j = 0; j < jLen; j += 1) {
            itemsData[i].prevViewData[j] = itemsData[i].it[j];
          }
        }
        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
      } else if (arr[i].ty === 'tr') {
        if (!processedPos) {
          currentTransform = this.createTransformElement(arr[i]);
          itemsData[i] = currentTransform;
        }
        ownTransforms.push(itemsData[i]);
        this.addTransformToStyleList(itemsData[i]);
      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
        if (!processedPos) {
          itemsData[i] = this.createShapeElement(arr[i]);
        }
      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          modifier.init(this, arr[i]);
          itemsData[i] = modifier;
          this.shapeModifiers.push(modifier);
        } else {
          modifier = itemsData[i];
          modifier.closed = false;
        }
        ownModifiers.push(modifier);
      } else if (arr[i].ty === 'rp') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          itemsData[i] = modifier;
          modifier.init(this, arr, i, itemsData);
          this.shapeModifiers.push(modifier);
          shouldRender = false;
        } else {
          modifier = itemsData[i];
          modifier.closed = true;
        }
        ownModifiers.push(modifier);
      }
      this.addProcessedElement(arr[i], i + 1);
    }
    this.removeTransformFromStyleList();
    this.closeStyles(ownStyles);
    len = ownModifiers.length;
    for (i = 0; i < len; i += 1) {
      ownModifiers[i].closed = true;
    }
  };
  CVShapeElement.prototype.renderInnerContent = function () {
    this.transformHelper.opacity = 1;
    this.transformHelper._opMdf = false;
    this.renderModifiers();
    this.transformsManager.processSequences(this._isFirstFrame);
    this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
  };
  CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
    if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
      groupTransform.opacity = parentTransform.opacity;
      groupTransform.opacity *= groupTransform.op.v;
      groupTransform._opMdf = true;
    }
  };
  CVShapeElement.prototype.drawLayer = function () {
    var i;
    var len = this.stylesList.length;
    var j;
    var jLen;
    var k;
    var kLen;
    var elems;
    var nodes;
    var renderer = this.globalData.renderer;
    var ctx = this.globalData.canvasContext;
    var type;
    var currentStyle;
    for (i = 0; i < len; i += 1) {
      currentStyle = this.stylesList[i];
      type = currentStyle.type;

      // Skipping style when
      // Stroke width equals 0
      // style should not be rendered (extra unused repeaters)
      // current opacity equals 0
      // global opacity equals 0
      if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
        renderer.save();
        elems = currentStyle.elements;
        if (type === 'st' || type === 'gs') {
          renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd);
          // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
          renderer.ctxLineWidth(currentStyle.wi);
          // ctx.lineWidth = currentStyle.wi;
          renderer.ctxLineCap(currentStyle.lc);
          // ctx.lineCap = currentStyle.lc;
          renderer.ctxLineJoin(currentStyle.lj);
          // ctx.lineJoin = currentStyle.lj;
          renderer.ctxMiterLimit(currentStyle.ml || 0);
          // ctx.miterLimit = currentStyle.ml || 0;
        } else {
          renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd);
          // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
        }
        renderer.ctxOpacity(currentStyle.coOp);
        if (type !== 'st' && type !== 'gs') {
          ctx.beginPath();
        }
        renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
        jLen = elems.length;
        for (j = 0; j < jLen; j += 1) {
          if (type === 'st' || type === 'gs') {
            ctx.beginPath();
            if (currentStyle.da) {
              ctx.setLineDash(currentStyle.da);
              ctx.lineDashOffset = currentStyle["do"];
            }
          }
          nodes = elems[j].trNodes;
          kLen = nodes.length;
          for (k = 0; k < kLen; k += 1) {
            if (nodes[k].t === 'm') {
              ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
            } else if (nodes[k].t === 'c') {
              ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
            } else {
              ctx.closePath();
            }
          }
          if (type === 'st' || type === 'gs') {
            // ctx.stroke();
            renderer.ctxStroke();
            if (currentStyle.da) {
              ctx.setLineDash(this.dashResetter);
            }
          }
        }
        if (type !== 'st' && type !== 'gs') {
          // ctx.fill(currentStyle.r);
          this.globalData.renderer.ctxFill(currentStyle.r);
        }
        renderer.restore();
      }
    }
  };
  CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
    var i;
    var len = items.length - 1;
    var groupTransform;
    groupTransform = parentTransform;
    for (i = len; i >= 0; i -= 1) {
      if (items[i].ty === 'tr') {
        groupTransform = data[i].transform;
        this.renderShapeTransform(parentTransform, groupTransform);
      } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
        this.renderPath(items[i], data[i]);
      } else if (items[i].ty === 'fl') {
        this.renderFill(items[i], data[i], groupTransform);
      } else if (items[i].ty === 'st') {
        this.renderStroke(items[i], data[i], groupTransform);
      } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
        this.renderGradientFill(items[i], data[i], groupTransform);
      } else if (items[i].ty === 'gr') {
        this.renderShape(groupTransform, items[i].it, data[i].it);
      } else if (items[i].ty === 'tm') {
        //
      }
    }
    if (isMain) {
      this.drawLayer();
    }
  };
  CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
    if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
      var shapeNodes = styledShape.trNodes;
      var paths = shape.paths;
      var i;
      var len;
      var j;
      var jLen = paths._length;
      shapeNodes.length = 0;
      var groupTransformMat = styledShape.transforms.finalTransform;
      for (j = 0; j < jLen; j += 1) {
        var pathNodes = paths.shapes[j];
        if (pathNodes && pathNodes.v) {
          len = pathNodes._length;
          for (i = 1; i < len; i += 1) {
            if (i === 1) {
              shapeNodes.push({
                t: 'm',
                p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
              });
            }
            shapeNodes.push({
              t: 'c',
              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
            });
          }
          if (len === 1) {
            shapeNodes.push({
              t: 'm',
              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
            });
          }
          if (pathNodes.c && len) {
            shapeNodes.push({
              t: 'c',
              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
            });
            shapeNodes.push({
              t: 'z'
            });
          }
        }
      }
      styledShape.trNodes = shapeNodes;
    }
  };
  CVShapeElement.prototype.renderPath = function (pathData, itemData) {
    if (pathData.hd !== true && pathData._shouldRender) {
      var i;
      var len = itemData.styledShapes.length;
      for (i = 0; i < len; i += 1) {
        this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
      }
    }
  };
  CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
    var styleElem = itemData.style;
    if (itemData.c._mdf || this._isFirstFrame) {
      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
    }
    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
      styleElem.coOp = itemData.o.v * groupTransform.opacity;
    }
  };
  CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
    var styleElem = itemData.style;
    var grd;
    if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
      var ctx = this.globalData.canvasContext;
      var pt1 = itemData.s.v;
      var pt2 = itemData.e.v;
      if (styleData.t === 1) {
        grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
      } else {
        var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
        var percent = itemData.h.v;
        if (percent >= 1) {
          percent = 0.99;
        } else if (percent <= -1) {
          percent = -0.99;
        }
        var dist = rad * percent;
        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
        grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
      }
      var i;
      var len = styleData.g.p;
      var cValues = itemData.g.c;
      var opacity = 1;
      for (i = 0; i < len; i += 1) {
        if (itemData.g._hasOpacity && itemData.g._collapsable) {
          opacity = itemData.g.o[i * 2 + 1];
        }
        grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
      }
      styleElem.grd = grd;
    }
    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  };
  CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
    var styleElem = itemData.style;
    var d = itemData.d;
    if (d && (d._mdf || this._isFirstFrame)) {
      styleElem.da = d.dashArray;
      styleElem["do"] = d.dashoffset[0];
    }
    if (itemData.c._mdf || this._isFirstFrame) {
      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
    }
    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
      styleElem.coOp = itemData.o.v * groupTransform.opacity;
    }
    if (itemData.w._mdf || this._isFirstFrame) {
      styleElem.wi = itemData.w.v;
    }
  };
  CVShapeElement.prototype.destroy = function () {
    this.shapesData = null;
    this.globalData = null;
    this.canvasContext = null;
    this.stylesList.length = 0;
    this.itemsData.length = 0;
  };

  function CVTextElement(data, globalData, comp) {
    this.textSpans = [];
    this.yOffset = 0;
    this.fillColorAnim = false;
    this.strokeColorAnim = false;
    this.strokeWidthAnim = false;
    this.stroke = false;
    this.fill = false;
    this.justifyOffset = 0;
    this.currentRender = null;
    this.renderType = 'canvas';
    this.values = {
      fill: 'rgba(0,0,0,0)',
      stroke: 'rgba(0,0,0,0)',
      sWidth: 0,
      fValue: ''
    };
    this.initElement(data, globalData, comp);
  }
  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);
  CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
  CVTextElement.prototype.buildNewText = function () {
    var documentData = this.textProperty.currentData;
    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
    var hasFill = false;
    if (documentData.fc) {
      hasFill = true;
      this.values.fill = this.buildColor(documentData.fc);
    } else {
      this.values.fill = 'rgba(0,0,0,0)';
    }
    this.fill = hasFill;
    var hasStroke = false;
    if (documentData.sc) {
      hasStroke = true;
      this.values.stroke = this.buildColor(documentData.sc);
      this.values.sWidth = documentData.sw;
    }
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    var i;
    var len;
    var letters = documentData.l;
    var matrixHelper = this.mHelper;
    this.stroke = hasStroke;
    this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
    len = documentData.finalText.length;
    // this.tHelper.font = this.values.fValue;
    var charData;
    var shapeData;
    var k;
    var kLen;
    var shapes;
    var j;
    var jLen;
    var pathNodes;
    var commands;
    var pathArr;
    var singleShape = this.data.singleShape;
    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
    var xPos = 0;
    var yPos = 0;
    var firstLine = true;
    var cnt = 0;
    for (i = 0; i < len; i += 1) {
      charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
      shapeData = charData && charData.data || {};
      matrixHelper.reset();
      if (singleShape && letters[i].n) {
        xPos = -trackingOffset;
        yPos += documentData.yOffset;
        yPos += firstLine ? 1 : 0;
        firstLine = false;
      }
      shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
      jLen = shapes.length;
      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
      if (singleShape) {
        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
      }
      commands = createSizedArray(jLen - 1);
      var commandsCounter = 0;
      for (j = 0; j < jLen; j += 1) {
        if (shapes[j].ty === 'sh') {
          kLen = shapes[j].ks.k.i.length;
          pathNodes = shapes[j].ks.k;
          pathArr = [];
          for (k = 1; k < kLen; k += 1) {
            if (k === 1) {
              pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
            }
            pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
          }
          pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
          commands[commandsCounter] = pathArr;
          commandsCounter += 1;
        }
      }
      if (singleShape) {
        xPos += letters[i].l;
        xPos += trackingOffset;
      }
      if (this.textSpans[cnt]) {
        this.textSpans[cnt].elem = commands;
      } else {
        this.textSpans[cnt] = {
          elem: commands
        };
      }
      cnt += 1;
    }
  };
  CVTextElement.prototype.renderInnerContent = function () {
    this.validateText();
    var ctx = this.canvasContext;
    ctx.font = this.values.fValue;
    this.globalData.renderer.ctxLineCap('butt');
    // ctx.lineCap = 'butt';
    this.globalData.renderer.ctxLineJoin('miter');
    // ctx.lineJoin = 'miter';
    this.globalData.renderer.ctxMiterLimit(4);
    // ctx.miterLimit = 4;

    if (!this.data.singleShape) {
      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
    }
    var i;
    var len;
    var j;
    var jLen;
    var k;
    var kLen;
    var renderedLetters = this.textAnimator.renderedLetters;
    var letters = this.textProperty.currentData.l;
    len = letters.length;
    var renderedLetter;
    var lastFill = null;
    var lastStroke = null;
    var lastStrokeW = null;
    var commands;
    var pathArr;
    var renderer = this.globalData.renderer;
    for (i = 0; i < len; i += 1) {
      if (!letters[i].n) {
        renderedLetter = renderedLetters[i];
        if (renderedLetter) {
          renderer.save();
          renderer.ctxTransform(renderedLetter.p);
          renderer.ctxOpacity(renderedLetter.o);
        }
        if (this.fill) {
          if (renderedLetter && renderedLetter.fc) {
            if (lastFill !== renderedLetter.fc) {
              renderer.ctxFillStyle(renderedLetter.fc);
              lastFill = renderedLetter.fc;
              // ctx.fillStyle = renderedLetter.fc;
            }
          } else if (lastFill !== this.values.fill) {
            lastFill = this.values.fill;
            renderer.ctxFillStyle(this.values.fill);
            // ctx.fillStyle = this.values.fill;
          }
          commands = this.textSpans[i].elem;
          jLen = commands.length;
          this.globalData.canvasContext.beginPath();
          for (j = 0; j < jLen; j += 1) {
            pathArr = commands[j];
            kLen = pathArr.length;
            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
            for (k = 2; k < kLen; k += 6) {
              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
            }
          }
          this.globalData.canvasContext.closePath();
          renderer.ctxFill();
          // this.globalData.canvasContext.fill();
          /// ctx.fillText(this.textSpans[i].val,0,0);
        }
        if (this.stroke) {
          if (renderedLetter && renderedLetter.sw) {
            if (lastStrokeW !== renderedLetter.sw) {
              lastStrokeW = renderedLetter.sw;
              renderer.ctxLineWidth(renderedLetter.sw);
              // ctx.lineWidth = renderedLetter.sw;
            }
          } else if (lastStrokeW !== this.values.sWidth) {
            lastStrokeW = this.values.sWidth;
            renderer.ctxLineWidth(this.values.sWidth);
            // ctx.lineWidth = this.values.sWidth;
          }
          if (renderedLetter && renderedLetter.sc) {
            if (lastStroke !== renderedLetter.sc) {
              lastStroke = renderedLetter.sc;
              renderer.ctxStrokeStyle(renderedLetter.sc);
              // ctx.strokeStyle = renderedLetter.sc;
            }
          } else if (lastStroke !== this.values.stroke) {
            lastStroke = this.values.stroke;
            renderer.ctxStrokeStyle(this.values.stroke);
            // ctx.strokeStyle = this.values.stroke;
          }
          commands = this.textSpans[i].elem;
          jLen = commands.length;
          this.globalData.canvasContext.beginPath();
          for (j = 0; j < jLen; j += 1) {
            pathArr = commands[j];
            kLen = pathArr.length;
            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
            for (k = 2; k < kLen; k += 6) {
              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
            }
          }
          this.globalData.canvasContext.closePath();
          renderer.ctxStroke();
          // this.globalData.canvasContext.stroke();
          /// ctx.strokeText(letters[i].val,0,0);
        }
        if (renderedLetter) {
          this.globalData.renderer.restore();
        }
      }
    }
  };

  function CVImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);
    this.img = globalData.imageLoader.getAsset(this.assetData);
    this.initElement(data, globalData, comp);
  }
  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
  CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
  CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
  CVImageElement.prototype.createContent = function () {
    if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
      var canvas = createTag('canvas');
      canvas.width = this.assetData.w;
      canvas.height = this.assetData.h;
      var ctx = canvas.getContext('2d');
      var imgW = this.img.width;
      var imgH = this.img.height;
      var imgRel = imgW / imgH;
      var canvasRel = this.assetData.w / this.assetData.h;
      var widthCrop;
      var heightCrop;
      var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
      if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
        heightCrop = imgH;
        widthCrop = heightCrop * canvasRel;
      } else {
        widthCrop = imgW;
        heightCrop = widthCrop / canvasRel;
      }
      ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
      this.img = canvas;
    }
  };
  CVImageElement.prototype.renderInnerContent = function () {
    this.canvasContext.drawImage(this.img, 0, 0);
  };
  CVImageElement.prototype.destroy = function () {
    this.img = null;
  };

  function CVSolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
  }
  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
  CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
  CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
  CVSolidElement.prototype.renderInnerContent = function () {
    // var ctx = this.canvasContext;
    this.globalData.renderer.ctxFillStyle(this.data.sc);
    // ctx.fillStyle = this.data.sc;
    this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
  };

  function CanvasRendererBase() {}
  extendPrototype([BaseRenderer], CanvasRendererBase);
  CanvasRendererBase.prototype.createShape = function (data) {
    return new CVShapeElement(data, this.globalData, this);
  };
  CanvasRendererBase.prototype.createText = function (data) {
    return new CVTextElement(data, this.globalData, this);
  };
  CanvasRendererBase.prototype.createImage = function (data) {
    return new CVImageElement(data, this.globalData, this);
  };
  CanvasRendererBase.prototype.createSolid = function (data) {
    return new CVSolidElement(data, this.globalData, this);
  };
  CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
  CanvasRendererBase.prototype.ctxTransform = function (props) {
    if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
      return;
    }
    this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
  };
  CanvasRendererBase.prototype.ctxOpacity = function (op) {
    this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
  };
  CanvasRendererBase.prototype.ctxFillStyle = function (value) {
    this.canvasContext.fillStyle = value;
  };
  CanvasRendererBase.prototype.ctxStrokeStyle = function (value) {
    this.canvasContext.strokeStyle = value;
  };
  CanvasRendererBase.prototype.ctxLineWidth = function (value) {
    this.canvasContext.lineWidth = value;
  };
  CanvasRendererBase.prototype.ctxLineCap = function (value) {
    this.canvasContext.lineCap = value;
  };
  CanvasRendererBase.prototype.ctxLineJoin = function (value) {
    this.canvasContext.lineJoin = value;
  };
  CanvasRendererBase.prototype.ctxMiterLimit = function (value) {
    this.canvasContext.miterLimit = value;
  };
  CanvasRendererBase.prototype.ctxFill = function (rule) {
    this.canvasContext.fill(rule);
  };
  CanvasRendererBase.prototype.ctxFillRect = function (x, y, w, h) {
    this.canvasContext.fillRect(x, y, w, h);
  };
  CanvasRendererBase.prototype.ctxStroke = function () {
    this.canvasContext.stroke();
  };
  CanvasRendererBase.prototype.reset = function () {
    if (!this.renderConfig.clearCanvas) {
      this.canvasContext.restore();
      return;
    }
    this.contextData.reset();
  };
  CanvasRendererBase.prototype.save = function () {
    this.canvasContext.save();
  };
  CanvasRendererBase.prototype.restore = function (actionFlag) {
    if (!this.renderConfig.clearCanvas) {
      this.canvasContext.restore();
      return;
    }
    if (actionFlag) {
      this.globalData.blendMode = 'source-over';
    }
    this.contextData.restore(actionFlag);
  };
  CanvasRendererBase.prototype.configAnimation = function (animData) {
    if (this.animationItem.wrapper) {
      this.animationItem.container = createTag('canvas');
      var containerStyle = this.animationItem.container.style;
      containerStyle.width = '100%';
      containerStyle.height = '100%';
      var origin = '0px 0px 0px';
      containerStyle.transformOrigin = origin;
      containerStyle.mozTransformOrigin = origin;
      containerStyle.webkitTransformOrigin = origin;
      containerStyle['-webkit-transform'] = origin;
      containerStyle.contentVisibility = this.renderConfig.contentVisibility;
      this.animationItem.wrapper.appendChild(this.animationItem.container);
      this.canvasContext = this.animationItem.container.getContext('2d');
      if (this.renderConfig.className) {
        this.animationItem.container.setAttribute('class', this.renderConfig.className);
      }
      if (this.renderConfig.id) {
        this.animationItem.container.setAttribute('id', this.renderConfig.id);
      }
    } else {
      this.canvasContext = this.renderConfig.context;
    }
    this.contextData.setContext(this.canvasContext);
    this.data = animData;
    this.layers = animData.layers;
    this.transformCanvas = {
      w: animData.w,
      h: animData.h,
      sx: 0,
      sy: 0,
      tx: 0,
      ty: 0
    };
    this.setupGlobalData(animData, document.body);
    this.globalData.canvasContext = this.canvasContext;
    this.globalData.renderer = this;
    this.globalData.isDashed = false;
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.globalData.transformCanvas = this.transformCanvas;
    this.elements = createSizedArray(animData.layers.length);
    this.updateContainerSize();
  };
  CanvasRendererBase.prototype.updateContainerSize = function (width, height) {
    this.reset();
    var elementWidth;
    var elementHeight;
    if (width) {
      elementWidth = width;
      elementHeight = height;
      this.canvasContext.canvas.width = elementWidth;
      this.canvasContext.canvas.height = elementHeight;
    } else {
      if (this.animationItem.wrapper && this.animationItem.container) {
        elementWidth = this.animationItem.wrapper.offsetWidth;
        elementHeight = this.animationItem.wrapper.offsetHeight;
      } else {
        elementWidth = this.canvasContext.canvas.width;
        elementHeight = this.canvasContext.canvas.height;
      }
      this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
      this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
    }
    var elementRel;
    var animationRel;
    if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
      var par = this.renderConfig.preserveAspectRatio.split(' ');
      var fillType = par[1] || 'meet';
      var pos = par[0] || 'xMidYMid';
      var xPos = pos.substr(0, 4);
      var yPos = pos.substr(4);
      elementRel = elementWidth / elementHeight;
      animationRel = this.transformCanvas.w / this.transformCanvas.h;
      if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
        this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
        this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
      } else {
        this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
        this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
      }
      if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
      } else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
      } else {
        this.transformCanvas.tx = 0;
      }
      if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
      } else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
      } else {
        this.transformCanvas.ty = 0;
      }
    } else if (this.renderConfig.preserveAspectRatio === 'none') {
      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
      this.transformCanvas.tx = 0;
      this.transformCanvas.ty = 0;
    } else {
      this.transformCanvas.sx = this.renderConfig.dpr;
      this.transformCanvas.sy = this.renderConfig.dpr;
      this.transformCanvas.tx = 0;
      this.transformCanvas.ty = 0;
    }
    this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
    /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */
    this.ctxTransform(this.transformCanvas.props);
    this.canvasContext.beginPath();
    this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
    this.canvasContext.closePath();
    this.canvasContext.clip();
    this.renderFrame(this.renderedFrame, true);
  };
  CanvasRendererBase.prototype.destroy = function () {
    if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
      this.animationItem.wrapper.innerText = '';
    }
    var i;
    var len = this.layers ? this.layers.length : 0;
    for (i = len - 1; i >= 0; i -= 1) {
      if (this.elements[i] && this.elements[i].destroy) {
        this.elements[i].destroy();
      }
    }
    this.elements.length = 0;
    this.globalData.canvasContext = null;
    this.animationItem.container = null;
    this.destroyed = true;
  };
  CanvasRendererBase.prototype.renderFrame = function (num, forceRender) {
    if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) {
      return;
    }
    this.renderedFrame = num;
    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
    this.globalData.frameId += 1;
    this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
    this.globalData.projectInterface.currentFrame = num;

    // console.log('--------');
    // console.log('NEW: ',num);
    var i;
    var len = this.layers.length;
    if (!this.completeLayers) {
      this.checkLayers(num);
    }
    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(num - this.layers[i].st);
      }
    }
    if (this.globalData._mdf) {
      if (this.renderConfig.clearCanvas === true) {
        this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
      } else {
        this.save();
      }
      for (i = len - 1; i >= 0; i -= 1) {
        if (this.completeLayers || this.elements[i]) {
          this.elements[i].renderFrame();
        }
      }
      if (this.renderConfig.clearCanvas !== true) {
        this.restore();
      }
    }
  };
  CanvasRendererBase.prototype.buildItem = function (pos) {
    var elements = this.elements;
    if (elements[pos] || this.layers[pos].ty === 99) {
      return;
    }
    var element = this.createItem(this.layers[pos], this, this.globalData);
    elements[pos] = element;
    element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */
  };
  CanvasRendererBase.prototype.checkPendingElements = function () {
    while (this.pendingElements.length) {
      var element = this.pendingElements.pop();
      element.checkParenting();
    }
  };
  CanvasRendererBase.prototype.hide = function () {
    this.animationItem.container.style.display = 'none';
  };
  CanvasRendererBase.prototype.show = function () {
    this.animationItem.container.style.display = 'block';
  };

  function CanvasContext() {
    this.opacity = -1;
    this.transform = createTypedArray('float32', 16);
    this.fillStyle = '';
    this.strokeStyle = '';
    this.lineWidth = '';
    this.lineCap = '';
    this.lineJoin = '';
    this.miterLimit = '';
    this.id = Math.random();
  }
  function CVContextData() {
    this.stack = [];
    this.cArrPos = 0;
    this.cTr = new Matrix();
    var i;
    var len = 15;
    for (i = 0; i < len; i += 1) {
      var canvasContext = new CanvasContext();
      this.stack[i] = canvasContext;
    }
    this._length = len;
    this.nativeContext = null;
    this.transformMat = new Matrix();
    this.currentOpacity = 1;
    //
    this.currentFillStyle = '';
    this.appliedFillStyle = '';
    //
    this.currentStrokeStyle = '';
    this.appliedStrokeStyle = '';
    //
    this.currentLineWidth = '';
    this.appliedLineWidth = '';
    //
    this.currentLineCap = '';
    this.appliedLineCap = '';
    //
    this.currentLineJoin = '';
    this.appliedLineJoin = '';
    //
    this.appliedMiterLimit = '';
    this.currentMiterLimit = '';
  }
  CVContextData.prototype.duplicate = function () {
    var newLength = this._length * 2;
    var i = 0;
    for (i = this._length; i < newLength; i += 1) {
      this.stack[i] = new CanvasContext();
    }
    this._length = newLength;
  };
  CVContextData.prototype.reset = function () {
    this.cArrPos = 0;
    this.cTr.reset();
    this.stack[this.cArrPos].opacity = 1;
  };
  CVContextData.prototype.restore = function (forceRestore) {
    this.cArrPos -= 1;
    var currentContext = this.stack[this.cArrPos];
    var transform = currentContext.transform;
    var i;
    var arr = this.cTr.props;
    for (i = 0; i < 16; i += 1) {
      arr[i] = transform[i];
    }
    if (forceRestore) {
      this.nativeContext.restore();
      var prevStack = this.stack[this.cArrPos + 1];
      this.appliedFillStyle = prevStack.fillStyle;
      this.appliedStrokeStyle = prevStack.strokeStyle;
      this.appliedLineWidth = prevStack.lineWidth;
      this.appliedLineCap = prevStack.lineCap;
      this.appliedLineJoin = prevStack.lineJoin;
      this.appliedMiterLimit = prevStack.miterLimit;
    }
    this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
    if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
      this.nativeContext.globalAlpha = currentContext.opacity;
      this.currentOpacity = currentContext.opacity;
    }
    this.currentFillStyle = currentContext.fillStyle;
    this.currentStrokeStyle = currentContext.strokeStyle;
    this.currentLineWidth = currentContext.lineWidth;
    this.currentLineCap = currentContext.lineCap;
    this.currentLineJoin = currentContext.lineJoin;
    this.currentMiterLimit = currentContext.miterLimit;
  };
  CVContextData.prototype.save = function (saveOnNativeFlag) {
    if (saveOnNativeFlag) {
      this.nativeContext.save();
    }
    var props = this.cTr.props;
    if (this._length <= this.cArrPos) {
      this.duplicate();
    }
    var currentStack = this.stack[this.cArrPos];
    var i;
    for (i = 0; i < 16; i += 1) {
      currentStack.transform[i] = props[i];
    }
    this.cArrPos += 1;
    var newStack = this.stack[this.cArrPos];
    newStack.opacity = currentStack.opacity;
    newStack.fillStyle = currentStack.fillStyle;
    newStack.strokeStyle = currentStack.strokeStyle;
    newStack.lineWidth = currentStack.lineWidth;
    newStack.lineCap = currentStack.lineCap;
    newStack.lineJoin = currentStack.lineJoin;
    newStack.miterLimit = currentStack.miterLimit;
  };
  CVContextData.prototype.setOpacity = function (value) {
    this.stack[this.cArrPos].opacity = value;
  };
  CVContextData.prototype.setContext = function (value) {
    this.nativeContext = value;
  };
  CVContextData.prototype.fillStyle = function (value) {
    if (this.stack[this.cArrPos].fillStyle !== value) {
      this.currentFillStyle = value;
      this.stack[this.cArrPos].fillStyle = value;
    }
  };
  CVContextData.prototype.strokeStyle = function (value) {
    if (this.stack[this.cArrPos].strokeStyle !== value) {
      this.currentStrokeStyle = value;
      this.stack[this.cArrPos].strokeStyle = value;
    }
  };
  CVContextData.prototype.lineWidth = function (value) {
    if (this.stack[this.cArrPos].lineWidth !== value) {
      this.currentLineWidth = value;
      this.stack[this.cArrPos].lineWidth = value;
    }
  };
  CVContextData.prototype.lineCap = function (value) {
    if (this.stack[this.cArrPos].lineCap !== value) {
      this.currentLineCap = value;
      this.stack[this.cArrPos].lineCap = value;
    }
  };
  CVContextData.prototype.lineJoin = function (value) {
    if (this.stack[this.cArrPos].lineJoin !== value) {
      this.currentLineJoin = value;
      this.stack[this.cArrPos].lineJoin = value;
    }
  };
  CVContextData.prototype.miterLimit = function (value) {
    if (this.stack[this.cArrPos].miterLimit !== value) {
      this.currentMiterLimit = value;
      this.stack[this.cArrPos].miterLimit = value;
    }
  };
  CVContextData.prototype.transform = function (props) {
    this.transformMat.cloneFromProps(props);
    // Taking the last transform value from the stored stack of transforms
    var currentTransform = this.cTr;
    // Applying the last transform value after the new transform to respect the order of transformations
    this.transformMat.multiply(currentTransform);
    // Storing the new transformed value in the stored transform
    currentTransform.cloneFromProps(this.transformMat.props);
    var trProps = currentTransform.props;
    // Applying the new transform to the canvas
    this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
  };
  CVContextData.prototype.opacity = function (op) {
    var currentOpacity = this.stack[this.cArrPos].opacity;
    currentOpacity *= op < 0 ? 0 : op;
    if (this.stack[this.cArrPos].opacity !== currentOpacity) {
      if (this.currentOpacity !== op) {
        this.nativeContext.globalAlpha = op;
        this.currentOpacity = op;
      }
      this.stack[this.cArrPos].opacity = currentOpacity;
    }
  };
  CVContextData.prototype.fill = function (rule) {
    if (this.appliedFillStyle !== this.currentFillStyle) {
      this.appliedFillStyle = this.currentFillStyle;
      this.nativeContext.fillStyle = this.appliedFillStyle;
    }
    this.nativeContext.fill(rule);
  };
  CVContextData.prototype.fillRect = function (x, y, w, h) {
    if (this.appliedFillStyle !== this.currentFillStyle) {
      this.appliedFillStyle = this.currentFillStyle;
      this.nativeContext.fillStyle = this.appliedFillStyle;
    }
    this.nativeContext.fillRect(x, y, w, h);
  };
  CVContextData.prototype.stroke = function () {
    if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
      this.appliedStrokeStyle = this.currentStrokeStyle;
      this.nativeContext.strokeStyle = this.appliedStrokeStyle;
    }
    if (this.appliedLineWidth !== this.currentLineWidth) {
      this.appliedLineWidth = this.currentLineWidth;
      this.nativeContext.lineWidth = this.appliedLineWidth;
    }
    if (this.appliedLineCap !== this.currentLineCap) {
      this.appliedLineCap = this.currentLineCap;
      this.nativeContext.lineCap = this.appliedLineCap;
    }
    if (this.appliedLineJoin !== this.currentLineJoin) {
      this.appliedLineJoin = this.currentLineJoin;
      this.nativeContext.lineJoin = this.appliedLineJoin;
    }
    if (this.appliedMiterLimit !== this.currentMiterLimit) {
      this.appliedMiterLimit = this.currentMiterLimit;
      this.nativeContext.miterLimit = this.appliedMiterLimit;
    }
    this.nativeContext.stroke();
  };

  function CVCompElement(data, globalData, comp) {
    this.completeLayers = false;
    this.layers = data.layers;
    this.pendingElements = [];
    this.elements = createSizedArray(this.layers.length);
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
  }
  extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement);
  CVCompElement.prototype.renderInnerContent = function () {
    var ctx = this.canvasContext;
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(this.data.w, 0);
    ctx.lineTo(this.data.w, this.data.h);
    ctx.lineTo(0, this.data.h);
    ctx.lineTo(0, 0);
    ctx.clip();
    var i;
    var len = this.layers.length;
    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  };
  CVCompElement.prototype.destroy = function () {
    var i;
    var len = this.layers.length;
    for (i = len - 1; i >= 0; i -= 1) {
      if (this.elements[i]) {
        this.elements[i].destroy();
      }
    }
    this.layers = null;
    this.elements = null;
  };
  CVCompElement.prototype.createComp = function (data) {
    return new CVCompElement(data, this.globalData, this);
  };

  function CanvasRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.renderConfig = {
      clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
      context: config && config.context || null,
      progressiveLoad: config && config.progressiveLoad || false,
      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      contentVisibility: config && config.contentVisibility || 'visible',
      className: config && config.className || '',
      id: config && config.id || '',
      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
    };
    this.renderConfig.dpr = config && config.dpr || 1;
    if (this.animationItem.wrapper) {
      this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
    }
    this.renderedFrame = -1;
    this.globalData = {
      frameNum: -1,
      _mdf: false,
      renderConfig: this.renderConfig,
      currentGlobalAlpha: -1
    };
    this.contextData = new CVContextData();
    this.elements = [];
    this.pendingElements = [];
    this.transformMat = new Matrix();
    this.completeLayers = false;
    this.rendererType = 'canvas';
    if (this.renderConfig.clearCanvas) {
      this.ctxTransform = this.contextData.transform.bind(this.contextData);
      this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
      this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
      this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
      this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
      this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
      this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
      this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
      this.ctxFill = this.contextData.fill.bind(this.contextData);
      this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
      this.ctxStroke = this.contextData.stroke.bind(this.contextData);
      this.save = this.contextData.save.bind(this.contextData);
    }
  }
  extendPrototype([CanvasRendererBase], CanvasRenderer);
  CanvasRenderer.prototype.createComp = function (data) {
    return new CVCompElement(data, this.globalData, this);
  };

  function HBaseElement() {}
  HBaseElement.prototype = {
    checkBlendMode: function checkBlendMode() {},
    initRendererElement: function initRendererElement() {
      this.baseElement = createTag(this.data.tg || 'div');
      if (this.data.hasMask) {
        this.svgElement = createNS('svg');
        this.layerElement = createNS('g');
        this.maskedElement = this.layerElement;
        this.svgElement.appendChild(this.layerElement);
        this.baseElement.appendChild(this.svgElement);
      } else {
        this.layerElement = this.baseElement;
      }
      styleDiv(this.baseElement);
    },
    createContainerElements: function createContainerElements() {
      this.renderableEffectsManager = new CVEffects(this);
      this.transformedElement = this.baseElement;
      this.maskedElement = this.layerElement;
      if (this.data.ln) {
        this.layerElement.setAttribute('id', this.data.ln);
      }
      if (this.data.cl) {
        this.layerElement.setAttribute('class', this.data.cl);
      }
      if (this.data.bm !== 0) {
        this.setBlendMode();
      }
    },
    renderElement: function renderElement() {
      var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
      if (this.finalTransform._matMdf) {
        var matrixValue = this.finalTransform.mat.toCSS();
        transformedElementStyle.transform = matrixValue;
        transformedElementStyle.webkitTransform = matrixValue;
      }
      if (this.finalTransform._opMdf) {
        transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
      }
    },
    renderFrame: function renderFrame() {
      // If it is exported as hidden (data.hd === true) no need to render
      // If it is not visible no need to render
      if (this.data.hd || this.hidden) {
        return;
      }
      this.renderTransform();
      this.renderRenderable();
      this.renderElement();
      this.renderInnerContent();
      if (this._isFirstFrame) {
        this._isFirstFrame = false;
      }
    },
    destroy: function destroy() {
      this.layerElement = null;
      this.transformedElement = null;
      if (this.matteElement) {
        this.matteElement = null;
      }
      if (this.maskManager) {
        this.maskManager.destroy();
        this.maskManager = null;
      }
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
    },
    addEffects: function addEffects() {},
    setMatte: function setMatte() {}
  };
  HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
  HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
  HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;

  function HSolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
  }
  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);
  HSolidElement.prototype.createContent = function () {
    var rect;
    if (this.data.hasMask) {
      rect = createNS('rect');
      rect.setAttribute('width', this.data.sw);
      rect.setAttribute('height', this.data.sh);
      rect.setAttribute('fill', this.data.sc);
      this.svgElement.setAttribute('width', this.data.sw);
      this.svgElement.setAttribute('height', this.data.sh);
    } else {
      rect = createTag('div');
      rect.style.width = this.data.sw + 'px';
      rect.style.height = this.data.sh + 'px';
      rect.style.backgroundColor = this.data.sc;
    }
    this.layerElement.appendChild(rect);
  };

  function HShapeElement(data, globalData, comp) {
    // List of drawable elements
    this.shapes = [];
    // Full shape data
    this.shapesData = data.shapes;
    // List of styles that will be applied to shapes
    this.stylesList = [];
    // List of modifiers that will be applied to shapes
    this.shapeModifiers = [];
    // List of items in shape tree
    this.itemsData = [];
    // List of items in previous shape tree
    this.processedElements = [];
    // List of animated components
    this.animatedContents = [];
    this.shapesContainer = createNS('g');
    this.initElement(data, globalData, comp);
    // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    // List of elements that have been created
    this.prevViewData = [];
    this.currentBBox = {
      x: 999999,
      y: -999999,
      h: 0,
      w: 0
    };
  }
  extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
  HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
  HShapeElement.prototype.createContent = function () {
    var cont;
    this.baseElement.style.fontSize = 0;
    if (this.data.hasMask) {
      this.layerElement.appendChild(this.shapesContainer);
      cont = this.svgElement;
    } else {
      cont = createNS('svg');
      var size = this.comp.data ? this.comp.data : this.globalData.compSize;
      cont.setAttribute('width', size.w);
      cont.setAttribute('height', size.h);
      cont.appendChild(this.shapesContainer);
      this.layerElement.appendChild(cont);
    }
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
    this.filterUniqueShapes();
    this.shapeCont = cont;
  };
  HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
    var i;
    var len = transformers.length;
    for (i = 0; i < len; i += 1) {
      point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
    }
    return point;
  };
  HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
    var shape = item.sh.v;
    var transformers = item.transformers;
    var i;
    var len = shape._length;
    var vPoint;
    var oPoint;
    var nextIPoint;
    var nextVPoint;
    if (len <= 1) {
      return;
    }
    for (i = 0; i < len - 1; i += 1) {
      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
      nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
      nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
    }
    if (shape.c) {
      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
      nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
      nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
    }
  };
  HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
    var bounds = this.shapeBoundingBox;
    boundingBox.x = bmMin(bounds.left, boundingBox.x);
    boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
    boundingBox.y = bmMin(bounds.top, boundingBox.y);
    boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
  };
  HShapeElement.prototype.shapeBoundingBox = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  };
  HShapeElement.prototype.tempBoundingBox = {
    x: 0,
    xMax: 0,
    y: 0,
    yMax: 0,
    width: 0,
    height: 0
  };
  HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
    var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];
    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {
      // eslint-disable-line no-plusplus
      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
      c = 3 * p1[i] - 3 * p0[i];
      b |= 0; // eslint-disable-line no-bitwise
      a |= 0; // eslint-disable-line no-bitwise
      c |= 0; // eslint-disable-line no-bitwise

      if (a === 0 && b === 0) {
        //
      } else if (a === 0) {
        t = -c / b;
        if (t > 0 && t < 1) {
          bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
        }
      } else {
        b2ac = b * b - 4 * c * a;
        if (b2ac >= 0) {
          t1 = (-b + bmSqrt(b2ac)) / (2 * a);
          if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
          t2 = (-b - bmSqrt(b2ac)) / (2 * a);
          if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
        }
      }
    }
    this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
    this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
    this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
    this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
  };
  HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
    return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
  };
  HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
    var i;
    var len = itemsData.length;
    for (i = 0; i < len; i += 1) {
      if (itemsData[i] && itemsData[i].sh) {
        this.calculateShapeBoundingBox(itemsData[i], boundingBox);
      } else if (itemsData[i] && itemsData[i].it) {
        this.calculateBoundingBox(itemsData[i].it, boundingBox);
      } else if (itemsData[i] && itemsData[i].style && itemsData[i].w) {
        this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
      }
    }
  };
  HShapeElement.prototype.expandStrokeBoundingBox = function (widthProperty, boundingBox) {
    var width = 0;
    if (widthProperty.keyframes) {
      for (var i = 0; i < widthProperty.keyframes.length; i += 1) {
        var kfw = widthProperty.keyframes[i].s;
        if (kfw > width) {
          width = kfw;
        }
      }
      width *= widthProperty.mult;
    } else {
      width = widthProperty.v * widthProperty.mult;
    }
    boundingBox.x -= width;
    boundingBox.xMax += width;
    boundingBox.y -= width;
    boundingBox.yMax += width;
  };
  HShapeElement.prototype.currentBoxContains = function (box) {
    return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
  };
  HShapeElement.prototype.renderInnerContent = function () {
    this._renderShapeFrame();
    if (!this.hidden && (this._isFirstFrame || this._mdf)) {
      var tempBoundingBox = this.tempBoundingBox;
      var max = 999999;
      tempBoundingBox.x = max;
      tempBoundingBox.xMax = -max;
      tempBoundingBox.y = max;
      tempBoundingBox.yMax = -max;
      this.calculateBoundingBox(this.itemsData, tempBoundingBox);
      tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
      tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
      // var tempBoundingBox = this.shapeCont.getBBox();
      if (this.currentBoxContains(tempBoundingBox)) {
        return;
      }
      var changed = false;
      if (this.currentBBox.w !== tempBoundingBox.width) {
        this.currentBBox.w = tempBoundingBox.width;
        this.shapeCont.setAttribute('width', tempBoundingBox.width);
        changed = true;
      }
      if (this.currentBBox.h !== tempBoundingBox.height) {
        this.currentBBox.h = tempBoundingBox.height;
        this.shapeCont.setAttribute('height', tempBoundingBox.height);
        changed = true;
      }
      if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
        this.currentBBox.w = tempBoundingBox.width;
        this.currentBBox.h = tempBoundingBox.height;
        this.currentBBox.x = tempBoundingBox.x;
        this.currentBBox.y = tempBoundingBox.y;
        this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
        var shapeStyle = this.shapeCont.style;
        var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
        shapeStyle.transform = shapeTransform;
        shapeStyle.webkitTransform = shapeTransform;
      }
    }
  };

  function HTextElement(data, globalData, comp) {
    this.textSpans = [];
    this.textPaths = [];
    this.currentBBox = {
      x: 999999,
      y: -999999,
      h: 0,
      w: 0
    };
    this.renderType = 'svg';
    this.isMasked = false;
    this.initElement(data, globalData, comp);
  }
  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);
  HTextElement.prototype.createContent = function () {
    this.isMasked = this.checkMasks();
    if (this.isMasked) {
      this.renderType = 'svg';
      this.compW = this.comp.data.w;
      this.compH = this.comp.data.h;
      this.svgElement.setAttribute('width', this.compW);
      this.svgElement.setAttribute('height', this.compH);
      var g = createNS('g');
      this.maskedElement.appendChild(g);
      this.innerElem = g;
    } else {
      this.renderType = 'html';
      this.innerElem = this.layerElement;
    }
    this.checkParenting();
  };
  HTextElement.prototype.buildNewText = function () {
    var documentData = this.textProperty.currentData;
    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
    var innerElemStyle = this.innerElem.style;
    var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
    innerElemStyle.fill = textColor;
    innerElemStyle.color = textColor;
    if (documentData.sc) {
      innerElemStyle.stroke = this.buildColor(documentData.sc);
      innerElemStyle.strokeWidth = documentData.sw + 'px';
    }
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    if (!this.globalData.fontManager.chars) {
      innerElemStyle.fontSize = documentData.finalSize + 'px';
      innerElemStyle.lineHeight = documentData.finalSize + 'px';
      if (fontData.fClass) {
        this.innerElem.className = fontData.fClass;
      } else {
        innerElemStyle.fontFamily = fontData.fFamily;
        var fWeight = documentData.fWeight;
        var fStyle = documentData.fStyle;
        innerElemStyle.fontStyle = fStyle;
        innerElemStyle.fontWeight = fWeight;
      }
    }
    var i;
    var len;
    var letters = documentData.l;
    len = letters.length;
    var tSpan;
    var tParent;
    var tCont;
    var matrixHelper = this.mHelper;
    var shapes;
    var shapeStr = '';
    var cnt = 0;
    for (i = 0; i < len; i += 1) {
      if (this.globalData.fontManager.chars) {
        if (!this.textPaths[cnt]) {
          tSpan = createNS('path');
          tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
          tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
          tSpan.setAttribute('stroke-miterlimit', '4');
        } else {
          tSpan = this.textPaths[cnt];
        }
        if (!this.isMasked) {
          if (this.textSpans[cnt]) {
            tParent = this.textSpans[cnt];
            tCont = tParent.children[0];
          } else {
            tParent = createTag('div');
            tParent.style.lineHeight = 0;
            tCont = createNS('svg');
            tCont.appendChild(tSpan);
            styleDiv(tParent);
          }
        }
      } else if (!this.isMasked) {
        if (this.textSpans[cnt]) {
          tParent = this.textSpans[cnt];
          tSpan = this.textPaths[cnt];
        } else {
          tParent = createTag('span');
          styleDiv(tParent);
          tSpan = createTag('span');
          styleDiv(tSpan);
          tParent.appendChild(tSpan);
        }
      } else {
        tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
      }
      // tSpan.setAttribute('visibility', 'hidden');
      if (this.globalData.fontManager.chars) {
        var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
        var shapeData;
        if (charData) {
          shapeData = charData.data;
        } else {
          shapeData = null;
        }
        matrixHelper.reset();
        if (shapeData && shapeData.shapes && shapeData.shapes.length) {
          shapes = shapeData.shapes[0].it;
          matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
          shapeStr = this.createPathShape(matrixHelper, shapes);
          tSpan.setAttribute('d', shapeStr);
        }
        if (!this.isMasked) {
          this.innerElem.appendChild(tParent);
          if (shapeData && shapeData.shapes) {
            // document.body.appendChild is needed to get exact measure of shape
            document.body.appendChild(tCont);
            var boundingBox = tCont.getBBox();
            tCont.setAttribute('width', boundingBox.width + 2);
            tCont.setAttribute('height', boundingBox.height + 2);
            tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
            var tContStyle = tCont.style;
            var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
            tContStyle.transform = tContTranslation;
            tContStyle.webkitTransform = tContTranslation;
            letters[i].yOffset = boundingBox.y - 1;
          } else {
            tCont.setAttribute('width', 1);
            tCont.setAttribute('height', 1);
          }
          tParent.appendChild(tCont);
        } else {
          this.innerElem.appendChild(tSpan);
        }
      } else {
        tSpan.textContent = letters[i].val;
        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
        if (!this.isMasked) {
          this.innerElem.appendChild(tParent);
          //
          var tStyle = tSpan.style;
          var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
          tStyle.transform = tSpanTranslation;
          tStyle.webkitTransform = tSpanTranslation;
        } else {
          this.innerElem.appendChild(tSpan);
        }
      }
      //
      if (!this.isMasked) {
        this.textSpans[cnt] = tParent;
      } else {
        this.textSpans[cnt] = tSpan;
      }
      this.textSpans[cnt].style.display = 'block';
      this.textPaths[cnt] = tSpan;
      cnt += 1;
    }
    while (cnt < this.textSpans.length) {
      this.textSpans[cnt].style.display = 'none';
      cnt += 1;
    }
  };
  HTextElement.prototype.renderInnerContent = function () {
    this.validateText();
    var svgStyle;
    if (this.data.singleShape) {
      if (!this._isFirstFrame && !this.lettersChangedFlag) {
        return;
      }
      if (this.isMasked && this.finalTransform._matMdf) {
        // Todo Benchmark if using this is better than getBBox
        this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
        svgStyle = this.svgElement.style;
        var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
        svgStyle.transform = translation;
        svgStyle.webkitTransform = translation;
      }
    }
    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
    if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
      return;
    }
    var i;
    var len;
    var count = 0;
    var renderedLetters = this.textAnimator.renderedLetters;
    var letters = this.textProperty.currentData.l;
    len = letters.length;
    var renderedLetter;
    var textSpan;
    var textPath;
    for (i = 0; i < len; i += 1) {
      if (letters[i].n) {
        count += 1;
      } else {
        textSpan = this.textSpans[i];
        textPath = this.textPaths[i];
        renderedLetter = renderedLetters[count];
        count += 1;
        if (renderedLetter._mdf.m) {
          if (!this.isMasked) {
            textSpan.style.webkitTransform = renderedLetter.m;
            textSpan.style.transform = renderedLetter.m;
          } else {
            textSpan.setAttribute('transform', renderedLetter.m);
          }
        }
        /// /textSpan.setAttribute('opacity',renderedLetter.o);
        textSpan.style.opacity = renderedLetter.o;
        if (renderedLetter.sw && renderedLetter._mdf.sw) {
          textPath.setAttribute('stroke-width', renderedLetter.sw);
        }
        if (renderedLetter.sc && renderedLetter._mdf.sc) {
          textPath.setAttribute('stroke', renderedLetter.sc);
        }
        if (renderedLetter.fc && renderedLetter._mdf.fc) {
          textPath.setAttribute('fill', renderedLetter.fc);
          textPath.style.color = renderedLetter.fc;
        }
      }
    }
    if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
      var boundingBox = this.innerElem.getBBox();
      if (this.currentBBox.w !== boundingBox.width) {
        this.currentBBox.w = boundingBox.width;
        this.svgElement.setAttribute('width', boundingBox.width);
      }
      if (this.currentBBox.h !== boundingBox.height) {
        this.currentBBox.h = boundingBox.height;
        this.svgElement.setAttribute('height', boundingBox.height);
      }
      var margin = 1;
      if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
        this.currentBBox.w = boundingBox.width + margin * 2;
        this.currentBBox.h = boundingBox.height + margin * 2;
        this.currentBBox.x = boundingBox.x - margin;
        this.currentBBox.y = boundingBox.y - margin;
        this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
        svgStyle = this.svgElement.style;
        var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
        svgStyle.transform = svgTransform;
        svgStyle.webkitTransform = svgTransform;
      }
    }
  };

  function HCameraElement(data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initHierarchy();
    var getProp = PropertyFactory.getProp;
    this.pe = getProp(this, data.pe, 0, 0, this);
    if (data.ks.p.s) {
      this.px = getProp(this, data.ks.p.x, 1, 0, this);
      this.py = getProp(this, data.ks.p.y, 1, 0, this);
      this.pz = getProp(this, data.ks.p.z, 1, 0, this);
    } else {
      this.p = getProp(this, data.ks.p, 1, 0, this);
    }
    if (data.ks.a) {
      this.a = getProp(this, data.ks.a, 1, 0, this);
    }
    if (data.ks.or.k.length && data.ks.or.k[0].to) {
      var i;
      var len = data.ks.or.k.length;
      for (i = 0; i < len; i += 1) {
        data.ks.or.k[i].to = null;
        data.ks.or.k[i].ti = null;
      }
    }
    this.or = getProp(this, data.ks.or, 1, degToRads, this);
    this.or.sh = true;
    this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
    this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
    this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
    this.mat = new Matrix();
    this._prevMat = new Matrix();
    this._isFirstFrame = true;

    // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
    this.finalTransform = {
      mProp: this
    };
  }
  extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);
  HCameraElement.prototype.setup = function () {
    var i;
    var len = this.comp.threeDElements.length;
    var comp;
    var perspectiveStyle;
    var containerStyle;
    for (i = 0; i < len; i += 1) {
      // [perspectiveElem,container]
      comp = this.comp.threeDElements[i];
      if (comp.type === '3d') {
        perspectiveStyle = comp.perspectiveElem.style;
        containerStyle = comp.container.style;
        var perspective = this.pe.v + 'px';
        var origin = '0px 0px 0px';
        var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
        perspectiveStyle.perspective = perspective;
        perspectiveStyle.webkitPerspective = perspective;
        containerStyle.transformOrigin = origin;
        containerStyle.mozTransformOrigin = origin;
        containerStyle.webkitTransformOrigin = origin;
        perspectiveStyle.transform = matrix;
        perspectiveStyle.webkitTransform = matrix;
      }
    }
  };
  HCameraElement.prototype.createElements = function () {};
  HCameraElement.prototype.hide = function () {};
  HCameraElement.prototype.renderFrame = function () {
    var _mdf = this._isFirstFrame;
    var i;
    var len;
    if (this.hierarchy) {
      len = this.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
      }
    }
    if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
      this.mat.reset();
      if (this.hierarchy) {
        len = this.hierarchy.length - 1;
        for (i = len; i >= 0; i -= 1) {
          var mTransf = this.hierarchy[i].finalTransform.mProp;
          this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
          this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
          this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
          this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
          this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
        }
      }
      if (this.p) {
        this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
      } else {
        this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
      }
      if (this.a) {
        var diffVector;
        if (this.p) {
          diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
        } else {
          diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
        }
        var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2));
        // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
        var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
        var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
        var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
        var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
        this.mat.rotateY(mRotationY).rotateX(-mRotationX);
      }
      this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
      this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
      this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
      this.mat.translate(0, 0, this.pe.v);
      var hasMatrixChanged = !this._prevMat.equals(this.mat);
      if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
        len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;
        for (i = 0; i < len; i += 1) {
          comp = this.comp.threeDElements[i];
          if (comp.type === '3d') {
            if (hasMatrixChanged) {
              var matValue = this.mat.toCSS();
              containerStyle = comp.container.style;
              containerStyle.transform = matValue;
              containerStyle.webkitTransform = matValue;
            }
            if (this.pe._mdf) {
              perspectiveStyle = comp.perspectiveElem.style;
              perspectiveStyle.perspective = this.pe.v + 'px';
              perspectiveStyle.webkitPerspective = this.pe.v + 'px';
            }
          }
        }
        this.mat.clone(this._prevMat);
      }
    }
    this._isFirstFrame = false;
  };
  HCameraElement.prototype.prepareFrame = function (num) {
    this.prepareProperties(num, true);
  };
  HCameraElement.prototype.destroy = function () {};
  HCameraElement.prototype.getBaseElement = function () {
    return null;
  };

  function HImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);
    this.initElement(data, globalData, comp);
  }
  extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);
  HImageElement.prototype.createContent = function () {
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    var img = new Image();
    if (this.data.hasMask) {
      this.imageElem = createNS('image');
      this.imageElem.setAttribute('width', this.assetData.w + 'px');
      this.imageElem.setAttribute('height', this.assetData.h + 'px');
      this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
      this.layerElement.appendChild(this.imageElem);
      this.baseElement.setAttribute('width', this.assetData.w);
      this.baseElement.setAttribute('height', this.assetData.h);
    } else {
      this.layerElement.appendChild(img);
    }
    img.crossOrigin = 'anonymous';
    img.src = assetPath;
    if (this.data.ln) {
      this.baseElement.setAttribute('id', this.data.ln);
    }
  };

  function HybridRendererBase(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.renderConfig = {
      className: config && config.className || '',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      hideOnTransparent: !(config && config.hideOnTransparent === false),
      filterSize: {
        width: config && config.filterSize && config.filterSize.width || '400%',
        height: config && config.filterSize && config.filterSize.height || '400%',
        x: config && config.filterSize && config.filterSize.x || '-100%',
        y: config && config.filterSize && config.filterSize.y || '-100%'
      }
    };
    this.globalData = {
      _mdf: false,
      frameNum: -1,
      renderConfig: this.renderConfig
    };
    this.pendingElements = [];
    this.elements = [];
    this.threeDElements = [];
    this.destroyed = false;
    this.camera = null;
    this.supports3d = true;
    this.rendererType = 'html';
  }
  extendPrototype([BaseRenderer], HybridRendererBase);
  HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
  HybridRendererBase.prototype.checkPendingElements = function () {
    while (this.pendingElements.length) {
      var element = this.pendingElements.pop();
      element.checkParenting();
    }
  };
  HybridRendererBase.prototype.appendElementInPos = function (element, pos) {
    var newDOMElement = element.getBaseElement();
    if (!newDOMElement) {
      return;
    }
    var layer = this.layers[pos];
    if (!layer.ddd || !this.supports3d) {
      if (this.threeDElements) {
        this.addTo3dContainer(newDOMElement, pos);
      } else {
        var i = 0;
        var nextDOMElement;
        var nextLayer;
        var tmpDOMElement;
        while (i < pos) {
          if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
            nextLayer = this.elements[i];
            tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
            nextDOMElement = tmpDOMElement || nextDOMElement;
          }
          i += 1;
        }
        if (nextDOMElement) {
          if (!layer.ddd || !this.supports3d) {
            this.layerElement.insertBefore(newDOMElement, nextDOMElement);
          }
        } else if (!layer.ddd || !this.supports3d) {
          this.layerElement.appendChild(newDOMElement);
        }
      }
    } else {
      this.addTo3dContainer(newDOMElement, pos);
    }
  };
  HybridRendererBase.prototype.createShape = function (data) {
    if (!this.supports3d) {
      return new SVGShapeElement(data, this.globalData, this);
    }
    return new HShapeElement(data, this.globalData, this);
  };
  HybridRendererBase.prototype.createText = function (data) {
    if (!this.supports3d) {
      return new SVGTextLottieElement(data, this.globalData, this);
    }
    return new HTextElement(data, this.globalData, this);
  };
  HybridRendererBase.prototype.createCamera = function (data) {
    this.camera = new HCameraElement(data, this.globalData, this);
    return this.camera;
  };
  HybridRendererBase.prototype.createImage = function (data) {
    if (!this.supports3d) {
      return new IImageElement(data, this.globalData, this);
    }
    return new HImageElement(data, this.globalData, this);
  };
  HybridRendererBase.prototype.createSolid = function (data) {
    if (!this.supports3d) {
      return new ISolidElement(data, this.globalData, this);
    }
    return new HSolidElement(data, this.globalData, this);
  };
  HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
  HybridRendererBase.prototype.getThreeDContainerByPos = function (pos) {
    var i = 0;
    var len = this.threeDElements.length;
    while (i < len) {
      if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
        return this.threeDElements[i].perspectiveElem;
      }
      i += 1;
    }
    return null;
  };
  HybridRendererBase.prototype.createThreeDContainer = function (pos, type) {
    var perspectiveElem = createTag('div');
    var style;
    var containerStyle;
    styleDiv(perspectiveElem);
    var container = createTag('div');
    styleDiv(container);
    if (type === '3d') {
      style = perspectiveElem.style;
      style.width = this.globalData.compSize.w + 'px';
      style.height = this.globalData.compSize.h + 'px';
      var center = '50% 50%';
      style.webkitTransformOrigin = center;
      style.mozTransformOrigin = center;
      style.transformOrigin = center;
      containerStyle = container.style;
      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
      containerStyle.transform = matrix;
      containerStyle.webkitTransform = matrix;
    }
    perspectiveElem.appendChild(container);
    // this.resizerElem.appendChild(perspectiveElem);
    var threeDContainerData = {
      container: container,
      perspectiveElem: perspectiveElem,
      startPos: pos,
      endPos: pos,
      type: type
    };
    this.threeDElements.push(threeDContainerData);
    return threeDContainerData;
  };
  HybridRendererBase.prototype.build3dContainers = function () {
    var i;
    var len = this.layers.length;
    var lastThreeDContainerData;
    var currentContainer = '';
    for (i = 0; i < len; i += 1) {
      if (this.layers[i].ddd && this.layers[i].ty !== 3) {
        if (currentContainer !== '3d') {
          currentContainer = '3d';
          lastThreeDContainerData = this.createThreeDContainer(i, '3d');
        }
        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
      } else {
        if (currentContainer !== '2d') {
          currentContainer = '2d';
          lastThreeDContainerData = this.createThreeDContainer(i, '2d');
        }
        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
      }
    }
    len = this.threeDElements.length;
    for (i = len - 1; i >= 0; i -= 1) {
      this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    }
  };
  HybridRendererBase.prototype.addTo3dContainer = function (elem, pos) {
    var i = 0;
    var len = this.threeDElements.length;
    while (i < len) {
      if (pos <= this.threeDElements[i].endPos) {
        var j = this.threeDElements[i].startPos;
        var nextElement;
        while (j < pos) {
          if (this.elements[j] && this.elements[j].getBaseElement) {
            nextElement = this.elements[j].getBaseElement();
          }
          j += 1;
        }
        if (nextElement) {
          this.threeDElements[i].container.insertBefore(elem, nextElement);
        } else {
          this.threeDElements[i].container.appendChild(elem);
        }
        break;
      }
      i += 1;
    }
  };
  HybridRendererBase.prototype.configAnimation = function (animData) {
    var resizerElem = createTag('div');
    var wrapper = this.animationItem.wrapper;
    var style = resizerElem.style;
    style.width = animData.w + 'px';
    style.height = animData.h + 'px';
    this.resizerElem = resizerElem;
    styleDiv(resizerElem);
    style.transformStyle = 'flat';
    style.mozTransformStyle = 'flat';
    style.webkitTransformStyle = 'flat';
    if (this.renderConfig.className) {
      resizerElem.setAttribute('class', this.renderConfig.className);
    }
    wrapper.appendChild(resizerElem);
    style.overflow = 'hidden';
    var svg = createNS('svg');
    svg.setAttribute('width', '1');
    svg.setAttribute('height', '1');
    styleDiv(svg);
    this.resizerElem.appendChild(svg);
    var defs = createNS('defs');
    svg.appendChild(defs);
    this.data = animData;
    // Mask animation
    this.setupGlobalData(animData, svg);
    this.globalData.defs = defs;
    this.layers = animData.layers;
    this.layerElement = this.resizerElem;
    this.build3dContainers();
    this.updateContainerSize();
  };
  HybridRendererBase.prototype.destroy = function () {
    if (this.animationItem.wrapper) {
      this.animationItem.wrapper.innerText = '';
    }
    this.animationItem.container = null;
    this.globalData.defs = null;
    var i;
    var len = this.layers ? this.layers.length : 0;
    for (i = 0; i < len; i += 1) {
      if (this.elements[i] && this.elements[i].destroy) {
        this.elements[i].destroy();
      }
    }
    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
  };
  HybridRendererBase.prototype.updateContainerSize = function () {
    var elementWidth = this.animationItem.wrapper.offsetWidth;
    var elementHeight = this.animationItem.wrapper.offsetHeight;
    var elementRel = elementWidth / elementHeight;
    var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
    var sx;
    var sy;
    var tx;
    var ty;
    if (animationRel > elementRel) {
      sx = elementWidth / this.globalData.compSize.w;
      sy = elementWidth / this.globalData.compSize.w;
      tx = 0;
      ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
    } else {
      sx = elementHeight / this.globalData.compSize.h;
      sy = elementHeight / this.globalData.compSize.h;
      tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
      ty = 0;
    }
    var style = this.resizerElem.style;
    style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
    style.transform = style.webkitTransform;
  };
  HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
  HybridRendererBase.prototype.hide = function () {
    this.resizerElem.style.display = 'none';
  };
  HybridRendererBase.prototype.show = function () {
    this.resizerElem.style.display = 'block';
  };
  HybridRendererBase.prototype.initItems = function () {
    this.buildAllItems();
    if (this.camera) {
      this.camera.setup();
    } else {
      var cWidth = this.globalData.compSize.w;
      var cHeight = this.globalData.compSize.h;
      var i;
      var len = this.threeDElements.length;
      for (i = 0; i < len; i += 1) {
        var style = this.threeDElements[i].perspectiveElem.style;
        style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
        style.perspective = style.webkitPerspective;
      }
    }
  };
  HybridRendererBase.prototype.searchExtraCompositions = function (assets) {
    var i;
    var len = assets.length;
    var floatingContainer = createTag('div');
    for (i = 0; i < len; i += 1) {
      if (assets[i].xt) {
        var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
        comp.initExpressions();
        this.globalData.projectInterface.registerComposition(comp);
      }
    }
  };

  function HCompElement(data, globalData, comp) {
    this.layers = data.layers;
    this.supports3d = !data.hasMask;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
  }
  extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement);
  HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
  HCompElement.prototype.createContainerElements = function () {
    this._createBaseContainerElements();
    // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
    if (this.data.hasMask) {
      this.svgElement.setAttribute('width', this.data.w);
      this.svgElement.setAttribute('height', this.data.h);
      this.transformedElement = this.baseElement;
    } else {
      this.transformedElement = this.layerElement;
    }
  };
  HCompElement.prototype.addTo3dContainer = function (elem, pos) {
    var j = 0;
    var nextElement;
    while (j < pos) {
      if (this.elements[j] && this.elements[j].getBaseElement) {
        nextElement = this.elements[j].getBaseElement();
      }
      j += 1;
    }
    if (nextElement) {
      this.layerElement.insertBefore(elem, nextElement);
    } else {
      this.layerElement.appendChild(elem);
    }
  };
  HCompElement.prototype.createComp = function (data) {
    if (!this.supports3d) {
      return new SVGCompElement(data, this.globalData, this);
    }
    return new HCompElement(data, this.globalData, this);
  };

  function HybridRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.renderConfig = {
      className: config && config.className || '',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      hideOnTransparent: !(config && config.hideOnTransparent === false),
      filterSize: {
        width: config && config.filterSize && config.filterSize.width || '400%',
        height: config && config.filterSize && config.filterSize.height || '400%',
        x: config && config.filterSize && config.filterSize.x || '-100%',
        y: config && config.filterSize && config.filterSize.y || '-100%'
      },
      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
    };
    this.globalData = {
      _mdf: false,
      frameNum: -1,
      renderConfig: this.renderConfig
    };
    this.pendingElements = [];
    this.elements = [];
    this.threeDElements = [];
    this.destroyed = false;
    this.camera = null;
    this.supports3d = true;
    this.rendererType = 'html';
  }
  extendPrototype([HybridRendererBase], HybridRenderer);
  HybridRenderer.prototype.createComp = function (data) {
    if (!this.supports3d) {
      return new SVGCompElement(data, this.globalData, this);
    }
    return new HCompElement(data, this.globalData, this);
  };

  var CompExpressionInterface = function () {
    return function (comp) {
      function _thisLayerFunction(name) {
        var i = 0;
        var len = comp.layers.length;
        while (i < len) {
          if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
            return comp.elements[i].layerInterface;
          }
          i += 1;
        }
        return null;
        // return {active:false};
      }
      Object.defineProperty(_thisLayerFunction, '_name', {
        value: comp.data.nm
      });
      _thisLayerFunction.layer = _thisLayerFunction;
      _thisLayerFunction.pixelAspect = 1;
      _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
      _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
      _thisLayerFunction.pixelAspect = 1;
      _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
      _thisLayerFunction.displayStartTime = 0;
      _thisLayerFunction.numLayers = comp.layers.length;
      return _thisLayerFunction;
    };
  }();

  function _typeof$2(o) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$2(o); }
  /* eslint-disable */
  /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */

  function seedRandom(pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var global = this,
      width = 256,
      // each RC4 output is 0 <= x < 256
      chunks = 6,
      // at least six RC4 outputs for each double
      digits = 52,
      // there are 52 significant digits in a double
      rngname = 'random',
      // rngname: name for Math.random and Math.seedrandom
      startdenom = math.pow(width, chunks),
      significance = math.pow(2, digits),
      overflow = significance * 2,
      mask = width - 1,
      nodecrypto; // node.js crypto module, initialized at the bottom.

    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
      var key = [];
      options = options === true ? {
        entropy: true
      } : options || {};

      // Flatten the seed string or build one from local entropy if needed.
      var shortseed = mixkey(flatten(options.entropy ? [seed, tostring(pool)] : seed === null ? autoseed() : seed, 3), key);

      // Use the seed to initialize an ARC4 generator.
      var arc4 = new ARC4(key);

      // This function returns a random double in [0, 1) that contains
      // randomness in every bit of the mantissa of the IEEE 754 value.
      var prng = function prng() {
        var n = arc4.g(chunks),
          // Start with a numerator n < 2 ^ 48
          d = startdenom,
          //   and denominator d = 2 ^ 48.
          x = 0; //   and no 'extra last byte'.
        while (n < significance) {
          // Fill up all significant digits by
          n = (n + x) * width; //   shifting numerator and
          d *= width; //   denominator and generating a
          x = arc4.g(1); //   new least-significant-byte.
        }
        while (n >= overflow) {
          // To avoid rounding up, before adding
          n /= 2; //   last byte, shift everything
          d /= 2; //   right using integer math until
          x >>>= 1; //   we have exactly the desired bits.
        }
        return (n + x) / d; // Form the number within [0, 1).
      };
      prng.int32 = function () {
        return arc4.g(4) | 0;
      };
      prng.quick = function () {
        return arc4.g(4) / 0x100000000;
      };
      prng["double"] = prng;

      // Mix the randomness into accumulated entropy.
      mixkey(tostring(arc4.S), pool);

      // Calling convention: what to return as a function of prng, seed, is_math.
      return (options.pass || callback || function (prng, seed, is_math_call, state) {
        if (state) {
          // Load the arc4 state from the given state if it has an S array.
          if (state.S) {
            copy(state, arc4);
          }
          // Only provide the .state method if requested via options.state.
          prng.state = function () {
            return copy(arc4, {});
          };
        }

        // If called as a method of Math (Math.seedrandom()), mutate
        // Math.random because that is how seedrandom.js has worked since v1.0.
        if (is_math_call) {
          math[rngname] = prng;
          return seed;
        }

        // Otherwise, it is a newer calling convention, so return the
        // prng directly.
        else return prng;
      })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }
    math['seed' + rngname] = seedrandom;

    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
      var t,
        keylen = key.length,
        me = this,
        i = 0,
        j = me.i = me.j = 0,
        s = me.S = [];

      // The empty key [] is treated as [0].
      if (!keylen) {
        key = [keylen++];
      }

      // Set up S using the standard key scheduling algorithm.
      while (i < width) {
        s[i] = i++;
      }
      for (i = 0; i < width; i++) {
        s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
        s[j] = t;
      }

      // The "g" method returns the next (count) outputs as one number.
      me.g = function (count) {
        // Using instance members instead of closure state nearly doubles speed.
        var t,
          r = 0,
          i = me.i,
          j = me.j,
          s = me.S;
        while (count--) {
          t = s[i = mask & i + 1];
          r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
        }
        me.i = i;
        me.j = j;
        return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
      };
    }

    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
      t.i = f.i;
      t.j = f.j;
      t.S = f.S.slice();
      return t;
    }

    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
      var result = [],
        typ = _typeof$2(obj),
        prop;
      if (depth && typ == 'object') {
        for (prop in obj) {
          try {
            result.push(flatten(obj[prop], depth - 1));
          } catch (e) {}
        }
      }
      return result.length ? result : typ == 'string' ? obj : obj + '\0';
    }

    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
      var stringseed = seed + '',
        smear,
        j = 0;
      while (j < stringseed.length) {
        key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
      }
      return tostring(key);
    }

    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
      try {
        if (nodecrypto) {
          return tostring(nodecrypto.randomBytes(width));
        }
        var out = new Uint8Array(width);
        (global.crypto || global.msCrypto).getRandomValues(out);
        return tostring(out);
      } catch (e) {
        var browser = global.navigator,
          plugins = browser && browser.plugins;
        return [+new Date(), global, plugins, global.screen, tostring(pool)];
      }
    }

    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
      return String.fromCharCode.apply(0, a);
    }

    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);

    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //

    // End anonymous scope, and pass initial values.
  }
  ;
  function initialize$2(BMMath) {
    seedRandom([], BMMath);
  }

  var propTypes = {
    SHAPE: 'shape'
  };

  function _typeof$1(o) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$1(o); }
  var ExpressionManager = function () {
    'use strict';

    var ob = {};
    var Math = BMMath;
    var window = null;
    var document = null;
    var XMLHttpRequest = null;
    var fetch = null;
    var frames = null;
    var _lottieGlobal = {};
    initialize$2(BMMath);
    function resetFrame() {
      _lottieGlobal = {};
    }
    function $bm_isInstanceOfArray(arr) {
      return arr.constructor === Array || arr.constructor === Float32Array;
    }
    function isNumerable(tOfV, v) {
      return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
    }
    function $bm_neg(a) {
      var tOfA = _typeof$1(a);
      if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') {
        return -a;
      }
      if ($bm_isInstanceOfArray(a)) {
        var i;
        var lenA = a.length;
        var retArr = [];
        for (i = 0; i < lenA; i += 1) {
          retArr[i] = -a[i];
        }
        return retArr;
      }
      if (a.propType) {
        return a.v;
      }
      return -a;
    }
    var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
    var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
    var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
    function sum(a, b) {
      var tOfA = _typeof$1(a);
      var tOfB = _typeof$1(b);
      if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') {
        return a + b;
      }
      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        a = a.slice(0);
        a[0] += b;
        return a;
      }
      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        b = b.slice(0);
        b[0] = a + b[0];
        return b;
      }
      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
        var i = 0;
        var lenA = a.length;
        var lenB = b.length;
        var retArr = [];
        while (i < lenA || i < lenB) {
          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
            retArr[i] = a[i] + b[i];
          } else {
            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
          }
          i += 1;
        }
        return retArr;
      }
      return 0;
    }
    var add = sum;
    function sub(a, b) {
      var tOfA = _typeof$1(a);
      var tOfB = _typeof$1(b);
      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
        if (tOfA === 'string') {
          a = parseInt(a, 10);
        }
        if (tOfB === 'string') {
          b = parseInt(b, 10);
        }
        return a - b;
      }
      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        a = a.slice(0);
        a[0] -= b;
        return a;
      }
      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        b = b.slice(0);
        b[0] = a - b[0];
        return b;
      }
      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
        var i = 0;
        var lenA = a.length;
        var lenB = b.length;
        var retArr = [];
        while (i < lenA || i < lenB) {
          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
            retArr[i] = a[i] - b[i];
          } else {
            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
          }
          i += 1;
        }
        return retArr;
      }
      return 0;
    }
    function mul(a, b) {
      var tOfA = _typeof$1(a);
      var tOfB = _typeof$1(b);
      var arr;
      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
        return a * b;
      }
      var i;
      var len;
      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        len = a.length;
        arr = createTypedArray('float32', len);
        for (i = 0; i < len; i += 1) {
          arr[i] = a[i] * b;
        }
        return arr;
      }
      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        len = b.length;
        arr = createTypedArray('float32', len);
        for (i = 0; i < len; i += 1) {
          arr[i] = a * b[i];
        }
        return arr;
      }
      return 0;
    }
    function div(a, b) {
      var tOfA = _typeof$1(a);
      var tOfB = _typeof$1(b);
      var arr;
      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
        return a / b;
      }
      var i;
      var len;
      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        len = a.length;
        arr = createTypedArray('float32', len);
        for (i = 0; i < len; i += 1) {
          arr[i] = a[i] / b;
        }
        return arr;
      }
      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        len = b.length;
        arr = createTypedArray('float32', len);
        for (i = 0; i < len; i += 1) {
          arr[i] = a / b[i];
        }
        return arr;
      }
      return 0;
    }
    function mod(a, b) {
      if (typeof a === 'string') {
        a = parseInt(a, 10);
      }
      if (typeof b === 'string') {
        b = parseInt(b, 10);
      }
      return a % b;
    }
    var $bm_sum = sum;
    var $bm_sub = sub;
    var $bm_mul = mul;
    var $bm_div = div;
    var $bm_mod = mod;
    function clamp(num, min, max) {
      if (min > max) {
        var mm = max;
        max = min;
        min = mm;
      }
      return Math.min(Math.max(num, min), max);
    }
    function radiansToDegrees(val) {
      return val / degToRads;
    }
    var radians_to_degrees = radiansToDegrees;
    function degreesToRadians(val) {
      return val * degToRads;
    }
    var degrees_to_radians = radiansToDegrees;
    var helperLengthArray = [0, 0, 0, 0, 0, 0];
    function length(arr1, arr2) {
      if (typeof arr1 === 'number' || arr1 instanceof Number) {
        arr2 = arr2 || 0;
        return Math.abs(arr1 - arr2);
      }
      if (!arr2) {
        arr2 = helperLengthArray;
      }
      var i;
      var len = Math.min(arr1.length, arr2.length);
      var addedLength = 0;
      for (i = 0; i < len; i += 1) {
        addedLength += Math.pow(arr2[i] - arr1[i], 2);
      }
      return Math.sqrt(addedLength);
    }
    function normalize(vec) {
      return div(vec, length(vec));
    }
    function rgbToHsl(val) {
      var r = val[0];
      var g = val[1];
      var b = val[2];
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var h;
      var s;
      var l = (max + min) / 2;
      if (max === min) {
        h = 0; // achromatic
        s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
          default:
            break;
        }
        h /= 6;
      }
      return [h, s, l, val[3]];
    }
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    function hslToRgb(val) {
      var h = val[0];
      var s = val[1];
      var l = val[2];
      var r;
      var g;
      var b;
      if (s === 0) {
        r = l; // achromatic
        b = l; // achromatic
        g = l; // achromatic
      } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }
      return [r, g, b, val[3]];
    }
    function linear(t, tMin, tMax, value1, value2) {
      if (value1 === undefined || value2 === undefined) {
        value1 = tMin;
        value2 = tMax;
        tMin = 0;
        tMax = 1;
      }
      if (tMax < tMin) {
        var _tMin = tMax;
        tMax = tMin;
        tMin = _tMin;
      }
      if (t <= tMin) {
        return value1;
      }
      if (t >= tMax) {
        return value2;
      }
      var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
      if (!value1.length) {
        return value1 + (value2 - value1) * perc;
      }
      var i;
      var len = value1.length;
      var arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
      }
      return arr;
    }
    function random(min, max) {
      if (max === undefined) {
        if (min === undefined) {
          min = 0;
          max = 1;
        } else {
          max = min;
          min = undefined;
        }
      }
      if (max.length) {
        var i;
        var len = max.length;
        if (!min) {
          min = createTypedArray('float32', len);
        }
        var arr = createTypedArray('float32', len);
        var rnd = BMMath.random();
        for (i = 0; i < len; i += 1) {
          arr[i] = min[i] + rnd * (max[i] - min[i]);
        }
        return arr;
      }
      if (min === undefined) {
        min = 0;
      }
      var rndm = BMMath.random();
      return min + rndm * (max - min);
    }
    function createPath(points, inTangents, outTangents, closed) {
      var i;
      var len = points.length;
      var path = shapePool.newElement();
      path.setPathData(!!closed, len);
      var arrPlaceholder = [0, 0];
      var inVertexPoint;
      var outVertexPoint;
      for (i = 0; i < len; i += 1) {
        inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
        outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
        path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
      }
      return path;
    }
    function initiateExpression(elem, data, property) {
      // Bail out if we don't want expressions
      function noOp(_value) {
        return _value;
      }
      if (!elem.globalData.renderConfig.runExpressions) {
        return noOp;
      }
      var val = data.x;
      var needsVelocity = /velocity(?![\w\d])/.test(val);
      var _needsRandom = val.indexOf('random') !== -1;
      var elemType = elem.data.ty;
      var transform;
      var $bm_transform;
      var content;
      var effect;
      var thisProperty = property;
      thisProperty._name = elem.data.nm;
      thisProperty.valueAtTime = thisProperty.getValueAtTime;
      Object.defineProperty(thisProperty, 'value', {
        get: function get() {
          return thisProperty.v;
        }
      });
      elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
      elem.comp.displayStartTime = 0;
      var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
      var outPoint = elem.data.op / elem.comp.globalData.frameRate;
      var width = elem.data.sw ? elem.data.sw : 0;
      var height = elem.data.sh ? elem.data.sh : 0;
      var name = elem.data.nm;
      var loopIn;
      var loop_in;
      var loopOut;
      var loop_out;
      var smooth;
      var toWorld;
      var fromWorld;
      var fromComp;
      var toComp;
      var fromCompToSurface;
      var position;
      var rotation;
      var anchorPoint;
      var scale;
      var thisLayer;
      var thisComp;
      var mask;
      var valueAtTime;
      var velocityAtTime;
      var scoped_bm_rt;
      // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
      var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
      var numKeys = property.kf ? data.k.length : 0;
      var active = !this.data || this.data.hd !== true;
      var wiggle = function wiggle(freq, amp) {
        var iWiggle;
        var j;
        var lenWiggle = this.pv.length ? this.pv.length : 1;
        var addedAmps = createTypedArray('float32', lenWiggle);
        freq = 5;
        var iterations = Math.floor(time * freq);
        iWiggle = 0;
        j = 0;
        while (iWiggle < iterations) {
          // var rnd = BMMath.random();
          for (j = 0; j < lenWiggle; j += 1) {
            addedAmps[j] += -amp + amp * 2 * BMMath.random();
            // addedAmps[j] += -amp + amp*2*rnd;
          }
          iWiggle += 1;
        }
        // var rnd2 = BMMath.random();
        var periods = time * freq;
        var perc = periods - Math.floor(periods);
        var arr = createTypedArray('float32', lenWiggle);
        if (lenWiggle > 1) {
          for (j = 0; j < lenWiggle; j += 1) {
            arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc;
            // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
            // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
          }
          return arr;
        }
        return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
      }.bind(this);
      if (thisProperty.loopIn) {
        loopIn = thisProperty.loopIn.bind(thisProperty);
        loop_in = loopIn;
      }
      if (thisProperty.loopOut) {
        loopOut = thisProperty.loopOut.bind(thisProperty);
        loop_out = loopOut;
      }
      if (thisProperty.smooth) {
        smooth = thisProperty.smooth.bind(thisProperty);
      }
      function loopInDuration(type, duration) {
        return loopIn(type, duration, true);
      }
      function loopOutDuration(type, duration) {
        return loopOut(type, duration, true);
      }
      if (this.getValueAtTime) {
        valueAtTime = this.getValueAtTime.bind(this);
      }
      if (this.getVelocityAtTime) {
        velocityAtTime = this.getVelocityAtTime.bind(this);
      }
      var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
      function lookAt(elem1, elem2) {
        var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
        var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
        var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
        return [yaw, pitch, 0];
      }
      function easeOut(t, tMin, tMax, val1, val2) {
        return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
      }
      function easeIn(t, tMin, tMax, val1, val2) {
        return applyEase(easeInBez, t, tMin, tMax, val1, val2);
      }
      function ease(t, tMin, tMax, val1, val2) {
        return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
      }
      function applyEase(fn, t, tMin, tMax, val1, val2) {
        if (val1 === undefined) {
          val1 = tMin;
          val2 = tMax;
        } else {
          t = (t - tMin) / (tMax - tMin);
        }
        if (t > 1) {
          t = 1;
        } else if (t < 0) {
          t = 0;
        }
        var mult = fn(t);
        if ($bm_isInstanceOfArray(val1)) {
          var iKey;
          var lenKey = val1.length;
          var arr = createTypedArray('float32', lenKey);
          for (iKey = 0; iKey < lenKey; iKey += 1) {
            arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
          }
          return arr;
        }
        return (val2 - val1) * mult + val1;
      }
      function nearestKey(time) {
        var iKey;
        var lenKey = data.k.length;
        var index;
        var keyTime;
        if (!data.k.length || typeof data.k[0] === 'number') {
          index = 0;
          keyTime = 0;
        } else {
          index = -1;
          time *= elem.comp.globalData.frameRate;
          if (time < data.k[0].t) {
            index = 1;
            keyTime = data.k[0].t;
          } else {
            for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
              if (time === data.k[iKey].t) {
                index = iKey + 1;
                keyTime = data.k[iKey].t;
                break;
              } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                  index = iKey + 2;
                  keyTime = data.k[iKey + 1].t;
                } else {
                  index = iKey + 1;
                  keyTime = data.k[iKey].t;
                }
                break;
              }
            }
            if (index === -1) {
              index = iKey + 1;
              keyTime = data.k[iKey].t;
            }
          }
        }
        var obKey = {};
        obKey.index = index;
        obKey.time = keyTime / elem.comp.globalData.frameRate;
        return obKey;
      }
      function key(ind) {
        var obKey;
        var iKey;
        var lenKey;
        if (!data.k.length || typeof data.k[0] === 'number') {
          throw new Error('The property has no keyframe at index ' + ind);
        }
        ind -= 1;
        obKey = {
          time: data.k[ind].t / elem.comp.globalData.frameRate,
          value: []
        };
        var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
        lenKey = arr.length;
        for (iKey = 0; iKey < lenKey; iKey += 1) {
          obKey[iKey] = arr[iKey];
          obKey.value[iKey] = arr[iKey];
        }
        return obKey;
      }
      function framesToTime(fr, fps) {
        if (!fps) {
          fps = elem.comp.globalData.frameRate;
        }
        return fr / fps;
      }
      function timeToFrames(t, fps) {
        if (!t && t !== 0) {
          t = time;
        }
        if (!fps) {
          fps = elem.comp.globalData.frameRate;
        }
        return t * fps;
      }
      function seedRandom(seed) {
        BMMath.seedrandom(randSeed + seed);
      }
      function sourceRectAtTime() {
        return elem.sourceRectAtTime();
      }
      function substring(init, end) {
        if (typeof value === 'string') {
          if (end === undefined) {
            return value.substring(init);
          }
          return value.substring(init, end);
        }
        return '';
      }
      function substr(init, end) {
        if (typeof value === 'string') {
          if (end === undefined) {
            return value.substr(init);
          }
          return value.substr(init, end);
        }
        return '';
      }
      function posterizeTime(framesPerSecond) {
        time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
        value = valueAtTime(time);
      }
      var time;
      var velocity;
      var value;
      var text;
      var textIndex;
      var textTotal;
      var selectorValue;
      var index = elem.data.ind;
      var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
      var parent;
      var randSeed = Math.floor(Math.random() * 1000000);
      var globalData = elem.globalData;
      function executeExpression(_value) {
        // globalData.pushExpression();
        value = _value;
        if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
          return value;
        }
        if (this.propType === 'textSelector') {
          textIndex = this.textIndex;
          textTotal = this.textTotal;
          selectorValue = this.selectorValue;
        }
        if (!thisLayer) {
          text = elem.layerInterface.text;
          thisLayer = elem.layerInterface;
          thisComp = elem.comp.compInterface;
          toWorld = thisLayer.toWorld.bind(thisLayer);
          fromWorld = thisLayer.fromWorld.bind(thisLayer);
          fromComp = thisLayer.fromComp.bind(thisLayer);
          toComp = thisLayer.toComp.bind(thisLayer);
          mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
          fromCompToSurface = fromComp;
        }
        if (!transform) {
          transform = elem.layerInterface('ADBE Transform Group');
          $bm_transform = transform;
          if (transform) {
            anchorPoint = transform.anchorPoint;
            /* position = transform.position;
                      rotation = transform.rotation;
                      scale = transform.scale; */
          }
        }
        if (elemType === 4 && !content) {
          content = thisLayer('ADBE Root Vectors Group');
        }
        if (!effect) {
          effect = thisLayer(4);
        }
        hasParent = !!(elem.hierarchy && elem.hierarchy.length);
        if (hasParent && !parent) {
          parent = elem.hierarchy[0].layerInterface;
        }
        time = this.comp.renderedFrame / this.comp.globalData.frameRate;
        if (_needsRandom) {
          seedRandom(randSeed + time);
        }
        if (needsVelocity) {
          velocity = velocityAtTime(time);
        }
        expression_function();
        this.frameExpressionId = elem.globalData.frameId;

        // TODO: Check if it's possible to return on ShapeInterface the .v value
        // Changed this to a ternary operation because Rollup failed compiling it correctly
        scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
        return scoped_bm_rt;
      }
      // Bundlers will see these as dead code and unless we reference them
      executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData];
      return executeExpression;
    }
    ob.initiateExpression = initiateExpression;
    ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal];
    ob.resetFrame = resetFrame;
    return ob;
  }();

  var Expressions = function () {
    var ob = {};
    ob.initExpressions = initExpressions;
    ob.resetFrame = ExpressionManager.resetFrame;
    function initExpressions(animation) {
      var stackCount = 0;
      var registers = [];
      function pushExpression() {
        stackCount += 1;
      }
      function popExpression() {
        stackCount -= 1;
        if (stackCount === 0) {
          releaseInstances();
        }
      }
      function registerExpressionProperty(expression) {
        if (registers.indexOf(expression) === -1) {
          registers.push(expression);
        }
      }
      function releaseInstances() {
        var i;
        var len = registers.length;
        for (i = 0; i < len; i += 1) {
          registers[i].release();
        }
        registers.length = 0;
      }
      animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
      animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
      animation.renderer.globalData.pushExpression = pushExpression;
      animation.renderer.globalData.popExpression = popExpression;
      animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
    }
    return ob;
  }();

  var MaskManagerInterface = function () {
    function MaskInterface(mask, data) {
      this._mask = mask;
      this._data = data;
    }
    Object.defineProperty(MaskInterface.prototype, 'maskPath', {
      get: function get() {
        if (this._mask.prop.k) {
          this._mask.prop.getValue();
        }
        return this._mask.prop;
      }
    });
    Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
      get: function get() {
        if (this._mask.op.k) {
          this._mask.op.getValue();
        }
        return this._mask.op.v * 100;
      }
    });
    var MaskManager = function MaskManager(maskManager) {
      var _masksInterfaces = createSizedArray(maskManager.viewData.length);
      var i;
      var len = maskManager.viewData.length;
      for (i = 0; i < len; i += 1) {
        _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
      }
      var maskFunction = function maskFunction(name) {
        i = 0;
        while (i < len) {
          if (maskManager.masksProperties[i].nm === name) {
            return _masksInterfaces[i];
          }
          i += 1;
        }
        return null;
      };
      return maskFunction;
    };
    return MaskManager;
  }();

  var ExpressionPropertyInterface = function () {
    var defaultUnidimensionalValue = {
      pv: 0,
      v: 0,
      mult: 1
    };
    var defaultMultidimensionalValue = {
      pv: [0, 0, 0],
      v: [0, 0, 0],
      mult: 1
    };
    function completeProperty(expressionValue, property, type) {
      Object.defineProperty(expressionValue, 'velocity', {
        get: function get() {
          return property.getVelocityAtTime(property.comp.currentFrame);
        }
      });
      expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
      expressionValue.key = function (pos) {
        if (!expressionValue.numKeys) {
          return 0;
        }
        var value = '';
        if ('s' in property.keyframes[pos - 1]) {
          value = property.keyframes[pos - 1].s;
        } else if ('e' in property.keyframes[pos - 2]) {
          value = property.keyframes[pos - 2].e;
        } else {
          value = property.keyframes[pos - 2].s;
        }
        var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
        valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
        valueProp.value = type === 'unidimensional' ? value[0] : value;
        return valueProp;
      };
      expressionValue.valueAtTime = property.getValueAtTime;
      expressionValue.speedAtTime = property.getSpeedAtTime;
      expressionValue.velocityAtTime = property.getVelocityAtTime;
      expressionValue.propertyGroup = property.propertyGroup;
    }
    function UnidimensionalPropertyInterface(property) {
      if (!property || !('pv' in property)) {
        property = defaultUnidimensionalValue;
      }
      var mult = 1 / property.mult;
      var val = property.pv * mult;
      var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
      expressionValue.value = val;
      completeProperty(expressionValue, property, 'unidimensional');
      return function () {
        if (property.k) {
          property.getValue();
        }
        val = property.v * mult;
        if (expressionValue.value !== val) {
          expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
          expressionValue.value = val;
          expressionValue[0] = val;
          completeProperty(expressionValue, property, 'unidimensional');
        }
        return expressionValue;
      };
    }
    function MultidimensionalPropertyInterface(property) {
      if (!property || !('pv' in property)) {
        property = defaultMultidimensionalValue;
      }
      var mult = 1 / property.mult;
      var len = property.data && property.data.l || property.pv.length;
      var expressionValue = createTypedArray('float32', len);
      var arrValue = createTypedArray('float32', len);
      expressionValue.value = arrValue;
      completeProperty(expressionValue, property, 'multidimensional');
      return function () {
        if (property.k) {
          property.getValue();
        }
        for (var i = 0; i < len; i += 1) {
          arrValue[i] = property.v[i] * mult;
          expressionValue[i] = arrValue[i];
        }
        return expressionValue;
      };
    }

    // TODO: try to avoid using this getter
    function defaultGetter() {
      return defaultUnidimensionalValue;
    }
    return function (property) {
      if (!property) {
        return defaultGetter;
      }
      if (property.propType === 'unidimensional') {
        return UnidimensionalPropertyInterface(property);
      }
      return MultidimensionalPropertyInterface(property);
    };
  }();

  var TransformExpressionInterface = function () {
    return function (transform) {
      function _thisFunction(name) {
        switch (name) {
          case 'scale':
          case 'Scale':
          case 'ADBE Scale':
          case 6:
            return _thisFunction.scale;
          case 'rotation':
          case 'Rotation':
          case 'ADBE Rotation':
          case 'ADBE Rotate Z':
          case 10:
            return _thisFunction.rotation;
          case 'ADBE Rotate X':
            return _thisFunction.xRotation;
          case 'ADBE Rotate Y':
            return _thisFunction.yRotation;
          case 'position':
          case 'Position':
          case 'ADBE Position':
          case 2:
            return _thisFunction.position;
          case 'ADBE Position_0':
            return _thisFunction.xPosition;
          case 'ADBE Position_1':
            return _thisFunction.yPosition;
          case 'ADBE Position_2':
            return _thisFunction.zPosition;
          case 'anchorPoint':
          case 'AnchorPoint':
          case 'Anchor Point':
          case 'ADBE AnchorPoint':
          case 1:
            return _thisFunction.anchorPoint;
          case 'opacity':
          case 'Opacity':
          case 11:
            return _thisFunction.opacity;
          default:
            return null;
        }
      }
      Object.defineProperty(_thisFunction, 'rotation', {
        get: ExpressionPropertyInterface(transform.r || transform.rz)
      });
      Object.defineProperty(_thisFunction, 'zRotation', {
        get: ExpressionPropertyInterface(transform.rz || transform.r)
      });
      Object.defineProperty(_thisFunction, 'xRotation', {
        get: ExpressionPropertyInterface(transform.rx)
      });
      Object.defineProperty(_thisFunction, 'yRotation', {
        get: ExpressionPropertyInterface(transform.ry)
      });
      Object.defineProperty(_thisFunction, 'scale', {
        get: ExpressionPropertyInterface(transform.s)
      });
      var _px;
      var _py;
      var _pz;
      var _transformFactory;
      if (transform.p) {
        _transformFactory = ExpressionPropertyInterface(transform.p);
      } else {
        _px = ExpressionPropertyInterface(transform.px);
        _py = ExpressionPropertyInterface(transform.py);
        if (transform.pz) {
          _pz = ExpressionPropertyInterface(transform.pz);
        }
      }
      Object.defineProperty(_thisFunction, 'position', {
        get: function get() {
          if (transform.p) {
            return _transformFactory();
          }
          return [_px(), _py(), _pz ? _pz() : 0];
        }
      });
      Object.defineProperty(_thisFunction, 'xPosition', {
        get: ExpressionPropertyInterface(transform.px)
      });
      Object.defineProperty(_thisFunction, 'yPosition', {
        get: ExpressionPropertyInterface(transform.py)
      });
      Object.defineProperty(_thisFunction, 'zPosition', {
        get: ExpressionPropertyInterface(transform.pz)
      });
      Object.defineProperty(_thisFunction, 'anchorPoint', {
        get: ExpressionPropertyInterface(transform.a)
      });
      Object.defineProperty(_thisFunction, 'opacity', {
        get: ExpressionPropertyInterface(transform.o)
      });
      Object.defineProperty(_thisFunction, 'skew', {
        get: ExpressionPropertyInterface(transform.sk)
      });
      Object.defineProperty(_thisFunction, 'skewAxis', {
        get: ExpressionPropertyInterface(transform.sa)
      });
      Object.defineProperty(_thisFunction, 'orientation', {
        get: ExpressionPropertyInterface(transform.or)
      });
      return _thisFunction;
    };
  }();

  var LayerExpressionInterface = function () {
    function getMatrix(time) {
      var toWorldMat = new Matrix();
      if (time !== undefined) {
        var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
        propMatrix.clone(toWorldMat);
      } else {
        var transformMat = this._elem.finalTransform.mProp;
        transformMat.applyToMatrix(toWorldMat);
      }
      return toWorldMat;
    }
    function toWorldVec(arr, time) {
      var toWorldMat = this.getMatrix(time);
      toWorldMat.props[12] = 0;
      toWorldMat.props[13] = 0;
      toWorldMat.props[14] = 0;
      return this.applyPoint(toWorldMat, arr);
    }
    function toWorld(arr, time) {
      var toWorldMat = this.getMatrix(time);
      return this.applyPoint(toWorldMat, arr);
    }
    function fromWorldVec(arr, time) {
      var toWorldMat = this.getMatrix(time);
      toWorldMat.props[12] = 0;
      toWorldMat.props[13] = 0;
      toWorldMat.props[14] = 0;
      return this.invertPoint(toWorldMat, arr);
    }
    function fromWorld(arr, time) {
      var toWorldMat = this.getMatrix(time);
      return this.invertPoint(toWorldMat, arr);
    }
    function applyPoint(matrix, arr) {
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i;
        var len = this._elem.hierarchy.length;
        for (i = 0; i < len; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
        }
      }
      return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
    }
    function invertPoint(matrix, arr) {
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i;
        var len = this._elem.hierarchy.length;
        for (i = 0; i < len; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
        }
      }
      return matrix.inversePoint(arr);
    }
    function fromComp(arr) {
      var toWorldMat = new Matrix();
      toWorldMat.reset();
      this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i;
        var len = this._elem.hierarchy.length;
        for (i = 0; i < len; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
        }
        return toWorldMat.inversePoint(arr);
      }
      return toWorldMat.inversePoint(arr);
    }
    function sampleImage() {
      return [1, 1, 1, 1];
    }
    return function (elem) {
      var transformInterface;
      function _registerMaskInterface(maskManager) {
        _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
      }
      function _registerEffectsInterface(effects) {
        _thisLayerFunction.effect = effects;
      }
      function _thisLayerFunction(name) {
        switch (name) {
          case 'ADBE Root Vectors Group':
          case 'Contents':
          case 2:
            return _thisLayerFunction.shapeInterface;
          case 1:
          case 6:
          case 'Transform':
          case 'transform':
          case 'ADBE Transform Group':
            return transformInterface;
          case 4:
          case 'ADBE Effect Parade':
          case 'effects':
          case 'Effects':
            return _thisLayerFunction.effect;
          case 'ADBE Text Properties':
            return _thisLayerFunction.textInterface;
          default:
            return null;
        }
      }
      _thisLayerFunction.getMatrix = getMatrix;
      _thisLayerFunction.invertPoint = invertPoint;
      _thisLayerFunction.applyPoint = applyPoint;
      _thisLayerFunction.toWorld = toWorld;
      _thisLayerFunction.toWorldVec = toWorldVec;
      _thisLayerFunction.fromWorld = fromWorld;
      _thisLayerFunction.fromWorldVec = fromWorldVec;
      _thisLayerFunction.toComp = toWorld;
      _thisLayerFunction.fromComp = fromComp;
      _thisLayerFunction.sampleImage = sampleImage;
      _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
      _thisLayerFunction._elem = elem;
      transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
      var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
      Object.defineProperties(_thisLayerFunction, {
        hasParent: {
          get: function get() {
            return elem.hierarchy.length;
          }
        },
        parent: {
          get: function get() {
            return elem.hierarchy[0].layerInterface;
          }
        },
        rotation: getDescriptor(transformInterface, 'rotation'),
        scale: getDescriptor(transformInterface, 'scale'),
        position: getDescriptor(transformInterface, 'position'),
        opacity: getDescriptor(transformInterface, 'opacity'),
        anchorPoint: anchorPointDescriptor,
        anchor_point: anchorPointDescriptor,
        transform: {
          get: function get() {
            return transformInterface;
          }
        },
        active: {
          get: function get() {
            return elem.isInRange;
          }
        }
      });
      _thisLayerFunction.startTime = elem.data.st;
      _thisLayerFunction.index = elem.data.ind;
      _thisLayerFunction.source = elem.data.refId;
      _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
      _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
      _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
      _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
      _thisLayerFunction._name = elem.data.nm;
      _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
      _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
      return _thisLayerFunction;
    };
  }();

  var propertyGroupFactory = function () {
    return function (interfaceFunction, parentPropertyGroup) {
      return function (val) {
        val = val === undefined ? 1 : val;
        if (val <= 0) {
          return interfaceFunction;
        }
        return parentPropertyGroup(val - 1);
      };
    };
  }();

  var PropertyInterface = function () {
    return function (propertyName, propertyGroup) {
      var interfaceFunction = {
        _name: propertyName
      };
      function _propertyGroup(val) {
        val = val === undefined ? 1 : val;
        if (val <= 0) {
          return interfaceFunction;
        }
        return propertyGroup(val - 1);
      }
      return _propertyGroup;
    };
  }();

  var EffectsExpressionInterface = function () {
    var ob = {
      createEffectsInterface: createEffectsInterface
    };
    function createEffectsInterface(elem, propertyGroup) {
      if (elem.effectsManager) {
        var effectElements = [];
        var effectsData = elem.data.ef;
        var i;
        var len = elem.effectsManager.effectElements.length;
        for (i = 0; i < len; i += 1) {
          effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
        }
        var effects = elem.data.ef || [];
        var groupInterface = function groupInterface(name) {
          i = 0;
          len = effects.length;
          while (i < len) {
            if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
              return effectElements[i];
            }
            i += 1;
          }
          return null;
        };
        Object.defineProperty(groupInterface, 'numProperties', {
          get: function get() {
            return effects.length;
          }
        });
        return groupInterface;
      }
      return null;
    }
    function createGroupInterface(data, elements, propertyGroup, elem) {
      function groupInterface(name) {
        var effects = data.ef;
        var i = 0;
        var len = effects.length;
        while (i < len) {
          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
            if (effects[i].ty === 5) {
              return effectElements[i];
            }
            return effectElements[i]();
          }
          i += 1;
        }
        throw new Error();
      }
      var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
      var effectElements = [];
      var i;
      var len = data.ef.length;
      for (i = 0; i < len; i += 1) {
        if (data.ef[i].ty === 5) {
          effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
        } else {
          effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
        }
      }
      if (data.mn === 'ADBE Color Control') {
        Object.defineProperty(groupInterface, 'color', {
          get: function get() {
            return effectElements[0]();
          }
        });
      }
      Object.defineProperties(groupInterface, {
        numProperties: {
          get: function get() {
            return data.np;
          }
        },
        _name: {
          value: data.nm
        },
        propertyGroup: {
          value: _propertyGroup
        }
      });
      groupInterface.enabled = data.en !== 0;
      groupInterface.active = groupInterface.enabled;
      return groupInterface;
    }
    function createValueInterface(element, type, elem, propertyGroup) {
      var expressionProperty = ExpressionPropertyInterface(element.p);
      function interfaceFunction() {
        if (type === 10) {
          return elem.comp.compInterface(element.p.v);
        }
        return expressionProperty();
      }
      if (element.p.setGroupProperty) {
        element.p.setGroupProperty(PropertyInterface('', propertyGroup));
      }
      return interfaceFunction;
    }
    return ob;
  }();

  var ShapePathInterface = function () {
    return function pathInterfaceFactory(shape, view, propertyGroup) {
      var prop = view.sh;
      function interfaceFunction(val) {
        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
          return interfaceFunction.path;
        }
        return null;
      }
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        path: {
          get: function get() {
            if (prop.k) {
              prop.getValue();
            }
            return prop;
          }
        },
        shape: {
          get: function get() {
            if (prop.k) {
              prop.getValue();
            }
            return prop;
          }
        },
        _name: {
          value: shape.nm
        },
        ix: {
          value: shape.ix
        },
        propertyIndex: {
          value: shape.ix
        },
        mn: {
          value: shape.mn
        },
        propertyGroup: {
          value: propertyGroup
        }
      });
      return interfaceFunction;
    };
  }();

  var ShapeExpressionInterface = function () {
    function iterateElements(shapes, view, propertyGroup) {
      var arr = [];
      var i;
      var len = shapes ? shapes.length : 0;
      for (i = 0; i < len; i += 1) {
        if (shapes[i].ty === 'gr') {
          arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'fl') {
          arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'st') {
          arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'tm') {
          arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'tr') {
          // arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
        } else if (shapes[i].ty === 'el') {
          arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'sr') {
          arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'sh') {
          arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'rc') {
          arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'rd') {
          arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'rp') {
          arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'gf') {
          arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else {
          arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
        }
      }
      return arr;
    }
    function contentsInterfaceFactory(shape, view, propertyGroup) {
      var interfaces;
      var interfaceFunction = function _interfaceFunction(value) {
        var i = 0;
        var len = interfaces.length;
        while (i < len) {
          if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
            return interfaces[i];
          }
          i += 1;
        }
        if (typeof value === 'number') {
          return interfaces[value - 1];
        }
        return null;
      };
      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
      interfaceFunction.numProperties = interfaces.length;
      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
      interfaceFunction.transform = transformInterface;
      interfaceFunction.propertyIndex = shape.cix;
      interfaceFunction._name = shape.nm;
      return interfaceFunction;
    }
    function groupInterfaceFactory(shape, view, propertyGroup) {
      var interfaceFunction = function _interfaceFunction(value) {
        switch (value) {
          case 'ADBE Vectors Group':
          case 'Contents':
          case 2:
            return interfaceFunction.content;
          // Not necessary for now. Keeping them here in case a new case appears
          // case 'ADBE Vector Transform Group':
          // case 3:
          default:
            return interfaceFunction.transform;
        }
      };
      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
      interfaceFunction.content = content;
      interfaceFunction.transform = transformInterface;
      Object.defineProperty(interfaceFunction, '_name', {
        get: function get() {
          return shape.nm;
        }
      });
      // interfaceFunction.content = interfaceFunction;
      interfaceFunction.numProperties = shape.np;
      interfaceFunction.propertyIndex = shape.ix;
      interfaceFunction.nm = shape.nm;
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }
    function fillInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(val) {
        if (val === 'Color' || val === 'color') {
          return interfaceFunction.color;
        }
        if (val === 'Opacity' || val === 'opacity') {
          return interfaceFunction.opacity;
        }
        return null;
      }
      Object.defineProperties(interfaceFunction, {
        color: {
          get: ExpressionPropertyInterface(view.c)
        },
        opacity: {
          get: ExpressionPropertyInterface(view.o)
        },
        _name: {
          value: shape.nm
        },
        mn: {
          value: shape.mn
        }
      });
      view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
      return interfaceFunction;
    }
    function gradientFillInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(val) {
        if (val === 'Start Point' || val === 'start point') {
          return interfaceFunction.startPoint;
        }
        if (val === 'End Point' || val === 'end point') {
          return interfaceFunction.endPoint;
        }
        if (val === 'Opacity' || val === 'opacity') {
          return interfaceFunction.opacity;
        }
        return null;
      }
      Object.defineProperties(interfaceFunction, {
        startPoint: {
          get: ExpressionPropertyInterface(view.s)
        },
        endPoint: {
          get: ExpressionPropertyInterface(view.e)
        },
        opacity: {
          get: ExpressionPropertyInterface(view.o)
        },
        type: {
          get: function get() {
            return 'a';
          }
        },
        _name: {
          value: shape.nm
        },
        mn: {
          value: shape.mn
        }
      });
      view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
      view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
      return interfaceFunction;
    }
    function defaultInterfaceFactory() {
      function interfaceFunction() {
        return null;
      }
      return interfaceFunction;
    }
    function strokeInterfaceFactory(shape, view, propertyGroup) {
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
      function addPropertyToDashOb(i) {
        Object.defineProperty(dashOb, shape.d[i].nm, {
          get: ExpressionPropertyInterface(view.d.dataProps[i].p)
        });
      }
      var i;
      var len = shape.d ? shape.d.length : 0;
      var dashOb = {};
      for (i = 0; i < len; i += 1) {
        addPropertyToDashOb(i);
        view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
      }
      function interfaceFunction(val) {
        if (val === 'Color' || val === 'color') {
          return interfaceFunction.color;
        }
        if (val === 'Opacity' || val === 'opacity') {
          return interfaceFunction.opacity;
        }
        if (val === 'Stroke Width' || val === 'stroke width') {
          return interfaceFunction.strokeWidth;
        }
        return null;
      }
      Object.defineProperties(interfaceFunction, {
        color: {
          get: ExpressionPropertyInterface(view.c)
        },
        opacity: {
          get: ExpressionPropertyInterface(view.o)
        },
        strokeWidth: {
          get: ExpressionPropertyInterface(view.w)
        },
        dash: {
          get: function get() {
            return dashOb;
          }
        },
        _name: {
          value: shape.nm
        },
        mn: {
          value: shape.mn
        }
      });
      view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
      view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
      return interfaceFunction;
    }
    function trimInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(val) {
        if (val === shape.e.ix || val === 'End' || val === 'end') {
          return interfaceFunction.end;
        }
        if (val === shape.s.ix) {
          return interfaceFunction.start;
        }
        if (val === shape.o.ix) {
          return interfaceFunction.offset;
        }
        return null;
      }
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      interfaceFunction.propertyIndex = shape.ix;
      view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
      view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
      interfaceFunction.propertyIndex = shape.ix;
      interfaceFunction.propertyGroup = propertyGroup;
      Object.defineProperties(interfaceFunction, {
        start: {
          get: ExpressionPropertyInterface(view.s)
        },
        end: {
          get: ExpressionPropertyInterface(view.e)
        },
        offset: {
          get: ExpressionPropertyInterface(view.o)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }
    function transformInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.a.ix === value || value === 'Anchor Point') {
          return interfaceFunction.anchorPoint;
        }
        if (shape.o.ix === value || value === 'Opacity') {
          return interfaceFunction.opacity;
        }
        if (shape.p.ix === value || value === 'Position') {
          return interfaceFunction.position;
        }
        if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
          return interfaceFunction.rotation;
        }
        if (shape.s.ix === value || value === 'Scale') {
          return interfaceFunction.scale;
        }
        if (shape.sk && shape.sk.ix === value || value === 'Skew') {
          return interfaceFunction.skew;
        }
        if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') {
          return interfaceFunction.skewAxis;
        }
        return null;
      }
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
      view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
      view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
      view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
      if (view.transform.mProps.sk) {
        view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
        view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
      }
      view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        opacity: {
          get: ExpressionPropertyInterface(view.transform.mProps.o)
        },
        position: {
          get: ExpressionPropertyInterface(view.transform.mProps.p)
        },
        anchorPoint: {
          get: ExpressionPropertyInterface(view.transform.mProps.a)
        },
        scale: {
          get: ExpressionPropertyInterface(view.transform.mProps.s)
        },
        rotation: {
          get: ExpressionPropertyInterface(view.transform.mProps.r)
        },
        skew: {
          get: ExpressionPropertyInterface(view.transform.mProps.sk)
        },
        skewAxis: {
          get: ExpressionPropertyInterface(view.transform.mProps.sa)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.ty = 'tr';
      interfaceFunction.mn = shape.mn;
      interfaceFunction.propertyGroup = propertyGroup;
      return interfaceFunction;
    }
    function ellipseInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.p.ix === value) {
          return interfaceFunction.position;
        }
        if (shape.s.ix === value) {
          return interfaceFunction.size;
        }
        return null;
      }
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      interfaceFunction.propertyIndex = shape.ix;
      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        size: {
          get: ExpressionPropertyInterface(prop.s)
        },
        position: {
          get: ExpressionPropertyInterface(prop.p)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }
    function starInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.p.ix === value) {
          return interfaceFunction.position;
        }
        if (shape.r.ix === value) {
          return interfaceFunction.rotation;
        }
        if (shape.pt.ix === value) {
          return interfaceFunction.points;
        }
        if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
          return interfaceFunction.outerRadius;
        }
        if (shape.os.ix === value) {
          return interfaceFunction.outerRoundness;
        }
        if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
          return interfaceFunction.innerRadius;
        }
        if (shape.is && shape.is.ix === value) {
          return interfaceFunction.innerRoundness;
        }
        return null;
      }
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
      interfaceFunction.propertyIndex = shape.ix;
      prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
      prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
      prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
      if (shape.ir) {
        prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
        prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
      }
      Object.defineProperties(interfaceFunction, {
        position: {
          get: ExpressionPropertyInterface(prop.p)
        },
        rotation: {
          get: ExpressionPropertyInterface(prop.r)
        },
        points: {
          get: ExpressionPropertyInterface(prop.pt)
        },
        outerRadius: {
          get: ExpressionPropertyInterface(prop.or)
        },
        outerRoundness: {
          get: ExpressionPropertyInterface(prop.os)
        },
        innerRadius: {
          get: ExpressionPropertyInterface(prop.ir)
        },
        innerRoundness: {
          get: ExpressionPropertyInterface(prop.is)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }
    function rectInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.p.ix === value) {
          return interfaceFunction.position;
        }
        if (shape.r.ix === value) {
          return interfaceFunction.roundness;
        }
        if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
          return interfaceFunction.size;
        }
        return null;
      }
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
      interfaceFunction.propertyIndex = shape.ix;
      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        position: {
          get: ExpressionPropertyInterface(prop.p)
        },
        roundness: {
          get: ExpressionPropertyInterface(prop.r)
        },
        size: {
          get: ExpressionPropertyInterface(prop.s)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }
    function roundedInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.r.ix === value || value === 'Round Corners 1') {
          return interfaceFunction.radius;
        }
        return null;
      }
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      var prop = view;
      interfaceFunction.propertyIndex = shape.ix;
      prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        radius: {
          get: ExpressionPropertyInterface(prop.rd)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }
    function repeaterInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.c.ix === value || value === 'Copies') {
          return interfaceFunction.copies;
        }
        if (shape.o.ix === value || value === 'Offset') {
          return interfaceFunction.offset;
        }
        return null;
      }
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      var prop = view;
      interfaceFunction.propertyIndex = shape.ix;
      prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
      prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        copies: {
          get: ExpressionPropertyInterface(prop.c)
        },
        offset: {
          get: ExpressionPropertyInterface(prop.o)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }
    return function (shapes, view, propertyGroup) {
      var interfaces;
      function _interfaceFunction(value) {
        if (typeof value === 'number') {
          value = value === undefined ? 1 : value;
          if (value === 0) {
            return propertyGroup;
          }
          return interfaces[value - 1];
        }
        var i = 0;
        var len = interfaces.length;
        while (i < len) {
          if (interfaces[i]._name === value) {
            return interfaces[i];
          }
          i += 1;
        }
        return null;
      }
      function parentGroupWrapper() {
        return propertyGroup;
      }
      _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
      interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
      _interfaceFunction.numProperties = interfaces.length;
      _interfaceFunction._name = 'Contents';
      return _interfaceFunction;
    };
  }();

  var TextExpressionInterface = function () {
    return function (elem) {
      var _sourceText;
      function _thisLayerFunction(name) {
        switch (name) {
          case 'ADBE Text Document':
            return _thisLayerFunction.sourceText;
          default:
            return null;
        }
      }
      Object.defineProperty(_thisLayerFunction, 'sourceText', {
        get: function get() {
          elem.textProperty.getValue();
          var stringValue = elem.textProperty.currentData.t;
          if (!_sourceText || stringValue !== _sourceText.value) {
            _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
            // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
            _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
            Object.defineProperty(_sourceText, 'style', {
              get: function get() {
                return {
                  fillColor: elem.textProperty.currentData.fc
                };
              }
            });
          }
          return _sourceText;
        }
      });
      return _thisLayerFunction;
    };
  }();

  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  var FootageInterface = function () {
    var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
      var currentPropertyName = '';
      var currentProperty = elem.getFootageData();
      function init() {
        currentPropertyName = '';
        currentProperty = elem.getFootageData();
        return searchProperty;
      }
      function searchProperty(value) {
        if (currentProperty[value]) {
          currentPropertyName = value;
          currentProperty = currentProperty[value];
          if (_typeof(currentProperty) === 'object') {
            return searchProperty;
          }
          return currentProperty;
        }
        var propertyNameIndex = value.indexOf(currentPropertyName);
        if (propertyNameIndex !== -1) {
          var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
          currentProperty = currentProperty[index];
          if (_typeof(currentProperty) === 'object') {
            return searchProperty;
          }
          return currentProperty;
        }
        return '';
      }
      return init;
    };
    var dataInterfaceFactory = function dataInterfaceFactory(elem) {
      function interfaceFunction(value) {
        if (value === 'Outline') {
          return interfaceFunction.outlineInterface();
        }
        return null;
      }
      interfaceFunction._name = 'Outline';
      interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
      return interfaceFunction;
    };
    return function (elem) {
      function _interfaceFunction(value) {
        if (value === 'Data') {
          return _interfaceFunction.dataInterface;
        }
        return null;
      }
      _interfaceFunction._name = 'Data';
      _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
      return _interfaceFunction;
    };
  }();

  var interfaces = {
    layer: LayerExpressionInterface,
    effects: EffectsExpressionInterface,
    comp: CompExpressionInterface,
    shape: ShapeExpressionInterface,
    text: TextExpressionInterface,
    footage: FootageInterface
  };
  function getInterface(type) {
    return interfaces[type] || null;
  }

  var expressionHelpers = function () {
    function searchExpressions(elem, data, prop) {
      if (data.x) {
        prop.k = true;
        prop.x = true;
        prop.initiateExpression = ExpressionManager.initiateExpression;
        prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
      }
    }
    function getValueAtTime(frameNum) {
      frameNum *= this.elem.globalData.frameRate;
      frameNum -= this.offsetTime;
      if (frameNum !== this._cachingAtTime.lastFrame) {
        this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
        this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
        this._cachingAtTime.lastFrame = frameNum;
      }
      return this._cachingAtTime.value;
    }
    function getSpeedAtTime(frameNum) {
      var delta = -0.01;
      var v1 = this.getValueAtTime(frameNum);
      var v2 = this.getValueAtTime(frameNum + delta);
      var speed = 0;
      if (v1.length) {
        var i;
        for (i = 0; i < v1.length; i += 1) {
          speed += Math.pow(v2[i] - v1[i], 2);
        }
        speed = Math.sqrt(speed) * 100;
      } else {
        speed = 0;
      }
      return speed;
    }
    function getVelocityAtTime(frameNum) {
      if (this.vel !== undefined) {
        return this.vel;
      }
      var delta = -0.001;
      // frameNum += this.elem.data.st;
      var v1 = this.getValueAtTime(frameNum);
      var v2 = this.getValueAtTime(frameNum + delta);
      var velocity;
      if (v1.length) {
        velocity = createTypedArray('float32', v1.length);
        var i;
        for (i = 0; i < v1.length; i += 1) {
          // removing frameRate
          // if needed, don't add it here
          // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
          velocity[i] = (v2[i] - v1[i]) / delta;
        }
      } else {
        velocity = (v2 - v1) / delta;
      }
      return velocity;
    }
    function getStaticValueAtTime() {
      return this.pv;
    }
    function setGroupProperty(propertyGroup) {
      this.propertyGroup = propertyGroup;
    }
    return {
      searchExpressions: searchExpressions,
      getSpeedAtTime: getSpeedAtTime,
      getVelocityAtTime: getVelocityAtTime,
      getValueAtTime: getValueAtTime,
      getStaticValueAtTime: getStaticValueAtTime,
      setGroupProperty: setGroupProperty
    };
  }();

  function addPropertyDecorator() {
    function loopOut(type, duration, durationFlag) {
      if (!this.k || !this.keyframes) {
        return this.pv;
      }
      type = type ? type.toLowerCase() : '';
      var currentFrame = this.comp.renderedFrame;
      var keyframes = this.keyframes;
      var lastKeyFrame = keyframes[keyframes.length - 1].t;
      if (currentFrame <= lastKeyFrame) {
        return this.pv;
      }
      var cycleDuration;
      var firstKeyFrame;
      if (!durationFlag) {
        if (!duration || duration > keyframes.length - 1) {
          duration = keyframes.length - 1;
        }
        firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
        cycleDuration = lastKeyFrame - firstKeyFrame;
      } else {
        if (!duration) {
          cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
        } else {
          cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
        }
        firstKeyFrame = lastKeyFrame - cycleDuration;
      }
      var i;
      var len;
      var ret;
      if (type === 'pingpong') {
        var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
        if (iterations % 2 !== 0) {
          return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
      } else if (type === 'offset') {
        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
        if (this.pv.length) {
          ret = new Array(initV.length);
          len = ret.length;
          for (i = 0; i < len; i += 1) {
            ret[i] = (endV[i] - initV[i]) * repeats + current[i];
          }
          return ret;
        }
        return (endV - initV) * repeats + current;
      } else if (type === 'continue') {
        var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
        if (this.pv.length) {
          ret = new Array(lastValue.length);
          len = ret.length;
          for (i = 0; i < len; i += 1) {
            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
          }
          return ret;
        }
        return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
      }
      return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
    }
    function loopIn(type, duration, durationFlag) {
      if (!this.k) {
        return this.pv;
      }
      type = type ? type.toLowerCase() : '';
      var currentFrame = this.comp.renderedFrame;
      var keyframes = this.keyframes;
      var firstKeyFrame = keyframes[0].t;
      if (currentFrame >= firstKeyFrame) {
        return this.pv;
      }
      var cycleDuration;
      var lastKeyFrame;
      if (!durationFlag) {
        if (!duration || duration > keyframes.length - 1) {
          duration = keyframes.length - 1;
        }
        lastKeyFrame = keyframes[duration].t;
        cycleDuration = lastKeyFrame - firstKeyFrame;
      } else {
        if (!duration) {
          cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
        } else {
          cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
        }
        lastKeyFrame = firstKeyFrame + cycleDuration;
      }
      var i;
      var len;
      var ret;
      if (type === 'pingpong') {
        var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
        if (iterations % 2 === 0) {
          return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
      } else if (type === 'offset') {
        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
        var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
        if (this.pv.length) {
          ret = new Array(initV.length);
          len = ret.length;
          for (i = 0; i < len; i += 1) {
            ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
          }
          return ret;
        }
        return current - (endV - initV) * repeats;
      } else if (type === 'continue') {
        var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
        var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
        if (this.pv.length) {
          ret = new Array(firstValue.length);
          len = ret.length;
          for (i = 0; i < len; i += 1) {
            ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
          }
          return ret;
        }
        return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
      }
      return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
    }
    function smooth(width, samples) {
      if (!this.k) {
        return this.pv;
      }
      width = (width || 0.4) * 0.5;
      samples = Math.floor(samples || 5);
      if (samples <= 1) {
        return this.pv;
      }
      var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
      var initFrame = currentTime - width;
      var endFrame = currentTime + width;
      var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
      var i = 0;
      var j = 0;
      var value;
      if (this.pv.length) {
        value = createTypedArray('float32', this.pv.length);
      } else {
        value = 0;
      }
      var sampleValue;
      while (i < samples) {
        sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
        if (this.pv.length) {
          for (j = 0; j < this.pv.length; j += 1) {
            value[j] += sampleValue[j];
          }
        } else {
          value += sampleValue;
        }
        i += 1;
      }
      if (this.pv.length) {
        for (j = 0; j < this.pv.length; j += 1) {
          value[j] /= samples;
        }
      } else {
        value /= samples;
      }
      return value;
    }
    function getTransformValueAtTime(time) {
      if (!this._transformCachingAtTime) {
        this._transformCachingAtTime = {
          v: new Matrix()
        };
      }
      /// /
      var matrix = this._transformCachingAtTime.v;
      matrix.cloneFromProps(this.pre.props);
      if (this.appliedTransformations < 1) {
        var anchor = this.a.getValueAtTime(time);
        matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
      }
      if (this.appliedTransformations < 2) {
        var scale = this.s.getValueAtTime(time);
        matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
      }
      if (this.sk && this.appliedTransformations < 3) {
        var skew = this.sk.getValueAtTime(time);
        var skewAxis = this.sa.getValueAtTime(time);
        matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
      }
      if (this.r && this.appliedTransformations < 4) {
        var rotation = this.r.getValueAtTime(time);
        matrix.rotate(-rotation * this.r.mult);
      } else if (!this.r && this.appliedTransformations < 4) {
        var rotationZ = this.rz.getValueAtTime(time);
        var rotationY = this.ry.getValueAtTime(time);
        var rotationX = this.rx.getValueAtTime(time);
        var orientation = this.or.getValueAtTime(time);
        matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
      }
      if (this.data.p && this.data.p.s) {
        var positionX = this.px.getValueAtTime(time);
        var positionY = this.py.getValueAtTime(time);
        if (this.data.p.z) {
          var positionZ = this.pz.getValueAtTime(time);
          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
        } else {
          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
        }
      } else {
        var position = this.p.getValueAtTime(time);
        matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
      }
      return matrix;
      /// /
    }
    function getTransformStaticValueAtTime() {
      return this.v.clone(new Matrix());
    }
    var getTransformProperty = TransformPropertyFactory.getTransformProperty;
    TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
      var prop = getTransformProperty(elem, data, container);
      if (prop.dynamicProperties.length) {
        prop.getValueAtTime = getTransformValueAtTime.bind(prop);
      } else {
        prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
      }
      prop.setGroupProperty = expressionHelpers.setGroupProperty;
      return prop;
    };
    var propertyGetProp = PropertyFactory.getProp;
    PropertyFactory.getProp = function (elem, data, type, mult, container) {
      var prop = propertyGetProp(elem, data, type, mult, container);
      // prop.getVelocityAtTime = getVelocityAtTime;
      // prop.loopOut = loopOut;
      // prop.loopIn = loopIn;
      if (prop.kf) {
        prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
      } else {
        prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
      }
      prop.setGroupProperty = expressionHelpers.setGroupProperty;
      prop.loopOut = loopOut;
      prop.loopIn = loopIn;
      prop.smooth = smooth;
      prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
      prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
      prop.numKeys = data.a === 1 ? data.k.length : 0;
      prop.propertyIndex = data.ix;
      var value = 0;
      if (type !== 0) {
        value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
      }
      prop._cachingAtTime = {
        lastFrame: initialDefaultFrame,
        lastIndex: 0,
        value: value
      };
      expressionHelpers.searchExpressions(elem, data, prop);
      if (prop.k) {
        container.addDynamicProperty(prop);
      }
      return prop;
    };
    function getShapeValueAtTime(frameNum) {
      // For now this caching object is created only when needed instead of creating it when the shape is initialized.
      if (!this._cachingAtTime) {
        this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        };
      }
      frameNum *= this.elem.globalData.frameRate;
      frameNum -= this.offsetTime;
      if (frameNum !== this._cachingAtTime.lastTime) {
        this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
        this._cachingAtTime.lastTime = frameNum;
        this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
      }
      return this._cachingAtTime.shapeValue;
    }
    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
    function ShapeExpressions() {}
    ShapeExpressions.prototype = {
      vertices: function vertices(prop, time) {
        if (this.k) {
          this.getValue();
        }
        var shapePath = this.v;
        if (time !== undefined) {
          shapePath = this.getValueAtTime(time, 0);
        }
        var i;
        var len = shapePath._length;
        var vertices = shapePath[prop];
        var points = shapePath.v;
        var arr = createSizedArray(len);
        for (i = 0; i < len; i += 1) {
          if (prop === 'i' || prop === 'o') {
            arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
          } else {
            arr[i] = [vertices[i][0], vertices[i][1]];
          }
        }
        return arr;
      },
      points: function points(time) {
        return this.vertices('v', time);
      },
      inTangents: function inTangents(time) {
        return this.vertices('i', time);
      },
      outTangents: function outTangents(time) {
        return this.vertices('o', time);
      },
      isClosed: function isClosed() {
        return this.v.c;
      },
      pointOnPath: function pointOnPath(perc, time) {
        var shapePath = this.v;
        if (time !== undefined) {
          shapePath = this.getValueAtTime(time, 0);
        }
        if (!this._segmentsLength) {
          this._segmentsLength = bez.getSegmentsLength(shapePath);
        }
        var segmentsLength = this._segmentsLength;
        var lengths = segmentsLength.lengths;
        var lengthPos = segmentsLength.totalLength * perc;
        var i = 0;
        var len = lengths.length;
        var accumulatedLength = 0;
        var pt;
        while (i < len) {
          if (accumulatedLength + lengths[i].addedLength > lengthPos) {
            var initIndex = i;
            var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
            var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
            pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
            break;
          } else {
            accumulatedLength += lengths[i].addedLength;
          }
          i += 1;
        }
        if (!pt) {
          pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
        }
        return pt;
      },
      vectorOnPath: function vectorOnPath(perc, time, vectorType) {
        // perc doesn't use triple equality because it can be a Number object as well as a primitive.
        if (perc == 1) {
          // eslint-disable-line eqeqeq
          perc = this.v.c;
        } else if (perc == 0) {
          // eslint-disable-line eqeqeq
          perc = 0.999;
        }
        var pt1 = this.pointOnPath(perc, time);
        var pt2 = this.pointOnPath(perc + 0.001, time);
        var xLength = pt2[0] - pt1[0];
        var yLength = pt2[1] - pt1[1];
        var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
        if (magnitude === 0) {
          return [0, 0];
        }
        var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
        return unitVector;
      },
      tangentOnPath: function tangentOnPath(perc, time) {
        return this.vectorOnPath(perc, time, 'tangent');
      },
      normalOnPath: function normalOnPath(perc, time) {
        return this.vectorOnPath(perc, time, 'normal');
      },
      setGroupProperty: expressionHelpers.setGroupProperty,
      getValueAtTime: expressionHelpers.getStaticValueAtTime
    };
    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
    ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
      var prop = propertyGetShapeProp(elem, data, type, arr, trims);
      prop.propertyIndex = data.ix;
      prop.lock = false;
      if (type === 3) {
        expressionHelpers.searchExpressions(elem, data.pt, prop);
      } else if (type === 4) {
        expressionHelpers.searchExpressions(elem, data.ks, prop);
      }
      if (prop.k) {
        elem.addDynamicProperty(prop);
      }
      return prop;
    };
  }
  function initialize$1() {
    addPropertyDecorator();
  }

  function addDecorator() {
    function searchExpressions() {
      if (this.data.d.x) {
        this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
        this.addEffect(this.getExpressionValue.bind(this));
        return true;
      }
      return null;
    }
    TextProperty.prototype.getExpressionValue = function (currentValue, text) {
      var newValue = this.calculateExpression(text);
      if (currentValue.t !== newValue) {
        var newData = {};
        this.copyData(newData, currentValue);
        newData.t = newValue.toString();
        newData.__complete = false;
        return newData;
      }
      return currentValue;
    };
    TextProperty.prototype.searchProperty = function () {
      var isKeyframed = this.searchKeyframes();
      var hasExpressions = this.searchExpressions();
      this.kf = isKeyframed || hasExpressions;
      return this.kf;
    };
    TextProperty.prototype.searchExpressions = searchExpressions;
  }
  function initialize() {
    addDecorator();
  }

  function SVGComposableEffect() {}
  SVGComposableEffect.prototype = {
    createMergeNode: function createMergeNode(resultId, ins) {
      var feMerge = createNS('feMerge');
      feMerge.setAttribute('result', resultId);
      var feMergeNode;
      var i;
      for (i = 0; i < ins.length; i += 1) {
        feMergeNode = createNS('feMergeNode');
        feMergeNode.setAttribute('in', ins[i]);
        feMerge.appendChild(feMergeNode);
        feMerge.appendChild(feMergeNode);
      }
      return feMerge;
    }
  };

  var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';
  function SVGTintFilter(filter, filterManager, elem, id, source) {
    this.filterManager = filterManager;
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
    feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
    this.linearFilter = feColorMatrix;
    feColorMatrix.setAttribute('result', id + '_tint_1');
    filter.appendChild(feColorMatrix);
    feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result', id + '_tint_2');
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
    var feMerge = this.createMergeNode(id, [source, id + '_tint_1', id + '_tint_2']);
    filter.appendChild(feMerge);
  }
  extendPrototype([SVGComposableEffect], SVGTintFilter);
  SVGTintFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var colorBlack = this.filterManager.effectElements[0].p.v;
      var colorWhite = this.filterManager.effectElements[1].p.v;
      var opacity = this.filterManager.effectElements[2].p.v / 100;
      this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
      this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
    }
  };

  function SVGFillFilter(filter, filterManager, elem, id) {
    this.filterManager = filterManager;
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result', id);
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
  }
  SVGFillFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var color = this.filterManager.effectElements[2].p.v;
      var opacity = this.filterManager.effectElements[6].p.v;
      this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
    }
  };

  function SVGStrokeEffect(fil, filterManager, elem) {
    this.initialized = false;
    this.filterManager = filterManager;
    this.elem = elem;
    this.paths = [];
  }
  SVGStrokeEffect.prototype.initialize = function () {
    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
    var path;
    var groupPath;
    var i;
    var len;
    if (this.filterManager.effectElements[1].p.v === 1) {
      len = this.elem.maskManager.masksProperties.length;
      i = 0;
    } else {
      i = this.filterManager.effectElements[0].p.v - 1;
      len = i + 1;
    }
    groupPath = createNS('g');
    groupPath.setAttribute('fill', 'none');
    groupPath.setAttribute('stroke-linecap', 'round');
    groupPath.setAttribute('stroke-dashoffset', 1);
    for (i; i < len; i += 1) {
      path = createNS('path');
      groupPath.appendChild(path);
      this.paths.push({
        p: path,
        m: i
      });
    }
    if (this.filterManager.effectElements[10].p.v === 3) {
      var mask = createNS('mask');
      var id = createElementID();
      mask.setAttribute('id', id);
      mask.setAttribute('mask-type', 'alpha');
      mask.appendChild(groupPath);
      this.elem.globalData.defs.appendChild(mask);
      var g = createNS('g');
      g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
      while (elemChildren[0]) {
        g.appendChild(elemChildren[0]);
      }
      this.elem.layerElement.appendChild(g);
      this.masker = mask;
      groupPath.setAttribute('stroke', '#fff');
    } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
      if (this.filterManager.effectElements[10].p.v === 2) {
        elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        while (elemChildren.length) {
          this.elem.layerElement.removeChild(elemChildren[0]);
        }
      }
      this.elem.layerElement.appendChild(groupPath);
      this.elem.layerElement.removeAttribute('mask');
      groupPath.setAttribute('stroke', '#fff');
    }
    this.initialized = true;
    this.pathMasker = groupPath;
  };
  SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
    if (!this.initialized) {
      this.initialize();
    }
    var i;
    var len = this.paths.length;
    var mask;
    var path;
    for (i = 0; i < len; i += 1) {
      if (this.paths[i].m !== -1) {
        mask = this.elem.maskManager.viewData[this.paths[i].m];
        path = this.paths[i].p;
        if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
          path.setAttribute('d', mask.lastPath);
        }
        if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
          var dasharrayValue;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
            var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
            var l = path.getTotalLength();
            dasharrayValue = '0 0 0 ' + l * s + ' ';
            var lineLength = l * (e - s);
            var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
            var units = Math.floor(lineLength / segment);
            var j;
            for (j = 0; j < units; j += 1) {
              dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
            }
            dasharrayValue += '0 ' + l * 10 + ' 0 0';
          } else {
            dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          }
          path.setAttribute('stroke-dasharray', dasharrayValue);
        }
      }
    }
    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
      this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
    }
    if (forceRender || this.filterManager.effectElements[6].p._mdf) {
      this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
    }
    if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
      if (forceRender || this.filterManager.effectElements[3].p._mdf) {
        var color = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
      }
    }
  };

  function SVGTritoneFilter(filter, filterManager, elem, id) {
    this.filterManager = filterManager;
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
    feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
    filter.appendChild(feColorMatrix);
    var feComponentTransfer = createNS('feComponentTransfer');
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    feComponentTransfer.setAttribute('result', id);
    this.matrixFilter = feComponentTransfer;
    var feFuncR = createNS('feFuncR');
    feFuncR.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFuncR);
    this.feFuncR = feFuncR;
    var feFuncG = createNS('feFuncG');
    feFuncG.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFuncG);
    this.feFuncG = feFuncG;
    var feFuncB = createNS('feFuncB');
    feFuncB.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFuncB);
    this.feFuncB = feFuncB;
    filter.appendChild(feComponentTransfer);
  }
  SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var color1 = this.filterManager.effectElements[0].p.v;
      var color2 = this.filterManager.effectElements[1].p.v;
      var color3 = this.filterManager.effectElements[2].p.v;
      var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
      var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
      var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
      this.feFuncR.setAttribute('tableValues', tableR);
      this.feFuncG.setAttribute('tableValues', tableG);
      this.feFuncB.setAttribute('tableValues', tableB);
    }
  };

  function SVGProLevelsFilter(filter, filterManager, elem, id) {
    this.filterManager = filterManager;
    var effectElements = this.filterManager.effectElements;
    var feComponentTransfer = createNS('feComponentTransfer');

    // Red
    if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
      this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
    }
    // Green
    if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
      this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
    }
    // Blue
    if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
      this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
    }
    // Alpha
    if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
      this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
    }
    // RGB
    if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
      filter.appendChild(feComponentTransfer);
    }
    if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
      feComponentTransfer = createNS('feComponentTransfer');
      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
      feComponentTransfer.setAttribute('result', id);
      filter.appendChild(feComponentTransfer);
      this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
      this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
      this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
    }
  }
  SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
    var feFunc = createNS(type);
    feFunc.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFunc);
    return feFunc;
  };
  SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
    var cnt = 0;
    var segments = 256;
    var perc;
    var min = Math.min(inputBlack, inputWhite);
    var max = Math.max(inputBlack, inputWhite);
    var table = Array.call(null, {
      length: segments
    });
    var colorValue;
    var pos = 0;
    var outputDelta = outputWhite - outputBlack;
    var inputDelta = inputWhite - inputBlack;
    while (cnt <= 256) {
      perc = cnt / 256;
      if (perc <= min) {
        colorValue = inputDelta < 0 ? outputWhite : outputBlack;
      } else if (perc >= max) {
        colorValue = inputDelta < 0 ? outputBlack : outputWhite;
      } else {
        colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
      }
      table[pos] = colorValue;
      pos += 1;
      cnt += 256 / (segments - 1);
    }
    return table.join(' ');
  };
  SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var val;
      var effectElements = this.filterManager.effectElements;
      if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
        val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
        this.feFuncRComposed.setAttribute('tableValues', val);
        this.feFuncGComposed.setAttribute('tableValues', val);
        this.feFuncBComposed.setAttribute('tableValues', val);
      }
      if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
        val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
        this.feFuncR.setAttribute('tableValues', val);
      }
      if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
        val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
        this.feFuncG.setAttribute('tableValues', val);
      }
      if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
        val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
        this.feFuncB.setAttribute('tableValues', val);
      }
      if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
        val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
        this.feFuncA.setAttribute('tableValues', val);
      }
    }
  };

  function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
    var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
    var filterSize = filterManager.data.fs || globalFilterSize;
    filter.setAttribute('x', filterSize.x || globalFilterSize.x);
    filter.setAttribute('y', filterSize.y || globalFilterSize.y);
    filter.setAttribute('width', filterSize.width || globalFilterSize.width);
    filter.setAttribute('height', filterSize.height || globalFilterSize.height);
    this.filterManager = filterManager;
    var feGaussianBlur = createNS('feGaussianBlur');
    feGaussianBlur.setAttribute('in', 'SourceAlpha');
    feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
    feGaussianBlur.setAttribute('stdDeviation', '0');
    this.feGaussianBlur = feGaussianBlur;
    filter.appendChild(feGaussianBlur);
    var feOffset = createNS('feOffset');
    feOffset.setAttribute('dx', '25');
    feOffset.setAttribute('dy', '0');
    feOffset.setAttribute('in', id + '_drop_shadow_1');
    feOffset.setAttribute('result', id + '_drop_shadow_2');
    this.feOffset = feOffset;
    filter.appendChild(feOffset);
    var feFlood = createNS('feFlood');
    feFlood.setAttribute('flood-color', '#00ff00');
    feFlood.setAttribute('flood-opacity', '1');
    feFlood.setAttribute('result', id + '_drop_shadow_3');
    this.feFlood = feFlood;
    filter.appendChild(feFlood);
    var feComposite = createNS('feComposite');
    feComposite.setAttribute('in', id + '_drop_shadow_3');
    feComposite.setAttribute('in2', id + '_drop_shadow_2');
    feComposite.setAttribute('operator', 'in');
    feComposite.setAttribute('result', id + '_drop_shadow_4');
    filter.appendChild(feComposite);
    var feMerge = this.createMergeNode(id, [id + '_drop_shadow_4', source]);
    filter.appendChild(feMerge);
    //
  }
  extendPrototype([SVGComposableEffect], SVGDropShadowEffect);
  SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      if (forceRender || this.filterManager.effectElements[4].p._mdf) {
        this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
      }
      if (forceRender || this.filterManager.effectElements[0].p._mdf) {
        var col = this.filterManager.effectElements[0].p.v;
        this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
      }
      if (forceRender || this.filterManager.effectElements[1].p._mdf) {
        this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
      }
      if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
        var distance = this.filterManager.effectElements[3].p.v;
        var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
        var x = distance * Math.cos(angle);
        var y = distance * Math.sin(angle);
        this.feOffset.setAttribute('dx', x);
        this.feOffset.setAttribute('dy', y);
      }
    }
  };

  var _svgMatteSymbols = [];
  function SVGMatte3Effect(filterElem, filterManager, elem) {
    this.initialized = false;
    this.filterManager = filterManager;
    this.filterElem = filterElem;
    this.elem = elem;
    elem.matteElement = createNS('g');
    elem.matteElement.appendChild(elem.layerElement);
    elem.matteElement.appendChild(elem.transformedElement);
    elem.baseElement = elem.matteElement;
  }
  SVGMatte3Effect.prototype.findSymbol = function (mask) {
    var i = 0;
    var len = _svgMatteSymbols.length;
    while (i < len) {
      if (_svgMatteSymbols[i] === mask) {
        return _svgMatteSymbols[i];
      }
      i += 1;
    }
    return null;
  };
  SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
    var parentNode = mask.layerElement.parentNode;
    if (!parentNode) {
      return;
    }
    var children = parentNode.children;
    var i = 0;
    var len = children.length;
    while (i < len) {
      if (children[i] === mask.layerElement) {
        break;
      }
      i += 1;
    }
    var nextChild;
    if (i <= len - 2) {
      nextChild = children[i + 1];
    }
    var useElem = createNS('use');
    useElem.setAttribute('href', '#' + symbolId);
    if (nextChild) {
      parentNode.insertBefore(useElem, nextChild);
    } else {
      parentNode.appendChild(useElem);
    }
  };
  SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
    if (!this.findSymbol(mask)) {
      var symbolId = createElementID();
      var masker = createNS('mask');
      masker.setAttribute('id', mask.layerId);
      masker.setAttribute('mask-type', 'alpha');
      _svgMatteSymbols.push(mask);
      var defs = elem.globalData.defs;
      defs.appendChild(masker);
      var symbol = createNS('symbol');
      symbol.setAttribute('id', symbolId);
      this.replaceInParent(mask, symbolId);
      symbol.appendChild(mask.layerElement);
      defs.appendChild(symbol);
      var useElem = createNS('use');
      useElem.setAttribute('href', '#' + symbolId);
      masker.appendChild(useElem);
      mask.data.hd = false;
      mask.show();
    }
    elem.setMatte(mask.layerId);
  };
  SVGMatte3Effect.prototype.initialize = function () {
    var ind = this.filterManager.effectElements[0].p.v;
    var elements = this.elem.comp.elements;
    var i = 0;
    var len = elements.length;
    while (i < len) {
      if (elements[i] && elements[i].data.ind === ind) {
        this.setElementAsMask(this.elem, elements[i]);
      }
      i += 1;
    }
    this.initialized = true;
  };
  SVGMatte3Effect.prototype.renderFrame = function () {
    if (!this.initialized) {
      this.initialize();
    }
  };

  function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
    // Outset the filter region by 100% on all sides to accommodate blur expansion.
    filter.setAttribute('x', '-100%');
    filter.setAttribute('y', '-100%');
    filter.setAttribute('width', '300%');
    filter.setAttribute('height', '300%');
    this.filterManager = filterManager;
    var feGaussianBlur = createNS('feGaussianBlur');
    feGaussianBlur.setAttribute('result', id);
    filter.appendChild(feGaussianBlur);
    this.feGaussianBlur = feGaussianBlur;
  }
  SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      // Empirical value, matching AE's blur appearance.
      var kBlurrinessToSigma = 0.3;
      var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma;

      // Dimensions mapping:
      //
      //   1 -> horizontal & vertical
      //   2 -> horizontal only
      //   3 -> vertical only
      //
      var dimensions = this.filterManager.effectElements[1].p.v;
      var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
      var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq

      this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY);

      // Repeat edges mapping:
      //
      //   0 -> off -> duplicate
      //   1 -> on  -> wrap
      var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
      this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
    }
  };

  function TransformEffect() {}
  TransformEffect.prototype.init = function (effectsManager) {
    this.effectsManager = effectsManager;
    this.type = effectTypes.TRANSFORM_EFFECT;
    this.matrix = new Matrix();
    this.opacity = -1;
    this._mdf = false;
    this._opMdf = false;
  };
  TransformEffect.prototype.renderFrame = function (forceFrame) {
    this._opMdf = false;
    this._mdf = false;
    if (forceFrame || this.effectsManager._mdf) {
      var effectElements = this.effectsManager.effectElements;
      var anchor = effectElements[0].p.v;
      var position = effectElements[1].p.v;
      var isUniformScale = effectElements[2].p.v === 1;
      var scaleHeight = effectElements[3].p.v;
      var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
      var skew = effectElements[5].p.v;
      var skewAxis = effectElements[6].p.v;
      var rotation = effectElements[7].p.v;
      this.matrix.reset();
      this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
      this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
      this.matrix.rotate(-rotation * degToRads);
      this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
      this.matrix.translate(position[0], position[1], 0);
      this._mdf = true;
      if (this.opacity !== effectElements[8].p.v) {
        this.opacity = effectElements[8].p.v;
        this._opMdf = true;
      }
    }
  };

  function SVGTransformEffect(_, filterManager) {
    this.init(filterManager);
  }
  extendPrototype([TransformEffect], SVGTransformEffect);

  function CVTransformEffect(effectsManager) {
    this.init(effectsManager);
  }
  extendPrototype([TransformEffect], CVTransformEffect);

  // Registering renderers
  registerRenderer('canvas', CanvasRenderer);
  registerRenderer('html', HybridRenderer);
  registerRenderer('svg', SVGRenderer);

  // Registering shape modifiers
  ShapeModifiers.registerModifier('tm', TrimModifier);
  ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
  ShapeModifiers.registerModifier('rp', RepeaterModifier);
  ShapeModifiers.registerModifier('rd', RoundCornersModifier);
  ShapeModifiers.registerModifier('zz', ZigZagModifier);
  ShapeModifiers.registerModifier('op', OffsetPathModifier);

  // Registering expression plugin
  setExpressionsPlugin(Expressions);
  setExpressionInterfaces(getInterface);
  initialize$1();
  initialize();

  // Registering svg effects
  registerEffect$1(20, SVGTintFilter, true);
  registerEffect$1(21, SVGFillFilter, true);
  registerEffect$1(22, SVGStrokeEffect, false);
  registerEffect$1(23, SVGTritoneFilter, true);
  registerEffect$1(24, SVGProLevelsFilter, true);
  registerEffect$1(25, SVGDropShadowEffect, true);
  registerEffect$1(28, SVGMatte3Effect, false);
  registerEffect$1(29, SVGGaussianBlurEffect, true);
  registerEffect$1(35, SVGTransformEffect, false);
  registerEffect(35, CVTransformEffect);

  return lottie;

}));

/**
 * TinyMCE version 8.10.0 (2026-10-14)
 */

/**
 * This file bundles the code of
 * DOMPurify 3.4.11 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.11/LICENSE
 */

!function(){"use strict";var e=function(e){if(null===e)return"null";if(void 0===e)return"undefined";var t=typeof e;return"object"===t&&(Array.prototype.isPrototypeOf(e)||e.constructor&&"Array"===e.constructor.name)?"array":"object"===t&&(String.prototype.isPrototypeOf(e)||e.constructor&&"String"===e.constructor.name)?"string":t},t=function(e){return{eq:e}},n=t(function(e,t){return e===t}),o=function(e){return t(function(t,n){if(t.length!==n.length)return!1;for(var o=t.length,r=0;r<o;r++)if(!e.eq(t[r],n[r]))return!1;return!0})},r=function(e){return t(function(r,s){var a=Object.keys(r),i=Object.keys(s);if(!function(e,n){return function(e,n){return t(function(t,o){return e.eq(n(t),n(o))})}(o(e),function(e){return function(e,t){return Array.prototype.slice.call(e).sort(t)}(e,n)})}(n).eq(a,i))return!1;for(var l=a.length,c=0;c<l;c++){var d=a[c];if(!e.eq(r[d],s[d]))return!1}return!0})},s=t(function(t,n){if(t===n)return!0;var a=e(t);return a===e(n)&&(function(e){return-1!==["undefined","boolean","number","string","function","xml","null"].indexOf(e)}(a)?t===n:"array"===a?o(s).eq(t,n):"object"===a&&r(s).eq(t,n))});const a=Object.getPrototypeOf,i=(e,t,n)=>!!n(e,t.prototype)||e.constructor?.name===t.name,l=e=>t=>(e=>{const t=typeof e;return null===e?"null":"object"===t&&Array.isArray(e)?"array":"object"===t&&i(e,String,(e,t)=>t.isPrototypeOf(e))?"string":t})(t)===e,c=e=>t=>typeof t===e,d=e=>t=>e===t,m=(e,t)=>f(e)&&i(e,t,(e,t)=>a(e)===t),u=l("string"),f=l("object"),g=e=>m(e,Object),p=l("array"),h=d(null),b=c("boolean"),y=d(void 0),v=e=>null==e,C=e=>!v(e),w=c("function"),S=c("number"),E=(e,t)=>{if(p(e)){for(let n=0,o=e.length;n<o;++n)if(!t(e[n]))return!1;return!0}return!1},x=()=>{},_=(e,t)=>(...n)=>e(t.apply(null,n)),k=(e,t)=>n=>e(t(n)),N=e=>()=>e,R=e=>e,A=(e,t)=>e===t;function D(e,...t){return(...n)=>{const o=t.concat(n);return e.apply(null,o)}}const T=e=>t=>!e(t),O=e=>()=>{throw new Error(e)},B=e=>e(),P=e=>{e()},L=N(!1),M=N(!0);class I{tag;value;static singletonNone=new I(!1);constructor(e,t){this.tag=e,this.value=t}static some(e){return new I(!0,e)}static none(){return I.singletonNone}fold(e,t){return this.tag?t(this.value):e()}isSome(){return this.tag}isNone(){return!this.tag}map(e){return this.tag?I.some(e(this.value)):I.none()}bind(e){return this.tag?e(this.value):I.none()}exists(e){return this.tag&&e(this.value)}forall(e){return!this.tag||e(this.value)}filter(e){return!this.tag||e(this.value)?this:I.none()}getOr(e){return this.tag?this.value:e}or(e){return this.tag?this:e}getOrThunk(e){return this.tag?this.value:e()}orThunk(e){return this.tag?this:e()}getOrDie(e){if(this.tag)return this.value;throw new Error(e??"Called getOrDie on None")}static from(e){return C(e)?I.some(e):I.none()}getOrNull(){return this.tag?this.value:null}getOrUndefined(){return this.value}each(e){this.tag&&e(this.value)}toArray(){return this.tag?[this.value]:[]}toString(){return this.tag?`some(${this.value})`:"none()"}}const F=Array.prototype.slice,U=Array.prototype.indexOf,z=Array.prototype.push,j=(e,t)=>U.call(e,t),$=(e,t)=>j(e,t)>-1,H=(e,t)=>{for(let n=0,o=e.length;n<o;n++)if(t(e[n],n))return!0;return!1},V=(e,t)=>{const n=e.length,o=new Array(n);for(let r=0;r<n;r++){const n=e[r];o[r]=t(n,r)}return o},q=(e,t)=>{for(let n=0,o=e.length;n<o;n++)t(e[n],n)},W=(e,t)=>{for(let n=e.length-1;n>=0;n--)t(e[n],n)},K=(e,t)=>{const n=[],o=[];for(let r=0,s=e.length;r<s;r++){const s=e[r];(t(s,r)?n:o).push(s)}return{pass:n,fail:o}},Y=(e,t)=>{const n=[];for(let o=0,r=e.length;o<r;o++){const r=e[o];t(r,o)&&n.push(r)}return n},G=(e,t,n)=>(W(e,(e,o)=>{n=t(n,e,o)}),n),X=(e,t,n)=>(q(e,(e,o)=>{n=t(n,e,o)}),n),Q=(e,t,n)=>{for(let o=0,r=e.length;o<r;o++){const r=e[o];if(t(r,o))return I.some(r);if(n(r,o))break}return I.none()},Z=(e,t)=>Q(e,t,L),J=(e,t)=>{for(let n=0,o=e.length;n<o;n++)if(t(e[n],n))return I.some(n);return I.none()},ee=(e,t)=>{for(let n=e.length-1;n>=0;n--)if(t(e[n],n))return I.some({v:e[n],i:n});return I.none()},te=e=>{const t=[];for(let n=0,o=e.length;n<o;++n){if(!p(e[n]))throw new Error("Arr.flatten item "+n+" was not an array, input: "+e);z.apply(t,e[n])}return t},ne=(e,t)=>te(V(e,t)),oe=(e,t)=>{for(let n=0,o=e.length;n<o;++n)if(!0!==t(e[n],n))return!1;return!0},re=e=>{const t=F.call(e,0);return t.reverse(),t},se=(e,t)=>Y(e,e=>!$(t,e)),ae=(e,t)=>{const n={};for(let o=0,r=e.length;o<r;o++){const r=e[o];n[String(r)]=t(r,o)}return n},ie=(e,t)=>{const n=F.call(e,0);return n.sort(t),n},le=(e,t)=>t>=0&&t<e.length?I.some(e[t]):I.none(),ce=e=>le(e,0),de=e=>le(e,e.length-1),me=w(Array.from)?Array.from:e=>F.call(e),ue=(e,t)=>{for(let n=0;n<e.length;n++){const o=t(e[n],n);if(o.isSome())return o}return I.none()},fe=(e,t)=>{const n=[],o=w(t)?e=>H(n,n=>t(n,e)):e=>$(n,e);for(let t=0,r=e.length;t<r;t++){const r=e[t];o(r)||n.push(r)}return n},ge=Object.keys,pe=Object.hasOwnProperty,he=(e,t)=>{const n=ge(e);for(let o=0,r=n.length;o<r;o++){const r=n[o];t(e[r],r)}},be=(e,t)=>ye(e,(e,n)=>({k:n,v:t(e,n)})),ye=(e,t)=>{const n={};return he(e,(e,o)=>{const r=t(e,o);n[r.k]=r.v}),n},ve=e=>(t,n)=>{e[n]=t},Ce=(e,t,n,o)=>{he(e,(e,r)=>{(t(e,r)?n:o)(e,r)})},we=(e,t)=>{const n={};return Ce(e,t,ve(n),x),n},Se=(e,t)=>{const n=[];return he(e,(e,o)=>{n.push(t(e,o))}),n},Ee=e=>Se(e,R),xe=(e,t)=>_e(e,t)?I.from(e[t]):I.none(),_e=(e,t)=>pe.call(e,t),ke=(e,t)=>_e(e,t)&&void 0!==e[t]&&null!==e[t],Ne=e=>{if(!p(e))throw new Error("cases must be an array");if(0===e.length)throw new Error("there must be at least one case");const t=[],n={};return q(e,(o,r)=>{const s=ge(o);if(1!==s.length)throw new Error("one and only one name per case");const a=s[0],i=o[a];if(void 0!==n[a])throw new Error("duplicate key detected:"+a);if("cata"===a)throw new Error("cannot have a case named cata (sorry)");if(!p(i))throw new Error("case arguments must be an array");t.push(a),n[a]=(...n)=>{const o=n.length;if(o!==i.length)throw new Error("Wrong number of arguments to case "+a+". Expected "+i.length+" ("+i+"), got "+o);return{fold:(...t)=>{if(t.length!==e.length)throw new Error("Wrong number of arguments to fold. Expected "+e.length+", got "+t.length);return t[r].apply(null,n)},match:e=>{const o=ge(e);if(t.length!==o.length)throw new Error("Wrong number of arguments to match. Expected: "+t.join(",")+"\nActual: "+o.join(","));if(!oe(t,e=>$(o,e)))throw new Error("Not all branches were specified when using match. Specified: "+o.join(", ")+"\nRequired: "+t.join(", "));return e[a].apply(null,n)},log:e=>{console.log(e,{constructors:t,constructor:a,params:n})}}}}),n},Re=e=>{let t=e;return{get:()=>t,set:e=>{t=e}}},Ae=e=>{const t=t=>t(e),n=N(e),o=()=>r,r={tag:!0,inner:e,fold:(t,n)=>n(e),isValue:M,isError:L,map:t=>Te.value(t(e)),mapError:o,bind:t,exists:t,forall:t,getOr:n,or:o,getOrThunk:n,orThunk:o,getOrDie:n,each:t=>{t(e)},toOptional:()=>I.some(e)};return r},De=e=>{const t=()=>n,n={tag:!1,inner:e,fold:(t,n)=>t(e),isValue:L,isError:M,map:t,mapError:t=>Te.error(t(e)),bind:t,exists:L,forall:M,getOr:R,or:R,getOrThunk:B,orThunk:B,getOrDie:O(String(e)),each:x,toOptional:I.none};return n},Te={value:Ae,error:De,fromOption:(e,t)=>e.fold(()=>De(t),Ae)},Oe="undefined"!=typeof window?window:Function("return this;")(),Be=()=>window.crypto.getRandomValues(new Uint32Array(1))[0]/4294967295;let Pe=0;const Le=e=>{const t=(new Date).getTime(),n=Math.floor(1e9*Be());return Pe++,e+"_"+n+Pe+String(t)},Me=()=>window.isSecureContext?window.crypto.randomUUID():(()=>{const e=(()=>{const e=window.crypto.getRandomValues(new Uint8Array(16));return e[6]=15&e[6]|64,e[8]=63&e[8]|128,e})(),t=(t,n)=>{let o="";for(let r=t;r<=n;++r)o+=e[r].toString(16).padStart(2,"0");return o};return`${t(0,3)}-${t(4,5)}-${t(6,7)}-${t(8,9)}-${t(10,15)}`})(),Ie=e=>(...t)=>{if(0===t.length)throw new Error("Can't merge zero objects");const n={};for(let o=0;o<t.length;o++){const r=t[o];for(const t in r)_e(r,t)&&(n[t]=e(n[t],r[t]))}return n},Fe=Ie((e,t)=>g(e)&&g(t)?Fe(e,t):t),Ue=Ie((e,t)=>t),ze=(e,t,n=A)=>e.exists(e=>n(e,t)),je=(e,t,n=A)=>$e(e,t,n).getOr(e.isNone()&&t.isNone()),$e=(e,t,n)=>e.isSome()&&t.isSome()?I.some(n(e.getOrDie(),t.getOrDie())):I.none(),He=(e,t)=>e?I.some(t):I.none(),Ve=(e,t)=>((e,t)=>{let n=null!=t?t:Oe;for(let t=0;t<e.length&&null!=n;++t)n=n[e[t]];return n})(e.split("."),t);Ne([{bothErrors:["error1","error2"]},{firstError:["error1","value2"]},{secondError:["value1","error2"]},{bothValues:["value1","value2"]}]);const qe=e=>{const t=[],n=[];return q(e,e=>{e.fold(e=>{t.push(e)},e=>{n.push(e)})}),{errors:t,values:n}},We=e=>{const t=Re(I.none()),n=()=>t.get().each(e=>clearInterval(e));return{clear:()=>{n(),t.set(I.none())},isSet:()=>t.get().isSome(),get:()=>t.get(),set:o=>{n(),t.set(I.some(setInterval(o,e)))}}},Ke=()=>{const e=(e=>{const t=Re(I.none()),n=()=>t.get().each(e);return{clear:()=>{n(),t.set(I.none())},isSet:()=>t.get().isSome(),get:()=>t.get(),set:e=>{n(),t.set(I.some(e))}}})(x);return{...e,on:t=>e.get().each(t)}},Ye=(e,t,n)=>""===t||e.length>=t.length&&e.substr(n,n+t.length)===t,Ge=(e,t)=>Qe(e,t)?((e,t)=>e.substring(t))(e,t.length):e,Xe=(e,t,n=0,o)=>{const r=e.indexOf(t,n);return-1!==r&&(!!y(o)||r+t.length<=o)},Qe=(e,t)=>Ye(e,t,0),Ze=(e,t)=>Ye(e,t,e.length-t.length),Je=e=>t=>t.replace(e,""),et=Je(/^\s+|\s+$/g),tt=Je(/^\s+/g),nt=Je(/\s+$/g),ot=e=>e.length>0,rt=e=>!ot(e),st=(e,t=10)=>{const n=parseInt(e,t);return isNaN(n)?I.none():I.some(n)},at=(e,t)=>{let n=null;return{cancel:()=>{h(n)||(clearTimeout(n),n=null)},throttle:(...o)=>{h(n)&&(n=setTimeout(()=>{n=null,e.apply(null,o)},t))}}},it=(e,t)=>{let n=null;const o=()=>{h(n)||(clearTimeout(n),n=null)};return{cancel:o,throttle:(...r)=>{o(),n=setTimeout(()=>{n=null,e.apply(null,r)},t)}}},lt=e=>{let t,n=!1;return(...o)=>(n||(n=!0,t=e.apply(null,o)),t)},ct="\ufeff",dt="\xa0",mt=e=>e===ct,ut=e=>{const t={};return q(e,e=>{t[e]={}}),ge(t)},ft=e=>void 0!==e.length,gt=Array.isArray,pt=(e,t,n)=>{if(!e)return!1;if(n=n||e,ft(e)){for(let o=0,r=e.length;o<r;o++)if(!1===t.call(n,e[o],o,e))return!1}else for(const o in e)if(_e(e,o)&&!1===t.call(n,e[o],o,e))return!1;return!0},ht=(e,t)=>{const n=[];return pt(e,(o,r)=>{n.push(t(o,r,e))}),n},bt=(e,t)=>{const n=[];return pt(e,(o,r)=>{t&&!t(o,r,e)||n.push(o)}),n},yt=(e,t,n,o)=>{let r=y(n)?e[0]:n;for(let n=0;n<e.length;n++)r=t.call(o,r,e[n],n);return r},vt=(e,t,n)=>{for(let o=0,r=e.length;o<r;o++)if(t.call(n,e[o],o,e))return o;return-1},Ct=e=>e[e.length-1],wt=()=>St(0,0),St=(e,t)=>({major:e,minor:t}),Et={nu:St,detect:(e,t)=>{const n=String(t).toLowerCase();return 0===e.length?wt():((e,t)=>{const n=((e,t)=>{for(let n=0;n<e.length;n++){const o=e[n];if(o.test(t))return o}})(e,t);if(!n)return{major:0,minor:0};const o=e=>Number(t.replace(n,"$"+e));return St(o(1),o(2))})(e,n)},unknown:wt},xt=(e,t)=>{const n=String(t).toLowerCase();return Z(e,e=>e.search(n))},_t=/.*?version\/\ ?([0-9]+)\.([0-9]+).*/,kt=e=>t=>Xe(t,e),Nt=[{name:"Edge",versionRegexes:[/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],search:e=>Xe(e,"edge/")&&Xe(e,"chrome")&&Xe(e,"safari")&&Xe(e,"applewebkit")},{name:"Chromium",brand:"Chromium",versionRegexes:[/.*?chrome\/([0-9]+)\.([0-9]+).*/,_t],search:e=>Xe(e,"chrome")&&!Xe(e,"chromeframe")},{name:"IE",versionRegexes:[/.*?msie\ ?([0-9]+)\.([0-9]+).*/,/.*?rv:([0-9]+)\.([0-9]+).*/],search:e=>Xe(e,"msie")||Xe(e,"trident")},{name:"Opera",versionRegexes:[_t,/.*?opera\/([0-9]+)\.([0-9]+).*/],search:kt("opera")},{name:"Firefox",versionRegexes:[/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],search:kt("firefox")},{name:"Safari",versionRegexes:[_t,/.*?cpu os ([0-9]+)_([0-9]+).*/],search:e=>(Xe(e,"safari")||Xe(e,"mobile/"))&&Xe(e,"applewebkit")}],Rt=[{name:"Windows",search:kt("win"),versionRegexes:[/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]},{name:"iOS",search:e=>Xe(e,"iphone")||Xe(e,"ipad"),versionRegexes:[/.*?version\/\ ?([0-9]+)\.([0-9]+).*/,/.*cpu os ([0-9]+)_([0-9]+).*/,/.*cpu iphone os ([0-9]+)_([0-9]+).*/]},{name:"Android",search:kt("android"),versionRegexes:[/.*?android\ ?([0-9]+)\.([0-9]+).*/]},{name:"macOS",search:kt("mac os x"),versionRegexes:[/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]},{name:"Linux",search:kt("linux"),versionRegexes:[]},{name:"Solaris",search:kt("sunos"),versionRegexes:[]},{name:"FreeBSD",search:kt("freebsd"),versionRegexes:[]},{name:"ChromeOS",search:kt("cros"),versionRegexes:[/.*?chrome\/([0-9]+)\.([0-9]+).*/]}],At={browsers:N(Nt),oses:N(Rt)},Dt="Edge",Tt="Chromium",Ot="Opera",Bt="Firefox",Pt="Safari",Lt=e=>{const t=e.current,n=e.version,o=e=>()=>t===e;return{current:t,version:n,isEdge:o(Dt),isChromium:o(Tt),isIE:o("IE"),isOpera:o(Ot),isFirefox:o(Bt),isSafari:o(Pt)}},Mt=()=>Lt({current:void 0,version:Et.unknown()}),It=Lt,Ft=(N(Dt),N(Tt),N("IE"),N(Ot),N(Bt),N(Pt),"Windows"),Ut="Android",zt="Linux",jt="macOS",$t="Solaris",Ht="FreeBSD",Vt="ChromeOS",qt=e=>{const t=e.current,n=e.version,o=e=>()=>t===e;return{current:t,version:n,isWindows:o(Ft),isiOS:o("iOS"),isAndroid:o(Ut),isMacOS:o(jt),isLinux:o(zt),isSolaris:o($t),isFreeBSD:o(Ht),isChromeOS:o(Vt)}},Wt=()=>qt({current:void 0,version:Et.unknown()}),Kt=qt,Yt=(N(Ft),N("iOS"),N(Ut),N(zt),N(jt),N($t),N(Ht),N(Vt),e=>window.matchMedia(e).matches);let Gt=lt(()=>((e,t,n)=>{const o=At.browsers(),r=At.oses(),s=t.bind(e=>((e,t)=>ue(t.brands,t=>{const n=t.brand.toLowerCase();return Z(e,e=>n===e.brand?.toLowerCase()).map(e=>({current:e.name,version:Et.nu(parseInt(t.version,10),0)}))}))(o,e)).orThunk(()=>((e,t)=>xt(e,t).map(e=>{const n=Et.detect(e.versionRegexes,t);return{current:e.name,version:n}}))(o,e)).fold(Mt,It),a=((e,t)=>xt(e,t).map(e=>{const n=Et.detect(e.versionRegexes,t);return{current:e.name,version:n}}))(r,e).fold(Wt,Kt),i=((e,t,n,o)=>{const r=e.isiOS()&&!0===/ipad/i.test(n),s=e.isiOS()&&!r,a=e.isiOS()||e.isAndroid(),i=a||o("(pointer:coarse)"),l=r||!s&&a&&o("(min-device-width:768px)"),c=s||a&&!l,d=t.isSafari()&&e.isiOS()&&!1===/safari/i.test(n),m=!c&&!l&&!d;return{isiPad:N(r),isiPhone:N(s),isTablet:N(l),isPhone:N(c),isTouch:N(i),isAndroid:e.isAndroid,isiOS:e.isiOS,isWebView:N(d),isDesktop:N(m)}})(a,s,e,n);return{browser:s,os:a,deviceType:i}})(window.navigator.userAgent,I.from(window.navigator.userAgentData),Yt));const Xt=()=>Gt(),Qt=Object.getPrototypeOf,Zt=e=>{const t=Ve("ownerDocument.defaultView",e);return f(e)&&((e=>((e,t)=>{const n=((e,t)=>Ve(e,t))(e,t);if(null==n)throw new Error(e+" not available on this browser");return n})("HTMLElement",e))(t).prototype.isPrototypeOf(e)||/^HTML\w*Element$/.test(Qt(e).constructor.name))},Jt=window.navigator.userAgent,en=Xt(),tn=en.browser,nn=en.os,on=en.deviceType,rn=-1!==Jt.indexOf("Windows Phone"),sn={transparentSrc:"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",documentMode:tn.isIE()?document.documentMode||7:10,cacheSuffix:null,container:null,canHaveCSP:!tn.isIE(),windowsPhone:rn,browser:{current:tn.current,version:tn.version,isChromium:tn.isChromium,isEdge:tn.isEdge,isFirefox:tn.isFirefox,isIE:tn.isIE,isOpera:tn.isOpera,isSafari:tn.isSafari},os:{current:nn.current,version:nn.version,isAndroid:nn.isAndroid,isChromeOS:nn.isChromeOS,isFreeBSD:nn.isFreeBSD,isiOS:nn.isiOS,isLinux:nn.isLinux,isMacOS:nn.isMacOS,isSolaris:nn.isSolaris,isWindows:nn.isWindows},deviceType:{isDesktop:on.isDesktop,isiPad:on.isiPad,isiPhone:on.isiPhone,isPhone:on.isPhone,isTablet:on.isTablet,isTouch:on.isTouch,isWebView:on.isWebView}},an=/^\s*|\s*$/g,ln=e=>v(e)?"":(""+e).replace(an,""),cn=function(e,t,n,o){o=o||this,e&&(n&&(e=e[n]),pt(e,(e,r)=>!1!==t.call(o,e,r,n)&&(cn(e,t,n,o),!0)))},dn={trim:ln,isArray:gt,is:(e,t)=>t?!("array"!==t||!gt(e))||typeof e===t:void 0!==e,toArray:e=>{if(gt(e))return e;{const t=[];for(let n=0,o=e.length;n<o;n++)t[n]=e[n];return t}},makeMap:(e,t,n={})=>{const o=u(e)?e.split(t||","):e||[];let r=o.length;for(;r--;)n[o[r]]={};return n},each:pt,map:ht,grep:bt,inArray:(e,t)=>{if(e)for(let n=0,o=e.length;n<o;n++)if(e[n]===t)return n;return-1},hasOwn:_e,extend:(e,...t)=>{for(let n=0;n<t.length;n++){const o=t[n];for(const t in o)if(_e(o,t)){const n=o[t];void 0!==n&&(e[t]=n)}}return e},walk:cn,resolve:(e,t=window)=>{const n=e.split(".");for(let e=0,o=n.length;e<o&&(t=t[n[e]]);e++);return t},explode:(e,t)=>p(e)?e:""===e?[]:ht(e.split(t||","),ln),_addCacheSuffix:e=>{const t=sn.cacheSuffix;return t&&(e+=(-1===e.indexOf("?")?"?":"&")+t),e}},mn=e=>{if(null==e)throw new Error("Node cannot be null or undefined");return{dom:e}},un={fromHtml:(e,t)=>{const n=(t||document).createElement("div");if(n.innerHTML=e,!n.hasChildNodes()||n.childNodes.length>1){const t="HTML does not have a single root node";throw console.error(t,e),new Error(t)}return mn(n.childNodes[0])},fromTag:(e,t)=>{const n=(t||document).createElement(e);return mn(n)},fromText:(e,t)=>{const n=(t||document).createTextNode(e);return mn(n)},fromDom:mn,fromPoint:(e,t,n)=>I.from(e.dom.elementFromPoint(t,n)).map(mn)},fn=(e,t,n)=>{const o=e.document.createRange();var r;return r=o,t.fold(e=>{r.setStartBefore(e.dom)},(e,t)=>{r.setStart(e.dom,t)},e=>{r.setStartAfter(e.dom)}),((e,t)=>{t.fold(t=>{e.setEndBefore(t.dom)},(t,n)=>{e.setEnd(t.dom,n)},t=>{e.setEndAfter(t.dom)})})(o,n),o},gn=(e,t,n,o,r)=>{const s=e.document.createRange();return s.setStart(t.dom,n),s.setEnd(o.dom,r),s},pn=Ne([{ltr:["start","soffset","finish","foffset"]},{rtl:["start","soffset","finish","foffset"]}]),hn=(e,t,n)=>t(un.fromDom(n.startContainer),n.startOffset,un.fromDom(n.endContainer),n.endOffset);pn.ltr,pn.rtl;const bn=(e,t)=>{const n=e.dom;if(1!==n.nodeType)return!1;{const e=n;if(void 0!==e.matches)return e.matches(t);if(void 0!==e.msMatchesSelector)return e.msMatchesSelector(t);if(void 0!==e.webkitMatchesSelector)return e.webkitMatchesSelector(t);if(void 0!==e.mozMatchesSelector)return e.mozMatchesSelector(t);throw new Error("Browser lacks native selectors")}},yn=e=>1!==e.nodeType&&9!==e.nodeType&&11!==e.nodeType||0===e.childElementCount,vn=(e,t)=>e.dom===t.dom,Cn=(e,t)=>{const n=e.dom,o=t.dom;return n!==o&&n.contains(o)},wn=bn,Sn=(e,t)=>{const n=[],o=e=>(n.push(e),t(e));let r=t(e);do{r=r.bind(o)}while(r.isSome());return n},En=e=>e.dom.nodeName.toLowerCase(),xn=e=>e.dom.nodeType,_n=e=>t=>xn(t)===e,kn=e=>8===xn(e)||"#comment"===En(e),Nn=e=>Rn(e)&&Zt(e.dom),Rn=_n(1),An=_n(3),Dn=_n(9),Tn=_n(11),On=e=>t=>Rn(t)&&En(t)===e,Bn=e=>un.fromDom(e.dom.ownerDocument),Pn=e=>Dn(e)?e:Bn(e),Ln=e=>un.fromDom(Pn(e).dom.defaultView),Mn=e=>I.from(e.dom.parentNode).map(un.fromDom),In=e=>I.from(e.dom.parentElement).map(un.fromDom),Fn=(e,t)=>{const n=w(t)?t:L;let o=e.dom;const r=[];for(;null!==o.parentNode&&void 0!==o.parentNode;){const e=o.parentNode,t=un.fromDom(e);if(r.push(t),!0===n(t))break;o=e}return r},Un=e=>Mn(e).map(Vn).map(t=>Y(t,t=>!vn(e,t))).getOr([]),zn=e=>I.from(e.dom.previousSibling).map(un.fromDom),jn=e=>I.from(e.dom.nextSibling).map(un.fromDom),$n=e=>re(Sn(e,zn)),Hn=e=>Sn(e,jn),Vn=e=>V(e.dom.childNodes,un.fromDom),qn=(e,t)=>{const n=e.dom.childNodes;return I.from(n[t]).map(un.fromDom)},Wn=e=>qn(e,0),Kn=e=>qn(e,e.dom.childNodes.length-1),Yn=e=>e.dom.childNodes.length,Gn=e=>{const t=e.dom.head;if(null==t)throw new Error("Head is not available yet");return un.fromDom(t)},Xn=e=>Tn(e)&&C(e.dom.host),Qn=e=>un.fromDom(e.dom.getRootNode()),Zn=e=>Xn(e)?e:Gn(Pn(e)),Jn=e=>un.fromDom(e.dom.host),eo=e=>{if(C(e.target)){const t=un.fromDom(e.target);if(Rn(t)&&to(t)&&e.composed&&e.composedPath){const t=e.composedPath();if(t)return ce(t)}}return I.from(e.target)},to=e=>C(e.dom.shadowRoot),no=(e,t,n,o)=>((e,t,n,o,r)=>{const s=((e,t)=>n=>{e(n)&&t((e=>{const t=un.fromDom(eo(e).getOr(e.target)),n=()=>e.stopPropagation(),o=()=>e.preventDefault(),r=_(o,n);return((e,t,n,o,r,s,a)=>({target:e,x:t,y:n,stop:o,prevent:r,kill:s,raw:a}))(t,e.clientX,e.clientY,n,o,r,e)})(n))})(n,o);return e.dom.addEventListener(t,s,r),{unbind:D(oo,e,t,s,r)}})(e,t,n,o,!1),oo=(e,t,n,o)=>{e.dom.removeEventListener(t,n,o)},ro=M,so=(e,t,n)=>no(e,t,ro,n),ao=()=>un.fromDom(document),io=(e,t=!1)=>e.dom.focus({preventScroll:t}),lo=e=>{const t=Qn(e).dom;return e.dom===t.activeElement},co=(e=ao())=>I.from(e.dom.activeElement).map(un.fromDom),mo=(e,t)=>{Mn(e).each(n=>{n.dom.insertBefore(t.dom,e.dom)})},uo=(e,t)=>{jn(e).fold(()=>{Mn(e).each(e=>{go(e,t)})},e=>{mo(e,t)})},fo=(e,t)=>{Wn(e).fold(()=>{go(e,t)},n=>{e.dom.insertBefore(t.dom,n.dom)})},go=(e,t)=>{e.dom.appendChild(t.dom)},po=(e,t)=>{mo(e,t),go(t,e)},ho=(e,t)=>{q(t,(n,o)=>{const r=0===o?e:t[o-1];uo(r,n)})},bo=(e,t)=>{q(t,t=>{go(e,t)})},yo=(e,t,n)=>{if(!(u(n)||b(n)||S(n)))throw console.error("Invalid call to Attribute.set. Key ",t,":: Value ",n,":: Element ",e),new Error("Attribute value was not simple");e.setAttribute(t,n+"")},vo=(e,t,n)=>{yo(e.dom,t,n)},Co=(e,t)=>{const n=e.dom;he(t,(e,t)=>{yo(n,t,e)})},wo=(e,t)=>{const n=e.dom.getAttribute(t);return null===n?void 0:n},So=(e,t)=>I.from(wo(e,t)),Eo=(e,t)=>{const n=e.dom;return!(!n||!n.hasAttribute)&&n.hasAttribute(t)},xo=(e,t)=>{e.dom.removeAttribute(t)},_o=e=>{const t=e.dom.attributes;return null==t||0===t.length},ko=e=>X(e.dom.attributes,(e,t)=>(e[t.name]=t.value,e),{}),No=e=>{e.dom.textContent="",q(Vn(e),e=>{Ro(e)})},Ro=e=>{const t=e.dom;null!==t.parentNode&&t.parentNode.removeChild(t)},Ao=e=>{const t=Vn(e);t.length>0&&ho(e,t),Ro(e)},Do=(e,t)=>un.fromDom(e.dom.cloneNode(t)),To=e=>Do(e,!1),Oo=e=>Do(e,!0),Bo=(e,t)=>{const n=((e,t)=>{const n=un.fromTag(t),o=ko(e);return Co(n,o),n})(e,t);uo(e,n);const o=Vn(e);return bo(n,o),Ro(e),n},Po=e=>V(e,un.fromDom),Lo=e=>e.dom.innerHTML,Mo=(e,t)=>{const n=Bn(e).dom,o=un.fromDom(n.createDocumentFragment()),r=((e,t)=>{const n=(t||document).createElement("div");return n.innerHTML=e,Vn(un.fromDom(n))})(t,n);bo(o,r),No(e),go(e,o)},Io=e=>void 0!==e.style&&w(e.style.getPropertyValue),Fo=e=>{const t=An(e)?e.dom.parentNode:e.dom;if(null==t||null===t.ownerDocument)return!1;const n=t.ownerDocument;return(e=>{const t=Qn(e);return Xn(t)?I.some(t):I.none()})(un.fromDom(t)).fold(()=>n.body.contains(t),k(Fo,Jn))},Uo=(e,t,n)=>{if(!u(n))throw console.error("Invalid call to CSS.set. Property ",t,":: Value ",n,":: Element ",e),new Error("CSS value must be a string: "+n);Io(e)&&e.style.setProperty(t,n)},zo=(e,t,n)=>{const o=e.dom;Uo(o,t,n)},jo=(e,t)=>{const n=e.dom;he(t,(e,t)=>{Uo(n,t,e)})},$o=(e,t)=>{const n=e.dom,o=window.getComputedStyle(n).getPropertyValue(t);return""!==o||Fo(e)?o:Ho(n,t)},Ho=(e,t)=>Io(e)?e.style.getPropertyValue(t):"",Vo=(e,t)=>{const n=e.dom,o=Ho(n,t);return I.from(o).filter(e=>e.length>0)},qo=e=>{const t={},n=e.dom;if(Io(n))for(let e=0;e<n.style.length;e++){const o=n.style.item(e);t[o]=n.style[o]}return t},Wo=(e,t)=>{((e,t)=>{Io(e)&&e.style.removeProperty(t)})(e.dom,t),ze(So(e,"style").map(et),"")&&xo(e,"style")},Ko=(e=>{const t=t=>{const n=(e=>{const t=e.dom;return Fo(e)?t.getBoundingClientRect().height:t.offsetHeight})(t);if(n<=0||null===n){const n=$o(t,e);return parseFloat(n)||0}return n},n=(e,t)=>X(t,(t,n)=>{const o=$o(e,n),r=void 0===o?0:parseInt(o,10);return isNaN(r)?t:t+r},0);return{set:(t,n)=>{if(!S(n)&&!n.match(/^[0-9]+$/))throw new Error(e+".set accepts only positive integer values. Value was "+n);const o=t.dom;Io(o)&&(o.style[e]=n+"px")},get:t,getOuter:t,aggregate:n,max:(e,t,o)=>{const r=n(e,o);return t>r?t-r:0}}})("height"),Yo=(e,t)=>({left:e,top:t,translate:(n,o)=>Yo(e+n,t+o)}),Go=Yo,Xo=(e,t)=>void 0!==e?e:void 0!==t?t:0,Qo=e=>{const t=e.dom,n=t.ownerDocument.body;return n===t?Go(n.offsetLeft,n.offsetTop):Fo(e)?(e=>{const t=e.getBoundingClientRect();return Go(t.left,t.top)})(t):Go(0,0)},Zo=e=>{const t=void 0!==e?e.dom:document,n=t.body.scrollLeft||t.documentElement.scrollLeft,o=t.body.scrollTop||t.documentElement.scrollTop;return Go(n,o)},Jo=(e,t,n)=>{const o=(void 0!==n?n.dom:document).defaultView;o&&o.scrollTo(e,t)},er=(e,t)=>{Xt().browser.isSafari()&&w(e.dom.scrollIntoViewIfNeeded)?e.dom.scrollIntoViewIfNeeded(!1):e.dom.scrollIntoView(t)},tr=(e,t)=>{const n=(t||document).createDocumentFragment();return q(e,e=>{n.appendChild(e.dom)}),un.fromDom(n)},nr=(e=>{const t=t=>e(t)?I.from(t.dom.nodeValue):I.none();return{get:n=>{if(!e(n))throw new Error("Can only get text value of a text node");return t(n).getOr("")},getOption:t,set:(t,n)=>{if(!e(t))throw new Error("Can only set raw text value of a text node");t.dom.nodeValue=n}}})(An),or=e=>nr.get(e),rr=(e,t)=>nr.set(e,t),sr=(e,t)=>{const n=wo(e,t);return void 0===n||""===n?[]:n.split(" ")};var ar=(e,t,n,o,r)=>e(n,o)?I.some(n):w(r)&&r(n)?I.none():t(n,o,r);const ir=(e,t,n)=>{let o=e.dom;const r=w(n)?n:L;for(;o.parentNode;){o=o.parentNode;const e=un.fromDom(o);if(t(e))return I.some(e);if(r(e))break}return I.none()},lr=(e,t,n)=>ar((e,t)=>t(e),ir,e,t,n),cr=(e,t)=>Z(e.dom.childNodes,e=>t(un.fromDom(e))).map(un.fromDom),dr=(e,t)=>{const n=e=>{for(let o=0;o<e.childNodes.length;o++){const r=un.fromDom(e.childNodes[o]);if(t(r))return I.some(r);const s=n(e.childNodes[o]);if(s.isSome())return s}return I.none()};return n(e.dom)},mr=(e,t,n)=>ir(e,e=>bn(e,t),n),ur=(e,t)=>((e,t)=>{const n=void 0===t?document:t.dom;return yn(n)?I.none():I.from(n.querySelector(e)).map(un.fromDom)})(t,e),fr=(e,t,n)=>ar((e,t)=>bn(e,t),mr,e,t,n),gr=e=>void 0!==e.dom.classList,pr=e=>sr(e,"class"),hr=(e,t)=>((e,t,n)=>{const o=sr(e,t).concat([n]);return vo(e,t,o.join(" ")),!0})(e,"class",t),br=(e,t)=>((e,t,n)=>{const o=Y(sr(e,t),e=>e!==n);return o.length>0?vo(e,t,o.join(" ")):xo(e,t),!1})(e,"class",t),yr=(e,t)=>{gr(e)?e.dom.classList.add(t):hr(e,t)},vr=e=>{0===(gr(e)?e.dom.classList:pr(e)).length&&xo(e,"class")},Cr=(e,t)=>{gr(e)?e.dom.classList.remove(t):br(e,t),vr(e)},wr=(e,t)=>gr(e)&&e.dom.classList.contains(t),Sr=(e,t=!1)=>{return Fo(e)?e.dom.isContentEditable:(n=e,fr(n,"[contenteditable]")).fold(N(t),e=>"true"===Er(e));var n},Er=e=>e.dom.contentEditable,xr=(e,t)=>{e.dom.contentEditable=t?"true":"false"},_r=(e,t,n)=>Y(Fn(e,n),t),kr=(e,t)=>Y(Vn(e),t),Nr=(e,t)=>{let n=[];return q(Vn(e),e=>{t(e)&&(n=n.concat([e])),n=n.concat(Nr(e,t))}),n},Rr=(e,t)=>((e,t)=>{const n=void 0===t?document:t.dom;return yn(n)?[]:V(n.querySelectorAll(e),un.fromDom)})(t,e),Ar=(e,t,n)=>ir(e,t,n).isSome(),Dr=(e,t)=>dr(e,t).isSome(),Tr=e=>w(e)?e:L,Or=(e,t,n)=>{const o=t(e),r=Tr(n);return o.orThunk(()=>r(e)?I.none():((e,t,n)=>{let o=e.dom;const r=Tr(n);for(;o.parentNode;){o=o.parentNode;const e=un.fromDom(o),n=t(e);if(n.isSome())return n;if(r(e))break}return I.none()})(e,t,r))},Br=["img","br"],Pr=e=>{return(t=e,nr.getOption(t)).filter(e=>0!==e.trim().length||e.indexOf(dt)>-1).isSome()||$(Br,En(e))||(e=>Nn(e)&&"false"===wo(e,"contenteditable"))(e);var t},Lr=(e,t,n,o)=>({start:e,soffset:t,finish:n,foffset:o}),Mr=Ne([{before:["element"]},{on:["element","offset"]},{after:["element"]}]),Ir={before:Mr.before,on:Mr.on,after:Mr.after,cata:(e,t,n,o)=>e.fold(t,n,o),getStart:e=>e.fold(R,R,R)},Fr=Ne([{domRange:["rng"]},{relative:["startSitu","finishSitu"]},{exact:["start","soffset","finish","foffset"]}]),Ur={domRange:Fr.domRange,relative:Fr.relative,exact:Fr.exact,exactFromRange:e=>Fr.exact(e.start,e.soffset,e.finish,e.foffset),getWin:e=>{const t=(e=>e.match({domRange:e=>un.fromDom(e.startContainer),relative:(e,t)=>Ir.getStart(e),exact:(e,t,n,o)=>e}))(e);return Ln(t)},range:Lr},zr=(e,t)=>{const n=En(e);return"input"===n?Ir.after(e):$(["br","img"],n)?0===t?Ir.before(e):Ir.after(e):Ir.on(e,t)},jr=(e,t)=>{const n=e.fold(Ir.before,zr,Ir.after),o=t.fold(Ir.before,zr,Ir.after);return Ur.relative(n,o)},$r=(e,t,n,o)=>{const r=zr(e,t),s=zr(n,o);return Ur.relative(r,s)},Hr=e=>{const t=Ur.getWin(e).dom,n=(e,n,o,r)=>gn(t,e,n,o,r),o=(e=>e.match({domRange:e=>{const t=un.fromDom(e.startContainer),n=un.fromDom(e.endContainer);return $r(t,e.startOffset,n,e.endOffset)},relative:jr,exact:$r}))(e);return((e,t)=>{const n=((e,t)=>t.match({domRange:e=>({ltr:N(e),rtl:I.none}),relative:(t,n)=>({ltr:lt(()=>fn(e,t,n)),rtl:lt(()=>I.some(fn(e,n,t)))}),exact:(t,n,o,r)=>({ltr:lt(()=>gn(e,t,n,o,r)),rtl:lt(()=>I.some(gn(e,o,r,t,n)))})}))(e,t);return((e,t)=>{const n=t.ltr();return n.collapsed?t.rtl().filter(e=>!1===e.collapsed).map(e=>pn.rtl(un.fromDom(e.endContainer),e.endOffset,un.fromDom(e.startContainer),e.startOffset)).getOrThunk(()=>hn(0,pn.ltr,n)):hn(0,pn.ltr,n)})(0,n)})(t,o).match({ltr:n,rtl:n})},Vr=(e,t,n)=>((e,t,n)=>((e,t,n)=>e.caretPositionFromPoint?((e,t,n)=>I.from(e.caretPositionFromPoint?.(t,n)).bind(t=>{if(null===t.offsetNode)return I.none();const n=e.createRange();return n.setStart(t.offsetNode,t.offset),n.collapse(),I.some(n)}))(e,t,n):e.caretRangeFromPoint?((e,t,n)=>I.from(e.caretRangeFromPoint?.(t,n)))(e,t,n):I.none())(e.document,t,n).map(e=>Lr(un.fromDom(e.startContainer),e.startOffset,un.fromDom(e.endContainer),e.endOffset)))(e,t,n),qr=(e,t,n,o)=>({x:e,y:t,width:n,height:o,right:e+n,bottom:t+o}),Wr=e=>{const t=void 0===e?window:e,n=t.document,o=Zo(un.fromDom(n));return(e=>{const t=void 0===e?window:e;return Xt().browser.isFirefox()?I.none():I.from(t.visualViewport)})(t).fold(()=>{const e=t.document.documentElement,n=e.clientWidth,r=e.clientHeight;return qr(o.left,o.top,n,r)},e=>qr(Math.max(e.pageLeft,o.left),Math.max(e.pageTop,o.top),e.width,e.height))};class Kr{rootNode;node;constructor(e,t){this.node=e,this.rootNode=t,this.current=this.current.bind(this),this.next=this.next.bind(this),this.prev=this.prev.bind(this),this.prev2=this.prev2.bind(this)}current(){return this.node}next(e){return this.node=this.findSibling(this.node,"firstChild","nextSibling",e),this.node}prev(e){return this.node=this.findSibling(this.node,"lastChild","previousSibling",e),this.node}prev2(e){return this.node=this.findPreviousNode(this.node,e),this.node}findSibling(e,t,n,o){if(e){if(!o&&e[t])return e[t];if(e!==this.rootNode){let t=e[n];if(t)return t;for(let o=e.parentNode;o&&o!==this.rootNode;o=o.parentNode)if(t=o[n],t)return t}}}findPreviousNode(e,t){if(e){const n=e.previousSibling;if(this.rootNode&&n===this.rootNode)return;if(n){if(!t)for(let e=n.lastChild;e;e=e.lastChild)if(!e.lastChild)return e;return n}const o=e.parentNode;if(o&&o!==this.rootNode)return o}}}const Yr=e=>t=>!!t&&t.nodeType===e,Gr=e=>!!e&&!Object.getPrototypeOf(e),Xr=Yr(1),Qr=e=>Xr(e)&&Nn(un.fromDom(e)),Zr=e=>{const t=e.toLowerCase();return e=>C(e)&&e.nodeName.toLowerCase()===t},Jr=e=>{const t=e.map(e=>e.toLowerCase());return e=>{if(e&&e.nodeName){const n=e.nodeName.toLowerCase();return $(t,n)}return!1}},es=(e,t)=>{const n=t.toLowerCase().split(" ");return t=>{if(Xr(t)){const o=t.ownerDocument.defaultView;if(o)for(let r=0;r<n.length;r++){const s=o.getComputedStyle(t,null);if((s?s.getPropertyValue(e):null)===n[r])return!0}}return!1}},ts=e=>Xr(e)&&e.hasAttribute("data-mce-bogus"),ns=e=>Xr(e)&&"TABLE"===e.tagName,os=e=>t=>{if(Qr(t)){if(t.contentEditable===e)return!0;if(t.getAttribute("data-mce-contenteditable")===e)return!0}return!1},rs=Jr(["textarea","input"]),ss=Yr(3),as=Yr(4),is=Yr(7),ls=Yr(8),cs=Yr(9),ds=Yr(11),ms=Zr("br"),us=Zr("img"),fs=Zr("a"),gs=os("true"),ps=os("false"),hs=e=>Qr(e)&&e.isContentEditable&&C(e.parentElement)&&!e.parentElement.isContentEditable,bs=Jr(["td","th"]),ys=Jr(["td","th","caption"]),vs=Zr("template"),Cs=Jr(["video","audio","object","embed"]),ws=Zr("li"),Ss=Zr("details"),Es=Zr("summary"),xs="uc-video",_s=Zr(xs),ks=/^[ \t\r\n]*$/,Ns=e=>ks.test(e),Rs=e=>"\n"===e||"\r"===e,As=(e,t=4,n=!0,o=!0)=>{const r=((e,t)=>t<=0?"":new Array(t+1).join(" "))(0,t),s=e.replace(/\t/g,r),a=X(s,(e,t)=>(e=>-1!==" \f\t\v".indexOf(e))(t)||t===dt?e.pcIsSpace||""===e.str&&n||e.str.length===s.length-1&&o||((e,t)=>t<e.length&&t>=0&&Rs(e[t]))(s,e.str.length+1)?{pcIsSpace:!1,str:e.str+dt}:{pcIsSpace:!0,str:e.str+" "}:{pcIsSpace:Rs(t),str:e.str+t},{pcIsSpace:!1,str:""});return a.str},Ds={skipBogus:!0,includeZwsp:!1,checkRootAsContent:!1},Ts=e=>Xr(e)&&e.hasAttribute("data-mce-bookmark");const Os=(e,t,n,o)=>ss(e)&&!((e,t,n)=>Ns(e.data)&&!((e,t,n)=>{const o=un.fromDom(t),r=un.fromDom(e),s=n.getWhitespaceElements();return Ar(r,e=>_e(s,En(e)),D(vn,o))})(e,t,n))(e,t,n)&&(!o.includeZwsp||!(e=>{for(const t of e)if(!mt(t))return!1;return!0})(e.data)),Bs=(e,t,n,o)=>w(o.isContent)&&o.isContent(t)||((e,t)=>Xr(e)&&_e(t.getNonEmptyElements(),e.nodeName))(t,e)||Ts(t)||(e=>Xr(e)&&"A"===e.nodeName&&!e.hasAttribute("href")&&(e.hasAttribute("name")||e.hasAttribute("id")))(t)||Os(t,n,e,o)||ps(t)||gs(t)&&(e=>In(un.fromDom(e)).exists(e=>!Sr(e)))(t),Ps=(e,t,n)=>{const o={...Ds,...n};if(o.checkRootAsContent&&Bs(e,t,t,o))return!1;let r=t.firstChild,s=0;if(!r)return!0;const a=new Kr(r,t);do{if(o.skipBogus&&Xr(r)){const e=r.getAttribute("data-mce-bogus");if(e){r=a.next("all"===e);continue}}if(ls(r))r=a.next(!0);else if(ms(r))s++,r=a.next();else{if(Bs(e,r,t,o))return!1;r=a.next()}}while(r);return s<=1},Ls=(e,t,n)=>Ps(e,t.dom,{checkRootAsContent:!0,...n}),Ms=(e,t,n)=>Bs(e,t,t,{includeZwsp:Ds.includeZwsp,...n}),Is=e=>{const t=e.toLowerCase();return"svg"===t?"svg":"math"===t?"math":"html"},Fs=e=>"html"!==Is(e),Us=e=>Fs(e.nodeName),zs=e=>Is(e.nodeName),js=["svg","math"],$s="data-mce-block",Hs=e=>V((e=>Y(ge(e),e=>!/[A-Z]/.test(e)))(e),e=>{const t=CSS.escape(e);return`${t}:`+V(js,e=>`not(${e} ${t})`).join(":")}).join(","),Vs=(e,t)=>C(t.querySelector(e))?(t.setAttribute($s,"true"),"inline-boundary"===t.getAttribute("data-mce-selected")&&t.removeAttribute("data-mce-selected"),!0):(t.removeAttribute($s),!1),qs=(e,t)=>{const n=Hs(e.getTransparentElements()),o=Hs(e.getBlockElements());return Y(t.querySelectorAll(n),e=>Vs(o,e))},Ws=(e,t,n)=>{const o=n?"lastChild":"firstChild";for(let n=t[o];n;n=n[o])if(Ps(e,n,{checkRootAsContent:!0}))return void n.parentNode?.removeChild(n)},Ks=(e,t)=>{const n=qs(e,t);((e,t,n)=>{const o=e.getBlockElements(),r=un.fromDom(t),s=e=>En(e)in o,a=e=>vn(e,r);q(Po(n),t=>{ir(t,s,a).each(n=>{const o=kr(t,t=>s(t)&&!e.isValidChild(En(n),En(t)));if(o.length>0){const t=In(n);q(o,t=>{ir(t,s,a).each(n=>{((e,t,n)=>{const o=document.createRange(),r=t.parentNode;if(r){o.setStartBefore(t),o.setEndBefore(n);const s=o.extractContents();Ws(e,s,!0),o.setStartAfter(n),o.setEndAfter(t);const a=o.extractContents();Ws(e,a,!1),Ps(e,s,{checkRootAsContent:!0})||r.insertBefore(s,t),Ps(e,n,{checkRootAsContent:!0})||r.insertBefore(n,t),Ps(e,a,{checkRootAsContent:!0})||r.insertBefore(a,t),r.removeChild(t)}})(e,n.dom,t.dom)})}),t.each(t=>qs(e,t.dom))}})})})(e,t,n),((e,t,n)=>{q([...n,...Zs(e,t)?[t]:[]],t=>q(Rr(un.fromDom(t),t.nodeName.toLowerCase()),t=>{Js(e,t.dom)&&Ao(t)}))})(e,t,n)},Ys=(e,t)=>{if(Qs(e,t)){const n=Hs(e.getBlockElements());Vs(n,t)}},Gs=e=>e.hasAttribute($s),Xs=(e,t)=>_e(e.getTransparentElements(),t),Qs=(e,t)=>Xr(t)&&Xs(e,t.nodeName),Zs=(e,t)=>Qs(e,t)&&Gs(t),Js=(e,t)=>Qs(e,t)&&!Gs(t),ea=(e,t)=>1===t.type&&Xs(e,t.name)&&u(t.attr($s)),ta=Xt().browser,na=e=>Z(e,Rn),oa=(e,t)=>e.children&&$(e.children,t),ra=(e,t={})=>{let n=0;const o={},r=un.fromDom(e),s=Pn(r),a=e=>{go(Zn(r),e)},i=e=>{const t=Zn(r);ur(t,"#"+e).each(Ro)},l=e=>xe(o,e).getOrThunk(()=>({id:"mce-u"+n++,passed:[],failed:[],count:0})),c=e=>new Promise((n,r)=>{let i;const c=dn._addCacheSuffix(e),d=l(c);o[c]=d,d.count++;const m=(e,t)=>{q(e,P),d.status=t,d.passed=[],d.failed=[],i&&(i.onload=null,i.onerror=null,i=null)},u=()=>m(d.passed,2),f=()=>m(d.failed,3);if(n&&d.passed.push(n),r&&d.failed.push(r),1===d.status)return;if(2===d.status)return void u();if(3===d.status)return void f();d.status=1;const g=un.fromTag("link",s.dom);Co(g,{rel:"stylesheet",type:"text/css",id:d.id});const p=((e,t)=>{const n=t.crossOrigin;return t.contentCssCors?"anonymous":w(n)?n(e):void 0})(e,t);void 0!==p&&vo(g,"crossOrigin",p),t.referrerPolicy&&vo(g,"referrerpolicy",t.referrerPolicy),i=g.dom,i.onload=u,i.onerror=f,a(g),vo(g,"href",c)}),d=e=>{const t=dn._addCacheSuffix(e);xe(o,t).each(e=>{0===--e.count&&(delete o[t],i(e.id))})};return{load:c,loadRawCss:(e,t)=>{const n=l(e);o[e]=n,n.count++;const r=un.fromTag("style",s.dom);Co(r,{rel:"stylesheet",type:"text/css",id:n.id,"data-mce-key":e}),r.dom.innerHTML=t,a(r)},loadAll:e=>Promise.allSettled(V(e,e=>c(e).then(N(e)))).then(e=>{const t=K(e,e=>"fulfilled"===e.status);return t.fail.length>0?Promise.reject(V(t.fail,e=>e.reason)):V(t.pass,e=>e.value)}),unload:d,unloadRawCss:e=>{xe(o,e).each(t=>{0===--t.count&&(delete o[e],i(t.id))})},unloadAll:e=>{q(e,e=>{d(e)})},_setReferrerPolicy:e=>{t.referrerPolicy=e},_setContentCssCors:e=>{t.contentCssCors=e},_setCrossOrigin:e=>{t.crossOrigin=e}}},sa=(()=>{const e=new WeakMap;return{forElement:(t,n)=>{const o=Qn(t).dom;return I.from(e.get(o)).getOrThunk(()=>{const t=ra(o,n);return e.set(o,t),t})}}})(),aa=(e,t)=>C(e)&&(Ms(t,e)||t.isInline(e.nodeName.toLowerCase())),ia=e=>(e=>"span"===e.nodeName.toLowerCase())(e)&&"bookmark"===e.getAttribute("data-mce-type"),la=(e,t,n,o)=>{const r=o||t;if(Xr(t)&&ia(t))return t;const s=t.childNodes;for(let t=s.length-1;t>=0;t--)la(e,s[t],n,r);if(Xr(t)){const e=t.childNodes;1===e.length&&ia(e[0])&&t.parentNode?.insertBefore(e[0],t)}return(e=>ds(e)||cs(e))(t)||Ms(n,t)||(e=>!!Xr(e)&&e.childNodes.length>0)(t)||((e,t,n)=>ss(e)&&e.data.length>0&&((e,t,n)=>{const o=new Kr(e,t).prev(!1),r=new Kr(e,t).next(!1),s=y(o)||aa(o,n),a=y(r)||aa(r,n);return s&&a})(e,t,n))(t,r,n)||e.remove(t),t},ca=dn.makeMap,da=/[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g,ma=/[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g,ua=/[<>&\"\']/g,fa=/&#([a-z0-9]+);?|&([a-z0-9]+);/gi,ga={128:"\u20ac",130:"\u201a",131:"\u0192",132:"\u201e",133:"\u2026",134:"\u2020",135:"\u2021",136:"\u02c6",137:"\u2030",138:"\u0160",139:"\u2039",140:"\u0152",142:"\u017d",145:"\u2018",146:"\u2019",147:"\u201c",148:"\u201d",149:"\u2022",150:"\u2013",151:"\u2014",152:"\u02dc",153:"\u2122",154:"\u0161",155:"\u203a",156:"\u0153",158:"\u017e",159:"\u0178"},pa={'"':"&quot;","'":"&#39;","<":"&lt;",">":"&gt;","&":"&amp;","`":"&#96;"},ha={"&lt;":"<","&gt;":">","&amp;":"&","&quot;":'"',"&apos;":"'"},ba=(e,t)=>{const n={};if(e){const o=e.split(",");t=t||10;for(let e=0;e<o.length;e+=2){const r=String.fromCharCode(parseInt(o[e],t));if(!pa[r]){const t="&"+o[e+1]+";";n[r]=t,n[t]=r}}return n}},ya=ba("50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,t9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro",32),va=(e,t)=>e.replace(t?da:ma,e=>pa[e]||e),Ca=(e,t)=>e.replace(t?da:ma,e=>e.length>1?"&#"+(1024*(e.charCodeAt(0)-55296)+(e.charCodeAt(1)-56320)+65536)+";":pa[e]||"&#"+e.charCodeAt(0)+";"),wa=(e,t,n)=>{const o=n||ya;return e.replace(t?da:ma,e=>pa[e]||o[e]||e)},Sa={encodeRaw:va,encodeAllRaw:e=>(""+e).replace(ua,e=>pa[e]||e),encodeNumeric:Ca,encodeNamed:wa,getEncodeFunc:(e,t)=>{const n=ba(t)||ya,o=ca(e.replace(/\+/g,","));return o.named&&o.numeric?(e,t)=>e.replace(t?da:ma,e=>void 0!==pa[e]?pa[e]:void 0!==n[e]?n[e]:e.length>1?"&#"+(1024*(e.charCodeAt(0)-55296)+(e.charCodeAt(1)-56320)+65536)+";":"&#"+e.charCodeAt(0)+";"):o.named?t?(e,t)=>wa(e,t,n):wa:o.numeric?Ca:va},decode:e=>e.replace(fa,(e,t)=>t?(t="x"===t.charAt(0).toLowerCase()?parseInt(t.substr(1),16):parseInt(t,10))>65535?(t-=65536,String.fromCharCode(55296+(t>>10),56320+(1023&t))):ga[t]||String.fromCharCode(t):ha[e]||ya[e]||(e=>{const t=un.fromTag("div").dom;return t.innerHTML=e,t.textContent||t.innerText||e})(e))},Ea=(e,t)=>(e=dn.trim(e))?e.split(t||" "):[],xa=e=>new RegExp("^"+e.replace(/([?+*])/g,".$1")+"$"),_a=e=>Object.freeze(["id","accesskey","class","dir","lang","style","tabindex","title","role",..."html4"!==e?["contenteditable","contextmenu","draggable","dropzone","hidden","spellcheck","translate","itemprop","itemscope","itemtype"]:[],..."html5-strict"!==e?["xml:lang"]:[]]),ka=e=>{let t,n;t="address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul",n="a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd label map noscript object q s samp script select small span strong sub sup textarea u var #text #comment","html4"!==e&&(t+=" article aside details dialog figure main header footer hgroup section nav a ins del canvas map",n+=" audio canvas command data datalist mark meter output picture progress template time wbr video ruby bdi keygen svg"),"html5-strict"!==e&&(n=[n,"acronym applet basefont big font strike tt"].join(" "),t=[t,"center dir isindex noframes"].join(" "));const o=[t,n].join(" ");return{blockContent:t,phrasingContent:n,flowContent:o}},Na=e=>{const{blockContent:t,phrasingContent:n,flowContent:o}=ka(e),r=e=>Object.freeze(e.split(" "));return Object.freeze({blockContent:r(t),phrasingContent:r(n),flowContent:r(o)})},Ra={html4:lt(()=>Na("html4")),html5:lt(()=>Na("html5")),"html5-strict":lt(()=>Na("html5-strict"))},Aa=(e,t)=>{const{blockContent:n,phrasingContent:o,flowContent:r}=Ra[e]();return"blocks"===t?I.some(n):"phrasing"===t?I.some(o):"flow"===t?I.some(r):I.none()},Da=e=>I.from(/^(@?)([A-Za-z0-9_\-.\u00b7\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u037d\u037f-\u1fff\u200c-\u200d\u203f-\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]+)$/.exec(e)).map(e=>({preset:"@"===e[1],name:e[2]})),Ta={},Oa=dn.makeMap,Ba=dn.each,Pa=dn.extend,La=dn.explode,Ma=(e,t={})=>{const n=Oa(e," ",Oa(e.toUpperCase()," "));return Pa(n,t)},Ia=e=>Ma("td th li dt dd figcaption caption details summary",e.getTextBlockElements()),Fa=(e,t)=>{if(e){const n={};return u(e)&&(e={"*":e}),Ba(e,(e,o)=>{n[o]=n[o.toUpperCase()]="map"===t?Oa(e,/[, ]/):La(e,/[, ]/)}),n}},Ua=(e={})=>{const t={},n={};let o=[];const r={},s={},a={},i=(t,n,o)=>{const r=e[t];if(r)return Oa(r,/[, ]/,Oa(r.toUpperCase(),/[, ]/));{let e=Ta[t];return e||(e=Ma(n,o),Ta[t]=e),e}},l=e.schema??"html5",c=(e=>{const t=_a(e),{phrasingContent:n,flowContent:o}=ka(e),r={},s=(e,t,n)=>{r[e]={attributes:ae(t,N({})),attributesOrder:t,children:ae(n,N({}))}},a=(e,n="",o="")=>{const r=Ea(o),a=Ea(e);let i=a.length;const l=[...t,...Ea(n)];for(;i--;)s(a[i],l.slice(),r)},i=(e,t)=>{const n=Ea(e),o=Ea(t);let s=n.length;for(;s--;){const e=r[n[s]];for(let t=0,n=o.length;t<n;t++)e.attributes[o[t]]={},e.attributesOrder.push(o[t])}};return"html5-strict"!==e&&(q(Ea("acronym applet basefont big font strike tt"),e=>{a(e,"",n)}),q(Ea("center dir isindex noframes"),e=>{a(e,"",o)})),a("html","manifest","head body"),a("head","","base command link meta noscript script style title"),a("title hr noscript br"),a("base","href target"),a("link","href rel media hreflang type sizes hreflang"),a("meta","name http-equiv content charset property"),a("style","media type scoped"),a("script","src async defer type charset"),a("body","onafterprint onbeforeprint onbeforeunload onblur onerror onfocus onhashchange onload onmessage onoffline ononline onpagehide onpageshow onpopstate onresize onscroll onstorage onunload",o),a("dd div","",o),a("address dt caption","","html4"===e?n:o),a("h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn","",n),a("blockquote","cite",o),a("ol","reversed start type","li"),a("ul","","li"),a("li","value",o),a("dl","","dt dd"),a("a","href target rel media hreflang type","html4"===e?n:o),a("q","cite",n),a("ins del","cite datetime",o),a("img","src sizes srcset alt usemap ismap width height"),a("iframe","src name width height",o),a("embed","src type width height"),a("object","data type typemustmatch name usemap form width height",[o,"param"].join(" ")),a("param","name value"),a("map","name",[o,"area"].join(" ")),a("area","alt coords shape href target rel media hreflang type"),a("table","border","caption colgroup thead tfoot tbody tr"+("html4"===e?" col":"")),a("colgroup","span","col"),a("col","span"),a("tbody thead tfoot","","tr"),a("tr","","td th"),a("td","colspan rowspan headers",o),a("th","colspan rowspan headers scope abbr",o),a("form","accept-charset action autocomplete enctype method name novalidate target",o),a("fieldset","disabled form name",[o,"legend"].join(" ")),a("label","form for",n),a("input","accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate formtarget height list max maxlength min multiple name pattern readonly required size src step type value width"),a("button","disabled form formaction formenctype formmethod formnovalidate formtarget name type value","html4"===e?o:n),a("select","disabled form multiple name required size","option optgroup"),a("optgroup","disabled label","option"),a("option","disabled label selected value"),a("textarea","cols dirname disabled form maxlength name readonly required rows wrap"),a("menu","type label",[o,"li"].join(" ")),a("noscript","",o),"html4"!==e&&(a("wbr"),a("ruby","",[n,"rt rp"].join(" ")),a("figcaption","",o),a("mark rt rp bdi","",n),a("summary","",[n,"h1 h2 h3 h4 h5 h6"].join(" ")),a("canvas","width height",o),a("data","value",n),a("video","src crossorigin poster preload autoplay mediagroup loop controlslist disablepictureinpicture disableremoteplayback playsinline muted controls width height buffered",[o,"track source"].join(" ")),a("audio","src crossorigin preload autoplay mediagroup loop muted controls buffered volume",[o,"track source"].join(" ")),a("picture","","img source"),a("source","src srcset type media sizes"),a("track","kind src srclang label default"),a("datalist","",[n,"option"].join(" ")),a("article section nav aside main header footer","",o),a("hgroup","","h1 h2 h3 h4 h5 h6"),a("figure","",[o,"figcaption"].join(" ")),a("time","datetime",n),a("dialog","open",o),a("command","type label icon disabled checked radiogroup command"),a("output","for form name",n),a("progress","value max",n),a("meter","value min max low high optimum",n),a("details","open",[o,"summary"].join(" ")),a("keygen","autofocus challenge disabled form keytype name"),s("svg","id tabindex lang xml:space class style x y width height viewBox preserveAspectRatio zoomAndPan transform".split(" "),[])),"html5-strict"!==e&&(i("script","language xml:space"),i("style","xml:space"),i("object","declare classid code codebase codetype archive standby align border hspace vspace"),i("embed","align name hspace vspace"),i("param","valuetype type"),i("a","charset name rev shape coords"),i("br","clear"),i("applet","codebase archive code object alt name width height align hspace vspace"),i("img","name longdesc align border hspace vspace"),i("iframe","longdesc frameborder marginwidth marginheight scrolling align"),i("font basefont","size color face"),i("input","usemap align"),i("select"),i("textarea"),i("h1 h2 h3 h4 h5 h6 div p legend caption","align"),i("ul","type compact"),i("li","type"),i("ol dl menu dir","compact"),i("pre","width xml:space"),i("hr","align noshade size width"),i("isindex","prompt"),i("table","summary width frame rules cellspacing cellpadding align bgcolor"),i("col","width align char charoff valign"),i("colgroup","width align char charoff valign"),i("thead","align char charoff valign"),i("tr","align char charoff valign bgcolor"),i("th","axis align char charoff valign nowrap bgcolor width height"),i("form","accept"),i("td","abbr axis scope align char charoff valign nowrap bgcolor width height"),i("tfoot","align char charoff valign"),i("tbody","align char charoff valign"),i("area","nohref"),i("body","background bgcolor text link vlink alink")),"html4"!==e&&(i("input button select textarea","autofocus"),i("input textarea","placeholder"),i("a","download"),i("link script img","crossorigin"),i("img","loading"),i("iframe","sandbox seamless allow allowfullscreen loading referrerpolicy")),"html4"!==e&&q([r.video,r.audio],e=>{delete e.children.audio,delete e.children.video}),q(Ea("a form meter progress dfn"),e=>{r[e]&&delete r[e].children[e]}),delete r.caption.children.table,delete r.script,r})(l);!1===e.verify_html&&(e.valid_elements="*[*]");const d=Fa(e.valid_styles),m=Fa(e.invalid_styles,"map"),g=Fa(e.valid_classes,"map"),h=i("whitespace_elements","pre script noscript style textarea video audio iframe object code"),y=i("self_closing_elements","colgroup dd dt li option p td tfoot th thead tr"),v=i("void_elements","area base basefont br col frame hr img input isindex link meta param embed source wbr track"),C=i("boolean_attributes","checked compact declare defer disabled ismap multiple nohref noresize noshade nowrap readonly selected autoplay loop controls allowfullscreen"),w="td th iframe video audio object script code",S=i("non_empty_elements",w+" pre svg textarea summary",v),E=i("move_caret_before_on_enter_elements",w+" table",v),x="h1 h2 h3 h4 h5 h6",_=i("text_block_elements",x+" p div address pre form blockquote center dir fieldset header footer article section hgroup aside main nav figure"),k=i("block_elements","hr table tbody thead tfoot th tr td li ol ul caption dl dt dd noscript menu isindex option datalist select optgroup figcaption details summary html body multicol listing colgroup col",_),R=i("text_inline_elements","span strong b em i font s strike u var cite dfn code mark q sup sub samp"),A=i("transparent_elements","a ins del canvas map"),D=i("wrap_block_elements","pre "+x);Ba("script noscript iframe noframes noembed title style textarea xmp plaintext".split(" "),e=>{s[e]=new RegExp("</"+e+"[^>]*>","gi")});const T=e=>{const n=I.from(t["@"]),r=/[*?+]/;q(((e,t)=>{const n=/^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)])?$/;return ne(Ea(t,","),t=>{const o=n.exec(t);if(o){const t=o[1],n=o[2],r=o[3],s=o[4],a=o[5],i={attributes:{},attributesOrder:[]};if(e.each(e=>((e,t)=>{he(e.attributes,(e,n)=>{t.attributes[n]=e}),t.attributesOrder.push(...e.attributesOrder)})(e,i)),"#"===t?i.paddEmpty=!0:"-"===t&&(i.removeEmpty=!0),"!"===s&&(i.removeEmptyAttrs=!0),a&&((e,t)=>{const n=/^([!\-])?(\w+[\\:]:\w+|[^=~<]+)?(?:([=~<])(.*))?$/,o=/[*?+]/,{attributes:r,attributesOrder:s}=t;q(Ea(e,"|"),e=>{const a=n.exec(e);if(a){const e={},n=a[1],i=a[2].replace(/[\\:]:/g,":"),l=a[3],c=a[4];if("!"===n&&(t.attributesRequired=t.attributesRequired||[],t.attributesRequired.push(i),e.required=!0),"-"===n)return delete r[i],void s.splice(dn.inArray(s,i),1);if(l&&("="===l?(t.attributesDefault=t.attributesDefault||[],t.attributesDefault.push({name:i,value:c}),e.defaultValue=c):"~"===l?(t.attributesForced=t.attributesForced||[],t.attributesForced.push({name:i,value:c}),e.forcedValue=c):"<"===l&&(e.validValues=dn.makeMap(c,"?"))),o.test(i)){const n=e;t.attributePatterns=t.attributePatterns||[],n.pattern=xa(i),t.attributePatterns.push(n)}else r[i]||s.push(i),r[i]=e}})})(a,i),r&&(i.outputName=n),"@"===n){if(!e.isNone())return[];e=I.some(i)}return[r?{name:n,element:i,aliasName:r}:{name:n,element:i}]}return[]})})(n,e??""),({name:e,element:n,aliasName:s})=>{if(s&&(t[s]=n),r.test(e)){const t=n;t.pattern=xa(e),o.push(t)}else t[e]=n})},O=e=>{o=[],q(ge(t),e=>{delete t[e]}),T(e)},B=(e,o)=>{delete Ta.text_block_elements,delete Ta.block_elements;const s=!!o.extends&&!oe(o.extends),a=o.extends;if(n[e]=a?n[a]:{},r[e]=a??e,S[e.toUpperCase()]={},S[e]={},s||(k[e.toUpperCase()]={},k[e]={}),a&&!t[e]&&t[a]){const n=(e=>{const t=e=>p(e)?V(e,t):(e=>f(e)&&e.source&&"[object RegExp]"===Object.prototype.toString.call(e))(e)?new RegExp(e.source,e.flags):f(e)?be(e,t):e;return t(e)})(t[a]);delete n.removeEmptyAttrs,delete n.removeEmpty,t[e]=n}else t[e]={attributesOrder:[],attributes:{}};if(p(o.attributes)){const n=e=>{r.attributesOrder.push(e),r.attributes[e]={}},r=t[e]??{};delete r.attributesDefault,delete r.attributesForced,delete r.attributePatterns,delete r.attributesRequired,r.attributesOrder=[],r.attributes={},q(o.attributes,e=>{const t=_a(l);Da(e).each(({preset:e,name:o})=>{e?"global"===o&&q(t,n):n(o)})}),t[e]=r}if(b(o.padEmpty)){const n=t[e]??{};n.paddEmpty=o.padEmpty,t[e]=n}if(p(o.children)){const t={},r=e=>{t[e]={}},s=e=>{Aa(l,e).each(e=>{q(e,r)})};q(o.children,e=>{Da(e).each(({preset:e,name:t})=>{e?s(t):r(t)})}),n[e]=t}a&&he(n,(t,o)=>{t[a]&&(n[o]=t=Pa({},n[o]),t[e]=t[a])})},P=e=>{f(e)?he(e,(e,t)=>{const n=e.componentUrl;u(n)&&((e,t)=>{a[e]=t})(t,n),B(t,e)}):u(e)&&(e=>{q((e=>{const t=/^(~)?(.+)$/;return ne(Ea(e,","),e=>{const n=t.exec(e);return n?[{cloneName:"~"===n[1]?"span":"div",name:n[2]}]:[]})})(e??""),({name:e,cloneName:t})=>{B(e,{extends:t})})})(e)},L=e=>{q((e=>{const t=/^([+\-]?)([A-Za-z0-9_\-.\u00b7\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u037d\u037f-\u1fff\u200c-\u200d\u203f-\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]+)\[([^\]]+)]$/;return ne(Ea(e,","),e=>{const n=t.exec(e);if(n){const e=n[1],t=e?(e=>"-"===e?"remove":"add")(e):"replace";return[{operation:t,name:n[2],validChildren:ne(Ea(n[3],"|"),e=>Da(e).toArray())}]}return[]})})(e??""),({operation:e,name:t,validChildren:o})=>{const r="replace"===e?{"#comment":{}}:n[t],s=t=>{"remove"===e?delete r[t]:r[t]={}};q(o,({preset:e,name:t})=>{e?(e=>{Aa(l,e).each(e=>{q(e,s)})})(t):s(t)}),n[t]=r})},M=e=>{const n=t[e];if(n)return n;let r=o.length;for(;r--;){const t=o[r];if(t.pattern.test(e))return t}},F=N(d),U=N(m),z=N(g),j=N(C),$=N(k),H=N(_),W=N(R),K=N(Object.seal(v)),Y=N(y),G=N(S),X=N(E),Q=N(h),Z=N(A),J=N(D),ee=N(Object.seal(s)),te=(e,t)=>{const n=M(e);if(n){if(!t)return!0;{if(n.attributes[t])return!0;const e=n.attributePatterns;if(e){let n=e.length;for(;n--;)if(e[n].pattern.test(t))return!0}}}return!1},oe=e=>_e($(),e),re=e=>!Qe(e,"#")&&te(e)&&!oe(e),se=N(r),ie=N(a);return e.valid_elements?(O(e.valid_elements),Ba(c,(e,t)=>{n[t]=e.children})):(Ba(c,(e,o)=>{t[o]={attributes:e.attributes,attributesOrder:e.attributesOrder},n[o]=e.children}),Ba(Ea("strong/b em/i"),e=>{const n=Ea(e,"/");t[n[1]].outputName=n[0]}),Ba(R,(n,o)=>{t[o]&&(e.padd_empty_block_inline_children&&(t[o].paddInEmptyBlock=!0),t[o].removeEmpty=!0)}),Ba(Ea("ol ul blockquote a table tbody"),e=>{t[e]&&(t[e].removeEmpty=!0)}),Ba(Ea("p h1 h2 h3 h4 h5 h6 th td pre div address caption li summary"),e=>{t[e]&&(t[e].paddEmpty=!0)}),Ba(Ea("span"),e=>{t[e].removeEmptyAttrs=!0})),delete t.svg,P(e.custom_elements),L(e.valid_children),T(e.extended_valid_elements),L("+ol[ul|ol],+ul[ul|ol]"),Ba({dd:"dl",dt:"dl",li:"ul ol",td:"tr",th:"tr",tr:"tbody thead tfoot",tbody:"table",thead:"table",tfoot:"table",legend:"fieldset",area:"map",param:"video audio object"},(e,n)=>{t[n]&&(t[n].parentsRequired=Ea(e))}),e.invalid_elements&&Ba(La(e.invalid_elements),e=>{t[e]&&delete t[e]}),M("span")||T("span[!data-mce-type|*]"),{type:l,children:n,elements:t,getValidStyles:F,getValidClasses:z,getBlockElements:$,getInvalidStyles:U,getVoidElements:K,getTextBlockElements:H,getTextInlineElements:W,getBoolAttrs:j,getElementRule:M,getSelfClosingElements:Y,getNonEmptyElements:G,getMoveCaretBeforeOnEnterElements:X,getWhitespaceElements:Q,getTransparentElements:Z,getSpecialElements:ee,getComponentUrls:ie,isValidChild:(e,t)=>{const o=n[e.toLowerCase()];return!(!o||!o[t.toLowerCase()])},isValid:te,isBlock:oe,isInline:re,isWrapper:e=>_e(J(),e)||re(e),getCustomElements:se,addValidElements:T,setValidElements:O,addCustomElements:P,addValidChildren:L}},za=e=>{const t=e.toString(16);return(1===t.length?"0"+t:t).toUpperCase()},ja=e=>(e=>{return{value:(t=e,Ge(t,"#").toUpperCase())};var t})(za(e.red)+za(e.green)+za(e.blue)),$a=/^\s*rgb\s*\(\s*(\d+)\s*[,\s]\s*(\d+)\s*[,\s]\s*(\d+)\s*\)\s*$/i,Ha=/^\s*rgba\s*\(\s*(\d+)\s*[,\s]\s*(\d+)\s*[,\s]\s*(\d+)\s*[,\s]\s*((?:\d?\.\d+|\d+)%?)\s*\)\s*$/i,Va=(e,t,n,o)=>((e,t,n,o)=>({red:e,green:t,blue:n,alpha:o}))(parseInt(e,10),parseInt(t,10),parseInt(n,10),parseFloat(o)),qa=e=>$a.test(e)?"rgb":Ha.test(e)?"rgba":"other",Wa=e=>{const t=$a.exec(e);if(null!==t)return I.some(Va(t[1],t[2],t[3],"1"));const n=Ha.exec(e);return null!==n?I.some(Va(n[1],n[2],n[3],n[4])):I.none()},Ka=e=>`rgba(${e.red},${e.green},${e.blue},${e.alpha})`,Ya=e=>Wa(e).map(ja).map(e=>"#"+e.value).getOr(e),Ga=(e={},t)=>{const n=/(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi,o=/\s*([^:]+):\s*([^;]+);?/g,r=/\s+$/,s={};let a,i;const l=ct;t&&(a=t.getValidStyles(),i=t.getInvalidStyles());const c="\\\" \\' \\; \\: ; : \ufeff".split(" ");for(let e=0;e<c.length;e++)s[c[e]]=l+e,s[l+e]=c[e];const d={parse:t=>{const a={};let i=!1;const c=e.url_converter,m=e.url_converter_scope||d,u=(e,t,n)=>{const o=a[e+"-top"+t];if(!o)return;const r=a[e+"-right"+t];if(!r)return;const s=a[e+"-bottom"+t];if(!s)return;const i=a[e+"-left"+t];if(!i)return;const l=[o,r,s,i];let c=l.length-1;for(;c--&&l[c]===l[c+1];);c>-1&&n||(a[e+t]=-1===c?l[0]:l.join(" "),delete a[e+"-top"+t],delete a[e+"-right"+t],delete a[e+"-bottom"+t],delete a[e+"-left"+t])},f=e=>{const t=a[e];if(!t)return;const n=t.indexOf(",")>-1?[t]:t.split(" ");let o=n.length;for(;o--;)if(n[o]!==n[0])return!1;return a[e]=n[0],!0},g=e=>(i=!0,s[e]),p=(e,t)=>(i&&(e=e.replace(/\uFEFF[0-9]/g,e=>s[e])),t||(e=e.replace(/\\([\'\";:])/g,"$1")),e),h=e=>String.fromCharCode(parseInt(e.slice(1),16)),b=e=>e.replace(/\\[0-9a-f]+/gi,h),y=(t,n,o,r,s,a)=>{if(s=s||a)return"'"+(s=p(s)).replace(/\'/g,"\\'")+"'";if(n=p(n||o||r||""),!e.allow_script_urls){const t=n.replace(/[\s\r\n]+/g,"");if(/(java|vb)script:/i.test(t))return"";if(!e.allow_svg_data_urls&&/^data:image\/svg/i.test(t))return""}return c&&(n=c.call(m,n,"style")),"url('"+n.replace(/\'/g,"\\'")+"')"};if(t){let s;for(t=(t=t.replace(/[\u0000-\u001F]/g,"")).replace(/\\[\"\';:\uFEFF]/g,g).replace(/\"[^\"]+\"|\'[^\']+\'/g,e=>e.replace(/[;:]/g,g));s=o.exec(t);){o.lastIndex=s.index+s[0].length;let t=s[1].replace(r,""),c=s[2].replace(r,"");if(t&&c){if(t=b(t),c=b(c),t.startsWith("--")||(t=t.toLowerCase()),-1!==t.indexOf(l)||-1!==t.indexOf('"'))continue;if(!e.allow_script_urls&&("behavior"===t||/expression\s*\(|\/\*|\*\//.test(c)))continue;"font-weight"===t&&"700"===c&&(c="bold"),"rgb"===qa(c)&&Wa(c).each(e=>{c=Ya(Ka(e)).toLowerCase()}),c=c.replace(n,y),a[t]=i?p(c,!0):c}}u("border","",!0),u("border","-width"),u("border","-color"),u("border","-style"),u("padding",""),u("margin",""),/(#.* rgb(a?)\(.*)|(rgb(a?)\(.*\) )/.test(a["border-color"])||(C="border-style",w="border-color",f(v="border-width")&&f(C)&&f(w)&&(a.border=a[v]+" "+a[C]+" "+a[w],delete a[v],delete a[C],delete a[w])),"medium none"===a.border&&delete a.border,"none"===a["border-image"]&&delete a["border-image"]}var v,C,w;return a},serialize:(e,t)=>{let n="";const o=(t,o)=>{const r=o[t];if(r)for(let t=0,o=r.length;t<o;t++){const o=r[t],s=e[o];s&&(n+=(n.length>0?" ":"")+o+": "+s+";")}};return t&&a?(o("*",a),o(t,a)):he(e,(e,o)=>{e&&((e,t)=>{if(!i||!t)return!0;let n=i["*"];return!(n&&n[e]||(n=i[t],n&&n[e]))})(o,t)&&(n+=(n.length>0?" ":"")+o+": "+e+";")}),n}};return d},Xa={keyLocation:!0,layerX:!0,layerY:!0,returnValue:!0,webkitMovementX:!0,webkitMovementY:!0,keyIdentifier:!0,mozPressure:!0,mozInputSource:!0},Qa=(e,t)=>{const n=t??{};for(const t in e)_e(Xa,t)||(n[t]=e[t]);return C(e.composedPath)&&(n.composedPath=()=>e.composedPath()),C(e.getModifierState)&&(n.getModifierState=t=>e.getModifierState(t)),C(e.getTargetRanges)&&(n.getTargetRanges=()=>e.getTargetRanges()),n},Za=(e,t,n,o)=>{const r=Qa(t,o);return r.type=e,v(r.target)&&(r.target=r.srcElement??n),(e=>v(e.preventDefault)||(e=>e instanceof Event||w(e.initEvent))(e))(t)&&(r.preventDefault=()=>{r.defaultPrevented=!0,r.isDefaultPrevented=M,w(t.preventDefault)&&t.preventDefault()},r.stopPropagation=()=>{r.cancelBubble=!0,r.isPropagationStopped=M,w(t.stopPropagation)&&t.stopPropagation()},r.stopImmediatePropagation=()=>{r.isImmediatePropagationStopped=M,r.stopPropagation()},(e=>e.isDefaultPrevented===M||e.isDefaultPrevented===L)(r)||(r.isDefaultPrevented=!0===r.defaultPrevented?M:L,r.isPropagationStopped=!0===r.cancelBubble?M:L,r.isImmediatePropagationStopped=L)),r},Ja=/^(?:mouse|contextmenu)|click/,ei=(e,t,n,o)=>{e.addEventListener(t,n,o||!1)},ti=(e,t,n,o)=>{e.removeEventListener(t,n,o||!1)},ni=(e,t)=>{const n=Za(e.type,e,document,t);if((e=>C(e)&&Ja.test(e.type))(e)&&y(e.pageX)&&!y(e.clientX)){const t=n.target.ownerDocument||document,o=t.documentElement,r=t.body,s=n;s.pageX=e.clientX+(o&&o.scrollLeft||r&&r.scrollLeft||0)-(o&&o.clientLeft||r&&r.clientLeft||0),s.pageY=e.clientY+(o&&o.scrollTop||r&&r.scrollTop||0)-(o&&o.clientTop||r&&r.clientTop||0)}return n},oi=(e,t,n)=>{const o=e.document,r={type:"ready"};if(n.domLoaded)return void t(r);const s=()=>{ti(e,"DOMContentLoaded",s),ti(e,"load",s),n.domLoaded||(n.domLoaded=!0,t(r)),e=null};"complete"===o.readyState||"interactive"===o.readyState&&o.body?s():ei(e,"DOMContentLoaded",s),n.domLoaded||ei(e,"load",s)};class ri{static Event=new ri;domLoaded=!1;events={};expando;hasFocusIn;count=1;constructor(){this.expando="mce-data-"+(+new Date).toString(32),this.hasFocusIn="onfocusin"in document.documentElement,this.count=1}bind(e,t,n,o){const r=this;let s;const a=window,i=e=>{r.executeHandlers(ni(e||a.event),l)};if(!e||ss(e)||ls(e))return n;let l;e[r.expando]?l=e[r.expando]:(l=r.count++,e[r.expando]=l,r.events[l]={}),o=o||e;const c=t.split(" ");let d=c.length;for(;d--;){let t=c[d],m=i,u=!1,f=!1;"DOMContentLoaded"===t&&(t="ready"),r.domLoaded&&"ready"===t&&"complete"===e.readyState?n.call(o,ni({type:t})):(r.hasFocusIn||"focusin"!==t&&"focusout"!==t||(u=!0,f="focusin"===t?"focus":"blur",m=e=>{const t=ni(e||a.event);t.type="focus"===t.type?"focusin":"focusout",r.executeHandlers(t,l)}),s=r.events[l][t],s?"ready"===t&&r.domLoaded?n(ni({type:t})):s.push({func:n,scope:o}):(r.events[l][t]=s=[{func:n,scope:o}],s.fakeName=f,s.capture=u,s.nativeHandler=m,"ready"===t?oi(e,m,r):ei(e,f||t,m,u)))}return e=s=null,n}unbind(e,t,n){if(!e||ss(e)||ls(e))return this;const o=e[this.expando];if(o){let r=this.events[o];if(t){const o=t.split(" ");let s=o.length;for(;s--;){const t=o[s],a=r[t];if(a){if(n){let e=a.length;for(;e--;)if(a[e].func===n){const n=a.nativeHandler,o=a.fakeName,s=a.capture,i=a.slice(0,e).concat(a.slice(e+1));i.nativeHandler=n,i.fakeName=o,i.capture=s,r[t]=i}}n&&0!==a.length||(delete r[t],ti(e,a.fakeName||t,a.nativeHandler,a.capture))}}}else he(r,(t,n)=>{ti(e,t.fakeName||n,t.nativeHandler,t.capture)}),r={};for(const e in r)if(_e(r,e))return this;delete this.events[o];try{delete e[this.expando]}catch{e[this.expando]=null}}return this}fire(e,t,n){return this.dispatch(e,t,n)}dispatch(e,t,n){if(!e||ss(e)||ls(e))return this;const o=ni({type:t,target:e},n);do{const t=e[this.expando];t&&this.executeHandlers(o,t),e=e.parentNode||e.ownerDocument||e.defaultView||e.parentWindow}while(e&&!o.isPropagationStopped());return this}clean(e){if(!e||ss(e)||ls(e))return this;if(e[this.expando]&&this.unbind(e),e.getElementsByTagName||(e=e.document),e&&e.getElementsByTagName){this.unbind(e);const t=e.getElementsByTagName("*");let n=t.length;for(;n--;)(e=t[n])[this.expando]&&this.unbind(e)}return this}destroy(){this.events={}}cancel(e){return e&&(e.preventDefault(),e.stopImmediatePropagation()),!1}executeHandlers(e,t){const n=this.events[t],o=n&&n[e.type];if(o)for(let t=0,n=o.length;t<n;t++){const n=o[t];if(n&&!1===n.func.call(n.scope,e)&&e.preventDefault(),e.isImmediatePropagationStopped())return}}}const si=dn.each,ai=dn.grep,ii="data-mce-style",li=dn.makeMap("fill-opacity font-weight line-height opacity orphans widows z-index zoom"," "),ci=(e,t,n)=>{v(n)||""===n?xo(e,t):vo(e,t,n)},di=e=>e.replace(/[A-Z]/g,e=>"-"+e.toLowerCase()),mi=(e,t)=>{let n=0;if(e)for(let o=e.nodeType,r=e.previousSibling;r;r=r.previousSibling){const e=r.nodeType;(!t||!ss(r)||e!==o&&r.data.length)&&(n++,o=e)}return n},ui=(e,t)=>{const n=wo(t,"style"),o=e.serialize(e.parse(n),En(t));ci(t,ii,o)},fi=(e,t,n)=>{const o=di(t);v(n)||""===n?Wo(e,o):zo(e,o,((e,t)=>S(e)?_e(li,t)?e+"":e+"px":e)(n,o))},gi=(e,t={})=>{const n={},o=window,r={};let s=0;const a=sa.forElement(un.fromDom(e),{contentCssCors:t.contentCssCors,referrerPolicy:t.referrerPolicy,crossOrigin:e=>{const n=t.crossOrigin;return w(n)?n(e,"stylesheet"):void 0}}),i=[],l=t.schema?t.schema:Ua({}),c=Ga({url_converter:t.url_converter,url_converter_scope:t.url_converter_scope},t.schema),d=t.ownEvents?new ri:ri.Event,m=l.getBlockElements(),f=t=>t&&e&&u(t)?e.getElementById(t):t,h=e=>{const t=f(e);return C(t)?un.fromDom(t):null},b=(e,t,n="")=>{let o;const r=h(e);if(C(r)&&Rn(r)){const e=G[t];o=e&&e.get?e.get(r.dom,t):wo(r,t)}return C(o)?o:n},y=e=>{const t=f(e);return v(t)?[]:t.attributes},S=(e,n,o)=>{O(e,e=>{if(Xr(e)){const r=un.fromDom(e),s=""===o?null:o,a=wo(r,n),i=G[n];i&&i.set?i.set(r.dom,s,n):ci(r,n,s),a!==s&&t.onSetAttrib&&t.onSetAttrib({attrElm:r.dom,attrName:n,attrValue:s})}})},E=()=>t.root_element||e.body,_=(t,n)=>((e,t,n)=>{let o=0,r=0;const s=e.ownerDocument;if(n=n||e,t){if(n===e&&t.getBoundingClientRect&&"static"===$o(un.fromDom(e),"position")){const n=t.getBoundingClientRect();return o=n.left+(s.documentElement.scrollLeft||e.scrollLeft)-s.documentElement.clientLeft,r=n.top+(s.documentElement.scrollTop||e.scrollTop)-s.documentElement.clientTop,{x:o,y:r}}let a=t;for(;a&&a!==n&&a.nodeType&&!oa(a,n);){const e=a;o+=e.offsetLeft||0,r+=e.offsetTop||0,a=e.offsetParent}for(a=t.parentNode;a&&a!==n&&a.nodeType&&!oa(a,n);)o-=a.scrollLeft||0,r-=a.scrollTop||0,a=a.parentNode;r+=(e=>ta.isFirefox()&&"table"===En(e)?na(Vn(e)).filter(e=>"caption"===En(e)).bind(e=>na(Hn(e)).map(t=>{const n=t.dom.offsetTop,o=e.dom.offsetTop,r=e.dom.offsetHeight;return n<=o?-r:0})).getOr(0):0)(un.fromDom(t))}return{x:o,y:r}})(e.body,f(t),n),k=(e,t,n)=>{const o=f(e);var r;if(!v(o)&&(Qr(o)||Xr(r=o)&&"http://www.w3.org/2000/svg"===r.namespaceURI))return n?$o(un.fromDom(o),di(t)):("float"===(t=t.replace(/-(\D)/g,(e,t)=>t.toUpperCase()))&&(t="cssFloat"),o.style?o.style[t]:void 0)},R=e=>{const t=f(e);if(!t)return{w:0,h:0};let n=k(t,"width"),o=k(t,"height");return n&&-1!==n.indexOf("px")||(n="0"),o&&-1!==o.indexOf("px")||(o="0"),{w:parseInt(n,10)||t.offsetWidth||t.clientWidth,h:parseInt(o,10)||t.offsetHeight||t.clientHeight}},A=(e,t)=>{if(!e)return!1;const n=p(e)?e:[e];return H(n,e=>bn(un.fromDom(e),t))},D=(e,t,n,o)=>{const r=[];let s=f(e);o=void 0===o;const a=n||("BODY"!==E().nodeName?E().parentNode:null);if(u(t))if("*"===t)t=Xr;else{const e=t;t=t=>A(t,e)}for(;s&&!(s===a||v(s.nodeType)||cs(s)||ds(s));){if(!t||t(s)){if(!o)return[s];r.push(s)}s=s.parentNode}return o?r:null},T=(e,t,n)=>{let o=t;if(e){u(t)&&(o=e=>A(e,t));for(let t=e[n];t;t=t[n])if(w(o)&&o(t))return t}return null},O=function(e,t,n){const o=n??this;if(p(e)){const n=[];return si(e,(e,r)=>{const s=f(e);s&&n.push(t.call(o,s,r))}),n}{const n=f(e);return!!n&&t.call(o,n)}},B=(e,t)=>{O(e,e=>{he(t,(t,n)=>{S(e,n,t)})})},P=(e,t)=>{O(e,e=>{const n=un.fromDom(e);Mo(n,t)})},L=(t,n,o,r,s)=>O(t,t=>{const a=u(n)?e.createElement(n):n;return C(o)&&B(a,o),r&&(!u(r)&&r.nodeType?a.appendChild(r):u(r)&&P(a,r)),s?a:t.appendChild(a)}),M=(t,n,o)=>L(e.createElement(t),t,n,o,!0),I=Sa.encodeAllRaw,F=(e,t)=>O(e,e=>{const n=un.fromDom(e);return t&&q(Vn(n),e=>{An(e)&&0===e.dom.length?Ro(e):mo(n,e)}),Ro(n),n.dom}),U=(e,t,n)=>{O(e,e=>{if(Xr(e)){const o=un.fromDom(e),r=t.split(" ");q(r,e=>{C(n)?(n?yr:Cr)(o,e):((e,t)=>{const n=gr(e)?e.dom.classList.toggle(t):((e,t)=>$(pr(e),t)?br(e,t):hr(e,t))(e,t);vr(e)})(o,e)})}})},z=(e,t,n)=>O(t,o=>{const r=p(t)?e.cloneNode(!0):e;return n&&si(ai(o.childNodes),e=>{r.appendChild(e)}),o.parentNode?.replaceChild(r,o),o}),j=()=>e.createRange(),V=(n,r,s,a)=>{if(p(n)){let e=n.length;const t=[];for(;e--;)t[e]=V(n[e],r,s,a);return t}return!t.collect||n!==e&&n!==o||i.push([n,r,s,a]),d.bind(n,r,s,a||Y)},W=(t,n,r)=>{if(p(t)){let e=t.length;const o=[];for(;e--;)o[e]=W(t[e],n,r);return o}if(i.length>0&&(t===e||t===o)){let e=i.length;for(;e--;){const[o,s,a]=i[e];t!==o||n&&n!==s||r&&r!==a||d.unbind(o,s,a)}}return d.unbind(t,n,r)},K=e=>{if(e&&Qr(e)){const t=e.getAttribute("data-mce-contenteditable");return t&&"inherit"!==t?t:"inherit"!==e.contentEditable?e.contentEditable:null}return null},Y={doc:e,settings:t,win:o,files:r,stdMode:!0,boxModel:!0,styleSheetLoader:a,boundEvents:i,styles:c,schema:l,events:d,isBlock:e=>u(e)?_e(m,e):Xr(e)&&(_e(m,e.nodeName)||Zs(l,e)),root:null,clone:(e,t)=>e.cloneNode(t),getRoot:E,getViewPort:e=>{const t=Wr(e);return{x:t.x,y:t.y,w:t.width,h:t.height}},getRect:e=>{const t=f(e),n=_(t),o=R(t);return{x:n.x,y:n.y,w:o.w,h:o.h}},getSize:R,getParent:(e,t,n)=>{const o=D(e,t,n,!1);return o&&o.length>0?o[0]:null},getParents:D,get:f,getNext:(e,t)=>T(e,t,"nextSibling"),getPrev:(e,t)=>T(e,t,"previousSibling"),select:(n,o)=>{const r=f(o)??t.root_element??e;return w(r.querySelectorAll)?me(r.querySelectorAll(n)):[]},is:A,add:L,create:M,createHTML:(e,t,n="")=>{let o="<"+e;for(const e in t)ke(t,e)&&(o+=" "+e+'="'+I(t[e])+'"');return rt(n)&&_e(l.getVoidElements(),e)?o+" />":o+">"+n+"</"+e+">"},createFragment:t=>{const n=e.createElement("div"),o=e.createDocumentFragment();let r;for(o.appendChild(n),t&&(n.innerHTML=t);r=n.firstChild;)o.appendChild(r);return o.removeChild(n),o},remove:F,setStyle:(e,n,o)=>{O(e,e=>{const r=un.fromDom(e);fi(r,n,o),t.update_styles&&ui(c,r)})},getStyle:k,setStyles:(e,n)=>{O(e,e=>{const o=un.fromDom(e);he(n,(e,t)=>{fi(o,t,e)}),t.update_styles&&ui(c,o)})},removeAllAttribs:e=>O(e,e=>{const t=e.attributes;for(let n=t.length-1;n>=0;n--)e.removeAttributeNode(t.item(n))}),setAttrib:S,setAttribs:B,getAttrib:b,getPos:_,parseStyle:e=>c.parse(e),serializeStyle:(e,t)=>c.serialize(e,t),addStyle:t=>{if(Y!==gi.DOM&&e===document){if(n[t])return;n[t]=!0}let o=e.getElementById("mceDefaultStyles");if(!o){o=e.createElement("style"),o.id="mceDefaultStyles",o.type="text/css";const t=e.head;t.firstChild?t.insertBefore(o,t.firstChild):t.appendChild(o)}o.styleSheet?o.styleSheet.cssText+=t:o.appendChild(e.createTextNode(t))},loadCSS:e=>{e||(e=""),q(e.split(","),e=>{r[e]=!0,a.load(e).catch(x)})},addClass:(e,t)=>{U(e,t,!0)},removeClass:(e,t)=>{U(e,t,!1)},hasClass:(e,t)=>{const n=h(e),o=t.split(" ");return C(n)&&oe(o,e=>wr(n,e))},toggleClass:U,show:e=>{O(e,e=>Wo(un.fromDom(e),"display"))},hide:e=>{O(e,e=>zo(un.fromDom(e),"display","none"))},isHidden:e=>{const t=h(e);return C(t)&&ze(Vo(t,"display"),"none")},uniqueId:e=>(e||"mce_")+s++,setHTML:P,getOuterHTML:e=>{const t=h(e);return C(t)?Xr(t.dom)?t.dom.outerHTML:(e=>{const t=un.fromTag("div"),n=un.fromDom(e.dom.cloneNode(!0));return go(t,n),Lo(t)})(t):""},setOuterHTML:(e,t)=>{O(e,e=>{Xr(e)&&(e.outerHTML=t)})},decode:Sa.decode,encode:I,insertAfter:(e,t)=>{const n=f(t);return O(e,e=>{const t=n?.parentNode,o=n?.nextSibling;return t&&(o?t.insertBefore(e,o):t.appendChild(e)),e})},replace:z,rename:(e,t)=>{if(e.nodeName!==t.toUpperCase()){const n=M(t);return si(y(e),t=>{S(n,t.nodeName,b(e,t.nodeName))}),z(n,e,!0),n}return e},findCommonAncestor:(e,t)=>{let n=e;for(;n;){let e=t;for(;e&&n!==e;)e=e.parentNode;if(n===e)break;n=n.parentNode}return!n&&e.ownerDocument?e.ownerDocument.documentElement:n},run:O,getAttribs:y,isEmpty:(e,t,n)=>{if(g(t)){const o=e=>{const n=e.nodeName.toLowerCase();return Boolean(t[n])};return Ps(l,e,{...n,isContent:o})}return Ps(l,e,n)},createRng:j,nodeIndex:mi,split:(e,t,n)=>{let o,r,s=j();if(e&&t&&e.parentNode&&t.parentNode){const a=e.parentNode;return s.setStart(a,mi(e)),s.setEnd(t.parentNode,mi(t)),o=s.extractContents(),s=j(),s.setStart(t.parentNode,mi(t)+1),s.setEnd(a,mi(e)+1),r=s.extractContents(),a.insertBefore(la(Y,o,l),e),n?a.insertBefore(n,e):a.insertBefore(t,e),a.insertBefore(la(Y,r,l),e),F(e),n||t}},bind:V,unbind:W,fire:(e,t,n)=>d.dispatch(e,t,n),dispatch:(e,t,n)=>d.dispatch(e,t,n),getContentEditable:K,getContentEditableParent:e=>{const t=E();let n=null;for(let o=e;o&&o!==t&&(n=K(o),null===n);o=o.parentNode);return n},isEditable:e=>{if(C(e)){const t=Xr(e)?e:e.parentElement;return C(t)&&Qr(t)&&Sr(un.fromDom(t))}return!1},destroy:()=>{if(i.length>0){let e=i.length;for(;e--;){const[t,n,o]=i[e];d.unbind(t,n,o)}}he(r,(e,t)=>{a.unload(t),delete r[t]})},isChildOf:(e,t)=>e===t||t.contains(e),dumpRng:e=>"startContainer: "+e.startContainer.nodeName+", startOffset: "+e.startOffset+", endContainer: "+e.endContainer.nodeName+", endOffset: "+e.endOffset},G=((e,t,n)=>{const o=t.keep_values,r={set:(e,o,r)=>{const s=un.fromDom(e);w(t.url_converter)&&C(o)&&(o=t.url_converter.call(t.url_converter_scope||n(),String(o),r,e)),ci(s,"data-mce-"+r,o),ci(s,r,o)},get:(e,t)=>{const n=un.fromDom(e);return wo(n,"data-mce-"+t)||wo(n,t)}},s={style:{set:(t,n)=>{const r=un.fromDom(t);o&&ci(r,ii,n),xo(r,"style"),u(n)&&jo(r,e.parse(n))},get:t=>{const n=un.fromDom(t),o=wo(n,ii)||wo(n,"style");return e.serialize(e.parse(o),En(n))}}};return o&&(s.href=s.src=r),s})(c,t,N(Y));return Y};gi.DOM=gi(document),gi.nodeIndex=mi;const pi=gi.DOM;class hi{static ScriptLoader=new hi;settings;states={};queue=[];scriptLoadedCallbacks={};queueLoadedCallbacks=[];loading=!1;constructor(e={}){this.settings=e}_setReferrerPolicy(e){this.settings.referrerPolicy=e}_setCrossOrigin(e){this.settings.crossOrigin=e}loadScript(e){return new Promise((t,n)=>{const o=pi,r=document;let s;const a=()=>{o.remove(i),s&&(s.onerror=s.onload=s=null)},i=o.uniqueId();s=r.createElement("script"),s.id=i,s.type="text/javascript",s.src=dn._addCacheSuffix(e),this.settings.referrerPolicy&&o.setAttrib(s,"referrerpolicy",this.settings.referrerPolicy);const l=this.settings.crossOrigin;if(w(l)){const t=l(e);void 0!==t&&o.setAttrib(s,"crossorigin",t)}s.onload=()=>{a(),t()},s.onerror=()=>{a(),n("Failed to load script: "+e)},(r.head||r.body).appendChild(s)})}isDone(e){return 2===this.states[e]}markDone(e){this.states[e]=2}add(e){const t=this;return t.queue.push(e),void 0===t.states[e]&&(t.states[e]=0),new Promise((n,o)=>{t.scriptLoadedCallbacks[e]||(t.scriptLoadedCallbacks[e]=[]),t.scriptLoadedCallbacks[e].push({resolve:n,reject:o})})}load(e){return this.add(e)}remove(e){delete this.states[e],delete this.scriptLoadedCallbacks[e]}loadQueue(){const e=this.queue;return this.queue=[],this.loadScripts(e)}loadScripts(e){const t=this,n=(e,n)=>{xe(t.scriptLoadedCallbacks,n).each(t=>{q(t,t=>t[e](n))}),delete t.scriptLoadedCallbacks[n]},o=e=>{const t=Y(e,e=>"rejected"===e.status);return t.length>0?Promise.reject(ne(t,({reason:e})=>p(e)?e:[e])):Promise.resolve()},r=e=>Promise.allSettled(V(e,e=>2===t.states[e]?(n("resolve",e),Promise.resolve()):3===t.states[e]?(n("reject",e),Promise.reject(e)):(t.states[e]=1,t.loadScript(e).then(()=>{t.states[e]=2,n("resolve",e);const s=t.queue;return s.length>0?(t.queue=[],r(s).then(o)):Promise.resolve()},()=>(t.states[e]=3,n("reject",e),Promise.reject(e)))))),s=e=>(t.loading=!0,r(e).then(e=>{t.loading=!1;const n=t.queueLoadedCallbacks.shift();return I.from(n).each(P),o(e)})),a=ut(e);return t.loading?new Promise((e,n)=>{t.queueLoadedCallbacks.push(()=>{s(a).then(e,n)})}):s(a)}getScriptAttributes(e){const t={};this.settings.referrerPolicy&&(t.referrerpolicy=this.settings.referrerPolicy);const n=this.settings.crossOrigin;if(w(n)){const o=n(e);u(o)&&(t.crossorigin=o)}return t}}const bi={},yi=Re("en"),vi=()=>xe(bi,yi.get()),Ci={getData:()=>be(bi,e=>({...e})),setCode:e=>{e&&yi.set(e)},getCode:()=>yi.get(),add:(e,t)=>{let n=bi[e];n||(bi[e]=n={});const o=V(ge(t),e=>e.toLowerCase());he(t,(e,r)=>{const s=r.toLowerCase();s!==r&&((e,t)=>{const n=e.indexOf(t);return-1!==n&&e.indexOf(t,n+1)>n})(o,s)?(_e(t,s)||(n[s]=e),n[r]=e):n[s]=e})},translate:e=>{const t=vi().getOr({}),n=e=>w(e)?Object.prototype.toString.call(e):o(e)?"":""+e,o=e=>""===e||null==e,r=e=>{const o=n(e);return _e(t,o)?n(t[o]):xe(t,o.toLowerCase()).map(n).getOr(o)},s=e=>e.replace(/{context:\w+}$/,""),a=e=>e.replaceAll("...","\u2026");if(o(e))return"";if(f(i=e)&&_e(i,"raw"))return a(n(e.raw));var i;if((e=>p(e)&&e.length>1)(e)){const t=e.slice(1);return a(s(r(e[0]).replace(/\{([0-9]+)\}/g,(e,o)=>_e(t,o)?n(t[o]):e)))}return a(s(r(e)))},isRtl:()=>vi().bind(e=>xe(e,"_dir")).exists(e=>"rtl"===e),hasCode:e=>_e(bi,e)},wi=()=>{const e=[],t={},n={},o=[],r=(e,t)=>{const n=Y(o,n=>n.name===e&&n.state===t);q(n,e=>e.resolve())},s=e=>_e(t,e),a=(e,n)=>{const o=Ci.getCode();!o||n&&-1===(","+(n||"")+",").indexOf(","+o+",")||hi.ScriptLoader.add(t[e]+"/langs/"+o+".js")},i=(e,t="added")=>"added"===t&&(e=>_e(n,e))(e)||"loaded"===t&&s(e)?Promise.resolve():new Promise(n=>{o.push({name:e,state:t,resolve:n})});return{items:e,urls:t,lookup:n,get:e=>{if(n[e])return n[e].instance},requireLangPack:(e,t)=>{!1!==wi.languageLoad&&(s(e)?a(e,t):i(e,"loaded").then(()=>a(e,t)))},add:(t,o)=>(e.push(o),n[t]={instance:o},r(t,"added"),o),remove:e=>{delete t[e],delete n[e]},createUrl:(e,t)=>u(t)?u(e)?{prefix:"",resource:t,suffix:""}:{prefix:e.prefix,resource:t,suffix:e.suffix}:t,load:(e,o)=>{if(t[e])return Promise.resolve();let s=u(o)?o:o.prefix+o.resource+o.suffix;0!==s.indexOf("/")&&-1===s.indexOf("://")&&(s=wi.baseURL+"/"+s),t[e]=s.substring(0,s.lastIndexOf("/"));const a=()=>(r(e,"loaded"),Promise.resolve());return n[e]?a():hi.ScriptLoader.add(s).then(a)},waitFor:i}};wi.languageLoad=!0,wi.baseURL="",wi.PluginManager=wi(),wi.ThemeManager=wi(),wi.ModelManager=wi();const Si=N("mce-annotation"),Ei=N("data-mce-annotation"),xi=N("data-mce-annotation-uid"),_i=N("data-mce-annotation-active"),ki=N("data-mce-annotation-classes"),Ni=N("data-mce-annotation-attrs"),Ri=e=>t=>vn(t,e),Ai=(e,t)=>{const n=e.selection.getRng(),o=un.fromDom(n.startContainer),r=un.fromDom(e.getBody()),s=t.fold(()=>"."+Si(),e=>`[${Ei()}="${e}"]`),a=qn(o,n.startOffset).getOr(o);return fr(a,s,Ri(r)).bind(t=>So(t,`${xi()}`).bind(n=>So(t,`${Ei()}`).map(t=>{const o=Ti(e,n);return{uid:n,name:t,elements:o}})))},Di=(e,t)=>Eo(e,"data-mce-bogus")||((e,t,n)=>mr(e,'[data-mce-bogus="all"]',n).isSome())(e,0,Ri(t)),Ti=(e,t)=>{const n=un.fromDom(e.getBody()),o=Rr(n,`[${xi()}="${t}"]`);return Y(o,e=>!Di(e,n))},Oi=(e,t)=>{const n=un.fromDom(e.getBody()),o=Rr(n,`[${Ei()}="${t}"]`),r={};return q(o,e=>{if(!Di(e,n)){const t=wo(e,xi()),n=xe(r,t).getOr([]);r[t]=n.concat([e])}}),r},Bi=(e,t,n=L)=>{const o=new Kr(e,t),r=e=>{let t;do{t=o[e]()}while(t&&!ss(t)&&!n(t));return I.from(t).filter(ss)};return{current:()=>I.from(o.current()).filter(ss),next:()=>r("next"),prev:()=>r("prev"),prev2:()=>r("prev2")}},Pi=(e,t)=>{const n=t||(t=>e.isBlock(t)||ms(t)||ps(t)),o=(e,t,n,r)=>{if(ss(e)){const n=r(e,t,e.data);if(-1!==n)return I.some({container:e,offset:n})}return n().bind(e=>o(e.container,e.offset,n,r))};return{backwards:(t,r,s,a)=>{const i=Bi(t,a??e.getRoot(),n);return o(t,r,()=>i.prev().map(e=>({container:e,offset:e.length})),s).getOrNull()},forwards:(t,r,s,a)=>{const i=Bi(t,a??e.getRoot(),n);return o(t,r,()=>i.next().map(e=>({container:e,offset:0})),s).getOrNull()}}},Li=e=>{let t;return n=>(t=t||ae(e,M),_e(t,En(n)))},Mi=e=>Rn(e)&&"br"===En(e),Ii=e=>Rn(e)&&"script"===En(e),Fi=e=>Rn(e)&&"style"===En(e),Ui=Li(["h1","h2","h3","h4","h5","h6","p","div","address","pre","form","blockquote","center","dir","fieldset","header","footer","article","section","hgroup","aside","nav","figure"]),zi=Li(["ul","ol","dl"]),ji=Li(["li","dd","dt"]),$i=Li(["thead","tbody","tfoot"]),Hi=Li(["td","th"]),Vi=Li(["pre","script","textarea","style"]),qi=()=>{const e=un.fromTag("br");return vo(e,"data-mce-bogus","1"),e},Wi=e=>{No(e),go(e,qi())},Ki=ct,Yi=mt,Gi=e=>e.replace(/\uFEFF/g,""),Xi=Xr,Qi=ss,Zi=e=>(Qi(e)&&(e=e.parentNode),Xi(e)&&e.hasAttribute("data-mce-caret")),Ji=e=>Qi(e)&&Yi(e.data),el=e=>Zi(e)||Ji(e),tl=e=>e.firstChild!==e.lastChild||!ms(e.firstChild),nl=e=>{const t=e.container();return!!ss(t)&&(t.data.charAt(e.offset())===Ki||e.isAtStart()&&Ji(t.previousSibling))},ol=e=>{const t=e.container();return!!ss(t)&&(t.data.charAt(e.offset()-1)===Ki||e.isAtEnd()&&Ji(t.nextSibling))},rl=e=>Qi(e)&&e.data[0]===Ki,sl=e=>Qi(e)&&e.data[e.data.length-1]===Ki,al=e=>e&&e.hasAttribute("data-mce-caret")?((e=>{const t=e.getElementsByTagName("br"),n=t[t.length-1];ts(n)&&n.parentNode?.removeChild(n)})(e),e.removeAttribute("data-mce-caret"),e.removeAttribute("data-mce-bogus"),e.removeAttribute("style"),e.removeAttribute("data-mce-style"),e.removeAttribute("_moz_abspos"),e):null,il=e=>Zi(e.startContainer),ll=Math.round,cl=e=>e?{left:ll(e.left),top:ll(e.top),bottom:ll(e.bottom),right:ll(e.right),width:ll(e.width),height:ll(e.height)}:{left:0,top:0,bottom:0,right:0,width:0,height:0},dl=(e,t)=>(e=cl(e),t||(e.left=e.left+e.width),e.right=e.left,e.width=0,e),ml=(e,t,n)=>e>=0&&e<=Math.min(t.height,n.height)/2,ul=(e,t)=>{const n=Math.min(t.height/2,e.height/2);return e.bottom-n<t.top||!(e.top>t.bottom)&&ml(t.top-e.bottom,e,t)},fl=(e,t)=>e.top>t.bottom||!(e.bottom<t.top)&&ml(t.bottom-e.top,e,t),gl=(e,t,n)=>{const o=Math.max(Math.min(t,e.left+e.width),e.left),r=Math.max(Math.min(n,e.top+e.height),e.top);return Math.sqrt((t-o)*(t-o)+(n-r)*(n-r))},pl=e=>{const t=e.startContainer,n=e.startOffset;return t===e.endContainer&&t.hasChildNodes()&&e.endOffset===n+1?t.childNodes[n]:null},hl=(e,t)=>{if(Xr(e)&&e.hasChildNodes()){const n=e.childNodes,o=((e,t,n)=>Math.min(Math.max(e,0),n))(t,0,n.length-1);return n[o]}return e},bl=new RegExp("[\u0300-\u036f\u0483-\u0487\u0488-\u0489\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u0610-\u061a\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7-\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e3-\u0902\u093a\u093c\u0941-\u0948\u094d\u0951-\u0957\u0962-\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2-\u09e3\u0a01-\u0a02\u0a3c\u0a41-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a70-\u0a71\u0a75\u0a81-\u0a82\u0abc\u0ac1-\u0ac5\u0ac7-\u0ac8\u0acd\u0ae2-\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62-\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c00\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56\u0c62-\u0c63\u0c81\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc-\u0ccd\u0cd5-\u0cd6\u0ce2-\u0ce3\u0d01\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62-\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb-\u0ebc\u0ec8-\u0ecd\u0f18-\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039-\u103a\u103d-\u103e\u1058-\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085-\u1086\u108d\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17b4-\u17b5\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193b\u1a17-\u1a18\u1a1b\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1ab0-\u1abd\u1abe\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80-\u1b81\u1ba2-\u1ba5\u1ba8-\u1ba9\u1bab-\u1bad\u1be6\u1be8-\u1be9\u1bed\u1bef-\u1bf1\u1c2c-\u1c33\u1c36-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1cf4\u1cf8-\u1cf9\u1dc0-\u1df5\u1dfc-\u1dff\u200c-\u200d\u20d0-\u20dc\u20dd-\u20e0\u20e1\u20e2-\u20e4\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302d\u302e-\u302f\u3099-\u309a\ua66f\ua670-\ua672\ua674-\ua67d\ua69e-\ua69f\ua6f0-\ua6f1\ua802\ua806\ua80b\ua825-\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\ua9e5\uaa29-\uaa2e\uaa31-\uaa32\uaa35-\uaa36\uaa43\uaa4c\uaa7c\uaab0\uaab2-\uaab4\uaab7-\uaab8\uaabe-\uaabf\uaac1\uaaec-\uaaed\uaaf6\uabe5\uabe8\uabed\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\uff9e-\uff9f]"),yl=e=>u(e)&&e.charCodeAt(0)>=768&&bl.test(e),vl=gs,Cl=ps,wl=ms,Sl=ss,El=Jr(["script","style","textarea"]),xl=Jr(["img","input","textarea","hr","iframe","video","audio","object","embed"]),_l=Jr(["table"]),kl=el,Nl=e=>!kl(e)&&(Sl(e)?!El(e.parentNode):xl(e)||wl(e)||_l(e)||Rl(e)),Rl=e=>!(e=>Xr(e)&&"true"===e.getAttribute("unselectable"))(e)&&Cl(e),Al=(e,t)=>Nl(e)&&((e,t)=>{for(let n=e.parentNode;n&&n!==t;n=n.parentNode){if(Rl(n))return!1;if(vl(n))return!0}return!0})(e,t),Dl=Xr,Tl=Nl,Ol=es("display","block table"),Bl=es("float","left right"),Pl=((...e)=>t=>{for(let n=0;n<e.length;n++)if(!e[n](t))return!1;return!0})(Dl,Tl,T(Bl)),Ll=T(es("white-space","pre pre-line pre-wrap")),Ml=ss,Il=ms,Fl=gi.nodeIndex,Ul=(e,t)=>t<0&&Xr(e)&&e.hasChildNodes()?void 0:hl(e,t),zl=e=>e?e.createRange():gi.DOM.createRng(),jl=e=>u(e)&&/[\r\n\t ]/.test(e),$l=e=>!!e.setStart&&!!e.setEnd,Hl=e=>{const t=e.startContainer,n=e.startOffset;if(jl(e.toString())&&Ll(t.parentNode)&&ss(t)){const e=t.data;if(jl(e[n-1])||jl(e[n+1]))return!0}return!1},Vl=e=>0===e.left&&0===e.right&&0===e.top&&0===e.bottom,ql=e=>{let t;const n=e.getClientRects();return t=n.length>0?cl(n[0]):cl(e.getBoundingClientRect()),!$l(e)&&Il(e)&&Vl(t)?(e=>{const t=e.ownerDocument,n=zl(t),o=t.createTextNode(dt),r=e.parentNode;r.insertBefore(o,e),n.setStart(o,0),n.setEnd(o,1);const s=cl(n.getBoundingClientRect());return r.removeChild(o),s})(e):Vl(t)&&$l(e)?(e=>{const t=e.startContainer,n=e.endContainer,o=e.startOffset,r=e.endOffset;if(t===n&&ss(n)&&0===o&&1===r){const t=e.cloneRange();return t.setEndAfter(n),ql(t)}return null})(e)??t:t},Wl=(e,t)=>{const n=dl(e,t);return n.width=1,n.right=n.left+1,n},Kl=(e,t,n)=>{const o=()=>(n||(n=(e=>{const t=[],n=e=>{var n,o;0!==e.height&&(t.length>0&&(n=e,o=t[t.length-1],n.left===o.left&&n.top===o.top&&n.bottom===o.bottom&&n.right===o.right)||t.push(e))},o=(e,t)=>{const o=zl(e.ownerDocument);if(t<e.data.length){if(yl(e.data[t]))return;if(yl(e.data[t-1])&&(o.setStart(e,t),o.setEnd(e,t+1),!Hl(o)))return void n(Wl(ql(o),!1))}t>0&&(o.setStart(e,t-1),o.setEnd(e,t),Hl(o)||n(Wl(ql(o),!1))),t<e.data.length&&(o.setStart(e,t),o.setEnd(e,t+1),Hl(o)||n(Wl(ql(o),!0)))},r=e.container(),s=e.offset();if(Ml(r))return o(r,s),t;if(Dl(r))if(e.isAtEnd()){const e=Ul(r,s);Ml(e)&&o(e,e.data.length),Pl(e)&&!Il(e)&&n(Wl(ql(e),!1))}else{const a=Ul(r,s);if(Ml(a)&&o(a,0),Pl(a)&&e.isAtEnd())return n(Wl(ql(a),!1)),t;const i=Ul(e.container(),e.offset()-1);Pl(i)&&!Il(i)&&(Ol(i)||Ol(a)||!Pl(a))&&n(Wl(ql(i),!1)),Pl(a)&&n(Wl(ql(a),!0))}return t})(Kl(e,t))),n);return{container:N(e),offset:N(t),toRange:()=>{const n=zl(e.ownerDocument);return n.setStart(e,t),n.setEnd(e,t),n},getClientRects:o,isVisible:()=>o().length>0,isAtStart:()=>(Ml(e),0===t),isAtEnd:()=>Ml(e)?t>=e.data.length:t>=e.childNodes.length,isEqual:n=>n&&e===n.container()&&t===n.offset(),getNode:n=>Ul(e,n?t-1:t)}};Kl.fromRangeStart=e=>Kl(e.startContainer,e.startOffset),Kl.fromRangeEnd=e=>Kl(e.endContainer,e.endOffset),Kl.after=e=>Kl(e.parentNode,Fl(e)+1),Kl.before=e=>Kl(e.parentNode,Fl(e)),Kl.isAbove=(e,t)=>$e(ce(t.getClientRects()),de(e.getClientRects()),ul).getOr(!1),Kl.isBelow=(e,t)=>$e(de(t.getClientRects()),ce(e.getClientRects()),fl).getOr(!1),Kl.isAtStart=e=>!!e&&e.isAtStart(),Kl.isAtEnd=e=>!!e&&e.isAtEnd(),Kl.isTextPosition=e=>!!e&&ss(e.container()),Kl.isElementPosition=e=>!Kl.isTextPosition(e);const Yl=(e,t)=>{ss(t)&&0===t.data.length&&e.remove(t)},Gl=(e,t,n)=>{ds(n)?((e,t,n)=>{const o=I.from(n.firstChild),r=I.from(n.lastChild);t.insertNode(n),o.each(t=>Yl(e,t.previousSibling)),r.each(t=>Yl(e,t.nextSibling))})(e,t,n):((e,t,n)=>{t.insertNode(n),Yl(e,n.previousSibling),Yl(e,n.nextSibling)})(e,t,n)},Xl=ss,Ql=ts,Zl=gi.nodeIndex,Jl=e=>{const t=e.parentNode;return Ql(t)?Jl(t):t},ec=e=>e?yt(e.childNodes,(e,t)=>(Ql(t)&&"BR"!==t.nodeName?e=e.concat(ec(t)):e.push(t),e),[]):[],tc=e=>t=>e===t,nc=e=>(Xl(e)?"text()":e.nodeName.toLowerCase())+"["+(e=>{let t,n;t=ec(Jl(e)),n=vt(t,tc(e),e),t=t.slice(0,n+1);const o=yt(t,(e,n,o)=>(Xl(n)&&Xl(t[o-1])&&e++,e),0);return t=bt(t,Jr([e.nodeName])),n=vt(t,tc(e),e),n-o})(e)+"]",oc=(e,t)=>{let n,o=[],r=t.container(),s=t.offset();if(Xl(r))n=((e,t)=>{let n=e;for(;(n=n.previousSibling)&&Xl(n);)t+=n.data.length;return t})(r,s);else{const e=r.childNodes;s>=e.length?(n="after",s=e.length-1):n="before",r=e[s]}o.push(nc(r));let a=((e,t)=>{const n=[];for(let o=t.parentNode;o&&o!==e;o=o.parentNode)n.push(o);return n})(e,r);return a=bt(a,T(ts)),o=o.concat(ht(a,e=>nc(e))),o.reverse().join("/")+","+n},rc=(e,t)=>{if(!t)return null;const n=t.split(","),o=n[0].split("/"),r=n.length>1?n[1]:"before",s=yt(o,(e,t)=>{const n=/([\w\-\(\)]+)\[([0-9]+)\]/.exec(t);return n?("text()"===n[1]&&(n[1]="#text"),((e,t,n)=>{let o=ec(e);return o=bt(o,(e,t)=>!Xl(e)||!Xl(o[t-1])),o=bt(o,Jr([t])),o[n]})(e,n[1],parseInt(n[2],10))):null},e);if(!s)return null;if(!Xl(s)&&s.parentNode){let e;return e="after"===r?Zl(s)+1:Zl(s),Kl(s.parentNode,e)}return((e,t)=>{let n=e,o=0;for(;Xl(n);){const r=n.data.length;if(t>=o&&t<=o+r){e=n,t-=o;break}if(!Xl(n.nextSibling)){e=n,t=r;break}o+=r,n=n.nextSibling}return Xl(e)&&t>e.data.length&&(t=e.data.length),Kl(e,t)})(s,parseInt(r,10))},sc=ps,ac=(e,t,n,o,r)=>{const s=r?o.startContainer:o.endContainer;let a=r?o.startOffset:o.endOffset;const i=[],l=e.getRoot();if(ss(s))i.push(n?((e,t,n)=>{let o=e(t.data.slice(0,n)).length;for(let n=t.previousSibling;n&&ss(n);n=n.previousSibling)o+=e(n.data).length;return o})(t,s,a):a);else{let t=0;const o=s.childNodes;a>=o.length&&o.length&&(t=1,a=Math.max(0,o.length-1)),i.push(e.nodeIndex(o[a],n)+t)}for(let t=s;t&&t!==l;t=t.parentNode)i.push(e.nodeIndex(t,n));return i},ic=(e,t,n)=>{let o=0;return dn.each(e.select(t),e=>"all"===e.getAttribute("data-mce-bogus")?void 0:e!==n&&void o++),o},lc=(e,t)=>{let n=t?e.startContainer:e.endContainer,o=t?e.startOffset:e.endOffset;if(Xr(n)&&"TR"===n.nodeName){const r=n.childNodes;n=r[Math.min(t?o:o-1,r.length-1)],n&&(o=t?0:n.childNodes.length,t?e.setStart(n,o):e.setEnd(n,o))}},cc=e=>(lc(e,!0),lc(e,!1),e),dc=(e,t)=>{if(Xr(e)&&(e=hl(e,t),sc(e)))return e;if(el(e)){ss(e)&&Zi(e)&&(e=e.parentNode);let t=e.previousSibling;if(sc(t))return t;if(t=e.nextSibling,sc(t))return t}},mc=(e,t,n)=>{const o=n.getNode(),r=n.getRng();if("IMG"===o.nodeName||sc(o)){const e=o.nodeName;return{name:e,index:ic(n.dom,e,o)}}const s=(e=>dc(e.startContainer,e.startOffset)||dc(e.endContainer,e.endOffset))(r);if(s){const e=s.tagName;return{name:e,index:ic(n.dom,e,s)}}return((e,t,n,o)=>{const r=t.dom,s=ac(r,e,n,o,!0),a=t.isForward(),i=il(o)?{isFakeCaret:!0}:{};return t.isCollapsed()?{start:s,forward:a,...i}:{start:s,end:ac(r,e,n,o,!1),forward:a,...i}})(e,n,t,r)},uc=(e,t,n)=>{const o={"data-mce-type":"bookmark",id:t,style:"overflow:hidden;line-height:0px"};return n?e.create("span",o,"&#xFEFF;"):e.create("span",o)},fc=(e,t)=>{const n=e.dom;let o=e.getRng();const r=n.uniqueId(),s=e.isCollapsed(),a=e.getNode(),i=a.nodeName,l=e.isForward();if("IMG"===i)return{name:i,index:ic(n,i,a)};const c=cc(o.cloneRange());if(!s){c.collapse(!1);const e=uc(n,r+"_end",t);Gl(n,c,e)}o=cc(o),o.collapse(!0);const d=uc(n,r+"_start",t);return Gl(n,o,d),e.moveToBookmark({id:r,keep:!0,forward:l}),{id:r,forward:l}},gc=D(mc,R,!0),pc=e=>1===e,hc=e=>-1===e;var bc;!function(e){e[e.Error=0]="Error",e[e.Value=1]="Value"}(bc||(bc={}));const yc=(e,t,n)=>e.stype===bc.Error?t(e.serror):n(e.svalue),vc=e=>({stype:bc.Value,svalue:e}),Cc=e=>({stype:bc.Error,serror:e}),wc=yc,Sc=e=>f(e)&&ge(e).length>100?" removed due to size":JSON.stringify(e,null,2),Ec=(e,t)=>Cc([{path:e,getErrorInfo:t}]),xc=e=>({extract:(t,n)=>{return o=e(n),r=e=>((e,t)=>Ec(e,N(t)))(t,e),o.stype===bc.Error?r(o.serror):o;var o,r},toString:N("val")}),_c=xc(vc),kc=N(_c),Nc=(e,t)=>xc(n=>{const o=typeof n;return e(n)?vc(n):Cc(`Expected type: ${t} but got: ${o}`)}),Rc=Nc(S,"number"),Ac=Nc(u,"string"),Dc=Nc(w,"function"),Tc=e=>({tag:"defaultedThunk",process:N(e)}),Oc=(e,t,n)=>{switch(e.tag){case"field":return t(e.key,e.newKey,e.presence,e.prop);case"custom":return n(e.newKey,e.instantiator)}},Bc=e=>{const t=(e=>{const t=[],n=[];return q(e,e=>{yc(e,e=>n.push(e),e=>t.push(e))}),{values:t,errors:n}})(e);return t.errors.length>0?(n=t.errors,_(Cc,te)(n)):vc(t.values);var n},Pc=(e,t,n,o)=>o(xe(e,t).getOrThunk(()=>n(e))),Lc=(e,t,n,o,r)=>{const s=e=>r.extract(t.concat([o]),e),a=e=>e.fold(()=>vc(I.none()),e=>{const n=r.extract(t.concat([o]),e);return s=n,a=I.some,s.stype===bc.Value?{stype:bc.Value,svalue:a(s.svalue)}:s;var s,a});switch(e.tag){case"required":return((e,t,n,o)=>xe(t,n).fold(()=>((e,t,n)=>Ec(e,()=>'Could not find valid *required* value for "'+t+'" in '+Sc(n)))(e,n,t),o))(t,n,o,s);case"defaultedThunk":return Pc(n,o,e.process,s);case"option":return((e,t,n)=>n(xe(e,t)))(n,o,a);case"defaultedOptionThunk":return((e,t,n,o)=>o(xe(e,t).map(t=>!0===t?n(e):t)))(n,o,e.process,a);case"mergeWithThunk":return Pc(n,o,N({}),t=>{const o=Fe(e.process(n),t);return s(o)})}},Mc=e=>({extract:(t,n)=>((e,t,n)=>{const o={},r=[];for(const s of n)Oc(s,(n,s,a,i)=>{const l=Lc(a,e,t,n,i);wc(l,e=>{r.push(...e)},e=>{o[s]=e})},(e,n)=>{o[e]=n(t)});return r.length>0?Cc(r):vc(o)})(t,n,e),toString:()=>{const t=V(e,e=>Oc(e,(e,t,n,o)=>e+" -> "+o.toString(),(e,t)=>"state("+e+")"));return"obj{\n"+t.join("\n")+"}"}}),Ic=e=>({extract:(t,n)=>{const o=V(n,(n,o)=>e.extract(t.concat(["["+o+"]"]),n));return Bc(o)},toString:()=>"array("+e.toString()+")"}),Fc=_(Ic,Mc),Uc=(e,t,n)=>{return o=((e,t,n)=>((e,t)=>e.stype===bc.Error?{stype:bc.Error,serror:t(e.serror)}:e)(t.extract([e],n),e=>({input:n,errors:e})))(e,t,n),yc(o,Te.error,Te.value);var o},zc=e=>"Errors: \n"+(e=>{const t=e.length>10?e.slice(0,10).concat([{path:[],getErrorInfo:N("... (only showing first ten failures)")}]):e;return V(t,e=>"Failed path: ("+e.path.join(" > ")+")\n"+e.getErrorInfo())})(e.errors).join("\n")+"\n\nInput object: "+Sc(e.input),jc=(e,t,n,o)=>({tag:"field",key:e,newKey:t,presence:n,prop:o}),$c=(e,t)=>jc(e,e,{tag:"required",process:{}},t),Hc=e=>$c(e,Ac),Vc=e=>$c(e,Dc),qc=(e,t)=>jc(e,e,{tag:"option",process:{}},t),Wc=e=>qc(e,Ac),Kc=(e,t,n)=>jc(e,e,Tc(t),n),Yc=(e,t)=>Kc(e,t,Rc),Gc=e=>"inline-command"===e.type||"inline-format"===e.type,Xc=e=>"block-command"===e.type||"block-format"===e.type,Qc=e=>{const t=t=>Te.error({message:t,pattern:e}),n=(n,o,r)=>{if(void 0!==e.format){let r;if(p(e.format)){if(!oe(e.format,u))return t(n+" pattern has non-string items in the `format` array");r=e.format}else{if(!u(e.format))return t(n+" pattern has non-string `format` parameter");r=[e.format]}return Te.value(o(r))}return void 0!==e.cmd?u(e.cmd)?Te.value(r(e.cmd,e.value)):t(n+" pattern has non-string `cmd` parameter"):t(n+" pattern is missing both `format` and `cmd` parameters")};if(!f(e))return t("Raw pattern is not an object");if(!u(e.start))return t("Raw pattern is missing `start` parameter");if(void 0!==e.end){if(!u(e.end))return t("Inline pattern has non-string `end` parameter");if(0===e.start.length&&0===e.end.length)return t("Inline pattern has empty `start` and `end` parameters");let o=e.start,r=e.end;return 0===r.length&&(r=o,o=""),n("Inline",e=>({type:"inline-format",start:o,end:r,format:e}),(e,t)=>({type:"inline-command",start:o,end:r,cmd:e,value:t}))}if(void 0!==e.replacement)return u(e.replacement)?0===e.start.length?t("Replacement pattern has empty `start` parameter"):Te.value({type:"inline-command",start:"",end:e.start,cmd:"mceInsertContent",value:e.replacement}):t("Replacement pattern has non-string `replacement` parameter");{const o=e.trigger??"space";return 0===e.start.length?t("Block pattern has empty `start` parameter"):n("Block",t=>({type:"block-format",start:e.start,format:t[0],trigger:o}),(t,n)=>({type:"block-command",start:e.start,cmd:t,value:n,trigger:o}))}},Zc=e=>Y(e,Xc),Jc=e=>Y(e,Gc),ed=(e,t)=>({...e,blockPatterns:Y(e.blockPatterns,e=>((e,t)=>("block-command"===e.type||"block-format"===e.type)&&e.trigger===t)(e,t))}),td=e=>{const t=qe(V(e,Qc));return q(t.errors,e=>console.error(e.message,e.pattern)),t.values},nd=(e,t,n)=>{e.dispatch(t,n)},od=(e,t,n,o)=>{e.dispatch("FormatApply",{format:t,node:n,vars:o})},rd=(e,t,n,o)=>{e.dispatch("FormatRemove",{format:t,node:n,vars:o})},sd=(e,t)=>e.dispatch("SetContent",t),ad=(e,t)=>e.dispatch("GetContent",t),id=(e,t)=>{e.dispatch("AutocompleterUpdateActiveRange",t)},ld=(e,t)=>e.dispatch("PastePlainTextToggle",{state:t}),cd=Xt().deviceType,dd=cd.isTouch(),md=gi.DOM,ud=e=>m(e,RegExp),fd=e=>t=>t.options.get(e),gd=e=>u(e)||f(e),pd=(e,t="")=>n=>{const o=u(n);if(o){if(-1!==n.indexOf("=")){const r=(e=>{const t=e.indexOf("=")>0?e.split(/[;,](?![^=;,]*(?:[;,]|$))/):e.split(",");return X(t,(e,t)=>{const n=t.split("="),o=n[0],r=n.length>1?n[1]:o;return e[et(o)]=et(r),e},{})})(n);return{value:xe(r,e.id).getOr(t),valid:o}}return{value:n,valid:o}}return{valid:!1,message:"Must be a string."}},hd=fd("iframe_attrs"),bd=fd("doctype"),yd=fd("document_base_url"),vd=fd("body_id"),Cd=fd("body_class"),wd=fd("content_security_policy"),Sd=fd("br_in_pre"),Ed=fd("forced_root_block"),xd=fd("forced_root_block_attrs"),_d=fd("newline_behavior"),kd=fd("br_newline_selector"),Nd=fd("no_newline_selector"),Rd=fd("keep_styles"),Ad=fd("end_container_on_empty_block"),Dd=fd("automatic_uploads"),Td=fd("images_reuse_filename"),Od=fd("images_replace_blob_uris"),Bd=fd("icons"),Pd=fd("icons_url"),Ld=fd("images_upload_url"),Md=fd("images_upload_base_path"),Id=fd("images_upload_credentials"),Fd=fd("images_upload_handler"),Ud=fd("content_css_cors"),zd=fd("referrer_policy"),jd=fd("crossorigin"),$d=fd("language"),Hd=fd("language_url"),Vd=fd("indent_use_margin"),qd=fd("indentation"),Wd=fd("content_css"),Kd=fd("content_style"),Yd=fd("content_language"),Gd=fd("font_css"),Xd=fd("directionality"),Qd=fd("inline_boundaries_selector"),Zd=fd("object_resizing"),Jd=fd("resize_img_proportional"),em=fd("placeholder"),tm=fd("event_root"),nm=fd("service_message"),om=fd("theme"),rm=fd("theme_url"),sm=fd("model"),am=fd("model_url"),im=fd("inline_boundaries"),lm=fd("formats"),cm=fd("preview_styles"),dm=fd("format_empty_lines"),mm=fd("format_noneditable_selector"),um=fd("custom_ui_selector"),fm=fd("inline"),gm=fd("hidden_input"),pm=fd("submit_patch"),hm=fd("add_form_submit_trigger"),bm=fd("add_unload_trigger"),ym=fd("custom_undo_redo_levels"),vm=fd("disable_nodechange"),Cm=fd("readonly"),wm=fd("editable_root"),Sm=fd("content_css_cors"),Em=fd("plugins"),xm=fd("external_plugins"),_m=fd("block_unsupported_drop"),km=fd("visual"),Nm=fd("visual_table_class"),Rm=fd("visual_anchor_class"),Am=fd("iframe_aria_text"),Dm=fd("setup"),Tm=fd("init_instance_callback"),Om=fd("urlconverter_callback"),Bm=fd("auto_focus"),Pm=fd("browser_spellcheck"),Lm=fd("protect"),Mm=fd("paste_block_drop"),Im=fd("paste_data_images"),Fm=fd("paste_preprocess"),Um=fd("paste_postprocess"),zm=fd("newdocument_content"),jm=fd("paste_webkit_styles"),$m=fd("paste_remove_styles_if_webkit"),Hm=fd("paste_merge_formats"),Vm=fd("smart_paste"),qm=fd("paste_as_text"),Wm=fd("paste_tab_spaces"),Km=fd("allow_html_data_urls"),Ym=fd("text_patterns"),Gm=fd("text_patterns_lookup"),Xm=fd("allow_noneditable"),Qm=fd("noneditable_class"),Zm=fd("editable_class"),Jm=fd("noneditable_regexp"),eu=fd("preserve_cdata"),tu=fd("highlight_on_focus"),nu=fd("xss_sanitization"),ou=fd("init_content_sync"),ru=e=>dn.explode(e.options.get("images_file_types")),su=fd("table_tab_navigation"),au=fd("details_initial_state"),iu=fd("details_serialized_state"),lu=fd("sandbox_iframes"),cu=e=>e.options.get("sandbox_iframes_exclusions"),du=fd("convert_unsafe_embeds"),mu=fd("license_key"),uu=fd("api_key"),fu=fd("disabled"),gu=fd("user_id"),pu=fd("fetch_users"),hu=fd("lists_indent_on_tab"),bu=e=>I.from(e.options.get("list_max_depth")),yu=Xr,vu=ss,Cu=e=>{const t=e.parentNode;t&&t.removeChild(e)},wu=e=>{const t=Gi(e);return{count:e.length-t.length,text:t}},Su=e=>{let t;for(;-1!==(t=e.data.lastIndexOf(Ki));)e.deleteData(t,1)},Eu=(e,t)=>(_u(e),t),xu=(e,t)=>Kl.isTextPosition(t)?((e,t)=>vu(e)&&t.container()===e?((e,t)=>{const n=wu(e.data.substr(0,t.offset())),o=wu(e.data.substr(t.offset()));return(n.text+o.text).length>0?(Su(e),Kl(e,t.offset()-n.count)):t})(e,t):Eu(e,t))(e,t):((e,t)=>t.container()===e.parentNode?((e,t)=>{const n=t.container(),o=((e,t)=>{const n=j(e,t);return-1===n?I.none():I.some(n)})(me(n.childNodes),e).map(e=>e<t.offset()?Kl(n,t.offset()-1):t).getOr(t);return _u(e),o})(e,t):Eu(e,t))(e,t),_u=e=>{yu(e)&&el(e)&&(tl(e)?e.removeAttribute("data-mce-caret"):Cu(e)),vu(e)&&(Su(e),0===e.data.length&&Cu(e))},ku=ps,Nu=Cs,Ru=bs,Au=(e,t,n)=>{const o=dl(t.getBoundingClientRect(),n);let r,s;if("BODY"===e.tagName){const t=e.ownerDocument.documentElement;r=e.scrollLeft||t.scrollLeft,s=e.scrollTop||t.scrollTop}else{const t=e.getBoundingClientRect();r=e.scrollLeft-t.left,s=e.scrollTop-t.top}o.left+=r,o.right+=r,o.top+=s,o.bottom+=s,o.width=1;let a=t.offsetWidth-t.clientWidth;return a>0&&(n&&(a*=-1),o.left+=a,o.right+=a),o},Du=(e,t,n,o)=>{const r=Ke();let s,a;const i=Ed(e),l=e.dom,c=()=>{(e=>{const t=Rr(un.fromDom(e),"*[contentEditable=false],video,audio,embed,object");for(let e=0;e<t.length;e++){const n=t[e].dom;let o=n.previousSibling;if(sl(o)){const e=o.data;1===e.length?o.parentNode?.removeChild(o):o.deleteData(e.length-1,1)}o=n.nextSibling,rl(o)&&(1===o.data.length?o.parentNode?.removeChild(o):o.deleteData(0,1))}})(t),a&&(_u(a),a=null),r.on(e=>{l.remove(e.caret),r.clear()}),s&&(clearInterval(s),s=void 0)};return{isShowing:r.isSet,show:(e,d)=>{let m;if(c(),Ru(d))return null;if(!n(d))return a=((e,t)=>{const n=(e.ownerDocument??document).createTextNode(Ki),o=e.parentNode;if(t){const t=e.previousSibling;if(Qi(t)){if(el(t))return t;if(sl(t))return t.splitText(t.data.length-1)}o?.insertBefore(n,e)}else{const t=e.nextSibling;if(Qi(t)){if(el(t))return t;if(rl(t))return t.splitText(1),t}e.nextSibling?o?.insertBefore(n,e.nextSibling):o?.appendChild(n)}return n})(d,e),m=d.ownerDocument.createRange(),Ou(a.nextSibling)?(m.setStart(a,0),m.setEnd(a,0)):(m.setStart(a,1),m.setEnd(a,1)),m;{const n=((e,t,n)=>{const o=(t.ownerDocument??document).createElement(e);o.setAttribute("data-mce-caret",n?"before":"after"),o.setAttribute("data-mce-bogus","all"),o.appendChild(qi().dom);const r=t.parentNode;return n?r?.insertBefore(o,t):t.nextSibling?r?.insertBefore(o,t.nextSibling):r?.appendChild(o),o})(i,d,e),c=Au(t,d,e);l.setStyle(n,"top",c.top),l.setStyle(n,"caret-color","transparent"),a=n;const u=l.create("div",{class:"mce-visual-caret","data-mce-bogus":"all"});l.setStyles(u,{...c}),l.add(t,u),r.set({caret:u,element:d,before:e}),e&&l.addClass(u,"mce-visual-caret-before"),s=window.setInterval(()=>{r.on(e=>{o()?l.toggleClass(e.caret,"mce-visual-caret-hidden"):l.addClass(e.caret,"mce-visual-caret-hidden")})},500),m=d.ownerDocument.createRange(),m.setStart(n,0),m.setEnd(n,0)}return m},hide:c,getCss:()=>".mce-visual-caret {position: absolute;background-color: black;background-color: currentcolor;}.mce-visual-caret-hidden {display: none;}*[data-mce-caret] {position: absolute;left: -1000px;right: auto;top: 0;margin: 0;padding: 0;}",reposition:()=>{r.on(e=>{const n=Au(t,e.element,e.before);l.setStyles(e.caret,{...n})})},destroy:()=>clearInterval(s)}},Tu=()=>sn.browser.isFirefox(),Ou=e=>ku(e)||Nu(e),Bu=e=>(Ou(e)||ns(e)&&Tu())&&In(un.fromDom(e)).exists(Sr),Pu=gs,Lu=ps,Mu=Cs,Iu=es("display","block table table-cell table-row table-caption list-item"),Fu=el,Uu=Zi,zu=Xr,ju=ss,$u=Nl,Hu=(e,t)=>{let n;for(;n=e(t);)if(!Uu(n))return n;return null},Vu=(e,t,n,o,r)=>{const s=new Kr(e,o),a=Lu(e)||Uu(e);let i;if(hc(t)){if(a&&(i=Hu(s.prev.bind(s),!0),n(i)))return i;for(;i=Hu(s.prev.bind(s),r);)if(n(i))return i}if(pc(t)){if(a&&(i=Hu(s.next.bind(s),!0),n(i)))return i;for(;i=Hu(s.next.bind(s),r);)if(n(i))return i}return null},qu=e=>Xr(e)&&"absolute"===$o(un.fromDom(e),"position"),Wu=(e,t)=>Lu(e)&&qu(e)&&((e,t)=>e.parentNode!==t)(e,t),Ku=(e,t)=>{for(;e&&e!==t;){if(Iu(e)&&!Wu(e,t))return e;e=e.parentNode}return null},Yu=(e,t,n)=>Ku(e.container(),n)===Ku(t.container(),n),Gu=(e,t)=>{if(!t)return I.none();const n=t.container(),o=t.offset();return zu(n)?I.from(n.childNodes[o+e]):I.none()},Xu=(e,t)=>{const n=(t.ownerDocument??document).createRange();return e?(n.setStartBefore(t),n.setEndBefore(t)):(n.setStartAfter(t),n.setEndAfter(t)),n},Qu=(e,t,n)=>Ku(t,e)===Ku(n,e),Zu=(e,t,n)=>{const o=e?"previousSibling":"nextSibling";let r=n;for(;r&&r!==t;){let e=r[o];if(e&&Fu(e)&&(e=e[o]),Lu(e)||Mu(e)){if(Qu(t,e,r))return e;break}if($u(e))break;r=r.parentNode}return null},Ju=D(Xu,!0),ef=D(Xu,!1),tf=(e,t,n)=>{let o;const r=D(Zu,!0,t),s=D(Zu,!1,t),a=n.startContainer,i=n.startOffset;if(Zi(a)){const e=ju(a)?a.parentNode:a,t=e.getAttribute("data-mce-caret");if("before"===t&&(o=e.nextSibling,Bu(o)))return Ju(o);if("after"===t&&(o=e.previousSibling,Bu(o)))return ef(o)}if(!n.collapsed)return n;if(ss(a)){if(Fu(a)){if(1===e){if(o=s(a),o)return Ju(o);if(o=r(a),o)return ef(o)}if(-1===e){if(o=r(a),o)return ef(o);if(o=s(a),o)return Ju(o)}return n}if(sl(a)&&i>=a.data.length-1)return 1===e&&(o=s(a),o)?Ju(o):n;if(rl(a)&&i<=1)return-1===e&&(o=r(a),o)?ef(o):n;if(i===a.data.length)return o=s(a),o?Ju(o):n;if(0===i)return o=r(a),o?ef(o):n}return n},nf=(e,t)=>Gu(e?0:-1,t).filter(Lu),of=(e,t,n)=>{const o=tf(e,t,n);return-1===e?Kl.fromRangeStart(o):Kl.fromRangeEnd(o)},rf=e=>I.from(e.getNode()).map(un.fromDom),sf=(e,t)=>{let n=t;for(;n=e(n);)if(n.isVisible())return n;return n},af=(e,t)=>{const n=Yu(e,t);return!(n||!ms(e.getNode()))||n},lf=ps,cf=ss,df=Xr,mf=ms,uf=Nl,ff=e=>xl(e)||(e=>!!Rl(e)&&!X(me(e.getElementsByTagName("*")),(e,t)=>e||vl(t),!1))(e),gf=Al,pf=(e,t)=>e.hasChildNodes()&&t<e.childNodes.length?e.childNodes[t]:null,hf=(e,t)=>{if(pc(e)){if(uf(t.previousSibling)&&!cf(t.previousSibling))return Kl.before(t);if(cf(t))return Kl(t,0)}if(hc(e)){if(uf(t.nextSibling)&&!cf(t.nextSibling))return Kl.after(t);if(cf(t))return Kl(t,t.data.length)}return hc(e)?mf(t)?Kl.before(t):Kl.after(t):Kl.before(t)},bf=(e,t,n)=>{let o,r,s,a;if(!df(n)||!t)return null;if(t.isEqual(Kl.after(n))&&n.lastChild){if(a=Kl.after(n.lastChild),hc(e)&&uf(n.lastChild)&&df(n.lastChild))return mf(n.lastChild)?Kl.before(n.lastChild):a}else a=t;const i=a.container();let l=a.offset();if(cf(i)){if(hc(e)&&l>0)return Kl(i,--l);if(pc(e)&&l<i.length)return Kl(i,++l);o=i}else{if(hc(e)&&l>0&&(r=pf(i,l-1),uf(r)))return!ff(r)&&(s=Vu(r,e,gf,r),s)?cf(s)?Kl(s,s.data.length):Kl.after(s):cf(r)?Kl(r,r.data.length):Kl.before(r);if(pc(e)&&l<i.childNodes.length&&(r=pf(i,l),uf(r)))return mf(r)?((e,t)=>{const n=t.nextSibling;return n&&uf(n)?cf(n)?Kl(n,0):Kl.before(n):bf(1,Kl.after(t),e)})(n,r):!ff(r)&&(s=Vu(r,e,gf,r),s)?cf(s)?Kl(s,0):Kl.before(s):cf(r)?Kl(r,0):Kl.after(r);o=r||a.getNode()}if(o&&(pc(e)&&a.isAtEnd()||hc(e)&&a.isAtStart())&&(o=Vu(o,e,M,n,!0),gf(o,n)))return hf(e,o);r=o?Vu(o,e,gf,n):o;const c=Ct(Y(((e,t)=>{const n=[];let o=e;for(;o&&o!==t;)n.push(o),o=o.parentNode;return n})(i,n),lf));return!c||r&&c.contains(r)?r?hf(e,r):null:(a=pc(e)?Kl.after(c):Kl.before(c),a)},yf=e=>({next:t=>bf(1,t,e),prev:t=>bf(-1,t,e)}),vf=e=>Kl.isTextPosition(e)?0===e.offset():Nl(e.getNode()),Cf=e=>{if(Kl.isTextPosition(e)){const t=e.container();return e.offset()===t.data.length}return Nl(e.getNode(!0))},wf=(e,t)=>!Kl.isTextPosition(e)&&!Kl.isTextPosition(t)&&e.getNode()===t.getNode(!0),Sf=(e,t,n)=>{const o=yf(t);return I.from(e?o.next(n):o.prev(n))},Ef=(e,t,n)=>Sf(e,t,n).bind(o=>Yu(n,o,t)&&((e,t,n)=>{return e?!wf(t,n)&&(o=t,!(!Kl.isTextPosition(o)&&ms(o.getNode())))&&Cf(t)&&vf(n):!wf(n,t)&&vf(t)&&Cf(n);var o})(e,n,o)?Sf(e,t,o):I.some(o)),xf=(e,t,n,o)=>Ef(e,t,n).bind(n=>o(n)?xf(e,t,n,o):I.some(n)),_f=(e,t)=>{const n=e?t.firstChild:t.lastChild;return ss(n)?I.some(Kl(n,e?0:n.data.length)):n?Nl(n)?I.some(e?Kl.before(n):ms(o=n)?Kl.before(o):Kl.after(o)):((e,t,n)=>{const o=e?Kl.before(n):Kl.after(n);return Sf(e,t,o)})(e,t,n):I.none();var o},kf=D(Sf,!0),Nf=D(Sf,!1),Rf=D(_f,!0),Af=D(_f,!1),Df="_mce_caret",Tf=e=>Xr(e)&&e.id===Df,Of=(e,t)=>{let n=t;for(;n&&n!==e;){if(Tf(n))return n;n=n.parentNode}return null},Bf=e=>_e(e,"name"),Pf=e=>dn.isArray(e.start),Lf=e=>!(!Bf(e)&&b(e.forward))||e.forward,Mf=(e,t)=>(Xr(t)&&e.isBlock(t)&&!t.innerHTML&&(t.innerHTML='<br data-mce-bogus="1" />'),t),If=(e,t)=>Af(e).fold(L,e=>(t.setStart(e.container(),e.offset()),t.setEnd(e.container(),e.offset()),!0)),Ff=(e,t,n)=>!(!(e=>!e.hasChildNodes())(t)||!Of(e,t)||(((e,t)=>{const n=(e.ownerDocument??document).createTextNode(Ki);e.appendChild(n),t.setStart(n,0),t.setEnd(n,0)})(t,n),0)),Uf=(e,t,n,o)=>{const r=n[t?"start":"end"],s=e.getRoot();if(r){let e=s,n=r[0];for(let t=r.length-1;e&&t>=1;t--){const n=e.childNodes;if(Ff(s,e,o))return!0;if(r[t]>n.length-1)return!!Ff(s,e,o)||If(e,o);e=n[r[t]]}ss(e)&&(n=Math.min(r[0],e.data.length)),Xr(e)&&(n=Math.min(r[0],e.childNodes.length)),t?o.setStart(e,n):o.setEnd(e,n)}return!0},zf=e=>ss(e)&&e.data.length>0,jf=(e,t,n)=>{const o=e.get(n.id+"_"+t),r=o?.parentNode,s=n.keep;if(o&&r){let a,i;if("start"===t?s?o.hasChildNodes()?(a=o.firstChild,i=1):zf(o.nextSibling)?(a=o.nextSibling,i=0):zf(o.previousSibling)?(a=o.previousSibling,i=o.previousSibling.data.length):(a=r,i=e.nodeIndex(o)+1):(a=r,i=e.nodeIndex(o)):s?o.hasChildNodes()?(a=o.firstChild,i=1):zf(o.previousSibling)?(a=o.previousSibling,i=o.previousSibling.data.length):(a=r,i=e.nodeIndex(o)):(a=r,i=e.nodeIndex(o)),!s){const r=o.previousSibling,s=o.nextSibling;let l;for(dn.each(dn.grep(o.childNodes),e=>{ss(e)&&(e.data=e.data.replace(/\uFEFF/g,""))});l=e.get(n.id+"_"+t);)e.remove(l,!0);if(ss(s)&&ss(r)&&!sn.browser.isOpera()){const t=r.data.length;r.appendData(s.data),e.remove(s),a=r,i=t}}return I.some(Kl(a,i))}return I.none()},$f=(e,t,n)=>((e,t,n=!1)=>2===t?mc(Gi,n,e):3===t?(e=>{const t=e.getRng();return{start:oc(e.dom.getRoot(),Kl.fromRangeStart(t)),end:oc(e.dom.getRoot(),Kl.fromRangeEnd(t)),forward:e.isForward()}})(e):t?(e=>({rng:e.getRng(),forward:e.isForward()}))(e):fc(e,!1))(e,t,n),Hf=(e,t)=>{((e,t)=>{const n=e.dom;if(t){if(Pf(t))return((e,t)=>{const n=e.createRng();return Uf(e,!0,t,n)&&Uf(e,!1,t,n)?I.some({range:n,forward:Lf(t)}):I.none()})(n,t);if((e=>u(e.start))(t))return((e,t)=>{const n=I.from(rc(e.getRoot(),t.start)),o=I.from(rc(e.getRoot(),t.end));return $e(n,o,(n,o)=>{const r=e.createRng();return r.setStart(n.container(),n.offset()),r.setEnd(o.container(),o.offset()),{range:r,forward:Lf(t)}})})(n,t);if((e=>_e(e,"id"))(t))return((e,t)=>{const n=jf(e,"start",t),o=jf(e,"end",t);return $e(n,o.or(n),(n,o)=>{const r=e.createRng();return r.setStart(Mf(e,n.container()),n.offset()),r.setEnd(Mf(e,o.container()),o.offset()),{range:r,forward:Lf(t)}})})(n,t);if(Bf(t))return((e,t)=>I.from(e.select(t.name)[t.index]).map(t=>{const n=e.createRng();return n.selectNode(t),{range:n,forward:!0}}))(n,t);if((e=>_e(e,"rng"))(t))return I.some({range:t.rng,forward:Lf(t)})}return I.none()})(e,t).each(({range:t,forward:n})=>{e.setRng(t,n)})},Vf=e=>Xr(e)&&"SPAN"===e.tagName&&"bookmark"===e.getAttribute("data-mce-type"),qf=(Wf=dt,e=>Wf===e);var Wf;const Kf=e=>""!==e&&-1!==" \f\n\r\t\v".indexOf(e),Yf=e=>!Kf(e)&&!qf(e)&&!mt(e),Gf=e=>{const t=[];if(e)for(let n=0;n<e.rangeCount;n++)t.push(e.getRangeAt(n));return t},Xf=(e,t)=>{const n=Rr(t,"td[data-mce-selected],th[data-mce-selected]");return n.length>0?n:(e=>Y((e=>ne(e,e=>{const t=pl(e);return t?[un.fromDom(t)]:[]}))(e),Hi))(e)},Qf=e=>Xf(Gf(e.selection.getSel()),un.fromDom(e.getBody())),Zf=(e,t)=>mr(e,"table",t),Jf=e=>Wn(e).fold(N([e]),t=>[e].concat(Jf(t))),eg=e=>Kn(e).fold(N([e]),t=>"br"===En(t)?zn(t).map(t=>[e].concat(eg(t))).getOr([]):[e].concat(eg(t))),tg=(e,t)=>$e((e=>{const t=e.startContainer,n=e.startOffset;return ss(t)?0===n?I.some(un.fromDom(t)):I.none():I.from(t.childNodes[n]).map(un.fromDom)})(t),(e=>{const t=e.endContainer,n=e.endOffset;return ss(t)?n===t.data.length?I.some(un.fromDom(t)):I.none():I.from(t.childNodes[n-1]).map(un.fromDom)})(t),(t,n)=>{const o=Z(Jf(e),D(vn,t)),r=Z(eg(e),D(vn,n));return o.isSome()&&r.isSome()}).getOr(!1),ng=(e,t,n,o)=>{const r=n,s=new Kr(n,r),a=we(e.schema.getMoveCaretBeforeOnEnterElements(),(e,t)=>!$(["td","th","table"],t.toLowerCase()));let i=n;do{if(ss(i)&&0!==dn.trim(i.data).length)return void(o?t.setStart(i,0):t.setEnd(i,i.data.length));if(a[i.nodeName])return void(o?t.setStartBefore(i):"BR"===i.nodeName?t.setEndBefore(i):t.setEndAfter(i))}while(i=o?s.next():s.prev());"BODY"===r.nodeName&&(o?t.setStart(r,0):t.setEnd(r,r.childNodes.length))},og=e=>{const t=e.selection.getSel();return C(t)&&t.rangeCount>0},rg=(e,t)=>{const n=Qf(e);n.length>0?q(n,n=>{const o=n.dom,r=e.dom.createRng();r.setStartBefore(o),r.setEndAfter(o),t(r,!0)}):t(e.selection.getRng(),!1)},sg=(e,t,n)=>{const o=fc(e,t);n(o),e.moveToBookmark(o)},ag=(e,t)=>e.startContainer===e.endContainer&&e.endOffset-e.startOffset===1&&t(e.startContainer.childNodes[e.startOffset]),ig=e=>S(e?.nodeType),lg=e=>Xr(e)&&!Vf(e)&&!Tf(e)&&!ts(e),cg=(e,t,n)=>{const{selection:o,dom:r}=e,s=o.getNode(),a=ps(s);sg(o,!0,()=>{t()}),a&&ps(s)&&r.isChildOf(s,e.getBody())?e.selection.select(s):n(o.getStart())&&dg(r,o)},dg=(e,t)=>{const n=t.getRng(),{startContainer:o,startOffset:r}=n;if(!((e,t)=>{if(lg(t)&&!/^(TD|TH)$/.test(t.nodeName)){const n=e.getAttrib(t,"data-mce-selected"),o=parseInt(n,10);return!isNaN(o)&&o>0}return!1})(e,t.getNode())&&Xr(o)){const s=o.childNodes,a=e.getRoot();let i;if(r<s.length){const t=s[r];i=new Kr(t,e.getParent(t,e.isBlock)??a)}else{const t=s[s.length-1];i=new Kr(t,e.getParent(t,e.isBlock)??a),i.next(!0)}for(let o=i.current();o;o=i.next()){if("false"===e.getContentEditable(o))return;if(ss(o)&&!gg(o))return n.setStart(o,0),void t.setRng(n)}}},mg=(e,t,n)=>{if(e){const o=t?"nextSibling":"previousSibling";for(e=n?e:e[o];e;e=e[o])if(Xr(e)||!gg(e))return e}},ug=(e,t)=>!!e.getTextBlockElements()[t.nodeName.toLowerCase()]||Zs(e,t),fg=(e,t,n)=>e.schema.isValidChild(t,n),gg=(e,t=!1)=>{if(C(e)&&ss(e)){const n=t?e.data.replace(/ /g,"\xa0"):e.data;return Ns(n)}return!1},pg=(e,t)=>e.select('[contenteditable="true"]',t).length>0,hg=(e,t)=>X(me(t.childNodes),(t,n)=>[...t,...Xr(n)&&"true"===e.getContentEditable(n)?[n]:hg(e,n)],[]),bg=(e,t)=>{const n=e.dom;return lg(t)&&"false"===n.getContentEditable(t)&&((e,t)=>{const n="[data-mce-cef-wrappable]",o=mm(e),r=rt(o)?n:`${n},${o}`;return bn(un.fromDom(t),r)})(e,t)&&!pg(n,t)},yg=(e,t)=>w(e)?e(t):(C(t)&&(e=e.replace(/%(\w+)/g,(e,n)=>t[n]||e)),e),vg=(e,t)=>(t=t||"",e=""+((e=e||"").nodeName||e),t=""+(t.nodeName||t),e.toLowerCase()===t.toLowerCase()),Cg=(e,t)=>{if(v(e))return null;{let n=String(e);return"color"!==t&&"backgroundColor"!==t||(n=Ya(n)),"fontWeight"===t&&700===e&&(n="bold"),"fontFamily"===t&&(n=n.replace(/[\'\"]/g,"").replace(/,\s+/g,",")),n}},wg=(e,t,n)=>{const o=e.getStyle(t,n);return Cg(o,n)},Sg=(e,t)=>{let n;return e.getParent(t,t=>!!Xr(t)&&(n=e.getStyle(t,"text-decoration"),!!n&&"none"!==n)),n},Eg=(e,t,n)=>e.getParents(t,n,e.getRoot()),xg=(e,t,n)=>{const o=e.formatter.get(t);return C(o)&&H(o,n)},_g=e=>ke(e,"block"),kg=e=>_g(e)&&!0===e.wrapper,Ng=e=>ke(e,"selector"),Rg=e=>ke(e,"inline"),Ag=e=>Ng(e)&&!1!==e.expand&&!Rg(e),Dg=e=>(e=>{const t=[];let n=e;for(;n;){if(ss(n)&&n.data!==Ki||n.childNodes.length>1)return[];Xr(n)&&t.push(n),n=n.firstChild}return t})(e).length>0,Tg=e=>Tf(e.dom)&&Dg(e.dom),Og=Vf,Bg=Eg,Pg=gg,Lg=ug,Mg=e=>ms(e)&&e.getAttribute("data-mce-bogus")&&!e.nextSibling,Ig=(e,t)=>{let n=t;for(;n;){if(Xr(n)&&e.getContentEditable(n))return"false"===e.getContentEditable(n)?n:t;n=n.parentNode}return t},Fg=(e,t,n,o)=>{const r=t.data;if(e){for(let e=n;e>0;e--)if(o(r.charAt(e-1)))return e}else for(let e=n;e<r.length;e++)if(o(r.charAt(e)))return e;return-1},Ug=(e,t,n)=>Fg(e,t,n,e=>qf(e)||Kf(e)),zg=(e,t,n)=>Fg(e,t,n,Yf),jg=(e,t,n,o,r,s)=>{let a;const i=e.getParent(n,t=>hs(t)||e.isBlock(t)),l=C(i)?i:t,c=(t,n,o)=>{const s=Pi(e),i=r?s.backwards:s.forwards;return I.from(i(t,n,(e,t)=>Og(e.parentNode)?-1:(a=e,o(r,e,t)),l))};return c(n,o,Ug).bind(e=>s?c(e.container,e.offset+(r?-1:0),zg):I.some(e)).orThunk(()=>a?I.some({container:a,offset:r?0:a.length}):I.none())},$g=(e,t,n,o,r)=>{const s=o[r];ss(o)&&rt(o.data)&&s&&(o=s);const a=Bg(e,o);for(let o=0;o<a.length;o++)for(let r=0;r<t.length;r++){const s=t[r];if((!C(s.collapsed)||s.collapsed===n.collapsed)&&Ng(s)&&e.is(a[o],s.selector))return a[o]}return o},Hg=(e,t,n,o)=>{let r=n;const s=e.getRoot(),a=t[0];if(_g(a)&&(r=a.wrapper?null:e.getParent(n,a.block,s)),!r){const t=e.getParent(n,"LI,TD,TH,SUMMARY")??s;r=e.getParent(ss(n)?n.parentNode:n,t=>t!==s&&Lg(e.schema,t),t)}if(r&&_g(a)&&a.wrapper&&(r=Bg(e,r,"ul,ol").reverse()[0]||r),!r)for(r=n;r&&r[o]&&!e.isBlock(r[o])&&(r=r[o],!vg(r,"br")););return r||n},Vg=(e,t,n,o)=>{const r=n.parentNode;return!C(n[o])&&(!(r!==t&&!v(r)&&!e.isBlock(r))||Vg(e,t,r,o))},qg=(e,t,n,o,r,s)=>{let a=n;const i=r?"previousSibling":"nextSibling",l=e.getRoot();if(ss(n)&&!Pg(n)&&(r?o>0:o<n.data.length))return n;for(;a;){if(hs(a))return n;if(!t[0].block_expand&&e.isBlock(a))return s?a:n;for(let t=a[i];t;t=t[i]){const n=ss(t)&&!Vg(e,l,t,i);if(!Og(t)&&!Mg(t)&&!Pg(t,n))return a}if(a===l||a.parentNode===l){n=a;break}a=a.parentNode}return n},Wg=e=>Og(e.parentNode)||Og(e),Kg=(e,t,n,o={})=>{const{includeTrailingSpace:r=!1,expandToBlock:s=!0}=o,a=e.getParent(t.commonAncestorContainer,e=>hs(e)),i=C(a)?a:e.getRoot();let{startContainer:l,startOffset:c,endContainer:d,endOffset:m}=t;const u=n[0];return Xr(l)&&l.hasChildNodes()&&(l=hl(l,c),ss(l)&&(c=0)),Xr(d)&&d.hasChildNodes()&&(d=hl(d,t.collapsed?m:m-1),ss(d)&&(m=d.data.length)),l=Ig(e,l),d=Ig(e,d),Wg(l)&&(l=Og(l)?l:l.parentNode,l=t.collapsed?l.previousSibling||l:l.nextSibling||l,ss(l)&&(c=t.collapsed?l.length:0)),Wg(d)&&(d=Og(d)?d:d.parentNode,d=t.collapsed?d.nextSibling||d:d.previousSibling||d,ss(d)&&(m=t.collapsed?0:d.length)),t.collapsed&&(jg(e,i,l,c,!0,r).each(({container:e,offset:t})=>{l=e,c=t}),jg(e,i,d,m,!1,r).each(({container:e,offset:t})=>{d=e,m=t})),(Rg(u)||u.block_expand)&&(Rg(u)&&ss(l)&&0!==c||(l=qg(e,n,l,c,!0,s)),Rg(u)&&ss(d)&&m!==d.data.length||(d=qg(e,n,d,m,!1,s))),Ag(u)&&(l=$g(e,n,t,l,"previousSibling"),d=$g(e,n,t,d,"nextSibling")),(_g(u)||Ng(u))&&(l=Hg(e,n,l,"previousSibling"),d=Hg(e,n,d,"nextSibling"),_g(u)&&(e.isBlock(l)||(l=qg(e,n,l,c,!0,s),ss(l)&&(c=0)),e.isBlock(d)||(d=qg(e,n,d,m,!1,s),ss(d)&&(m=d.data.length)))),Xr(l)&&l.parentNode&&(c=e.nodeIndex(l),l=l.parentNode),Xr(d)&&d.parentNode&&(m=e.nodeIndex(d)+1,d=d.parentNode),{startContainer:l,startOffset:c,endContainer:d,endOffset:m}},Yg=(e,t,n)=>{const o=t.startOffset,r=hl(t.startContainer,o),s=t.endOffset,a=hl(t.endContainer,s-1),i=e=>{const t=e[0];ss(t)&&t===r&&o>=t.data.length&&e.splice(0,1);const n=e[e.length-1];return 0===s&&e.length>0&&n===a&&ss(n)&&e.splice(e.length-1,1),e},l=(e,t,n)=>{const o=[];for(;e&&e!==n;e=e[t])o.push(e);return o},c=(t,n)=>e.getParent(t,e=>e.parentNode===n,n),d=(e,t,o)=>{const r=o?"nextSibling":"previousSibling";for(let s=e,a=s.parentNode;s&&s!==t;s=a){a=s.parentNode;const t=l(s===e?s:s[r],r);t.length&&(o||t.reverse(),n(i(t)))}};if(r===a)return n(i([r]));const m=e.findCommonAncestor(r,a)??e.getRoot();if(e.isChildOf(r,a))return d(r,m,!0);if(e.isChildOf(a,r))return d(a,m);const u=c(r,m)||r,f=c(a,m)||a;d(r,u,!0);const g=l(u===r?u:u.nextSibling,"nextSibling",f===a?f.nextSibling:f);g.length&&n(i(g)),d(a,f)},Gg=['pre[class*=language-][contenteditable="false"]',"figure.image","div[data-ephox-embed-iri]","div.tiny-pageembed","div.mce-toc","div[data-mce-toc]","div.mce-footnotes"],Xg=(e,t,n,o,r,s)=>{const{uid:a=t,...i}=n;yr(e,Si()),vo(e,`${xi()}`,a),vo(e,`${Ei()}`,o);const{attributes:l={},classes:c=[]}=r(a,i);if(Co(e,l),((e,t)=>{q(t,t=>{yr(e,t)})})(e,c),s){c.length>0&&vo(e,`${ki()}`,c.join(","));const t=ge(l);t.length>0&&vo(e,`${Ni()}`,t.join(","))}},Qg=(e,t,n,o,r)=>{const s=un.fromTag("span",e);return Xg(s,t,n,o,r,!1),s},Zg=(e,t,n,o,r,s)=>{const a=[],i=Qg(e.getDoc(),n,s,o,r),l=Ke(),c=()=>{l.clear()},d=e=>{q(e,m)},m=t=>{switch(((e,t,n,o)=>In(t).fold(()=>"skipping",r=>"br"===o||(e=>An(e)&&or(e)===Ki)(t)?"valid":(e=>Rn(e)&&wr(e,Si()))(t)?"existing":Tf(t.dom)?"caret":H(Gg,e=>bn(t,e))?"valid-block":fg(e,n,o)&&fg(e,En(r),n)?"valid":"invalid-child"))(e,t,"span",En(t))){case"invalid-child":{c();const e=Vn(t);d(e),c();break}case"valid-block":c(),Xg(t,n,s,o,r,!0);break;case"valid":{const e=l.get().getOrThunk(()=>{const e=To(i);return a.push(e),l.set(e),e});po(t,e);break}}};return Yg(e.dom,t,e=>{c(),(e=>{const t=V(e,un.fromDom);d(t)})(e)}),a},Jg=e=>{const t=(()=>{const e={};return{register:(t,n)=>{e[t]={name:t,settings:n}},lookup:t=>xe(e,t).map(e=>e.settings),getNames:()=>ge(e)}})();((e,t)=>{const n=Ei(),o=e=>I.from(e.attr(n)).bind(t.lookup),r=e=>{e.attr(xi(),null),e.attr(Ei(),null),e.attr(_i(),null);const t=I.from(e.attr(Ni())).map(e=>e.split(",")).getOr([]),n=I.from(e.attr(ki())).map(e=>e.split(",")).getOr([]);q(t,t=>e.attr(t,null));const o=e.attr("class")?.split(" ")??[],r=se(o,[Si()].concat(n));e.attr("class",r.length>0?r.join(" "):null),e.attr(ki(),null),e.attr(Ni(),null)};e.serializer.addTempAttr(_i()),e.serializer.addAttributeFilter(n,e=>{for(const t of e)o(t).each(e=>{!1===e.persistent&&("span"===t.name?t.unwrap():r(t))})})})(e,t);const n=((e,t)=>{const n=Re({}),o=()=>({listeners:[],previous:Ke()}),r=(e,t)=>{s(e,e=>(t(e),e))},s=(e,t)=>{const r=n.get(),s=t(xe(r,e).getOrThunk(o));r[e]=s,n.set(r)},a=(t,n)=>{q(Ti(e,t),e=>{n?vo(e,_i(),"true"):xo(e,_i())})},i=it(()=>{const n=ie(t.getNames());q(n,t=>{s(t,n=>{const o=n.previous.get();return Ai(e,I.some(t)).fold(()=>{o.each(e=>{(e=>{r(e,t=>{q(t.listeners,t=>t(!1,e))})})(t),n.previous.clear(),a(e,!1)})},({uid:e,name:t,elements:s})=>{ze(o,e)||(o.each(e=>a(e,!1)),((e,t,n)=>{r(e,o=>{q(o.listeners,o=>o(!0,e,{uid:t,nodes:V(n,e=>e.dom)}))})})(t,e,s),n.previous.set(e),a(e,!0))}),{previous:n.previous,listeners:n.listeners}})})},30);return e.on("remove",()=>{i.cancel()}),e.on("NodeChange",()=>{i.throttle()}),{addListener:(e,t)=>{s(e,e=>({previous:e.previous,listeners:e.listeners.concat([t])}))}}})(e,t),o=On("span"),r=e=>{q(e,e=>{o(e)?Ao(e):(e=>{Cr(e,Si()),xo(e,`${xi()}`),xo(e,`${Ei()}`),xo(e,`${_i()}`);const t=So(e,`${Ni()}`).map(e=>e.split(",")).getOr([]),n=So(e,`${ki()}`).map(e=>e.split(",")).getOr([]);var o;q(t,t=>xo(e,t)),o=e,q(n,e=>{Cr(o,e)}),xo(e,`${ki()}`),xo(e,`${Ni()}`)})(e)})};return{register:(e,n)=>{t.register(e,n)},annotate:(n,o)=>{t.lookup(n).each(t=>{((e,t,n,o)=>{e.undoManager.transact(()=>{const r=e.selection,s=r.getRng(),a=Qf(e).length>0,i=Le("mce-annotation");if(s.collapsed&&!a&&((e,t)=>{const n=Kg(e.dom,t,[{inline:"span"}]);t.setStart(n.startContainer,n.startOffset),t.setEnd(n.endContainer,n.endOffset),e.selection.setRng(t)})(e,s),r.getRng().collapsed&&!a){const s=Qg(e.getDoc(),i,o,t,n.decorate);Mo(s,dt),r.getRng().insertNode(s.dom),r.select(s.dom)}else sg(r,!1,()=>{rg(e,r=>{Zg(e,r,i,t,n.decorate,o)})})})})(e,n,t,o)})},annotationChanged:(e,t)=>{n.addListener(e,t)},remove:t=>{Ai(e,I.some(t)).each(({elements:t})=>{const n=e.selection.getBookmark();r(t),e.selection.moveToBookmark(n)})},removeAll:t=>{const n=e.selection.getBookmark();he(Oi(e,t),(e,t)=>{r(e)}),e.selection.moveToBookmark(n)},getAll:t=>{const n=Oi(e,t);return be(n,e=>V(e,e=>e.dom))}}},ep=Le("tiny-aria-announcer"),tp="data-mce-announced-at",np={position:"absolute",left:"-9999px",width:"1px",height:"1px",overflow:"hidden"},op=e=>{const t=un.fromTag("div");return Co(t,{"aria-live":e,"aria-atomic":"false","aria-relevant":"additions"}),t},rp=()=>{const e=un.fromTag("div"),t=op("polite"),n=op("assertive");return vo(e,"id",ep),jo(e,np),go(e,t),go(e,n),go((e=>{const t=e.dom.body;if(null==t)throw new Error("Body is not available yet");return un.fromDom(t)})(un.fromDom(document)),e),{container:e,politeRegion:t,assertiveRegion:n}},sp=(()=>{const e=Ke(),t=async()=>{const t=async()=>{const t=new Promise(e=>{const t=rp();setTimeout(()=>e(t),100)});return e.set(t),t};return e.get().fold(t,async n=>{const{container:o}=await n;return o.dom.isConnected?n:e.get().filter(e=>e!==n).getOrThunk(t)})},n=(e,t)=>{const n=Date.now();((e,t)=>{var n;q((n=`div[${tp}]`,kr(e,e=>bn(e,n))),e=>{So(e,tp).bind(e=>st(e)).filter(e=>t-e>6e5).each(()=>Ro(e))})})(e,n);const o=un.fromTag("div");vo(o,tp,String(n)),go(o,un.fromText(t)),go(e,o)};return{polite:async e=>{const{politeRegion:o}=await t();n(o,e)},assertive:async e=>{const{assertiveRegion:o}=await t();n(o,e)}}})(),ap={announce:(e,t)=>{!0===t?.assertive?sp.assertive(e).catch(x):sp.polite(e).catch(x)}},ip=e=>({getBookmark:D($f,e),moveToBookmark:D(Hf,e)});ip.isBookmarkNode=Vf;const lp=(e,t,n)=>!n.collapsed&&H(n.getClientRects(),n=>((e,t,n)=>t>=e.left&&t<=e.right&&n>=e.top&&n<=e.bottom)(n,e,t)),cp=(e,t)=>{const n=An(t)?or(t).length:Vn(t).length+1;return e>n?n:e<0?0:e},dp=e=>Ur.range(e.start,cp(e.soffset,e.start),e.finish,cp(e.foffset,e.finish)),mp=(e,t)=>!Gr(t.dom)&&(Cn(e,t)||vn(e,t)),up=e=>t=>mp(e,t.start)&&mp(e,t.finish),fp=e=>Ur.range(un.fromDom(e.startContainer),e.startOffset,un.fromDom(e.endContainer),e.endOffset),gp=e=>{const t=document.createRange();try{return t.setStart(e.start.dom,e.soffset),t.setEnd(e.finish.dom,e.foffset),I.some(t)}catch{return I.none()}},pp=e=>{const t=(e=>e.inline||sn.browser.isFirefox())(e)?(n=un.fromDom(e.getBody()),(e=>{const t=e.getSelection();return(t&&0!==t.rangeCount?I.from(t.getRangeAt(0)):I.none()).map(fp)})(Ln(n).dom).filter(up(n))):I.none();var n;e.bookmark=t.isSome()?t:e.bookmark},hp=e=>(e.bookmark?e.bookmark:I.none()).bind(t=>{return n=un.fromDom(e.getBody()),o=t,I.from(o).filter(up(n)).map(dp);var n,o}).bind(gp),bp={isEditorUIElement:e=>{const t=e.className.toString();return-1!==t.indexOf("tox-")||-1!==t.indexOf("mce-")}},yp={setEditorTimeout:(e,t,n)=>((e,t)=>(S(t)||(t=0),window.setTimeout(e,t)))(()=>{e.removed||t()},n),setEditorInterval:(e,t,n)=>{const o=((e,t)=>(S(t)||(t=0),window.setInterval(e,t)))(()=>{e.removed?window.clearInterval(o):t()},n);return o}};let vp;const Cp=gi.DOM,wp=e=>{const t=e.classList;return void 0!==t&&(t.contains("tox-edit-area")||t.contains("tox-edit-area__iframe")||t.contains("mce-content-body"))},Sp=(e,t)=>{const n=um(e),o=Cp.getParent(t,t=>(e=>Xr(e)&&bp.isEditorUIElement(e))(t)||!!n&&e.dom.is(t,n));return null!==o},Ep=e=>{try{const t=Qn(un.fromDom(e.getElement()));return co(t).fold(()=>document.body,e=>e.dom)}catch{return document.body}},xp=(e,t)=>{const n=t.editor;(e=>{const t=at(()=>{pp(e)},0);e.on("init",()=>{e.inline&&((e,t)=>{const n=()=>{t.throttle()};gi.DOM.bind(document,"mouseup",n),e.on("remove",()=>{gi.DOM.unbind(document,"mouseup",n)})})(e,t),((e,t)=>{((e,t)=>{e.on("mouseup touchend",e=>{t.throttle()})})(e,t),e.on("keyup NodeChange AfterSetSelectionRange",t=>{(e=>"nodechange"===e.type&&e.selectionChange)(t)||pp(e)})})(e,t)}),e.on("remove",()=>{t.cancel()})})(n);const o=(e,t)=>{tu(e)&&!0!==e.inline&&t(un.fromDom(e.getContainer()),"tox-edit-focus")};n.on("focusin",()=>{const t=e.focusedEditor;wp(Ep(n))&&o(n,yr),t!==n&&(t&&t.dispatch("blur",{focusedEditor:n}),e.setActive(n),e.focusedEditor=n,n.dispatch("focus",{blurredEditor:t}),n.focus(!0))}),n.on("focusout",()=>{yp.setEditorTimeout(n,()=>{const t=e.focusedEditor;wp(Ep(n))&&t===n||o(n,Cr),Sp(n,Ep(n))||t!==n||(n.dispatch("blur",{focusedEditor:null}),e.focusedEditor=null)})}),vp||(vp=t=>{const n=e.activeEditor;n&&eo(t).each(t=>{const o=t;o.ownerDocument===document&&(o===document.body||Sp(n,o)||e.focusedEditor!==n||(n.dispatch("blur",{focusedEditor:null}),e.focusedEditor=null))})},Cp.bind(document,"focusin",vp))},_p=(e,t)=>{e.focusedEditor===t.editor&&(e.focusedEditor=null),!e.activeEditor&&vp&&(Cp.unbind(document,"focusin",vp),vp=null)},kp=(e,t)=>{((e,t)=>(e=>e.collapsed?I.from(hl(e.startContainer,e.startOffset)).map(un.fromDom):I.none())(t).bind(t=>$i(t)?I.some(t):Cn(e,t)?I.none():I.some(e)))(un.fromDom(e.getBody()),t).bind(e=>Rf(e.dom)).fold(()=>{e.selection.normalize()},t=>e.selection.setRng(t.toRange()))},Np=(e,t=!1)=>{if(t)e.focus({preventScroll:!0});else if(e.setActive)try{e.setActive()}catch{e.focus()}else e.focus()},Rp=e=>e.inline?(e=>{const t=e.getBody();return t&&(n=un.fromDom(t),lo(n)||(o=n,co(Qn(o)).filter(e=>o.dom.contains(e.dom))).isSome());var n,o})(e):(e=>C(e.iframeElement)&&lo(un.fromDom(e.iframeElement)))(e),Ap=e=>Rp(e)||(e=>{const t=Qn(un.fromDom(e.getElement()));return co(t).filter(t=>!wp(t.dom)&&Sp(e,t.dom)).isSome()})(e),Dp=e=>e.editorManager.setActive(e),Tp={BACKSPACE:8,DELETE:46,DOWN:40,ENTER:13,ESC:27,LEFT:37,RIGHT:39,SPACEBAR:32,TAB:9,UP:38,PAGE_UP:33,PAGE_DOWN:34,END:35,HOME:36,modifierPressed:e=>e.shiftKey||e.ctrlKey||e.altKey||Tp.metaKeyPressed(e),metaKeyPressed:e=>sn.os.isMacOS()||sn.os.isiOS()?e.metaKey:e.ctrlKey&&!e.altKey},Op="data-mce-selected",Bp=`table,img,figure.image,hr,video,span.mce-preview-object,details,${xs}`,Pp=Math.abs,Lp=Math.round,Mp={nw:[0,0,-1,-1],ne:[1,0,1,-1],se:[1,1,1,1],sw:[0,1,-1,1]},Ip=(e,t)=>{const n=t.dom,o=t.getDoc(),r=document,s=t.getBody();let a,i,l,c,d,m,u,f,g,p,b,y,v,w,S;const E=e=>C(e)&&(us(e)||n.is(e,"figure.image")),x=e=>Cs(e)||n.hasClass(e,"mce-preview-object"),_=e=>{const n=e.target;((e,t)=>{if((e=>"longpress"===e.type||0===e.type.indexOf("touch"))(e)){const n=e.touches[0];return E(e.target)&&!lp(n.clientX,n.clientY,t)}return E(e.target)&&!lp(e.clientX,e.clientY,t)})(e,t.selection.getRng())&&!e.isDefaultPrevented()&&t.selection.select(n)},k=e=>n.hasClass(e,"mce-preview-object")&&C(e.firstElementChild)?[e,e.firstElementChild]:n.is(e,"figure.image")?[e.querySelector("img")]:[e],N=e=>{const o=Zd(t);return!(!o||t.mode.isReadOnly())&&"false"!==e.getAttribute("data-mce-resize")&&e!==t.getBody()&&(n.hasClass(e,"mce-preview-object")&&C(e.firstElementChild)?bn(un.fromDom(e.firstElementChild),o):bn(un.fromDom(e),o))},R=(e,o,r)=>{if(C(r)){const s=k(e);q(s,e=>{_s(e)?((e,t,o)=>{e[t]=o;const r=400;if(e.width>r&&!("width"===t&&o<r))e[t]=o,n.setStyle(e,t,o);else{const o="height"===t?r*(p??1):r;e[t]=o,n.setStyle(e,t,o)}})(e,o,r):e.style[o]||!t.schema.isValid(e.nodeName.toLowerCase(),o)?n.setStyle(e,o,r):n.setAttrib(e,o,""+r)})}},A=(e,t,n)=>{R(e,"width",t),R(e,"height",n)},D=e=>{let o,r,d,h,C;o=e.screenX-m,r=e.screenY-u,y=o*c[2]+f,v=r*c[3]+g,y=y<5?5:y,v=v<5?5:v,d=(E(a)||x(a)||_s(a))&&!1!==Jd(t)?!Tp.modifierPressed(e):Tp.modifierPressed(e),d&&(Pp(o)>Pp(r)?(v=Lp(y*p),y=Lp(v/p)):(y=Lp(v/p),v=Lp(y*p))),A(i,y,v),h=c.startPos.x+o,C=c.startPos.y+r,h=h>0?h:0,C=C>0?C:0,n.setStyles(l,{left:h,top:C,display:"block"}),l.innerHTML=y+" &times; "+v,o=s.scrollWidth-w,r=s.scrollHeight-S,o+r!==0&&n.setStyles(l,{left:h-o,top:C-r}),b||(((e,t,n,o,r)=>{e.dispatch("ObjectResizeStart",{target:t,width:n,height:o,origin:r})})(t,a,f,g,"corner-"+c.name),b=!0)},T=()=>{const e=b;b=!1,e&&(R(a,"width",y),R(a,"height",v)),n.unbind(o,"mousemove",D),n.unbind(o,"mouseup",T),r!==o&&(n.unbind(r,"mousemove",D),n.unbind(r,"mouseup",T)),n.remove(i),n.remove(l),n.remove(d),O(a),e&&(((e,t,n,o,r)=>{e.dispatch("ObjectResized",{target:t,width:n,height:o,origin:r})})(t,a,y,v,"corner-"+c.name),n.setAttrib(a,"style",n.getAttrib(a,"style"))),t.nodeChanged()},O=e=>{if(!e.isConnected)return void P();I();const h=n.getPos(e,s),b=h.x,C=h.y,E=e.getBoundingClientRect(),_=E.width||E.right-E.left,R=E.height||E.bottom-E.top;a!==e&&(P(),a=e,y=v=0);const O=t.dispatch("ObjectSelected",{target:e});N(e)&&!O.isDefaultPrevented()?he(Mp,(e,t)=>{let h=n.get("mceResizeHandle"+t);h&&n.remove(h),h=n.add(s,"div",{id:"mceResizeHandle"+t,"data-mce-bogus":"all",class:"mce-resizehandle",unselectable:!0,style:"cursor:"+t+"-resize; margin:0; padding:0"}),n.bind(h,"mousedown",h=>{h.stopImmediatePropagation(),h.preventDefault(),(h=>{const y=k(a)[0];m=h.screenX,u=h.screenY,f=y.clientWidth,g=y.clientHeight,p=g/f,c=e,c.name=t,c.startPos={x:_*e[0]+b,y:R*e[1]+C},w=s.scrollWidth,S=s.scrollHeight,d=n.add(s,"div",{class:"mce-resize-backdrop","data-mce-bogus":"all"}),n.setStyles(d,{position:"fixed",left:"0",top:"0",width:"100%",height:"100%"}),i=((e,t)=>{if(x(t))return e.create("img",{src:sn.transparentSrc});if(ns(t)){const n=Qe(c.name,"n")?ce:de,o=t.cloneNode(!0);return n(e.select("tr",o)).each(t=>{const n=e.select("td,th",t);e.setStyle(t,"height",null),q(n,t=>e.setStyle(t,"height",null))}),o}return t.cloneNode(!0)})(n,a),n.addClass(i,"mce-clonedresizable"),n.setAttrib(i,"data-mce-bogus","all"),i.contentEditable="false",n.setStyles(i,{left:b,top:C,margin:0}),A(i,_,R),i.removeAttribute(Op),s.appendChild(i),n.bind(o,"mousemove",D),n.bind(o,"mouseup",T),r!==o&&(n.bind(r,"mousemove",D),n.bind(r,"mouseup",T)),l=n.add(s,"div",{class:"mce-resize-helper","data-mce-bogus":"all"},f+" &times; "+g)})(h)}),e.elm=h,n.setStyles(h,{left:_*e[0]+b-h.offsetWidth/2,top:R*e[1]+C-h.offsetHeight/2})}):P(!1)},B=(e=>{let t=null,n=null;return{cancel:()=>{h(t)||(clearTimeout(t),t=null,n=null)},throttle:(...o)=>{n=o,h(t)&&(t=setTimeout(()=>{const o=n;t=null,n=null,e.apply(null,o)},0))}}})(O),P=(e=!0)=>{B.cancel(),I(),a&&e&&a.removeAttribute(Op),he(Mp,(e,t)=>{const o=n.get("mceResizeHandle"+t);o&&(n.unbind(o),n.remove(o))})},L=(e,t)=>n.isChildOf(e,t),M=o=>{if(b||t.removed||t.composing)return;const r="mousedown"===o.type?o.target:e.getNode(),a=fr(un.fromDom(r),Bp).map(e=>e.dom).filter(e=>n.isEditable(e.parentElement)||"IMG"===e.nodeName&&n.isEditable(e)).getOrUndefined(),i=C(a)?n.getAttrib(a,Op,"1"):"1";if(q(n.select(`img[${Op}],hr[${Op}]`),e=>{e.removeAttribute(Op)}),C(a)&&L(a,s)&&Ap(t)){F();const t=e.getStart(!0);if(L(t,a)&&L(e.getEnd(!0),a))return n.setAttrib(a,Op,i),void B.throttle(a)}P()},I=()=>{he(Mp,e=>{e.elm&&(n.unbind(e.elm),delete e.elm)})},F=()=>{try{t.getDoc().execCommand("enableObjectResizing",!1,"false")}catch{}};return t.on("init",()=>{F(),t.on("NodeChange ResizeEditor ResizeWindow ResizeContent drop",M),t.on("keyup compositionend",e=>{a&&"TABLE"===a.nodeName&&M(e)}),t.on("hide blur",P),t.on("contextmenu longpress",_,!0)}),t.on("remove",I),{isResizable:N,showResizeRect:O,hideResizeRect:P,updateResizeRect:M,destroy:()=>{B.cancel(),a=i=d=null}}},Fp=(e,t,n)=>{const o=Ln(un.fromDom(n));return Vr(o.dom,e,t).map(e=>{const t=n.createRange();return t.setStart(e.start.dom,e.soffset),t.setEnd(e.finish.dom,e.foffset),t}).getOrUndefined()},Up=(e,t)=>C(e)&&C(t)&&e.startContainer===t.startContainer&&e.startOffset===t.startOffset&&e.endContainer===t.endContainer&&e.endOffset===t.endOffset,zp=(e,t,n)=>null!==((e,t,n)=>{let o=e;for(;o&&o!==t;){if(n(o))return o;o=o.parentNode}return null})(e,t,n),jp=(e,t,n)=>zp(e,t,e=>e.nodeName===n),$p=(e,t)=>el(e)&&!zp(e,t,Tf),Hp=(e,t,n)=>{const o=t.parentNode;if(o){const r=new Kr(t,e.getParent(o,e.isBlock)||e.getRoot());let s;for(;s=r[n?"prev":"next"]();)if(ms(s))return!0}return!1},Vp=(e,t,n,o,r)=>{const s=e.getRoot(),a=e.schema.getNonEmptyElements(),i=r.parentNode;let l,c;if(!i)return I.none();const d=e.getParent(i,e.isBlock)||s;if(o&&ms(r)&&t&&e.isEmpty(d))return I.some(Kl(i,e.nodeIndex(r)));const m=new Kr(r,d);for(;c=m[o?"prev":"next"]();){if("false"===e.getContentEditableParent(c)||$p(c,s))return I.none();if(ss(c)&&c.data.length>0)return jp(c,s,"A")?I.none():I.some(Kl(c,o?c.data.length:0));if(e.isBlock(c)||a[c.nodeName.toLowerCase()])return I.none();l=c}return ls(l)?I.none():n&&l?I.some(Kl(l,0)):I.none()},qp=(e,t,n,o)=>{const r=e.getRoot();let s,a=!1,i=n?o.startContainer:o.endContainer,l=n?o.startOffset:o.endOffset;const c=Xr(i)&&l===i.childNodes.length,d=e.schema.getNonEmptyElements();let m=n;if(el(i))return I.none();if(Xr(i)&&l>i.childNodes.length-1&&(m=!1),cs(i)&&(i=r,l=0),i===r){if(m&&(s=i.childNodes[l>0?l-1:0],s)){if(el(s))return I.none();if(d[s.nodeName]||ns(s))return I.none()}if(i.hasChildNodes()){if(l=Math.min(!m&&l>0?l-1:l,i.childNodes.length-1),i=i.childNodes[l],l=ss(i)&&c?i.data.length:0,!t&&i===r.lastChild&&ns(i))return I.none();if(((e,t)=>{let n=t;for(;n&&n!==e;){if(ps(n))return!0;n=n.parentNode}return!1})(r,i)||el(i))return I.none();if(Ss(i))return I.none();if(i.hasChildNodes()&&!ns(i)){s=i;const t=new Kr(i,r);do{if(ps(s)||el(s)){a=!1;break}if(ss(s)&&s.data.length>0){l=m?0:s.data.length,i=s,a=!0;break}if(d[s.nodeName.toLowerCase()]&&!ys(s)){l=e.nodeIndex(s),i=s.parentNode,m||l++,a=!0;break}}while(s=m?t.next():t.prev())}}}return t&&(ss(i)&&0===l&&Vp(e,c,t,!0,i).each(e=>{i=e.container(),l=e.offset(),a=!0}),Xr(i)&&(s=i.childNodes[l],s||(s=i.childNodes[l-1]),!s||!ms(s)||(e=>"A"===e.previousSibling?.nodeName)(s)||Hp(e,s,!1)||Hp(e,s,!0)||Vp(e,c,t,!0,s).each(e=>{i=e.container(),l=e.offset(),a=!0}))),m&&!t&&ss(i)&&l===i.data.length&&Vp(e,c,t,!1,i).each(e=>{i=e.container(),l=e.offset(),a=!0}),a&&i?I.some(Kl(i,l)):I.none()},Wp=(e,t)=>{const n=t.collapsed,o=t.cloneRange(),r=Kl.fromRangeStart(t);return qp(e,n,!0,o).each(e=>{n&&Kl.isAbove(r,e)||o.setStart(e.container(),e.offset())}),n||qp(e,n,!1,o).each(e=>{o.setEnd(e.container(),e.offset())}),n&&o.collapse(!0),Up(t,o)?I.none():I.some(o)},Kp=(e,t)=>e.splitText(t),Yp=e=>{let t=e.startContainer,n=e.startOffset,o=e.endContainer,r=e.endOffset;if(t===o&&ss(t)){if(n>0&&n<t.data.length)if(o=Kp(t,n),t=o.previousSibling,r>n){r-=n;const e=Kp(o,r).previousSibling;t=o=e,r=e.data.length,n=0}else r=0}else if(ss(t)&&n>0&&n<t.data.length&&(t=Kp(t,n),n=0),ss(o)&&r>0&&r<o.data.length){const e=Kp(o,r).previousSibling;o=e,r=e.data.length}return{startContainer:t,startOffset:n,endContainer:o,endOffset:r}},Gp=e=>({walk:(t,n)=>Yg(e,t,n),split:Yp,expand:(t,n={type:"word"})=>{if("word"===n.type){const n=Kg(e,t,[{inline:"span"}],{includeTrailingSpace:!1,expandToBlock:!1}),o=e.createRng();return o.setStart(n.startContainer,n.startOffset),o.setEnd(n.endContainer,n.endOffset),o}return t},normalize:t=>Wp(e,t).fold(L,e=>(t.setStart(e.startContainer,e.startOffset),t.setEnd(e.endContainer,e.endOffset),!0))});Gp.compareRanges=Up,Gp.getCaretRangeFromPoint=Fp,Gp.getSelectedNode=pl,Gp.getNode=hl;const Xp=(e,t)=>e.view(t).fold(N([]),t=>{const n=e.owner(t),o=Xp(e,n);return[t].concat(o)});var Qp=Object.freeze({__proto__:null,view:e=>(e.dom===document?I.none():I.from(e.dom.defaultView?.frameElement)).map(un.fromDom),owner:e=>Pn(e)});const Zp=e=>"textarea"===En(e),Jp=(e,t)=>{const n=(e=>{const t=e.dom.ownerDocument,n=t.body,o=t.defaultView,r=t.documentElement;if(n===e.dom)return Go(n.offsetLeft,n.offsetTop);const s=Xo(o?.pageYOffset,r.scrollTop),a=Xo(o?.pageXOffset,r.scrollLeft),i=Xo(r.clientTop,n.clientTop),l=Xo(r.clientLeft,n.clientLeft);return Qo(e).translate(a-l,s-i)})(e),o=(e=>Ko.get(e))(e);return{element:e,bottom:n.top+o,height:o,pos:n,cleanup:t}},eh=(e,t,n,o)=>{rh(e,(r,s)=>nh(e,t,n,o),n)},th=(e,t,n,o,r)=>{const s={elm:o.element.dom,alignToTop:r};((e,t)=>e.dispatch("ScrollIntoView",t).isDefaultPrevented())(e,s)||(n(e,t,Zo(t).top,o,r),((e,t)=>{e.dispatch("AfterScrollIntoView",t)})(e,s))},nh=(e,t,n,o)=>{const r=un.fromDom(e.getBody()),s=un.fromDom(e.getDoc());r.dom.offsetWidth;const a=((e,t)=>{const n=((e,t)=>{const n=Vn(e);if(0===n.length||Zp(e))return{element:e,offset:t};if(t<n.length&&!Zp(n[t]))return{element:n[t],offset:0};{const o=n[n.length-1];return Zp(o)?{element:e,offset:t}:"img"===En(o)?{element:o,offset:1}:An(o)?{element:o,offset:or(o).length}:{element:o,offset:Vn(o).length}}})(e,t),o=un.fromHtml('<span data-mce-bogus="all" style="display: inline-block;">\ufeff</span>');return mo(n.element,o),Jp(o,()=>Ro(o))})(un.fromDom(n.startContainer),n.startOffset);th(e,s,t,a,o),a.cleanup()},oh=(e,t,n,o)=>{const r=un.fromDom(e.getDoc());th(e,r,n,(e=>Jp(un.fromDom(e),x))(t),o)},rh=(e,t,n)=>{const o=n.startContainer,r=n.startOffset,s=n.endContainer,a=n.endOffset;t(un.fromDom(o),un.fromDom(s));const i=e.dom.createRng();i.setStart(o,r),i.setEnd(s,a),e.selection.setRng(n)},sh=(e,t,n,o,r)=>{const s=t.pos;if(o)Jo(s.left,Math.max(0,s.top-30),r);else{const o=s.top-n+t.height+30;Jo(-e.getBody().getBoundingClientRect().left,o,r)}},ah=(e,t,n,o,r,s)=>{const a=o+n,i=r.pos.top,l=r.bottom,c=l-i>=o;i<n?sh(e,r,o,!1!==s,t):i>a?sh(e,r,o,c?!1!==s:!0===s,t):l>a&&!c&&sh(e,r,o,!0===s,t)},ih=(e,t,n,o,r)=>{const s=Ln(t).dom.innerHeight;ah(e,t,n,s,o,r)},lh=(e,t,n,o,r)=>{const s=Ln(t).dom.innerHeight;ah(e,t,n,s,o,r);const a=(e=>{const t=ao(),n=Zo(t),o=((e,t)=>{const n=t.owner(e);return Xp(t,n)})(e,Qp),r=Qo(e),s=G(o,(e,t)=>{const n=Qo(t);return{left:e.left+n.left,top:e.top+n.top}},{left:0,top:0});return Go(s.left+r.left+n.left,s.top+r.top+n.top)})(o.element),i=Wr(window);a.top<i.y?er(o.element,!1!==r):a.top>i.bottom&&er(o.element,!0===r)},ch=(e,t,n)=>eh(e,ih,t,n),dh=(e,t,n)=>oh(e,t,ih,n),mh=(e,t,n)=>eh(e,lh,t,n),uh=(e,t,n)=>oh(e,t,lh,n),fh=(e,t,n)=>{(e.inline?ch:mh)(e,t,n)},gh=(e,t)=>t.collapsed?e.isEditable(t.startContainer):e.isEditable(t.startContainer)&&e.isEditable(t.endContainer),ph=(e,t,n,o,r)=>{const s=n?t.startContainer:t.endContainer,a=n?t.startOffset:t.endOffset;return I.from(s).map(un.fromDom).map(e=>o&&t.collapsed?e:qn(e,r(e,a)).getOr(e)).bind(e=>Rn(e)?I.some(e):Mn(e).filter(Rn)).map(e=>e.dom).getOr(e)},hh=(e,t,n=!1)=>ph(e,t,!0,n,(e,t)=>Math.min(Yn(e),t)),bh=(e,t,n=!1)=>ph(e,t,!1,n,(e,t)=>t>0?t-1:t),yh=(e,t)=>{const n=e;for(;e&&ss(e)&&0===e.length;)e=t?e.nextSibling:e.previousSibling;return e||n},vh=(e,t)=>V(t,t=>{const n=e.dispatch("GetSelectionRange",{range:t});return n.range!==t?n.range:t}),Ch={"#text":3,"#comment":8,"#cdata":4,"#pi":7,"#doctype":10,"#document-fragment":11},wh=(e,t,n)=>{const o=n?"lastChild":"firstChild",r=n?"prev":"next";if(e[o])return e[o];if(e!==t){let n=e[r];if(n)return n;for(let o=e.parent;o&&o!==t;o=o.parent)if(n=o[r],n)return n}},Sh=e=>{const t=e.value??"";if(!Ns(t))return!1;const n=e.parent;return!n||"span"===n.name&&!n.attr("style")||!/^[ ]+$/.test(t)},Eh=e=>{const t="a"===e.name&&!e.attr("href")&&e.attr("id");return e.attr("name")||e.attr("id")&&!e.firstChild||e.attr("data-mce-bookmark")||t};class xh{static create(e,t){const n=new xh(e,Ch[e]||1);return t&&he(t,(e,t)=>{n.attr(t,e)}),n}name;type;attributes;value;parent;firstChild;lastChild;next;prev;raw;constructor(e,t){this.name=e,this.type=t,1===t&&(this.attributes=[],this.attributes.map={})}replace(e){const t=this;return e.parent&&e.remove(),t.insert(e,t),t.remove(),t}attr(e,t){const n=this;if(!u(e))return C(e)&&he(e,(e,t)=>{n.attr(t,e)}),n;const o=n.attributes;if(o){if(void 0!==t){if(null===t){if(e in o.map){delete o.map[e];let t=o.length;for(;t--;)if(o[t].name===e)return o.splice(t,1),n}return n}if(e in o.map){let n=o.length;for(;n--;)if(o[n].name===e){o[n].value=t;break}}else o.push({name:e,value:t});return o.map[e]=t,n}return o.map[e]}}clone(){const e=this,t=new xh(e.name,e.type),n=e.attributes;if(n){const e=[];e.map={};for(let t=0,o=n.length;t<o;t++){const o=n[t];"id"!==o.name&&(e[e.length]={name:o.name,value:o.value},e.map[o.name]=o.value)}t.attributes=e}return t.value=e.value,t}wrap(e){const t=this;return t.parent&&(t.parent.insert(e,t),e.append(t)),t}unwrap(){const e=this;for(let t=e.firstChild;t;){const n=t.next;e.insert(t,e,!0),t=n}e.remove()}remove(){const e=this,t=e.parent,n=e.next,o=e.prev;return t&&(t.firstChild===e?(t.firstChild=n,n&&(n.prev=null)):o&&(o.next=n),t.lastChild===e?(t.lastChild=o,o&&(o.next=null)):n&&(n.prev=o),e.parent=e.next=e.prev=null),e}append(e){const t=this;e.parent&&e.remove();const n=t.lastChild;return n?(n.next=e,e.prev=n,t.lastChild=e):t.lastChild=t.firstChild=e,e.parent=t,e}insert(e,t,n){e.parent&&e.remove();const o=t.parent||this;return n?(t===o.firstChild?o.firstChild=e:t.prev&&(t.prev.next=e),e.prev=t.prev,e.next=t,t.prev=e):(t===o.lastChild?o.lastChild=e:t.next&&(t.next.prev=e),e.next=t.next,e.prev=t,t.next=e),e.parent=o,e}getAll(e){const t=this,n=[];for(let o=t.firstChild;o;o=wh(o,t))o.name===e&&n.push(o);return n}children(){const e=[];for(let t=this.firstChild;t;t=t.next)e.push(t);return e}empty(){const e=this;if(e.firstChild){const t=[];for(let n=e.firstChild;n;n=wh(n,e))t.push(n);let n=t.length;for(;n--;){const e=t[n];e.parent=e.firstChild=e.lastChild=e.next=e.prev=null}}return e.firstChild=e.lastChild=null,e}isEmpty(e,t={},n){const o=this;let r=o.firstChild;if(Eh(o))return!1;if(r)do{if(1===r.type){if(r.attr("data-mce-bogus"))continue;if(e[r.name])return!1;if(Eh(r))return!1}if(8===r.type)return!1;if(3===r.type&&!Sh(r))return!1;if(3===r.type&&r.parent&&t[r.parent.name]&&Ns(r.value??""))return!1;if(n&&n(r))return!1}while(r=wh(r,o));return!0}walk(e){return wh(this,null,e)}}const _h=dn.makeMap("NOSCRIPT STYLE SCRIPT XMP IFRAME NOEMBED NOFRAMES PLAINTEXT"," "),kh=e=>u(e.nodeValue)&&e.nodeValue.includes(Ki),Nh=e=>(0===e.length?"":`${V(e,e=>`[${e}]`).join(",")},`)+'[data-mce-bogus="all"]',Rh=e=>document.createTreeWalker(e,NodeFilter.SHOW_COMMENT,e=>kh(e)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_SKIP),Ah=e=>document.createTreeWalker(e,NodeFilter.SHOW_TEXT,e=>{if(kh(e)){const t=e.parentNode;return t&&_e(_h,t.nodeName)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_SKIP}return NodeFilter.FILTER_SKIP}),Dh=e=>null!==Rh(e).nextNode(),Th=e=>null!==Ah(e).nextNode(),Oh=(e,t)=>null!==t.querySelector(Nh(e)),Bh=(e,t)=>{q(((e,t)=>t.querySelectorAll(Nh(e)))(e,t),t=>{const n=un.fromDom(t);"all"===wo(n,"data-mce-bogus")?Ro(n):q(e,e=>{Eo(n,e)&&xo(n,e)})})},Ph=e=>{let t=e.nextNode();for(;null!==t;)t.nodeValue=null,t=e.nextNode()},Lh=_(Ph,Rh),Mh=_(Ph,Ah),Ih=(e,t)=>{const n=[{condition:D(Oh,t),action:D(Bh,t)},{condition:Dh,action:Lh},{condition:Th,action:Mh}];let o=e,r=!1;return q(n,({condition:t,action:n})=>{t(o)&&(r||(o=e.cloneNode(!0),r=!0),n(o))}),o},Fh=e=>{const t=Rr(e,"[data-mce-bogus]");q(t,e=>{"all"===wo(e,"data-mce-bogus")?Ro(e):Mi(e)?(mo(e,un.fromText(ct)),Ro(e)):Ao(e)})},Uh=e=>{const t=Rr(e,"input");q(t,e=>{xo(e,"name")})},zh=(e,t,n)=>{let o;return o="raw"===t.format?dn.trim(Gi(Ih(n,e.serializer.getTempAttrs()).innerHTML)):"text"===t.format?((e,t)=>{const n=e.getDoc(),o=Qn(un.fromDom(e.getBody())),r=un.fromTag("div",n);vo(r,"data-mce-bogus","all"),jo(r,{position:"fixed",left:"-9999999px",top:"0"}),Mo(r,t.innerHTML),Fh(r),Uh(r);const s=(e=>Xn(e)?e:un.fromDom(Pn(e).dom.body))(o);go(s,r);const a=Gi(r.dom.innerText);return Ro(r),a})(e,n):"tree"===t.format?e.serializer.serialize(n,t):((e,t)=>{const n=new RegExp(`^(<${e}[^>]*>(&nbsp;|&#160;|\\s|\xa0|<br \\/>|)<\\/${e}>[\r\n]*|<br \\/>[\r\n]*)$`);return t.replace(n,"")})(Ed(e),e.serializer.serialize(n,t)),"text"!==t.format&&!Vi(un.fromDom(n))&&u(o)?dn.trim(o):o},jh=dn.makeMap,$h=e=>{const t=[],n=(e=e||{}).indent,o=jh(e.indent_before||""),r=jh(e.indent_after||""),s=Sa.getEncodeFunc(e.entity_encoding||"raw",e.entities),a="xhtml"!==e.element_format;return{start:(e,i,l)=>{if(n&&o[e]&&t.length>0){const e=t[t.length-1];e.length>0&&"\n"!==e&&t.push("\n")}if(t.push("<",e),i)for(let e=0,n=i.length;e<n;e++){const n=i[e];t.push(" ",n.name,'="',s(n.value,!0),'"')}if(t[t.length]=!l||a?">":" />",l&&n&&r[e]&&t.length>0){const e=t[t.length-1];e.length>0&&"\n"!==e&&t.push("\n")}},end:e=>{let o;t.push("</",e,">"),n&&r[e]&&t.length>0&&(o=t[t.length-1],o.length>0&&"\n"!==o&&t.push("\n"))},text:(e,n)=>{e.length>0&&(t[t.length]=n?e:s(e))},cdata:e=>{t.push("<![CDATA[",e,"]]>")},comment:e=>{t.push("\x3c!--",e,"--\x3e")},pi:(e,o)=>{o?t.push("<?",e," ",s(o),"?>"):t.push("<?",e,"?>"),n&&t.push("\n")},doctype:e=>{t.push("<!DOCTYPE",e,">",n?"\n":"")},reset:()=>{t.length=0},getContent:()=>t.join("").replace(/\n$/,"")}},Hh=(e={},t=Ua())=>{const n=$h(e);return e.validate=!("validate"in e)||e.validate,{serialize:o=>{const r=e.validate,s={3:e=>{n.text(e.value??"",e.raw)},8:e=>{n.comment(e.value??"")},7:e=>{n.pi(e.name,e.value)},10:e=>{n.doctype(e.value??"")},4:e=>{n.cdata(e.value??"")},11:e=>{let t=e;if(t=t.firstChild)do{a(t)}while(t=t.next)}};n.reset();const a=e=>{const o=s[e.type];if(o)o(e);else{const o=e.name,s=o in t.getVoidElements();let i=e.attributes;if(r&&i&&i.length>1){const n=[];n.map={};const o=t.getElementRule(e.name);if(o){for(let e=0,t=o.attributesOrder.length;e<t;e++){const t=o.attributesOrder[e];if(t in i.map){const e=i.map[t];n.map[t]=e,n.push({name:t,value:e})}}for(let e=0,t=i.length;e<t;e++){const t=i[e].name;if(!(t in n.map)){const e=i.map[t];n.map[t]=e,n.push({name:t,value:e})}}i=n}}if(n.start(o,i,s),Fs(o))u(e.value)&&n.text(e.value,!0),n.end(o);else if(!s){let t=e.firstChild;if(t){"pre"!==o&&"textarea"!==o||3!==t.type||"\n"!==t.value?.[0]||n.text("\n",!0);do{a(t)}while(t=t.next)}n.end(o)}}};return 1!==o.type||e.inner?3===o.type?s[3](o):s[11](o):a(o),n.getContent()}}},Vh=new Set;q(["margin","margin-left","margin-right","margin-top","margin-bottom","padding","padding-left","padding-right","padding-top","padding-bottom","border","border-width","border-style","border-color","background","background-attachment","background-clip","background-image","background-origin","background-position","background-repeat","background-size","float","position","left","right","top","bottom","z-index","display","transform","width","max-width","min-width","height","max-height","min-height","overflow","overflow-x","overflow-y","text-overflow","vertical-align","transition","transition-delay","transition-duration","transition-property","transition-timing-function"],e=>{Vh.add(e)});const qh=new Set;q(["background-color"],e=>{qh.add(e)});const Wh=["font","text-decoration","text-emphasis"],Kh=(e,t)=>ge(((e,t)=>e.parseStyle(e.getAttrib(t,"style")))(e,t)),Yh=(e,t)=>H(Kh(e,t),e=>(e=>Vh.has(e))(e)),Gh=(e,t,n)=>I.from(n.container()).filter(ss).exists(o=>{const r=e?0:-1;return t(o.data.charAt(n.offset()+r))}),Xh=D(Gh,!0,Kf),Qh=D(Gh,!1,Kf),Zh=e=>{const t=e.container();return ss(t)&&(0===t.data.length||Yi(t.data)&&ip.isBookmarkNode(t.parentNode))},Jh=(e,t)=>n=>Gu(e?0:-1,n).filter(t).isSome(),eb=e=>us(e)&&"block"===$o(un.fromDom(e),"display"),tb=e=>ps(e)&&!(e=>Xr(e)&&"all"===e.getAttribute("data-mce-bogus"))(e),nb=Jh(!0,eb),ob=Jh(!1,eb),rb=Jh(!0,Cs),sb=Jh(!1,Cs),ab=Jh(!0,ns),ib=Jh(!1,ns),lb=Jh(!0,tb),cb=Jh(!1,tb),db=(e,t)=>((e,t,n)=>Cn(t,e)?Fn(e,e=>n(e)||vn(e,t)).slice(0,-1):[])(e,t,L),mb=(e,t)=>[e].concat(db(e,t)),ub=(e,t,n)=>xf(e,t,n,Zh),fb=(e,t,n)=>Z(mb(un.fromDom(t.container()),e),(e=>t=>e.isBlock(En(t)))(n)),gb=(e,t,n,o)=>ub(e,t.dom,n).forall(e=>fb(t,n,o).fold(()=>!Yu(e,n,t.dom),o=>!Yu(e,n,t.dom)&&Cn(o,un.fromDom(e.container())))),pb=(e,t,n,o)=>fb(t,n,o).fold(()=>ub(e,t.dom,n).forall(e=>!Yu(e,n,t.dom)),t=>ub(e,t.dom,n).isNone()),hb=D(pb,!1),bb=D(pb,!0),yb=D(gb,!1),vb=D(gb,!0),Cb=e=>rf(e).exists(Mi),wb=(e,t,n,o)=>{const r=Y(mb(un.fromDom(n.container()),t),e=>o.isBlock(En(e))),s=ce(r).getOr(t);return Sf(e,s.dom,n).filter(Cb)},Sb=(e,t,n)=>rf(t).exists(Mi)||wb(!0,e,t,n).isSome(),Eb=(e,t,n)=>(e=>I.from(e.getNode(!0)).map(un.fromDom))(t).exists(Mi)||wb(!1,e,t,n).isSome(),xb=D(wb,!1),_b=D(wb,!0),kb=e=>Kl.isTextPosition(e)&&!e.isAtStart()&&!e.isAtEnd(),Nb=(e,t,n)=>{const o=Y(mb(un.fromDom(t.container()),e),e=>n.isBlock(En(e)));return ce(o).getOr(e)},Rb=(e,t,n)=>kb(t)?Qh(t):Qh(t)||Nf(Nb(e,t,n).dom,t).exists(Qh),Ab=(e,t,n)=>kb(t)?Xh(t):Xh(t)||kf(Nb(e,t,n).dom,t).exists(Xh),Db=e=>rf(e).bind(e=>lr(e,Rn)).exists(e=>(e=>$(["pre","pre-wrap"],e))($o(e,"white-space"))),Tb=(e,t)=>n=>{return o=new Kr(n,e)[t](),C(o)&&ps(o)&&Iu(o);var o},Ob=(e,t,n)=>!Db(t)&&(((e,t,n)=>((e,t)=>Nf(e.dom,t).isNone())(e,t)||((e,t)=>kf(e.dom,t).isNone())(e,t)||hb(e,t,n)||bb(e,t,n)||Eb(e,t,n)||Sb(e,t,n))(e,t,n)||Rb(e,t,n)||Ab(e,t,n)),Bb=(e,t,n)=>!Db(t)&&(hb(e,t,n)||yb(e,t,n)||Eb(e,t,n)||Rb(e,t,n)||((e,t)=>{const n=Nf(e.dom,t).getOr(t),o=Tb(e.dom,"prev");return t.isAtStart()&&(o(t.container())||o(n.container()))})(e,t)),Pb=(e,t,n)=>!Db(t)&&(bb(e,t,n)||vb(e,t,n)||Sb(e,t,n)||Ab(e,t,n)||((e,t)=>{const n=kf(e.dom,t).getOr(t),o=Tb(e.dom,"next");return t.isAtEnd()&&(o(t.container())||o(n.container()))})(e,t)),Lb=(e,t,n)=>Bb(e,t,n)||Pb(e,(e=>{const t=e.container(),n=e.offset();return ss(t)&&n<t.data.length?Kl(t,n+1):e})(t),n),Mb=(e,t)=>qf(e.charAt(t)),Ib=(e,t)=>Kf(e.charAt(t)),Fb=(e,t,n,o)=>{const r=t.data,s=Kl(t,0);return n||!Mb(r,0)||Lb(e,s,o)?!!(n&&Ib(r,0)&&Bb(e,s,o))&&(t.data=dt+r.slice(1),!0):(t.data=" "+r.slice(1),!0)},Ub=(e,t,n,o)=>{const r=t.data,s=Kl(t,r.length-1);return n||!Mb(r,r.length-1)||Lb(e,s,o)?!!(n&&Ib(r,r.length-1)&&Pb(e,s,o))&&(t.data=r.slice(0,-1)+dt,!0):(t.data=r.slice(0,-1)+" ",!0)},zb=(e,t,n)=>{const o=t.container();if(!ss(o))return I.none();if((e=>{const t=e.container();return ss(t)&&Xe(t.data,dt)})(t)){const r=Fb(e,o,!1,n)||(e=>{const t=e.data,n=(e=>{const t=e.split("");return V(t,(e,n)=>qf(e)&&n>0&&n<t.length-1&&Yf(t[n-1])&&Yf(t[n+1])?" ":e).join("")})(t);return n!==t&&(e.data=n,!0)})(o)||Ub(e,o,!1,n);return He(r,t)}if(Lb(e,t,n)){const r=Fb(e,o,!0,n)||Ub(e,o,!0,n);return He(r,t)}return I.none()},jb=(e,t,n,o)=>{if(0===n)return;const r=un.fromDom(e),s=ir(r,e=>o.isBlock(En(e))).getOr(r),a=e.data.slice(t,t+n),i=t+n>=e.data.length&&Pb(s,Kl(e,e.data.length),o),l=0===t&&Bb(s,Kl(e,0),o);e.replaceData(t,n,As(a,4,l,i))},$b=(e,t,n)=>{const o=e.data.slice(t),r=o.length-tt(o).length;jb(e,t,r,n)},Hb=(e,t,n)=>{const o=e.data.slice(0,t),r=o.length-nt(o).length;jb(e,t-r,r,n)},Vb=(e,t,n,o,r=!0)=>{const s=nt(e.data).length,a=r?e:t,i=r?t:e;return r?a.appendData(i.data):a.insertData(0,i.data),Ro(un.fromDom(i)),o&&$b(a,s,n),a},qb=(e,t)=>((e,t)=>{const n=e.container(),o=e.offset();return!Kl.isTextPosition(e)&&n===t.parentNode&&o>Kl.before(t).offset()})(t,e)?Kl(t.container(),t.offset()-1):t,Wb=e=>{return Nl(e.previousSibling)?I.some((t=e.previousSibling,ss(t)?Kl(t,t.data.length):Kl.after(t))):e.previousSibling?Af(e.previousSibling):I.none();var t},Kb=e=>{return Nl(e.nextSibling)?I.some((t=e.nextSibling,ss(t)?Kl(t,0):Kl.before(t))):e.nextSibling?Rf(e.nextSibling):I.none();var t},Yb=(e,t,n)=>((e,t,n)=>e?((e,t)=>Kb(t).orThunk(()=>Wb(t)).orThunk(()=>((e,t)=>kf(e,Kl.after(t)).orThunk(()=>Nf(e,Kl.before(t))))(e,t)))(t,n):((e,t)=>Wb(t).orThunk(()=>Kb(t)).orThunk(()=>((e,t)=>I.from(t.previousSibling?t.previousSibling:t.parentNode).bind(t=>Nf(e,Kl.before(t))).orThunk(()=>kf(e,Kl.after(t))))(e,t)))(t,n))(e,t,n).map(D(qb,n)),Gb=(e,t,n)=>{n.fold(()=>{e.focus()},n=>{e.selection.setRng(n.toRange(),t)})},Xb=(e,t)=>t&&_e(e.schema.getBlockElements(),En(t)),Qb=(e,t,n,o=!0,r=!1)=>{const s=Yb(t,e.getBody(),n.dom),a=ir(n,D(Xb,e),(i=e.getBody(),e=>e.dom===i));var i;const l=((e,t,n,o)=>{const r=zn(e).filter(An),s=jn(e).filter(An);return Ro(e),(a=r,i=s,l=t,c=(e,t,r)=>{const s=e.dom,a=t.dom,i=s.data.length;return Vb(s,a,n,o),r.container()===a?Kl(s,i):r},a.isSome()&&i.isSome()&&l.isSome()?I.some(c(a.getOrDie(),i.getOrDie(),l.getOrDie())):I.none()).orThunk(()=>(o&&(r.each(e=>Hb(e.dom,e.dom.length,n)),s.each(e=>$b(e.dom,0,n))),t));var a,i,l,c})(n,s,e.schema,((e,t)=>_e(e.schema.getTextInlineElements(),En(t)))(e,n));e.dom.isEmpty(e.getBody())?(e.setContent(""),e.selection.setCursorLocation()):a.bind(t=>((e,t,n)=>{if(Ls(e,t)){const e=un.fromHtml('<br data-mce-bogus="1">');return n?q(Vn(t),e=>{Tg(e)||Ro(e)}):No(t),go(t,e),I.some(Kl.before(e.dom))}return I.none()})(e.schema,t,r)).fold(()=>{o&&Gb(e,t,l)},n=>{o&&Gb(e,t,I.some(n))})},Zb=/[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/,Jb=(e,t)=>bn(un.fromDom(t),Qd(e))&&!Zs(e.schema,t)&&e.dom.isEditable(t),ey=e=>"rtl"===gi.DOM.getStyle(e,"direction",!0)||(e=>Zb.test(e))(e.textContent??""),ty=(e,t,n)=>{const o=((e,t,n)=>Y(gi.DOM.getParents(n.container(),"*",t),e))(e,t,n);return I.from(o[o.length-1])},ny=(e,t)=>{const n=t.container(),o=t.offset();return e?Ji(n)?ss(n.nextSibling)?Kl(n.nextSibling,0):Kl.after(n):nl(t)?Kl(n,o+1):t:Ji(n)?ss(n.previousSibling)?Kl(n.previousSibling,n.previousSibling.data.length):Kl.before(n):ol(t)?Kl(n,o-1):t},oy=D(ny,!0),ry=D(ny,!1),sy=(e,t)=>{const n=e=>e.stopImmediatePropagation();e.on("beforeinput input",n,!0),e.getDoc().execCommand(t),e.off("beforeinput input",n)},ay=e=>sy(e,"Delete"),iy=e=>sy(e,"ForwardDelete"),ly=e=>Ui(e)||ji(e),cy=(e,t)=>Cn(e,t)?lr(t,ly,(e=>t=>ze(Mn(t),e,vn))(e)):I.none(),dy=(e,t=!0)=>{e.dom.isEmpty(e.getBody())&&e.setContent("",{no_selection:!t})},my=(e,t,n)=>$e(Rf(n),Af(n),(o,r)=>{const s=ny(!0,o),a=ny(!1,r),i=ny(!1,t);return e?kf(n,i).exists(e=>e.isEqual(a)&&t.isEqual(s)):Nf(n,i).exists(e=>e.isEqual(s)&&t.isEqual(a))}).getOr(!0),uy=e=>(kn(e)?zn(e):Kn(e)).bind(uy).orThunk(()=>I.some(e)),fy=(e,t,n,o=!0)=>{t.deleteContents();const r=uy(n).getOr(n),s=un.fromDom(e.dom.getParent(r.dom,e.dom.isBlock)??n.dom);if(s.dom===e.getBody()?dy(e,o):Ls(e.schema,s,{checkRootAsContent:!1})&&(Wi(s),o&&e.selection.setCursorLocation(s.dom,0)),!vn(n,s)){const t=ze(Mn(s),n)?[]:Un(s);q(t.concat(Vn(n)),t=>{vn(t,s)||Cn(t,s)||!Ls(e.schema,t)||Ro(t)})}},gy=e=>Rr(e,"td,th"),py=(e,t)=>Zf(un.fromDom(e),t),hy=(e,t)=>({start:e,end:t}),by=Ne([{singleCellTable:["rng","cell"]},{fullTable:["table"]},{partialTable:["cells","outsideDetails"]},{multiTable:["startTableCells","endTableCells","betweenRng"]}]),yy=(e,t)=>fr(un.fromDom(e),"td,th",t),vy=e=>!vn(e.start,e.end),Cy=(e,t)=>Zf(e.start,t).bind(n=>Zf(e.end,t).bind(e=>He(vn(n,e),n))),wy=e=>t=>Cy(t,e).map(e=>((e,t,n)=>({rng:e,table:t,cells:n}))(t,e,gy(e))),Sy=(e,t,n,o)=>{if(n.collapsed||!e.forall(vy))return I.none();if(t.isSameTable){const t=e.bind(wy(o));return I.some({start:t,end:t})}{const e=yy(n.startContainer,o),t=yy(n.endContainer,o),r=e.bind((e=>t=>Zf(t,e).bind(e=>de(gy(e)).map(e=>hy(t,e))))(o)).bind(wy(o)),s=t.bind((e=>t=>Zf(t,e).bind(e=>ce(gy(e)).map(e=>hy(e,t))))(o)).bind(wy(o));return I.some({start:r,end:s})}},Ey=(e,t)=>J(e,e=>vn(e,t)),xy=e=>$e(Ey(e.cells,e.rng.start),Ey(e.cells,e.rng.end),(t,n)=>e.cells.slice(t,n+1)),_y=(e,t)=>{const{startTable:n,endTable:o}=t,r=e.cloneRange();return n.each(e=>r.setStartAfter(e.dom)),o.each(e=>r.setEndBefore(e.dom)),r},ky=(e,t)=>{const n=(e=>t=>vn(e,t))(e),o=((e,t)=>{const n=yy(e.startContainer,t),o=yy(e.endContainer,t);return $e(n,o,hy)})(t,n),r=((e,t)=>{const n=py(e.startContainer,t),o=py(e.endContainer,t),r=n.isSome(),s=o.isSome(),a=$e(n,o,vn).getOr(!1);return(e=>$e(e.startTable,e.endTable,(t,n)=>{const o=Dr(t,e=>vn(e,n)),r=Dr(n,e=>vn(e,t));return o||r?{...e,startTable:o?I.none():e.startTable,endTable:r?I.none():e.endTable,isSameTable:!1,isMultiTable:!1}:e}).getOr(e))({startTable:n,endTable:o,isStartInTable:r,isEndInTable:s,isSameTable:a,isMultiTable:!a&&r&&s})})(t,n);return((e,t,n)=>e.exists(e=>((e,t)=>!vy(e)&&Cy(e,t).exists(e=>{const t=e.dom.rows;return 1===t.length&&1===t[0].cells.length}))(e,n)&&tg(e.start,t)))(o,t,n)?o.map(e=>by.singleCellTable(t,e.start)):r.isMultiTable?((e,t,n,o)=>Sy(e,t,n,o).bind(({start:e,end:o})=>{const r=e.bind(xy).getOr([]),s=o.bind(xy).getOr([]);if(r.length>0&&s.length>0){const e=_y(n,t);return I.some(by.multiTable(r,s,e))}return I.none()}))(o,r,t,n):((e,t,n,o)=>Sy(e,t,n,o).bind(({start:e,end:t})=>e.or(t)).bind(e=>{const{isSameTable:o}=t,r=xy(e).getOr([]);if(o&&e.cells.length===r.length)return I.some(by.fullTable(e.table));if(r.length>0){if(o)return I.some(by.partialTable(r,I.none()));{const e=_y(n,t);return I.some(by.partialTable(r,I.some({...t,rng:e})))}}return I.none()}))(o,r,t,n)},Ny=e=>q(e,e=>{xo(e,"contenteditable"),Wi(e)}),Ry=(e,t,n,o)=>{const r=n.cloneRange();o?(r.setStart(n.startContainer,n.startOffset),r.setEndAfter(t.dom.lastChild)):(r.setStartBefore(t.dom.firstChild),r.setEnd(n.endContainer,n.endOffset)),Oy(e,r,t,!1).each(e=>e())},Ay=e=>{const t=Qf(e),n=un.fromDom(e.selection.getNode());bs(n.dom)&&Ls(e.schema,n)?e.selection.setCursorLocation(n.dom,0):e.selection.collapse(!0),t.length>1&&H(t,e=>vn(e,n))&&vo(n,"data-mce-selected","1")},Dy=(e,t,n)=>I.some(()=>{const o=e.selection.getRng(),r=n.bind(({rng:n,isStartInTable:r})=>{const s=((e,t)=>I.from(e.dom.getParent(t,e.dom.isBlock)).map(un.fromDom))(e,r?n.endContainer:n.startContainer);n.deleteContents(),((e,t,n)=>{n.each(n=>{t?Ro(n):(Wi(n),e.selection.setCursorLocation(n.dom,0))})})(e,r,s.filter(D(Ls,e.schema)));const a=r?t[0]:t[t.length-1];return Ry(e,a,o,r),Ls(e.schema,a)?I.none():I.some(r?t.slice(1):t.slice(0,-1))}).getOr(t);Ny(r),Ay(e)}),Ty=(e,t,n,o)=>I.some(()=>{const r=e.selection.getRng(),s=t[0],a=n[n.length-1];Ry(e,s,r,!0),Ry(e,a,r,!1);const i=Ls(e.schema,s)?t:t.slice(1),l=Ls(e.schema,a)?n:n.slice(0,-1);Ny(i.concat(l)),o.deleteContents(),Ay(e)}),Oy=(e,t,n,o=!0)=>I.some(()=>{fy(e,t,n,o)}),By=(e,t)=>I.some(()=>Qb(e,!1,t)),Py=(e,t)=>Z(mb(t,e),Hi),Ly=(e,t)=>Z(mb(t,e),On("caption")),My=(e,t)=>I.some(()=>{Wi(t),e.selection.setCursorLocation(t.dom,0)}),Iy=(e,t)=>e?ab(t):ib(t),Fy=(e,t,n)=>{const o=un.fromDom(e.getBody());return Ly(o,n).fold(()=>((e,t,n,o)=>{const r=Kl.fromRangeStart(e.selection.getRng());return Py(n,o).bind(o=>Ls(e.schema,o,{checkRootAsContent:!1})?My(e,o):((e,t,n,o,r)=>Ef(n,e.getBody(),r).bind(e=>Py(t,un.fromDom(e.getNode())).bind(e=>vn(e,o)?I.none():I.some(x))))(e,n,t,o,r))})(e,t,o,n).orThunk(()=>He(((e,t)=>{const n=Kl.fromRangeStart(e.selection.getRng());return Iy(t,n)||Sf(t,e.getBody(),n).exists(e=>Iy(t,e))})(e,t),x)),n=>((e,t,n,o)=>{const r=Kl.fromRangeStart(e.selection.getRng());return Ls(e.schema,o)?My(e,o):((e,t,n,o,r)=>Ef(n,e.getBody(),r).fold(()=>I.some(x),s=>((e,t,n,o)=>Rf(e.dom).bind(r=>Af(e.dom).map(e=>t?n.isEqual(r)&&o.isEqual(e):n.isEqual(e)&&o.isEqual(r))).getOr(!0))(o,n,r,s)?((e,t)=>My(e,t))(e,o):((e,t,n)=>Ly(e,un.fromDom(n.getNode())).fold(()=>I.some(x),e=>He(!vn(e,t),x)))(t,o,s)))(e,n,t,o,r)})(e,t,o,n))},Uy=(e,t)=>{const n=un.fromDom(e.selection.getStart(!0)),o=Qf(e);return e.selection.isCollapsed()&&0===o.length?Fy(e,t,n):((e,t,n)=>{const o=un.fromDom(e.getBody()),r=e.selection.getRng();return 0!==n.length?Dy(e,n,I.none()):((e,t,n,o)=>Ly(t,o).fold(()=>((e,t,n)=>ky(t,n).bind(t=>t.fold(D(Oy,e),D(By,e),D(Dy,e),D(Ty,e))))(e,t,n),t=>((e,t)=>My(e,t))(e,t)))(e,o,r,t)})(e,n,o)},zy=(e,t)=>{let n=t;for(;n&&n!==e;){if(gs(n)||ps(n))return n;n=n.parentNode}return null},jy=["data-ephox-","data-mce-","data-alloy-","data-snooker-","_"],$y=dn.each,Hy=e=>{const t=e.dom,n=new Set(e.serializer.getTempAttrs()),o=e=>H(jy,t=>Qe(e,t))||n.has(e);return{compare:(e,n)=>{if(e.nodeName!==n.nodeName||e.nodeType!==n.nodeType)return!1;const r=e=>{const n={};return $y(t.getAttribs(e),r=>{const s=r.nodeName.toLowerCase();"style"===s||o(s)||(n[s]=t.getAttrib(e,s))}),n},s=(e,t)=>{for(const n in e)if(_e(e,n)){const o=t[n];if(y(o))return!1;if(e[n]!==o)return!1;delete t[n]}for(const e in t)if(_e(t,e))return!1;return!0};if(Xr(e)&&Xr(n)){if(!s(r(e),r(n)))return!1;if(!s(t.parseStyle(t.getAttrib(e,"style")),t.parseStyle(t.getAttrib(n,"style"))))return!1}return!Vf(e)&&!Vf(n)},isAttributeInternal:o}},Vy=(e,t)=>{if(ss(e))return{container:e,offset:t};const n=Gp.getNode(e,t);return ss(n)?{container:n,offset:t>=e.childNodes.length?n.data.length:0}:n.previousSibling&&ss(n.previousSibling)?{container:n.previousSibling,offset:n.previousSibling.data.length}:n.nextSibling&&ss(n.nextSibling)?{container:n.nextSibling,offset:0}:{container:e,offset:t}},qy=gi.DOM,Wy=()=>qy.create("span",{"data-mce-type":"bookmark"}),Ky=(e,t,n)=>{if(Xr(e)){const o=n();return e.hasChildNodes()?t===e.childNodes.length?e.appendChild(o):e.insertBefore(o,e.childNodes[t]):e.appendChild(o),{container:o,offset:0}}return{container:e,offset:t}},Yy=(e,t)=>{if(Xr(e)&&C(e.parentNode)){const n=e;t=(e=>{let t=e.parentNode?.firstChild,n=0;for(;t;){if(t===e)return n;Xr(t)&&"bookmark"===t.getAttribute("data-mce-type")||n++,t=t.nextSibling}return-1})(e),e=e.parentNode,qy.remove(n),!e.hasChildNodes()&&qy.isBlock(e)&&e.appendChild(qy.create("br"))}return{container:e,offset:t}},Gy=(e,t,n,o)=>{const r=qy.createRng();return r.setStart(e,t),r.setEnd(n,o),(e=>{const t=e.cloneRange(),n=Vy(e.startContainer,e.startOffset);t.setStart(n.container,n.offset);const o=Vy(e.endContainer,e.endOffset);return t.setEnd(o.container,o.offset),t})(r)},Xy=(e,t=Wy)=>{const{container:n,offset:o}=Ky(e.startContainer,e.startOffset,t);if(e.collapsed)return{startContainer:n,startOffset:o};{const{container:r,offset:s}=Ky(e.endContainer,e.endOffset,t);return{startContainer:n,startOffset:o,endContainer:r,endOffset:s}}},Qy=e=>{const{container:t,offset:n}=Yy(e.startContainer,e.startOffset);if(y(e.endContainer)||y(e.endOffset))return Gy(t,n,t,n);{const{container:o,offset:r}=Yy(e.endContainer,e.endOffset);return Gy(t,n,o,r)}},Zy=(e,t,n,o)=>{if(dn.each(n.styles,(n,r)=>{e.setStyle(t,r,yg(n,o))}),n.styles){const n=e.getAttrib(t,"style");n&&e.setAttrib(t,"data-mce-style",n)}},Jy=(e,t,n,o,r)=>{const s=e.dom;w(n.onformat)&&n.onformat(t,n,o,r),Zy(s,t,n,o),dn.each(n.attributes,(e,n)=>{s.setAttrib(t,n,yg(e,o))}),dn.each(n.classes,e=>{const n=yg(e,o);s.hasClass(t,n)||s.addClass(t,n)})},ev=vg,tv=(e,t,n)=>{const o=e.formatter.get(n);if(o)for(let n=0;n<o.length;n++){const r=o[n];if(Ng(r)&&!1===r.inherit&&e.dom.is(t,r.selector))return!0}return!1},nv=(e,t,n,o,r)=>{const s=e.dom.getRoot();if(t===s)return!1;const a=e.dom.getParent(t,t=>!!tv(e,t,n)||t.parentNode===s||!!sv(e,t,n,o,!0));return!!sv(e,a,n,o,r)},ov=(e,t,n)=>!(!Rg(n)||!ev(t,n.inline))||!(!_g(n)||!ev(t,n.block))||!!Ng(n)&&Xr(t)&&e.is(t,n.selector),rv=(e,t,n,o,r,s)=>{const a=n[o],i="attributes"===o;if(w(n.onmatch))return n.onmatch(t,n,o);if(a)if(ft(a)){for(let n=0;n<a.length;n++)if(i?e.getAttrib(t,a[n]):wg(e,t,a[n]))return!0}else for(const o in a)if(_e(a,o)){const l=i?e.getAttrib(t,o):wg(e,t,o),c=yg(a[o],s),d=v(l)||rt(l);if(d&&v(c))continue;if(r&&d&&!n.exact)return!1;if((!r||n.exact)&&!ev(l,Cg(c,o)))return!1}return!0},sv=(e,t,n,o,r)=>{const s=e.formatter.get(n),a=e.dom;if(s&&Xr(t))for(let n=0;n<s.length;n++){const i=s[n];if(ov(e.dom,t,i)&&rv(a,t,i,"attributes",r,o)&&rv(a,t,i,"styles",r,o)){const n=i.classes;if(n)for(let r=0;r<n.length;r++)if(!e.dom.hasClass(t,yg(n[r],o)))return;return i}}},av=(e,t,n,o,r)=>C(sv(e,t,n,o,r))||H(me(t.childNodes),t=>av(e,t,n,o,r)),iv=(e,t,n,o,r)=>{const s=e.dom;return!(!Xr(t)||"false"!==s.getContentEditable(t)||bg(e,t))&&H(hg(s,t),t=>av(e,t,n,o,r))},lv=(e,t,n,o,r)=>{if(o)return nv(e,o,t,n,r)||iv(e,o,t,n,r);if(o=e.selection.getNode(),nv(e,o,t,n,r)||iv(e,o,t,n,r))return!0;const s=e.selection.getStart();return!(s===o||!nv(e,s,t,n,r))},cv=Ki,dv=e=>{if(e){const t=new Kr(e,e);for(let e=t.current();e;e=t.next())if(ss(e))return e}return null},mv=e=>{const t=un.fromTag("span");return Co(t,{id:Df,"data-mce-bogus":"1","data-mce-type":"format-caret"}),e&&go(t,un.fromText(cv)),t},uv=(e,t,n)=>{const o=e.dom,r=e.selection;if(Dg(t))Qb(e,!1,un.fromDom(t),n,!0);else{const e=r.getRng(),n=o.getParent(t,o.isBlock),s=e.startContainer,a=e.startOffset,i=e.endContainer,l=e.endOffset,c=(e=>{const t=dv(e);return t&&t.data.charAt(0)===cv&&t.deleteData(0,1),t})(t);o.remove(t,!0),s===c&&a>0&&e.setStart(c,a-1),i===c&&l>0&&e.setEnd(c,l-1),n&&o.isEmpty(n)&&Wi(un.fromDom(n)),r.setRng(e)}},fv=(e,t)=>e.nextSibling===t||e.previousSibling===t,gv=(e,t,n)=>e===t||e===n||fv(e,t)||fv(e,n),pv=(e,t,n)=>{const o=e.dom,r=e.selection;if(t)uv(e,t,n);else if(!(t=Of(e.getBody(),r.getStart()))){const n=e.selection.getRng().startContainer,r=e.selection.getRng().endContainer;for(;t=o.get(Df);)uv(e,t,gv(t,n,r))}},hv=(e,t)=>(e.appendChild(t),t),bv=(e,t)=>{const n=G(e,(e,t)=>hv(e,t.cloneNode(!1)),t),o=n.ownerDocument??document;return hv(n,o.createTextNode(cv))},yv=e=>rr(e,or(e).replace(new RegExp(`${dt}$`)," ")),vv=(e,t)=>{const n=()=>{null===t||e.dom.isEmpty(t)||zn(un.fromDom(t)).each(e=>{An(e)?yv(e):dr(e,e=>An(e)).each(e=>{An(e)&&yv(e)})})};e.once("input",t=>{t.data&&!Kf(t.data)&&(t.isComposing?e.once("compositionend",()=>{n()}):n())})},Cv=(e,t,n,o)=>{const a=e.dom,i=e.selection;let l=!1;const c=e.formatter.get(t);if(!c)return;const d=i.getRng(),m=d.startContainer,u=d.startOffset;let f=m;ss(m)&&(u!==m.data.length&&(l=!0),f=f.parentNode);const g=[];let h;for(;f;){if(sv(e,f,t,n,o)){h=f;break}f.nextSibling&&(l=!0),g.push(f),f=f.parentNode}if(h)if(l){const r=i.getBookmark();d.collapse(!0);let s=Kg(a,d,c,{includeTrailingSpace:!0});s=Yp(s),e.formatter.remove(t,n,s,o),i.moveToBookmark(r)}else{const l=Of(e.getBody(),h),c=C(l)?a.getParents(h.parentNode,M,l):[],d=mv(!1).dom;((e,t,n)=>{const o=e.dom,r=o.getParent(n,D(ug,e.schema));r&&o.isEmpty(r)?n.parentNode?.replaceChild(t,n):((e=>{const t=Rr(e,"br"),n=Y((e=>{const t=[];let n=e.dom;for(;n;)t.push(un.fromDom(n)),n=n.lastChild;return t})(e).slice(-1),Mi);t.length===n.length&&q(n,Ro)})(un.fromDom(n)),o.isEmpty(n)?n.parentNode?.replaceChild(t,n):o.insertAfter(t,n))})(e,d,l??h);const m=((e,t,n,o,a,i)=>{const l=e.formatter,c=e.dom,d=Y(ge(l.get()),e=>e!==o&&!Xe(e,"removeformat")),m=((e,t,n)=>X(n,(n,o)=>{const r=((e,t)=>xg(e,t,e=>{const t=e=>w(e)||e.length>1&&"%"===e.charAt(0);return H(["styles","attributes"],n=>xe(e,n).exists(e=>{const n=p(e)?e:Ee(e);return H(n,t)}))}))(e,o);return e.formatter.matchNode(t,o,{},r)?n.concat([o]):n},[]))(e,n,d);if(Y(m,t=>!((e,t,n)=>{const o=["inline","block","selector","attributes","styles","classes"],a=e=>we(e,(e,t)=>H(o,e=>e===t));return xg(e,t,t=>{const o=a(t);return xg(e,n,e=>{const t=a(e);return((e,t,n=s)=>r(n).eq(e,t))(o,t)})})})(e,t,o)).length>0){const e=n.cloneNode(!1);return c.add(t,e),l.remove(o,a,e,i),c.remove(e),I.some(e)}return I.none()})(e,d,h,t,n,o),u=bv([...g,...m.toArray(),...c],d);l&&uv(e,l,C(l)),i.setCursorLocation(u,1),vv(e,d),a.isEmpty(h)&&a.remove(h)}},wv=e=>{const t=mv(!1),n=bv(e,t.dom);return{caretContainer:t,caretPosition:Kl(n,0)}},Sv=(e,t)=>{const{caretContainer:n,caretPosition:o}=wv(t);return mo(un.fromDom(e),n),Ro(un.fromDom(e)),o},Ev=(e,t)=>{if(Tf(t.dom))return!1;const n=e.schema.getTextInlineElements();return _e(n,En(t))&&!Tf(t.dom)&&!ts(t.dom)},xv=["fontWeight","fontStyle","color","fontSize","fontFamily"],_v=(e,t)=>{const n=e.get(t);return p(n)?Z(n,e=>Rg(e)&&"span"===e.inline&&(e=>f(e.styles)&&H(ge(e.styles),e=>$(xv,e)))(e)):I.none()},kv=(e,t)=>Nf(t,Kl.fromRangeStart(e)).isNone(),Nv=(e,t)=>!1===kf(t,Kl.fromRangeEnd(e)).exists(e=>!ms(e.getNode())||kf(t,e).isSome()),Rv=e=>t=>ws(t)&&e.isEditable(t),Av=(e,t)=>V(e.getSelectedBlocks(),(n,o)=>0===o&&t(n)?e.dom.getParent(n,ws)??n:n),Dv=e=>{const t=Qf(e);if(t.length>0){const e=ne(t,e=>Rr(e,"li"));return I.some(V(e,e=>e.dom))}return I.none()},Tv=e=>{const t=Dv(e).getOrThunk(()=>Av(e.selection,e=>!ws(e)));return Y(t,Rv(e.selection.dom))},Ov=dn.each,Bv=e=>Xr(e)&&!Vf(e)&&!Tf(e)&&!ts(e),Pv=(e,t)=>{for(let n=e;n;n=n[t]){if(ss(n)&&ot(n.data))return e;if(Xr(n)&&!Vf(n))return n}return e},Lv=(e,t,n)=>{const o=Hy(e),r=Qr(t)&&e.dom.isEditable(t),s=Qr(n)&&e.dom.isEditable(n);if(r&&s){const r=Pv(t,"previousSibling"),s=Pv(n,"nextSibling");if(o.compare(r,s)){for(let e=r.nextSibling;e&&e!==s;){const t=e;e=e.nextSibling,r.appendChild(t)}return e.dom.remove(s),dn.each(dn.grep(s.childNodes),e=>{r.appendChild(e)}),r}}return n},Mv=(e,t,n,o)=>{if(o&&!1!==t.merge_siblings){const t=Lv(e,mg(o),o)??o;Lv(e,t,mg(t,!0))}},Iv=(e,t,n)=>{Ov(e.childNodes,e=>{Bv(e)&&(t(e)&&n(e),e.hasChildNodes()&&Iv(e,t,n))})},Fv=(e,t)=>n=>!(!n||!wg(e,n,t)),Uv=(e,t,n)=>o=>{e.setStyle(o,t,n),""===o.getAttribute("style")&&o.removeAttribute("style"),((e,t)=>{"SPAN"===t.nodeName&&0===e.getAttribs(t).length&&e.remove(t,!0)})(e,o)},zv=Ne([{keep:[]},{rename:["name"]},{removed:[]}]),jv=/^(src|href|style)$/,$v=dn.each,Hv=vg,Vv=(e,t,n)=>e.isChildOf(t,n)&&t!==n&&!e.isBlock(n),qv=(e,t,n)=>{let o=t[n?"startContainer":"endContainer"],r=t[n?"startOffset":"endOffset"];if(Xr(o)){const e=o.childNodes.length-1;!n&&r&&r--,o=o.childNodes[r>e?e:r]}return ss(o)&&n&&r>=o.data.length&&(o=new Kr(o,e.getBody()).next()||o),ss(o)&&!n&&0===r&&(o=new Kr(o,e.getBody()).prev()||o),o},Wv=(e,t)=>{const n=t?"firstChild":"lastChild",o=e[n];return(e=>/^(TR|TH|TD)$/.test(e.nodeName))(e)&&o?"TR"===e.nodeName&&o[n]||o:e},Kv=(e,t,n,o)=>{const r=e.create(n,o);return t.parentNode?.insertBefore(r,t),r.appendChild(t),r},Yv=(e,t,n,o,r)=>{const s=un.fromDom(t),a=un.fromDom(e.create(o,r)),i=n?Hn(s):$n(s);return bo(a,i),n?(mo(s,a),fo(a,s)):(uo(s,a),go(a,s)),a.dom},Gv=(e,t,n)=>{const o=t.parentNode;let r;const s=e.dom,a=Ed(e);_g(n)&&o===s.getRoot()&&(n.list_block&&Hv(t,n.list_block)||q(me(t.childNodes),t=>{fg(e,a,t.nodeName.toLowerCase())?r?r.appendChild(t):(r=Kv(s,t,a),s.setAttribs(r,xd(e))):r=null})),(e=>Ng(e)&&Rg(e)&&ze(xe(e,"mixed"),!0))(n)&&!Hv(n.inline,t)||s.remove(t,!0)},Xv=(e,t,n)=>S(e)?{name:t,value:null}:{name:e,value:yg(t,n)},Qv=(e,t)=>{""===e.getAttrib(t,"style")&&(t.removeAttribute("style"),t.removeAttribute("data-mce-style"))},Zv=(e,t,n,o,r)=>{let s=!1;$v(n.styles,(a,i)=>{const{name:l,value:c}=Xv(i,a,o),d=Cg(c,l);(n.remove_similar||h(c)||!Xr(r)||Hv(wg(e,r,l),d))&&e.setStyle(t,l,""),s=!0}),s&&Qv(e,t)},Jv=(e,t,n,o,r)=>{const s=e.dom,a=Hy(e),i=e.schema;if(Rg(t)&&Xs(i,t.inline)&&Zs(i,o)&&o.parentElement===e.getBody())return Gv(e,o,t),zv.removed();if(!t.ceFalseOverride&&o&&"false"===s.getContentEditableParent(o))return zv.keep();if(o&&!ov(s,o,t)&&!((e,t)=>t.links&&"A"===e.nodeName)(o,t))return zv.keep();const l=o,c=t.preserve_attributes;if(Rg(t)&&"all"===t.remove&&p(c)){const e=Y(s.getAttribs(l),e=>$(c,e.name.toLowerCase()));if(s.removeAllAttribs(l),q(e,e=>s.setAttrib(l,e.name,e.value)),e.length>0)return zv.rename("span")}if("all"!==t.remove){Zv(s,l,t,n,r),$v(t.attributes,(e,o)=>{const{name:a,value:i}=Xv(o,e,n);if(t.remove_similar||h(i)||!Xr(r)||Hv(s.getAttrib(r,a),i)){if("class"===a){const e=s.getAttrib(l,a);if(e){let t="";if(q(e.split(/\s+/),e=>{/mce\-\w+/.test(e)&&(t+=(t?" ":"")+e)}),t)return void s.setAttrib(l,a,t)}}if(jv.test(a)&&l.removeAttribute("data-mce-"+a),"style"===a&&Jr(["li"])(l)&&"none"===s.getStyle(l,"list-style-type"))return l.removeAttribute(a),void s.setStyle(l,"list-style-type","none");"class"===a&&l.removeAttribute("className"),l.removeAttribute(a)}}),$v(t.classes,e=>{e=yg(e,n),Xr(r)&&!s.hasClass(r,e)||s.removeClass(l,e)});const e=s.getAttribs(l);for(let t=0;t<e.length;t++){const n=e[t].nodeName;if(!a.isAttributeInternal(n))return zv.keep()}}return"none"!==t.remove?(Gv(e,l,t),zv.removed()):zv.keep()},eC=(e,t,n,o)=>Jv(e,t,n,o,o).fold(N(o),t=>(e.dom.createFragment().appendChild(o),e.dom.rename(o,t)),N(null)),tC=(e,t,n,o,r)=>{(o||e.selection.isEditable())&&((e,t,n,o,r)=>{const s=e.formatter.get(t),a=s[0],i=e.dom,l=e.selection,c=o=>{const i=((e,t,n,o,r)=>{let s;return t.parentNode&&q(Eg(e.dom,t.parentNode).reverse(),t=>{if(!s&&Xr(t)&&"_start"!==t.id&&"_end"!==t.id){const a=sv(e,t,n,o,r);a&&!1!==a.split&&(s=t)}}),s})(e,o,t,n,r);return((e,t,n,o,r,s,a,i)=>{let l,c;const d=e.dom;if(n){const s=n.parentNode;for(let n=o.parentNode;n&&n!==s;n=n.parentNode){let o=d.clone(n,!1);for(let n=0;n<t.length&&(o=eC(e,t[n],i,o),null!==o);n++);o&&(l&&o.appendChild(l),c||(c=o),l=o)}a.mixed&&d.isBlock(n)||(o=d.split(n,o)??o),l&&c&&(r.parentNode?.insertBefore(l,r),c.appendChild(r),Rg(a)&&Mv(e,a,0,l))}return o})(e,s,i,o,o,0,a,n)},d=t=>H(s,o=>nC(e,o,n,t,t)),m=t=>{const n=me(t.childNodes),o=d(t)||H(s,e=>ov(i,t,e)),r=t.parentNode;if(!o&&C(r)&&Ag(a)&&d(r),a.deep&&n.length)for(let e=0;e<n.length;e++)m(n[e]);q(["underline","line-through","overline"],n=>{Xr(t)&&e.dom.getStyle(t,"text-decoration")===n&&t.parentNode&&Sg(i,t.parentNode)===n&&nC(e,{deep:!1,exact:!0,inline:"span",styles:{textDecoration:n}},void 0,t)})},u=e=>{const t=i.get(e?"_start":"_end");if(t){let n=t[e?"firstChild":"lastChild"];return(e=>Vf(e)&&Xr(e)&&("_start"===e.id||"_end"===e.id))(n)&&(n=n[e?"firstChild":"lastChild"]),ss(n)&&0===n.data.length&&(n=e?t.previousSibling||t.nextSibling:t.nextSibling||t.previousSibling),i.remove(t,!0),n}return null},f=t=>{let n,o,r=Kg(i,t,s,{includeTrailingSpace:t.collapsed});if(a.split){if(r=Yp(r),n=qv(e,r,!0),o=qv(e,r),n!==o){if(n=Wv(n,!0),o=Wv(o,!1),Vv(i,n,o)){const e=I.from(n.firstChild).getOr(n);return c(Yv(i,e,!0,"span",{id:"_start","data-mce-type":"bookmark"})),void u(!0)}if(Vv(i,o,n)){const e=I.from(o.lastChild).getOr(o);return c(Yv(i,e,!1,"span",{id:"_end","data-mce-type":"bookmark"})),void u(!1)}n=Kv(i,n,"span",{id:"_start","data-mce-type":"bookmark"}),o=Kv(i,o,"span",{id:"_end","data-mce-type":"bookmark"});const e=i.createRng();e.setStartAfter(n),e.setEndBefore(o),Yg(i,e,e=>{q(e,e=>{Vf(e)||Vf(e.parentNode)||c(e)})}),c(n),c(o),n=u(!0),o=u()}else n=o=c(n);r.startContainer=n.parentNode?n.parentNode:n,r.startOffset=i.nodeIndex(n),r.endContainer=o.parentNode?o.parentNode:o,r.endOffset=i.nodeIndex(o)+1}Yg(i,r,e=>{q(e,m)})};if(o){if(ig(o)){const e=i.createRng();e.setStartBefore(o),e.setEndAfter(o),f(e)}else f(o);rd(e,t,o,n)}else l.isCollapsed()&&Rg(a)&&!Qf(e).length?Cv(e,t,n,r):(cg(e,()=>rg(e,f),o=>Rg(a)&&lv(e,t,n,o)),e.nodeChanged()),((e,t,n)=>{"removeformat"===t?q(Tv(e),t=>{q(xv,n=>e.dom.setStyle(t,n,"")),Qv(e.dom,t)}):_v(e.formatter,t).each(t=>{q(Tv(e),o=>Zv(e.dom,o,t,n,null))})})(e,t,n),rd(e,t,o,n)})(e,t,n,o,r)},nC=(e,t,n,o,r)=>Jv(e,t,n,o,r).fold(L,t=>(e.dom.rename(o,t),!0),M),oC=["fontsize","subscript","superscript"],rC=["strikethrough",...oC],sC=(e,t)=>H(oC,n=>((e,t,n)=>C(e.matchNode(t.dom,n,{},"fontsize"===n)))(e,t,n)),aC=(e,t,n,o,r)=>{const s=t=>vn(un.fromDom(e.getRoot()),t)||e.isBlock(t.dom);q(t,t=>{((e,t,n,o,r)=>{const s=Fn(t,e).filter(Rn);return(a=s,i=n,ee(a,i).map(e=>e.i)).map(e=>{const t=s[e];return{container:t,innerWrapper:o(t),outerWrappers:[...r(To(t)).toArray(),...ne(s.slice(0,e),e=>n(e)?r(e).toArray():[To(e)])]}});var a,i})(s,t,n,o,r).each(({container:o,innerWrapper:s,outerWrappers:a})=>{e.split(o.dom,t.dom),((e,t,n,o)=>{q(Vn(e),e=>{Rn(e)&&n(e)&&o(e).isNone()&&Ao(e)}),q(Vn(e),e=>go(t,e)),fo(e,t)})(t,s,n,r),((e,t)=>{if(t.length>0){const n=t[t.length-1];mo(e,n);const o=X(t.slice(0,t.length-1),(e,t)=>(go(e,t),t),n);go(o,e)}})(t,a)})})},iC=(e,t,n)=>{const o=Xy(e.selection.getRng());aC(e.dom,n,n=>C(sv(e,n.dom,t)),n=>{const o=un.fromTag(En(n)),r=sv(e,n.dom,t,{});return C(r)&&(e=>!p(e.attributes)&&!p(e.styles))(r)&&Jy(e,o.dom,r),o},n=>{const o=sv(e,n.dom,t,{});return C(o)?((e,t,n,o)=>Jv(e,t,{},o).fold(()=>I.some(o),t=>I.some(e.dom.rename(o,t)),I.none))(e,o,0,n.dom).map(un.fromDom):I.some(n)}),e.selection.setRng(Qy(o))},lC=e=>["h1","h2","h3","h4","h5","h6"].includes(e.name),cC=(e,t,n,o)=>{const r=n.name;for(let t=0,s=e.length;t<s;t++){const s=e[t];if(s.name===r){const e=o.nodes[r];e?e.nodes.push(n):o.nodes[r]={filter:s,nodes:[n]}}}if(n.attributes)for(let e=0,r=t.length;e<r;e++){const r=t[e],s=r.name;if(s in n.attributes.map){const e=o.attributes[s];e?e.nodes.push(n):o.attributes[s]={filter:r,nodes:[n]}}}},dC=(e,t)=>{const n=(e,n)=>{he(e,e=>{const o=me(e.nodes);q(e.filter.callbacks,r=>{for(let t=o.length-1;t>=0;t--){const r=o[t];(n?void 0!==r.attr(e.filter.name):r.name===e.filter.name)&&!v(r.parent)||o.splice(t,1)}o.length>0&&r(o,e.filter.name,t)})})};n(e.nodes,!1),n(e.attributes,!0)},mC=(e,t,n,o={})=>{const r=((e,t,n)=>{const o={nodes:{},attributes:{}};return n.firstChild&&((e,t)=>{let n=e;for(;n=n.walk();)t(n)})(n,n=>{cC(e,t,n,o)}),o})(e,t,n);dC(r,o)},uC=(e,t,n,o)=>{if((e.pad_empty_with_br||t.insert)&&n(o)){const e=new xh("br",1);t.insert&&e.attr("data-mce-bogus","1"),o.empty().append(e)}else o.empty().append(new xh("#text",3)).value=dt},fC=(e,t)=>{const n=e?.firstChild;return C(n)&&n===e.lastChild&&n.name===t},gC=(e,t,n,o)=>o.isEmpty(t,n,t=>((e,t)=>{const n=e.getElementRule(t.name);return!0===n?.paddEmpty})(e,t)),pC=e=>{let t;for(let n=e;n;n=n.parent){const e=n.attr("contenteditable");if("false"===e)break;"true"===e&&(t=n)}return I.from(t)},hC=(e,t,n=e.parent)=>{if(t.getSpecialElements()[e.name])e.empty().remove();else{const o=e.children();for(const e of o)n&&!t.isValidChild(n.name,e.name)&&hC(e,t,n);e.unwrap()}},bC=(e,t,n,o=x)=>{const r=t.getTextBlockElements(),s=t.getNonEmptyElements(),a=t.getWhitespaceElements(),i=dn.makeMap("tr,td,th,tbody,thead,tfoot,table,summary"),l=new Set,c=e=>e!==n&&!i[e.name];for(let n=0;n<e.length;n++){const i=e[n];let d,m,u;if(!i.parent||l.has(i))continue;if(r[i.name]&&"li"===i.parent.name){let e=i.next;for(;e&&r[e.name];)e.name="li",l.add(e),i.parent.insert(e,i.parent),e=e.next;i.unwrap();continue}const f=[i];for(d=i.parent;d&&!t.isValidChild(d.name,i.name)&&c(d);d=d.parent)f.push(d);if(d&&f.length>1)if(yC(t,i,d))hC(i,t);else{f.reverse(),m=f[0].clone(),o(m);let e=m;for(let n=0;n<f.length-1;n++){t.isValidChild(e.name,f[n].name)&&n>0?(u=f[n].clone(),o(u),e.append(u)):u=e;for(let e=f[n].firstChild;e&&e!==f[n+1];){const t=e.next;u.append(e),e=t}e=u}gC(t,s,a,m)?d.insert(i,f[0],!0):(d.insert(m,f[0],!0),d.insert(i,m)),d=f[0],(gC(t,s,a,d)||fC(d,"br"))&&d.empty().remove()}else if(i.parent){if("li"===i.name){let e=i.prev;if(e&&("ul"===e.name||"ol"===e.name)){e.append(i);continue}if(e=i.next,e&&("ul"===e.name||"ol"===e.name)&&e.firstChild){e.insert(i,e.firstChild,!0);continue}const t=new xh("ul",1);o(t),i.wrap(t);continue}if(t.isValidChild(i.parent.name,"div")&&t.isValidChild("div",i.name)){const e=new xh("div",1);o(e),i.wrap(e)}else hC(i,t)}}},yC=(e,t,n=t.parent)=>!(!n||(!e.children[t.name]||e.isValidChild(n.name,t.name))&&("a"!==t.name||!(e=>{let t=e;for(;t;){if("a"===t.name)return!0;t=t.parent}return!1})(n))&&(!(e=>"summary"===e.name)(n)||!lC(t)||n?.firstChild===t&&n?.lastChild===t)),vC=e=>e.collapsed?e:(e=>{const t=Kl.fromRangeStart(e),n=Kl.fromRangeEnd(e),o=e.commonAncestorContainer;return Sf(!1,o,n).map(r=>!Yu(t,n,o)&&Yu(t,r,o)?((e,t,n,o)=>{const r=document.createRange();return r.setStart(e,t),r.setEnd(n,o),r})(t.container(),t.offset(),r.container(),r.offset()):e).getOr(e)})(e),CC=dn.explode,wC=()=>{const e={};return{addFilter:(t,n)=>{q(CC(t),t=>{_e(e,t)||(e[t]={name:t,callbacks:[]}),e[t].callbacks.push(n)})},getFilters:()=>Ee(e),removeFilter:(t,n)=>{q(CC(t),t=>{if(_e(e,t))if(C(n)){const o=e[t],r=Y(o.callbacks,e=>e!==n);r.length>0?o.callbacks=r:delete e[t]}else delete e[t]})}}},SC=e=>e.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&"),EC=(e,t,n)=>{const o=Ga();t.convert_fonts_to_spans&&((e,t,n)=>{e.addNodeFilter("font",e=>{q(e,e=>{const o=t.parse(e.attr("style")),r=e.attr("color"),s=e.attr("face"),a=e.attr("size");r&&(o.color=r),s&&(o["font-family"]=s),a&&st(a).each(e=>{o["font-size"]=n[e-1]}),e.name="span",e.attr("style",t.serialize(o)),(e=>{q(["color","face","size"],t=>{e.attr(t,null)})})(e)})})})(e,o,dn.explode(t.font_size_legacy_values??"")),((e,t,n)=>{e.addNodeFilter("strike",e=>{const o="html4"!==t.type;q(e,e=>{if(o)e.name="s";else{const t=n.parse(e.attr("style"));t["text-decoration"]="line-through",e.name="span",e.attr("style",n.serialize(t))}})})})(e,n,o)},xC=e=>{const[t,...n]=e.split(","),o=n.join(","),r=/data:([^/]+\/[^;]+)(;.+)?/.exec(t);if(r){const e=";base64"===r[2],t=(e=>{try{return decodeURIComponent(e)}catch{return e}})(o),n=e?(e=>{const t=/([a-z0-9+\/=\s]+)/i.exec(e);return t?t[1]:""})(t):t;return I.some({type:r[1],data:n,base64Encoded:e})}return I.none()},_C=(e,t,n=!0)=>{let o=t;if(n)try{o=atob(t)}catch{return I.none()}const r=new Uint8Array(o.length);for(let e=0;e<r.length;e++)r[e]=o.charCodeAt(e);return I.some(new Blob([r],{type:e}))},kC=e=>new Promise((t,n)=>{const o=new FileReader;o.onloadend=()=>{t(o.result)},o.onerror=()=>{n(o.error?.message)},o.readAsDataURL(e)});let NC=0;const RC=(e,t,n)=>xC(e).bind(({data:e,type:o,base64Encoded:r})=>{if(t&&!r)return I.none();{const t=r?e:btoa((s=e,X((new window.TextEncoder).encode(s),(e,t)=>e+String.fromCharCode(t),"")));return n(t,o)}var s}),AC=(e,t,n)=>{const o=e.create("blobid"+NC++,t,n);return e.add(o),o},DC=(e,t,n=!1)=>RC(t,n,(t,n)=>I.from(e.getByData(t,n)).orThunk(()=>_C(n,t).map(n=>AC(e,n,t)))),TC=/^(?:(?:(?:[A-Za-z][A-Za-z\d.+-]{0,14}:\/\/(?:[-.~*+=!&;:'%@?^${}(),\w]+@)?|www\.|[-;:&=+$,.\w]+@)([A-Za-z\d-]+(?:\.[A-Za-z\d-]+)*))(?::\d+)?(?:\/(?:[-.~*+=!;:'%@$(),\/\w]*[-~*+=%@$()\/\w])?)?(?:\?(?:[-.~*+=!&;:'%@?^${}(),\/\w]+)?)?(?:#(?:[-.~*+=!&;:'%@?^${}(),\/\w]+)?)?)$/,OC=e=>I.from(e.match(TC)).bind(e=>le(e,1)).map(e=>Qe(e,"www.")?e.substring(4):e),BC=(e,t)=>{I.from(e.attr("src")).bind(OC).forall(e=>!$(t,e))&&e.attr("sandbox","")},PC=(e,t)=>Qe(e,`${t}/`);
/*! @license DOMPurify 3.4.12 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.12/LICENSE */
function LC(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function MC(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var o,r,s,a,i=[],l=!0,c=!1;try{if(s=(n=n.call(e)).next,0===t);else for(;!(l=(o=s.call(n)).done)&&(i.push(o.value),i.length!==t);l=!0);}catch(e){c=!0,r=e}finally{try{if(!l&&null!=n.return&&(a=n.return(),Object(a)!==a))return}finally{if(c)throw r}}return i}}(e,t)||function(e,t){if(e){if("string"==typeof e)return LC(e,t);var n={}.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?LC(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}const IC=Object.entries,FC=Object.setPrototypeOf,UC=Object.isFrozen,zC=Object.getPrototypeOf,jC=Object.getOwnPropertyDescriptor;let $C=Object.freeze,HC=Object.seal,VC=Object.create,qC="undefined"!=typeof Reflect&&Reflect,WC=qC.apply,KC=qC.construct;$C||($C=function(e){return e}),HC||(HC=function(e){return e}),WC||(WC=function(e,t){for(var n=arguments.length,o=new Array(n>2?n-2:0),r=2;r<n;r++)o[r-2]=arguments[r];return e.apply(t,o)}),KC||(KC=function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];return new e(...n)});const YC=pw(Array.prototype.forEach),GC=pw(Array.prototype.lastIndexOf),XC=pw(Array.prototype.pop),QC=pw(Array.prototype.push),ZC=pw(Array.prototype.splice),JC=Array.isArray,ew=pw(String.prototype.toLowerCase),tw=pw(String.prototype.toString),nw=pw(String.prototype.match),ow=pw(String.prototype.replace),rw=pw(String.prototype.indexOf),sw=pw(String.prototype.trim),aw=pw(Number.prototype.toString),iw=pw(Boolean.prototype.toString),lw="undefined"==typeof BigInt?null:pw(BigInt.prototype.toString),cw="undefined"==typeof Symbol?null:pw(Symbol.prototype.toString),dw=pw(Object.prototype.hasOwnProperty),mw=pw(Object.prototype.toString),uw=pw(RegExp.prototype.test),fw=(gw=TypeError,function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return KC(gw,t)});var gw;function pw(e){return function(t){t instanceof RegExp&&(t.lastIndex=0);for(var n=arguments.length,o=new Array(n>1?n-1:0),r=1;r<n;r++)o[r-1]=arguments[r];return WC(e,t,o)}}function hw(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:ew;if(FC&&FC(e,null),!JC(t))return e;let o=t.length;for(;o--;){let r=t[o];if("string"==typeof r){const e=n(r);e!==r&&(UC(t)||(t[o]=e),r=e)}e[r]=!0}return e}function bw(e){for(let t=0;t<e.length;t++)dw(e,t)||(e[t]=null);return e}function yw(e){const t=VC(null);for(const o of IC(e)){var n=MC(o,2);const r=n[0],s=n[1];dw(e,r)&&(JC(s)?t[r]=bw(s):s&&"object"==typeof s&&s.constructor===Object?t[r]=yw(s):t[r]=s)}return t}function vw(e,t){for(;null!==e;){const n=jC(e,t);if(n){if(n.get)return pw(n.get);if("function"==typeof n.value)return pw(n.value)}e=zC(e)}return function(){return null}}const Cw=$C(["a","abbr","acronym","address","area","article","aside","audio","b","bdi","bdo","big","blink","blockquote","body","br","button","canvas","caption","center","cite","code","col","colgroup","content","data","datalist","dd","decorator","del","details","dfn","dialog","dir","div","dl","dt","element","em","fieldset","figcaption","figure","font","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","img","input","ins","kbd","label","legend","li","main","map","mark","marquee","menu","menuitem","meter","nav","nobr","ol","optgroup","option","output","p","picture","pre","progress","q","rp","rt","ruby","s","samp","search","section","select","shadow","slot","small","source","spacer","span","strike","strong","style","sub","summary","sup","table","tbody","td","template","textarea","tfoot","th","thead","time","tr","track","tt","u","ul","var","video","wbr"]),ww=$C(["svg","a","altglyph","altglyphdef","altglyphitem","animatecolor","animatemotion","animatetransform","circle","clippath","defs","desc","ellipse","enterkeyhint","exportparts","filter","font","g","glyph","glyphref","hkern","image","inputmode","line","lineargradient","marker","mask","metadata","mpath","part","path","pattern","polygon","polyline","radialgradient","rect","stop","style","switch","symbol","text","textpath","title","tref","tspan","view","vkern"]),Sw=$C(["feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feDropShadow","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence"]),Ew=$C(["animate","color-profile","cursor","discard","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","foreignobject","hatch","hatchpath","mesh","meshgradient","meshpatch","meshrow","missing-glyph","script","set","solidcolor","unknown","use"]),xw=$C(["math","menclose","merror","mfenced","mfrac","mglyph","mi","mlabeledtr","mmultiscripts","mn","mo","mover","mpadded","mphantom","mroot","mrow","ms","mspace","msqrt","mstyle","msub","msup","msubsup","mtable","mtd","mtext","mtr","munder","munderover","mprescripts"]),_w=$C(["maction","maligngroup","malignmark","mlongdiv","mscarries","mscarry","msgroup","mstack","msline","msrow","semantics","annotation","annotation-xml","mprescripts","none"]),kw=$C(["#text"]),Nw=$C(["accept","action","align","alt","autocapitalize","autocomplete","autopictureinpicture","autoplay","background","bgcolor","border","capture","cellpadding","cellspacing","checked","cite","class","clear","color","cols","colspan","command","commandfor","controls","controlslist","coords","crossorigin","datetime","decoding","default","dir","disabled","disablepictureinpicture","disableremoteplayback","download","draggable","enctype","enterkeyhint","exportparts","face","for","headers","height","hidden","high","href","hreflang","id","inert","inputmode","integrity","ismap","kind","label","lang","list","loading","loop","low","max","maxlength","media","method","min","minlength","multiple","muted","name","nonce","noshade","novalidate","nowrap","open","optimum","part","pattern","placeholder","playsinline","popover","popovertarget","popovertargetaction","poster","preload","pubdate","radiogroup","readonly","rel","required","rev","reversed","role","rows","rowspan","spellcheck","scope","selected","shape","size","sizes","slot","span","srclang","start","src","srcset","step","style","summary","tabindex","title","translate","type","usemap","valign","value","width","wrap","xmlns"]),Rw=$C(["accent-height","accumulate","additive","alignment-baseline","amplitude","ascent","attributename","attributetype","azimuth","basefrequency","baseline-shift","begin","bias","by","class","clip","clippathunits","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","cx","cy","d","dx","dy","diffuseconstant","direction","display","divisor","dominant-baseline","dur","edgemode","elevation","end","exponent","fill","fill-opacity","fill-rule","filter","filterunits","flood-color","flood-opacity","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-weight","fx","fy","g1","g2","glyph-name","glyphref","gradientunits","gradienttransform","height","href","id","image-rendering","in","in2","intercept","k","k1","k2","k3","k4","kerning","keypoints","keysplines","keytimes","lang","lengthadjust","letter-spacing","kernelmatrix","kernelunitlength","lighting-color","local","marker-end","marker-mid","marker-start","markerheight","markerunits","markerwidth","maskcontentunits","maskunits","max","mask","mask-type","media","method","mode","min","name","numoctaves","offset","operator","opacity","order","orient","orientation","origin","overflow","paint-order","path","pathlength","patterncontentunits","patterntransform","patternunits","points","preservealpha","preserveaspectratio","primitiveunits","r","rx","ry","radius","refx","refy","repeatcount","repeatdur","restart","result","rotate","scale","seed","shape-rendering","slope","specularconstant","specularexponent","spreadmethod","startoffset","stddeviation","stitchtiles","stop-color","stop-opacity","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke","stroke-width","style","surfacescale","systemlanguage","tabindex","tablevalues","targetx","targety","transform","transform-origin","text-anchor","text-decoration","text-orientation","text-rendering","textlength","type","u1","u2","unicode","values","viewbox","visibility","version","vert-adv-y","vert-origin-x","vert-origin-y","width","word-spacing","wrap","writing-mode","xchannelselector","ychannelselector","x","x1","x2","xmlns","y","y1","y2","z","zoomandpan"]),Aw=$C(["accent","accentunder","align","bevelled","close","columnalign","columnlines","columnspacing","columnspan","denomalign","depth","dir","display","displaystyle","encoding","fence","frame","height","href","id","largeop","length","linethickness","lquote","lspace","mathbackground","mathcolor","mathsize","mathvariant","maxsize","minsize","movablelimits","notation","numalign","open","rowalign","rowlines","rowspacing","rowspan","rspace","rquote","scriptlevel","scriptminsize","scriptsizemultiplier","selection","separator","separators","stretchy","subscriptshift","supscriptshift","symmetric","voffset","width","xmlns"]),Dw=$C(["xlink:href","xml:id","xlink:title","xml:space","xmlns:xlink"]),Tw=HC(/{{[\w\W]*|^[\w\W]*}}/g),Ow=HC(/<%[\w\W]*|^[\w\W]*%>/g),Bw=HC(/\${[\w\W]*/g),Pw=HC(/^data-[\-\w.\u00B7-\uFFFF]+$/),Lw=HC(/^aria-[\-\w]+$/),Mw=HC(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),Iw=HC(/^(?:\w+script|data):/i),Fw=HC(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),Uw=HC(/^html$/i),zw=HC(/^[a-z][.\w]*(-[.\w]+)+$/i),jw=HC(/<[/\w!]/g),$w=HC(/<[/\w]/g),Hw=HC(/<\/no(script|embed|frames)/i),Vw=HC(/\/>/i),qw=function(){return"undefined"==typeof window?null:window},Ww=function(e,t,n,o){return dw(e,t)&&JC(e[t])?hw(o.base?yw(o.base):{},e[t],o.transform):n};var Kw=function e(){let t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:qw();const n=t=>e(t);if(n.version="3.4.12",n.removed=[],!t||!t.document||9!==t.document.nodeType||!t.Element)return n.isSupported=!1,n;let o=t.document;const r=o,s=r.currentScript;t.DocumentFragment;const a=t.HTMLTemplateElement,i=t.Node,l=t.Element,c=t.NodeFilter;void 0===t.NamedNodeMap&&(t.NamedNodeMap||t.MozNamedAttrMap),t.HTMLFormElement;const d=t.DOMParser,m=t.trustedTypes,u=l.prototype,f=vw(u,"cloneNode"),g=vw(u,"remove"),p=vw(u,"nextSibling"),h=vw(u,"childNodes"),b=vw(u,"parentNode"),y=vw(u,"shadowRoot"),v=vw(u,"attributes"),C=i&&i.prototype?vw(i.prototype,"nodeType"):null,w=i&&i.prototype?vw(i.prototype,"nodeName"):null;if("function"==typeof a){const e=o.createElement("template");e.content&&e.content.ownerDocument&&(o=e.content.ownerDocument)}let S,E,x="",_=!1,k=0;const N=function(){if(k>0)throw fw('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.')},R=function(e){N(),k++;try{return S.createHTML(e)}finally{k--}},A=o,D=A.implementation,T=A.createNodeIterator,O=A.createDocumentFragment,B=A.getElementsByTagName,P=r.importNode;let L={afterSanitizeAttributes:[],afterSanitizeElements:[],afterSanitizeShadowDOM:[],beforeSanitizeAttributes:[],beforeSanitizeElements:[],beforeSanitizeShadowDOM:[],uponSanitizeAttribute:[],uponSanitizeElement:[],uponSanitizeShadowNode:[]};n.isSupported="function"==typeof IC&&"function"==typeof b&&D&&void 0!==D.createHTMLDocument;const M=Tw,I=Ow,F=Bw,U=Pw,z=Lw,j=Iw,$=Fw,H=zw;let V=Mw,q=null;const W=hw({},[...Cw,...ww,...Sw,...xw,...kw]);let K=null;const Y=hw({},[...Nw,...Rw,...Aw,...Dw]);let G=Object.seal(VC(null,{tagNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},attributeNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},allowCustomizedBuiltInElements:{writable:!0,configurable:!1,enumerable:!0,value:!1}})),X=null,Q=null;const Z=Object.seal(VC(null,{tagCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},attributeCheck:{writable:!0,configurable:!1,enumerable:!0,value:null}}));let J=!0,ee=!0,te=!1,ne=!0,oe=!1,re=!0,se=!1,ae=!1,ie=null,le=null,ce=!1,de=!1,me=!1,ue=!1,fe=!0,ge=!1;const pe="user-content-";let he=!0,be=!1,ye={},ve=null;const Ce=hw({},["annotation-xml","audio","colgroup","desc","foreignobject","head","iframe","math","mi","mn","mo","ms","mtext","noembed","noframes","noscript","plaintext","script","selectedcontent","style","svg","template","thead","title","video","xmp"]);let we=null;const Se=hw({},["audio","video","img","source","image","track"]);let Ee=null;const xe=hw({},["alt","class","for","id","label","name","pattern","placeholder","role","summary","title","value","style","xmlns"]),_e="http://www.w3.org/1998/Math/MathML",ke="http://www.w3.org/2000/svg",Ne="http://www.w3.org/1999/xhtml";let Re=Ne,Ae=!1,De=null;const Te=hw({},[_e,ke,Ne],tw),Oe=$C(["mi","mo","mn","ms","mtext"]);let Be=hw({},Oe);const Pe=$C(["annotation-xml"]);let Le=hw({},Pe);const Me=hw({},["title","style","font","a","script"]);let Ie=null;const Fe=["application/xhtml+xml","text/html"];let Ue=null,ze=null;const je=o.createElement("form"),$e=function(e){return e instanceof RegExp||e instanceof Function},He=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(ze&&ze===e)return;e&&"object"==typeof e||(e={}),e=yw(e),Ie=-1===Fe.indexOf(e.PARSER_MEDIA_TYPE)?"text/html":e.PARSER_MEDIA_TYPE,Ue="application/xhtml+xml"===Ie?tw:ew,q=Ww(e,"ALLOWED_TAGS",W,{transform:Ue}),K=Ww(e,"ALLOWED_ATTR",Y,{transform:Ue}),De=Ww(e,"ALLOWED_NAMESPACES",Te,{transform:tw}),Ee=Ww(e,"ADD_URI_SAFE_ATTR",xe,{transform:Ue,base:xe}),we=Ww(e,"ADD_DATA_URI_TAGS",Se,{transform:Ue,base:Se}),ve=Ww(e,"FORBID_CONTENTS",Ce,{transform:Ue}),X=Ww(e,"FORBID_TAGS",yw({}),{transform:Ue}),Q=Ww(e,"FORBID_ATTR",yw({}),{transform:Ue}),ye=!!dw(e,"USE_PROFILES")&&(e.USE_PROFILES&&"object"==typeof e.USE_PROFILES?yw(e.USE_PROFILES):e.USE_PROFILES),J=!1!==e.ALLOW_ARIA_ATTR,ee=!1!==e.ALLOW_DATA_ATTR,te=e.ALLOW_UNKNOWN_PROTOCOLS||!1,ne=!1!==e.ALLOW_SELF_CLOSE_IN_ATTR,oe=e.SAFE_FOR_TEMPLATES||!1,re=!1!==e.SAFE_FOR_XML,se=e.WHOLE_DOCUMENT||!1,de=e.RETURN_DOM||!1,me=e.RETURN_DOM_FRAGMENT||!1,ue=e.RETURN_TRUSTED_TYPE||!1,ce=e.FORCE_BODY||!1,fe=!1!==e.SANITIZE_DOM,ge=e.SANITIZE_NAMED_PROPS||!1,he=!1!==e.KEEP_CONTENT,be=e.IN_PLACE||!1,V=function(e){try{return uw(e,""),!0}catch(e){return!1}}(e.ALLOWED_URI_REGEXP)?e.ALLOWED_URI_REGEXP:Mw,Re="string"==typeof e.NAMESPACE?e.NAMESPACE:Ne,Be=dw(e,"MATHML_TEXT_INTEGRATION_POINTS")&&e.MATHML_TEXT_INTEGRATION_POINTS&&"object"==typeof e.MATHML_TEXT_INTEGRATION_POINTS?yw(e.MATHML_TEXT_INTEGRATION_POINTS):hw({},Oe),Le=dw(e,"HTML_INTEGRATION_POINTS")&&e.HTML_INTEGRATION_POINTS&&"object"==typeof e.HTML_INTEGRATION_POINTS?yw(e.HTML_INTEGRATION_POINTS):hw({},Pe);const t=dw(e,"CUSTOM_ELEMENT_HANDLING")&&e.CUSTOM_ELEMENT_HANDLING&&"object"==typeof e.CUSTOM_ELEMENT_HANDLING?yw(e.CUSTOM_ELEMENT_HANDLING):VC(null);if(G=VC(null),dw(t,"tagNameCheck")&&$e(t.tagNameCheck)&&(G.tagNameCheck=t.tagNameCheck),dw(t,"attributeNameCheck")&&$e(t.attributeNameCheck)&&(G.attributeNameCheck=t.attributeNameCheck),dw(t,"allowCustomizedBuiltInElements")&&"boolean"==typeof t.allowCustomizedBuiltInElements&&(G.allowCustomizedBuiltInElements=t.allowCustomizedBuiltInElements),HC(G),oe&&(ee=!1),me&&(de=!0),ye&&(q=hw({},kw),K=VC(null),!0===ye.html&&(hw(q,Cw),hw(K,Nw)),!0===ye.svg&&(hw(q,ww),hw(K,Rw),hw(K,Dw)),!0===ye.svgFilters&&(hw(q,Sw),hw(K,Rw),hw(K,Dw)),!0===ye.mathMl&&(hw(q,xw),hw(K,Aw),hw(K,Dw))),Z.tagCheck=null,Z.attributeCheck=null,dw(e,"ADD_TAGS")&&("function"==typeof e.ADD_TAGS?Z.tagCheck=e.ADD_TAGS:JC(e.ADD_TAGS)&&(q===W&&(q=yw(q)),hw(q,e.ADD_TAGS,Ue))),dw(e,"ADD_ATTR")&&("function"==typeof e.ADD_ATTR?Z.attributeCheck=e.ADD_ATTR:JC(e.ADD_ATTR)&&(K===Y&&(K=yw(K)),hw(K,e.ADD_ATTR,Ue))),dw(e,"ADD_URI_SAFE_ATTR")&&JC(e.ADD_URI_SAFE_ATTR)&&hw(Ee,e.ADD_URI_SAFE_ATTR,Ue),dw(e,"FORBID_CONTENTS")&&JC(e.FORBID_CONTENTS)&&(ve===Ce&&(ve=yw(ve)),hw(ve,e.FORBID_CONTENTS,Ue)),dw(e,"ADD_FORBID_CONTENTS")&&JC(e.ADD_FORBID_CONTENTS)&&(ve===Ce&&(ve=yw(ve)),hw(ve,e.ADD_FORBID_CONTENTS,Ue)),he&&(q["#text"]=!0),se&&hw(q,["html","head","body"]),q.table&&(hw(q,["tbody"]),delete X.tbody),e.TRUSTED_TYPES_POLICY){if("function"!=typeof e.TRUSTED_TYPES_POLICY.createHTML)throw fw('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');if("function"!=typeof e.TRUSTED_TYPES_POLICY.createScriptURL)throw fw('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');const t=S;S=e.TRUSTED_TYPES_POLICY;try{x=R("")}catch(e){throw S=t,e}}else null===e.TRUSTED_TYPES_POLICY?(S=void 0,x=""):(void 0===S&&(_||(E=function(e,t){if("object"!=typeof e||"function"!=typeof e.createPolicy)return null;let n=null;const o="data-tt-policy-suffix";t&&t.hasAttribute(o)&&(n=t.getAttribute(o));const r="dompurify"+(n?"#"+n:"");try{return e.createPolicy(r,{createHTML:e=>e,createScriptURL:e=>e})}catch(e){return console.warn("TrustedTypes policy "+r+" could not be created."),null}}(m,s),_=!0),S=E),S&&"string"==typeof x&&(x=R("")));$C&&$C(e),ze=e},Ve=hw({},[...ww,...Sw,...Ew]),qe=hw({},[...xw,..._w]),We=function(e){QC(n.removed,{element:e});try{b(e).removeChild(e)}catch(t){if(g(e),!b(e))throw fw("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place")}},Ke=function(e){Xe(e);const t=h(e);if(t){const e=[];YC(t,t=>{QC(e,t)}),YC(e,e=>{try{g(e)}catch(e){}})}const n=v(e);if(n)for(let t=n.length-1;t>=0;--t){const o=n[t],r=o&&o.name;if("string"==typeof r)try{e.removeAttribute(r)}catch(e){}}},Ye=function(e,t){try{QC(n.removed,{attribute:t.getAttributeNode(e),from:t})}catch(e){QC(n.removed,{attribute:null,from:t})}if(t.removeAttribute(e),"is"===e)if(de||me)try{We(t)}catch(e){}else try{t.setAttribute(e,"")}catch(e){}},Ge=function(e){const t=v(e);if(t)for(let n=t.length-1;n>=0;--n){const o=t[n],r=o&&o.name;if("string"==typeof r&&!K[Ue(r)])try{e.removeAttribute(r)}catch(e){}}},Xe=function(e){const t=[e];for(;t.length>0;){const e=t.pop();1===(C?C(e):e.nodeType)&&Ge(e);const n=h(e);if(n)for(let e=n.length-1;e>=0;--e)t.push(n[e])}},Qe=function(e){let t=null,n=null;if(ce)e="<remove></remove>"+e;else{const t=nw(e,/^[\r\n\t ]+/);n=t&&t[0]}"application/xhtml+xml"===Ie&&Re===Ne&&(e='<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>'+e+"</body></html>");const r=S?R(e):e;if(Re===Ne)try{t=(new d).parseFromString(r,Ie)}catch(e){}if(!t||!t.documentElement){t=D.createDocument(Re,"template",null);try{t.documentElement.innerHTML=Ae?x:r}catch(e){}}const s=t.body||t.documentElement;return e&&n&&s.insertBefore(o.createTextNode(n),s.childNodes[0]||null),Re===Ne?B.call(t,se?"html":"body")[0]:se?t.documentElement:s},Ze=function(e){return T.call(e.ownerDocument||e,e,c.SHOW_ELEMENT|c.SHOW_COMMENT|c.SHOW_TEXT|c.SHOW_PROCESSING_INSTRUCTION|c.SHOW_CDATA_SECTION,null)},Je=function(e){return e=ow(e,M," "),e=ow(e,I," "),ow(e,F," ")},et=function(e){var t;e.normalize();const n=T.call(e.ownerDocument||e,e,c.SHOW_TEXT|c.SHOW_COMMENT|c.SHOW_CDATA_SECTION|c.SHOW_PROCESSING_INSTRUCTION,null);let o=n.nextNode();for(;o;)o.data=Je(o.data),o=n.nextNode();const r=null===(t=e.querySelectorAll)||void 0===t?void 0:t.call(e,"template");r&&YC(r,e=>{nt(e.content)&&et(e.content)})},tt=function(e){const t=w?w(e):null;return"string"==typeof t&&"form"===Ue(t)&&("string"!=typeof e.nodeName||"string"!=typeof e.textContent||"function"!=typeof e.removeChild||e.attributes!==v(e)||"function"!=typeof e.removeAttribute||"function"!=typeof e.setAttribute||"string"!=typeof e.namespaceURI||"function"!=typeof e.insertBefore||"function"!=typeof e.hasChildNodes||e.nodeType!==C(e)||e.childNodes!==h(e))},nt=function(e){if(!C||"object"!=typeof e||null===e)return!1;try{return 11===C(e)}catch(e){return!1}},ot=function(e){if(!C||"object"!=typeof e||null===e)return!1;try{return"number"==typeof C(e)}catch(e){return!1}};function rt(e,t,o){0!==e.length&&YC(e,e=>{e.call(n,t,o,ze)})}const st=function(e,t){if(rt(L.beforeSanitizeElements,e,null),e!==t&&null===b(e))return!0;if(tt(e))return We(e),!0;const o=Ue(w?w(e):e.nodeName);if(rt(L.uponSanitizeElement,e,{tagName:o,allowedTags:q}),e!==t&&null===b(e))return!0;if(function(e,t){return!!(re&&e.hasChildNodes()&&!ot(e.firstElementChild)&&uw(jw,e.textContent)&&uw(jw,e.innerHTML))||!(!re||e.namespaceURI!==Ne||"style"!==t||!ot(e.firstElementChild))||7===e.nodeType||!(!re||8!==e.nodeType||!uw($w,e.data))}(e,o))return We(e),!0;if(X[o]||!(Z.tagCheck instanceof Function&&Z.tagCheck(o))&&!q[o]){const t=function(e,t){if(!X[t]&&lt(t)){if(G.tagNameCheck instanceof RegExp&&uw(G.tagNameCheck,t))return!1;if(G.tagNameCheck instanceof Function&&G.tagNameCheck(t))return!1}if(he&&!ve[t]){const t=b(e),n=h(e);if(n&&t)for(let o=n.length-1;o>=0;--o){const r=be?n[o]:f(n[o],!0);t.insertBefore(r,p(e))}}return We(e),!0}(e,o);return!1===t&&rt(L.afterSanitizeElements,e,null),t}if(1===(C?C(e):e.nodeType)&&!function(e){let t=b(e);t&&t.tagName||(t={namespaceURI:Re,tagName:"template"});const n=ew(e.tagName),o=ew(t.tagName);return!!De[e.namespaceURI]&&(e.namespaceURI===ke?function(e,t,n){return t.namespaceURI===Ne?"svg"===e:t.namespaceURI===_e?"svg"===e&&("annotation-xml"===n||Be[n]):Boolean(Ve[e])}(n,t,o):e.namespaceURI===_e?function(e,t,n){return t.namespaceURI===Ne?"math"===e:t.namespaceURI===ke?"math"===e&&Le[n]:Boolean(qe[e])}(n,t,o):e.namespaceURI===Ne?function(e,t,n){return!(t.namespaceURI===ke&&!Le[n])&&!(t.namespaceURI===_e&&!Be[n])&&!qe[e]&&(Me[e]||!Ve[e])}(n,t,o):!("application/xhtml+xml"!==Ie||!De[e.namespaceURI]))}(e))return We(e),!0;if(("noscript"===o||"noembed"===o||"noframes"===o)&&uw(Hw,e.innerHTML))return We(e),!0;if(oe&&3===e.nodeType){const t=Je(e.textContent);e.textContent!==t&&(QC(n.removed,{element:e.cloneNode()}),e.textContent=t)}return rt(L.afterSanitizeElements,e,null),!1},at=function(e,t,n){if(Q[t])return!1;if(re&&"patchsrc"===t)return!1;if(re&&"for"===t&&"label"!==e&&"output"!==e)return!1;if(fe&&("id"===t||"name"===t)&&(n in o||n in je))return!1;const r=K[t]||Z.attributeCheck instanceof Function&&Z.attributeCheck(t,e);if(ee&&uw(U,t));else if(J&&uw(z,t));else if(r){if(Ee[t]);else if(uw(V,ow(n,$,"")));else if("src"!==t&&"xlink:href"!==t&&"href"!==t||"script"===e||0!==rw(n,"data:")||!we[e])if(te&&!uw(j,ow(n,$,"")));else if(n)return!1}else if(!(lt(e)&&(G.tagNameCheck instanceof RegExp&&uw(G.tagNameCheck,e)||G.tagNameCheck instanceof Function&&G.tagNameCheck(e))&&(G.attributeNameCheck instanceof RegExp&&uw(G.attributeNameCheck,t)||G.attributeNameCheck instanceof Function&&G.attributeNameCheck(t,e))||"is"===t&&G.allowCustomizedBuiltInElements&&(G.tagNameCheck instanceof RegExp&&uw(G.tagNameCheck,n)||G.tagNameCheck instanceof Function&&G.tagNameCheck(n))))return!1;return!0},it=hw({},["annotation-xml","color-profile","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","missing-glyph"]),lt=function(e){return!it[ew(e)]&&uw(H,e)},ct=function(e,t,n,o){if(S&&"object"==typeof m&&"function"==typeof m.getAttributeType&&!n)switch(m.getAttributeType(e,t)){case"TrustedHTML":return R(o);case"TrustedScriptURL":return function(e){N(),k++;try{return S.createScriptURL(e)}finally{k--}}(o)}return o},dt=function(e,t,o,r){try{o?e.setAttributeNS(o,t,r):e.setAttribute(t,r),tt(e)?We(e):XC(n.removed)}catch(n){Ye(t,e)}},mt=function(e){rt(L.beforeSanitizeAttributes,e,null);const t=e.attributes;if(!t||tt(e))return;const n={attrName:"",attrValue:"",keepAttr:!0,allowedAttributes:K,forceKeepAttr:void 0};let o=t.length;const r=Ue(e.nodeName);for(;o--;){const s=t[o],a=s.name,i=s.namespaceURI,l=s.value,c=Ue(a),d=l;let m="value"===a?d:sw(d);n.attrName=c,n.attrValue=m,n.keepAttr=!0,n.forceKeepAttr=void 0,rt(L.uponSanitizeAttribute,e,n),m=n.attrValue,!ge||"id"!==c&&"name"!==c||0===rw(m,pe)||(Ye(a,e),m=pe+m),re&&uw(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i,m)||"attributename"===c&&nw(m,"href")?Ye(a,e):n.forceKeepAttr||(!n.keepAttr||!ne&&uw(Vw,m)?Ye(a,e):(oe&&(m=Je(m)),at(r,c,m)?(m=ct(r,c,i,m),m!==d&&dt(e,a,i,m)):Ye(a,e)))}rt(L.afterSanitizeAttributes,e,null)},ut=function(e){let t=null;const n=Ze(e);for(rt(L.beforeSanitizeShadowDOM,e,null);t=n.nextNode();)if(rt(L.uponSanitizeShadowNode,t,null),st(t,e),mt(t),nt(t.content)&&ut(t.content),1===(C?C(t):t.nodeType)){const e=y(t);nt(e)&&(ft(e),ut(e))}rt(L.afterSanitizeShadowDOM,e,null)},ft=function(e){const t=[{node:e,shadow:null}];for(;t.length>0;){const e=t.pop();if(e.shadow){ut(e.shadow);continue}const n=e.node,o=1===(C?C(n):n.nodeType),r=h(n);if(r)for(let e=r.length-1;e>=0;--e)t.push({node:r[e],shadow:null});if(o){const e=w?w(n):null;if("string"==typeof e&&"template"===Ue(e)){const e=n.content;nt(e)&&t.push({node:e,shadow:null})}}if(o){const e=y(n);nt(e)&&t.push({node:null,shadow:e},{node:e,shadow:null})}}};return n.sanitize=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=null,s=null,a=null,i=null;if(Ae=!e,Ae&&(e="\x3c!--\x3e"),"string"!=typeof e&&!ot(e)&&(e=function(e){switch(typeof e){case"string":return e;case"number":return aw(e);case"boolean":return iw(e);case"bigint":return lw?lw(e):"0";case"symbol":return cw?cw(e):"Symbol()";case"undefined":default:return mw(e);case"function":case"object":{if(null===e)return mw(e);const t=e,n=vw(t,"toString");if("function"==typeof n){const e=n(t);return"string"==typeof e?e:mw(e)}return mw(e)}}}(e),"string"!=typeof e))throw fw("dirty is not a string, aborting");if(!n.isSupported)return e;ae?(q=ie,K=le):He(t),(L.uponSanitizeElement.length>0||L.uponSanitizeAttribute.length>0)&&(q=yw(q)),L.uponSanitizeAttribute.length>0&&(K=yw(K)),n.removed=[];const l=be&&"string"!=typeof e&&ot(e);if(l){!function(e){if(!re)return;const t=[e];for(;t.length>0;){const e=t.pop(),n=C?C(e):e.nodeType;if(7===n||8===n&&uw($w,e.data)){try{g(e)}catch(e){}continue}if(1===n){const t=e,n=Ue(w?w(e):e.nodeName);try{t.hasAttribute&&t.hasAttribute("patchsrc")&&t.removeAttribute("patchsrc"),t.hasAttribute&&t.hasAttribute("for")&&"label"!==n&&"output"!==n&&t.removeAttribute("for")}catch(e){}}const o=h(e);if(o)for(let e=o.length-1;e>=0;--e)t.push(o[e])}}(e);const t=w?w(e):e.nodeName;if("string"==typeof t){const n=Ue(t);if(!q[n]||X[n])throw Ke(e),fw("root node is forbidden and cannot be sanitized in-place")}if(tt(e))throw Ke(e),fw("root node is clobbered and cannot be sanitized in-place");try{ft(e)}catch(t){throw Ke(e),t}}else if(ot(e))o=Qe("\x3c!----\x3e"),s=o.ownerDocument.importNode(e,!0),1===s.nodeType&&"BODY"===s.nodeName||"HTML"===s.nodeName?o=s:o.appendChild(s),ft(s);else{if(!de&&!oe&&!se&&-1===e.indexOf("<"))return S&&ue?R(e):e;if(o=Qe(e),!o)return de?null:ue?x:""}o&&ce&&We(o.firstChild);const c=l?e:o,d=Ze(c);try{for(;a=d.nextNode();)st(a,c),mt(a),nt(a.content)&&ut(a.content)}catch(t){throw l&&(Ke(e),YC(n.removed,e=>{e.element&&Xe(e.element)})),t}if(l)return YC(n.removed,e=>{e.element&&Xe(e.element)}),oe&&et(e),e;if(de){if(oe&&et(o),me)for(i=O.call(o.ownerDocument);o.firstChild;)i.appendChild(o.firstChild);else i=o;return(K.shadowroot||K.shadowrootmode)&&(i=P.call(r,i,!0)),i}let m=se?o.outerHTML:o.innerHTML;return se&&q["!doctype"]&&o.ownerDocument&&o.ownerDocument.doctype&&o.ownerDocument.doctype.name&&uw(Uw,o.ownerDocument.doctype.name)&&(m="<!DOCTYPE "+o.ownerDocument.doctype.name+">\n"+m),oe&&(m=Je(m)),S&&ue?R(m):m},n.setConfig=function(){He(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}),ae=!0,ie=q,le=K},n.clearConfig=function(){ze=null,ae=!1,ie=null,le=null,S=E,x=""},n.isValidAttribute=function(e,t,n){ze||He({});const o=Ue(e),r=Ue(t);return at(o,r,n)},n.addHook=function(e,t){"function"==typeof t&&dw(L,e)&&QC(L[e],t)},n.removeHook=function(e,t){if(dw(L,e)){if(void 0!==t){const n=GC(L[e],t);return-1===n?void 0:ZC(L[e],n,1)[0]}return XC(L[e])}},n.removeHooks=function(e){dw(L,e)&&(L[e]=[])},n.removeAllHooks=function(){L={afterSanitizeAttributes:[],afterSanitizeElements:[],afterSanitizeShadowDOM:[],beforeSanitizeAttributes:[],beforeSanitizeElements:[],beforeSanitizeShadowDOM:[],uponSanitizeAttribute:[],uponSanitizeElement:[],uponSanitizeShadowNode:[]}},n}();const Yw=dn.each,Gw=dn.trim,Xw=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],Qw={ftp:21,http:80,https:443,mailto:25},Zw=["img","video"],Jw=(e,t,n)=>{const o=(e=>{try{return decodeURIComponent(e)}catch{return unescape(e)}})(t).replace(/\s/g,"");return!e.allow_script_urls&&(!!/((java|vb)script|mhtml):/i.test(o)||!e.allow_html_data_urls&&(/^data:image\//i.test(o)?((e,t)=>C(e)?!e:!C(t)||!$(Zw,t))(e.allow_svg_data_urls,n)&&/^data:image\/svg\+xml/i.test(o):/^data:/i.test(o)))};class eS{static parseDataUri(e){let t;const n=decodeURIComponent(e).split(","),o=/data:([^;]+)/.exec(n[0]);return o&&(t=o[1]),{type:t,data:n[1]}}static isDomSafe(e,t,n={}){if(n.allow_script_urls)return!0;{const o=Sa.decode(e).replace(/[\s\u0000-\u001F]+/g,"");return!Jw(n,o,t)}}static getDocumentBaseUrl(e){let t;return t=0!==e.protocol.indexOf("http")&&"file:"!==e.protocol?e.href??"":e.protocol+"//"+e.host+e.pathname,/^[^:]+:\/\/\/?[^\/]+\//.test(t)&&(t=t.replace(/[\?#].*$/,"").replace(/[\/\\][^\/]+$/,""),/[\/\\]$/.test(t)||(t+="/")),t}source;protocol;authority;userInfo;user;password;host;port;relative;path="";directory="";file;query;anchor;settings;constructor(e,t={}){e=Gw(e),this.settings=t;const n=t.base_uri,o=this;if(/^([\w\-]+):([^\/]{2})/i.test(e)||/^\s*#/.test(e))return void(o.source=e);const r=0===e.indexOf("//");if(0!==e.indexOf("/")||r||(e=(n&&n.protocol||"http")+"://mce_host"+e),!/^[\w\-]*:?\/\//.test(e)){const t=n?n.path:new eS(document.location.href).directory;if(""===n?.protocol)e="//mce_host"+o.toAbsPath(t,e);else{const r=/([^#?]*)([#?]?.*)/.exec(e);r&&(e=(n&&n.protocol||"http")+"://mce_host"+o.toAbsPath(t,r[1])+r[2])}}e=e.replace(/@@/g,"(mce_at)");const s=/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?(\[[a-zA-Z0-9:.%]+\]|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(e);s&&Yw(Xw,(e,t)=>{let n=s[t];n&&(n=n.replace(/\(mce_at\)/g,"@@")),o[e]=n}),n&&(o.protocol||(o.protocol=n.protocol),o.userInfo||(o.userInfo=n.userInfo),o.port||"mce_host"!==o.host||(o.port=n.port),o.host&&"mce_host"!==o.host||(o.host=n.host),o.source=""),r&&(o.protocol="")}setPath(e){const t=/^(.*?)\/?(\w+)?$/.exec(e);t&&(this.path=t[0],this.directory=t[1],this.file=t[2]),this.source="",this.getURI()}toRelative(e){if("./"===e)return e;const t=new eS(e,{base_uri:this});if("mce_host"!==t.host&&this.host!==t.host&&t.host||this.port!==t.port||this.protocol!==t.protocol&&""!==t.protocol)return t.getURI();const n=this.getURI(),o=t.getURI();if(n===o||"/"===n.charAt(n.length-1)&&n.substr(0,n.length-1)===o)return n;let r=this.toRelPath(this.path,t.path);return t.query&&(r+="?"+t.query),t.anchor&&(r+="#"+t.anchor),r}toAbsolute(e,t){const n=new eS(e,{base_uri:this});return n.getURI(t&&this.isSameOrigin(n))}isSameOrigin(e){if(this.host==e.host&&this.protocol==e.protocol){if(this.port==e.port)return!0;const t=this.protocol?Qw[this.protocol]:null;if(t&&(this.port||t)==(e.port||t))return!0}return!1}toRelPath(e,t){let n,o,r=0,s="";const a=e.substring(0,e.lastIndexOf("/")).split("/"),i=t.split("/");if(a.length>=i.length)for(n=0,o=a.length;n<o;n++)if(n>=i.length||a[n]!==i[n]){r=n+1;break}if(a.length<i.length)for(n=0,o=i.length;n<o;n++)if(n>=a.length||a[n]!==i[n]){r=n+1;break}if(1===r)return t;for(n=0,o=a.length-(r-1);n<o;n++)s+="../";for(n=r-1,o=i.length;n<o;n++)s+=n!==r-1?"/"+i[n]:i[n];return s}toAbsPath(e,t){let n=0;const o=/\/$/.test(t)?"/":"",r=e.split("/"),s=t.split("/"),a=[];Yw(r,e=>{e&&a.push(e)});const i=[];for(let e=s.length-1;e>=0;e--)0!==s[e].length&&"."!==s[e]&&(".."!==s[e]?n>0?n--:i.push(s[e]):n++);const l=a.length-n;let c;return c=l<=0?re(i).join("/"):a.slice(0,l).join("/")+"/"+re(i).join("/"),0!==c.indexOf("/")&&(c="/"+c),o&&c.lastIndexOf("/")!==c.length-1&&(c+=o),c}getURI(e=!1){let t;return this.source&&!e||(t="",e||(this.protocol?t+=this.protocol+"://":t+="//",this.userInfo&&(t+=this.userInfo+"@"),this.host&&(t+=this.host),this.port&&(t+=":"+this.port)),this.path&&(t+=this.path),this.query&&(t+="?"+this.query),this.anchor&&(t+="#"+this.anchor),this.source=t),this.source}}const tS=dn.makeMap("src,href,data,background,action,formaction,poster,xlink:href"),nS="data-mce-type";let oS=0;const rS=(e,t,n,o,r)=>{const s=t.validate,a=n.getSpecialElements();8===e.nodeType&&(!t.allow_conditional_comments&&/^\[if/i.test(e.nodeValue??"")&&(e.nodeValue=" "+e.nodeValue),t.sanitize&&t.allow_html_in_comments&&u(e.nodeValue)&&(e.nodeValue=(e=>e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"))(e.nodeValue)));const i=r?.tagName??e.nodeName.toLowerCase();if("html"!==o&&n.isValid(o))return void(C(r)&&(r.allowedTags[i]=!0));if(1!==e.nodeType||"body"===i)return;const l=un.fromDom(e);if(t.sanitize){const e=Ii(l)&&n.isValid("script")||Fi(l)&&n.isValid("style");e&&I.from((e=>e.dom.textContent)(l)).each(e=>vo(l,"data-mce-tmp",e));const t=(e=>Rn(e)&&"iframe"===En(e))(l)&&n.isValid("iframe");(e||t)&&No(l)}const c=Eo(l,nS),d=wo(l,"data-mce-bogus");if(!c&&u(d))return void("all"===d?Ro(l):Ao(l));const m=n.getElementRule(i);if(!s||m){if(C(r)&&(r.allowedTags[i]=!0),s&&m&&!c){if(q(m.attributesForced??[],e=>{vo(l,e.name,"{$uid}"===e.value?"mce_"+oS++:e.value)}),q(m.attributesDefault??[],e=>{Eo(l,e.name)||vo(l,e.name,"{$uid}"===e.value?"mce_"+oS++:e.value)}),m.attributesRequired&&!H(m.attributesRequired,e=>Eo(l,e)))return void Ao(l);if(m.removeEmptyAttrs&&_o(l))return void Ao(l);m.outputName&&m.outputName!==i&&Bo(l,m.outputName)}}else _e(a,i)?Ro(l):Ao(l)},sS=(e,t,n,o,r,s)=>"html"!==n&&!Fs(o)||!(r in tS&&Jw(e,s,o))&&(!e.validate||t.isValid(o,r)||Qe(r,"data-")||Qe(r,"aria-")),aS=(e,t)=>e.hasAttribute(nS)&&("id"===t||"class"===t||"style"===t),iS=(e,t,n)=>e in t.getBoolAttrs()&&!_e(t.getCustomElements(),n.toLowerCase()),lS=(e,t,n,o)=>{const{attributes:r}=e;for(let s=r.length-1;s>=0;s--){const a=r[s],i=a.name,l=a.value;sS(t,n,o,e.tagName.toLowerCase(),i,l)||aS(e,i)?iS(i,n,e.nodeName)&&e.setAttribute(i,i):e.removeAttribute(i)}},cS=(e,t,n)=>{const o=Kw();return o.addHook("uponSanitizeElement",(o,r)=>{rS(o,e,t,n.track(o),r)}),o.addHook("afterSanitizeElements",e=>{(e=>{const t=un.fromDom(e);(Ii(t)||Fi(t))&&So(t,"data-mce-tmp").each(e=>{((e,t)=>{e.dom.textContent=t})(t,e),xo(t,"data-mce-tmp")})})(e)}),o.addHook("uponSanitizeAttribute",(o,r)=>{((e,t,n,o,r)=>{const s=e.tagName.toLowerCase(),{attrName:a,attrValue:i}=r;r.keepAttr=sS(t,n,o,s,a,i),r.keepAttr?(r.allowedAttributes[a]=!0,iS(a,n,e.nodeName)&&(r.attrValue=a),t.allow_svg_data_urls&&Qe(i,"data:image/svg+xml")&&(r.forceKeepAttr=!0)):aS(e,a)&&(r.forceKeepAttr=!0)})(o,e,t,n.current(),r)}),o},dS=(e,t)=>{const n=Kw(),o=t.allow_mathml_annotation_encodings,r=p(o)&&o.length>0;n.addHook("uponSanitizeElement",(e,n)=>{const s=n.tagName??e.nodeName.toLowerCase();((e,n)=>r&&"semantics"===n?I.some(!0):"annotation"===n?I.some(Xr(e)&&(e=>{const t=e.getAttribute("encoding");return r&&u(t)&&$(o,t)})(e)):p(t.extended_mathml_elements)&&t.extended_mathml_elements.includes(n)?I.from(!0):I.none())(e,s).each(o=>{n.allowedTags[s]=o,!o&&t.sanitize&&Xr(e)&&e.remove()})}),n.addHook("uponSanitizeAttribute",(e,n)=>{p(t.extended_mathml_attributes)&&t.extended_mathml_attributes.includes(n.attrName)&&(n.forceKeepAttr=!0)}),n.sanitize(e,{IN_PLACE:!0,USE_PROFILES:{mathMl:!0}})},mS=e=>t=>{const n=zs(t);if("svg"===n)(e=>{const t=["type","href","role","arcrole","title","show","actuate","label","from","to"].map(e=>`xlink:${e}`),n={IN_PLACE:!0,USE_PROFILES:{html:!0,svg:!0,svgFilters:!0},ALLOWED_ATTR:t};Kw().sanitize(e,n)})(t);else{if("math"!==n)throw new Error("Not a namespace element");dS(t,e)}},uS=["script","style","template","param","meta","title","link"],fS=dn.makeMap,gS=dn.extend,pS=(e,t,n,o,r)=>{const s=e.name,a=s in n&&"title"!==s&&"textarea"!==s&&"noscript"!==s,i=t.childNodes;for(let t=0,s=i.length;t<s;t++){const s=i[t],l=new xh(s.nodeName.toLowerCase(),s.nodeType);if(Xr(s)){const e=s.attributes;for(let t=0,n=e.length;t<n;t++){const n=e[t];l.attr(n.name,n.value)}Fs(l.name)&&(o(s),l.value=s.innerHTML)}else ss(s)?(l.value=s.data,a&&(l.raw=!0)):ls(s)?l.value=r?SC(s.data):s.data:(as(s)||is(s))&&(l.value=s.data);if(vs(s)){const e=xh.create("#text");e.value=s.innerHTML,e.raw=!0,l.append(e)}else Fs(l.name)||pS(l,s,n,o,r);e.append(l)}},hS=' xmlns="http://www.w3.org/1999/xhtml"',bS=(e={},t=Ua())=>{const n=wC(),o=wC(),r={validate:!0,root_name:"body",sanitize:!0,allow_html_in_comments:!1,...e},s=new DOMParser,a=((e,t)=>{const n=(()=>{const e=Ke(),t=()=>e.get().map(zs).getOr("html");return{track:n=>(Us(n)?e.set(n):e.get().exists(e=>!e.contains(n))&&e.clear(),t()),current:t,reset:()=>{e.clear()}}})();if(e.sanitize){const o=cS(e,t,n),r=(t,r)=>{o.sanitize(t,((e,t)=>{const n={IN_PLACE:!0,ALLOW_UNKNOWN_PROTOCOLS:!0,ALLOWED_TAGS:["#comment","#cdata-section","body","html"],ALLOWED_ATTR:[]};return n.PARSER_MEDIA_TYPE=t,e.allow_script_urls?n.ALLOWED_URI_REGEXP=/.*/:e.allow_html_data_urls&&(n.ALLOWED_URI_REGEXP=/^(?!(\w+script|mhtml):)/i),n})(e,r)),o.removed=[],n.reset()};return{sanitizeHtmlElement:r,sanitizeNamespaceElement:mS(e)}}return{sanitizeHtmlElement:(o,r)=>{const s=document.createNodeIterator(o,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_COMMENT|NodeFilter.SHOW_TEXT);let a;for(;a=s.nextNode();){const o=n.track(a);rS(a,e,t,o),Xr(a)&&lS(a,e,t,o)}n.reset()},sanitizeNamespaceElement:x}})(r,t),i=n.addFilter,l=n.getFilters,c=n.removeFilter,d=o.addFilter,m=o.getFilters,f=o.removeFilter,g=(e,n)=>{const o=u(n.attr(nS)),r=1===n.type&&!_e(e,n.name)&&!ea(t,n)&&!Fs(n.name);return 3===n.type||r&&!o},p={schema:t,addAttributeFilter:d,getAttributeFilters:m,removeAttributeFilter:f,addNodeFilter:i,getNodeFilters:l,removeNodeFilter:c,parse:(e,n={})=>{const o=r.validate,i="#document"===(n.context??r.root_name),c=n.context??(i?"html":r.root_name),d=((e,n,o="html",r=!1)=>{const i="xhtml"===o,l=i?"application/xhtml+xml":"text/html",c=_e(t.getSpecialElements(),n.toLowerCase()),d=c?`<${n}>${e}</${n}>`:e,m=s.parseFromString(/^[\s]*<head/i.test(e)||/^[\s]*<html/i.test(e)||/^[\s]*<!DOCTYPE/i.test(e)?`<html${i?hS:""}>${d}</html>`:i?`<html${hS}><head></head><body>${d}</body></html>`:`<body>${d}</body>`,l),u=r?m.documentElement:m.body;return a.sanitizeHtmlElement(u,l),c?u.firstChild:u})(e,c,n.format,i);Ks(t,d);const u=new xh(c,11);pS(u,d,t.getSpecialElements(),a.sanitizeNamespaceElement,r.sanitize&&r.allow_html_in_comments),d.innerHTML="";const[f,p]=((e,t,n,o)=>{const r=n.validate,s=t.getNonEmptyElements(),a=t.getWhitespaceElements(),i=gS(fS(uS),t.getBlockElements()),l=Ia(t),c=/[ \t\r\n]+/g,d=/^[ \t\r\n]+/,m=/[ \t\r\n]+$/,u=e=>{let t=e.parent;for(;C(t);){if(t.name in a)return!0;t=t.parent}return!1},f=n=>n.name in i||ea(t,n)||Fs(n.name)&&n.parent===e,g=(t,n)=>{const r=n?t.prev:t.next;return!C(r)&&!v(t.parent)&&f(t.parent)&&(t.parent!==e||!0===o.isRootContent)};return[e=>{if(3===e.type&&!u(e)){let t=e.value??"";t=t.replace(c," "),(((e,t)=>C(e)&&(t(e)||"br"===e.name))(e.prev,f)||g(e,!0))&&(t=t.replace(d,"")),0===t.length||" "===t&&e.prev&&8===e.prev.type&&e.next&&8===e.next.type?e.remove():e.value=t}},e=>{if(1===e.type){const i=t.getElementRule(e.name);if(r&&i){const r=gC(t,s,a,e);i.paddInEmptyBlock&&r&&(e=>{let n=e;for(;C(n);){if(n.name in l)return gC(t,s,a,n);n=n.parent}return!1})(e)?uC(n,o,f,e):i.removeEmpty&&r?f(e)?e.remove():e.unwrap():i.paddEmpty&&(r||(e=>fC(e,"#text")&&e?.firstChild?.value===dt)(e))&&uC(n,o,f,e)}}else if(3===e.type&&!u(e)){let t=e.value??"";(e.next&&f(e.next)||g(e,!1))&&(t=t.replace(m,"")),0===t.length?e.remove():e.value=t}}]})(u,t,r,n),h=[],b=o?e=>((e,n)=>{yC(t,e)&&n.push(e)})(e,h):x,y={nodes:{},attributes:{}},w=e=>cC(l(),m(),e,y);((e,t,n)=>{const o=[];for(let n=e,r=n;n;r=n,n=n.walk()){const s=n;q(t,e=>e(s)),v(s.parent)&&s!==e?n=r:o.push(s)}for(let e=o.length-1;e>=0;e--){const t=o[e];q(n,e=>e(t))}})(u,[f,w],[p,b]),h.reverse(),o&&h.length>0&&(n.context?n.invalid=!0:bC(h,t,u,w));const S=((e,t)=>{const n=t.forced_root_block??e.forced_root_block;return!1===n?"":!0===n?"p":n})(r,n);return S&&("body"===u.name||n.isRootContent)&&((e,n)=>{const o=gS(fS(uS),t.getBlockElements()),s=/^[ \t\r\n]+/,a=/[ \t\r\n]+$/;let i=e.firstChild,l=null;const c=e=>{e&&(i=e.firstChild,i&&3===i.type&&(i.value=i.value?.replace(s,"")),i=e.lastChild,i&&3===i.type&&(i.value=i.value?.replace(a,"")))};if(t.isValidChild(e.name,n.toLowerCase())){for(;i;){const t=i.next;g(o,i)?(l||(l=new xh(n,1),l.attr(r.forced_root_block_attrs),e.insert(l,i)),l.append(i)):(c(l),l=null),i=t}c(l)}})(u,S),n.invalid||dC(y,n),u}};return((e,t)=>{const n=e.schema;e.addAttributeFilter("href",e=>{let n=e.length;const o=e=>{const t=e?dn.trim(e):"";return/\b(noopener)\b/g.test(t)?t:(e=>e.split(" ").filter(e=>e.length>0).concat(["noopener"]).sort().join(" "))(t)};if(!t.allow_unsafe_link_target)for(;n--;){const t=e[n];"a"===t.name&&"_blank"===t.attr("target")&&t.attr("rel",o(t.attr("rel")))}}),t.allow_html_in_named_anchor||e.addAttributeFilter("id,name",e=>{let t,n,o,r,s=e.length;for(;s--;)if(r=e[s],"a"===r.name&&r.firstChild&&!r.attr("href"))for(o=r.parent,t=r.lastChild;t&&o;)n=t.prev,o.insert(t,r),t=n}),t.fix_list_elements&&e.addNodeFilter("ul,ol",e=>{let t,n,o=e.length;for(;o--;)if(t=e[o],n=t.parent,n&&("ul"===n.name||"ol"===n.name))if(t.prev&&"li"===t.prev.name)t.prev.append(t);else{const e=new xh("li",1);e.attr("style","list-style-type: none"),t.wrap(e)}});const o=n.getValidClasses();t.validate&&o&&e.addAttributeFilter("class",e=>{let t=e.length;for(;t--;){const n=e[t],r=n.attr("class")??"",s=dn.explode(r," ");let a="";for(let e=0;e<s.length;e++){const t=s[e];let r=!1,i=o["*"];i&&i[t]&&(r=!0),i=o[n.name],!r&&i&&i[t]&&(r=!0),r&&(a&&(a+=" "),a+=t)}a.length||(a=null),n.attr("class",a)}}),((e,t)=>{const{blob_cache:n}=t;if(n){const t=e=>{const t=e.attr("src");(e=>e.attr("src")===sn.transparentSrc||C(e.attr("data-mce-placeholder")))(e)||(e=>C(e.attr("data-mce-bogus")))(e)||v(t)||DC(n,t,!0).each(t=>{e.attr("src",t.blobUri())})};e.addAttributeFilter("src",e=>q(e,t))}})(e,t);const r=t.sandbox_iframes??!1,s=fe(t.sandbox_iframes_exclusions??[]);t.convert_unsafe_embeds&&e.addNodeFilter("object,embed",e=>q(e,e=>{e.replace((({type:e,src:t,width:n,height:o}={},r,s)=>{const a=(e=>y(e)?"iframe":PC(e,"image")?"img":PC(e,"video")?"video":PC(e,"audio")?"audio":"iframe")(e),i=new xh(a,1);return i.attr("audio"===a?{src:t}:{src:t,width:n,height:o}),"audio"!==a&&"video"!==a||i.attr("controls",""),"iframe"===a&&r&&BC(i,s),i})({type:e.attr("type"),src:"object"===e.name?e.attr("data"):e.attr("src"),width:e.attr("width"),height:e.attr("height")},r,s))})),r&&e.addNodeFilter("iframe",e=>q(e,e=>BC(e,s)))})(p,r),((e,t,n)=>{t.inline_styles&&EC(e,t,n)})(p,r,t),p},yS=e=>e instanceof xh,vS=(e,t,n)=>{const o=(e=>yS(e)?Hh({validate:!1}).serialize(e):e)(e),r=t(o);if(r.isDefaultPrevented())return r;if(yS(e)){if(r.content!==o){const t=bS({validate:!1,forced_root_block:!1,...n}).parse(r.content,{context:e.name});return{...r,content:t}}return{...r,content:e}}return r},CS=e=>({sanitize:nu(e),sandbox_iframes:lu(e),sandbox_iframes_exclusions:cu(e)}),wS=(e,t)=>{if(t.no_events)return Te.value(t);{const n=((e,t)=>e.dispatch("BeforeGetContent",t))(e,t);return n.isDefaultPrevented()?Te.error(ad(e,{content:"",...n}).content):Te.value(n)}},SS=(e,t,n)=>{if(n.no_events)return t;{const o=vS(t,t=>ad(e,{...n,content:t}),CS(e));return o.content}},ES=(e,t)=>{if(t.no_events)return Te.value(t);{const n=vS(t.content,n=>((e,t)=>e.dispatch("BeforeSetContent",t))(e,{...t,content:n}),CS(e));return n.isDefaultPrevented()?(sd(e,n),Te.error(void 0)):Te.value(n)}},xS=(e,t,n)=>{n.no_events||sd(e,{...n,content:t})},_S="autoresize_on_init,content_editable_state,padd_empty_with_br,block_elements,boolean_attributes,editor_deselector,editor_selector,elements,file_browser_callback_types,filepicker_validator_handler,force_hex_style_colors,force_p_newlines,gecko_spellcheck,images_dataimg_filter,media_scripts,mode,move_caret_before_on_enter_elements,non_empty_elements,self_closing_elements,short_ended_elements,special,spellchecker_select_languages,spellchecker_whitelist,tab_focus,tabfocus_elements,table_responsive_width,text_block_elements,text_inline_elements,toolbar_drawer,types,validate,whitespace_elements,paste_enable_default_filters,paste_filter_drop,paste_word_valid_elements,paste_retain_style_properties,paste_convert_word_fake_lists,template_cdate_classes,template_mdate_classes,template_selected_content_classes,template_preview_replace_values,template_replace_values,templates,template_cdate_format,template_mdate_format".split(","),kS=["content_css_cors"],NS="bbcode,colorpicker,contextmenu,fullpage,legacyoutput,spellchecker,template,textcolor,rtc".split(","),RS=[{name:"export",replacedWith:"Export to PDF"}],AS=(e,t)=>{const n=Y(t,t=>_e(e,t));return ie(n)},DS=e=>{const t=AS(e,_S),n=e.forced_root_block;return!1!==n&&""!==n||t.push("forced_root_block (false only)"),ie(t)},TS=e=>AS(e,kS),OS=(e,t)=>{const n=dn.makeMap(e.plugins," "),o=Y(t,e=>_e(n,e));return ie(o)},BS=e=>OS(e,NS),PS=e=>OS(e,RS.map(e=>e.name)),LS=e=>Z(RS,t=>t.name===e).fold(()=>e,t=>t.replacedWith?`${e}, replaced by ${t.replacedWith}`:e),MS={fire:'The "fire" event api has been deprecated and will be removed in TinyMCE 9. Use "dispatch" instead.',selectionSetContent:'The "editor.selection.setContent" method has been deprecated and will be removed in TinyMCE 9. Use "editor.insertContent" instead.'},IS=e=>{console.warn(MS[e],(new Error).stack)},FS=e=>0===e.dom.length?(Ro(e),I.none()):I.some(e),US=(e,t,n,o,r)=>{e.bind(e=>((o?Hb:$b)(e.dom,o?e.dom.length:0,r),t.filter(An).map(t=>((e,t,n,o,r)=>{const s=e.dom,a=t.dom,i=o?s.length:a.length;o?(Vb(s,a,r,!1,!o),n.setStart(a,i)):(Vb(a,s,r,!1,!o),n.setEnd(a,i))})(e,t,n,o,r)))).orThunk(()=>{const e=((e,t)=>e.filter(e=>ip.isBookmarkNode(e.dom)).bind(t?jn:zn))(t,o).or(t).filter(An);return e.map(e=>((e,t,n)=>{Mn(e).each(o=>{const r=e.dom;t&&Bb(o,Kl(r,0),n)?$b(r,0,n):!t&&Pb(o,Kl(r,r.length),n)&&Hb(r,r.length,n)})})(e,o,r))})},zS=(e,t,n={})=>{const o=((e,t)=>({format:"html",...e,set:!0,selection:!0,content:t}))(n,t);ES(e,o).each(t=>{const n=((e,t)=>{if("raw"!==t.format){const n=e.selection.getRng(),o=e.dom.getParent(n.commonAncestorContainer,e.dom.isBlock),r=o?{context:o.nodeName.toLowerCase()}:{},s=e.parser.parse(t.content,{forced_root_block:!1,...r,...t});return Hh({validate:!1},e.schema).serialize(s)}return t.content})(e,t),o=e.selection.getRng();((e,t,n)=>{const o=I.from(t.firstChild).map(un.fromDom),r=I.from(t.lastChild).map(un.fromDom);e.deleteContents(),e.insertNode(t);const s=o.bind(zn).filter(An).bind(FS),a=r.bind(jn).filter(An).bind(FS);US(s,o,e,!0,n),US(a,r,e,!1,n),e.collapse(!1)})(o,o.createContextualFragment(n),e.schema),e.selection.setRng(o),fh(e,o),xS(e,n,t)})},jS=(e,t)=>{let n=t.firstChild,o=t.lastChild;return n&&"meta"===n.name&&(n=n.next),o&&"mce_marker"===o.attr("id")&&(o=o.prev),((e,t)=>{const n=e.getNonEmptyElements();return C(t)&&(t.isEmpty(n)||((e,t)=>e.getBlockElements()[t.name]&&(e=>C(e.firstChild)&&e.firstChild===e.lastChild)(t)&&(e=>"br"===e.name||e.value===dt)(t.firstChild))(e,t))})(e,o)&&(o=o?.prev),!(!n||n!==o||"ul"!==n.name&&"ol"!==n.name)},$S=e=>{return e.length>0&&(!(n=e[e.length-1]).firstChild||(t=n,C(t?.firstChild)&&t.firstChild===t.lastChild&&(e=>e.data===dt||ms(e))(t.firstChild)))?e.slice(0,-1):e;var t,n},HS=(e,t)=>{const n=e.getParent(t,e.isBlock);return n&&"LI"===n.nodeName?n:null},VS=(e,t)=>{const n=Kl.after(e),o=yf(t).prev(n);return o?o.toRange():null},qS=(e,t,n,o)=>{const r=((e,t,n)=>{const o=t.serialize(n);return(e=>{const t=e.firstChild,n=e.lastChild;return t&&"META"===t.nodeName&&t.parentNode?.removeChild(t),n&&"mce_marker"===n.id&&n.parentNode?.removeChild(n),e})(e.createFragment(o))})(t,e,o),s=HS(t,n.startContainer),a=$S((i=r.firstChild,Y(i?.childNodes??[],e=>"LI"===e.nodeName)));var i;const l=t.getRoot(),c=e=>{const o=Kl.fromRangeStart(n),r=yf(t.getRoot()),a=1===e?r.prev(o):r.next(o),i=a?.getNode();return!i||HS(t,i)!==s};return s?c(1)?((e,t,n)=>{const o=e.parentNode;return o&&dn.each(t,t=>{o.insertBefore(t,e)}),((e,t)=>{const n=Kl.before(e),o=yf(t).next(n);return o?o.toRange():null})(e,n)})(s,a,l):c(2)?((e,t,n,o)=>(o.insertAfter(t.reverse(),e),VS(t[0],n)))(s,a,l,t):((e,t,n,o)=>{const r=((e,t)=>{const n=t.cloneRange(),o=t.cloneRange();return n.setStartBefore(e),o.setEndAfter(e),[n.cloneContents(),o.cloneContents()]})(e,o),s=e.parentNode;return s&&(s.insertBefore(r[0],e),dn.each(t,t=>{s.insertBefore(t,e)}),s.insertBefore(r[1],e),s.removeChild(e)),VS(t[t.length-1],n)})(s,a,l,n):null},WS=["pre"],KS=bs,YS=(e,t)=>{const n=e.schema.getTextInlineElements(),o=e.dom;if(t){const t=e.getBody(),r=Hy(e),s="*[data-mce-fragment]",a=o.select(s);dn.each(a,e=>{const a=e=>C(n[e.nodeName.toLowerCase()]),i=e=>1===e.childNodes.length;if(!Yh(o,l=e)&&!((e,t)=>Yh(e,t)&&H(Kh(e,t),e=>(e=>qh.has(e))(e)))(o,l)&&a(e)&&i(e)){const n=Kh(o,e),l=(e,t)=>oe(e,e=>$(t,e)),c=t=>i(e)&&o.is(t,s)&&a(t)&&(t.nodeName===e.nodeName&&l(n,Kh(o,t))||c(t.children[0])),d=n=>C(n)&&n!==t&&(r.compare(e,n)||d(n.parentElement)),m=n=>C(n)&&n!==t&&o.is(n,s)&&(((e,t,n)=>{const o=Kh(e,t),r=Kh(e,n),s=o=>{const r=e.getStyle(t,o)??"",s=e.getStyle(n,o)??"";return ot(r)&&ot(s)&&r!==s};return H(o,e=>{const t=t=>H(t,t=>t===e);if(!t(r)&&t(Wh)){const e=Y(r,e=>H(Wh,t=>Qe(e,t)));return H(e,s)}return s(e)})})(o,e,n)||m(n.parentElement));(c(e.children[0])||d(e.parentElement)&&!m(e.parentElement))&&o.remove(e,!0)}var l}),((e,t)=>{const n=Y(t,t=>sC(e.formatter,t));iC(e,"strikethrough",n)})(e,Po(a))}},GS=(e,t,n)=>{const o=e.selection,r=e.dom,s=e.parser,a=n.merge,i=Hh({validate:!0},e.schema),l='<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;</span>';n.preserve_zwsp||(t=Gi(t)),-1===t.indexOf("{$caret}")&&(t+="{$caret}"),t=t.replace(/\{\$caret\}/,l);let c=o.getRng();const d=c.startContainer,m=e.getBody();d===m&&o.isCollapsed()&&r.isBlock(m.firstChild)&&((e,t)=>C(t)&&!e.schema.getVoidElements()[t.nodeName])(e,m.firstChild)&&r.isEmpty(m.firstChild)&&(c=r.createRng(),c.setStart(m.firstChild,0),c.setEnd(m.firstChild,0),o.setRng(c)),o.isCollapsed()||(e=>{const t=e.dom,n=vC(e.selection.getRng());e.selection.setRng(n);const o=t.getParent(n.startContainer,KS);((e,t,n)=>!!C(n)&&n===e.getParent(t.endContainer,KS)&&tg(un.fromDom(n),t))(t,n,o)?Oy(e,n,un.fromDom(o)):ag(n,fs)||(r=n,ag(r,ss))?n.deleteContents():e.getDoc().execCommand("Delete",!1);var r})(e);const u=o.getNode(),f={context:u.nodeName.toLowerCase(),data:n.data,insert:!0},g=s.parse(t,f);if(!0===n.paste&&jS(e.schema,g)&&((e,t)=>!!HS(e,t))(r,u))return c=qS(i,r,o.getRng(),g),c&&o.setRng(c),t;!0===n.paste&&((e,t,n,o)=>{const r=t.firstChild,s=t.lastChild,a=r===("bookmark"===s.attr("data-mce-type")?s.prev:s),i=$(WS,r.name);if(a&&i){const t="false"!==r.attr("contenteditable"),s=e.getParent(n,e.isBlock)?.nodeName.toLowerCase()===r.name,a=I.from(zy(o,n)).forall(gs);return t&&s&&a}return!1})(r,g,u,e.getBody())&&g.firstChild?.unwrap(),(e=>{let t=e;for(;t=t.walk();)1===t.type&&t.attr("data-mce-fragment","1")})(g);let p=g.lastChild;if(p&&"mce_marker"===p.attr("id")){const t=p;for(p=p.prev;p&&"table"!==p.name;p=p.walk(!0))if(3===p.type||!r.isBlock(p.name)){p.parent&&e.schema.isValidChild(p.parent.name,"span")&&p.parent.insert(t,p,"br"===p.name);break}}if(e._selectionOverrides.showBlockCaretContainer(u),f.invalid||((e,t,n)=>H(n.children(),lC)&&"SUMMARY"===e.getParent(t,e.isBlock)?.nodeName)(r,u,g)){zS(e,l);let n,a=o.getNode();const c=e.getBody();for(cs(a)?a=n=c:n=a;n&&n!==c;)a=n,n=n.parentNode;t=a===c?c.innerHTML:r.getOuterHTML(a);const d=s.parse(t),m=(e=>{for(let t=e;t;t=t.walk())if("mce_marker"===t.attr("id"))return I.some(t);return I.none()})(d),u=m.bind(pC).getOr(d);m.each(e=>e.replace(g));const f=(e=>{const t=[];for(let n=e.firstChild;C(n);n=n.walk())t.push(n);return t})(g);g.unwrap();const p=Y(f,t=>yC(e.schema,t));bC(p,e.schema,u),mC(s.getNodeFilters(),s.getAttributeFilters(),d),t=i.serialize(d),a===c?r.setHTML(c,t):r.setOuterHTML(a,t)}else t=i.serialize(g),((e,t,n)=>{"all"===n.getAttribute("data-mce-bogus")?n.parentNode?.insertBefore(e.dom.createFragment(t),n):((e,t)=>{if(e.isBlock(t)&&e.isEditable(t)){const e=t.childNodes;return 1===e.length&&ms(e[0])||0===e.length}return!1})(e.dom,n)?e.dom.setHTML(n,t):zS(e,t,{no_events:!0})})(e,t,u);var h;return YS(e,a),((e,t)=>{let n;const o=e.dom,r=e.selection;if(!t)return;r.scrollIntoView(t);const s=zy(e.getBody(),t);if(s&&"false"===o.getContentEditable(s))return o.remove(t),void r.select(s);let a=o.createRng();const i=t.previousSibling;if(ss(i)){a.setStart(i,i.nodeValue?.length??0);const e=t.nextSibling;ss(e)&&(i.appendData(e.data),e.parentNode?.removeChild(e))}else a.setStartBefore(t),a.setEndBefore(t);const l=o.getParent(t,o.isBlock);if(o.remove(t),l&&o.isEmpty(l)){const t=KS(l);No(un.fromDom(l)),a.setStart(l,0),a.setEnd(l,0),t||(e=>!!e.getAttribute("data-mce-fragment"))(l)||!(n=(t=>{let n=Kl.fromRangeStart(t);return n=yf(e.getBody()).next(n),n?.toRange()})(a))?o.add(l,o.create("br",t?{}:{"data-mce-bogus":"1"})):(a=n,o.remove(l))}r.setRng(a)})(e,r.get("mce_marker")),h=e.getBody(),dn.each(h.getElementsByTagName("*"),e=>{e.removeAttribute("data-mce-fragment")}),((e,t,n)=>{I.from(e.getParent(t,"td,th")).map(un.fromDom).each(e=>((e,t)=>{Kn(e).each(n=>{zn(n).each(o=>{t.isBlock(En(e))&&Mi(n)&&t.isBlock(En(o))&&Ro(n)})})})(e,n))})(r,o.getStart(),e.schema),((e,t,n)=>{const o=Fn(un.fromDom(n),e=>vn(e,un.fromDom(t)));le(o,o.length-2).filter(Rn).fold(()=>Ks(e,t),t=>Ks(e,t.dom))})(e.schema,e.getBody(),o.getStart()),t},XS=(e,t,n)=>{e.dom.setHTML(e.getBody(),t),!0!==n&&(e=>{Rp(e)&&Rf(e.getBody()).each(t=>{const n=t.getNode(),o=ns(n)?Rf(n).getOr(t):t;e.selection.setRng(o.toRange())})})(e)},QS={},ZS=Jr(["pre"]);(e=>{QS[e]||(QS[e]=[]),QS[e].push(e=>{if(!e.selection.getRng().collapsed){const t=e.selection.getSelectedBlocks(),n=Y(Y(t,ZS),(e=>t=>{const n=t.previousSibling;return ZS(n)&&$(e,n)})(t));q(n,e=>{((e,t)=>{const n=un.fromDom(t),o=Pn(n).dom;Ro(n),bo(un.fromDom(e),[un.fromTag("br",o),un.fromTag("br",o),...Vn(n)])})(e.previousSibling,e)})}})})("pre");const JS=dn.each,eE=dn.each,tE=(e,t,n,o)=>{const r=e.formatter.get(t),s=r[0],a=!o&&e.selection.isCollapsed(),i=e.dom,l=e.selection,c=(t,o)=>{let r=!1;return eE(t,t=>!(!Ng(t)||("false"!==i.getContentEditable(o)||t.ceFalseOverride)&&(!C(t.collapsed)||t.collapsed===a)&&i.is(o,t.selector)&&!Tf(o)&&(Jy(e,o,t,n,o),r=!0,1))),r},d=t=>{if(u(t)){const r=i.create(t);return Jy(e,r,s,n,o),r}return null},m=(a,i,l)=>{const m=[];let u=!0;const f=s.inline||s.block,g=d(f);Yg(a,i,o=>{let i;const d=o=>{let p=!1,h=u,b=!1;const y=o.parentNode,v=y.nodeName.toLowerCase(),w=a.getContentEditable(o);C(w)&&(h=u,u="true"===w,p=!0,b=bg(e,o));const S=u&&!p;if(ms(o)&&!((e,t,n,o)=>{if(dm(e)&&Rg(t)&&n.parentNode){const t=Ia(e.schema),a=(r=un.fromDom(n),s=e=>Tf(e.dom),((e,t)=>{const n=e.dom;return n.parentNode?cr(un.fromDom(n.parentNode),n=>!vn(e,n)&&t(n)):I.none()})(r,s).isSome());return ke(t,o)&&Ps(e.schema,n.parentNode,{skipBogus:!1,includeZwsp:!0})&&!a}var r,s;return!1})(e,s,o,v))return i=null,void(_g(s)&&a.remove(o));if((o=>kg(s)&&sv(e,o,t,n))(o))i=null;else{if(((t,n,o)=>{const r=(e=>_g(e)&&!0!==e.wrapper)(s)&&ug(e.schema,t)&&fg(e,n,f)&&(t=>oe(t.childNodes,t=>!ug(e.schema,t)||fg(e,f,t.nodeName.toLowerCase())))(t);return o&&r})(o,v,S)){const t=a.rename(o,f);return Jy(e,t,s,n,o),m.push(t),void(i=null)}if(Ng(s)){let e=c(r,o);if(!e&&C(y)&&Ag(s)&&(e=c(r,y)),!Rg(s)||e)return void(i=null)}C(g)&&((t,n,o,r)=>{const i=t.nodeName.toLowerCase(),c=fg(e,f,i)&&fg(e,n,f),d=!l&&ss(t)&&Yi(t.data),m=Tf(t),u=!Rg(s)||!a.isBlock(t);return(o||r)&&c&&!d&&!m&&u})(o,v,S,b)?(i||(i=a.clone(g,!1),y.insertBefore(i,o),m.push(i)),b&&p&&(u=h),i.appendChild(o)):(i=null,q(me(o.childNodes),d),p&&(u=h),i=null)}};q(o,d)}),!0===s.links&&q(m,t=>{const r=t=>{"A"===t.nodeName&&Jy(e,t,s,n,o),q(me(t.childNodes),r)};r(t)}),((e,t,n)=>{if($(rC,t)){const t=((e,t)=>ne(t,t=>{const n=Nr(t,t=>sC(e,t));return sC(e,t)?[t,...n]:n}))(e.formatter,n);iC(e,"strikethrough",t)}})(e,t,Po(m)),q(m,o=>{const i=(e=>{let t=0;return q(e.childNodes,e=>{(e=>C(e)&&ss(e)&&0===e.length)(e)||Vf(e)||t++}),t})(o);!(m.length>1)&&a.isBlock(o)||0!==i?(Rg(s)||_g(s)&&s.wrapper)&&(s.exact||1!==i||(o=(t=>{const o=Z(t.childNodes,lg).filter(e=>"false"!==a.getContentEditable(e)&&ov(a,e,s));return o.map(o=>{const r=a.clone(o,!1);return Jy(e,r,s,n,t),a.replace(r,t,!0),a.remove(o,!0),r}).getOr(t)})(o)),((e,t,n,o)=>{JS(t,t=>{Rg(t)&&JS(e.dom.select(t.inline,o),o=>{Bv(o)&&nC(e,t,n,o,t.exact?o:null)}),((e,t,n)=>{if(t.clear_child_styles){const o=t.links?"*:not(a)":"*";Ov(e.select(o,n),n=>{Bv(n)&&e.isEditable(n)&&Ov(t.styles,(t,o)=>{e.setStyle(n,o,"")})})}})(e.dom,t,o)})})(e,r,n,o),((e,t,n,o,r)=>{const s=r.parentNode;sv(e,s,n,o)&&nC(e,t,o,r)||t.merge_with_parents&&s&&e.dom.getParent(s,s=>!!sv(e,s,n,o)&&(nC(e,t,o,r),!0))})(e,s,t,n,o),((e,t,n,o)=>{if(t.styles&&t.styles.backgroundColor){const r=Fv(e,"fontSize");Iv(o,t=>r(t)&&e.isEditable(t),Uv(e,"backgroundColor",yg(t.styles.backgroundColor,n)))}})(a,s,n,o),((e,t,n,o)=>{const r=t=>{if(Qr(t)&&Xr(t.parentNode)&&e.isEditable(t)){const n=Sg(e,t.parentNode);e.getStyle(t,"color")&&n?e.setStyle(t,"text-decoration",n):e.getStyle(t,"text-decoration")===n&&e.setStyle(t,"text-decoration",null)}};t.styles&&(t.styles.color||t.styles.textDecoration)&&(dn.walk(o,r,"childNodes"),r(o))})(a,s,0,o),((e,t,n,o)=>{if(Rg(t)&&("sub"===t.inline||"sup"===t.inline)){const n=Fv(e,"fontSize");Iv(o,t=>n(t)&&e.isEditable(t),Uv(e,"fontSize",""));const r=Y(e.select("sup"===t.inline?"sub":"sup",o),e.isEditable);e.remove(r,!0)}})(a,s,0,o),Mv(e,s,0,o)):a.remove(o,!0)})},f=ig(o)?o:l.getNode();if("false"!==i.getContentEditable(f)||bg(e,f)){if(s){if(o)if(ig(o)){if(!c(r,o)){const e=i.createRng();e.setStartBefore(o),e.setEndAfter(o),m(i,Kg(i,e,r),!0)}}else m(i,o,!0);else a&&Rg(s)&&!Qf(e).length?((e,t,n)=>{let o;const r=e.selection,s=e.formatter.get(t);if(!s)return;const a=r.getRng();let i=a.startOffset;const l=a.startContainer.nodeValue;o=Of(e.getBody(),r.getStart());const c=/[^\s\u00a0\u00ad\u200b\ufeff]/;if(l&&i>0&&i<l.length&&c.test(l.charAt(i))&&c.test(l.charAt(i-1))){const o=r.getBookmark();a.collapse(!0);let i=Kg(e.dom,a,s);i=Yp(i),e.formatter.apply(t,n,i),r.moveToBookmark(o)}else{let s=o?dv(o):null;o&&s?.data===cv||(d=e.getDoc(),m=mv(!0).dom,o=d.importNode(m,!0),s=o.firstChild,a.insertNode(o),i=1,vv(e,o)),e.formatter.apply(t,n,o),r.setCursorLocation(s,i)}var d,m})(e,t,n):(l.setRng(vC(l.getRng())),cg(e,()=>{rg(e,(e,t)=>{const n=t?e:Kg(i,e,r);m(i,n,!1)})},M),e.nodeChanged()),_v(e.formatter,t).each(t=>{const o=(e=>{const t=Dv(e).getOrThunk(()=>(e=>{if(e.isCollapsed())return[];const t=e.getRng(),n=Av(e,e=>kv(t,e)&&!ws(e));if(1===n.length)return kv(t,n[0])&&Nv(t,n[0])?n:[];{const e=ce(n).filter(e=>kv(t,e)).toArray(),o=de(n).filter(e=>Nv(t,e)).toArray(),r=n.slice(1,-1);return e.concat(r).concat(o)}})(e.selection));return Y(t,Rv(e.selection.dom))})(e);q(o,e=>Zy(i,e,t,n))});((e,t)=>{_e(QS,e)&&q(QS[e],e=>{e(t)})})(t,e)}od(e,t,o,n)}else{if(c(r,o=f),pg(i,o))return void q(hg(i,o),e=>{const t=i.createRng();t.selectNodeContents(e),m(i,t,!0)});if(_g(s)&&!i.isBlock(o)){const t=i.getParent(o,i.isBlock);if(i.isEditable(t)){const r=s.block;if(t.nodeName.toLowerCase()===r.toLowerCase())Jy(e,t,s,n,o);else if(!kg(s)){const a=i.rename(t,r);Jy(e,a,s,n,o)}}}else{const e=Y(r,Ng);I.from(i.getParent(o,t=>H(e,e=>i.is(t,e.selector)))).filter(i.isEditable).each(e=>c(r,e))}od(e,t,o,n)}},nE=(e,t,n,o)=>{(o||e.selection.isEditable())&&tE(e,t,n,o)},oE=e=>_e(e,"vars"),rE=e=>e.selection.getStart(),sE=(e,t,n,o,r)=>Q(t,t=>{const s=e.formatter.matchNode(t,n,r??{},o);return!y(s)},t=>!!tv(e,t,n)||!o&&C(e.formatter.matchNode(t,n,r,!0))),aE=(e,t)=>{const n=t??rE(e);return Y(Eg(e.dom,n),e=>Xr(e)&&!ts(e))},iE=(e,t,n)=>{const o=aE(e,t);he(n,(n,r)=>{const s=n=>{const s=sE(e,o,r,n.similar,oE(n)?n.vars:void 0),a=s.isSome();if(n.state.get()!==a){n.state.set(a);const e=s.getOr(t);oE(n)?n.callback(a,{node:e,format:r,parents:o}):q(n.callbacks,t=>t(a,{node:e,format:r,parents:o}))}};q([n.withSimilar,n.withoutSimilar],s),q(n.withVars,s)})},lE=(e,t,n)=>({element:e,width:t,rows:n}),cE=(e,t)=>({element:e,cells:t}),dE=(e,t)=>({x:e,y:t}),mE=(e,t)=>So(e,t).bind(st).getOr(1),uE=(e,t,n)=>{const o=e.rows;return!!(o[n]?o[n].cells:[])[t]},fE=e=>X(e,(e,t)=>t.cells.length>e?t.cells.length:e,0),gE=(e,t)=>{const n=e.rows;for(let e=0;e<n.length;e++){const o=n[e].cells;for(let n=0;n<o.length;n++)if(vn(o[n],t))return I.some(dE(n,e))}return I.none()},pE=(e,t,n,o,r)=>{const s=[],a=e.rows;for(let e=n;e<=r;e++){const n=a[e].cells,r=t<o?n.slice(t,o+1):n.slice(o,t+1);s.push(cE(a[e].element,r))}return s},hE=e=>((e,t)=>{const n=To(e.element),o=un.fromTag("tbody");return bo(o,t),go(n,o),n})(e,(e=>V(e.rows,e=>{const t=V(e.cells,e=>{const t=Oo(e);return xo(t,"colspan"),xo(t,"rowspan"),t}),n=To(e.element);return bo(n,t),n}))(e)),bE=(e,t,n)=>{const o=un.fromDom(t.commonAncestorContainer),r=mb(o,e),s=Y(r,e=>n.isWrapper(En(e))),a=((e,t)=>Z(e,e=>"li"===En(e)&&tg(e,t)).fold(N([]),t=>(e=>Z(e,e=>"ul"===En(e)||"ol"===En(e)))(e).map(e=>{const t=un.fromTag(En(e)),n=we(qo(e),(e,t)=>Qe(t,"list-style"));return jo(t,n),[un.fromTag("li"),t]}).getOr([])))(r,t),i=s.concat(a.length?a:(e=>ji(e)?Mn(e).filter(zi).fold(N([]),t=>[e,t]):zi(e)?[e]:[])(o));return V(i,To)},yE=()=>tr([]),vE=(e,t)=>((e,t)=>mr(t,"table",D(vn,e)))(e,t[0]).bind(e=>{const n=t[0],o=t[t.length-1],r=(e=>{const t=lE(To(e),0,[]);return q(Rr(e,"tr"),(e,n)=>{q(Rr(e,"td,th"),(o,r)=>{((e,t,n,o,r)=>{const s=mE(r,"rowspan"),a=mE(r,"colspan"),i=e.rows;for(let e=n;e<n+s;e++){i[e]||(i[e]=cE(Oo(o),[]));for(let o=t;o<t+a;o++)i[e].cells[o]=e===n&&o===t?r:To(r)}})(t,((e,t,n)=>{for(;uE(e,t,n);)t++;return t})(t,r,n),n,e,o)})}),lE(t.element,fE(t.rows),t.rows)})(e);return((e,t,n)=>gE(e,t).bind(t=>gE(e,n).map(n=>((e,t,n)=>{const o=t.x,r=t.y,s=n.x,a=n.y,i=r<a?pE(e,o,r,s,a):pE(e,o,a,s,r);return lE(e.element,fE(i),i)})(e,t,n))))(r,n,o).map(e=>tr([hE(e)]))}).getOrThunk(yE),CE=(e,t,n)=>{const o=Xf(t,e);return o.length>0?vE(e,o):((e,t,n)=>t.length>0&&t[0].collapsed?yE():((e,t,n)=>((e,t)=>{const n=X(t,(e,t)=>(go(t,e),t),e);return t.length>0?tr([n]):n})(un.fromDom(t.cloneContents()),bE(e,t,n)))(e,t[0],n))(e,t,n)},wE=(e,t)=>t>=0&&t<e.length&&Kf(e.charAt(t)),SE=e=>Gi(e.innerText),EE=e=>Xr(e)?e.outerHTML:ss(e)?Sa.encodeRaw(e.data,!1):ls(e)?"\x3c!--"+e.data+"--\x3e":"",xE=(e,t)=>(((e,t)=>{let n=0;q(e,e=>{0===e[0]?n++:1===e[0]?(((e,t,n)=>{const o=(e=>{let t;const n=document.createElement("div"),o=document.createDocumentFragment();for(e&&(n.innerHTML=e);t=n.firstChild;)o.appendChild(t);return o})(t);if(e.hasChildNodes()&&n<e.childNodes.length){const t=e.childNodes[n];e.insertBefore(o,t)}else e.appendChild(o)})(t,e[1],n),n++):2===e[0]&&((e,t)=>{if(e.hasChildNodes()&&t<e.childNodes.length){const n=e.childNodes[t];e.removeChild(n)}})(t,n)})})(((e,t)=>{const n=e.length+t.length+2,o=new Array(n),r=new Array(n),s=(n,o,r,a,l)=>{const c=i(n,o,r,a);if(null===c||c.start===o&&c.diag===o-a||c.end===n&&c.diag===n-r){let s=n,i=r;for(;s<o||i<a;)s<o&&i<a&&e[s]===t[i]?(l.push([0,e[s]]),++s,++i):o-n>a-r?(l.push([2,e[s]]),++s):(l.push([1,t[i]]),++i)}else{s(n,c.start,r,c.start-c.diag,l);for(let t=c.start;t<c.end;++t)l.push([0,e[t]]);s(c.end,o,c.end-c.diag,a,l)}},a=(n,o,r,s)=>{let a=n;for(;a-o<s&&a<r&&e[a]===t[a-o];)++a;return((e,t,n)=>({start:e,end:t,diag:n}))(n,a,o)},i=(n,s,i,l)=>{const c=s-n,d=l-i;if(0===c||0===d)return null;const m=c-d,u=d+c,f=(u%2==0?u:u+1)/2;let g,p,h,b,y;for(o[1+f]=n,r[1+f]=s+1,g=0;g<=f;++g){for(p=-g;p<=g;p+=2){for(h=p+f,p===-g||p!==g&&o[h-1]<o[h+1]?o[h]=o[h+1]:o[h]=o[h-1]+1,b=o[h],y=b-n+i-p;b<s&&y<l&&e[b]===t[y];)o[h]=++b,++y;if(m%2!=0&&m-g<=p&&p<=m+g&&r[h-m]<=o[h])return a(r[h-m],p+n-i,s,l)}for(p=m-g;p<=m+g;p+=2){for(h=p+f-m,p===m-g||p!==m+g&&r[h+1]<=r[h-1]?r[h]=r[h+1]-1:r[h]=r[h-1],b=r[h]-1,y=b-n+i-p;b>=n&&y>=i&&e[b]===t[y];)r[h]=b--,y--;if(m%2==0&&-g<=p&&p<=g&&r[h]<=o[h+m])return a(r[h],p+n-i,s,l)}}return null},l=[];return s(0,e.length,0,t.length,l),l})(V(me(t.childNodes),EE),e),t),t),_E=lt(()=>document.implementation.createHTMLDocument("undo")),kE=e=>{const t=e.serializer.getTempAttrs(),n=Ih(e.getBody(),t);return(e=>null!==e.querySelector(`iframe, ${xs}`))(n)?{type:"fragmented",fragments:Y(V(me(n.childNodes),_(Gi,EE)),e=>e.length>0),content:"",bookmark:null,beforeBookmark:null}:{type:"complete",fragments:null,content:Gi(n.innerHTML),bookmark:null,beforeBookmark:null}},NE=(e,t,n)=>{const o=n?t.beforeBookmark:t.bookmark;"fragmented"===t.type?xE(t.fragments,e.getBody()):e.setContent(t.content,{format:"raw",no_selection:!C(o)||!Pf(o)||!o.isFakeCaret}),o&&(e.selection.moveToBookmark(o),e.selection.scrollIntoView())},RE=e=>"fragmented"===e.type?e.fragments.join(""):e.content,AE=(e,t)=>{const n=un.fromTag("body",_E());return Mo(n,RE(t)),q(Rr(n,"*[data-mce-bogus]"),Ao),e&&q(Rr(n,"details[open]"),e=>xo(e,"open")),Lo(n)},DE=(e,t,n)=>!(!t||!n)&&(!!((e,t)=>RE(e)===RE(t))(t,n)||((e,t,n)=>AE(e,t)===AE(e,n))(e,t,n)),TE=e=>0===e.get(),OE=(e,t,n)=>{TE(n)&&(e.typing=t)},BE=(e,t)=>{e.typing&&(OE(e,!1,t),e.add())},PE=e=>({init:{bindEvents:x},undoManager:{beforeChange:(t,n)=>((e,t,n)=>{TE(t)&&n.set(gc(e.selection))})(e,t,n),add:(t,n,o,r,s,a)=>((e,t,n,o,r,s,a)=>{const i=kE(e),l=dn.extend(s||{},i);if(!TE(o)||e.removed)return null;const c=t.data[n.get()];if(e.dispatch("BeforeAddUndo",{level:l,lastLevel:c,originalEvent:a}).isDefaultPrevented())return null;if(c&&DE(e.readonly,c,l))return null;t.data[n.get()]&&r.get().each(e=>{t.data[n.get()].beforeBookmark=e});const d=ym(e);if(d&&t.data.length>d){for(let e=0;e<t.data.length-1;e++)t.data[e]=t.data[e+1];t.data.length--,n.set(t.data.length)}l.bookmark=gc(e.selection),n.get()<t.data.length-1&&(t.data.length=n.get()+1),t.data.push(l),n.set(t.data.length-1);const m={level:l,lastLevel:c,originalEvent:a};return n.get()>0?(e.setDirty(!0),e.dispatch("AddUndo",m),e.dispatch("change",m)):e.dispatch("AddUndo",m),l})(e,t,n,o,r,s,a),undo:(t,n,o)=>((e,t,n,o)=>{let r;return t.typing&&(t.add(),t.typing=!1,OE(t,!1,n)),o.get()>0&&(o.set(o.get()-1),r=t.data[o.get()],NE(e,r,!0),e.setDirty(!0),e.dispatch("Undo",{level:r})),r})(e,t,n,o),redo:(t,n)=>((e,t,n)=>{let o;return t.get()<n.length-1&&(t.set(t.get()+1),o=n[t.get()],NE(e,o,!1),e.setDirty(!0),e.dispatch("Redo",{level:o})),o})(e,t,n),clear:(t,n)=>((e,t,n)=>{t.data=[],n.set(0),t.typing=!1,e.dispatch("ClearUndos")})(e,t,n),reset:e=>(e=>{e.clear(),e.add()})(e),hasUndo:(t,n)=>((e,t,n)=>n.get()>0||t.typing&&t.data[0]&&!DE(e.readonly,kE(e),t.data[0]))(e,t,n),hasRedo:(e,t)=>((e,t)=>t.get()<e.data.length-1&&!e.typing)(e,t),transact:(e,t,n)=>((e,t,n)=>(BE(e,t),e.beforeChange(),e.ignore(n),e.add()))(e,t,n),ignore:(e,t)=>((e,t)=>{try{e.set(e.get()+1),t()}finally{e.set(e.get()-1)}})(e,t),extra:(t,n,o,r)=>((e,t,n,o,r)=>{if(t.transact(o)){const o=t.data[n.get()].bookmark,s=t.data[n.get()-1];NE(e,s,!0),t.transact(r)&&(t.data[n.get()-1].beforeBookmark=o)}})(e,t,n,o,r)},formatter:{match:(t,n,o,r)=>lv(e,t,n,o,r),matchAll:(t,n)=>((e,t,n)=>{const o=[],r={},s=e.selection.getStart();return e.dom.getParent(s,s=>{for(let a=0;a<t.length;a++){const i=t[a];!r[i]&&sv(e,s,i,n)&&(r[i]=!0,o.push(i))}},e.dom.getRoot()),o})(e,t,n),matchNode:(t,n,o,r)=>sv(e,t,n,o,r),canApply:t=>((e,t)=>{const n=e.formatter.get(t),o=e.dom;if(n&&e.selection.isEditable()){const t=e.selection.getStart(),r=Eg(o,t);for(let e=n.length-1;e>=0;e--){const t=n[e];if(!Ng(t))return!0;for(let e=r.length-1;e>=0;e--)if(o.is(r[e],t.selector))return!0}}return!1})(e,t),closest:t=>((e,t)=>{const n=t=>vn(t,un.fromDom(e.getBody()));return I.from(e.selection.getStart(!0)).bind(o=>Or(un.fromDom(o),n=>ue(t,t=>((t,n)=>sv(e,t.dom,n)?I.some(n):I.none())(n,t)),n)).getOrNull()})(e,t),apply:(t,n,o)=>nE(e,t,n,o),remove:(t,n,o,r)=>tC(e,t,n,o,r),toggle:(t,n,o)=>((e,t,n,o)=>{const r=e.formatter.get(t);r&&(!lv(e,t,n,o)||"toggle"in r[0]&&!r[0].toggle?nE(e,t,n,o):tC(e,t,n,o))})(e,t,n,o),formatChanged:(t,n,o,r,s)=>((e,t,n,o,r,s)=>(((e,t,n,o,r,s)=>{const a=t.get();q(n.split(","),t=>{const n=xe(a,t).getOrThunk(()=>{const e={withSimilar:{state:Re(!1),similar:!0,callbacks:[]},withoutSimilar:{state:Re(!1),similar:!1,callbacks:[]},withVars:[]};return a[t]=e,e}),i=()=>{const n=aE(e);return sE(e,n,t,r,s).isSome()};if(y(s)){const e=r?n.withSimilar:n.withoutSimilar;e.callbacks.push(o),1===e.callbacks.length&&e.state.set(i())}else n.withVars.push({state:Re(i()),similar:r,vars:s,callback:o})}),t.set(a)})(e,t,n,o,r,s),{unbind:()=>((e,t,n)=>{const o=e.get();q(t.split(","),e=>xe(o,e).each(t=>{o[e]={withSimilar:{...t.withSimilar,callbacks:Y(t.withSimilar.callbacks,e=>e!==n)},withoutSimilar:{...t.withoutSimilar,callbacks:Y(t.withoutSimilar.callbacks,e=>e!==n)},withVars:Y(t.withVars,e=>e.callback!==n)}})),e.set(o)})(t,n,o)}))(e,t,n,o,r,s)},editor:{getContent:t=>((e,t)=>I.from(e.getBody()).fold(N("tree"===t.format?new xh("body",11):""),n=>zh(e,t,n)))(e,t),setContent:(t,n)=>((e,t,n)=>I.from(e.getBody()).map(o=>yS(t)?((e,t,n,o)=>{mC(e.parser.getNodeFilters(),e.parser.getAttributeFilters(),n);const r=Hh({validate:!1},e.schema).serialize(n),s=Gi(Vi(un.fromDom(t))?r:dn.trim(r));return XS(e,s,o.no_selection),{content:n,html:s}})(e,o,t,n):((e,t,n,o)=>{if(0===(n=Gi(n)).length||/^\s+$/.test(n)){const r='<br data-mce-bogus="1">';"TABLE"===t.nodeName?n="<tr><td>"+r+"</td></tr>":/^(UL|OL)$/.test(t.nodeName)&&(n="<li>"+r+"</li>");const s=Ed(e);return e.schema.isValidChild(t.nodeName.toLowerCase(),s.toLowerCase())?(n=r,n=e.dom.createHTML(s,xd(e),n)):n||(n=r),XS(e,n,o.no_selection),{content:n,html:n}}{"raw"!==o.format&&(n=Hh({validate:!1},e.schema).serialize(e.parser.parse(n,{isRootContent:!0,insert:!0})));const r=Vi(un.fromDom(t))?n:dn.trim(n);return XS(e,r,o.no_selection),{content:r,html:r}}})(e,o,t,n)).getOr({content:t,html:yS(n.content)?"":n.content}))(e,t,n),insertContent:(t,n)=>GS(e,t,n),addVisual:t=>((e,t)=>{const n=e.dom,o=C(t)?t:e.getBody();q(n.select("table,a",o),t=>{switch(t.nodeName){case"TABLE":const o=Nm(e),r=n.getAttrib(t,"border");r&&"0"!==r||!e.hasVisual?n.removeClass(t,o):n.addClass(t,o);break;case"A":if(!n.getAttrib(t,"href")){const o=n.getAttrib(t,"name")||t.id,r=Rm(e);o&&e.hasVisual?n.addClass(t,r):n.removeClass(t,r)}}}),e.dispatch("VisualAid",{element:t,hasVisual:e.hasVisual})})(e,t)},selection:{getContent:(t,n)=>((e,t,n={})=>{const o=((e,t)=>({...e,format:t,get:!0,selection:!0,getInner:!0}))(n,t);return wS(e,o).fold(R,t=>{const n=((e,t)=>{if("text"===t.format)return(e=>I.from(e.selection.getRng()).map(t=>{const n=I.from(e.dom.getParent(t.commonAncestorContainer,e.dom.isBlock)),o=e.getBody(),r=(e=>e.map(e=>e.nodeName).getOr("div").toLowerCase())(n),s=un.fromDom(t.cloneContents());Fh(s),Uh(s);const a=e.dom.add(o,r,{"data-mce-bogus":"all",style:"overflow: hidden; opacity: 0;"},s.dom),i=SE(a),l=Gi(a.textContent??"");if(e.dom.remove(a),wE(l,0)||wE(l,l.length-1)){const e=n.getOr(o),t=SE(e),r=t.indexOf(i);return-1===r?i:(wE(t,r-1)?" ":"")+i+(wE(t,r+i.length)?" ":"")}return i}).getOr(""))(e);{const n=((e,t)=>{const n=e.selection.getRng(),o=e.dom.create("body"),r=e.selection.getSel(),s=vh(e,Gf(r)),a=t.contextual?CE(un.fromDom(e.getBody()),s,e.schema).dom:n.cloneContents();return a&&o.appendChild(a),e.selection.serializer.serialize(o,t)})(e,t);return"tree"===t.format?n:e.selection.isCollapsed()?"":n}})(e,t);return SS(e,n,t)})})(e,t,n)},autocompleter:{addDecoration:x,removeDecoration:x},raw:{getModel:()=>I.none()}}),LE=e=>_e(e.plugins,"rtc"),ME=e=>e.rtcInstance?e.rtcInstance:PE(e),IE=e=>{const t=e.rtcInstance;if(t)return t;throw new Error("Failed to get RTC instance not yet initialized.")},FE=e=>IE(e).init.bindEvents(),UE=(e,t,n)=>{if(_e(e,t)){const o=Y(e[t],e=>e!==n);0===o.length?delete e[t]:e[t]=o}};const zE=e=>!(!e||!e.ownerDocument)&&Cn(un.fromDom(e.ownerDocument),un.fromDom(e)),jE=(e,t,n,o)=>{let r,s;const{selectorChangedWithUnbind:a}=((e,t)=>{let n,o;const r=(t,n)=>Z(n,n=>e.is(n,t)),s=t=>e.getParents(t,void 0,e.getRoot());return{selectorChangedWithUnbind:(e,a)=>(n||(n={},o={},t.on("NodeChange",e=>{const t=e.element,a=s(t),i={};he(n,(e,t)=>{r(t,a).each(n=>{o[t]||(q(e,e=>{e(!0,{node:n,selector:t,parents:a})}),o[t]=e),i[t]=e})}),he(o,(e,n)=>{i[n]||(delete o[n],q(e,e=>{e(!1,{node:t,selector:n,parents:a})}))})})),n[e]||(n[e]=[]),n[e].push(a),r(e,s(t.selection.getStart())).each(()=>{o[e]=n[e]}),{unbind:()=>{UE(n,e,a),UE(o,e,a)}})}})(e,o),i=e=>{const t=c();t.collapse(!!e),d(t)},l=()=>t.getSelection?t.getSelection():t.document.selection,c=()=>{let n;const a=(e,t,n)=>{try{return t.compareBoundaryPoints(e,n)}catch{return-1}},i=t.document;if(C(o.bookmark)&&!Rp(o)){const e=hp(o);if(e.isSome())return e.map(e=>vh(o,[e])[0]).getOr(i.createRange())}try{const e=l();e&&!Gr(e.anchorNode)&&(n=e.rangeCount>0?e.getRangeAt(0):i.createRange(),n=vh(o,[n])[0])}catch{}if(n||(n=i.createRange()),cs(n.startContainer)&&n.collapsed){const t=e.getRoot();n.setStart(t,0),n.setEnd(t,0)}return r&&s&&(0===a(n.START_TO_START,n,r)&&0===a(n.END_TO_END,n,r)?n=s:(r=null,s=null)),n},d=(e,t)=>{if(!(e=>!!e&&zE(e.startContainer)&&zE(e.endContainer))(e))return;const n=l();if(e=o.dispatch("SetSelectionRange",{range:e,forward:t}).range,n){s=e;try{n.removeAllRanges(),n.addRange(e)}catch{}!1===t&&n.extend&&(n.collapse(e.endContainer,e.endOffset),n.extend(e.startContainer,e.startOffset)),r=n.rangeCount>0?n.getRangeAt(0):null}if(!e.collapsed&&e.startContainer===e.endContainer&&n?.setBaseAndExtent&&e.endOffset-e.startOffset<2&&e.startContainer.hasChildNodes()){const t=e.startContainer.childNodes[e.startOffset];t&&"IMG"===t.nodeName&&(n.setBaseAndExtent(e.startContainer,e.startOffset,e.endContainer,e.endOffset),n.anchorNode===e.startContainer&&n.focusNode===e.endContainer||n.setBaseAndExtent(t,0,t,1))}o.dispatch("AfterSetSelectionRange",{range:e,forward:t})},m=()=>{const t=l(),n=t?.anchorNode,o=t?.focusNode;if(!t||!n||!o||Gr(n)||Gr(o))return!0;const r=e.createRng(),s=e.createRng();try{r.setStart(n,t.anchorOffset),r.collapse(!0),s.setStart(o,t.focusOffset),s.collapse(!0)}catch{return!0}return r.compareBoundaryPoints(r.START_TO_START,s)<=0},u={dom:e,win:t,serializer:n,editor:o,expand:(t={type:"word"})=>d(Gp(e).expand(c(),t)),collapse:i,setCursorLocation:(t,n)=>{const r=e.createRng();C(t)&&C(n)?(r.setStart(t,n),r.setEnd(t,n),d(r),i(!1)):(ng(e,r,o.getBody(),!0),d(r))},getContent:e=>((e,t={})=>((e,t,n)=>IE(e).selection.getContent(t,n))(e,t.format?t.format:"html",t))(o,e),setContent:(e,t)=>((e,t,n={})=>{IS("selectionSetContent"),zS(e,t,n)})(o,e,t),getBookmark:(e,t)=>f.getBookmark(e,t),moveToBookmark:e=>f.moveToBookmark(e),select:(t,n)=>(((e,t,n)=>I.from(t).bind(t=>I.from(t.parentNode).map(o=>{const r=e.nodeIndex(t),s=e.createRng();return s.setStart(o,r),s.setEnd(o,r+1),n&&(ng(e,s,t,!0),ng(e,s,t,!1)),s})))(e,t,n).each(d),t),isCollapsed:()=>{const e=c(),t=l();return!(!e||e.item)&&(e.compareEndPoints?0===e.compareEndPoints("StartToEnd",e):!t||e.collapsed)},isEditable:()=>{if(o.mode.isReadOnly())return!1;const t=c(),n=o.getBody().querySelectorAll('[data-mce-selected="1"]');return n.length>0?oe(n,t=>e.isEditable(t.parentElement)):gh(e,t)},isForward:m,setNode:t=>(zS(o,e.getOuterHTML(t)),t),getNode:()=>((e,t)=>{if(!t)return e;let n=t.startContainer,o=t.endContainer;const r=t.startOffset,s=t.endOffset;let a=t.commonAncestorContainer;t.collapsed||(n===o&&s-r<2&&n.hasChildNodes()&&(a=n.childNodes[r]),ss(n)&&ss(o)&&(n=n.length===r?yh(n.nextSibling,!0):n.parentNode,o=0===s?yh(o.previousSibling,!1):o.parentNode,n&&n===o&&(a=n)));const i=ss(a)?a.parentNode:a;return Qr(i)?i:e})(o.getBody(),c()),getSel:l,setRng:d,getRng:c,getStart:e=>hh(o.getBody(),c(),e),getEnd:e=>bh(o.getBody(),c(),e),getSelectedBlocks:(t,n)=>((e,t,n,o)=>{const r=[],s=e.getRoot(),a=e.getParent(n||hh(s,t,t.collapsed),e.isBlock),i=e.getParent(o||bh(s,t,t.collapsed),e.isBlock);if(a&&a!==s&&r.push(a),a&&i&&a!==i){let t;const n=new Kr(a,s);for(;(t=n.next())&&t!==i;)e.isBlock(t)&&r.push(t)}return i&&a!==i&&i!==s&&r.push(i),r})(e,c(),t,n),normalize:()=>{const t=c(),n=l();if(!(Gf(n).length>1)&&og(o)){const n=Wp(e,t);return n.each(e=>{d(e,m())}),n.getOr(t)}return t},selectorChanged:(e,t)=>(a(e,t),u),selectorChangedWithUnbind:a,getScrollContainer:()=>{let t,n=e.getRoot();for(;n&&"BODY"!==n.nodeName;){if(n.scrollHeight>n.clientHeight){t=n;break}n=n.parentNode}return t},scrollIntoView:(e,t)=>{C(e)?((e,t,n)=>{(e.inline?dh:uh)(e,t,n)})(o,e,t):fh(o,c(),t)},placeCaretAt:(e,t)=>d(Fp(e,t,o.getDoc())),getBoundingClientRect:()=>{const e=c();return e.collapsed?Kl.fromRangeStart(e).getClientRects()[0]:e.getBoundingClientRect()},destroy:()=>{t=r=s=null,g.destroy()}},f=ip(u),g=Ip(u,o);return u.bookmarkManager=f,u.controlSelection=g,u},$E=(e,t,n)=>{-1===dn.inArray(t,n)&&(e.addAttributeFilter(n,(e,t)=>{let n=e.length;for(;n--;)e[n].attr(t,null)}),t.push(n))},HE=(e,t)=>{const n=["data-mce-selected"],o={entity_encoding:"named",remove_trailing_brs:!0,pad_empty_with_br:!1,...e},r=t&&t.dom?t.dom:gi.DOM,s=t&&t.schema?t.schema:Ua(o),a=bS(o,s);return((e,t,n)=>{e.addAttributeFilter("data-mce-tabindex",(e,t)=>{let n=e.length;for(;n--;){const o=e[n];o.attr("tabindex",o.attr("data-mce-tabindex")),o.attr(t,null)}}),e.addAttributeFilter("src,href,style",(e,o)=>{const r="data-mce-"+o,s=t.url_converter,a=t.url_converter_scope;let i=e.length;for(;i--;){const t=e[i];let l=t.attr(r);void 0!==l?(t.attr(o,l.length>0?l:null),t.attr(r,null)):(l=t.attr(o),"style"===o?l=n.serializeStyle(n.parseStyle(l),t.name):s&&(l=s.call(a,l,o,t.name)),t.attr(o,l.length>0?l:null))}}),e.addAttributeFilter("class",e=>{let t=e.length;for(;t--;){const n=e[t];let o=n.attr("class");o&&(o=o.replace(/(?:^|\s)mce-item-\w+(?!\S)/g,""),n.attr("class",o.length>0?o:null))}}),e.addAttributeFilter("data-mce-type",(e,t,n)=>{let o=e.length;for(;o--;){const t=e[o];if("bookmark"===t.attr("data-mce-type")&&!n.cleanup){const e=I.from(t.firstChild).exists(e=>!Yi(e.value??""));e?t.unwrap():t.remove()}}}),e.addNodeFilter("script,style",(e,n)=>{const o=e=>e.replace(/(<!--\[CDATA\[|\]\]-->)/g,"\n").replace(/^[\r\n]*|[\r\n]*$/g,"").replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi,"").replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g,"");let r=e.length;for(;r--;){const s=e[r],a=s.firstChild,i=a?.value??"";if("script"===n){const e=s.attr("type");e&&s.attr("type","mce-no/type"===e?null:e.replace(/^mce\-/,"")),"xhtml"===t.element_format&&a&&i.length>0&&(a.value="// <![CDATA[\n"+o(i)+"\n// ]]>")}else"xhtml"===t.element_format&&a&&i.length>0&&(a.value="\x3c!--\n"+o(i)+"\n--\x3e")}}),e.addNodeFilter("#comment",e=>{let o=e.length;for(;o--;){const r=e[o],s=r.value;t.preserve_cdata&&0===s?.indexOf("[CDATA[")&&(r.name="#cdata",r.type=4,r.value=n.decode(s.replace(/^\[CDATA\[|\]\]$/g,"")))}}),e.addNodeFilter("xml:namespace,input",(e,t)=>{let n=e.length;for(;n--;){const o=e[n];7===o.type?o.remove():1===o.type&&("input"!==t||o.attr("type")||o.attr("type","text"))}}),e.addAttributeFilter("data-mce-type",t=>{q(t,t=>{"format-caret"===t.attr("data-mce-type")&&(t.isEmpty(e.schema.getNonEmptyElements())?t.remove():t.unwrap())})}),e.addAttributeFilter("data-mce-src,data-mce-href,data-mce-style,data-mce-selected,data-mce-expando,data-mce-block,data-mce-type,data-mce-resize,data-mce-placeholder",(e,t)=>{let n=e.length;for(;n--;)e[n].attr(t,null)}),t.remove_trailing_brs&&((e,t,n)=>{t.addNodeFilter("br",(t,o,r)=>{const s=dn.extend({},n.getBlockElements()),a=n.getNonEmptyElements(),i=n.getWhitespaceElements();s.body=1;const l=e=>e.name in s||ea(n,e);for(let o=0,c=t.length;o<c;o++){let c=t[o],d=c.parent;if(d&&l(d)&&c===d.lastChild){let t=c.prev;for(;t;){const e=t.name;if("span"!==e||"bookmark"!==t.attr("data-mce-type")){"br"===e&&(c=null);break}t=t.prev}if(c&&(c.remove(),gC(n,a,i,d))){const t=n.getElementRule(d.name);t&&(t.removeEmpty?d.remove():t.paddEmpty&&uC(e,r,l,d))}}else{let e=c;for(;d&&d.firstChild===e&&d.lastChild===e&&(e=d,!s[d.name]);)d=d.parent;if(e===d){const e=new xh("#text",3);e.value=dt,c.replace(e)}}}})})(t,e,e.schema)})(a,o,r),{schema:s,addNodeFilter:a.addNodeFilter,addAttributeFilter:a.addAttributeFilter,serialize:(e,n={})=>{const{indent:i,entity_encoding:l,...c}=n,d={format:"html",...c},m=((e,t,n)=>((e,t)=>C(e)&&e.hasEventListeners("PreProcess")&&!t.no_events)(e,n)?((e,t,n)=>{let o;const r=e.dom;let s=t.cloneNode(!0);const a=document.implementation;if(a.createHTMLDocument){const e=a.createHTMLDocument("");dn.each("BODY"===s.nodeName?s.childNodes:[s],t=>{e.body.appendChild(e.importNode(t,!0))}),s="BODY"!==s.nodeName?e.body.firstChild:e.body,o=r.doc,r.doc=e}return((e,t)=>{e.dispatch("PreProcess",t)})(e,{...n,node:s}),o&&(r.doc=o),s})(e,t,n):t)(t,e,d),u=((e,t,n)=>{const o=Gi(n.getInner?t.innerHTML:e.getOuterHTML(t));return n.selection||Vi(un.fromDom(t))?o:dn.trim(o)})(r,m,d),f=((e,t,n)=>{const o=n.selection?{forced_root_block:!1,...n}:n,r=e.parse(t,o);return(e=>{const t=e=>"br"===e?.name,n=e.lastChild;if(t(n)){const e=n.prev;t(e)&&(n.remove(),e.remove())}})(r),r})(a,u,d);if("tree"===d.format)return f;const g={...o,...C(i)?{indent:i}:{},...C(l)?{entity_encoding:l}:{}};return((e,t,n,o,r)=>{const s=((e,t,n)=>Hh(e,t).serialize(n))(t,n,o);return((e,t,n)=>{if(!t.no_events&&e){const o=((e,t)=>e.dispatch("PostProcess",t))(e,{...t,content:n});return o.content}return n})(e,r,s)})(t,g,s,f,d)},addRules:s.addValidElements,setRules:s.setValidElements,addTempAttr:D($E,a,n),getTempAttrs:N(n),getNodeFilters:a.getNodeFilters,getAttributeFilters:a.getAttributeFilters,removeNodeFilter:a.removeNodeFilter,removeAttributeFilter:a.removeAttributeFilter}},VE=(e,t)=>{const n=HE(e,t);return{schema:n.schema,addNodeFilter:n.addNodeFilter,addAttributeFilter:n.addAttributeFilter,serialize:n.serialize,addRules:n.addRules,setRules:n.setRules,addTempAttr:n.addTempAttr,getTempAttrs:n.getTempAttrs,getNodeFilters:n.getNodeFilters,getAttributeFilters:n.getAttributeFilters,removeNodeFilter:n.removeNodeFilter,removeAttributeFilter:n.removeAttributeFilter}},qE=(e,t,n={})=>{const o=((e,t)=>({format:"html",...e,set:!0,content:t}))(n,t);ES(e,o).each(t=>{const n=((e,t,n)=>ME(e).editor.setContent(t,n))(e,t.content,t);xS(e,n.html,t)})},WE=gi.DOM,KE=e=>I.from(e).each(e=>e.destroy()),YE=(()=>{const e={};return{add:(t,n)=>{e[t]=n},get:t=>e[t]?e[t]:{icons:{}},has:t=>_e(e,t)}})(),GE=wi.ModelManager,XE=(e,t)=>t.dom[e],QE=(e,t)=>parseInt($o(t,e),10),ZE=D(XE,"clientWidth"),JE=D(XE,"clientHeight"),ex=D(QE,"margin-top"),tx=D(QE,"margin-left"),nx=e=>{const t=[],n=()=>{const t=e.theme;return t&&t.getNotificationManagerImpl?t.getNotificationManagerImpl():(()=>{const e=()=>{throw new Error("Theme did not provide a NotificationManager implementation.")};return{open:e,close:e,getArgs:e}})()},o=()=>I.from(t[0]),r=()=>{o().each(e=>{e.reposition()})},s=e=>{J(t,t=>t===e).each(e=>{t.splice(e,1)})},a=(o,a=!0)=>e.removed||!(e=>{return(t=e.inline?e.getBody():e.getContentAreaContainer(),I.from(t).map(un.fromDom)).map(Fo).getOr(!1);var t})(e)?{}:(a&&e.dispatch("BeforeOpenNotification",{notification:o}),Z(t,e=>{return t=n().getArgs(e),r=o,!(t.type!==r.type||t.text!==r.text||t.progressBar||t.timeout||r.progressBar||r.timeout);var t,r}).getOrThunk(()=>{e.editorManager.setActive(e);const a=n().open(o,()=>{s(a)},()=>Ap(e));return(e=>{t.push(e)})(a),r(),e.dispatch("OpenNotification",{notification:{...a}}),a})),i=N(t);return(e=>{e.on("SkinLoaded",()=>{const t=nm(e);t&&a({text:t,type:"warning",timeout:0},!1),r()}),e.on("show ResizeEditor ResizeWindow NodeChange ToggleView FullscreenStateChanged",()=>{requestAnimationFrame(r)}),e.on("remove",()=>{q(t.slice(),e=>{n().close(e)})}),e.on("keydown",e=>{const t="f12"===e.key?.toLowerCase()||123===e.keyCode;e.altKey&&t&&(e.preventDefault(),o().map(e=>un.fromDom(e.getEl())).each(e=>io(e)))})})(e),{open:a,close:()=>{o().each(e=>{n().close(e),s(e),r()})},getNotifications:i}},ox=wi.PluginManager,rx=wi.ThemeManager,sx=e=>{let t=[];const n=()=>{const t=e.theme;return t&&t.getWindowManagerImpl?t.getWindowManagerImpl():(()=>{const e=()=>{throw new Error("Theme did not provide a WindowManager implementation.")};return{open:e,openUrl:e,alert:e,confirm:e,close:e}})()},o=(e,t)=>(...n)=>t?t.apply(e,n):void 0,r=n=>{(t=>{e.dispatch("CloseWindow",{dialog:t})})(n);const o=ue(t,({instanceApi:e,triggerElement:t})=>e===n?t:I.none());t=Y(t,({instanceApi:e})=>e!==n),0===t.length?e.focus():o.filter(Fo).each(io)},s=n=>{e.editorManager.setActive(e),pp(e);const o=co();e.ui.show();const r=n();return((n,o)=>{t.push({instanceApi:n,triggerElement:o}),(t=>{e.dispatch("OpenWindow",{dialog:t})})(n)})(r,o),r},a=e=>{0!==t.length&&e.each(e=>io(e))};return e.on("remove",()=>{q(t,({instanceApi:e})=>{n().close(e)})}),{open:(e,t)=>s(()=>n().open(e,t,r)),openUrl:e=>s(()=>n().openUrl(e,r)),alert:(e,t,r)=>{const s=co(),i=n();i.alert(e,o(r||i,()=>{a(s),t?.()}))},confirm:(e,t,r)=>{const s=co(),i=n();i.confirm(e,o(r||i,e=>{a(s),t?.(e)}))},close:()=>{I.from(t[t.length-1]).each(({instanceApi:e})=>{n().close(e),r(e)})}}},ax=(e,t)=>{e.notificationManager.open({type:"error",text:t})},ix=(e,t)=>{e._skinLoaded?ax(e,t):e.on("SkinLoaded",()=>{ax(e,t)})},lx=(e,t,n)=>{nd(e,t,{message:n}),console.error(n)},cx=(e,t,n)=>n?`Failed to load ${e}: ${n} from url ${t}`:`Failed to load ${e} url: ${t}`,dx=(e,...t)=>{const n=window.console;n&&(n.error?n.error(e,...t):n.log(e,...t))},mx=new WeakMap,ux=(e,t)=>{const{type:n,message:o}=t;e.notificationManager.open({type:n,text:o})},fx=e=>{const t=(e=>{switch(e){case"error":return console.error;case"info":return console.info;case"warn":return console.warn;default:return console.log}})(e.type);t(e.message)},gx=(e,t)=>{const{console:n,editor:o}=t;C(o)&&(e._skinLoaded?ux(e,o):e.on("SkinLoaded",()=>{ux(e,o)})),C(n)&&fx(n)},px="Read more: https://www.tiny.cloud/docs/tinymce/latest/license-key/",hx="Make sure to provide a valid license key or add license_key: 'gpl' to the init config to agree to the open source license terms.",bx="licensekeymanager",yx=e=>{const t=(e=>u(uu(e))?"online":"offline")(e),n=(e=>{const t=mu(e)?.toLowerCase();return"gpl"===t?"gpl":v(t)?"no_key":"non_gpl"})(e),o=new Set([...Em(e),...ge(xm(e))]).has(bx);return"gpl"!==n||"online"===t||o?{type:"use_plugin",onlineStatus:t,licenseKeyType:n,forcePlugin:o}:{type:"use_gpl",onlineStatus:t,licenseKeyType:n,forcePlugin:o}},vx=e=>t=>{let n=!1;return{validate:o=>{const{plugin:r}=o,s=u(r);return s&&(((e,t,n)=>{gx(e,{console:{type:"error",message:[`The "${t}" plugin requires a valid TinyMCE license key.`,px].join(" ")},...n?{}:{editor:{type:"warning",message:"One or more premium plugins are disabled due to license key restrictions."}}})})(t,r,n),n=!0),Promise.resolve(e&&!s)}}},Cx=vx(!1),wx=vx(!0),Sx="manager",Ex=bx,xx=(()=>{const e=wi();return{load:(t,n)=>{if("use_plugin"===yx(t).type){const o=xe(xm(t),Ex).map(et).filter(ot).getOr(`plugins/${Ex}/plugin${n}.js`);e.load(Sx,o).catch(()=>{((e,t)=>{lx(e,"LicenseKeyManagerLoadError",cx("license key manager",t))})(t,o)})}},add:t=>{e.add(Sx,t)},init:t=>{const n=e=>{Object.defineProperty(t,"licenseKeyManager",{value:e,writable:!1,configurable:!1,enumerable:!0})},o=yx(t),r=e.get(Sx);if(C(r))n(r(t,e.urls[Sx]));else switch(o.type){case"use_gpl":n(wx(t));break;case"use_plugin":(e=>{mx.has(e)||(mx.set(e,!0),e.initialized?(e.removed||e.mode.set("readonly"),e.options.set("disabled",!0)):e.on("init",()=>{e.removed||e.mode.set("readonly"),e.options.set("disabled",!0)}),e.on("DisabledStateChange",e=>{const{state:t}=e;t||e.preventDefault()},!0),e.on("SwitchMode",t=>{const{mode:n}=t;"readonly"!==n&&e.mode.set("readonly")}))})(t),n(Cx(t)),"offline"===o.onlineStatus&&"no_key"===o.licenseKeyType?(e=>{const t="The editor is disabled because a TinyMCE license key has not been provided.";gx(e,{console:{type:"error",message:[`${t}`,hx,px].join(" ")},editor:{type:"warning",message:`${t}`}})})(t):((e,t)=>{const n=("online"===t?"API":"license")+" key",o=`The editor is disabled because the TinyMCE ${n} could not be validated.`;gx(e,{console:{type:"error",message:[`${o}`,`The TinyMCE Commercial License Key Manager plugin is required for the provided ${n} to be validated but could not be loaded.`,px].join(" ")},editor:{type:"warning",message:`${o}`}})})(t,o.onlineStatus)}t.licenseKeyManager.validate({})}}})(),_x=(e,t,n)=>{try{e.getDoc().execCommand(t,!1,String(n))}catch{}},kx=(e,t,n)=>{wr(e,t)&&!n?Cr(e,t):n&&yr(e,t)},Nx=e=>{const t=un.fromDom(e.getBody());kx(t,"mce-content-readonly",!0),e.selection.controlSelection.hideResizeRect(),e._selectionOverrides.hideFakeCaret(),(e=>{I.from(e.selection.getNode()).each(e=>{e.removeAttribute("data-mce-selected")})})(e)},Rx=e=>{const t=un.fromDom(e.getBody());kx(t,"mce-content-readonly",!1),e.hasEditableRoot()&&xr(t,!0),((e,t)=>{_x(e,"StyleWithCSS",t),_x(e,"enableInlineTableEditing",t),_x(e,"enableObjectResizing",t)})(e,!1),Ap(e)&&e.focus(),(e=>{e.selection.setRng(e.selection.getRng())})(e),e.nodeChanged()},Ax=e=>fu(e),Dx="data-mce-contenteditable",Tx=(e,t)=>{const n=un.fromDom(e.getBody());t?(Nx(e),xr(n,!1),q(Rr(n,'*[contenteditable="true"]'),e=>{vo(e,Dx,"true"),xr(e,!1)})):(q(Rr(n,`*[${Dx}="true"]`),e=>{xo(e,Dx),xr(e,!0)}),Rx(e))},Ox=e=>{e.parser.addAttributeFilter("contenteditable",t=>{Ax(e)&&q(t,e=>{e.attr(Dx,e.attr("contenteditable")),e.attr("contenteditable","false")})}),e.serializer.addAttributeFilter(Dx,t=>{Ax(e)&&q(t,e=>{e.attr("contenteditable",e.attr(Dx))})}),e.serializer.addTempAttr(Dx)},Bx=["copy"],Px=(e,t)=>fr(t,"details",t=>vn(t,un.fromDom(e.getBody()))).isSome(),Lx=e=>"content/"+e+"/content.css",Mx=(e,t)=>{const n=e.editorManager.baseURL+"/skins/content",o=`content${e.editorManager.suffix}.css`;return V(t,t=>(e=>tinymce.Resource.has(Lx(e)))(t)?Lx(t):(e=>/^[a-z0-9\-]+$/i.test(e))(t)&&!e.inline?`${n}/${t}/${o}`:e.documentBaseURI.toAbsolute(t))},Ix=(e,t)=>{const n={};return{findAll:(o,r=M)=>{const s=Y((e=>e?me(e.getElementsByTagName("img")):[])(o),t=>{const n=t.src;return!t.hasAttribute("data-mce-bogus")&&!t.hasAttribute("data-mce-placeholder")&&!(!n||n===sn.transparentSrc)&&(Qe(n,"blob:")?!e.isUploaded(n)&&r(t):!!Qe(n,"data:")&&r(t))}),a=V(s,e=>{const o=e.src;if(_e(n,o))return n[o].then(t=>u(t)?t:{image:e,blobInfo:t.blobInfo});{const r=((e,t)=>{const n=()=>Promise.reject("Invalid data URI");if(Qe(t,"blob:")){const s=e.getByUri(t);return C(s)?Promise.resolve(s):(o=t,Qe(o,"blob:")?(e=>fetch(e).then(e=>e.ok?e.blob():Promise.reject()).catch(()=>Promise.reject({message:`Cannot convert ${e} to Blob. Resource might not exist or is inaccessible.`,uriType:"blob"})))(o):Qe(o,"data:")?(r=o,new Promise((e,t)=>{xC(r).bind(({type:e,data:t,base64Encoded:n})=>_C(e,t,n)).fold(()=>t("Invalid data URI"),e)})):Promise.reject("Unknown URI format")).then(t=>kC(t).then(o=>RC(o,!1,n=>I.some(AC(e,t,n))).getOrThunk(n)))}var o,r;return Qe(t,"data:")?DC(e,t).fold(n,e=>Promise.resolve(e)):Promise.reject("Unknown image data format")})(t,o).then(t=>(delete n[o],{image:e,blobInfo:t})).catch(e=>(delete n[o],e));return n[o]=r,r}});return Promise.all(a)}}},Fx=()=>{let e={};const t=(e,t)=>({status:e,resultUri:t}),n=t=>t in e;return{hasBlobUri:n,getResultUri:t=>{const n=e[t];return n?n.resultUri:null},isPending:t=>!!n(t)&&1===e[t].status,isUploaded:t=>!!n(t)&&2===e[t].status,markPending:n=>{e[n]=t(1,null)},markUploaded:(n,o)=>{e[n]=t(2,o)},removeFailed:t=>{delete e[t]},destroy:()=>{e={}}}};let Ux=0;const zx=(e,t)=>{const n={},o=(e,n)=>new Promise((o,r)=>{const s=new XMLHttpRequest;s.open("POST",t.url),s.withCredentials=t.credentials,s.upload.onprogress=e=>{n(e.loaded/e.total*100)},s.onerror=()=>{r("Image upload failed due to a XHR Transport error. Code: "+s.status)},s.onload=()=>{if(s.status<200||s.status>=300)return void r("HTTP Error: "+s.status);const e=JSON.parse(s.responseText);var n,a;e&&u(e.location)?o((n=t.basePath,a=e.location,n?n.replace(/\/$/,"")+"/"+a.replace(/^\//,""):a)):r("Invalid JSON: "+s.responseText)};const a=new FormData;a.append("file",e.blob(),e.filename()),s.send(a)}),r=w(t.handler)?t.handler:o,s=(e,t)=>({url:t,blobInfo:e,status:!0}),a=(e,t)=>({url:"",blobInfo:e,status:!1,error:t}),i=(e,t)=>{dn.each(n[e],e=>{e(t)}),delete n[e]};return{upload:(l,c)=>t.url||r!==o?((t,o)=>(t=dn.grep(t,t=>!e.isUploaded(t.blobUri())),Promise.all(dn.map(t,t=>e.isPending(t.blobUri())?(e=>{const t=e.blobUri();return new Promise(e=>{n[t]=n[t]||[],n[t].push(e)})})(t):((t,n,o)=>(e.markPending(t.blobUri()),new Promise(r=>{let l,c;try{const d=()=>{l&&(l.close(),c=x)},m=n=>{d();const o=u(n)?n:n.url;e.markUploaded(t.blobUri(),o),i(t.blobUri(),s(t,o)),r(s(t,o))},f=n=>{d(),e.removeFailed(t.blobUri()),i(t.blobUri(),a(t,n)),r(a(t,n))};c=e=>{e<0||e>100||I.from(l).orThunk(()=>I.from(o).map(B)).each(t=>{l=t,t.progressBar.value(e)})},n(t,c).then(m,e=>{f(u(e)?{message:e}:e)})}catch(e){r(a(t,e))}})))(t,r,o)))))(l,c):new Promise(e=>{e([])})}},jx=e=>()=>e.notificationManager.open({text:e.translate("Image uploading..."),type:"info",timeout:-1,progressBar:!0}),$x=(e,t)=>zx(t,{url:Ld(e),basePath:Md(e),credentials:Id(e),handler:Fd(e)}),Hx=e=>{const t=(()=>{let e=[];const t=e=>{if(v(e.blob)||v(e.base64)||""===e.base64&&!e.allowEmptyFile)throw new Error("blob and base64 representations of the image are required for BlobInfo to be created");const t=e.id||"blobid"+Ux+++(()=>{const e=()=>Math.round(4294967295*Be()).toString(36);return"s"+(new Date).getTime().toString(36)+e()+e()+e()})(),n=e.name||t,o=e.blob;var r;return{id:N(t),name:N(n),filename:N(e.filename||n+"."+(r=o.type,{"image/jpeg":"jpg","image/jpg":"jpg","image/gif":"gif","image/png":"png","image/apng":"apng","image/avif":"avif","image/svg+xml":"svg","image/webp":"webp","image/bmp":"bmp","image/tiff":"tiff"}[r.toLowerCase()]||"dat")),blob:N(o),base64:N(e.base64),blobUri:N(e.blobUri||URL.createObjectURL(o)),uri:N(e.uri)}},n=t=>Z(e,t).getOrUndefined(),o=e=>n(t=>t.id()===e);return{create:(e,n,o,r,s)=>{if(u(e))return t({id:e,name:r,filename:s,blob:n,base64:o});if(f(e))return t(e);throw new Error("Unknown input type")},add:t=>{o(t.id())||e.push(t)},get:o,getByUri:e=>n(t=>t.blobUri()===e),getByData:(e,t)=>n(n=>n.base64()===e&&n.blob().type===t),findFirst:n,removeByUri:t=>{e=Y(e,e=>e.blobUri()!==t||(URL.revokeObjectURL(e.blobUri()),!1))},destroy:()=>{q(e,e=>{URL.revokeObjectURL(e.blobUri())}),e=[]}}})();let n,o;const r=Fx(),s=[],a=t=>n=>e.selection?t(n):[],i=(e,t,n)=>{let o=0;do{o=e.indexOf(t,o),-1!==o&&(e=e.substring(0,o)+n+e.substr(o+t.length),o+=n.length-t.length+1)}while(-1!==o);return e},l=(e,t,n)=>{const o=`src="${n}"${n===sn.transparentSrc?' data-mce-placeholder="1"':""}`;return e=i(e,`src="${t}"`,o),i(e,'data-mce-src="'+t+'"','data-mce-src="'+n+'"')},c=(t,n)=>{q(e.undoManager.data,e=>{"fragmented"===e.type?e.fragments=V(e.fragments,e=>l(e,t,n)):e.content=l(e.content,t,n)})},d=()=>(n||(n=$x(e,r)),p().then(a(o=>{const r=V(o,e=>e.blobInfo);return n.upload(r,jx(e)).then(a(n=>{const r=[];let s=!1;const a=V(n,(n,a)=>{const{blobInfo:i,image:l}=o[a];let d=!1;return n.status&&Od(e)?(n.url&&!Xe(l.src,n.url)&&(s=!0),t.removeByUri(l.src),LE(e)||((t,n)=>{const o=e.convertURL(n,"src");var r;c(t.src,n),Co(un.fromDom(t),{src:Td(e)?(r=n,r+(-1===r.indexOf("?")?"?":"&")+(new Date).getTime()):n,"data-mce-src":o})})(l,n.url)):n.error&&(n.error.remove&&(c(l.src,sn.transparentSrc),r.push(l),d=!0),((e,t)=>{ix(e,Ci.translate(["Failed to upload image: {0}",t]))})(e,n.error.message)),{element:l,status:n.status,uploadUri:n.url,blobInfo:i,removed:d}});return r.length>0&&!LE(e)?e.undoManager.transact(()=>{q(Po(r),n=>{const o=Mn(n);Ro(n),o.each((e=>t=>{((e,t)=>e.dom.isEmpty(t.dom)&&C(e.schema.getTextBlockElements()[En(t)]))(e,t)&&go(t,un.fromHtml('<br data-mce-bogus="1" />'))})(e)),t.removeByUri(n.dom.src)})}):s&&e.undoManager.dispatchChange(),a}))}))),m=()=>Dd(e)?d():Promise.resolve([]),g=e=>oe(s,t=>t(e)),p=()=>(o||(o=Ix(r,t)),o.findAll(e.getBody(),g).then(a(t=>{const n=Y(t,t=>u(t)?(ix(e,t),!1):"blob"!==t.uriType);return LE(e)||q(n,e=>{c(e.image.src,e.blobInfo.blobUri()),e.image.src=e.blobInfo.blobUri(),e.image.removeAttribute("data-mce-src")}),n}))),h=n=>n.replace(/src="(blob:[^"]+)"/g,(n,o)=>{const s=r.getResultUri(o);if(s)return'src="'+s+'"';let a=t.getByUri(o);return a||(a=X(e.editorManager.get(),(e,t)=>e||t.editorUpload&&t.editorUpload.blobCache.getByUri(o),void 0)),a?'src="data:'+a.blob().type+";base64,"+a.base64()+'"':n});return e.on("SetContent",()=>{Dd(e)?m():p()}),e.on("RawSaveContent",e=>{e.content=h(e.content)}),e.on("GetContent",e=>{e.source_view||"raw"===e.format||"tree"===e.format||(e.content=h(e.content))}),e.on("PostRender",()=>{e.parser.addNodeFilter("img",e=>{q(e,e=>{const n=e.attr("src");if(!n||t.getByUri(n))return;const o=r.getResultUri(n);o&&e.attr("src",o)})})}),{blobCache:t,addFilter:e=>{s.push(e)},uploadImages:d,uploadImagesAuto:m,scanForImages:p,destroy:()=>{t.destroy(),r.destroy(),o=n=null}}},Vx={remove_similar:!0,inherit:!1},qx={selector:"td,th",...Vx},Wx={tablecellbackgroundcolor:{styles:{backgroundColor:"%value"},...qx},tablecellverticalalign:{styles:{"vertical-align":"%value"},...qx},tablecellbordercolor:{styles:{borderColor:"%value"},...qx},tablecellclass:{classes:["%value"],...qx},tableclass:{selector:"table",classes:["%value"],...Vx},tablecellborderstyle:{styles:{borderStyle:"%value"},...qx},tablecellborderwidth:{styles:{borderWidth:"%value"},...qx}},Kx=N(Wx),Yx=dn.each,Gx=gi.DOM,Xx=e=>C(e)&&f(e),Qx=(e,t)=>{const n=t&&t.schema||Ua({}),o=e=>{const t=u(e)?{name:e,classes:[],attrs:{}}:e,n=Gx.create(t.name);return((e,t)=>{t.classes.length>0&&Gx.addClass(e,t.classes.join(" ")),Gx.setAttribs(e,t.attrs)})(n,t),n},r=(e,t,s)=>{let a;const i=t[0],l=Xx(i)?i.name:void 0,c=((e,t)=>{const o=n.getElementRule(e.nodeName.toLowerCase()),r=o?.parentsRequired;return!(!r||!r.length)&&(t&&$(r,t)?t:r[0])})(e,l);if(c)l===c?(a=i,t=t.slice(1)):a=c;else if(i)a=i,t=t.slice(1);else if(!s)return e;const d=a?o(a):Gx.create("div");d.appendChild(e),s&&dn.each(s,t=>{const n=o(t);d.insertBefore(n,e)});const m=Xx(a)?a.siblings:void 0;return r(d,t,m)},s=Gx.create("div");if(e.length>0){const t=e[0],n=o(t),a=Xx(t)?t.siblings:void 0;s.appendChild(r(n,e.slice(1),a))}return s},Zx=e=>{let t="div";const n={name:t,classes:[],attrs:{},selector:e=dn.trim(e)};return"*"!==e&&(t=e.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g,(e,t,o,r,s)=>{switch(t){case"#":n.attrs.id=o;break;case".":n.classes.push(o);break;case":":-1!==dn.inArray("checked disabled enabled read-only required".split(" "),o)&&(n.attrs[o]=o)}if("["===r){const e=s.match(/([\w\-]+)(?:\=\"([^\"]+))?/);e&&(n.attrs[e[1]]=e[2])}return""})),n.name=t||"div",n},Jx=(e,t)=>{let n="",o=cm(e);if(""===o)return"";const r=e=>u(e)?e.replace(/%(\w+)/g,""):"",s=(t,n)=>Gx.getStyle(n??e.getBody(),t,!0);if(u(t)){const n=e.formatter.get(t);if(!n)return"";t=n[0]}if("preview"in t){const e=t.preview;if(!1===e)return"";o=e||o}let a,i=t.block||t.inline||"span";const l=(c=t.selector,u(c)?(c=(c=c.split(/\s*,\s*/)[0]).replace(/\s*(~\+|~|\+|>)\s*/g,"$1"),dn.map(c.split(/(?:>|\s+(?![^\[\]]+\]))/),e=>{const t=dn.map(e.split(/(?:~\+|~|\+)/),Zx),n=t.pop();return t.length&&(n.siblings=t),n}).reverse()):[]);var c;l.length>0?(l[0].name||(l[0].name=i),i=t.selector,a=Qx(l,e)):a=Qx([i],e);const d=Gx.select(i,a)[0]||a.firstChild;Yx(t.styles,(e,t)=>{const n=r(e);n&&Gx.setStyle(d,t,n)}),Yx(t.attributes,(e,t)=>{const n=r(e);n&&Gx.setAttrib(d,t,n)}),Yx(t.classes,e=>{const t=r(e);Gx.hasClass(d,t)||Gx.addClass(d,t)}),e.dispatch("PreviewFormats"),Gx.setStyles(a,{position:"absolute",left:-65535}),e.getBody().appendChild(a);const m=s("fontSize"),f=/px$/.test(m)?parseInt(m,10):0;return Yx(o.split(" "),e=>{let t=s(e,d);if(!("background-color"===e&&/transparent|rgba\s*\([^)]+,\s*0\)/.test(t)&&(t=s(e),"#ffffff"===Ya(t).toLowerCase())||"color"===e&&"#000000"===Ya(t).toLowerCase())){if("font-size"===e&&/em|%$/.test(t)){if(0===f)return;t=parseFloat(t)/(/%$/.test(t)?100:1)*f+"px"}"border"===e&&t&&(n+="padding:0 2px;"),n+=e+":"+t+";"}}),e.dispatch("AfterPreviewFormats"),Gx.remove(a),n},e_=e=>{const t=(e=>{const t={},n=(e,o)=>{e&&(u(e)?(p(o)||(o=[o]),q(o,e=>{y(e.deep)&&(e.deep=!Ng(e)),y(e.split)&&(e.split=!Ng(e)||Rg(e)),y(e.remove)&&Ng(e)&&!Rg(e)&&(e.remove="none"),Ng(e)&&Rg(e)&&(e.mixed=!0,e.block_expand=!0),u(e.classes)&&(e.classes=e.classes.split(/\s+/))}),t[e]=o):he(e,(e,t)=>{n(t,e)}))};return n((e=>{const t=e.dom,n=e.schema.type,o={valigntop:[{selector:"td,th",styles:{verticalAlign:"top"}}],valignmiddle:[{selector:"td,th",styles:{verticalAlign:"middle"}}],valignbottom:[{selector:"td,th",styles:{verticalAlign:"bottom"}}],alignleft:[{selector:"figure.image",collapsed:!1,classes:"align-left",ceFalseOverride:!0,preview:"font-family font-size"},{selector:"figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",styles:{textAlign:"left"},inherit:!1,preview:!1},{selector:"img,audio,video",collapsed:!1,styles:{float:"left"},preview:"font-family font-size"},{selector:".mce-placeholder",styles:{float:"left"},ceFalseOverride:!0},{selector:"table",collapsed:!1,styles:{marginLeft:"0px",marginRight:"auto"},onformat:e=>{t.setStyle(e,"float",null)},preview:"font-family font-size"},{selector:".mce-preview-object,[data-ephox-embed-iri],.tiny-pageembed",ceFalseOverride:!0,styles:{float:"left"}}],aligncenter:[{selector:"figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",styles:{textAlign:"center"},inherit:!1,preview:"font-family font-size"},{selector:"figure.image",collapsed:!1,classes:"align-center",ceFalseOverride:!0,preview:"font-family font-size"},{selector:"img,audio,video",collapsed:!1,styles:{display:"block",marginLeft:"auto",marginRight:"auto"},preview:!1},{selector:".mce-placeholder",styles:{display:"block",marginLeft:"auto",marginRight:"auto"},ceFalseOverride:!0},{selector:"table",collapsed:!1,styles:{marginLeft:"auto",marginRight:"auto"},preview:"font-family font-size"},{selector:".mce-preview-object,.tiny-pageembed",ceFalseOverride:!0,styles:{display:"table",marginLeft:"auto",marginRight:"auto"},preview:!1},{selector:"[data-ephox-embed-iri]",ceFalseOverride:!0,styles:{marginLeft:"auto",marginRight:"auto"},preview:!1}],alignright:[{selector:"figure.image",collapsed:!1,classes:"align-right",ceFalseOverride:!0,preview:"font-family font-size"},{selector:"figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",styles:{textAlign:"right"},inherit:!1,preview:"font-family font-size"},{selector:"img,audio,video",collapsed:!1,styles:{float:"right"},preview:"font-family font-size"},{selector:".mce-placeholder",styles:{float:"right"},ceFalseOverride:!0},{selector:"table",collapsed:!1,styles:{marginRight:"0px",marginLeft:"auto"},onformat:e=>{t.setStyle(e,"float",null)},preview:"font-family font-size"},{selector:".mce-preview-object,[data-ephox-embed-iri],.tiny-pageembed",ceFalseOverride:!0,styles:{float:"right"},preview:!1}],alignjustify:[{selector:"figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li,pre",styles:{textAlign:"justify"},inherit:!1,preview:"font-family font-size"}],bold:[{inline:"strong",remove:"all",preserve_attributes:["class","style"]},{inline:"span",styles:{fontWeight:"bold"}},{inline:"b",remove:"all",preserve_attributes:["class","style"]}],italic:[{inline:"em",remove:"all",preserve_attributes:["class","style"]},{inline:"span",styles:{fontStyle:"italic"}},{inline:"i",remove:"all",preserve_attributes:["class","style"]}],underline:[{inline:"span",styles:{textDecoration:"underline"},exact:!0},{inline:"u",remove:"all",preserve_attributes:["class","style"]}],strikethrough:(()=>{const e={inline:"span",styles:{textDecoration:"line-through"},exact:!0},t={inline:"strike",remove:"all",preserve_attributes:["class","style"]},o={inline:"s",remove:"all",preserve_attributes:["class","style"]};return"html4"!==n?[o,e,t]:[e,o,t]})(),forecolor:{inline:"span",styles:{color:"%value"},links:!0,remove_similar:!0,clear_child_styles:!0},hilitecolor:{inline:"span",styles:{backgroundColor:"%value"},links:!0,remove_similar:!0,clear_child_styles:!0},fontname:{inline:"span",toggle:!1,styles:{fontFamily:"%value"},clear_child_styles:!0},fontsize:{inline:"span",toggle:!1,styles:{fontSize:"%value"},clear_child_styles:!0},lineheight:{selector:"h1,h2,h3,h4,h5,h6,p,li,td,th,div",styles:{lineHeight:"%value"},remove_similar:!0},fontsize_class:{inline:"span",attributes:{class:"%value"}},blockquote:{block:"blockquote",wrapper:!0,remove:"all"},subscript:{inline:"sub"},superscript:{inline:"sup"},code:{inline:"code"},samp:{inline:"samp"},link:{inline:"a",selector:"a",remove:"all",split:!0,deep:!0,onmatch:(e,t,n)=>Xr(e)&&e.hasAttribute("href"),onformat:(e,n,o)=>{dn.each(o,(n,o)=>{t.setAttrib(e,o,n)})}},lang:{inline:"span",clear_child_styles:!0,remove_similar:!0,attributes:{lang:"%value","data-mce-lang":e=>e?.customValue??null}},removeformat:[{selector:"b,strong,em,i,font,u,strike,s,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins,small",remove:"all",split:!0,expand:!1,block_expand:!0,deep:!0},{selector:"span",attributes:["style","class"],remove:"empty",split:!0,expand:!1,deep:!0},{selector:"*",attributes:["style","class"],split:!1,expand:!1,deep:!0}]};return dn.each("p h1 h2 h3 h4 h5 h6 div address pre dt dd".split(/\s/),e=>{o[e]={block:e,remove:"all"}}),o})(e)),n(Kx()),n(lm(e)),{get:e=>C(e)?t[e]:t,has:e=>_e(t,e),register:n,unregister:e=>(e&&t[e]&&delete t[e],t)}})(e),n=Re({});return(e=>{e.addShortcut("meta+b","","Bold"),e.addShortcut("meta+i","","Italic"),e.addShortcut("meta+u","","Underline");for(let t=1;t<=6;t++)e.addShortcut("access+"+t,"",["FormatBlock",!1,"h"+t]);e.addShortcut("access+7","",["FormatBlock",!1,"p"]),e.addShortcut("access+8","",["FormatBlock",!1,"div"]),e.addShortcut("access+9","",["FormatBlock",!1,"address"])})(e),(e=>{e.on("mouseup keydown",t=>{((e,t)=>{const n=e.selection,o=e.getBody();pv(e,null,!1),8!==t&&46!==t||!n.isCollapsed()||n.getStart().innerHTML!==cv||pv(e,Of(o,n.getStart()),!0),37!==t&&39!==t||pv(e,Of(o,n.getStart()),!0)})(e,t.keyCode)})})(e),LE(e)||((e,t)=>{e.set({}),t.on("NodeChange",n=>{iE(t,n.element,e.get())}),t.on("FormatApply FormatRemove",n=>{const o=I.from(n.node).map(e=>ig(e)?e:e.startContainer).bind(e=>Xr(e)?I.some(e):I.from(e.parentElement)).getOrThunk(()=>rE(t));iE(t,o,e.get())})})(n,e),{get:t.get,has:t.has,register:t.register,unregister:t.unregister,apply:(t,n,o)=>{((e,t,n,o)=>{IE(e).formatter.apply(t,n,o)})(e,t,n,o)},remove:(t,n,o,r)=>{((e,t,n,o,r)=>{IE(e).formatter.remove(t,n,o,r)})(e,t,n,o,r)},toggle:(t,n,o)=>{((e,t,n,o)=>{IE(e).formatter.toggle(t,n,o)})(e,t,n,o)},match:(t,n,o,r)=>((e,t,n,o,r)=>IE(e).formatter.match(t,n,o,r))(e,t,n,o,r),closest:t=>((e,t)=>IE(e).formatter.closest(t))(e,t),matchAll:(t,n)=>((e,t,n)=>IE(e).formatter.matchAll(t,n))(e,t,n),matchNode:(t,n,o,r)=>((e,t,n,o,r)=>IE(e).formatter.matchNode(t,n,o,r))(e,t,n,o,r),canApply:t=>((e,t)=>IE(e).formatter.canApply(t))(e,t),formatChanged:(t,o,r,s)=>((e,t,n,o,r,s)=>IE(e).formatter.formatChanged(t,n,o,r,s))(e,n,t,o,r,s),getCssText:D(Jx,e)}},t_=e=>{switch(e.toLowerCase()){case"undo":case"redo":case"mcefocus":return!0;default:return!1}},n_=e=>{const t=Ke(),n=Re(0),o=Re(0),r={data:[],typing:!1,beforeChange:()=>{((e,t,n)=>{IE(e).undoManager.beforeChange(t,n)})(e,n,t)},add:(s,a)=>((e,t,n,o,r,s,a)=>IE(e).undoManager.add(t,n,o,r,s,a))(e,r,o,n,t,s,a),dispatchChange:()=>{e.setDirty(!0);const t=kE(e);t.bookmark=gc(e.selection),e.dispatch("change",{level:t,lastLevel:le(r.data,o.get()).getOrUndefined()})},undo:()=>((e,t,n,o)=>IE(e).undoManager.undo(t,n,o))(e,r,n,o),redo:()=>((e,t,n)=>IE(e).undoManager.redo(t,n))(e,o,r.data),clear:()=>{((e,t,n)=>{IE(e).undoManager.clear(t,n)})(e,r,o)},reset:()=>{((e,t)=>{IE(e).undoManager.reset(t)})(e,r)},hasUndo:()=>((e,t,n)=>IE(e).undoManager.hasUndo(t,n))(e,r,o),hasRedo:()=>((e,t,n)=>IE(e).undoManager.hasRedo(t,n))(e,r,o),transact:t=>((e,t,n,o)=>IE(e).undoManager.transact(t,n,o))(e,r,n,t),ignore:t=>{((e,t,n)=>{IE(e).undoManager.ignore(t,n)})(e,n,t)},extra:(t,n)=>{((e,t,n,o,r)=>{IE(e).undoManager.extra(t,n,o,r)})(e,r,o,t,n)}};return LE(e)||((e,t,n)=>{const o=Re(!1),r=e=>{OE(t,!1,n),t.add({},e)};e.on("init",()=>{t.add()}),e.on("BeforeExecCommand",e=>{const o=e.command;t_(o)||(BE(t,n),t.beforeChange())}),e.on("ExecCommand",e=>{const t=e.command;t_(t)||r(e)}),e.on("ObjectResizeStart cut",()=>{t.beforeChange()}),e.on("SaveContent ObjectResized blur",r),e.on("dragend",r),e.on("keyup",n=>{const s=n.keyCode;if(n.isDefaultPrevented())return;const a=sn.os.isMacOS()&&"Meta"===n.key;(s>=33&&s<=36||s>=37&&s<=40||45===s||n.ctrlKey||a)&&(r(),e.nodeChanged()),46!==s&&8!==s||e.nodeChanged(),o.get()&&t.typing&&!DE(e.readonly,kE(e),t.data[0])&&(e.isDirty()||e.setDirty(!0),e.dispatch("TypingUndo"),o.set(!1),e.nodeChanged())}),e.on("keydown",e=>{const s=e.keyCode;if(e.isDefaultPrevented())return;if(s>=33&&s<=36||s>=37&&s<=40||45===s)return void(t.typing&&r(e));const a=e.ctrlKey&&!e.altKey||e.metaKey;if((s<16||s>20)&&224!==s&&91!==s&&!t.typing&&!a)return t.beforeChange(),OE(t,!0,n),t.add({},e),void o.set(!0);!(sn.os.isMacOS()?e.metaKey:e.ctrlKey&&!e.altKey)||"Backspace"!==e.key&&"Delete"!==e.key||t.beforeChange()}),e.on("mousedown",e=>{t.typing&&r(e)}),e.on("input",e=>{var t;e.inputType&&("insertReplacementText"===e.inputType||"insertText"===(t=e).inputType&&null===t.data||(e=>"insertFromPaste"===e.inputType||"insertFromDrop"===e.inputType)(e))&&r(e)}),e.on("AddUndo Undo Redo ClearUndos",t=>{t.isDefaultPrevented()||e.nodeChanged()})})(e,r,n),(e=>{e.addShortcut("meta+z","","Undo"),e.addShortcut("meta+y,meta+shift+z","","Redo")})(e),r},o_=[9,27,Tp.HOME,Tp.END,19,20,44,144,145,33,34,45,16,17,18,91,92,93,Tp.DOWN,Tp.UP,Tp.LEFT,Tp.RIGHT].concat(sn.browser.isFirefox()?[224]:[]),r_="data-mce-placeholder",s_=e=>"keydown"===e.type||"keyup"===e.type,a_=e=>{const t=e.keyCode;return t===Tp.BACKSPACE||t===Tp.DELETE},i_=e=>(t,n,o={})=>{const r=t.getBody(),s={bubbles:!0,composed:!0,data:null,isComposing:!1,detail:0,view:null,target:r,currentTarget:r,eventPhase:Event.AT_TARGET,originalTarget:r,explicitOriginalTarget:r,isTrusted:!1,srcElement:r,cancelable:!1,preventDefault:x,inputType:n},a=Qa(new InputEvent(e));return t.dispatch(e,{...a,...s,...o})},l_=i_("input"),c_=i_("beforeinput"),d_=(e,t,n)=>{let o=!0;const r=()=>o=!1;if(c_(e,t?"deleteContentForward":"deleteContentBackward").isDefaultPrevented())return!1;e.on("input",r);try{n()}finally{e.off("input",r)}return o&&e.dispatch("input"),!0},m_=e=>t=>C(t)&&e.test(t.nodeName),u_=e=>C(e)&&3===e.nodeType,f_=e=>C(e)&&1===e.nodeType,g_=m_(/^(OL|UL|DL)$/),p_=m_(/^(OL|UL)$/),h_=m_(/^(LI|DT|DD)$/),b_=m_(/^(DT|DD)$/),y_=m_(/^(TH|TD)$/),v_=e=>C(e)&&"br"===e.nodeName.toLowerCase(),C_=(e,t)=>C(t)&&t.nodeName in e.schema.getTextBlockElements(),w_=(e,t)=>C(e)&&e.nodeName in t,S_=(e,t)=>C(t)&&t.nodeName in e.schema.getVoidElements(),E_=(e,t,n)=>{const o=e.isEmpty(t);return!(n&&e.select("span[data-mce-type=bookmark]",t).length>0)&&o},x_=(e,t)=>e.isChildOf(t,e.getRoot()),__=gi.DOM,k_=(e,t)=>{const n=dn.grep(e.select("ol,ul",t));dn.each(n,t=>{((e,t)=>{const n=t.parentElement;if(n&&"LI"===n.nodeName&&n.firstChild===t){const o=n.previousSibling;o&&"LI"===o.nodeName?(o.appendChild(t),E_(e,n)&&__.remove(n)):__.setStyle(n,"listStyleType","none")}if(g_(n)){const e=n.previousSibling;e&&"LI"===e.nodeName&&e.appendChild(t)}})(e,t)})},N_=(e,t)=>{if(u_(e))return{container:e,offset:t};const n=Gp.getNode(e,t);return u_(n)?{container:n,offset:t>=e.childNodes.length?n.data.length:0}:n.previousSibling&&u_(n.previousSibling)?{container:n.previousSibling,offset:n.previousSibling.data.length}:n.nextSibling&&u_(n.nextSibling)?{container:n.nextSibling,offset:0}:{container:e,offset:t}},R_=e=>{const t=e.cloneRange(),n=N_(e.startContainer,e.startOffset);t.setStart(n.container,n.offset);const o=N_(e.endContainer,e.endOffset);return t.setEnd(o.container,o.offset),t},A_=e=>wn(e,"OL,UL"),D_=e=>wn(e,"LI"),T_=e=>Wn(e).exists(A_),O_=["OL","UL","DL"],B_=O_.join(","),P_=(e,t)=>{const n=t||e.selection.getStart(!0);return e.dom.getParent(n,B_,I_(e,n,e.selection.isCollapsed()))},L_=e=>{const t=e.selection.getSelectedBlocks();return Y(((e,t,n)=>{const o=dn.map(t,t=>e.dom.getParent(t,"li,dd,dt",I_(e,t,n))||t);return fe(o)})(e,t,e.selection.isCollapsed()),h_)},M_=(e,t)=>{const n=e.dom.getParents(t,"TD,TH");return n.length>0?n[0]:e.getBody()},I_=(e,t,n)=>{const o=e.dom.getParents(t,e.dom.isBlock);let r=!(e=>ue(e,e=>D_(un.fromDom(e))?I.some(!0):y_(e)?I.some(!1):I.none()).getOr(!1))(o);const s=Z(o,t=>{return(D_(un.fromDom(a=t))||A_(un.fromDom(a)))&&(r=!0),r&&(!n||(t=>t.nodeName.toLowerCase()!==Ed(e))(t))&&(o=e.schema,!g_(s=t)&&!h_(s)&&H(O_,e=>o.isValidChild(s.nodeName,e)));var o,s,a});return s.getOr(e.getBody())},F_=(e,t)=>{const n=e.dom.getParents(t,"ol,ul",I_(e,t,!0));return de(n)},U_=(e,t)=>{const n=V(t,t=>F_(e,t).getOr(t));return fe(n)},z_=e=>/\btox\-/.test(e.className),j_=(e,t)=>null!==t&&!e.dom.isEditable(t),$_=(e,t)=>{const n=e.dom.getParent(t,"ol,ul,dl");return j_(e,n)||!e.selection.isEditable()},H_=(e,t,n)=>e.dispatch("ListMutation",{action:t,element:n}),V_=(e,t,n={})=>{const o=e.dom,r=e.schema.getBlockElements(),s=o.createFragment(),a=Ed(e),i=xd(e);let l,c,d=!1;for(c=o.create(a,{...i,...n.style?{style:n.style}:{}}),w_(t.firstChild,r)||s.appendChild(c);l=t.firstChild;){const e=l.nodeName;d||"SPAN"===e&&"bookmark"===l.getAttribute("data-mce-type")||(d=!0),w_(l,r)?(s.appendChild(l),c=null):(c||(c=o.create(a,i),s.appendChild(c)),c.appendChild(l))}return!d&&c&&c.appendChild(o.create("br",{"data-mce-bogus":"1"})),s},q_=e=>"listAttributes"in e,W_=e=>"isComment"in e,K_=e=>e.depth>0,Y_=e=>e.isSelected,G_=e=>{const t=Vn(e),n=Kn(e).exists(A_)?t.slice(0,-1):t;return V(n,Oo)},X_=(e,t)=>{go(e.item,t.list)},Q_=(e,t)=>{const n={list:un.fromTag(t,e),item:un.fromTag("li",e)};return go(n.list,n.item),n},Z_=(e,t,n)=>{const o=t.slice(0,n.depth);return de(o).each(t=>{if(q_(n)){const o=((e,t,n)=>{const o=un.fromTag("li",e);return Co(o,t),bo(o,n),o})(e,n.itemAttributes,n.content);((e,t)=>{go(e.list,t),e.item=t})(t,o),((e,t)=>{En(e.list)!==t.listType&&(e.list=Bo(e.list,t.listType)),Co(e.list,t.listAttributes)})(t,n)}else if((e=>"isFragment"in e)(n))bo(t.item,n.content);else{const e=un.fromHtml(`\x3c!--${n.content}--\x3e`);go(t.list,e)}}),o},J_=e=>(q(e,(t,n)=>{((e,t)=>{const n=e[t].depth,o=e=>e.depth===n&&!e.dirty,r=e=>e.depth<n;return Q(re(e.slice(0,t)),o,r).orThunk(()=>Q(e.slice(t+1),o,r))})(e,n).fold(()=>{t.dirty&&q_(t)&&(e=>{e.listAttributes=we(e.listAttributes,(e,t)=>"start"!==t)})(t)},e=>{return o=e,void(q_(n=t)&&q_(o)&&(n.listType=o.listType,n.listAttributes={...o.listAttributes}));var n,o})}),e),ek=(e,t,n,o)=>{if(kn(o))return[{depth:e+1,content:o.dom.nodeValue??"",dirty:!1,isSelected:!1,isComment:!0}];t.each(e=>{vn(e.start,o)&&n.set(!0)});const r=((e,t,n)=>Mn(e).filter(Rn).map(o=>({depth:t,dirty:!1,isSelected:n,content:G_(e),itemAttributes:ko(e),listAttributes:ko(o),listType:En(o),isInPreviousLi:!1})))(o,e,n.get());t.each(e=>{vn(e.end,o)&&n.set(!1)});const s=Kn(o).filter(A_).map(o=>nk(e,t,n,o)).getOr([]);return r.toArray().concat(s)},tk=(e,t,n,o)=>Wn(o).filter(A_).fold(()=>ek(e,t,n,o),r=>{const s=X(Vn(o),(o,s,a)=>{if(0===a)return o;if(D_(s))return o.concat(ek(e,t,n,s));{const t={isFragment:!0,depth:e,content:[s],isSelected:!1,dirty:!1,parentListType:En(r)};return o.concat(t)}},[]);return nk(e,t,n,r).concat(s)}),nk=(e,t,n,o)=>ne(Vn(o),o=>(A_(o)?nk:tk)(e+1,t,n,o)),ok=(e,t)=>{const n=J_(t);return((e,t)=>{let n=I.none();const o=X(t,(t,o,r)=>W_(o)?0===r?(n=I.some(o),t):Z_(e,t,o):o.depth>t.length?((e,t,n)=>{const o=((e,t,n)=>{const o=[];for(let r=0;r<n;r++)o.push(Q_(e,q_(t)?t.listType:t.parentListType));return o})(e,n,n.depth-t.length);var r;return(e=>{for(let t=1;t<e.length;t++)X_(e[t-1],e[t])})(o),((e,t)=>{for(let t=0;t<e.length-1;t++)zo(e[t].item,"list-style-type","none");de(e).each(e=>{q_(t)&&(Co(e.list,t.listAttributes),Co(e.item,t.itemAttributes)),bo(e.item,t.content)})})(o,n),r=o,$e(de(t),ce(r),X_),t.concat(o)})(e,t,o):Z_(e,t,o),[]);return n.each(e=>{const t=un.fromHtml(`\x3c!--${e.content}--\x3e`);ce(o).each(e=>{fo(e.list,t)})}),ce(o).map(e=>e.list)})(e.contentDocument,n).toArray()},rk=(e,t,n)=>{const o=((e,t)=>{const n=Re(!1);return V(e,e=>({sourceList:e,entries:nk(0,t,n,e)}))})(t,(e=>{const t=V(L_(e),un.fromDom);return $e(Z(t,T(T_)),Z(re(t),T(T_)),(e,t)=>({start:e,end:t}))})(e));q(o,t=>{((e,t,n)=>{q(Y(t,Y_),t=>((e,t,n)=>{switch(t){case"Indent":if(!((e,t)=>bu(e).map(e=>e>=t).getOr(!0))(e,n.depth))return;n.depth++;break;case"Outdent":n.depth--;break;case"Flatten":n.depth=0}n.dirty=!0})(e,n,t))})(e,t.entries,n);const o=((e,t)=>ne(((e,t)=>{if(0===e.length)return[];{let n=t(e[0]);const o=[];let r=[];for(let s=0,a=e.length;s<a;s++){const a=e[s],i=t(a);i!==n&&(o.push(r),r=[]),n=i,r.push(a)}return 0!==r.length&&o.push(r),o}})(t,K_),t=>ce(t).exists(K_)?ok(e,t):((e,t)=>{const n=J_(t);return V(n,t=>{const n=W_(t)?tr([un.fromHtml(`\x3c!--${t.content}--\x3e`)]):tr(t.content),o=q_(t)?t.itemAttributes:{};return un.fromDom(V_(e,n.dom,o))})})(e,t)))(e,t.entries);var r;q(o,t=>{H_(e,"Indent"===n?"IndentList":"OutdentList",t.dom)}),r=t.sourceList,q(o,e=>{mo(r,e)}),Ro(t.sourceList)})},sk=gi.DOM,ak=On("dd"),ik=On("dt"),lk=e=>{ik(e)&&Bo(e,"dd")},ck=(e,t,n)=>{q(n,"Indent"===t?lk:t=>((e,t)=>{ak(t)?Bo(t,"dt"):ik(t)&&In(t).each(n=>((e,t,n)=>{const o=sk.select('span[data-mce-type="bookmark"]',t),r=V_(e,n),s=sk.createRng();s.setStartAfter(n),s.setEndAfter(t);const a=s.extractContents();for(let t=a.firstChild;t;t=t.firstChild)if("LI"===t.nodeName&&e.dom.isEmpty(t)){sk.remove(t);break}e.dom.isEmpty(a)||sk.insertAfter(a,t),sk.insertAfter(r,t);const i=n.parentElement;i&&E_(e.dom,i)&&(e=>{const t=e.parentNode;t&&dn.each(o,e=>{t.insertBefore(e,n.parentNode)}),sk.remove(e)})(i),sk.remove(n),E_(e.dom,t)&&sk.remove(t)})(e,n.dom,t.dom))})(e,t))},dk=(e,t)=>{const n=Po((e=>{const t=(e=>{const t=F_(e,e.selection.getStart()),n=Y(e.selection.getSelectedBlocks(),p_);return t.toArray().concat(n)})(e),n=(e=>{const t=e.selection.getStart();return e.dom.getParents(t,"ol,ul",I_(e,t,e.selection.isCollapsed()))})(e);return Z(n,e=>{return t=un.fromDom(e),Mn(t).exists(e=>h_(e.dom)&&Wn(e).exists(e=>!g_(e.dom))&&Kn(e).exists(e=>!g_(e.dom)));var t}).fold(()=>U_(e,t),e=>[e])})(e)),o=Po((e=>Y(L_(e),b_))(e));let r=!1;if(n.length||o.length){const s=e.selection.getBookmark();rk(e,n,t),ck(e,t,o),e.selection.moveToBookmark(s),e.selection.setRng(R_(e.selection.getRng())),e.nodeChanged(),r=!0}return r},mk=(e,t)=>!(e=>{const t=P_(e);return j_(e,t)||!e.selection.isEditable()})(e)&&dk(e,t),uk=e=>mk(e,"Indent"),fk=e=>mk(e,"Outdent"),gk=e=>mk(e,"Flatten"),pk=e=>{switch(e){case"UL":return"ToggleUlList";case"OL":return"ToggleOlList";case"DL":return"ToggleDLList"}},hk=(e,t)=>{dn.each(t,(t,n)=>{e.setAttribute(n,t)})},bk=(e,t,n)=>{((e,t,n)=>{const o=n["list-style-type"]?n["list-style-type"]:null;e.setStyle(t,"list-style-type",o)})(e,t,n),((e,t,n)=>{hk(t,n["list-attributes"]),dn.each(e.select("li",t),e=>{hk(e,n["list-item-attributes"])})})(e,t,n)},yk=(e,t)=>C(t)&&!w_(t,e.schema.getBlockElements()),vk=(e,t,n,o)=>{let r=t[n?"startContainer":"endContainer"];const s=t[n?"startOffset":"endOffset"];f_(r)&&(r=r.childNodes[Math.min(s,r.childNodes.length-1)]||r),!n&&v_(r.nextSibling)&&(r=r.nextSibling);const a=(t,n)=>{const r=new Kr(t,(t=>{for(;!e.dom.isBlock(t)&&t.parentNode&&o!==t;)t=t.parentNode;return t})(t)),s=n?"next":"prev";let a;for(;a=r[s]();)if(!S_(e,a)&&!mt(a.textContent)&&0!==a.textContent?.length)return I.some(a);return I.none()};if(n&&u_(r))if(mt(r.textContent))r=a(r,!1).getOr(r);else for(null!==r.parentNode&&yk(e,r.parentNode)&&(r=r.parentNode);null!==r.previousSibling&&(yk(e,r.previousSibling)||u_(r.previousSibling));)r=r.previousSibling;if(!n&&u_(r))if(mt(r.textContent))r=a(r,!0).getOr(r);else for(null!==r.parentNode&&yk(e,r.parentNode)&&(r=r.parentNode);null!==r.nextSibling&&(yk(e,r.nextSibling)||u_(r.nextSibling));)r=r.nextSibling;for(;r.parentNode!==o;){const t=r.parentNode;if(C_(e,r))return r;if(/^(TD|TH)$/.test(t.nodeName))return r;r=t}return r},Ck=(e,t,n)=>{const o=e.selection.getRng();let r="LI";const s=I_(e,((e,t)=>{const n=e.selection.getStart(!0),o=vk(e,t,!0,e.getBody());return r=un.fromDom(o),s=un.fromDom(t.commonAncestorContainer),Ar(r,D(vn,s))?t.commonAncestorContainer:n;var r,s})(e,o),o.collapsed),a=e.dom;if("false"===a.getContentEditable(e.selection.getNode()))return;"DL"===(t=t.toUpperCase())&&(r="DT");const i=Xy(o),l=Y(((e,t,n)=>{const o=[],r=e.dom,s=vk(e,t,!0,n),a=vk(e,t,!1,n);let i;const l=[];for(let e=s;e&&(l.push(e),e!==a);e=e.nextSibling);return dn.each(l,t=>{if(C_(e,t))return o.push(t),void(i=null);if(r.isBlock(t)||v_(t))return v_(t)&&r.remove(t),void(i=null);const s=t.nextSibling;ip.isBookmarkNode(t)&&(g_(s)||C_(e,s)||!s&&t.parentNode===n)?i=null:(i||(i=r.create("p"),t.parentNode?.insertBefore(i,t),o.push(i)),i.appendChild(t))}),o})(e,o,s),e.dom.isEditable);dn.each(l,o=>{let s;const i=o.previousSibling,l=o.parentNode;h_(l)||(i&&g_(i)&&i.nodeName===t&&((e,t,n)=>{const o=e.getStyle(t,"list-style-type");let r=n?n["list-style-type"]:"";return r=null===r?"":r,o===r})(a,i,n)?(s=i,o=a.rename(o,r),i.appendChild(o)):(s=a.create(t),l.insertBefore(s,o),s.appendChild(o),o=a.rename(o,r)),((e,t)=>{dn.each(["margin","margin-right","margin-bottom","margin-left","margin-top","padding","padding-right","padding-bottom","padding-left","padding-top"],n=>e.setStyle(t,n,""))})(a,o),bk(a,s,n),Sk(e.dom,s))}),e.selection.setRng(Qy(i))},wk=(e,t,n)=>{return((e,t)=>g_(e)&&e.nodeName===t?.nodeName)(t,n)&&((e,t,n)=>e.getStyle(t,"list-style-type",!0)===e.getStyle(n,"list-style-type",!0))(e,t,n)&&(o=n,t.className===o.className);var o},Sk=(e,t)=>{let n,o=t.nextSibling;if(wk(e,t,o)){const r=o;for(;n=r.firstChild;)t.appendChild(n);e.remove(r)}if(o=t.previousSibling,wk(e,t,o)){const r=o;for(;n=r.lastChild;)t.insertBefore(n,t.firstChild);e.remove(r)}},Ek=(e,t,n,o)=>{if(t.nodeName!==n){const r=e.dom.rename(t,n);bk(e.dom,r,o),H_(e,pk(n),r)}else bk(e.dom,t,o),H_(e,pk(n),t)},xk=(e,t,n,o)=>{if(t.classList.forEach((e,n,o)=>{e.startsWith("tox-")&&(o.remove(e),0===o.length&&t.removeAttribute("class"))}),t.nodeName!==n){const r=e.dom.rename(t,n);bk(e.dom,r,o),H_(e,pk(n),r)}else bk(e.dom,t,o),H_(e,pk(n),t)},_k=e=>"list-style-type"in e,kk=(e,t,n)=>{const o=P_(e);if($_(e,o))return;const r=(e=>{const t=P_(e),n=e.selection.getSelectedBlocks();return((e,t)=>C(e)&&1===t.length&&t[0]===e)(t,n)?(e=>Y(e.querySelectorAll(B_),g_))(t):Y(n,e=>g_(e)&&t!==e)})(e),s=f(n)?n:{};r.length>0?((e,t,n,o,r)=>{const s=g_(t);if(!s||t.nodeName!==o||_k(r)||z_(t)){Ck(e,o,r);const a=Xy(e.selection.getRng()),i=s?[t,...n]:n,l=s&&z_(t)?xk:Ek;dn.each(i,t=>{l(e,t,o,r)}),e.selection.setRng(Qy(a))}else gk(e)})(e,o,r,t,s):((e,t,n,o)=>{if(t!==e.getBody())if(t)if(t.nodeName!==n||_k(o)||z_(t)){const r=Xy(e.selection.getRng());z_(t)&&t.classList.forEach((e,n,o)=>{e.startsWith("tox-")&&(o.remove(e),0===o.length&&t.removeAttribute("class"))}),bk(e.dom,t,o);const s=e.dom.rename(t,n);Sk(e.dom,s),e.selection.setRng(Qy(r)),Ck(e,n,o),H_(e,pk(n),s)}else gk(e);else Ck(e,n,o),H_(e,pk(n),t)})(e,o,t,s),(e=>{q(L_(e),t=>{const n=e.dom.getStyle(t,"list-style-type");C(n)&&"none"!==n&&e.dom.setStyle(t,"list-style-type","")})})(e)},Nk=(e,t,n,o)=>{let r=t.startContainer;const s=t.startOffset;if(u_(r)&&(n?s<r.data.length:s>0))return r;const a=e.schema.getNonEmptyElements();f_(r)&&(r=Gp.getNode(r,s));const i=new Kr(r,o);n&&((e,t)=>!!v_(t)&&e.isBlock(t.nextSibling)&&!v_(t.previousSibling))(e.dom,r)&&i.next();const l=n?i.next.bind(i):i.prev2.bind(i);for(;r=l();){if("LI"===r.nodeName&&!r.hasChildNodes())return r;if(a[r.nodeName])return r;if(u_(r)&&r.data.length>0)return r}return null},Rk=(e,t)=>{const n=t.childNodes;return 1===n.length&&!g_(n[0])&&e.isBlock(n[0])},Ak=(e,t,n)=>{let o;const r=Rk(e,n)?n.firstChild:n;if(((e,t)=>{var n;Rk(e,t)&&(n=t.firstChild,I.from(n).map(un.fromDom).filter(Nn).exists(e=>Sr(e)&&!$(["details"],En(e))))&&e.remove(t.firstChild,!0)})(e,t),!E_(e,t,!0))for(;o=t.firstChild;)r.appendChild(o)},Dk=(e,t,n)=>{let o;const r=t.parentNode;if(!x_(e,t)||!x_(e,n))return;g_(n.lastChild)&&(o=n.lastChild),r===n.lastChild&&v_(r.previousSibling)&&e.remove(r.previousSibling);const s=n.lastChild;s&&v_(s)&&t.hasChildNodes()&&e.remove(s),E_(e,n,!0)&&No(un.fromDom(n)),Ak(e,t,n),o&&n.appendChild(o);const a=Cn(un.fromDom(n),un.fromDom(t))?e.getParents(t,g_,n):[];e.remove(t),q(a,t=>{E_(e,t)&&t!==e.getRoot()&&e.remove(t)})},Tk=(e,t)=>{const n=e.dom,o=e.selection,r=o.getStart(),s=M_(e,r),a=n.getParent(o.getStart(),"LI",s);if(a){const r=a.parentElement;if(r===e.getBody()&&E_(n,r))return!0;const i=R_(o.getRng()),l=n.getParent(Nk(e,i,t,s),"LI",s),c=l&&(t?n.isChildOf(a,l):n.isChildOf(l,a));if(l&&l!==a&&!c)return e.undoManager.transact(()=>{var n;t?((e,t,n,o)=>{const r=e.dom;if(r.isEmpty(o))((e,t,n)=>{No(un.fromDom(n)),Dk(e.dom,t,n),e.selection.setCursorLocation(n,0)})(e,n,o);else{const s=Xy(t);Dk(r,n,o),e.selection.setRng(Qy(s))}})(e,i,l,a):(n=a,n.parentNode?.firstChild===n?fk(e):((e,t,n,o)=>{const r=Xy(t);Dk(e.dom,n,o);const s=Qy(r);e.selection.setRng(s)})(e,i,a,l))}),!0;if(c&&!t&&l!==a){const t=i.commonAncestorContainer.parentElement;return!(!t||n.isChildOf(l,t)||(e.undoManager.transact(()=>{const o=Xy(i);Ak(n,t,l),t.remove();const r=Qy(o);e.selection.setRng(r)}),0))}if(!l&&!t&&0===i.startOffset&&0===i.endOffset)return e.undoManager.transact(()=>{gk(e)}),!0}return!1},Ok=e=>{const t=e.selection.getStart(),n=M_(e,t),o=e.dom.getParent(t,"LI,DT,DD",n);return C(o)||L_(e).length>0},Bk=(e,t)=>{const n=e.selection;return!$_(e,n.getNode())&&(n.isCollapsed()?((e,t)=>Tk(e,t)||((e,t)=>{const n=e.dom,o=e.selection.getStart(),r=M_(e,o),s=n.getParent(o,n.isBlock,r);if(s&&n.isEmpty(s,void 0,{checkRootAsContent:!0})){const o=R_(e.selection.getRng()),a=Nk(e,o,t,r),i=n.getParent(a,"LI",r);if(a&&i&&(t||!n.isChildOf(a,s))){const l=e=>$(["td","th","caption"],En(e)),c=e=>e.dom===r,d=lr(un.fromDom(i),l,c),m=lr(un.fromDom(o.startContainer),l,c);return!!je(d,m,vn)&&(e.undoManager.transact(()=>{const o=i.parentNode;((e,t,n)=>{const o=e.getParent(t.parentNode,e.isBlock,n);e.remove(t),o&&e.isEmpty(o)&&e.remove(o)})(n,s,r),Sk(n,o),e.selection.select(a,!0),e.selection.collapse(t)}),!0)}}return!1})(e,t))(e,t):((e,t)=>!!Ok(e)&&(e.undoManager.transact(()=>{d_(e,t,()=>e.execCommand("Delete"))&&k_(e.dom,e.getBody())}),!0))(e,t))},Pk=(e,t)=>({from:e,to:t}),Lk=(e,t)=>{const n=un.fromDom(e),o=un.fromDom(t.container());return cy(n,o).map(e=>((e,t)=>({block:e,position:t}))(e,t))},Mk=(e,t)=>lr(t,e=>Hi(e)||gs(e.dom),t=>vn(t,e)).filter(Rn).getOr(e),Ik=(e,t)=>{const n=((e,t)=>{const n=Vn(e);return J(n,e=>t.isBlock(En(e))).fold(N(n),e=>n.slice(0,e))})(e,t);return q(n,Ro),n},Fk=(e,t,n)=>{const o=mb(n,t);return Z(o.reverse(),t=>Ls(e,t)).each(Ro)},Uk=(e,t,n,o,r)=>{if(Ls(o,n))return Wi(n),Rf(n.dom);((e,t)=>0===Y($n(t),t=>!Ls(e,t)).length)(o,r)&&Ls(o,t)&&mo(r,un.fromTag("br"));const s=Nf(n.dom,Kl.before(r.dom));return q(Ik(t,o),e=>{mo(r,e)}),Fk(o,e,t),s},zk=(e,t,n,o)=>{if(Ls(o,n)){if(Ls(o,t)){const e=e=>{const t=(e,n)=>Wn(e).fold(()=>n,e=>((e,t)=>e.isInline(En(t)))(o,e)?t(e,n.concat(To(e))):n);return t(e,[])},r=G(e(n),(e,t)=>(po(e,t),t),qi());No(t),go(t,r)}return Ro(n),Rf(t.dom)}const r=Af(n.dom);return q(Ik(t,o),e=>{go(n,e)}),Fk(o,e,t),r},jk=(e,t)=>{_f(e,t.dom).bind(e=>I.from(e.getNode())).map(un.fromDom).filter(Mi).each(Ro)},$k=(e,t,n,o)=>(jk(!0,t),jk(!1,n),((e,t)=>Cn(t,e)?((e,t)=>{const n=mb(t,e);return I.from(n[n.length-1])})(t,e):I.none())(t,n).fold(D(zk,e,t,n,o),D(Uk,e,t,n,o))),Hk=(e,t,n,o,r)=>t?$k(e,o,n,r):$k(e,n,o,r),Vk=(e,t)=>{const n=un.fromDom(e.getBody()),o=((e,t,n,o)=>o.collapsed?((e,t,n,o)=>{const r=Lk(t,Kl.fromRangeStart(o)),s=r.bind(o=>Sf(n,t,o.position).bind(o=>Lk(t,o).map(o=>((e,t,n,o)=>ms(o.position.getNode())&&!Ls(e,o.block)?_f(!1,o.block.dom).bind(e=>e.isEqual(o.position)?Sf(n,t,e).bind(e=>Lk(t,e)):I.some(o)).getOr(o):o)(e,t,n,o))));return $e(r,s,Pk).filter(e=>(e=>!vn(e.from.block,e.to.block))(e)&&((e,t)=>{const n=un.fromDom(e);return vn(Mk(n,t.from.block),Mk(n,t.to.block))})(t,e)&&(e=>!1===ps(e.from.block.dom)&&!1===ps(e.to.block.dom))(e)&&(e=>{const t=e=>Ui(e)||Gs(e.dom)||ji(e);return t(e.from.block)&&t(e.to.block)})(e)&&(e=>!(Cn(e.to.block,e.from.block)||Cn(e.from.block,e.to.block)))(e))})(e,t,n,o):I.none())(e.schema,n.dom,t,e.selection.getRng()).map(o=>()=>{Hk(n,t,o.from.block,o.to.block,e.schema).each(t=>{e.selection.setRng(t.toRange())})});return o},qk=(e,t)=>{const n=un.fromDom(t),o=D(vn,e);return ir(n,Hi,o).isSome()},Wk=e=>{const t=un.fromDom(e.getBody());return((e,t)=>{const n=Nf(e.dom,Kl.fromRangeStart(t)).isNone(),o=kf(e.dom,Kl.fromRangeEnd(t)).isNone();return!((e,t)=>qk(e,t.startContainer)||qk(e,t.endContainer))(e,t)&&n&&o})(t,e.selection.getRng())?(e=>I.some(()=>{e.setContent(""),e.selection.setCursorLocation()}))(e):((e,t,n)=>{const o=t.getRng();return $e(cy(e,un.fromDom(o.startContainer)),cy(e,un.fromDom(o.endContainer)),(r,s)=>vn(r,s)?I.none():I.some(()=>{o.deleteContents(),Hk(e,!0,r,s,n).each(e=>{t.setRng(e.toRange())})})).getOr(I.none())})(t,e.selection,e.schema)},Kk=(e,t)=>e.selection.isCollapsed()?I.none():Wk(e),Yk=(e,t,n,o,r)=>I.from(t._selectionOverrides.showCaret(e,n,o,r)),Gk=(e,t)=>e.dispatch("BeforeObjectSelected",{target:t}).isDefaultPrevented()?I.none():I.some((e=>{const t=e.ownerDocument.createRange();return t.selectNode(e),t})(t)),Xk=(e,t,n)=>t.collapsed?((e,t,n)=>{const o=tf(1,e.getBody(),t),r=Kl.fromRangeStart(o),s=r.getNode();if(Ou(s))return Yk(1,e,s,!r.isAtEnd(),!1);const a=r.getNode(!0);if(Ou(a))return Yk(1,e,a,!1,!1);const i=zy(e.dom.getRoot(),r.getNode());return Ou(i)?Yk(1,e,i,!1,n):I.none()})(e,t,n).getOr(t):t,Qk=e=>lb(e)||rb(e),Zk=e=>cb(e)||sb(e),Jk=(e,t,n,o,r,s)=>{Yk(o,e,s.getNode(!r),r,!0).each(n=>{if(t.collapsed){const e=t.cloneRange();r?e.setEnd(n.startContainer,n.startOffset):e.setStart(n.endContainer,n.endOffset),e.deleteContents()}else t.deleteContents();e.selection.setRng(n)}),((e,t)=>{ss(t)&&0===t.data.length&&e.remove(t)})(e.dom,n)},eN=(e,t)=>((e,t)=>{const n=e.selection.getRng();if(!ss(n.commonAncestorContainer))return I.none();const o=t?1:-1,r=yf(e.getBody()),s=D(sf,t?r.next:r.prev),a=t?Qk:Zk,i=of(o,e.getBody(),n),l=s(i),c=l?ny(t,l):l;if(!c||!af(i,c))return I.none();if(a(c))return I.some(()=>Jk(e,n,i.getNode(),o,t,c));const d=s(c);return d&&a(d)&&af(c,d)?I.some(()=>Jk(e,n,i.getNode(),o,t,d)):I.none()})(e,t),tN=(e,t)=>{const n=e.getBody();return t?Rf(n).filter(lb):Af(n).filter(cb)},nN=e=>{const t=e.selection.getRng();return!t.collapsed&&(tN(e,!0).exists(e=>e.isEqual(Kl.fromRangeStart(t)))||tN(e,!1).exists(e=>e.isEqual(Kl.fromRangeEnd(t))))},oN=Ne([{remove:["element"]},{moveToElement:["element"]},{moveToPosition:["position"]}]),rN=(e,t,n,o)=>Sf(t,e,n).bind(r=>{return s=r.getNode(),C(s)&&(Hi(un.fromDom(s))||ji(un.fromDom(s)))||((e,t,n,o,r)=>{const s=t=>r.isInline(t.nodeName.toLowerCase())&&!Yu(n,o,e);return nf(!t,n).fold(()=>nf(t,o).fold(L,s),s)})(e,t,n,r,o)?I.none():t&&ps(r.getNode())||!t&&ps(r.getNode(!0))?((e,t,n,o,r)=>{const s=r.getNode(!n);return cy(un.fromDom(t),un.fromDom(o.getNode())).map(t=>Ls(e,t)?oN.remove(t.dom):oN.moveToElement(s)).orThunk(()=>I.some(oN.moveToElement(s)))})(o,e,t,n,r):t&&cb(n)||!t&&lb(n)?I.some(oN.moveToPosition(r)):I.none();var s}),sN=(e,t)=>I.from(zy(e.getBody(),t)),aN=(e,t)=>{const n=e.selection.getNode();return sN(e,n).filter(ps).fold(()=>((e,t,n,o)=>{const r=tf(t?1:-1,e,n),s=Kl.fromRangeStart(r),a=un.fromDom(e);return!t&&cb(s)?I.some(oN.remove(s.getNode(!0))):t&&lb(s)?I.some(oN.remove(s.getNode())):!t&&lb(s)&&Eb(a,s,o)?xb(a,s,o).map(e=>oN.remove(e.getNode())):t&&cb(s)&&Sb(a,s,o)?_b(a,s,o).map(e=>oN.remove(e.getNode())):((e,t,n,o)=>((e,t)=>{const n=t.getNode(!e),o=e?"after":"before";return Xr(n)&&n.getAttribute("data-mce-caret")===o})(t,n)?((e,t)=>v(t)?I.none():e&&ps(t.nextSibling)?I.some(oN.moveToElement(t.nextSibling)):!e&&ps(t.previousSibling)?I.some(oN.moveToElement(t.previousSibling)):I.none())(t,n.getNode(!t)).orThunk(()=>rN(e,t,n,o)):rN(e,t,n,o).bind(t=>((e,t,n)=>n.fold(e=>I.some(oN.remove(e)),e=>I.some(oN.moveToElement(e)),n=>Yu(t,n,e)?I.none():I.some(oN.moveToPosition(n))))(e,n,t)))(e,t,s,o)})(e.getBody(),t,e.selection.getRng(),e.schema).map(n=>()=>n.fold(((e,t)=>n=>(e._selectionOverrides.hideFakeCaret(),Qb(e,t,un.fromDom(n)),!0))(e,t),((e,t)=>n=>{const o=t?Kl.before(n):Kl.after(n);return e.selection.setRng(o.toRange()),!0})(e,t),(e=>t=>(e.selection.setRng(t.toRange()),!0))(e))),()=>I.some(x))},iN=e=>{const t=e.dom,n=e.selection,o=zy(e.getBody(),n.getNode());if(gs(o)&&t.isBlock(o)&&t.isEmpty(o)){const e=t.create("br",{"data-mce-bogus":"1"});t.setHTML(o,""),o.appendChild(e),n.setRng(Kl.before(e).toRange())}return!0},lN=(e,t)=>e.selection.isCollapsed()?aN(e,t):((e,t)=>{const n=e.selection.getNode();return ps(n)&&!bs(n)?sN(e,n.parentNode).filter(ps).fold(()=>I.some(()=>{var n;n=un.fromDom(e.getBody()),q(Rr(n,".mce-offscreen-selection"),Ro),Qb(e,t,un.fromDom(e.selection.getNode())),dy(e)}),()=>I.some(x)):nN(e)?I.some(()=>{fy(e,e.selection.getRng(),un.fromDom(e.getBody()))}):I.none()})(e,t),cN=(e,t)=>{const n=e.dom,o=n.getParent(e.selection.getStart(),n.isBlock),r=n.getParent(e.selection.getEnd(),n.isBlock),s=e.getBody(),a=o?.nodeName?.toLowerCase();if("div"===a&&o&&r&&o===s.firstChild&&r===s.lastChild&&!n.isEmpty(s)){const n=o.cloneNode(!1),r=()=>{if(t?iy(e):ay(e),s.firstChild!==o){const t=Xy(e.selection.getRng(),()=>document.createElement("span"));Array.from(s.childNodes).forEach(e=>n.appendChild(e)),s.appendChild(n),e.selection.setRng(Qy(t))}};return I.some(r)}return I.none()},dN=(e,t)=>e.selection.isCollapsed()?((e,t)=>{const n=Kl.fromRangeStart(e.selection.getRng());return Sf(t,e.getBody(),n).filter(e=>t?nb(e):ob(e)).bind(e=>Gu(t?0:-1,e)).map(t=>()=>e.selection.select(t))})(e,t):I.none(),mN=ss,uN=e=>mN(e)&&e.data[0]===Ki,fN=e=>mN(e)&&e.data[e.data.length-1]===Ki,gN=e=>(e.ownerDocument??document).createTextNode(Ki),pN=(e,t)=>e?(e=>{if(mN(e.previousSibling))return fN(e.previousSibling)||e.previousSibling.appendData(Ki),e.previousSibling;if(mN(e))return uN(e)||e.insertData(0,Ki),e;{const t=gN(e);return e.parentNode?.insertBefore(t,e),t}})(t):(e=>{if(mN(e.nextSibling))return uN(e.nextSibling)||e.nextSibling.insertData(0,Ki),e.nextSibling;if(mN(e))return fN(e)||e.appendData(Ki),e;{const t=gN(e);return e.nextSibling?e.parentNode?.insertBefore(t,e.nextSibling):e.parentNode?.appendChild(t),t}})(t),hN=D(pN,!0),bN=D(pN,!1),yN=(e,t)=>ss(e.container())?pN(t,e.container()):pN(t,e.getNode()),vN=(e,t)=>{const n=t.get();return n&&e.container()===n&&Ji(n)},CN=(e,t)=>t.fold(t=>{_u(e.get());const n=hN(t);return e.set(n),I.some(Kl(n,n.length-1))},t=>Rf(t).map(t=>{if(vN(t,e)){const t=e.get();return Kl(t,1)}{_u(e.get());const n=yN(t,!0);return e.set(n),Kl(n,1)}}),t=>Af(t).map(t=>{if(vN(t,e)){const t=e.get();return Kl(t,t.length-1)}{_u(e.get());const n=yN(t,!1);return e.set(n),Kl(n,n.length-1)}}),t=>{_u(e.get());const n=bN(t);return e.set(n),I.some(Kl(n,1))}),wN=(e,t)=>{for(let n=0;n<e.length;n++){const o=e[n].apply(null,t);if(o.isSome())return o}return I.none()},SN=Ne([{before:["element"]},{start:["element"]},{end:["element"]},{after:["element"]}]),EN=(e,t)=>Ku(t,e)||e,xN=(e,t,n)=>{const o=oy(n),r=EN(t,o.container());return ty(e,r,o).fold(()=>kf(r,o).bind(D(ty,e,r)).map(e=>SN.before(e)),I.none)},_N=(e,t)=>null===Of(e,t),kN=(e,t,n)=>ty(e,t,n).filter(D(_N,t)),NN=(e,t,n)=>{const o=ry(n);return kN(e,t,o).bind(e=>Nf(e,o).isNone()?I.some(SN.start(e)):I.none())},RN=(e,t,n)=>{const o=oy(n);return kN(e,t,o).bind(e=>kf(e,o).isNone()?I.some(SN.end(e)):I.none())},AN=(e,t,n)=>{const o=ry(n),r=EN(t,o.container());return ty(e,r,o).fold(()=>Nf(r,o).bind(D(ty,e,r)).map(e=>SN.after(e)),I.none)},DN=e=>!ey(ON(e)),TN=(e,t,n)=>wN([xN,NN,RN,AN],[e,t,n]).filter(DN),ON=e=>e.fold(R,R,R,R),BN=e=>e.fold(N("before"),N("start"),N("end"),N("after")),PN=e=>e.fold(SN.before,SN.before,SN.after,SN.after),LN=e=>e.fold(SN.start,SN.start,SN.end,SN.end),MN=(e,t,n,o,r,s)=>$e(ty(t,n,o),ty(t,n,r),(t,o)=>t!==o&&((e,t,n)=>{const o=Ku(t,e),r=Ku(n,e);return C(o)&&o===r})(n,t,o)?SN.after(e?t:o):s).getOr(s),IN=(e,t)=>e.fold(M,e=>{return o=t,!(BN(n=e)===BN(o)&&ON(n)===ON(o));var n,o}),FN=(e,t)=>e?t.fold(_(I.some,SN.start),I.none,_(I.some,SN.after),I.none):t.fold(I.none,_(I.some,SN.before),I.none,_(I.some,SN.end)),UN=(e,t,n)=>{const o=e?1:-1;return t.setRng(Kl(n.container(),n.offset()+o).toRange()),t.getSel().modify("move",e?"forward":"backward","word"),!0};var zN;!function(e){e[e.Br=0]="Br",e[e.Block=1]="Block",e[e.Wrap=2]="Wrap",e[e.Eol=3]="Eol"}(zN||(zN={}));const jN=(e,t)=>-1===e?re(t):t,$N=(e,t,n)=>1===e?t.next(n):t.prev(n),HN=(e,t,n,o)=>ms(o.getNode(1===t))?zN.Br:!1===Yu(n,o)?zN.Block:zN.Wrap,VN=(e,t,n,o)=>{const r=yf(n);let s=o;const a=[];for(;s;){const n=$N(t,r,s);if(!n)break;if(ms(n.getNode(!1)))return 1===t?{positions:jN(t,a).concat([n]),breakType:zN.Br,breakAt:I.some(n)}:{positions:jN(t,a),breakType:zN.Br,breakAt:I.some(n)};if(n.isVisible()){if(e(s,n)){const e=HN(0,t,s,n);return{positions:jN(t,a),breakType:e,breakAt:I.some(n)}}a.push(n),s=n}else s=n}return{positions:jN(t,a),breakType:zN.Eol,breakAt:I.none()}},qN=(e,t,n,o)=>t(n,o).breakAt.map(o=>{const r=t(n,o).positions;return-1===e?r.concat(o):[o].concat(r)}).getOr([]),WN=(e,t)=>X(e,(e,n)=>e.fold(()=>I.some(n),o=>$e(ce(o.getClientRects()),ce(n.getClientRects()),(e,r)=>{const s=Math.abs(t-e.left);return Math.abs(t-r.left)<=s?n:o}).or(e)),I.none()),KN=(e,t)=>ce(t.getClientRects()).bind(t=>WN(e,t.left)),YN=D(VN,Kl.isAbove,-1),GN=D(VN,Kl.isBelow,1),XN=D(qN,-1,YN),QN=D(qN,1,GN),ZN=(e,t)=>YN(e,t).breakAt.isNone(),JN=(e,t)=>GN(e,t).breakAt.isNone(),eR=(e,t)=>KN(XN(e,t),t),tR=(e,t)=>KN(QN(e,t),t),nR=ps,oR=(e,t)=>Math.abs(e.left-t),rR=(e,t)=>Math.abs(e.right-t),sR=(e,t)=>yt(e,(e,n)=>{const o=Math.min(oR(e,t),rR(e,t)),r=Math.min(oR(n,t),rR(n,t));return r===o&&ke(n,"node")&&nR(n.node)||r<o?n:e}),aR=e=>{const t=t=>V(t,t=>{const n=cl(t);return n.node=e,n});if(Xr(e))return t(e.getClientRects());if(ss(e)){const n=e.ownerDocument.createRange();return n.setStart(e,0),n.setEnd(e,e.data.length),t(n.getClientRects())}return[]},iR=e=>ne(e,aR);var lR;!function(e){e[e.Up=-1]="Up",e[e.Down=1]="Down"}(lR||(lR={}));const cR=(e,t,n,o,r,s)=>{let a=0;const i=[],l=o=>{let s=iR([o]);e===lR.Up&&(s=s.reverse());for(let e=0;e<s.length;e++){const o=s[e];if(!n(o,c)){if(i.length>0&&t(o,Ct(i))&&a++,o.line=a,r(o))return!0;i.push(o)}}return!1},c=Ct(s.getClientRects());if(!c)return i;const d=s.getNode();return d&&(l(d),((e,t,n,o)=>{let r=o;for(;r=Vu(r,e,Al,t);)if(n(r))return})(e,o,l,d)),i},dR=D(cR,lR.Up,ul,fl),mR=D(cR,lR.Down,fl,ul),uR=e=>Ct(e.getClientRects()),fR=e=>t=>((e,t)=>t.line>e)(e,t),gR=e=>t=>((e,t)=>t.line===e)(e,t),pR=(e,t)=>{e.selection.setRng(t),fh(e,e.selection.getRng())},hR=(e,t,n)=>I.some(Xk(e,t,n)),bR=(e,t)=>{const n=e.getNode(-1===t);return C(n)&&qu(n)?I.some(n):I.none()},yR=(e,t)=>{const n=e.dom.createRng();return n.selectNode(t),n},vR=(e,t,n,o,r,s)=>{const a=1===t,i=yf(e.getBody()),l=D(sf,a?i.next:i.prev),c=a?o:r;if(!n.collapsed){const o=pl(n);if(s(o)){if(qu(o)){const o=of(t,e.getBody(),n);return I.from(l(o)).map(e=>e.toRange())}return Yk(t,e,o,-1===t,!1)}if(nN(e)){const e=n.cloneRange();return e.collapse(-1===t),I.from(e)}}const d=of(t,e.getBody(),n);if(c(d))return Gk(e,d.getNode(!a));let m=l(d);const u=il(n);if(!m)return u?I.some(n):I.none();if(m=ny(a,m),c(m))return bR(m,t).fold(()=>Yk(t,e,m?.getNode(!a),a,!1),t=>I.some(yR(e,t)));const f=l(m);return f&&c(f)&&af(m,f)?bR(m,t).fold(()=>Yk(t,e,f.getNode(!a),a,!1),t=>I.some(yR(e,t))):u?hR(e,m.toRange(),!1):I.none()},CR=(e,t,n,o,r,s)=>{const a=of(t,e.getBody(),n),i=Ct(a.getClientRects()),l=t===lR.Down,c=e.getBody();if(!i)return I.none();if(nN(e)){const e=l?Kl.fromRangeEnd(n):Kl.fromRangeStart(n);return(l?tR:eR)(c,e).orThunk(()=>I.from(e)).map(e=>e.toRange())}const d=(l?mR:dR)(c,fR(1),a),m=Y(d,gR(1)),u=i.left,f=sR(m,u);if(f&&s(f.node)){const n=Math.abs(u-f.left),o=Math.abs(u-f.right);return Yk(t,e,f.node,n<o,!1)}let g;if(g=o(a)?a.getNode():r(a)?a.getNode(!0):pl(n),g){const n=((e,t,n,o)=>{const r=yf(t);let s,a,i,l;const c=[];let d=0;e===lR.Down?(s=r.next,a=fl,i=ul,l=Kl.after(o)):(s=r.prev,a=ul,i=fl,l=Kl.before(o));const m=uR(l);do{if(!l.isVisible())continue;const e=uR(l);if(i(e,m))continue;c.length>0&&a(e,Ct(c))&&d++;const t=cl(e);if(t.position=l,t.line=d,n(t))return c;c.push(t)}while(l=s(l));return c})(t,c,fR(1),g);let o=sR(Y(n,gR(1)),u);if(o)return hR(e,o.position.toRange(),!1);if(o=Ct(Y(n,gR(0))),o)return hR(e,o.position.toRange(),!1)}return 0===m.length?wR(e,l).filter(l?r:o).map(t=>Xk(e,t.toRange(),!1)):I.none()},wR=(e,t)=>{const n=e.selection.getRng(),o=t?Kl.fromRangeEnd(n):Kl.fromRangeStart(n),r=(s=o.container(),a=e.getBody(),ir(un.fromDom(s),e=>Pu(e.dom),e=>e.dom===a).map(e=>e.dom).getOr(a));var s,a;if(t){const e=GN(r,o);return de(e.positions)}{const e=YN(r,o);return ce(e.positions)}},SR=(e,t,n)=>wR(e,t).filter(n).exists(t=>(e.selection.setRng(t.toRange()),!0)),ER=(e,t)=>{const n=e.dom.createRng();n.setStart(t.container(),t.offset()),n.setEnd(t.container(),t.offset()),e.selection.setRng(n)},xR=(e,t)=>{e?t.setAttribute("data-mce-selected","inline-boundary"):t.removeAttribute("data-mce-selected")},_R=(e,t,n)=>CN(t,n).map(t=>(ER(e,t),n)),kR=(e,t,n)=>{const o=e.getBody(),r=((e,t,n)=>{const o=Kl.fromRangeStart(e);if(e.collapsed)return o;{const r=Kl.fromRangeEnd(e);return n?Nf(t,r).getOr(r):kf(t,o).getOr(o)}})(e.selection.getRng(),o,n);return((e,t,n,o)=>{const r=ny(e,o),s=TN(t,n,r);return TN(t,n,r).bind(D(FN,e)).orThunk(()=>((e,t,n,o,r)=>{const s=ny(e,r);return Sf(e,n,s).map(D(ny,e)).fold(()=>o.map(PN),r=>TN(t,n,r).map(D(MN,e,t,n,s,r)).filter(D(IN,o))).filter(DN)})(e,t,n,s,o))})(n,D(Jb,e),o,r).bind(n=>_R(e,t,n))},NR=(e,t,n)=>!!im(e)&&kR(e,t,n).isSome(),RR=(e,t,n)=>!!im(t)&&((e,t)=>{const n=t.selection.getRng(),o=e?Kl.fromRangeEnd(n):Kl.fromRangeStart(n);return!!(e=>w(e.selection.getSel().modify))(t)&&(e&&nl(o)?UN(!0,t.selection,o):!(e||!ol(o))&&UN(!1,t.selection,o))})(e,t),AR=e=>{const t=Re(null),n=D(Jb,e);return e.on("NodeChange",o=>{im(e)&&(((e,t,n)=>{const o=V(Rr(un.fromDom(t.getRoot()),'*[data-mce-selected="inline-boundary"]'),e=>e.dom),r=Y(o,e),s=Y(n,e);q(se(r,s),D(xR,!1)),q(se(s,r),D(xR,!0))})(n,e.dom,o.parents),((e,t)=>{const n=t.get();if(e.selection.isCollapsed()&&!e.composing&&n){const o=Kl.fromRangeStart(e.selection.getRng());Kl.isTextPosition(o)&&!(e=>nl(e)||ol(e))(o)&&(ER(e,xu(n,o)),t.set(null))}})(e,t),((e,t,n,o)=>{if(t.selection.isCollapsed()){const r=Y(o,e);q(r,o=>{const r=Kl.fromRangeStart(t.selection.getRng());TN(e,t.getBody(),r).bind(e=>_R(t,n,e))})}})(n,e,t,o.parents))}),t},DR=D(RR,!0),TR=D(RR,!1),OR=(e,t,n)=>{if(im(e)){const o=wR(e,t).getOrThunk(()=>{const n=e.selection.getRng();return t?Kl.fromRangeEnd(n):Kl.fromRangeStart(n)});return TN(D(Jb,e),e.getBody(),o).exists(t=>{const o=PN(t);return CN(n,o).exists(t=>(ER(e,t),!0))})}return!1},BR=(e,t)=>n=>CN(t,n).map(t=>()=>ER(e,t)),PR=(e,t,n,o)=>{const r=e.getBody(),s=D(Jb,e);e.undoManager.ignore(()=>{e.selection.setRng(((e,t)=>{const n=document.createRange();return n.setStart(e.container(),e.offset()),n.setEnd(t.container(),t.offset()),n})(n,o)),ay(e),TN(s,r,Kl.fromRangeStart(e.selection.getRng())).map(LN).bind(BR(e,t)).each(P)}),e.nodeChanged()},LR=(e,t,n)=>{if(e.selection.isCollapsed()&&im(e)){const o=Kl.fromRangeStart(e.selection.getRng());return((e,t,n,o)=>{const r=((e,t)=>Ku(t,e)||e)(e.getBody(),o.container()),s=D(Jb,e),a=TN(s,r,o);return a.bind(e=>n?e.fold(N(I.some(LN(e))),I.none,N(I.some(PN(e))),I.none):e.fold(I.none,N(I.some(PN(e))),I.none,N(I.some(LN(e))))).map(BR(e,t)).getOrThunk(()=>{const i=Ef(n,r,o),l=i.bind(e=>TN(s,r,e));return $e(a,l,()=>ty(s,r,o).bind(t=>(e=>$e(Rf(e),Af(e),(t,n)=>{const o=ny(!0,t),r=ny(!1,n);return kf(e,o).forall(e=>e.isEqual(r))}).getOr(!0))(t)?I.some(()=>{Qb(e,n,un.fromDom(t))}):I.none())).getOrThunk(()=>l.bind(()=>i.map(r=>()=>{n?PR(e,t,o,r):PR(e,t,r,o)})))})})(e,t,n,o)}return I.none()},MR=(e,t)=>{const n=un.fromDom(e.getBody()),o=un.fromDom(e.selection.getStart()),r=mb(o,n);return J(r,t).fold(N(r),e=>r.slice(0,e))},IR=e=>1===Yn(e),FR=(e,t)=>{const n=D(Ev,e);return ne(t,e=>n(e)?[e.dom]:[])},UR=e=>{const t=(e=>MR(e,t=>e.schema.isBlock(En(t))))(e);return FR(e,t)},zR=(e,t)=>{const n=Y((e=>MR(e,t=>e.schema.isBlock(En(t))||(e=>Yn(e)>1)(t)))(e),IR);return de(n).bind(o=>{const r=Kl.fromRangeStart(e.selection.getRng());return my(t,r,o.dom)&&!Tg(o)?I.some(()=>((e,t,n,o)=>{const r=FR(t,o);if(0===r.length)Qb(t,e,n);else{const e=Sv(n.dom,r);t.selection.setRng(e.toRange())}})(t,e,o,n)):I.none()})},jR=(e,t)=>{const n=e.selection.getStart(),o=((e,t)=>{const n=t.parentElement;return ms(t)&&!h(n)&&e.dom.isEmpty(n)})(e,n)||Tg(un.fromDom(n))?Sv(n,t):((e,t)=>{const{caretContainer:n,caretPosition:o}=wv(t);return e.insertNode(n.dom),o})(e.selection.getRng(),t);e.selection.setRng(o.toRange())},$R=(e,t)=>{const n=se(t,UR(e));n.length>0&&jR(e,n)},HR=e=>ss(e.startContainer),VR=e=>{const t=e.selection.getRng();return(e=>0===e.startOffset&&HR(e))(t)&&((e,t)=>{const n=t.startContainer.parentElement;return!h(n)&&Ev(e,un.fromDom(n))})(e,t)&&(e=>(e=>(e=>{const t=e.startContainer.parentNode,n=e.endContainer.parentNode;return!h(t)&&!h(n)&&t.isEqualNode(n)})(e)&&(e=>{const t=e.endContainer;return e.endOffset===(ss(t)?t.length:t.childNodes.length)})(e))(e)||(e=>!e.endContainer.isEqualNode(e.commonAncestorContainer))(e))(t)},qR=(e,t)=>e.selection.isCollapsed()?zR(e,t):(e=>{if(VR(e)){const t=UR(e);return I.some(()=>{ay(e),$R(e,t)})}return I.none()})(e),WR=e=>((e=>{const t=e.selection.getRng();return t.collapsed&&(HR(t)||e.dom.isEmpty(t.startContainer))&&!(e=>{return t=un.fromDom(e.selection.getStart()),n=e.schema,Ar(t,e=>Tf(e.dom),e=>n.isBlock(En(e)));var t,n})(e)})(e)&&jR(e,[]),!0),KR=(e,t,n)=>C(n)?I.some(()=>{e._selectionOverrides.hideFakeCaret(),Qb(e,t,un.fromDom(n))}):I.none(),YR=(e,t)=>e.selection.isCollapsed()?((e,t)=>{const n=t?rb:sb,o=of(t?1:-1,e.getBody(),e.selection.getRng());return n(o)?KR(e,t,o.getNode(!t)):I.from(ny(t,o)).filter(e=>n(e)&&af(o,e)).bind(n=>KR(e,t,n.getNode(!t)))})(e,t):((e,t)=>{const n=e.selection.getNode();return Cs(n)?KR(e,t,n):I.none()})(e,t),GR=e=>st(e??"").getOr(0),XR=(e,t)=>(e||"table"===En(t)?"margin":"padding")+("rtl"===$o(t,"direction")?"-right":"-left"),QR=e=>{const t=JR(e);return!e.mode.isReadOnly()&&(t.length>1||((e,t)=>oe(t,t=>{const n=XR(Vd(e),t),o=Vo(t,n).map(GR).getOr(0);return"false"!==e.dom.getContentEditable(t.dom)&&o>0}))(e,t))},ZR=e=>zi(e)||ji(e),JR=e=>{const t=Qf(e);return 0===t.length?Y(Po(e.selection.getSelectedBlocks()),e=>!ZR(e)&&!(e=>Mn(e).exists(ZR))(e)&&lr(e,e=>gs(e.dom)||ps(e.dom)).exists(e=>gs(e.dom))):t},eA=(e,t)=>{if(e.mode.isReadOnly())return;const{dom:n}=e,o=qd(e),r=/[a-z%]+$/i.exec(o)?.[0]??"px",s=GR(o),a=Vd(e);q(JR(e),e=>{((e,t,n,o,r,s)=>{const a=XR(n,un.fromDom(s)),i=GR(e.getStyle(s,a));if("outdent"===t){const t=Math.max(0,i-o);e.setStyle(s,a,t?t+r:"")}else{const t=i+o+r;e.setStyle(s,a,t)}})(n,t,a,s,r,e.dom)}),"indent"===t?uk(e):fk(e)},tA=e=>eA(e,"outdent"),nA=e=>{if(e.selection.isCollapsed()&&QR(e)){const t=e.dom,n=e.selection.getRng(),o=Kl.fromRangeStart(n),r=t.getParent(n.startContainer,t.isBlock);if(null!==r&&hb(un.fromDom(r),o,e.schema))return I.some(()=>tA(e))}return I.none()},oA=(e,t)=>e.selection.isCollapsed()?I.none():((e,t)=>{const n=e.selection.getRng();return(e=>ag(e,Qr))(vC(n))?I.some(()=>Qb(e,t,un.fromDom(n.startContainer.childNodes[n.startOffset]))):I.none()})(e,t),rA=(e,t,n)=>ue([nA,lN,eN,(e,n)=>LR(e,t,n),Vk,Uy,dN,YR,Kk,qR,cN,oA],t=>t(e,n)).filter(t=>e.selection.isEditable()),sA=(e,t)=>{rA(e,t,!1).fold(()=>{e.selection.isEditable()&&(ay(e),dy(e))},P),Ok(e)&&k_(e.dom,e.getBody())},aA=e=>void 0===e.touches||1!==e.touches.length?I.none():I.some(e.touches[0]),iA=(e,t)=>_e(e,t.nodeName),lA=(e,t)=>!!ss(t)||!!Xr(t)&&!(iA(e.getBlockElements(),t)||Vf(t)||Zs(e,t)||Us(t)||vs(t)),cA=(e,t)=>{if(ss(t)){if(0===t.data.length)return!0;if(/^\s+$/.test(t.data))return!t.nextSibling||iA(e,t.nextSibling)||Us(t.nextSibling)}return!1},dA=e=>e.dom.create(Ed(e),xd(e)),mA=(e,t,n)=>{const o=un.fromDom(dA(e)),r=qi();go(o,r),n(t,o);const s=document.createRange();return s.setStartBefore(r.dom),s.setEndBefore(r.dom),s},uA=e=>t=>-1!==(" "+t.attr("class")+" ").indexOf(e),fA=(e,t,n)=>function(o){const r=arguments,s=r[r.length-2],a=s>0?t.charAt(s-1):"";if('"'===a)return o;if(">"===a){const e=t.lastIndexOf("<",s);if(-1!==e&&-1!==t.substring(e,s).indexOf('contenteditable="false"'))return o}return'<span class="'+n+'" data-mce-content="'+e.dom.encode(r[0])+'">'+e.dom.encode("string"==typeof r[1]?r[1]:r[0])+"</span>"},gA=(e,t)=>oe(e,e=>{const n=t.match(e);return null!==n&&n[0].length===t.length}),pA=(e,t)=>{t.hasAttribute("data-mce-caret")&&(al(t),e.selection.setRng(e.selection.getRng()),e.selection.scrollIntoView(t))},hA=(e,t)=>{const n=(e=>ur(un.fromDom(e.getBody()),"*[data-mce-caret]").map(e=>e.dom).getOrNull())(e);if(n)return"compositionstart"===t.type?(t.preventDefault(),t.stopPropagation(),void pA(e,n)):void(tl(n)&&(pA(e,n),e.undoManager.add()))},bA=ps,yA=(e,t,n)=>{const o=yf(e.getBody()),r=D(sf,1===t?o.next:o.prev);if(n.collapsed){const o=e.dom.getParent(n.startContainer,"PRE");if(!o)return;if(!r(Kl.fromRangeStart(n))){const n=un.fromDom((e=>{const t=e.dom.create(Ed(e));return t.innerHTML='<br data-mce-bogus="1">',t})(e));1===t?uo(un.fromDom(o),n):mo(un.fromDom(o),n),e.selection.select(n.dom,!0),e.selection.collapse()}}},vA=(e,t)=>((e,t)=>{const n=t?1:-1,o=e.selection.getRng();return((e,t,n)=>vR(t,e,n,lb,cb,bA))(n,e,o).orThunk(()=>(yA(e,n,o),I.none()))})(e,((e,t)=>{const n=t?e.getEnd(!0):e.getStart(!0);return ey(n)?!t:t})(e.selection,t)).exists(t=>(pR(e,t),!0)),CA=(e,t)=>((e,t)=>{const n=t?1:-1,o=e.selection.getRng();return((e,t,n)=>CR(t,e,n,e=>lb(e)||ab(e),e=>cb(e)||ib(e),bA))(n,e,o).orThunk(()=>(yA(e,n,o),I.none()))})(e,t).exists(t=>(pR(e,t),!0)),wA=(e,t)=>SR(e,t,t?cb:lb),SA=(e,t)=>tN(e,!t).map(n=>{const o=n.toRange(),r=e.selection.getRng();return t?o.setStart(r.startContainer,r.startOffset):o.setEnd(r.endContainer,r.endOffset),o}).exists(t=>(pR(e,t),!0)),EA=(e,t)=>{const n=e=>vn(e,t),o=un.fromDom(e.container());return lr(o,e=>gs(e.dom),n).filter(e=>!n(e))},xA=(e,t)=>((e,t)=>{const n=Kl.fromRangeStart(e.selection.getRng()),o=Kl.fromRangeEnd(e.selection.getRng()),r=un.fromDom(e.getBody());return $e(EA(n,r),EA(o,r),(e,t)=>vn(e,t)?I.some(e):I.none()).bind(R).fold(L,r=>!!(t&&JN(r.dom,o)||!t&&ZN(r.dom,n))&&((e,t,n)=>(n?tR:eR)(e.getBody(),t).map(e=>e.toRange()))(e,t?o:n,t).exists(t=>(pR(e,t),!0)))})(e,t),_A=e=>$(["figcaption"],En(e)),kA=(e,t)=>!!e.selection.isCollapsed()&&((e,t)=>{const n=un.fromDom(e.getBody()),o=Kl.fromRangeStart(e.selection.getRng());return((e,t,n)=>{const o=D(vn,t);return lr(un.fromDom(e.container()),e=>n.isBlock(En(e)),o).filter(_A)})(o,n,e.schema).exists(()=>{if(((e,t,n)=>t?JN(e.dom,n):ZN(e.dom,n))(n,t,o)){const o=mA(e,n,t?go:fo);return e.selection.setRng(o),!0}return!1})})(e,t),NA=(e,t)=>((e,t)=>t?I.from(e.dom.getParent(e.selection.getNode(),"details")).map(t=>((e,t)=>{const n=e.selection.getRng(),o=Kl.fromRangeStart(n);return!(e.getBody().lastChild!==t||!JN(t,o)||(e.execCommand("InsertNewBlockAfter"),0))})(e,t)).getOr(!1):I.from(e.dom.getParent(e.selection.getNode(),"summary")).bind(t=>I.from(e.dom.getParent(t,"details")).map(n=>((e,t,n)=>{const o=e.selection.getRng(),r=Kl.fromRangeStart(o);return!(e.getBody().firstChild!==t||!ZN(n,r)||(e.execCommand("InsertNewBlockBefore"),0))})(e,n,t))).getOr(!1))(e,t),RA={shiftKey:!1,altKey:!1,ctrlKey:!1,metaKey:!1,keyCode:0},AA=(e,t)=>t.keyCode===e.keyCode&&t.shiftKey===e.shiftKey&&t.altKey===e.altKey&&t.ctrlKey===e.ctrlKey&&t.metaKey===e.metaKey,DA=(e,...t)=>()=>e.apply(null,t),TA=(e,t)=>Z(((e,t)=>ne((e=>V(e,e=>({...RA,...e})))(e),e=>AA(e,t)?[e]:[]))(e,t),e=>e.action()),OA=(e,t)=>ue(((e,t)=>ne((e=>V(e,e=>({...RA,...e})))(e),e=>AA(e,t)?[e]:[]))(e,t),e=>e.action()),BA=(e,t)=>{const n=t?1:-1,o=e.selection.getRng();return vR(e,n,o,rb,sb,Cs).exists(t=>(pR(e,t),!0))},PA=(e,t)=>{const n=t?1:-1,o=e.selection.getRng();return CR(e,n,o,rb,sb,Cs).exists(t=>(pR(e,t),!0))},LA=(e,t)=>SR(e,t,t?sb:rb),MA=(e,t,n)=>ne(Vn(e),e=>bn(e,t)?n(e)?[e]:[]:MA(e,t,n)),IA=(e,t)=>fr(e,"table",t),FA=Ne([{none:["current"]},{first:["current"]},{middle:["current","target"]},{last:["current"]}]),UA={...FA,none:e=>FA.none(e)},zA=(e,t,n,o,r=M)=>{const s=1===o;if(!s&&n<=0)return UA.first(e[0]);if(s&&n>=e.length-1)return UA.last(e[e.length-1]);{const s=n+o,a=e[s];return r(a)?UA.middle(t,a):zA(e,t,s,o,r)}},jA=(e,t)=>IA(e,t).bind(t=>{const n=MA(t,"th,td",M);return J(n,t=>vn(e,t)).map(e=>({index:e,all:n}))});var $A=["body","p","div","article","aside","figcaption","figure","footer","header","nav","section","ol","ul","li","table","thead","tbody","tfoot","caption","tr","td","th","h1","h2","h3","h4","h5","h6","blockquote","pre","address"];const HA=(e,t)=>({element:e,offset:t}),VA=(e,t)=>{if(e.property().isText(t))return HA(t,e.property().getText(t).length);{const n=e.property().children(t);return n.length>0?VA(e,n[n.length-1]):HA(t,n.length)}},qA=(e,t,n)=>{const o=e.property().children(t);return o.length>0&&n<o.length?qA(e,o[n],0):o.length>0&&e.property().isElement(t)&&o.length===n?VA(e,o[o.length-1]):HA(t,n)},WA=qA,KA={up:N({selector:mr,closest:fr,predicate:ir,all:Fn}),down:N({selector:Rr,predicate:Nr}),styles:N({get:$o,getRaw:Vo,set:zo,remove:Wo}),attrs:N({get:wo,set:vo,remove:xo,copyTo:(e,t)=>{const n=ko(e);Co(t,n)}}),insert:N({before:mo,after:uo,afterAll:ho,append:go,appendAll:bo,prepend:fo,wrap:po}),remove:N({unwrap:Ao,remove:Ro}),create:N({nu:un.fromTag,clone:e=>un.fromDom(e.dom.cloneNode(!1)),text:un.fromText}),query:N({comparePosition:(e,t)=>e.dom.compareDocumentPosition(t.dom),prevSibling:zn,nextSibling:jn}),property:N({children:Vn,name:En,parent:Mn,document:e=>Pn(e).dom,isText:An,isComment:kn,isElement:Rn,isSpecial:e=>{const t=En(e);return $(["script","noscript","iframe","noframes","noembed","title","style","textarea","xmp"],t)},getLanguage:e=>Rn(e)?So(e,"lang"):I.none(),getText:or,setText:rr,isBoundary:e=>!!Rn(e)&&("body"===En(e)||$($A,En(e))),isEmptyTag:e=>!!Rn(e)&&$(["br","img","hr","input"],En(e)),isNonEditable:e=>Rn(e)&&"false"===wo(e,"contenteditable")}),eq:vn,is:wn},YA=(e,t)=>WA(KA,e,t),GA=Le("image"),XA=Le("event"),QA=e=>t=>{t[XA]=e},ZA=QA(0),JA=QA(2),eD=QA(1),tD=e=>{const t=e;return I.from(t[XA]).exists(e=>0===e)};const nD=Le("mode"),oD=e=>t=>{t[nD]=e},rD=(e,t)=>oD(t)(e),sD=oD(0),aD=oD(2),iD=oD(1),lD=e=>t=>{const n=t;return I.from(n[nD]).exists(t=>t===e)},cD=lD(0),dD=lD(1),mD=["none","copy","link","move"],uD=["none","copy","copyLink","copyMove","link","linkMove","move","all","uninitialized"],fD=()=>{const e=new window.DataTransfer;let t="move",n="all";const o={get dropEffect(){return t},set dropEffect(e){$(mD,e)&&(t=e)},get effectAllowed(){return n},set effectAllowed(e){tD(o)&&$(uD,e)&&(n=e)},get items(){return((e,t)=>({...t,get length(){return t.length},add:(n,o)=>{if(cD(e)){if(!u(n))return t.add(n);if(!y(o))return t.add(n,o)}return null},remove:n=>{cD(e)&&t.remove(n)},clear:()=>{cD(e)&&t.clear()}}))(o,e.items)},get files(){return dD(o)?(()=>{const e=[];return Object.freeze({length:0,item:e=>null,[Symbol.iterator]:()=>e[Symbol.iterator]()})})():e.files},get types(){return e.types},setDragImage:(t,n,r)=>{var s;cD(o)&&(s={image:t,x:n,y:r},o[GA]=s,e.setDragImage(t,n,r))},getData:t=>dD(o)?"":e.getData(t),setData:(t,n)=>{cD(o)&&e.setData(t,n)},clearData:t=>{cD(o)&&e.clearData(t)}};return sD(o),o},gD=(e,t)=>e.setData("text/html",t),pD=(e,t,n,o,r)=>{const s=Rr(un.fromDom(n),"td,th,caption").map(e=>e.dom),a=Y(((e,t)=>ne(t,t=>{const n=((e,t)=>({left:e.left-t,top:e.top-t,right:e.right+-2,bottom:e.bottom+-2,width:e.width+t,height:e.height+t}))(cl(t.getBoundingClientRect()),-1);return[{x:n.left,y:e(n),cell:t},{x:n.right,y:e(n),cell:t}]}))(e,s),e=>t(e,r));return((e,t,n)=>X(e,(e,o)=>e.fold(()=>I.some(o),e=>{const r=Math.sqrt(Math.abs(e.x-t)+Math.abs(e.y-n)),s=Math.sqrt(Math.abs(o.x-t)+Math.abs(o.y-n));return I.some(s<r?o:e)}),I.none()))(a,o,r).map(e=>e.cell)},hD=D(pD,e=>e.bottom,(e,t)=>e.y<t),bD=D(pD,e=>e.top,(e,t)=>e.y>t),yD=(e,t,n)=>{const o=e(t,n);return(e=>e.breakType===zN.Wrap&&0===e.positions.length)(o)||!ms(n.getNode())&&(e=>e.breakType===zN.Br&&1===e.positions.length)(o)?!((e,t,n)=>n.breakAt.exists(n=>e(t,n).breakAt.isSome()))(e,t,o):o.breakAt.isNone()},vD=D(yD,YN),CD=D(yD,GN),wD=(e,t,n,o)=>{const r=e.selection.getRng(),s=t?1:-1;return!(!Tu()||!((e,t,n)=>{const o=Kl.fromRangeStart(t);return _f(!e,n).exists(e=>e.isEqual(o))})(t,r,n)||(Yk(s,e,n,!t,!1).each(t=>{pR(e,t)}),0))},SD=(e,t,n)=>{const o=((e,t)=>{const n=t.getNode(e);return ns(n)?I.some(n):I.none()})(!!t,n),r=!1===t;o.fold(()=>pR(e,n.toRange()),o=>_f(r,e.getBody()).filter(e=>e.isEqual(n)).fold(()=>pR(e,n.toRange()),n=>((e,t,n)=>{t.undoManager.transact(()=>{const o=e?uo:mo,r=mA(t,un.fromDom(n),o);pR(t,r)})})(t,e,o)))},ED=(e,t,n,o)=>{const r=e.selection.getRng(),s=Kl.fromRangeStart(r),a=e.getBody();if(!t&&vD(o,s)){const o=((e,t,n)=>((e,t)=>ce(t.getClientRects()).bind(t=>hD(e,t.left,t.top)).bind(e=>{return KN(Af(n=e).map(e=>YN(n,e).positions.concat(e)).getOr([]),t);var n}))(t,n).orThunk(()=>ce(n.getClientRects()).bind(n=>WN(XN(e,Kl.before(t)),n.left))).getOr(Kl.before(t)))(a,n,s);return SD(e,t,o),!0}if(t&&CD(o,s)){const o=((e,t,n)=>((e,t)=>de(t.getClientRects()).bind(t=>bD(e,t.left,t.top)).bind(e=>{return KN(Rf(n=e).map(e=>[e].concat(GN(n,e).positions)).getOr([]),t);var n}))(t,n).orThunk(()=>ce(n.getClientRects()).bind(n=>WN(QN(e,Kl.after(t)),n.left))).getOr(Kl.after(t)))(a,n,s);return SD(e,t,o),!0}return!1},xD=(e,t,n)=>I.from(e.dom.getParent(e.selection.getNode(),"td,th")).bind(o=>I.from(e.dom.getParent(o,"table")).map(r=>n(e,t,r,o))).getOr(!1),_D=(e,t)=>xD(e,t,wD),kD=(e,t)=>xD(e,t,ED),ND=(e,t,n)=>n.fold(I.none,I.none,(e,t)=>{return(n=t,dr(n,Pr)).map(e=>(e=>{const t=Ur.exact(e,0,e,0);return Hr(t)})(e));var n},n=>!e.mode.isReadOnly()&&RD(n)&&(e=>TD(e)||Un(e).some(e=>Nn(e)&&TD(e)))(n)?(e.execCommand("mceTableInsertRowAfter"),AD(e,t,n)):I.none()),RD=e=>lr(e,On("table")).exists(Sr),AD=(e,t,n)=>{return ND(e,t,(r=TD,jA(o=n,void 0).fold(()=>UA.none(o),e=>zA(e.all,o,e.index,1,r))));var o,r},DD=(e,t,n)=>{return ND(e,t,(r=TD,jA(o=n,void 0).fold(()=>UA.none(),e=>zA(e.all,o,e.index,-1,r))));var o,r},TD=e=>Sr(e)||Dr(e,OD),OD=e=>Nn(e)&&Sr(e),BD=(e,t)=>{const n=["table","li","dl"],o=un.fromDom(e.getBody()),r=e=>{const t=En(e);return vn(e,o)||$(n,t)},s=e.selection.getRng();return((e,t)=>((e,t,n=L)=>n(t)?I.none():$(e,En(t))?I.some(t):mr(t,e.join(","),e=>bn(e,"table")||n(e)))(["td","th"],e,t))(un.fromDom(t?s.endContainer:s.startContainer),r).map(n=>(IA(n,r).each(t=>{e.model.table.clearSelectedCells(t.dom)}),e.selection.collapse(!t),(t?AD:DD)(e,r,n).each(t=>{e.selection.setRng(t)}),!0)).getOr(!1)},PD=(e,t)=>({container:e,offset:t}),LD=gi.DOM,MD=e=>t=>e===t?-1:0,ID=(e,t,n)=>{if(ss(e)&&t>=0)return I.some(PD(e,t));{const o=Pi(LD);return I.from(o.backwards(e,t,MD(e),n)).map(e=>PD(e.container,e.container.data.length))}},FD=(e,t,n)=>{if(!ss(e))return I.none();const o=e.data;if(t>=0&&t<=o.length)return I.some(PD(e,t));{const o=Pi(LD);return I.from(o.backwards(e,t,MD(e),n)).bind(e=>{const o=e.container.data;return FD(e.container,t+o.length,n)})}},UD=(e,t,n)=>{if(!ss(e))return I.none();const o=e.data;if(t<=o.length)return I.some(PD(e,t));{const r=Pi(LD);return I.from(r.forwards(e,t,MD(e),n)).bind(e=>UD(e.container,t-o.length,n))}},zD=(e,t,n,o,r)=>{const s=Pi(e,(e=>t=>e.isBlock(t)||$(["BR","IMG","HR","INPUT"],t.nodeName)||"false"===e.getContentEditable(t))(e));return I.from(s.backwards(t,n,o,r))},jD=e=>""!==e&&-1!==" \xa0\ufeff\f\n\r\t\v".indexOf(e),$D=(e,t)=>e.substring(t.length),HD=(e,t,n,o=!1)=>{if(!(r=t).collapsed||!ss(r.startContainer))return I.none();var r;const s={text:"",offset:0},a=e.getParent(t.startContainer,e.isBlock)||e.getRoot();return zD(e,t.startContainer,t.startOffset,(e,t,r)=>(s.text=r+s.text,s.offset+=t,((e,t,n,o=!1)=>{let r;const s=n.charAt(0);for(r=t-1;r>=0;r--){const a=e.charAt(r);if(!o&&jD(a))return I.none();if(s===a&&Xe(e,n,r,t))break}return I.some(r)})(s.text,s.offset,n,o).getOr(t)),a).bind(e=>{const o=t.cloneRange();if(o.setStart(e.container,e.offset),o.setEnd(t.endContainer,t.endOffset),o.collapsed)return I.none();const r=(e=>Gi(e.toString().replace(/\u00A0/g," ")))(o);return 0!==r.lastIndexOf(n)?I.none():I.some({text:$D(r,n),range:o,trigger:n})})},VD=e=>{if((e=>3===e.nodeType)(e))return PD(e,e.data.length);{const t=e.childNodes;return t.length>0?VD(t[t.length-1]):PD(e,t.length)}},qD=(e,t)=>{const n=e.childNodes;return n.length>0&&t<n.length?qD(n[t],0):n.length>0&&(e=>1===e.nodeType)(e)&&n.length===t?VD(n[n.length-1]):PD(e,t)},WD=(e,t,n,o={})=>{const r=t(),s=e.selection.getRng().startContainer.nodeValue??"",a=Y(r.lookupByTrigger(n.trigger),t=>n.text.length>=t.minChars&&t.matches.getOrThunk(()=>(e=>t=>{const n=qD(t.startContainer,t.startOffset);return!((e,t)=>{const n=e.getParent(t.container,e.isBlock)??e.getRoot();return zD(e,t.container,t.offset,(e,t)=>0===t?-1:t,n).filter(e=>{const t=e.container.data.charAt(e.offset-1);return!jD(t)}).isSome()})(e,n)})(e.dom))(n.range,s,n.text));if(0===a.length)return I.none();const i=Promise.all(V(a,e=>e.fetch(n.text,e.maxResults,o).then(t=>({matchText:n.text,items:t,columns:e.columns,onAction:e.onAction,highlightOn:e.highlightOn}))));return I.some({lookupData:i,context:n})},KD=Hc("type"),YD=Vc("fetch"),GD=Vc("onAction");Wc("name"),Wc("text"),Wc("role"),Wc("icon"),Wc("url"),Wc("tooltip"),Wc("chevronTooltip"),Wc("label"),Wc("shortcut");const XD=Mc([KD,Hc("trigger"),Yc("minChars",1),(e=>jc(e,e,Tc(1),kc()))("columns"),Yc("maxResults",10),qc("matches",Dc),YD,GD,(QD=Ac,Kc("highlightOn",[],Ic(QD)))]);var QD;const ZD=e=>{const t=Ke(),n=Re(!1),o=t.isSet,r=()=>{o()&&((e=>{e.dispatch("AutocompleterEnd")})(e),n.set(!1),t.clear())},s=lt(()=>(e=>{const t=e.ui.registry.getAll().popups,n=be(t,e=>{return(t=e,Uc("Autocompleter",XD,t)).fold(e=>{throw new Error(zc(e))},R);var t}),o=ut(Se(n,e=>e.trigger)),r=Ee(n);return{dataset:n,triggers:o,lookupByTrigger:e=>Y(r,t=>t.trigger===e)}})(e)),a=a=>{(n=>t.get().map(t=>HD(e.dom,e.selection.getRng(),t.trigger,!0).bind(t=>WD(e,s,t,n))).getOrThunk(()=>((e,t)=>{const n=t(),o=e.selection.getRng();return((e,t,n)=>ue(n.triggers,n=>HD(e,t,n)))(e.dom,o,n).bind(n=>WD(e,t,n))})(e,s)))(a).fold(r,r=>{(e=>{o()||t.set({trigger:e.trigger,matchLength:e.text.length})})(r.context),r.lookupData.then(o=>{t.get().map(s=>{const a=r.context;s.trigger===a.trigger&&(t.set({...s,matchLength:a.text.length}),n.get()?(id(e,{range:a.range}),((e,t)=>{e.dispatch("AutocompleterUpdate",t)})(e,{lookupData:o})):(n.set(!0),id(e,{range:a.range}),((e,t)=>{e.dispatch("AutocompleterStart",t)})(e,{lookupData:o})))})})})},i=()=>t.get().bind(({trigger:t})=>{const o=e.selection.getRng();return HD(e.dom,o,t,n.get()).filter(({range:e})=>((e,t)=>{const n=e.compareBoundaryPoints(window.Range.START_TO_START,t),o=e.compareBoundaryPoints(window.Range.END_TO_END,t);return n>=0&&o<=0})(o,e)).map(({range:e})=>e)});e.addCommand("mceAutocompleterReload",(e,t)=>{const n=f(t)?t.fetchOptions:{};a(n)}),e.addCommand("mceAutocompleterClose",r),e.addCommand("mceAutocompleterRefreshActiveRange",()=>{i().each(t=>{id(e,{range:t})})}),e.editorCommands.addQueryStateHandler("mceAutoCompleterInRange",()=>i().isSome()),((e,t)=>{const n=it(t.load,50);e.on("input",t=>{("insertCompositionText"!==t.inputType||e.composing)&&n.throttle()}),e.on("keydown",e=>{const o=e.which;8===o?n.throttle():27===o?(n.cancel(),t.cancelIfNecessary()):38!==o&&40!==o||n.cancel()},!0),e.on("remove",n.cancel)})(e,{cancelIfNecessary:r,load:a})},JD=Xt().browser.isSafari(),eT=e=>Wi(un.fromDom(e)),tT=(e,t)=>0===e.startOffset&&e.endOffset===t.textContent?.length,nT=(e,t)=>I.from(e.getParent(t.container(),"details")),oT=(e,t)=>nT(e,t).isSome(),rT=(e,t)=>{const n=t.getNode();y(n)||e.selection.setCursorLocation(n,t.offset())},sT=(e,t,n)=>{const o=e.dom.getParent(t.container(),"details");if(o&&!o.open){const t=e.dom.select("summary",o)[0];t&&(n?Rf(t):Af(t)).each(t=>rT(e,t))}else rT(e,t)},aT=(e,t,n)=>{const{dom:o,selection:r}=e,s=e.getBody();if("character"===n){const n=Kl.fromRangeStart(r.getRng()),a=o.getParent(n.container(),o.isBlock),i=nT(o,n),l=a&&o.isEmpty(a),c=h(a?.previousSibling),d=h(a?.nextSibling);return!!(l&&(t?d:c)&&Ef(!t,s,n).exists(e=>oT(o,e)&&!je(i,nT(o,e))))||Ef(t,s,n).fold(L,n=>{const r=nT(o,n);if(oT(o,n)&&!je(i,r)){if(t||sT(e,n,!1),a&&l){if(t&&c)return!0;if(!t&&d)return!0;sT(e,n,t),e.dom.remove(a)}return!0}return!1})}return!1},iT=(e,t,n,o)=>{const r=e.selection.getRng(),s=Kl.fromRangeStart(r),a=e.getBody();return"selection"===o?((e,t)=>{const n=t.startSummary.exists(t=>t.contains(e.startContainer)),o=t.startSummary.exists(t=>t.contains(e.endContainer)),r=t.startDetails.forall(e=>t.endDetails.forall(t=>e!==t));return(n||o)&&!(n&&o)||r})(r,t):n?((e,t)=>t.startSummary.exists(t=>((e,t)=>Af(t).exists(n=>ms(n.getNode())&&Nf(t,n).exists(t=>t.isEqual(e))||n.isEqual(e)))(e,t)))(s,t)||((e,t,n)=>n.startDetails.exists(n=>kf(e,t).forall(e=>!n.contains(e.container()))))(a,s,t):((e,t)=>t.startSummary.exists(t=>((e,t)=>Rf(t).exists(t=>t.isEqual(e)))(e,t)))(s,t)||((e,t)=>t.startDetails.exists(n=>Nf(n,e).forall(n=>t.startSummary.exists(t=>!t.contains(e.container())&&t.contains(n.container())))))(s,t)},lT=(e,t,n)=>((e,t,n)=>((e,t)=>{const n=I.from(e.getParent(t.startContainer,"details")),o=I.from(e.getParent(t.endContainer,"details"));if(n.isSome()||o.isSome()){const t=n.bind(t=>I.from(e.select("summary",t)[0]));return I.some({startSummary:t,startDetails:n,endDetails:o})}return I.none()})(e.dom,e.selection.getRng()).fold(()=>aT(e,t,n),o=>iT(e,o,t,n)||aT(e,t,n)))(e,t,n)||JD&&((e,t,n)=>{const o=e.selection,r=o.getNode(),s=o.getRng(),a=Kl.fromRangeStart(s);return!!Es(r)&&("selection"===n&&tT(s,r)||my(t,a,r)?eT(r):e.undoManager.transact(()=>{const s=o.getSel();let{anchorNode:a,anchorOffset:i,focusNode:l,focusOffset:c}=s??{};const d=()=>{C(a)&&C(i)&&C(l)&&C(c)&&s?.setBaseAndExtent(a,i,l,c)},m=(e,t)=>{q(e.childNodes,e=>{ig(e)&&t.appendChild(e)})},u=e.dom.create("span",{"data-mce-bogus":"1"});m(r,u),r.appendChild(u),d(),"word"!==n&&"line"!==n||s?.modify("extend",t?"right":"left",n),!o.isCollapsed()&&tT(o.getRng(),u)?eT(r):(e.execCommand(t?"ForwardDelete":"Delete"),a=s?.anchorNode,i=s?.anchorOffset,l=s?.focusNode,c=s?.focusOffset,m(u,r),d()),e.dom.remove(u)}),!0)})(e,t,n)?I.some(x):I.none(),cT=Xt(),dT=cT.os,mT=dT.isMacOS()||dT.isiOS(),uT=cT.browser.isFirefox(),fT=(e,t)=>{const n=e.dom,o=e.schema.getMoveCaretBeforeOnEnterElements();if(!t)return;if(ji(un.fromDom(t))){const e=e=>zi(e)?I.from(e):dr(e,zi),o=e=>n.isEmpty(e.dom);(e=>{for(;e;){if(Xr(e)||ss(e)&&e.data&&/[\r\n\s]/.test(e.data))return I.from(un.fromDom(e));e=e.nextSibling}return I.none()})(t.firstChild).each(t=>{e(t).fold(()=>{if(o(t)){const e=YA(t,0).element;Rn(e)&&!Mi(e)&&go(e,un.fromHtml('<br data-mce-bogus="1" />'))}},e=>{mo(e,un.fromText(dt))})})}const r=n.createRng();if(t.normalize(),t.hasChildNodes()){const e=new Kr(t,t);let n,s=t;for(;n=e.current();){if(ss(n)){r.setStart(n,0),r.setEnd(n,0);break}if(o[n.nodeName.toLowerCase()]){r.setStartBefore(n),r.setEndBefore(n);break}s=n,n=e.next()}n||(r.setStart(s,0),r.setEnd(s,0))}else ms(t)?t.nextSibling&&n.isBlock(t.nextSibling)?(r.setStartBefore(t),r.setEndBefore(t)):(r.setStartAfter(t),r.setEndAfter(t)):(r.setStart(t,0),r.setEnd(t,0));e.selection.setRng(r),fh(e,r)},gT=(e,t)=>{const n=e.getRoot();let o,r=t;for(;r!==n&&r&&"false"!==e.getContentEditable(r);){if("true"===e.getContentEditable(r)){o=r;break}r=r.parentNode}return r!==n?o:n},pT=e=>I.from(e.dom.getParent(e.selection.getStart(!0),e.dom.isBlock)),hT=e=>{e.innerHTML='<br data-mce-bogus="1">'},bT=(e,t)=>{Ed(e).toLowerCase()===t.tagName.toLowerCase()&&((e,t,n)=>{const o=e.dom;I.from(n.style).map(o.parseStyle).each(e=>{const n={...qo(un.fromDom(t)),...e};o.setStyles(t,n)});const r=I.from(n.class).map(e=>e.split(/\s+/)),s=I.from(t.className).map(e=>Y(e.split(/\s+/),e=>""!==e));$e(r,s,(e,n)=>{const r=Y(n,t=>!$(e,t)),s=[...e,...r];o.setAttrib(t,"class",s.join(" "))});const a=["style","class"],i=we(n,(e,t)=>!$(a,t));o.setAttribs(t,i)})(e,t,xd(e))},yT=(e,t,n,o,r=!0,s,a)=>{const i=e.dom,l=e.schema,c=Ed(e),d=n?n.nodeName.toUpperCase():"";let m=t;const u=l.getTextInlineElements();let f;f=s||"TABLE"===d||"HR"===d?i.create(s||c,a||{}):n.cloneNode(!1);let g=f;if(r){do{if(u[m.nodeName]){if(Tf(m)||Vf(m))continue;const e=m.cloneNode(!1);i.setAttrib(e,"id",""),f.hasChildNodes()?(e.appendChild(f.firstChild),f.appendChild(e)):(g=e,f.appendChild(e))}}while((m=m.parentNode)&&m!==o);"LI"!==f.nodeName&&((e,t)=>{const n=un.fromDom(e),o=un.fromDom(t),r=On("span"),s=D(vn,n),a=e=>Rn(e)&&Vo(e,"font-size").isSome(),i=[...a(o)?[o]:[],..._r(o,a,s)];q(i.slice(1),e=>{Wo(e,"font-size"),xo(e,"data-mce-style"),r(e)&&_o(e)&&Ao(e)})})(f,g)}else i.setAttrib(f,"style",null),i.setAttrib(f,"class",null);return bT(e,f),hT(g),f},vT=(e,t)=>{const n=e?.parentNode;return C(n)&&n.nodeName===t},CT=e=>C(e)&&/^(OL|UL|LI)$/.test(e.nodeName),wT=e=>C(e)&&/^(LI|DT|DD)$/.test(e.nodeName),ST=e=>{const t=e.parentNode;return wT(t)?t:e},ET=(e,t,n)=>{let o=e[n?"firstChild":"lastChild"];for(;o&&!Xr(o);)o=o[n?"nextSibling":"previousSibling"];return o===t},xT=e=>X(Se(qo(un.fromDom(e)),(e,t)=>`${t}: ${e};`),(e,t)=>e+t,""),_T=(e,t)=>t&&"A"===t.nodeName&&e.isEmpty(t),kT=(e,t)=>e.nodeName===t||e.previousSibling&&e.previousSibling.nodeName===t,NT=(e,t)=>C(t)&&e.isBlock(t)&&!/^(TD|TH|CAPTION|FORM)$/.test(t.nodeName)&&!/^(fixed|absolute)/i.test(t.style.position)&&e.isEditable(t.parentNode)&&"false"!==e.getContentEditable(t),RT=(e,t,n)=>ss(t)?e?1===n&&t.data.charAt(n-1)===Ki?0:n:n===t.data.length-1&&t.data.charAt(n)===Ki?t.data.length:n:n,AT={insert:(e,t)=>{let n,o,r,s,a=!1;const i=e.dom,l=e.schema.getNonEmptyElements(),c=e.selection.getRng(),d=Ed(e),m=un.fromDom(c.startContainer),f=qn(m,c.startOffset),g=f.exists(e=>Nn(e)&&!Sr(e)),p=c.collapsed&&g,b=(t,o)=>yT(e,n,_,x,Rd(e),t,o),y=e=>{const t=RT(e,n,o);if(ss(n)&&(e?t>0:t<n.data.length))return!1;if((n.parentNode===_||n===_)&&a&&!e)return!0;if(e&&Xr(n)&&n===_.firstChild)return!0;if(kT(n,"TABLE")||kT(n,"HR"))return(e=>"BR"===e.nodeName||e.nextSibling&&"BR"===e.nextSibling.nodeName)(n)?!e:a&&!e||!a&&e;const r=new Kr(n,_);let s;for(ss(n)&&(e&&0===t?r.prev():e||t!==n.data.length||r.next());s=r.current();){if(Xr(s)){if(!s.getAttribute("data-mce-bogus")){const e=s.nodeName.toLowerCase();if(l[e]&&"br"!==e)return!1}}else if(ss(s)&&!Ns(s.data))return!1;e?r.prev():r.next()}return!0},w=()=>{let t;return t=/^(H[1-6]|PRE|FIGURE)$/.test(r)&&"HGROUP"!==k?b(d):b(),((e,t)=>{const n=Ad(e);return!v(t)&&(u(n)?$(dn.explode(n),t.nodeName.toLowerCase()):n)})(e,s)&&NT(i,s)&&i.isEmpty(_,void 0,{includeZwsp:!0})?t=i.split(s,_):i.insertAfter(t,_),fT(e,t),t};Wp(i,c).each(e=>{c.setStart(e.startContainer,e.startOffset),c.setEnd(e.endContainer,e.endOffset)}),n=c.startContainer,o=c.startOffset;const S=!(!t||!t.shiftKey),E=!(!t||!t.ctrlKey);Xr(n)&&n.hasChildNodes()&&!p&&(a=o>n.childNodes.length-1,n=n.childNodes[Math.min(o,n.childNodes.length-1)]||n,o=a&&ss(n)?n.data.length:0);const x=gT(i,n);if(!x||((e,t)=>{const n=e.dom.getParent(t,"ol,ul,dl");return null!==n&&"false"===e.dom.getContentEditableParent(n)})(e,n))return;S||(n=((e,t,n,o,r)=>{const s=e.dom,a=gT(s,o)??s.getRoot();let i=s.getParent(o,s.isBlock);if(!i||!NT(s,i)){if(i=i||a,!i.hasChildNodes()){const o=s.create(t);return bT(e,o),i.appendChild(o),n.setStart(o,0),n.setEnd(o,0),o}let l,c=o;for(;c&&c.parentNode!==i;)c=c.parentNode;for(;c&&!s.isBlock(c);)l=c,c=c.previousSibling;const d=l?.parentElement?.nodeName;if(l&&d&&e.schema.isValidChild(d,t.toLowerCase())){const a=l.parentNode,i=s.create(t);for(bT(e,i),a.insertBefore(i,l),c=l;c&&!s.isBlock(c);){const e=c.nextSibling;i.appendChild(c),c=e}n.setStart(o,r),n.setEnd(o,r)}}return o})(e,d,c,n,o));let _=i.getParent(n,i.isBlock)||i.getRoot();s=C(_?.parentNode)?i.getParent(_.parentNode,i.isBlock):null,r=_?_.nodeName.toUpperCase():"";const k=s?s.nodeName.toUpperCase():"";if("LI"!==k||E||(_=s,s=s.parentNode,r=k),Xr(s)&&((e,t,n)=>!t&&n.nodeName.toLowerCase()===Ed(e)&&e.dom.isEmpty(n)&&((e,t,n)=>{let o=t;for(;o&&o!==e&&h(o.nextSibling);){const e=o.parentElement;if(!e||!n(e))return Ss(e);o=e}return!1})(e.getBody(),n,t=>_e(e.schema.getTextBlockElements(),t.nodeName.toLowerCase())))(e,S,_))return((e,t,n)=>{const o=t(Ed(e)),r=((e,t)=>e.dom.getParent(t,Ss))(e,n);r&&(e.dom.insertAfter(o,r),fT(e,o),(n.parentElement?.childNodes?.length??0)>1&&e.dom.remove(n))})(e,b,_);if(/^(LI|DT|DD)$/.test(r)&&Xr(s)&&i.isEmpty(_))return void((e,t,n,o,r)=>{const s=e.dom,a=e.selection.getRng(),i=n.parentNode;if(n===e.getBody()||!i)return;var l;CT(l=n)&&CT(l.parentNode)&&(r="LI");const c=wT(o)?xT(o):void 0;let d=wT(o)&&c?t(r,{style:xT(o)}):t(r);if(ET(n,o,!0)&&ET(n,o,!1))if(vT(n,"LI")){const e=ST(n);s.insertAfter(d,e),(e=>e.parentNode?.firstChild===e)(n)?s.remove(e):s.remove(n)}else s.replace(d,n);else if(ET(n,o,!0))vT(n,"LI")?(s.insertAfter(d,ST(n)),d.appendChild(s.doc.createTextNode(" ")),d.appendChild(n)):i.insertBefore(d,n),s.remove(o);else if(ET(n,o,!1))s.insertAfter(d,ST(n)),s.remove(o);else{n=ST(n);const e=a.cloneRange();e.setStartAfter(o),e.setEndAfter(n);const t=e.extractContents();if("LI"===r&&(e=>e.firstChild&&"LI"===e.firstChild.nodeName)(t)){const e=Y(V(d.children,un.fromDom),T(On("br")));d=t.firstChild,s.insertAfter(t,n),q(e,e=>fo(un.fromDom(d),e)),c&&d.setAttribute("style",c)}else s.insertAfter(t,n),s.insertAfter(d,n);s.remove(o)}fT(e,d)})(e,b,s,_,d);if(!(p||_!==e.getBody()&&NT(i,_)))return;const N=_.parentNode;let R;if(p)R=b(d),f.fold(()=>{go(m,un.fromDom(R))},e=>{mo(e,un.fromDom(R))}),e.selection.setCursorLocation(R,0);else if(Zi(_))R=al(_),i.isEmpty(_)&&hT(_),bT(e,R),fT(e,R);else if(y(!1))R=w();else if(y(!0)&&N){const t=Kl.fromRangeStart(c),n=ib(t),o=un.fromDom(_),r=Eb(o,t,e.schema)?xb(o,t,e.schema).bind(e=>I.from(e.getNode())):I.none();R=N.insertBefore(b(),_);const s=kT(_,"HR")||n?R:r.getOr(_);fT(e,s)}else{const t=(e=>{const t=e.cloneRange();return t.setStart(e.startContainer,RT(!0,e.startContainer,e.startOffset)),t.setEnd(e.endContainer,RT(!1,e.endContainer,e.endOffset)),t})(c).cloneRange();t.setEndAfter(_);const n=t.extractContents();(e=>{q(Nr(un.fromDom(e),An),e=>{const t=e.dom;t.nodeValue=Gi(t.data)})})(n),(e=>{let t=e;do{ss(t)&&(t.data=t.data.replace(/^[\r\n]+/,"")),t=t.firstChild}while(t)})(n),R=n.firstChild,_===R?C(N)&&i.insertAfter(n,N):i.insertAfter(n,_),(e=>{const t=Wn(e).bind(jn);return ji(e)&&t.exists(zi)})(un.fromDom(R))?(e=>{const t=YA(un.fromDom(e),0).element;An(t)&&i.isEmpty(t.dom)&&t.dom.remove()})(R):(((e,t,n)=>{const o=[];if(!n)return;let r=n;for(;r=r.firstChild;){if(e.isBlock(r))return;Xr(r)&&!t[r.nodeName.toLowerCase()]&&o.push(r)}let s=o.length;for(;s--;)r=o[s],(!r.hasChildNodes()||r.firstChild===r.lastChild&&""===r.firstChild?.nodeValue||_T(e,r))&&e.remove(r)})(i,l,R),((e,t)=>{t.normalize();const n=t.lastChild;(!n||Xr(n)&&/^(left|right)$/gi.test(e.getStyle(n,"float",!0)))&&e.add(t,"br")})(i,_)),i.isEmpty(_)&&hT(_),R.normalize(),i.isEmpty(R)?(i.remove(R),w()):(bT(e,R),fT(e,R))}i.setAttrib(R,"id",""),e.dispatch("NewBlock",{newBlock:R})},fakeEventName:"insertParagraph"},DT=(e,t,n)=>{const o=e.dom.createRng();n?(o.setStartBefore(t),o.setEndBefore(t)):(o.setStartAfter(t),o.setEndAfter(t)),e.selection.setRng(o),fh(e,o)},TT=(e,t)=>{const n=un.fromTag("br");mo(un.fromDom(t),n),e.undoManager.add()},OT=(e,t)=>{BT(e.getBody(),t)||uo(un.fromDom(t),un.fromTag("br"));const n=un.fromTag("br");uo(un.fromDom(t),n),DT(e,n.dom,!1),e.undoManager.add()},BT=(e,t)=>{return n=Kl.after(t),!!ms(n.getNode())||kf(e,Kl.after(t)).map(e=>ms(e.getNode())).getOr(!1);var n},PT=e=>e&&"A"===e.nodeName&&"href"in e,LT=e=>e.fold(L,PT,PT,L),MT=(e,t)=>{t.fold(x,D(TT,e),D(OT,e),x)},IT={insert:(e,t)=>{const n=(e=>{const t=D(Jb,e),n=Kl.fromRangeStart(e.selection.getRng());return TN(t,e.getBody(),n).filter(LT)})(e);n.isSome()?n.each(D(MT,e)):((e,t)=>{const n=e.selection,o=e.dom,r=n.getRng();let s,a=!1;Wp(o,r).each(e=>{r.setStart(e.startContainer,e.startOffset),r.setEnd(e.endContainer,e.endOffset)});let i=r.startOffset,l=r.startContainer;if(Xr(l)&&l.hasChildNodes()){const e=i>l.childNodes.length-1;l=l.childNodes[Math.min(i,l.childNodes.length-1)]||l,i=e&&ss(l)?l.data.length:0}let c=o.getParent(l,o.isBlock);const d=c&&c.parentNode?o.getParent(c.parentNode,o.isBlock):null,m=d?d.nodeName.toUpperCase():"",u=!(!t||!t.ctrlKey);"LI"!==m||u||(c=d),ss(l)&&i>=l.data.length&&(((e,t,n)=>{const o=new Kr(t,n);let r;const s=e.getNonEmptyElements();for(;r=o.next();)if(s[r.nodeName.toLowerCase()]||ss(r)&&r.length>0)return!0;return!1})(e.schema,l,c||o.getRoot())||(s=o.create("br"),r.insertNode(s),r.setStartAfter(s),r.setEndAfter(s),a=!0)),s=o.create("br"),Gl(o,r,s),DT(e,s,a),e.undoManager.add()})(e,t)},fakeEventName:"insertLineBreak"},FT=(e,t)=>pT(e).filter(e=>t.length>0&&bn(un.fromDom(e),t)).isSome(),UT=Ne([{br:[]},{block:[]},{none:[]}]),zT=(e,t)=>(e=>FT(e,Nd(e)))(e),jT=e=>(t,n)=>(e=>pT(e).filter(e=>ji(un.fromDom(e))).isSome())(t)===e,$T=(e,t)=>(n,o)=>{const r=(e=>pT(e).fold(N(""),e=>e.nodeName.toUpperCase()))(n)===e.toUpperCase();return r===t},HT=e=>{const t=gT(e.dom,e.selection.getStart());return v(t)},VT=e=>$T("pre",e),qT=e=>(t,n)=>Sd(t)===e,WT=(e,t)=>(e=>FT(e,kd(e)))(e),KT=(e,t)=>t,YT=e=>{const t=Ed(e),n=gT(e.dom,e.selection.getStart());return C(n)&&e.schema.isValidChild(n.nodeName,t)},GT=e=>{const t=e.selection.getRng(),n=un.fromDom(t.startContainer),o=qn(n,t.startOffset).map(e=>Nn(e)&&!Sr(e));return t.collapsed&&o.getOr(!0)},XT=(e,t)=>(n,o)=>X(e,(e,t)=>e&&t(n,o),!0)?I.some(t):I.none(),QT=(e,t,n)=>{if(!t.mode.isReadOnly()){if(t.selection.isCollapsed()||(e=>{e.execCommand("delete")})(t),C(n)&&c_(t,e.fakeEventName).isDefaultPrevented())return;e.insert(t,n),C(n)&&l_(t,e.fakeEventName)}},ZT=(e,t)=>{if(e.mode.isReadOnly())return;const n=()=>QT(IT,e,t),o=()=>QT(AT,e,t),r=((e,t)=>wN([XT([zT],UT.none()),XT([VT(!0),HT],UT.none()),XT([$T("summary",!0)],UT.br()),XT([VT(!0),qT(!1),KT],UT.br()),XT([VT(!0),qT(!1)],UT.block()),XT([VT(!0),qT(!0),KT],UT.block()),XT([VT(!0),qT(!0)],UT.br()),XT([jT(!0),KT],UT.br()),XT([jT(!0)],UT.block()),XT([WT],UT.br()),XT([KT],UT.br()),XT([YT],UT.block()),XT([GT],UT.block())],[e,!(!t||!t.shiftKey)]).getOr(UT.none()))(e,t);switch(_d(e)){case"linebreak":r.fold(n,n,x);break;case"block":r.fold(o,o,x);break;case"invert":r.fold(o,n,x);break;default:r.fold(n,o,x)}},JT=Xt(),eO=JT.os.isiOS()&&JT.browser.isSafari(),tO=(e,t)=>{var n;t.isDefaultPrevented()||(t.preventDefault(),(n=e.undoManager).typing&&(n.typing=!1,n.add()),e.undoManager.transact(()=>{ZT(e,t)}))},nO=Xt(),oO=e=>e.stopImmediatePropagation(),rO=e=>e.keyCode===Tp.PAGE_UP||e.keyCode===Tp.PAGE_DOWN,sO=(e,t,n)=>{n&&!e.get()?t.on("NodeChange",oO,!0):!n&&e.get()&&t.off("NodeChange",oO),e.set(n)},aO=(e,t)=>e===t||e.contains(t),iO=(e,t)=>{const n=t.container(),o=t.offset();return ss(n)?(n.insertData(o,e),I.some(Kl(n,o+e.length))):rf(t).map(n=>{const o=un.fromText(e);return t.isAtEnd()?uo(n,o):mo(n,o),Kl(o.dom,e.length)})},lO=D(iO,dt),cO=D(iO," "),dO=e=>t=>{e.selection.setRng(t.toRange()),e.nodeChanged()},mO=e=>{const t=Kl.fromRangeStart(e.selection.getRng()),n=un.fromDom(e.getBody());if(e.selection.isCollapsed()){const o=D(Jb,e),r=Kl.fromRangeStart(e.selection.getRng());return TN(o,e.getBody(),r).bind((e=>t=>t.fold(t=>Nf(e.dom,Kl.before(t)),e=>Rf(e),e=>Af(e),t=>kf(e.dom,Kl.after(t))))(n)).map(o=>()=>((e,t,n)=>o=>Ob(e,o,n)?lO(t):cO(t))(n,t,e.schema)(o).each(dO(e)))}return I.none()},uO=e=>{return He(sn.browser.isFirefox()&&e.selection.isEditable()&&(t=e.dom,n=e.selection.getRng().startContainer,t.isEditable(t.getParent(n,"summary"))),()=>{const t=un.fromDom(e.getBody());e.selection.isCollapsed()||e.getDoc().execCommand("Delete"),((e,t,n)=>Ob(e,t,n)?lO(t):cO(t))(t,Kl.fromRangeStart(e.selection.getRng()),e.schema).each(dO(e))});var t,n},fO=e=>su(e)?[{keyCode:Tp.TAB,action:DA(BD,e,!0)},{keyCode:Tp.TAB,shiftKey:!0,action:DA(BD,e,!1)}]:[],gO=e=>{if(e.addShortcut("Meta+P","","mcePrint"),ZD(e),LE(e))return Re(null);{const t=AR(e);return(e=>{e.on("beforeinput",t=>{e.selection.isEditable()&&!H(t.getTargetRanges(),t=>!((e,t)=>!aO(e.getBody(),t.startContainer)||!aO(e.getBody(),t.endContainer)||gh(e.dom,t))(e,t))||t.preventDefault()})})(e),(e=>{e.on("keyup compositionstart",D(hA,e))})(e),((e,t)=>{e.on("keydown",n=>{n.isDefaultPrevented()||((e,t,n)=>{const o=sn.os.isMacOS()||sn.os.isiOS(),r=sn.browser.isFirefox();TA([{keyCode:Tp.RIGHT,action:DA(vA,e,!0)},{keyCode:Tp.LEFT,action:DA(vA,e,!1)},{keyCode:Tp.UP,action:DA(CA,e,!1)},{keyCode:Tp.DOWN,action:DA(CA,e,!0)},...o?[{keyCode:Tp.UP,action:DA(SA,e,!1),metaKey:!0,shiftKey:!0},{keyCode:Tp.DOWN,action:DA(SA,e,!0),metaKey:!0,shiftKey:!0}]:[],{keyCode:Tp.RIGHT,action:DA(_D,e,!0)},{keyCode:Tp.LEFT,action:DA(_D,e,!1)},{keyCode:Tp.UP,action:DA(kD,e,!1)},{keyCode:Tp.DOWN,action:DA(kD,e,!0)},{keyCode:Tp.UP,action:DA(kD,e,!1)},{keyCode:Tp.UP,action:DA(NA,e,!1)},{keyCode:Tp.DOWN,action:DA(NA,e,!0)},{keyCode:Tp.RIGHT,action:DA(BA,e,!0)},{keyCode:Tp.LEFT,action:DA(BA,e,!1)},{keyCode:Tp.UP,action:DA(PA,e,!1)},{keyCode:Tp.DOWN,action:DA(PA,e,!0)},{keyCode:Tp.RIGHT,action:DA(NR,e,t,!0)},{keyCode:Tp.LEFT,action:DA(NR,e,t,!1)},{keyCode:Tp.RIGHT,ctrlKey:!o,altKey:o,action:DA(DR,e,t)},{keyCode:Tp.LEFT,ctrlKey:!o,altKey:o,action:DA(TR,e,t)},{keyCode:Tp.UP,action:DA(kA,e,!1)},{keyCode:Tp.DOWN,action:DA(kA,e,!0)},...r?[{keyCode:Tp.UP,action:DA(xA,e,!1)},{keyCode:Tp.DOWN,action:DA(xA,e,!0)}]:[]],n).each(e=>{n.preventDefault()})})(e,t,n)})})(e,t),((e,t)=>{let n=!1,o=[];e.on("init",()=>{e.on("keydown",r=>{n=r.keyCode===Tp.BACKSPACE,o=UR(e),r.isDefaultPrevented()||((e,t,n)=>{const o=n.keyCode===Tp.BACKSPACE?"deleteContentBackward":"deleteContentForward",r=e.selection.isCollapsed(),s=r?"character":"selection",a=e=>r?e?"word":"line":"selection";OA([{keyCode:Tp.BACKSPACE,action:DA(nA,e)},{keyCode:Tp.BACKSPACE,action:DA(lN,e,!1)},{keyCode:Tp.DELETE,action:DA(lN,e,!0)},{keyCode:Tp.BACKSPACE,action:DA(eN,e,!1)},{keyCode:Tp.DELETE,action:DA(eN,e,!0)},{keyCode:Tp.BACKSPACE,action:DA(LR,e,t,!1)},{keyCode:Tp.DELETE,action:DA(LR,e,t,!0)},{keyCode:Tp.BACKSPACE,action:DA(Uy,e,!1)},{keyCode:Tp.DELETE,action:DA(Uy,e,!0)},{keyCode:Tp.BACKSPACE,action:DA(lT,e,!1,s)},{keyCode:Tp.DELETE,action:DA(lT,e,!0,s)},...mT?[{keyCode:Tp.BACKSPACE,altKey:!0,action:DA(lT,e,!1,a(!0))},{keyCode:Tp.DELETE,altKey:!0,action:DA(lT,e,!0,a(!0))},{keyCode:Tp.BACKSPACE,metaKey:!0,action:DA(lT,e,!1,a(!1))}]:[{keyCode:Tp.BACKSPACE,ctrlKey:!0,action:DA(lT,e,!1,a(!0))},{keyCode:Tp.DELETE,ctrlKey:!0,action:DA(lT,e,!0,a(!0))}],{keyCode:Tp.BACKSPACE,action:DA(dN,e,!1)},{keyCode:Tp.DELETE,action:DA(dN,e,!0)},{keyCode:Tp.BACKSPACE,action:DA(YR,e,!1)},{keyCode:Tp.DELETE,action:DA(YR,e,!0)},{keyCode:Tp.BACKSPACE,action:DA(Kk,e,!1)},{keyCode:Tp.DELETE,action:DA(Kk,e,!0)},{keyCode:Tp.BACKSPACE,action:DA(Vk,e,!1)},{keyCode:Tp.DELETE,action:DA(Vk,e,!0)},{keyCode:Tp.BACKSPACE,action:DA(qR,e,!1)},{keyCode:Tp.DELETE,action:DA(qR,e,!0)},{keyCode:Tp.BACKSPACE,action:DA(cN,e,!1)},{keyCode:Tp.DELETE,action:DA(cN,e,!0)},{keyCode:Tp.BACKSPACE,action:DA(oA,e,!1)},{keyCode:Tp.DELETE,action:DA(oA,e,!0)}],n).filter(t=>e.selection.isEditable()).each(t=>{n.preventDefault(),c_(e,o).isDefaultPrevented()||(t(),l_(e,o))})})(e,t,r)}),e.on("keyup",t=>{t.isDefaultPrevented()||(((e,t,n,o)=>{TA([{keyCode:Tp.BACKSPACE,action:DA(iN,e)},{keyCode:Tp.DELETE,action:DA(iN,e)},...mT?[{keyCode:Tp.BACKSPACE,altKey:!0,action:DA(WR,e)},{keyCode:Tp.DELETE,altKey:!0,action:DA(WR,e)},...n?[{keyCode:uT?224:91,action:DA(()=>($R(e,o),WR(e)))}]:[]]:[{keyCode:Tp.BACKSPACE,ctrlKey:!0,action:DA(WR,e)},{keyCode:Tp.DELETE,ctrlKey:!0,action:DA(WR,e)}]],t)})(e,t,n,o),o.length=0),n=!1})})})(e,t),(e=>{let t=I.none();e.on("keydown",n=>{n.keyCode===Tp.ENTER&&(eO&&(e=>{if(!e.collapsed)return!1;const t=e.startContainer;if(ss(t)){const n=/^[\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uD7B0-\uD7FF]$/,o=t.data.charAt(e.startOffset-1);return n.test(o)}return!1})(e.selection.getRng())?(e=>{t=I.some(e.selection.getBookmark()),e.undoManager.add()})(e):tO(e,n))}),e.on("keyup",n=>{n.keyCode===Tp.ENTER&&t.each(()=>((e,n)=>{e.undoManager.undo(),t.fold(x,t=>e.selection.moveToBookmark(t)),tO(e,n),t=I.none()})(e,n))})})(e),(e=>{e.on("keydown",t=>{t.isDefaultPrevented()||((e,t)=>{OA([{keyCode:Tp.SPACEBAR,action:DA(mO,e)},{keyCode:Tp.SPACEBAR,action:DA(uO,e)}],t).each(n=>{t.preventDefault(),c_(e,"insertText",{data:" "}).isDefaultPrevented()||(n(),l_(e,"insertText",{data:" "}))})})(e,t)})})(e),(e=>{e.on("input",t=>{t.isComposing||(e=>{const t=un.fromDom(e.getBody());e.selection.isCollapsed()&&zb(t,Kl.fromRangeStart(e.selection.getRng()),e.schema).each(t=>{e.selection.setRng(t.toRange())})})(e)})})(e),(e=>{e.on("keydown",t=>{t.isDefaultPrevented()||((e,t)=>{TA([...fO(e)],t).each(e=>{t.preventDefault()})})(e,t)})})(e),((e,t)=>{e.on("keydown",n=>{n.isDefaultPrevented()||((e,t,n)=>{const o=sn.os.isMacOS()||sn.os.isiOS();TA([{keyCode:Tp.END,action:DA(wA,e,!0)},{keyCode:Tp.HOME,action:DA(wA,e,!1)},...o?[]:[{keyCode:Tp.HOME,action:DA(SA,e,!1),ctrlKey:!0,shiftKey:!0},{keyCode:Tp.END,action:DA(SA,e,!0),ctrlKey:!0,shiftKey:!0}],{keyCode:Tp.END,action:DA(LA,e,!0)},{keyCode:Tp.HOME,action:DA(LA,e,!1)},{keyCode:Tp.END,action:DA(OR,e,!0,t)},{keyCode:Tp.HOME,action:DA(OR,e,!1,t)}],n).each(e=>{n.preventDefault()})})(e,t,n)})})(e,t),((e,t)=>{if(nO.os.isMacOS())return;const n=Re(!1);e.on("keydown",t=>{rO(t)&&sO(n,e,!0)}),e.on("keyup",o=>{o.isDefaultPrevented()||((e,t,n)=>{TA([{keyCode:Tp.PAGE_UP,action:DA(OR,e,!1,t)},{keyCode:Tp.PAGE_DOWN,action:DA(OR,e,!0,t)}],n)})(e,t,o),rO(o)&&n.get()&&(sO(n,e,!1),e.nodeChanged())})})(e,t),t}},pO=(e,t)=>()=>{const n=P_(e);return C(n)&&n.nodeName===t},hO=e=>3===e.type,bO=e=>0===e.length,yO=e=>{const t=(t,n)=>{const o=xh.create("li");q(t,e=>o.append(e)),n?e.insert(o,n,!0):e.append(o)},n=X(e.children(),(e,n)=>hO(n)?[...e,n]:bO(e)||hO(n)?e:(t(e,n),[]),[]);bO(n)||t(n)},vO=e=>{(e=>{e.on("init",()=>{e.on("keydown",t=>{t.defaultPrevented||(t.keyCode===Tp.BACKSPACE?Bk(e,!1)&&t.preventDefault():t.keyCode===Tp.DELETE&&Bk(e,!0)&&t.preventDefault())})})})(e),(e=>{e.addCommand("InsertUnorderedList",(t,n)=>{kk(e,"UL",n)}),e.addCommand("InsertOrderedList",(t,n)=>{kk(e,"OL",n)}),e.addCommand("InsertDefinitionList",(t,n)=>{kk(e,"DL",n)}),e.addCommand("RemoveList",()=>{gk(e)}),e.addCommand("mceListUpdate",(t,n)=>{f(n)&&((e,t)=>{const n=P_(e);null===n||$_(e,n)||e.undoManager.transact(()=>{f(t.styles)&&e.dom.setStyles(n,t.styles),f(t.attrs)&&he(t.attrs,(t,o)=>e.dom.setAttrib(n,o,t))})})(e,n)}),e.addCommand("mceListBackspaceDelete",(t,n)=>{Bk(e,n)}),e.addQueryStateHandler("InsertUnorderedList",pO(e,"UL")),e.addQueryStateHandler("InsertOrderedList",pO(e,"OL")),e.addQueryStateHandler("InsertDefinitionList",pO(e,"DL"))})(e),(e=>{e.on("PreInit",()=>{const{parser:t}=e;t.addNodeFilter("ul,ol",e=>q(e,yO))})})(e),(e=>{hu(e)&&(e=>{e.on("keydown",t=>{t.keyCode!==Tp.TAB||Tp.metaKeyPressed(t)||e.undoManager.transact(()=>{(t.shiftKey?fk(e):uk(e))&&t.preventDefault()})})})(e)})(e)};class CO{editor;lastPath=[];constructor(e){let t;this.editor=e;const n=this;"onselectionchange"in e.getDoc()||e.on("NodeChange click mouseup keyup focus",n=>{const o=e.selection.getRng(),r={startContainer:o.startContainer,startOffset:o.startOffset,endContainer:o.endContainer,endOffset:o.endOffset};"nodechange"!==n.type&&Up(r,t)||e.dispatch("SelectionChange"),t=r}),e.on("contextmenu",()=>{pp(e),e.dispatch("SelectionChange")}),e.on("SelectionChange",()=>{const t=e.selection.getStart(!0);t&&og(e)&&!n.isSameElementPath(t)&&e.dom.isChildOf(t,e.getBody())&&e.nodeChanged({selectionChange:!0})}),e.on("mouseup",t=>{!t.isDefaultPrevented()&&og(e)&&("IMG"===e.selection.getNode().nodeName?yp.setEditorTimeout(e,()=>{e.nodeChanged()}):e.nodeChanged())})}nodeChanged(e={}){const t=this.editor,n=t.selection;let o;if(t.initialized&&n&&!vm(t)&&!fu(t)){const r=t.getBody();o=n.getStart(!0)||r,o.ownerDocument===t.getDoc()&&t.dom.isChildOf(o,r)||(o=r);const s=[];t.dom.getParent(o,e=>e===r||(s.push(e),!1)),t.dispatch("NodeChange",{...e,element:o,parents:s})}}isSameElementPath(e){let t;const n=this.editor,o=re(n.dom.getParents(e,M,n.getBody()));if(o.length===this.lastPath.length){for(t=o.length;t>=0&&o[t]===this.lastPath[t];t--);if(-1===t)return this.lastPath=o,!0}return this.lastPath=o,!1}}const wO="x-tinymce/html",SO=N(wO),EO="\x3c!-- "+wO+" --\x3e",xO=e=>EO+e,_O=e=>-1!==e.indexOf(EO),kO="%MCEPASTEBIN%",NO=e=>e.dom.get("mcepastebin"),RO=e=>C(e)&&"mcepastebin"===e.id,AO=e=>e===kO,DO=(e,t)=>(dn.each(t,t=>{e=m(t,RegExp)?e.replace(t,""):e.replace(t[0],t[1])}),e),TO=e=>DO(e,[/^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/gi,/<!--StartFragment-->|<!--EndFragment-->/g,[/( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g,(e,t,n)=>t||n?dt:" "],/<br class="Apple-interchange-newline">/g,/<br>$/i]),OO=(e,t)=>({content:e,cancelled:t}),BO=(e,t)=>(e.insertContent(t,{merge:Hm(e),paste:!0}),!0),PO=e=>/^https?:\/\/[\w\-\/+=.,!;:&%@^~(){}?#]+$/i.test(e),LO=(e,t,n)=>!(e.selection.isCollapsed()||!PO(t))&&((e,t,n)=>(e.undoManager.extra(()=>{n(e,t)},()=>{e.execCommand("mceInsertLink",!1,t)}),!0))(e,t,n),MO=(e,t,n)=>!!((e,t)=>PO(t)&&H(ru(e),e=>Ze(t.toLowerCase(),`.${e.toLowerCase()}`)))(e,t)&&((e,t,n)=>(e.undoManager.extra(()=>{n(e,t)},()=>{e.insertContent('<img src="'+t+'">')}),!0))(e,t,n),IO=(()=>{let e=0;return()=>"mceclip"+e++})(),FO=e=>{const t=fD();return gD(t,e),aD(t),t},UO=(e,t,n,o,r)=>{const s=((e,t,n)=>((e,t,n)=>{const o=((e,t,n)=>e.dispatch("PastePreProcess",{content:t,internal:n}))(e,t,n),r=((e,t)=>{const n=bS({sanitize:nu(e),sandbox_iframes:lu(e),sandbox_iframes_exclusions:cu(e),convert_unsafe_embeds:du(e)},e.schema);n.addNodeFilter("meta",e=>{dn.each(e,e=>{e.remove()})});const o=n.parse(t,{forced_root_block:!1,isRootContent:!0});return Hh({validate:!0},e.schema).serialize(o)})(e,o.content);return e.hasEventListeners("PastePostProcess")&&!o.isDefaultPrevented()?((e,t,n)=>{const o=e.dom.create("div",{style:"display:none"},t),r=((e,t,n)=>e.dispatch("PastePostProcess",{node:t,internal:n}))(e,o,n);return OO(r.node.innerHTML,r.isDefaultPrevented())})(e,r,n):OO(r,o.isDefaultPrevented())})(e,t,n))(e,t,n);if(!s.cancelled){const t=s.content,n=()=>((e,t,n)=>{n||!Vm(e)?BO(e,t):((e,t)=>{dn.each([LO,MO,BO],n=>!n(e,t,BO))})(e,t)})(e,t,o);r?c_(e,"insertFromPaste",{dataTransfer:FO(t)}).isDefaultPrevented()||(n(),l_(e,"insertFromPaste")):n()}},zO=(e,t,n,o)=>{const r=n||_O(t);UO(e,(e=>e.replace(EO,""))(t),r,!1,o)},jO=(e,t,n)=>{const o=e.dom.encode(t).replace(/\r\n/g,"\n"),r=((e,t,n)=>{const o=e.split(/\n\n/),r=((e,t)=>{let n="<"+e;const o=Se(t,(e,t)=>t+'="'+Sa.encodeAllRaw(e)+'"');return o.length&&(n+=" "+o.join(" ")),n+">"})(t,n),s="</"+t+">",a=V(o,e=>e.split(/\n/).join("<br />"));return 1===a.length?a[0]:V(a,e=>r+e+s).join("")})(As(o,Wm(e)),Ed(e),xd(e));UO(e,r,!1,!0,n)},$O=e=>{const t={};if(e&&e.types)for(let n=0;n<e.types.length;n++){const o=e.types[n];try{t[o]=e.getData(o)}catch{t[o]=""}}return t},HO=(e,t)=>t in e&&e[t].length>0,VO=e=>HO(e,"text/html")||HO(e,"text/plain"),qO=async(e,t)=>xC(t.uri).fold(()=>Promise.resolve(),({data:n,type:o,base64Encoded:r})=>{const s=r?n:btoa(n),a=t.file,i=e.editorUpload.blobCache,l=(i.getByData(s,o)??((e,t,n,o)=>{const r=IO(),s=Td(e)&&C(n.name),a=s?((e,t)=>{const n=t.match(/([\s\S]+?)(?:\.[a-z0-9.]+)$/i);return C(n)?e.dom.encode(n[1]):void 0})(e,n.name):r,i=s?n.name:void 0,l=t.create(r,n,o,a,i);return t.add(l),l})(e,i,a,s)).blobUri();return(c=l,new Promise((e,t)=>{const n=document.createElement("img");n.addEventListener("load",()=>{e({width:n.naturalWidth,height:n.naturalHeight})}),n.addEventListener("error",()=>{t(`Failed to get image dimensions for: ${c}`)}),n.src=c})).then(({width:t,height:n})=>{zO(e,`<img width="${t}" height="${n}" src="${l}">`,!1,!0)}).catch(()=>{zO(e,`<img src="${l}">`,!1,!0)});var c}),WO=(e,t,n)=>{const o="paste"===t.type?t.clipboardData:t.dataTransfer;var r;if(Im(e)&&o){const s=((e,t)=>{const n=t.items?ne(me(t.items),e=>"file"===e.kind?[e.getAsFile()]:[]):[],o=t.files?me(t.files):[];return Y(n.length>0?n:o,(e=>{const t=ru(e);return e=>Qe(e.type,"image/")&&H(t,t=>(e=>{const t=e.toLowerCase(),n={jpg:"jpeg",jpe:"jpeg",jfi:"jpeg",jif:"jpeg",jfif:"jpeg",pjpeg:"jpeg",pjp:"jpeg",svg:"svg+xml"};return dn.hasOwn(n,t)?"image/"+n[t]:"image/"+t})(t)===e.type)})(e))})(e,o);if(s.length>0)return t.preventDefault(),(r=s,Promise.all(V(r,e=>kC(e).then(t=>({file:e,uri:t}))))).then(async t=>{n&&e.selection.setRng(n);for(const n of t)await qO(e,n)}),!0}return!1},KO=(e,t,n,o,r)=>{let s=TO(n);const a=HO(t,SO())||_O(n),i=!a&&(e=>!/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(e))(s),l=PO(s);(AO(s)||!s.length||i&&!l)&&(o=!0),(o||l)&&(s=HO(t,"text/plain")&&i?t["text/plain"]:(e=>{const t=Ua(),n=bS({},t);let o="";const r=t.getVoidElements(),s=dn.makeMap("script noscript style textarea video audio iframe object"," "),a=t.getBlockElements(),i=e=>{const n=e.name,l=e;if("br"!==n){if("wbr"!==n)if(r[n]&&(o+=" "),s[n])o+=" ";else{if(3===e.type&&(o+=e.value),!(e.name in t.getVoidElements())){let t=e.firstChild;if(t)do{i(t)}while(t=t.next)}a[n]&&l.next&&(o+="\n","p"===n&&(o+="\n"))}}else o+="\n"};return e=DO(e,[/<!\[[^\]]+\]>/g]),i(n.parse(e)),o})(s)),AO(s)||(o?jO(e,s,r):zO(e,s,a,r))},YO=(e,t,n)=>{((e,t,n)=>{let o;e.on("keydown",e=>{(e=>Tp.metaKeyPressed(e)&&86===e.keyCode||e.shiftKey&&45===e.keyCode)(e)&&!e.isDefaultPrevented()&&(o=e.shiftKey&&86===e.keyCode)}),e.on("paste",r=>{if(r.isDefaultPrevented()||(e=>sn.os.isAndroid()&&0===e.clipboardData?.items?.length)(r))return;const s="text"===n.get()||o;o=!1;const a=$O(r.clipboardData);!VO(a)&&WO(e,r,t.getLastRng()||e.selection.getRng())||(HO(a,"text/html")?(r.preventDefault(),KO(e,a,a["text/html"],s,!0)):HO(a,"text/plain")&&HO(a,"text/uri-list")?(r.preventDefault(),KO(e,a,a["text/plain"],s,!0)):(t.create(),yp.setEditorTimeout(e,()=>{const n=t.getHtml();t.remove(),KO(e,a,n,s,!1)},0)))})})(e,t,n),(e=>{const t=e=>Qe(e,"webkit-fake-url"),n=e=>Qe(e,"data:");e.parser.addNodeFilter("img",(o,r,s)=>{if(!Im(e)&&(e=>!0===e.data?.paste)(s))for(const r of o){const o=r.attr("src");u(o)&&!r.attr("data-mce-object")&&o!==sn.transparentSrc&&(t(o)||!Km(e)&&n(o))&&r.remove()}})})(e)},GO=(e,t,n,o)=>{((e,t,n)=>{if(!e)return!1;try{return e.clearData(),e.setData("text/html",t),e.setData("text/plain",n),e.setData(SO(),t),!0}catch{return!1}})(e.clipboardData,t.html,t.text)?(e.preventDefault(),o()):n(t.html,o)},XO=e=>(t,n)=>{const{dom:o,selection:r}=e,s=o.create("div",{contenteditable:"false","data-mce-bogus":"all"}),a=o.create("div",{contenteditable:"true"},t);o.setStyles(s,{position:"fixed",top:"0",left:"-3000px",width:"1000px",overflow:"hidden"}),s.appendChild(a),o.add(e.getBody(),s);const i=r.getRng();a.focus();const l=o.createRng();l.selectNodeContents(a),r.setRng(l),yp.setEditorTimeout(e,()=>{r.setRng(i),o.remove(s),n()},0)},QO=e=>({html:xO(e.selection.getContent({contextual:!0})),text:e.selection.getContent({format:"text"})}),ZO=e=>!e.selection.isCollapsed()||(e=>!!e.dom.getParent(e.selection.getStart(),"td[data-mce-selected],th[data-mce-selected]",e.getBody()))(e),JO=(e,t)=>Gp.getCaretRangeFromPoint(t.clientX??0,t.clientY??0,e.getDoc()),eB=(e,t)=>{t&&e.selection.setRng(t),e.focus()},tB=/rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi,nB=e=>dn.trim(e).replace(tB,Ya).toLowerCase(),oB=(e,t,n)=>{const o=jm(e);if(n||"all"===o||!$m(e))return t;const r=o?o.split(/[, ]/):[];if(r&&"none"!==o){const n=e.dom,o=e.selection.getNode();t=t.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi,(e,t,s,a)=>{const i=n.parseStyle(n.decode(s)),l={};for(let e=0;e<r.length;e++){const t=i[r[e]];let s=t,a=n.getStyle(o,r[e],!0);/color/.test(r[e])&&(s=nB(s),a=nB(a)),a!==s&&(l[r[e]]=t)}const c=n.serializeStyle(l,"span");return c?t+' style="'+c+'"'+a:t+a})}else t=t.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi,"$1$3");return t=t.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi,(e,t,n,o)=>t+' style="'+n+'"'+o),t},rB=(e,t)=>{const n=Re(!1),o=Re(qm(e)?"text":"html"),r=(e=>{const t=Re(null);return{create:()=>((e,t)=>{const{dom:n,selection:o}=e,r=e.getBody();t.set(o.getRng());const s=n.add(e.getBody(),"div",{id:"mcepastebin",class:"mce-pastebin",contentEditable:!0,"data-mce-bogus":"all",style:"position: fixed; top: 50%; width: 10px; height: 10px; overflow: hidden; opacity: 0"},kO);sn.browser.isFirefox()&&n.setStyle(s,"left","rtl"===n.getStyle(r,"direction",!0)?65535:-65535),n.bind(s,"beforedeactivate focusin focusout",e=>{e.stopPropagation()}),s.focus(),o.select(s,!0)})(e,t),remove:()=>((e,t)=>{const n=e.dom;if(NO(e)){let o;const r=t.get();for(;o=NO(e);)n.remove(o),n.unbind(o);r&&e.selection.setRng(r)}t.set(null)})(e,t),getEl:()=>NO(e),getHtml:()=>(e=>{const t=e.dom,n=(e,n)=>{e.appendChild(n),t.remove(n,!0)},[o,...r]=Y(e.getBody().childNodes,RO);q(r,e=>{n(o,e)});const s=t.select("div[id=mcepastebin]",o);for(let e=s.length-1;e>=0;e--){const r=t.create("div");o.insertBefore(r,s[e]),n(r,s[e])}return o?o.innerHTML:""})(e),getLastRng:t.get}})(e);(e=>{(sn.browser.isChromium()||sn.browser.isSafari())&&((e,t)=>{e.on("PastePreProcess",n=>{n.content=t(e,n.content,n.internal)})})(e,oB)})(e),((e,t)=>{e.addCommand("mceTogglePlainTextPaste",()=>{((e,t)=>{"text"===t.get()?(t.set("html"),ld(e,!1)):(t.set("text"),ld(e,!0)),e.focus()})(e,t)}),e.addCommand("mceInsertClipboardContent",(t,n)=>{n.html&&zO(e,n.html,n.internal,!1),n.text&&jO(e,n.text,!1)})})(e,o),(e=>{const t=t=>n=>{t(e,n)},n=Fm(e);w(n)&&e.on("PastePreProcess",t(n));const o=Um(e);w(o)&&e.on("PastePostProcess",t(o))})(e),e.addQueryStateHandler("mceTogglePlainTextPaste",()=>"text"===o.get()),e.on("PreInit",()=>{((e,t)=>{e.on("cut",((e,t)=>n=>{!n.isDefaultPrevented()&&ZO(e)&&e.selection.isEditable()&&GO(n,QO(e),XO(e),()=>{if(sn.browser.isChromium()||sn.browser.isFirefox()){const n=e.selection.getRng();yp.setEditorTimeout(e,()=>{e.selection.setRng(n),sA(e,t)},0)}else sA(e,t)})})(e,t)),e.on("copy",(e=>t=>{!t.isDefaultPrevented()&&ZO(e)&&GO(t,QO(e),XO(e),x)})(e))})(e,t),((e,t)=>{Mm(e)&&e.on("dragend dragover draggesture dragdrop drop drag",e=>{e.preventDefault(),e.stopPropagation()}),Im(e)||e.on("drop",e=>{const t=e.dataTransfer;t&&(e=>H(e.files,e=>/^image\//.test(e.type)))(t)&&e.preventDefault()}),e.on("drop",n=>{if(n.isDefaultPrevented())return;const o=JO(e,n);if(v(o))return;const r=$O(n.dataTransfer),s=HO(r,SO());if((!VO(r)||(e=>{const t=e["text/plain"];return!!t&&0===t.indexOf("file://")})(r))&&WO(e,n,o))return;const a=r[SO()],i=a||r["text/html"]||r["text/plain"],l=((e,t,n,o)=>{const r=e.getParent(n,e=>Zs(t,e));if(!h(e.getParent(n,"summary")))return!0;if(r&&_e(o,"text/html")){const e=(new DOMParser).parseFromString(o["text/html"],"text/html").body;return!h(e.querySelector(r.nodeName.toLowerCase()))}return!1})(e.dom,e.schema,o.startContainer,r),c=t.get();c&&!l||i&&(n.preventDefault(),yp.setEditorTimeout(e,()=>{e.undoManager.transact(()=>{(a||c&&l)&&e.execCommand("Delete"),eB(e,o);const t=TO(i);r["text/html"]?zO(e,t,s,!0):jO(e,t,!0)})}))}),e.on("dragstart",e=>{t.set(!0)}),e.on("dragover dragend",n=>{Im(e)&&!t.get()&&(n.preventDefault(),eB(e,JO(e,n))),"dragend"===n.type&&t.set(!1)}),(e=>{e.on("input",t=>{const n=e=>h(e.querySelector("summary"));if("deleteByDrag"===t.inputType){const t=Y(e.dom.select("details"),n);q(t,t=>{ms(t.firstChild)&&t.firstChild.remove();const n=e.dom.create("summary");n.appendChild(qi().dom),t.prepend(n)})}})})(e)})(e,n),YO(e,r,o)})},sB=ms,aB=ss,iB=e=>ps(e.dom),lB=e=>t=>vn(un.fromDom(e),t),cB=(e,t)=>lr(un.fromDom(e),iB,lB(t)),dB=(e,t,n)=>{const o=new Kr(e,t),r=n?o.next.bind(o):o.prev.bind(o);let s=e;for(let t=n?e:r();t&&!sB(t);t=r())Nl(t)&&(s=t);return s},mB=e=>{const t=((e,t,n)=>{const o=Kl.fromRangeStart(e).getNode(),r=((e,t,n)=>lr(un.fromDom(e),e=>(e=>gs(e.dom))(e)||n.isBlock(En(e)),lB(t)).getOr(un.fromDom(t)).dom)(o,t,n),s=dB(o,r,!1),a=dB(o,r,!0),i=document.createRange();return cB(s,r).fold(()=>{aB(s)?i.setStart(s,0):i.setStartBefore(s)},e=>i.setStartBefore(e.dom)),cB(a,r).fold(()=>{aB(a)?i.setEnd(a,a.data.length):i.setEndAfter(a)},e=>i.setEndAfter(e.dom)),i})(e.selection.getRng(),e.getBody(),e.schema);e.selection.setRng(vC(t))};var uB;!function(e){e.Before="before",e.After="after"}(uB||(uB={}));const fB=(e,t)=>Math.abs(e.left-t),gB=(e,t)=>Math.abs(e.right-t),pB=(e,t)=>(e=>X(e,(e,t)=>e.fold(()=>I.some(t),e=>{const n=Math.min(t.left,e.left),o=Math.min(t.top,e.top),r=Math.max(t.right,e.right),s=Math.max(t.bottom,e.bottom);return I.some({top:o,right:r,bottom:s,left:n,width:r-n,height:s-o})}),I.none()))(Y(e,e=>{return(n=t)>=(o=e).top&&n<=o.bottom;var n,o})).fold(()=>[[],e],t=>{const{pass:n,fail:o}=K(e,e=>((e,t)=>{const n=((e,t)=>Math.max(0,Math.min(e.bottom,t.bottom)-Math.max(e.top,t.top)))(e,t)/Math.min(e.height,t.height);return((e,t)=>e.top<t.bottom&&e.bottom>t.top)(e,t)&&n>.5})(e,t));return[n,o]}),hB=(e,t,n)=>t>e.left&&t<e.right?0:Math.min(Math.abs(e.left-t),Math.abs(e.right-t)),bB=(e,t,n,o)=>{const r=e=>Nl(e.node)?I.some(e):Xr(e.node)?bB(me(e.node.childNodes),t,n,!1):I.none(),s=(e,s)=>{const a=ie(e,(e,o)=>s(e,t,n)-s(o,t,n));return ue(a,r).map(e=>o&&!ss(e.node)&&a.length>1?((e,o,s)=>r(o).filter(o=>Math.abs(s(e,t,n)-s(o,t,n))<2&&ss(o.node)))(e,a[1],s).getOr(e):e)},[a,i]=pB(iR(e),n),{pass:l,fail:c}=K(i,e=>e.top<n);return s(a,hB).orThunk(()=>s(c,gl)).orThunk(()=>s(l,gl))},yB=(e,t,n)=>((e,t,n)=>{const o=un.fromDom(e),r=Pn(o),s=un.fromPoint(r,t,n).filter(e=>Cn(o,e)).getOr(o);return((e,t,n,o)=>{const r=(t,s)=>{const a=Y(t.dom.childNodes,T(e=>Xr(e)&&e.classList.contains("mce-drag-container")));return s.fold(()=>bB(a,n,o,!0),e=>{const t=Y(a,t=>t!==e.dom);return bB(t,n,o,!0)}).orThunk(()=>(vn(t,e)?I.none():In(t)).bind(e=>r(e,I.some(t))))};return r(t,I.none())})(o,s,t,n)})(e,t,n).filter(e=>Bu(e.node)).map(e=>((e,t)=>({node:e.node,position:fB(e,t)<gB(e,t)?uB.Before:uB.After}))(e,t)),vB=e=>{const t=e.getBoundingClientRect(),n=e.ownerDocument,o=n.documentElement,r=n.defaultView;return{top:t.top+(r?.scrollY??0)-o.clientTop,left:t.left+(r?.scrollX??0)-o.clientLeft}},CB=e=>({target:e,srcElement:e}),wB=(e,t,n,o)=>{const r=((e,t)=>{const n=(e=>{const t=fD(),n=(e=>{const t=e;return I.from(t[nD])})(e);return aD(e),ZA(t),t.dropEffect=e.dropEffect,t.effectAllowed=e.effectAllowed,(e=>{const t=e;return I.from(t[GA])})(e).each(e=>t.setDragImage(e.image,e.x,e.y)),q(e.types,n=>{"Files"!==n&&t.setData(n,e.getData(n))}),q(e.files,e=>t.items.add(e)),(e=>{const t=e;return I.from(t[XA])})(e).each(e=>{((e,t)=>{QA(t)(e)})(t,e)}),n.each(n=>{rD(e,n),rD(t,n)}),t})(e);return"dragstart"===t?(ZA(n),sD(n)):"drop"===t?(JA(n),aD(n)):(eD(n),iD(n)),n})(n,e);return y(o)?((e,t,n)=>{const o=O("Function not supported on simulated event.");return{bubbles:!0,cancelBubble:!1,cancelable:!0,composed:!1,currentTarget:null,defaultPrevented:!1,eventPhase:0,isTrusted:!0,returnValue:!1,timeStamp:0,type:e,composedPath:o,initEvent:o,preventDefault:x,stopImmediatePropagation:x,stopPropagation:x,AT_TARGET:window.Event.AT_TARGET,BUBBLING_PHASE:window.Event.BUBBLING_PHASE,CAPTURING_PHASE:window.Event.CAPTURING_PHASE,NONE:window.Event.NONE,altKey:!1,button:0,buttons:0,clientX:0,clientY:0,ctrlKey:!1,layerX:0,layerY:0,metaKey:!1,movementX:0,movementY:0,offsetX:0,offsetY:0,pageX:0,pageY:0,relatedTarget:null,screenX:0,screenY:0,shiftKey:!1,x:0,y:0,detail:0,view:null,which:0,initUIEvent:o,initMouseEvent:o,getModifierState:o,dataTransfer:n,...CB(t)}})(e,t,r):((e,t,n,o)=>({...t,dataTransfer:o,type:e,...CB(n)}))(e,o,t,r)},SB=ps,EB=((...e)=>t=>{for(let n=0;n<e.length;n++)if(e[n](t))return!0;return!1})(SB,gs),xB=(e,t,n,o)=>{const r=e.dom,s=t.cloneNode(!0);r.setStyles(s,{width:n,height:o}),r.setAttrib(s,"data-mce-selected",null);const a=r.create("div",{class:"mce-drag-container","data-mce-bogus":"all",unselectable:"on",contenteditable:"false"});return r.setStyles(a,{position:"absolute",opacity:.5,overflow:"hidden",border:0,padding:0,margin:0,width:n,height:o}),r.setStyles(s,{margin:0,boxSizing:"border-box"}),a.appendChild(s),a},_B=(e,t)=>n=>()=>{const o="left"===e?n.scrollX:n.scrollY;n.scroll({[e]:o+t,behavior:"smooth"})},kB=_B("left",-32),NB=_B("left",32),RB=_B("top",-32),AB=_B("top",32),DB=e=>{e&&e.parentNode&&e.parentNode.removeChild(e)},TB=(e,t,n,o,r)=>{"dragstart"===t&&gD(o,e.dom.getOuterHTML(n));const s=wB(t,n,o,r);return e.dispatch(t,s)},OB=(e,t)=>{const n=at((e,n)=>((e,t,n)=>{e._selectionOverrides.hideFakeCaret(),yB(e.getBody(),t,n).fold(()=>e.selection.placeCaretAt(t,n),o=>{const r=e._selectionOverrides.showCaret(1,o.node,o.position===uB.Before,!1);r?e.selection.setRng(r):e.selection.placeCaretAt(t,n)})})(t,e,n),0);t.on("remove",n.cancel);const o=e;return r=>e.on(e=>{const s=Math.max(Math.abs(r.screenX-e.screenX),Math.abs(r.screenY-e.screenY));if(!e.dragging&&s>10){const n=TB(t,"dragstart",e.element,e.dataTransfer,r);if(C(n.dataTransfer)&&(e.dataTransfer=n.dataTransfer),n.isDefaultPrevented())return;e.dragging=!0,t.focus()}if(e.dragging){const s=r.currentTarget===t.getDoc().documentElement,l=((e,t)=>({pageX:t.pageX-e.relX,pageY:t.pageY+5}))(e,((e,t)=>{return n=(e=>e.inline?vB(e.getBody()):{left:0,top:0})(e),o=(e=>{const t=e.getBody();return e.inline?{left:t.scrollLeft,top:t.scrollTop}:{left:0,top:0}})(e),r=((e,t)=>{if(t.target.ownerDocument!==e.getDoc()){const n=vB(e.getContentAreaContainer()),o=(e=>{const t=e.getBody(),n=e.getDoc().documentElement,o={left:t.scrollLeft,top:t.scrollTop},r={left:t.scrollLeft||n.scrollLeft,top:t.scrollTop||n.scrollTop};return e.inline?o:r})(e);return{left:t.pageX-n.left+o.left,top:t.pageY-n.top+o.top}}return{left:t.pageX,top:t.pageY}})(e,t),{pageX:r.left-n.left+o.left,pageY:r.top-n.top+o.top};var n,o,r})(t,r));a=e.ghost,i=t.getBody(),a.parentNode!==i&&i.appendChild(a),((e,t,n,o,r,s,a,i,l,c,d,m)=>{let u=0,f=0;e.style.left=t.pageX+"px",e.style.top=t.pageY+"px",t.pageX+n>r&&(u=t.pageX+n-r),t.pageY+o>s&&(f=t.pageY+o-s),e.style.width=n-u+"px",e.style.height=o-f+"px";const g=l.clientHeight,p=l.clientWidth,h=a+l.getBoundingClientRect().top,b=i+l.getBoundingClientRect().left;d.on(e=>{e.intervalId.clear(),e.dragging&&m&&(a+8>=g?e.intervalId.set(AB(c)):a-8<=0?e.intervalId.set(RB(c)):i+8>=p?e.intervalId.set(NB(c)):i-8<=0?e.intervalId.set(kB(c)):h+16>=window.innerHeight?e.intervalId.set(AB(window)):h-16<=0?e.intervalId.set(RB(window)):b+16>=window.innerWidth?e.intervalId.set(NB(window)):b-16<=0&&e.intervalId.set(kB(window)))})})(e.ghost,l,e.width,e.height,e.maxX,e.maxY,r.clientY,r.clientX,t.getContentAreaContainer(),t.getWin(),o,s),n.throttle(r.clientX,r.clientY)}var a,i})},BB=(e,t,n)=>{e.on(e=>{e.intervalId.clear(),e.dragging&&n.fold(()=>TB(t,"dragend",e.element,e.dataTransfer),n=>TB(t,"dragend",e.element,e.dataTransfer,n))}),PB(e)},PB=e=>{e.on(e=>{e.intervalId.clear(),DB(e.ghost)}),e.clear()},LB=e=>{const t=Ke(),n=gi.DOM,o=document,r=((e,t)=>n=>{if((e=>0===e.button)(n)){const o=Z(t.dom.getParents(n.target),EB).getOr(null);if(C(o)&&((e,t,n)=>SB(n)&&n!==t&&e.isEditable(n.parentElement))(t.dom,t.getBody(),o)){const r=t.dom.getPos(o),s=t.getBody(),a=t.getDoc().documentElement;e.set({element:o,dataTransfer:fD(),dragging:!1,screenX:n.screenX,screenY:n.screenY,maxX:(t.inline?s.scrollWidth:a.offsetWidth)-2,maxY:(t.inline?s.scrollHeight:a.offsetHeight)-2,relX:n.pageX-r.x,relY:n.pageY-r.y,width:o.offsetWidth,height:o.offsetHeight,ghost:xB(t,o,o.offsetWidth,o.offsetHeight),intervalId:We(100)})}}})(t,e),s=OB(t,e),a=((e,t)=>n=>{e.on(e=>{if(e.intervalId.clear(),e.dragging){if(((e,t,n)=>!v(t)&&t!==n&&!e.dom.isChildOf(t,n)&&e.dom.isEditable(t))(t,(e=>{const t=e.getSel();if(C(t)){const e=t.getRangeAt(0).startContainer;return ss(e)?e.parentNode:e}return null})(t.selection),e.element)){const o=t.getDoc().elementFromPoint(n.clientX,n.clientY)??t.getBody();TB(t,"drop",o,e.dataTransfer,n).isDefaultPrevented()||t.undoManager.transact(()=>{((e,t)=>{const n=e.getParent(t.parentNode,e.isBlock);DB(t),n&&n!==e.getRoot()&&e.isEmpty(n)&&Wi(un.fromDom(n))})(t.dom,e.element),(e=>{const t=e.getData("text/html");return""===t?I.none():I.some(t)})(e.dataTransfer).each(e=>t.insertContent(e)),t._selectionOverrides.hideFakeCaret()})}TB(t,"dragend",t.getBody(),e.dataTransfer,n)}}),PB(e)})(t,e),i=((e,t)=>n=>BB(e,t,I.some(n)))(t,e);e.on("mousedown",r),e.on("mousemove",s),e.on("mouseup",a),n.bind(o,"mousemove",s),n.bind(o,"mouseup",i),e.on("remove",()=>{n.unbind(o,"mousemove",s),n.unbind(o,"mouseup",i)}),e.on("keydown",n=>{n.keyCode===Tp.ESC&&BB(t,e,I.none())})},MB=ps,IB=(e,t)=>zy(e.getBody(),t),FB=e=>{const t=e.selection,n=e.dom,o=e.getBody(),r=Du(e,o,n.isBlock,()=>Rp(e)),s="sel-"+n.uniqueId(),a="data-mce-selected";let i;const l=e=>e!==o&&(MB(e)||Cs(e))&&n.isChildOf(e,o)&&n.isEditable(e.parentNode),c=(n,o,s,a=!0)=>e.dispatch("ShowCaret",{target:o,direction:n,before:s}).isDefaultPrevented()?null:(a&&t.scrollIntoView(o,-1===n),r.show(s,o)),d=e=>el(e)||rl(e)||sl(e),m=e=>d(e.startContainer)||d(e.endContainer),u=t=>{const o=e.schema.getVoidElements(),r=n.createRng(),s=t.startContainer,a=t.startOffset,i=t.endContainer,l=t.endOffset;return _e(o,s.nodeName.toLowerCase())?0===a?r.setStartBefore(s):r.setStartAfter(s):r.setStart(s,a),_e(o,i.nodeName.toLowerCase())?0===l?r.setEndBefore(i):r.setEndAfter(i):r.setEnd(i,l),r},f=(r,d)=>{if(!r)return null;if(r.collapsed){if(!m(r)){const e=d?1:-1,t=of(e,o,r),s=t.getNode(!d);if(C(s)){if(Bu(s))return c(e,s,!!d&&!t.isAtEnd(),!1);if(Ji(s)&&ps(s.nextSibling)){const e=n.createRng();return e.setStart(s,0),e.setEnd(s,0),e}}const a=t.getNode(d);if(C(a)){if(Bu(a))return c(e,a,!d&&!t.isAtEnd(),!1);if(Ji(a)&&ps(a.previousSibling)){const e=n.createRng();return e.setStart(a,1),e.setEnd(a,1),e}}}return null}let u=r.startContainer,f=r.startOffset;const g=r.endOffset;if(ss(u)&&0===f&&MB(u.parentNode)&&(u=u.parentNode,f=n.nodeIndex(u),u=u.parentNode),!Xr(u))return null;if(g===f+1&&u===r.endContainer){const o=u.childNodes[f];if(l(o))return(o=>{const r=_s(o)?(t=>{const n=e.getDoc().createElement("div");n.style.width=t.style.width,n.style.height=t.style.height;const o=t.getAttribute("width");o&&n.setAttribute("width",o);const r=t.getAttribute("height");return r&&n.setAttribute("height",r),n})(o):o.cloneNode(!0),l=e.dispatch("ObjectSelected",{target:o,targetClone:r});if(l.isDefaultPrevented())return null;const c=((o,r)=>{const a=un.fromDom(e.getBody()),i=e.getDoc(),l=ur(a,"#"+s).getOrThunk(()=>{const e=un.fromHtml('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>',i);return vo(e,"id",s),go(a,e),e}),c=n.createRng();No(l),bo(l,[un.fromText(dt,i),un.fromDom(r),un.fromText(dt,i)]),c.setStart(l.dom.firstChild,1),c.setEnd(l.dom.lastChild,0),jo(l,{top:n.getPos(o,e.getBody()).y+"px"}),io(l);const d=t.getSel();return d&&(d.removeAllRanges(),d.addRange(c)),c})(o,l.targetClone),d=un.fromDom(o);return q(Rr(un.fromDom(e.getBody()),`*[${a}]`),e=>{vn(d,e)||xo(e,a)}),n.getAttrib(o,a)||o.setAttribute(a,"1"),i=o,p(),c})(o)}return null},g=()=>{i&&i.removeAttribute(a),ur(un.fromDom(e.getBody()),"#"+s).each(Ro),i=null},p=()=>{r.hide()};return LE(e)||(e.on("click",t=>{n.isEditable(t.target)||(t.preventDefault(),e.focus())}),e.on("blur NewBlock",g),e.on("ResizeWindow FullscreenStateChanged",r.reposition),e.on("tap",t=>{const n=t.target,o=IB(e,n);MB(o)?(t.preventDefault(),Gk(e,o).each(f)):l(n)&&Gk(e,n).each(f)},!0),e.on("mousedown",r=>{const s=r.target;if(s!==o&&"HTML"!==s.nodeName&&!n.isChildOf(s,o))return;if(!((e,t,n)=>{const o=un.fromDom(e.getBody()),r=e.inline?o:un.fromDom(Pn(o).dom.documentElement),s=((e,t,n,o)=>{const r=(e=>e.dom.getBoundingClientRect())(t);return{x:n-(e?r.left+t.dom.clientLeft+tx(t):0),y:o-(e?r.top+t.dom.clientTop+ex(t):0)}})(e.inline,r,t,n);return((e,t,n)=>{const o=ZE(e),r=JE(e);return t>=0&&n>=0&&t<=o&&n<=r})(r,s.x,s.y)})(e,r.clientX,r.clientY))return;g(),p();const a=IB(e,s);MB(a)?(r.preventDefault(),Gk(e,a).each(f)):yB(o,r.clientX,r.clientY).each(n=>{var o;r.preventDefault(),(o=c(1,n.node,n.position===uB.Before,!1))&&t.setRng(o),Qr(a)?a.focus():e.getBody().focus()})}),e.on("keypress",e=>{Tp.modifierPressed(e)||MB(t.getNode())&&e.preventDefault()}),e.on("GetSelectionRange",e=>{let t=e.range;if(i){if(!i.parentNode)return void(i=null);t=t.cloneRange(),t.selectNode(i),e.range=t}}),e.on("focusin",t=>{if(!Cs(t.target)&&e.getBody().contains(t.target)&&t.target!==e.getBody()&&!e.dom.isEditable(t.target.parentNode)){r.isShowing()&&r.hide(),t.target.contains(e.selection.getNode())||(e.selection.select(t.target,!0),e.selection.collapse(!0));const n=f(e.selection.getRng(),!0);n&&e.selection.setRng(n)}}),e.on("SetSelectionRange",e=>{e.range=u(e.range);const t=f(e.range,e.forward);t&&(e.range=t)}),e.on("AfterSetSelectionRange",e=>{const t=e.range,o=t.startContainer.parentElement;var r;m(t)||Xr(r=o)&&"mcepastebin"===r.id||p(),(e=>C(e)&&n.hasClass(e,"mce-offscreen-selection"))(o)||g()}),(e=>{LB(e),_m(e)&&(e=>{const t=t=>{if(!t.isDefaultPrevented()){const n=t.dataTransfer;n&&($(n.types,"Files")||n.files.length>0)&&(t.preventDefault(),"drop"===t.type&&ix(e,"Dropped file type is not supported"))}},n=n=>{Sp(e,n.target)&&t(n)},o=()=>{const o=gi.DOM,r=e.dom,s=document,a=e.inline?e.getBody():e.getDoc(),i=["drop","dragover"];q(i,e=>{o.bind(s,e,n),r.bind(a,e,t)}),e.on("remove",()=>{q(i,e=>{o.unbind(s,e,n),r.unbind(a,e,t)})})};e.on("init",()=>{yp.setEditorTimeout(e,o,0)})})(e)})(e),(e=>{const t=at(()=>{if(!e.removed&&e.getBody().contains(document.activeElement)){const t=e.selection.getRng();if(t.collapsed){const n=Xk(e,t,!1);e.selection.setRng(n)}}},0);e.on("focus",()=>{t.throttle()}),e.on("blur",()=>{t.cancel()})})(e),(e=>{e.on("init",()=>{e.on("focusin",t=>{const n=t.target;if(Cs(n)){const t=zy(e.getBody(),n),o=ps(t)?t:n;e.selection.getNode()!==o&&Gk(e,o).each(t=>e.selection.setRng(t))}})})})(e)),{showCaret:c,showBlockCaretContainer:e=>{e.hasAttribute("data-mce-caret")&&(al(e),t.scrollIntoView(e))},hideFakeCaret:p,destroy:()=>{r.destroy(),i=null}}},UB=(e,t)=>{let n=t;for(let t=e.previousSibling;ss(t);t=t.previousSibling)n+=t.data.length;return n},zB=(e,t,n,o,r)=>{if(ss(n)&&(o<0||o>n.data.length))return[];const s=r&&ss(n)?[UB(n,o)]:[o];let a=n;for(;a!==t&&a.parentNode;)s.push(e.nodeIndex(a,r)),a=a.parentNode;return a===t?s.reverse():[]},jB=(e,t,n,o,r,s,a=!1)=>({start:zB(e,t,n,o,a),end:zB(e,t,r,s,a)}),$B=(e,t)=>{const n=t.slice(),o=n.pop();return S(o)?X(n,(e,t)=>e.bind(e=>I.from(e.childNodes[t])),I.some(e)).bind(e=>ss(e)&&(o<0||o>e.data.length)?I.none():I.some({node:e,offset:o})):I.none()},HB=(e,t)=>$B(e,t.start).bind(({node:n,offset:o})=>$B(e,t.end).map(({node:e,offset:t})=>{const r=document.createRange();return r.setStart(n,o),r.setEnd(e,t),r})),VB=(e,t,n)=>{if(t&&e.isEmpty(t)&&!n(t)){const o=t.parentNode;e.remove(t,ss(t.firstChild)&&Ns(t.firstChild.data)),VB(e,o,n)}},qB=(e,t,n,o=!0)=>{const r=t.startContainer.parentNode,s=t.endContainer.parentNode;t.deleteContents(),o&&!n(t.startContainer)&&(ss(t.startContainer)&&0===t.startContainer.data.length&&e.remove(t.startContainer),ss(t.endContainer)&&0===t.endContainer.data.length&&e.remove(t.endContainer),VB(e,r,n),r!==s&&VB(e,s,n))},WB=(e,t)=>I.from(e.dom.getParent(t.startContainer,e.dom.isBlock)),KB=(e,t,n)=>{const o=e.dynamicPatternsLookup({text:n,block:t});return{...e,blockPatterns:Zc(o).concat(e.blockPatterns),inlinePatterns:Jc(o).concat(e.inlinePatterns)}},YB=(e,t,n,o)=>{const r=e.createRng();return r.setStart(t,0),r.setEnd(n,o),r.toString()},GB=(e,t)=>e.create("span",{"data-mce-type":"bookmark",id:t}),XB=(e,t)=>{const n=e.createRng();return n.setStartAfter(t.start),n.setEndBefore(t.end),n},QB=(e,t,n)=>{const o=HB(e.getRoot(),n).getOrDie("Unable to resolve path range"),r=o.startContainer,s=o.endContainer,a=0===o.endOffset?s:s.splitText(o.endOffset),i=0===o.startOffset?r:r.splitText(o.startOffset),l=i.parentNode;return{prefix:t,end:a.parentNode.insertBefore(GB(e,t+"-end"),a),start:l.insertBefore(GB(e,t+"-start"),i)}},ZB=(e,t,n)=>{VB(e,e.get(t.prefix+"-end"),n),VB(e,e.get(t.prefix+"-start"),n)},JB=e=>0===e.start.length,eP=(e,t,n,o)=>{const r=t.start;var s;return zD(e,o.container,o.offset,(s=r,(e,t)=>{const n=e.data.substring(0,t),o=n.lastIndexOf(s.charAt(s.length-1)),r=n.lastIndexOf(s);return-1!==r?r+s.length:-1!==o?o+1:-1}),n).bind(o=>{const s=n.textContent?.indexOf(r)??-1;if(-1!==s&&o.offset>=s+r.length){const t=e.createRng();return t.setStart(o.container,o.offset-r.length),t.setEnd(o.container,o.offset),I.some(t)}{const s=o.offset-r.length;return FD(o.container,s,n).map(t=>{const n=e.createRng();return n.setStart(t.container,t.offset),n.setEnd(o.container,o.offset),n}).filter(e=>e.toString()===r).orThunk(()=>eP(e,t,n,PD(o.container,0)))}})},tP=(e,t,n,o)=>{const r=e.dom,s=r.getRoot(),a=n.pattern,i=n.position.container,l=n.position.offset;return FD(i,l-n.pattern.end.length,t).bind(c=>{const d=jB(r,s,c.container,c.offset,i,l,o);if(JB(a))return I.some({matches:[{pattern:a,startRng:d,endRng:d}],position:c});{const i=nP(e,n.remainingPatterns,c.container,c.offset,t,o),l=i.getOr({matches:[],position:c}),m=l.position,u=((e,t,n,o,r,s=!1)=>{if(0===t.start.length&&!s){const t=e.createRng();return t.setStart(n,o),t.setEnd(n,o),I.some(t)}return ID(n,o,r).bind(n=>eP(e,t,r,n).bind(e=>{if(s){if(e.endContainer===n.container&&e.endOffset===n.offset)return I.none();if(0===n.offset&&e.endContainer.textContent?.length===e.endOffset)return I.none()}return I.some(e)}))})(r,a,m.container,m.offset,t,i.isNone());return u.map(e=>{const t=((e,t,n,o=!1)=>jB(e,t,n.startContainer,n.startOffset,n.endContainer,n.endOffset,o))(r,s,e,o);return{matches:l.matches.concat([{pattern:a,startRng:t,endRng:d}]),position:PD(e.startContainer,e.startOffset)}})}})},nP=(e,t,n,o,r,s)=>{const a=e.dom;return ID(n,o,a.getRoot()).bind(i=>{const l=YB(a,r,n,o);for(let a=0;a<t.length;a++){const c=t[a];if(!Ze(l,c.end))continue;const d=t.slice();d.splice(a,1);const m=tP(e,r,{pattern:c,remainingPatterns:d,position:i},s);if(m.isNone()&&o>0)return nP(e,t,n,o-1,r,s);if(m.isSome())return m}return I.none()})},oP=(e,t,n)=>{e.selection.setRng(n),"inline-format"===t.type?q(t.format,t=>{e.formatter.apply(t)}):e.execCommand(t.cmd,!1,t.value)},rP=(e,t,n,o,r,s)=>{var a;return((e,t)=>{const n=oe(e,e=>H(t,t=>e.pattern.start===t.pattern.start&&e.pattern.end===t.pattern.end));return e.length===t.length?n?e:t:e.length>t.length?e:t})(nP(e,r.inlinePatterns,n,o,t,s).fold(()=>[],e=>e.matches),nP(e,(a=r.inlinePatterns,ie(a,(e,t)=>t.end.length-e.end.length)),n,o,t,s).fold(()=>[],e=>e.matches))},sP=(e,t)=>{if(0===t.length)return;const n=e.dom,o=e.selection.getBookmark(),r=((e,t)=>{const n=Le("mce_textpattern"),o=G(t,(t,o)=>{const r=QB(e,n+`_end${t.length}`,o.endRng);return t.concat([{...o,endMarker:r}])},[]);return G(o,(t,r)=>{const s=o.length-t.length-1,a=JB(r.pattern)?r.endMarker:QB(e,n+`_start${s}`,r.startRng);return t.concat([{...r,startMarker:a}])},[])})(n,t);q(r,t=>{const o=n.getParent(t.startMarker.start,n.isBlock),r=e=>e===o;JB(t.pattern)?((e,t,n,o)=>{const r=XB(e.dom,n);qB(e.dom,r,o),oP(e,t,r)})(e,t.pattern,t.endMarker,r):((e,t,n,o,r)=>{const s=e.dom,a=XB(s,o),i=XB(s,n);qB(s,i,r),qB(s,a,r);const l={prefix:n.prefix,start:n.end,end:o.start},c=XB(s,l);oP(e,t,c)})(e,t.pattern,t.startMarker,t.endMarker,r),ZB(n,t.endMarker,r),ZB(n,t.startMarker,r)}),e.selection.moveToBookmark(o)},aP=(e,t,n)=>((e,t,n)=>{if(ss(e)&&0>=e.length)return I.some(PD(e,0));{const t=Pi(LD);return I.from(t.forwards(e,0,MD(e),n)).map(e=>PD(e.container,0))}})(t,0,t).map(o=>{const r=o.container;return UD(r,n.start.length,t).each(n=>{const o=e.createRng();o.setStart(r,0),o.setEnd(n.container,n.offset),qB(e,o,e=>e===t)}),r}),iP=e=>(t,n)=>{const o=t.dom,r=n.pattern,s=HB(o.getRoot(),n.range).getOrDie("Unable to resolve path range");return WB(t,s).each(n=>{"block-format"===r.type?((e,t)=>{const n=t.get(e);return p(n)&&ce(n).exists(e=>_e(e,"block"))})(r.format,t.formatter)&&t.undoManager.transact(()=>{e(t.dom,n,r),t.formatter.apply(r.format)}):"block-command"===r.type&&t.undoManager.transact(()=>{e(t.dom,n,r),t.execCommand(r.cmd,!1,r.value)})}),!0},lP=e=>(t,n)=>{const o=(e=>ie(e,(e,t)=>t.start.length-e.start.length))(t),r=n.replace(dt," ");return Z(o,t=>e(t,n,r))},cP=(e,t)=>(n,o,r,s,a=o.textContent??"")=>{const i=n.dom,l=Ed(n);return i.is(o,l)?e(r.blockPatterns,a).map(e=>t&&dn.trim(a).length===e.start.length?[]:[{pattern:e,range:jB(i,i.getRoot(),o,0,o,0,s)}]).getOr([]):[]},dP=iP((e,t,n)=>{aP(e,t,n).each(e=>{const t=un.fromDom(e),n=or(t);/^\s[^\s]/.test(n)&&rr(t,n.slice(1))})}),mP=lP((e,t,n)=>0===t.indexOf(e.start)||0===n.indexOf(e.start)),uP=cP(mP,!0),fP=iP(aP),gP=lP((e,t,n)=>t===e.start||n===e.start),pP=cP(gP,!1),hP=(e,t,n)=>{for(let o=0;o<e.length;o++)if(n(e[o],t))return!0;return!1},bP=e=>{const t=[",",".",";",":","!","?"],n=[32],o=()=>{return t=Ym(e).filter(t=>"inline-command"!==t.type&&"block-command"!==t.type||e.queryCommandSupported(t.cmd)),n=Gm(e),{inlinePatterns:Jc(t),blockPatterns:Zc(t),dynamicPatternsLookup:n};var t,n},r=()=>(e=>e.options.isSet("text_patterns_lookup"))(e);e.on("keydown",t=>{if(13===t.keyCode&&!Tp.modifierPressed(t)&&e.selection.isCollapsed()&&e.selection.isEditable()){const n=ed(o(),"enter");(n.inlinePatterns.length>0||n.blockPatterns.length>0||r())&&((e,t)=>((e,t)=>{const n=e.selection.getRng();return WB(e,n).map(o=>{const r=Math.max(0,n.startOffset),s=KB(t,o,o.textContent??"");return{inlineMatches:rP(e,o,n.startContainer,r,s,!0),blockMatches:uP(e,o,s,!0)}}).filter(({inlineMatches:e,blockMatches:t})=>t.length>0||e.length>0)})(e,t).fold(L,({inlineMatches:t,blockMatches:n})=>(e.undoManager.add(),e.undoManager.extra(()=>{e.execCommand("mceInsertNewLine")},()=>{(e=>{e.insertContent(Ki,{preserve_zwsp:!0})})(e),sP(e,t),((e,t)=>{if(0===t.length)return;const n=e.selection.getBookmark();q(t,t=>dP(e,t)),e.selection.moveToBookmark(n)})(e,n);const o=e.selection.getRng(),r=ID(o.startContainer,o.startOffset,e.dom.getRoot());e.execCommand("mceInsertNewLine"),r.each(t=>{const n=t.container;n.data.charAt(t.offset-1)===ct&&(n.deleteData(t.offset-1,1),VB(e.dom,n.parentNode,t=>t===e.dom.getRoot()))})}),!0)))(e,n)&&t.preventDefault()}},!0),e.on("keydown",t=>{if(32===t.keyCode&&e.selection.isCollapsed()&&e.selection.isEditable()){const n=ed(o(),"space");(n.blockPatterns.length>0||r())&&((e,t)=>((e,t)=>{const n=e.selection.getRng();return WB(e,n).map(o=>{const r=Math.max(0,n.startOffset),s=YB(e.dom,o,n.startContainer,r),a=KB(t,o,s);return pP(e,o,a,!1,s)}).filter(e=>e.length>0)})(e,t).fold(L,t=>(e.undoManager.transact(()=>{((e,t)=>{q(t,t=>fP(e,t))})(e,t)}),!0)))(e,n)&&t.preventDefault()}},!0);const s=()=>{if(e.selection.isCollapsed()&&e.selection.isEditable()){const t=ed(o(),"space");(t.inlinePatterns.length>0||r())&&((e,t)=>{const n=e.selection.getRng();WB(e,n).map(o=>{const r=Math.max(0,n.startOffset-1),s=YB(e.dom,o,n.startContainer,r),a=KB(t,o,s),i=rP(e,o,n.startContainer,r,a,!1);i.length>0&&e.undoManager.transact(()=>{sP(e,i)})})})(e,t)}};e.on("keyup",e=>{hP(n,e,(e,t)=>e===t.keyCode&&!Tp.modifierPressed(t))&&s()}),e.on("keypress",n=>{hP(t,n,(e,t)=>e.charCodeAt(0)===t.charCode)&&yp.setEditorTimeout(e,s)})},yP=e=>{const t=dn.each,n=Tp.BACKSPACE,o=Tp.DELETE,r=e.dom,s=e.selection,a=e.parser,i=sn.browser,l=i.isFirefox(),c=i.isChromium()||i.isSafari(),d=i.isSafari(),m=sn.deviceType.isiPhone()||sn.deviceType.isiPad(),u=sn.os.isMacOS()||sn.os.isiOS(),f=(t,n)=>{try{e.getDoc().execCommand(t,!1,String(n))}catch{}},g=e=>e.isDefaultPrevented(),p=()=>{e.shortcuts.add("meta+a",null,"SelectAll")},h=()=>{e.inline||r.bind(e.getDoc(),"mousedown mouseup",t=>{let n;if(t.target===e.getDoc().documentElement)if(n=s.getRng(),null!==e.getDoc().getSelection()?.anchorNode&&e.getBody().focus(),"mousedown"===t.type){if(el(n.startContainer))return;s.placeCaretAt(t.clientX,t.clientY)}else s.setRng(n)})},b=()=>{Range.prototype.getClientRects||e.on("mousedown",t=>{if(!g(t)&&"HTML"===t.target.nodeName){const t=e.getBody();t.blur(),yp.setEditorTimeout(e,()=>{t.focus()})}})},y=()=>{const t=Rm(e);e.on("click",n=>{const o=n.target;/^(IMG|HR)$/.test(o.nodeName)&&r.isEditable(o)&&(n.preventDefault(),e.selection.select(o),e.nodeChanged()),"A"===o.nodeName&&r.hasClass(o,t)&&0===o.childNodes.length&&r.isEditable(o.parentNode)&&(n.preventDefault(),s.select(o))})},v=()=>{e.on("keydown",e=>{if(!g(e)&&e.keyCode===n&&s.isCollapsed()&&0===s.getRng().startOffset){const t=s.getNode().previousSibling;if(t&&t.nodeName&&"table"===t.nodeName.toLowerCase())return e.preventDefault(),!1}return!0})},w=()=>{Cm(e)||e.on("BeforeExecCommand mousedown",()=>{f("StyleWithCSS",!1),f("enableInlineTableEditing",!1),Zd(e)||f("enableObjectResizing",!1)})},S=()=>{e.inline||e.on("keydown",()=>{document.activeElement===document.body&&e.getWin().focus()})},E=()=>{e.inline||(e.contentStyles.push("body {min-height: 150px}"),e.on("click",t=>{let n;"HTML"===t.target.nodeName&&(n=e.selection.getRng(),e.getBody().focus(),e.selection.setRng(n),e.selection.normalize(),e.nodeChanged())}))},_=()=>{u&&e.on("keydown",t=>{!Tp.metaKeyPressed(t)||t.shiftKey||37!==t.keyCode&&39!==t.keyCode||(t.preventDefault(),e.selection.getSel().modify("move",37===t.keyCode?"backward":"forward","lineboundary"))})},k=()=>{e.on("click",e=>{let t=e.target;do{if("A"===t.tagName)return void e.preventDefault()}while(t=t.parentNode)}),e.contentStyles.push(".mce-content-body {-webkit-touch-callout: none}")},N=()=>{e.on("init",()=>{e.dom.bind(e.getBody(),"submit",e=>{e.preventDefault()})})},R=e=>iR([e.dom]).length>0,A=(e,t,n)=>le(iR([n.dom]),0).exists(n=>e>=n.right&&t>=n.top&&t<=n.bottom),D=(e,t,n)=>{t.preventDefault(),e.selection.setRng(n.toRange()),e.focus()},T=x;return LE(e)?(c&&(h(),y(),N(),p(),m&&(S(),E(),k())),l&&(b(),w(),_())):(e.on("keydown",t=>{if(g(t)||t.keyCode!==Tp.BACKSPACE)return;let n=s.getRng();const o=n.startContainer,a=n.startOffset,i=r.getRoot();let l=o;if(n.collapsed&&0===a){for(;l.parentNode&&l.parentNode.firstChild===l&&l.parentNode!==i;)l=l.parentNode;"BLOCKQUOTE"===l.nodeName&&(e.formatter.toggle("blockquote",void 0,l),n=r.createRng(),n.setStart(o,0),n.setEnd(o,0),s.setRng(n))}}),(()=>{const t=e=>{const t=r.create("body"),n=e.cloneContents();return t.appendChild(n),s.serializer.serialize(t,{format:"html"})};e.on("keydown",s=>{const a=s.keyCode;if(!g(s)&&(a===o||a===n)&&e.selection.isEditable()){const n=e.selection.isCollapsed(),i=e.getBody();if(n&&!Ps(e.schema,i))return;if(!n&&!(n=>{const o=t(n),s=r.createRng();return s.selectNode(e.getBody()),o===t(s)})(e.selection.getRng()))return;s.preventDefault(),d_(e,a===o,()=>e.setContent(""))&&(i.firstChild&&r.isBlock(i.firstChild)?e.selection.setCursorLocation(i.firstChild,0):e.selection.setCursorLocation(i,0))}})})(),sn.windowsPhone||e.on("keyup focusin mouseup",t=>{Tp.modifierPressed(t)||(e=>{const t=e.getBody(),n=e.selection.getRng();return n.startContainer===n.endContainer&&n.startContainer===t&&0===n.startOffset&&n.endOffset===t.childNodes.length})(e)||s.normalize()},!0),c&&(h(),y(),e.on("init",()=>{f("DefaultParagraphSeparator",Ed(e))}),N(),v(),a.addNodeFilter("br",e=>{let t=e.length;for(;t--;)"Apple-interchange-newline"===e[t].attr("class")&&e[t].remove()}),d||e.on("click",t=>{const n=un.fromDom(t.target);ji(n)&&(e=>cr(e,e=>Mi(e)||Rn(e)&&"block"===$o(e,"display")))(n).fold(()=>{Kn(n).each(o=>{A(t.clientX,t.clientY,o)&&Af(n.dom).each(n=>D(e,t,n))})},o=>{var r,s;(r=$n(o),s=R,ee(r,s).map(e=>e.v)).each(r=>{A(t.clientX,t.clientY,r)&&Nf(n.dom,Kl(o.dom,0)).each(n=>D(e,t,n))})})}),m?(S(),E(),k()):p()),l&&((()=>{const t=On("figcaption");e.on("keydown",n=>{if(n.keyCode===Tp.LEFT||n.keyCode===Tp.RIGHT){const o=un.fromDom(e.selection.getNode());t(o)&&e.selection.isCollapsed()&&Mn(o).bind(t=>0===e.selection.getRng().startOffset&&n.keyCode===Tp.LEFT?zn(t):e.selection.getRng().endOffset===o.dom.textContent?.length&&n.keyCode===Tp.RIGHT?jn(t):I.none()).each(t=>{e.selection.setCursorLocation(t.dom,0)})}})})(),e.on("mousedown",t=>{$e(I.from(t.clientX),I.from(t.clientY),(n,o)=>{const r=e.getDoc().caretPositionFromPoint(n,o),s=r?.offsetNode?.childNodes[r.offset-(r.offset>0?1:0)]||r?.offsetNode;if(C(s)&&"IMG"===(a=s).nodeName&&e.dom.isEditable(a)){const n=s.getBoundingClientRect();t.preventDefault(),e.hasFocus()||e.focus(),e.selection.select(s),t.clientX<n.left||t.clientY<n.top?e.selection.collapse(!0):(t.clientX>n.right||t.clientY>n.bottom)&&e.selection.collapse(!1)}var a})}),e.on("keydown",t=>{if(!g(t)&&t.keyCode===n){if(!e.getBody().getElementsByTagName("hr").length)return;if(s.isCollapsed()&&0===s.getRng().startOffset){const e=s.getNode(),n=e.previousSibling;if("HR"===e.nodeName)return r.remove(e),void t.preventDefault();n&&n.nodeName&&"hr"===n.nodeName.toLowerCase()&&(r.remove(n),t.preventDefault())}}}),b(),(()=>{const n=()=>{const n=r.getAttribs(s.getStart().cloneNode(!1));return()=>{const o=s.getStart();o!==e.getBody()&&(r.setAttrib(o,"style",null),t(n,e=>{o.setAttributeNode(e.cloneNode(!0))}))}},o=()=>!s.isCollapsed()&&r.getParent(s.getStart(),r.isBlock)!==r.getParent(s.getEnd(),r.isBlock);e.on("keypress",t=>{let r;return!(!(g(t)||8!==t.keyCode&&46!==t.keyCode)&&o()&&(r=n(),e.getDoc().execCommand("delete",!1),r(),t.preventDefault(),1))}),r.bind(e.getDoc(),"cut",t=>{if(!g(t)&&o()){const t=n();yp.setEditorTimeout(e,()=>{t()})}})})(),w(),e.on("SetContent ExecCommand",e=>{"setcontent"!==e.type&&"mceInsertLink"!==e.command||t(r.select("a:not([data-mce-block])"),e=>{let t=e.parentNode;const n=r.getRoot();if(t?.lastChild===e){for(;t&&!r.isBlock(t);){if(t.parentNode?.lastChild!==t||t===n)return;t=t.parentNode}r.add(t,"br",{"data-mce-bogus":1})}})}),_(),v())),{refreshContentEditable:T,isHidden:()=>{if(!l||e.removed)return!1;const t=e.selection.getSel();return!t||!t.rangeCount||0===t.rangeCount}}};class vP extends Error{url;constructor(e,t){super(e),this.url=t}}const CP={},wP=async(e,t)=>{const n=hi.ScriptLoader.getScriptAttributes(e);return await((e,t,n)=>new Promise((o,r)=>{const s=un.fromTag("script");Co(s,{type:"text/javascript",src:e,...n});const a=()=>{Ro(s)};so(s,"load",()=>{a(),o()}),so(s,"error",()=>{a(),r(new Error(`Failed to load script url: ${e}`))}),go(Gn(t),s)}))(e,t,n).catch(()=>Promise.reject(new vP(`Failed to load component url: ${e}`,e))),e},SP=async e=>{const t=(e=>{const t=e.schema.getComponentUrls();return e.inline?(e=>Se(e,(e,t)=>xe(CP,e).getOrThunk(()=>{if(v(window.customElements.get(t))){const t=wP(e,ao());return CP[e]=t,t}return Promise.resolve(e)}).catch(t=>(delete CP[e],Promise.reject(t)))))(t):((e,t)=>{const n=fe(Ee(e));return V(n,e=>wP(e,un.fromDom(t)))})(t,e.getDoc())})(e),n=Y(await Promise.allSettled(t),e=>"rejected"===e.status);n.length>0&&q(n,t=>{if(t.reason instanceof vP){const{url:n}=t.reason;((e,t)=>{lx(e,"ComponentLoadError",cx("component",t))})(e,n)}})},EP=gi.DOM,xP=e=>e.inline?e.getElement().nodeName.toLowerCase():void 0,_P=e=>we(e,e=>!1===y(e)),kP=e=>{const t=e.options.get,n=e.editorUpload.blobCache;return _P({allow_conditional_comments:t("allow_conditional_comments"),allow_html_data_urls:t("allow_html_data_urls"),allow_svg_data_urls:t("allow_svg_data_urls"),allow_html_in_named_anchor:t("allow_html_in_named_anchor"),allow_script_urls:t("allow_script_urls"),allow_html_in_comments:t("allow_html_in_comments"),allow_mathml_annotation_encodings:t("allow_mathml_annotation_encodings"),allow_unsafe_link_target:t("allow_unsafe_link_target"),convert_unsafe_embeds:t("convert_unsafe_embeds"),convert_fonts_to_spans:t("convert_fonts_to_spans"),extended_mathml_attributes:t("extended_mathml_attributes"),extended_mathml_elements:t("extended_mathml_elements"),fix_list_elements:t("fix_list_elements"),font_size_legacy_values:t("font_size_legacy_values"),forced_root_block:t("forced_root_block"),forced_root_block_attrs:t("forced_root_block_attrs"),preserve_cdata:t("preserve_cdata"),inline_styles:t("inline_styles"),root_name:xP(e),sandbox_iframes:t("sandbox_iframes"),sandbox_iframes_exclusions:cu(e),sanitize:t("xss_sanitization"),validate:!0,blob_cache:n,document:e.getDoc()})},NP=e=>{const t=e.options.get;return _P({custom_elements:t("custom_elements"),extended_valid_elements:t("extended_valid_elements"),invalid_elements:t("invalid_elements"),invalid_styles:t("invalid_styles"),schema:t("schema"),valid_children:t("valid_children"),valid_classes:t("valid_classes"),valid_elements:t("valid_elements"),valid_styles:t("valid_styles"),verify_html:t("verify_html"),padd_empty_block_inline_children:t("format_empty_lines")})},RP=e=>e.inline?e.ui.styleSheetLoader:e.dom.styleSheetLoader,AP=e=>{const t=RP(e),n=Gd(e),o=e.contentCSS,r=()=>{t.unloadAll(o),e.inline||e.ui.styleSheetLoader.unloadAll(n)},s=()=>{e.removed?r():e.on("remove",r)};if(e.contentStyles.length>0){let t="";dn.each(e.contentStyles,e=>{t+=e+"\r\n"}),e.dom.addStyle(t)}const a=Promise.all(((e,t,n)=>{const{pass:o,fail:r}=K(t,e=>tinymce.Resource.has(e)),s=o.map(t=>{const n=tinymce.Resource.get(t);return u(n)?Promise.resolve(RP(e).loadRawCss(t,n)):Promise.resolve()}),a=[...s,RP(e).loadAll(r)];return e.inline?a:a.concat([e.ui.styleSheetLoader.loadAll(n)])})(e,o,n)).then(s).catch(s),i=Kd(e);return i&&((e,t)=>{const n=un.fromDom(e.getBody()),o=Zn(Qn(n)),r=un.fromTag("style");vo(r,"type","text/css"),go(r,un.fromText(t)),go(o,r),e.on("remove",()=>{Ro(r)})})(e,i),a},DP=e=>{!0!==e.removed&&((e=>{LE(e)||e.load({initial:!0,format:"html"}),e.startContent=e.getContent({format:"raw"})})(e),(e=>{e.bindPendingEventDelegates(),e.initialized=!0,(e=>{e.dispatch("Init")})(e),e.focus(!0),(e=>{const t=e.dom.getRoot();e.inline||og(e)&&e.selection.getStart(!0)!==t||Rf(t).each(t=>{const n=t.getNode(),o=ns(n)?Rf(n).getOr(t):t;e.selection.setRng(o.toRange())})})(e),e.nodeChanged({initial:!0});const t=Tm(e);w(t)&&t.call(e,e),(e=>{const t=Bm(e);t&&yp.setEditorTimeout(e,()=>{let n;n=!0===t?e:e.editorManager.get(t),n&&!n.destroyed&&(n.focus(),n.selection.scrollIntoView())},100)})(e),Ax(e)&&Tx(e,!0)})(e))},TP=e=>{const t=e.getElement();let n=e.getDoc();e.inline&&(EP.addClass(t,"mce-content-body"),e.contentDocument=n=document,e.contentWindow=window,e.bodyElement=t,e.contentAreaContainer=t);const o=Yd(e);if(o){const r=e.inline?t:n.documentElement;EP.setAttrib(r,"lang",o)}const r=e.getBody();r.disabled=!0,e.readonly=Cm(e),e._editableRoot=wm(e),!fu(e)&&e.hasEditableRoot()&&(e.inline&&"static"===EP.getStyle(r,"position",!0)&&(r.style.position="relative"),r.contentEditable="true"),r.disabled=!1,e.editorUpload=Hx(e),e.schema=Ua(NP(e)),e.dom=gi(n,{keep_values:!0,url_converter:e.convertURL,url_converter_scope:e,update_styles:!0,root_element:e.inline?e.getBody():null,collect:e.inline,schema:e.schema,contentCssCors:Ud(e),referrerPolicy:zd(e),crossOrigin:jd(e),onSetAttrib:t=>{e.dispatch("SetAttrib",t)}}),e.parser=(e=>{const t=bS(kP(e),e.schema);return t.addAttributeFilter("data-mce-src,data-mce-href,data-mce-style",(e,t)=>{for(let n=0;n<e.length;n++)e[n].attr(t,null)}),t.addAttributeFilter("src,href,style,tabindex",(t,n)=>{const o=e.dom,r="data-mce-"+n;let s=t.length;for(;s--;){const a=t[s];let i=a.attr(n);if(i&&!a.attr(r)){if(0===i.indexOf("data:")||0===i.indexOf("blob:"))continue;"style"===n?(i=o.serializeStyle(o.parseStyle(i),a.name),i.length||(i=null),a.attr(r,i),a.attr(n,i)):"tabindex"===n?(a.attr(r,i),a.attr(n,null)):a.attr(r,e.convertURL(i,n,a.name))}}}),t.addNodeFilter("script",e=>{let t=e.length;for(;t--;){const n=e[t],o=n.attr("type")||"no/type";0!==o.indexOf("mce-")&&n.attr("type","mce-"+o)}}),eu(e)&&t.addNodeFilter("#cdata",t=>{let n=t.length;for(;n--;){const o=t[n];o.type=8,o.name="#comment",o.value="[CDATA["+e.dom.encode(o.value??"")+"]]"}}),t.addNodeFilter("p,h1,h2,h3,h4,h5,h6,div",t=>{let n=t.length;const o=e.schema.getNonEmptyElements();for(;n--;){const e=t[n];e.isEmpty(o)&&0===e.getAll("br").length&&e.append(new xh("br",1))}}),t})(e),e.serializer=VE((e=>{const t=e.options.get;return{...kP(e),...NP(e),..._P({remove_trailing_brs:t("remove_trailing_brs"),pad_empty_with_br:t("pad_empty_with_br"),url_converter:t("url_converter"),url_converter_scope:t("url_converter_scope"),element_format:t("element_format"),entities:t("entities"),entity_encoding:t("entity_encoding"),indent:t("indent"),indent_after:t("indent_after"),indent_before:t("indent_before")})}})(e),e),e.selection=jE(e.dom,e.getWin(),e.serializer,e),e.annotator=Jg(e),e.formatter=e_(e),e.undoManager=n_(e),e._nodeChangeDispatcher=new CO(e),e._selectionOverrides=FB(e),vO(e),(e=>{const t=Ke(),n=Re(!1),o=it(t=>{e.dispatch("longpress",{...t,type:"longpress"}),n.set(!0)},400);e.on("touchstart",e=>{aA(e).each(r=>{o.cancel();const s={x:r.clientX,y:r.clientY,target:e.target};o.throttle(e),n.set(!1),t.set(s)})},!0),e.on("touchmove",r=>{o.cancel(),aA(r).each(o=>{t.on(r=>{((e,t)=>{const n=Math.abs(e.clientX-t.x),o=Math.abs(e.clientY-t.y);return n>5||o>5})(o,r)&&(t.clear(),n.set(!1),e.dispatch("longpresscancel"))})})},!0),e.on("touchend touchcancel",r=>{o.cancel(),"touchcancel"!==r.type&&t.get().filter(e=>e.target.isEqualNode(r.target)).each(()=>{n.get()?r.preventDefault():e.dispatch("tap",{...r,type:"tap"})})},!0)})(e),(e=>{(e=>{e.on("click",t=>{e.dom.getParent(t.target,"details")&&t.preventDefault()})})(e),(e=>{e.parser.addNodeFilter("details",t=>{const n=au(e);q(t,e=>{"expanded"===n?e.attr("open","open"):"collapsed"===n&&e.attr("open",null)})}),e.serializer.addNodeFilter("details",t=>{const n=iu(e);q(t,e=>{"expanded"===n?e.attr("open","open"):"collapsed"===n&&e.attr("open",null)})})})(e)})(e),Xm(e)&&(e=>{const t="contenteditable",n=" "+dn.trim(Zm(e))+" ",o=" "+dn.trim(Qm(e))+" ",r=uA(n),s=uA(o),a=Jm(e);a.length>0&&e.on("BeforeSetContent",t=>{((e,t,n)=>{let o=t.length,r=n.content;if("raw"!==n.format){for(;o--;)r=r.replace(t[o],fA(e,r,Qm(e)));n.content=r}})(e,a,t)}),e.parser.addAttributeFilter("class",e=>{let n=e.length;for(;n--;){const o=e[n];r(o)?o.attr(t,"true"):s(o)&&o.attr(t,"false")}}),e.serializer.addAttributeFilter(t,e=>{let n=e.length;for(;n--;){const o=e[n];if(!r(o)&&!s(o))continue;const i=o.attr("data-mce-content");a.length>0&&i?gA(a,i)?(o.name="#text",o.type=3,o.raw=!0,o.value=i):o.remove():o.attr(t,null)}})})(e),LE(e)||((e=>{e.on("mousedown",t=>{t.detail>=3&&(t.preventDefault(),mB(e))})})(e),(e=>{bP(e)})(e));const s=gO(e);((e,t)=>{e.addCommand("delete",()=>{sA(e,t)}),e.addCommand("forwardDelete",()=>{((e,t)=>{rA(e,t,!0).fold(()=>{e.selection.isEditable()&&iy(e)},P),Ok(e)&&k_(e.dom,e.getBody())})(e,t)})})(e,s),(e=>{e.on("NodeChange",()=>(e=>{const t=e.dom,n=e.selection,o=e.schema,r=o.getBlockElements(),s=n.getStart(),a=e.getBody();let i,l,c=null;const d=Ed(e);if(!s||!Xr(s))return;const m=a.nodeName.toLowerCase();if(!o.isValidChild(m,d.toLowerCase())||((e,t,n)=>H(db(un.fromDom(n),un.fromDom(t)),t=>iA(e,t.dom)))(r,a,s))return;if(a.firstChild===a.lastChild&&ms(a.firstChild))return i=dA(e),i.appendChild(qi().dom),a.replaceChild(i,a.firstChild),e.selection.setCursorLocation(i,0),void e.nodeChanged();let u=a.firstChild;for(;u;)if(Xr(u)&&Ys(o,u),lA(o,u)){if(cA(r,u)){l=u,u=u.nextSibling,t.remove(l);continue}if(!i){if(!c&&e.hasFocus()&&(c=Xy(e.selection.getRng(),()=>document.createElement("span"))),!u.parentNode){u=null;break}i=dA(e),a.insertBefore(i,u)}l=u,u=u.nextSibling,i.appendChild(l)}else i=null,u=u.nextSibling;c&&(e.selection.setRng(Qy(c)),e.nodeChanged())})(e))})(e),(e=>{const t=e.dom,n=Ed(e),o=em(e)??"",r=(s,a)=>{if((e=>{if(s_(e)){const t=e.keyCode;return!a_(e)&&(Tp.metaKeyPressed(e)||e.altKey||t>=112&&t<=123||$(o_,t))}return!1})(s))return;const i=e.getBody(),l=!(e=>s_(e)&&!(a_(e)||"keyup"===e.type&&229===e.keyCode))(s)&&((e,t,n)=>{if(e.isEmpty(t,void 0,{skipBogus:!1,includeZwsp:!0})){const o=t.firstElementChild;return!o||!e.getStyle(t.firstElementChild,"padding-left")&&!e.getStyle(t.firstElementChild,"padding-right")&&n===o.nodeName.toLowerCase()}return!1})(t,i,n);(""!==t.getAttrib(i,r_)!==l||a)&&(t.setAttrib(i,r_,l?o:null),((e,t)=>{e.dispatch("PlaceholderToggle",{state:t})})(e,l),e.on(l?"keydown":"keyup",r),e.off(l?"keyup":"keydown",r))};ot(o)&&e.on("init",t=>{r(t,!0),e.on("change SetContent ExecCommand",r),e.on("paste",t=>yp.setEditorTimeout(e,()=>r(t)))})})(e),rB(e,s);const a=(e=>{const t=e;return(e=>xe(e.plugins,"rtc").bind(e=>I.from(e.setup)))(e).fold(()=>(t.rtcInstance=PE(e),I.none()),e=>(t.rtcInstance=(()=>{const e=N(null),t=N("");return{init:{bindEvents:x},undoManager:{beforeChange:x,add:e,undo:e,redo:e,clear:x,reset:x,hasUndo:L,hasRedo:L,transact:e,ignore:x,extra:x},formatter:{match:L,matchAll:N([]),matchNode:N(void 0),canApply:L,closest:t,apply:x,remove:x,toggle:x,formatChanged:N({unbind:x})},editor:{getContent:t,setContent:N({content:"",html:""}),insertContent:N(""),addVisual:x},selection:{getContent:t},autocompleter:{addDecoration:x,removeDecoration:x},raw:{getModel:N(I.none())}}})(),I.some(()=>e().then(e=>(t.rtcInstance=(e=>{const t=e=>f(e)?e:{},{init:n,undoManager:o,formatter:r,editor:s,selection:a,autocompleter:i,raw:l}=e;return{init:{bindEvents:n.bindEvents},undoManager:{beforeChange:o.beforeChange,add:o.add,undo:o.undo,redo:o.redo,clear:o.clear,reset:o.reset,hasUndo:o.hasUndo,hasRedo:o.hasRedo,transact:(e,t,n)=>o.transact(n),ignore:(e,t)=>o.ignore(t),extra:(e,t,n,r)=>o.extra(n,r)},formatter:{match:(e,n,o,s)=>r.match(e,t(n),s),matchAll:r.matchAll,matchNode:r.matchNode,canApply:e=>r.canApply(e),closest:e=>r.closest(e),apply:(e,n,o)=>r.apply(e,t(n)),remove:(e,n,o,s)=>r.remove(e,t(n)),toggle:(e,n,o)=>r.toggle(e,t(n)),formatChanged:(e,t,n,o,s)=>r.formatChanged(t,n,o,s)},editor:{getContent:e=>s.getContent(e),setContent:(e,t)=>({content:s.setContent(e,t),html:""}),insertContent:(e,t)=>(s.insertContent(e),""),addVisual:s.addVisual},selection:{getContent:(e,t)=>a.getContent(t)},autocompleter:{addDecoration:i.addDecoration,removeDecoration:i.removeDecoration},raw:{getModel:()=>I.some(l.getRawModel())}}})(e),e.rtc.isRemote)))))})(e);(e=>{const t=e.getDoc(),n=e.getBody();(e=>{e.dispatch("PreInit")})(e),Pm(e)||(t.body.spellcheck=!1,EP.setAttrib(n,"spellcheck","false")),e.quirks=yP(e),(e=>{e.dispatch("PostRender")})(e);const o=Xd(e);void 0!==o&&(n.dir=o);const r=Lm(e);r&&((e,t)=>{((e,t)=>{e.on("BeforeSetContent",e=>{q(t,t=>{e.content=e.content.replace(t,e=>"\x3c!--mce:protected "+escape(e)+"--\x3e")})})})(e,t),((e,t)=>{e.serializer.addNodeFilter("#comment",e=>{let n=e.length;for(;n--;){const o=e[n],r=o.value;if(0===r?.indexOf("mce:protected ")){const e=unescape(r).substr(14);H(t,t=>{const n=e.match(t);return null!==n&&n[0].length===e.length})?(o.name="#text",o.type=3,o.raw=!0,o.value=e):o.remove()}}})})(e,t)})(e,r),e.on("SetContent",()=>{e.addVisual(e.getBody())}),e.on("compositionstart compositionend",t=>{e.composing="compositionstart"===t.type})})(e),(e=>{SP(e)})(e),a.fold(()=>{const t=(e=>{let t=!1;const n=setTimeout(()=>{t||e.setProgressState(!0)},500);return()=>{clearTimeout(n),t=!0,e.setProgressState(!1)}})(e);AP(e).then(()=>{DP(e),t()})},t=>{e.setProgressState(!0),AP(e).then(()=>{t().then(t=>{e.setProgressState(!1),DP(e),FE(e)},t=>{e.notificationManager.open({type:"error",text:String(t)}),DP(e),FE(e)})})})},OP=gi.DOM,BP=(e,t)=>{((e,t)=>{const n=Am(e),o=e.translate(n),r=So(un.fromDom(e.getElement()),"tabindex").bind(st),s=((e,t,n,o)=>{const r=un.fromTag("iframe");return o.each(e=>vo(r,"tabindex",e)),Co(r,n),Co(r,{id:e+"_ifr",frameBorder:"0",allowTransparency:"true",title:t}),yr(r,"tox-edit-area__iframe"),r})(e.id,o,hd(e),r).dom;s.onload=()=>{s.onload=null,e.dispatch("load")},e.contentAreaContainer=t.iframeContainer,e.iframeElement=s,e.iframeHTML=(e=>{let t=bd(e)+"<html><head>";yd(e)!==e.editorManager.documentBaseURL&&(t+='<base href="'+e.documentBaseURI.getURI()+'" />'),t+='<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';const n=vd(e),o=Cd(e),r=e.translate(Am(e)),s=sn.os.isMacOS()||sn.os.isiOS()?`role="textbox" aria-multiline="true" aria-label="${r}"`:"";return wd(e)&&(t+='<meta http-equiv="Content-Security-Policy" content="'+wd(e)+'" />'),t+=`</head><body id="${n}" class="mce-content-body ${o}" data-id="${e.id}" ${s}><br></body></html>`,t})(e),OP.add(t.iframeContainer,s)})(e,t),t.editorContainer&&(t.editorContainer.style.display=e.orgDisplay,e.hidden=OP.isHidden(t.editorContainer)),e.getElement().style.display="none",OP.setAttrib(e.id,"aria-hidden","true"),e.getElement().style.visibility=e.orgVisibility,(e=>{const t=e.iframeElement,n=()=>{e.contentDocument=t.contentDocument,TP(e)};if(ou(e)||sn.browser.isFirefox()){const t=e.getDoc();t.open(),t.write(e.iframeHTML),t.close(),n()}else{const o=so(un.fromDom(t),"load",()=>{o.unbind(),n()});t.srcdoc=e.iframeHTML}})(e)},PP=gi.DOM,LP=(e,t)=>({editorContainer:e,iframeContainer:t,api:{}}),MP=e=>{const t=e.getElement();return e.inline?LP(null):(e=>{const t=PP.create("div");return PP.insertAfter(t,e),LP(t,t)})(t)},IP=async e=>{e.dispatch("ScriptsLoaded"),(e=>{const t=dn.trim(Bd(e)),n=e.ui.registry.getAll().icons,o={...YE.get("default").icons,...YE.get(t).icons};he(o,(t,o)=>{_e(n,o)||e.ui.registry.addIcon(o,t)})})(e),(e=>{const t=t=>{t.keyCode!==Tp.ESC||t.defaultPrevented||q(e.editorManager.get(),e=>{(e=>e.dispatch("CloseActiveTooltips"))(e).isDefaultPrevented()&&t.preventDefault()})};document.addEventListener("keyup",t),e.inline||e.on("keyup",t),e.on("remove",()=>{document.removeEventListener("keyup",t),e.inline||e.off("keyup",t)})})(e),(e=>{const t=om(e);if(u(t)){const n=rx.get(t);e.theme=n(e,rx.urls[t])||{},w(e.theme.init)&&e.theme.init(e,rx.urls[t]||e.editorManager.documentBaseURL.replace(/\/$/,""))}else e.theme={}})(e),(e=>{const t=sm(e),n=GE.get(t);e.model=n(e,GE.urls[t])})(e),(e=>{xx.init(e)})(e),(e=>{const t=[];q(Em(e),n=>{((e,t,n)=>{const o=ox.get(n),r=ox.urls[n]||e.editorManager.documentBaseURL.replace(/\/$/,"");if(n=dn.trim(n),o&&-1===dn.inArray(t,n)){if(e.plugins[n])return;try{const s=o(e,r)||{};e.plugins[n]=s,w(s.init)&&(s.init(e,r),t.push(n))}catch(t){((e,t,n)=>{const o=Ci.translate(["Failed to initialize plugin: {0}",t]);nd(e,"PluginLoadError",{message:o}),dx(o,n),ix(e,o)})(e,n,t)}}})(e,t,(e=>e.replace(/^\-/,""))(n))})})(e);const t=await(e=>{const t=e.getElement();return e.orgDisplay=t.style.display,u(om(e))?(e=>{const t=e.theme.renderUI;return t?t():MP(e)})(e):w(om(e))?(e=>{const t=e.getElement(),n=om(e)(e,t);return n.editorContainer.nodeType&&(n.editorContainer.id=n.editorContainer.id||e.id+"_parent"),n.iframeContainer&&n.iframeContainer.nodeType&&(n.iframeContainer.id=n.iframeContainer.id||e.id+"_iframecontainer"),n.height=n.iframeHeight?n.iframeHeight:t.offsetHeight,n})(e):MP(e)})(e);((e,t)=>{const n={show:I.from(t.show).getOr(x),hide:I.from(t.hide).getOr(x),isEnabled:I.from(t.isEnabled).getOr(M),setEnabled:n=>{n&&("readonly"===e.mode.get()||Ax(e))||I.from(t.setEnabled).each(e=>e(n))}};e.ui={...e.ui,...n}})(e,I.from(t.api).getOr({})),e.editorContainer=t.editorContainer,(e=>{e.contentCSS=e.contentCSS.concat((e=>Mx(e,Wd(e)))(e),(e=>Mx(e,Gd(e)))(e))})(e),e.inline?TP(e):BP(e,{editorContainer:t.editorContainer,iframeContainer:t.iframeContainer})},FP=gi.DOM,UP=e=>"-"===e.charAt(0),zP=(e,t,n)=>I.from(t).filter(e=>ot(e)&&!YE.has(e)).map(t=>({url:`${e.editorManager.baseURL}/icons/${t}/icons${n}.js`,name:I.some(t)})),jP=(e,t)=>{const n=hi.ScriptLoader,o=()=>{!e.removed&&(e=>{const t=om(e);return!u(t)||C(rx.get(t))})(e)&&(e=>{const t=sm(e);return C(GE.get(t))})(e)&&IP(e)};((e,t)=>{const n=om(e);if(u(n)&&!UP(n)&&!_e(rx.urls,n)){const o=rm(e),r=o?e.documentBaseURI.toAbsolute(o):`themes/${n}/theme${t}.js`;rx.load(n,r).catch(()=>{((e,t,n)=>{lx(e,"ThemeLoadError",cx("theme",t,n))})(e,r,n)})}})(e,t),((e,t)=>{const n=sm(e);if("plugin"!==n&&!_e(GE.urls,n)){const o=am(e),r=u(o)?e.documentBaseURI.toAbsolute(o):`models/${n}/model${t}.js`;GE.load(n,r).catch(()=>{((e,t,n)=>{lx(e,"ModelLoadError",cx("model",t,n))})(e,r,n)})}})(e,t),((e,t)=>{xx.load(e,t)})(e,t),((e,t)=>{const n=$d(t),o=Hd(t);if(!Ci.hasCode(n)&&"en"!==n){const r=ot(o)?o:`${t.editorManager.baseURL}/langs/${n}.js`;e.add(r).catch(()=>{((e,t,n)=>{lx(e,"LanguageLoadError",cx("language",t,n))})(t,r,n)})}})(n,e),((e,t,n)=>{const o=zP(t,"default",n),r=(e=>I.from(Pd(e)).filter(ot).map(e=>({url:e,name:I.none()})))(t).orThunk(()=>zP(t,Bd(t),""));q((e=>{const t=[],n=e=>{t.push(e)};for(let t=0;t<e.length;t++)e[t].each(n);return t})([o,r]),n=>{e.add(n.url).catch(()=>{((e,t,n)=>{lx(e,"IconsLoadError",cx("icons",t,n))})(t,n.url,n.name.getOrUndefined())})})})(n,e,t),((e,t)=>{const n=(t,n)=>{"licensekeymanager"!==t&&ox.load(t,n).catch(()=>{((e,t,n)=>{lx(e,"PluginLoadError",cx("plugin",t,n))})(e,n,t)})};he(xm(e),(t,o)=>{n(o,t),e.options.set("plugins",Em(e).concat(o))}),q(Em(e),e=>{!(e=dn.trim(e))||ox.urls[e]||UP(e)||n(e,`plugins/${e}/plugin${t}.js`)})})(e,t),n.loadQueue().then(o,o)},$P=["#E41B60","#AD1457","#1939EC","#001CB5","#648000","#465B00","#006CE7","#0054B4","#00838F","#006064","#00866F","#004D40","#51742F","#385021","#CF4900","#A84600","#CC0000","#6A1B9A","#9C27B0","#6A00AB","#3041BA","#0A1877","#774433","#452B24","#607D8B","#455A64"],HP=(e,t={size:36})=>{return n=(e=>{if(Intl.Segmenter){const t=(new Intl.Segmenter).segment(e)[Symbol.iterator]();return`${t.next().value?.segment}`}return e.trim()[0]})(e.name),o=(e=>{const t=((e,t)=>{let n=5381;for(let t=0;t<e.length;t++)n=(n<<5)+n+e.charCodeAt(t);return(n>>>0)%(t+1)})(e??"",$P.length-1);return $P[t]})(e.id),r=t.size,"data:image/svg+xml,"+encodeURIComponent(((e,t,n)=>{const o=n/2;return`<svg height="${n}" width="${n}" xmlns="http://www.w3.org/2000/svg"><circle cx="${o}" cy="${o}" r="${o}" fill="${t}"/><text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" fill="#FFF" font-family="sans-serif" font-size="${o}">`+e+"</text></svg>"})(n,o,r));var n,o,r},VP=Mc([jc("id","id",{tag:"required",process:{}},kc()),Wc("name"),Wc("avatar"),(e=>jc(e,e,{tag:"option",process:{}},kc()))("custom")]),qP=e=>{const t={};return he(e,(e,n)=>{e.each(e=>{t[n]=e})}),t},WP=e=>{if(!Array.isArray(e))throw new Error("fetch_users must return an array");const t=V(e,e=>Uc("Invalid user object",VP,e)),{errors:n,values:o}=qe(t);if(n.length>0){const e=V(n,(e,t)=>`User at index ${t}: ${zc(e)}`);console.warn("User validation errors:\n"+e.join("\n"))}return V(o,e=>{const{id:t,name:n,avatar:o,...r}=e;return{id:t,name:n.getOr(t),avatar:o.getOr(HP({id:t,name:n.getOr(t)})),...qP(r)}})},KP=Xt().deviceType,YP=KP.isPhone(),GP=KP.isTablet(),XP=e=>{if(v(e))return[];{const t=p(e)?e:e.split(/[ ,]/),n=V(t,et);return Y(n,ot)}},QP=(e,t)=>{const n=(t=>{const n={},o={};return Ce(t,(t,n)=>$(e,n),ve(n),ve(o)),{t:n,f:o}})(t);return o=n.t,r=n.f,{sections:N(o),options:N(r)};var o,r},ZP=(e,t)=>_e(e.sections(),t),JP=(e,t)=>({table_grid:!1,object_resizing:!1,resize:!1,toolbar_mode:xe(e,"toolbar_mode").getOr("scrolling"),toolbar_sticky:!1,...t?{menubar:!1}:{}}),eL=(e,t)=>{const n=t.external_plugins??{};return e&&e.external_plugins?dn.extend({},e.external_plugins,n):n},tL=(e,t,n,o,r)=>{const s=e?{mobile:JP(r.mobile??{},t)}:{},a=QP(["mobile"],Fe(s,r)),i=dn.extend(n,o,a.options(),((e,t)=>e&&ZP(t,"mobile"))(e,a)?((e,t,n={})=>{const o=e.sections(),r=xe(o,t).getOr({});return dn.extend({},n,r)})(a,"mobile"):{},{external_plugins:eL(o,a.options())});return((e,t,n,o)=>{const r=XP(n.forced_plugins),s=XP(o.plugins),a=((e,t)=>ZP(e,t)?e.sections()[t]:{})(t,"mobile"),i=((e,t,n,o)=>e&&ZP(t,"mobile")?o:n)(e,t,s,a.plugins?XP(a.plugins):s),l=((e,t)=>[...XP(e),...XP(t)])(r,i);return dn.extend(o,{forced_plugins:r,plugins:l})})(e,a,o,i)},nL=e=>{(e=>{const t=t=>()=>{q("left,center,right,justify".split(","),n=>{t!==n&&e.formatter.remove("align"+n)}),"none"!==t&&(t=>{e.formatter.toggle(t,void 0),e.nodeChanged()})("align"+t)};e.editorCommands.addCommands({JustifyLeft:t("left"),JustifyCenter:t("center"),JustifyRight:t("right"),JustifyFull:t("justify"),JustifyNone:t("none")})})(e),(e=>{const t=t=>()=>{const n=e.selection,o=n.isCollapsed()?[e.dom.getParent(n.getNode(),e.dom.isBlock)]:n.getSelectedBlocks();return H(o,n=>C(e.formatter.matchNode(n,t)))};e.editorCommands.addCommands({JustifyLeft:t("alignleft"),JustifyCenter:t("aligncenter"),JustifyRight:t("alignright"),JustifyFull:t("alignjustify")},"state")})(e)},oL=(e,t)=>{const n=e.selection,o=e.dom;return/^ | $/.test(t)?((e,t,n,o)=>{const r=un.fromDom(e.getRoot());return n=Bb(r,Kl.fromRangeStart(t),o)?n.replace(/^ /,"&nbsp;"):n.replace(/^&nbsp;/," "),Pb(r,Kl.fromRangeEnd(t),o)?n.replace(/(&nbsp;| )(<br( \/)>)?$/,"&nbsp;"):n.replace(/&nbsp;(<br( \/)?>)?$/," ")})(o,n.getRng(),t,e.schema):t},rL=(e,t)=>{if(e.selection.isEditable()){const{content:n,details:o}=(e=>{if("string"!=typeof e){const t=dn.extend({paste:e.paste,data:{paste:e.paste}},e);return{content:e.content,details:t}}return{content:e,details:{}}})(t);ES(e,{...o,content:oL(e,n),format:"html",set:!1,selection:!0}).each(t=>{const n=((e,t,n)=>ME(e).editor.insertContent(t,n))(e,t.content,o);xS(e,n,t),e.addVisual()})}},sL={"font-size":"size","font-family":"face"},aL=On("font"),iL=e=>(t,n)=>I.from(n).map(un.fromDom).filter(Rn).bind(n=>((e,t,n)=>Or(un.fromDom(n),t=>(t=>Vo(t,e).orThunk(()=>aL(t)?xe(sL,e).bind(e=>So(t,e)):I.none()))(t),e=>vn(un.fromDom(t),e)))(e,t,n.dom).or(((e,t)=>I.from(gi.DOM.getStyle(t,e,!0)))(e,n.dom))).getOr(""),lL=iL("font-size"),cL=_(e=>e.replace(/[\'\"\\]/g,"").replace(/,\s+/g,","),iL("font-family")),dL=e=>Rf(e.getBody()).bind(e=>{const t=e.container();return I.from(ss(t)?t.parentNode:t)}),mL=(e,t)=>((e,t)=>(e=>I.from(e.selection.getRng()).bind(t=>{const n=e.getBody();return t.startContainer===n&&0===t.startOffset?I.none():I.from(e.selection.getStart(!0))}))(e).orThunk(D(dL,e)).map(un.fromDom).filter(Rn).bind(t))(e,k(I.some,t)),uL=(e,t)=>{if(/^[0-9.]+$/.test(t)){const n=parseInt(t,10);if(n>=1&&n<=7){const o=(e=>dn.explode(e.options.get("font_size_style_values")))(e),r=(e=>dn.explode(e.options.get("font_size_classes")))(e);return r.length>0?r[n-1]||t:o[n-1]||t}return t}return t},fL=e=>{const t=e.split(/\s*,\s*/);return V(t,e=>-1===e.indexOf(" ")||Qe(e,'"')||Qe(e,"'")?e:`'${e}'`).join(",")},gL=e=>{e.editorCommands.addCommands({Indent:()=>{(e=>{eA(e,"indent")})(e)},Outdent:()=>{tA(e)}}),e.editorCommands.addCommands({Outdent:()=>QR(e),Indent:()=>(e=>!e.mode.isReadOnly()&&(e=>bu(e).forall(t=>{const n=e.selection.getSelectedBlocks();return H(n,e=>fr(un.fromDom(e),"li").forall(e=>{return(n=e,_r(n,e=>bn(e,"ol,ul"),void 0)).length<=t;var n}))}))(e))(e)},"state")},pL=(e,t)=>{if(e.mode.isReadOnly())return;const n=e.dom,o=e.selection.getRng(),r=t?e.selection.getStart():e.selection.getEnd(),s=t?o.startContainer:o.endContainer,a=gT(n,s);if(!a||!a.isContentEditable)return;const i=t?mo:uo,l=Ed(e);((e,t,n,o)=>{const r=e.dom,s=e=>r.isBlock(e)&&e.parentElement===n,a=s(t)?t:r.getParent(o,s,n);return I.from(a).map(un.fromDom)})(e,r,a,s).each(t=>{const n=yT(e,s,t.dom,a,!1,l);i(t,un.fromDom(n)),e.selection.setCursorLocation(n,0),e.dispatch("NewBlock",{newBlock:n}),l_(e,"insertParagraph")})},hL=e=>{nL(e),(e=>{e.editorCommands.addCommands({"Cut,Copy,Paste":t=>{const n=e.getDoc();let o;try{n.execCommand(t)}catch{o=!0}if("paste"!==t||n.queryCommandEnabled(t)||(o=!0),o||!n.queryCommandSupported(t)){let t=e.translate("Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.");(sn.os.isMacOS()||sn.os.isiOS())&&(t=t.replace(/Ctrl\+/g,"\u2318+")),e.notificationManager.open({text:t,type:"error"})}}})})(e),(e=>{e.editorCommands.addCommands({mceAddUndoLevel:()=>{e.undoManager.add()},mceEndUndoLevel:()=>{e.undoManager.add()},Undo:()=>{e.undoManager.undo()},Redo:()=>{e.undoManager.redo()}})})(e),(e=>{e.editorCommands.addCommands({mceSelectNodeDepth:(t,n,o)=>{let r=0;e.dom.getParent(e.selection.getNode(),t=>!Xr(t)||r++!==o||(e.selection.select(t),!1),e.getBody())},mceSelectNode:(t,n,o)=>{e.selection.select(o)},selectAll:()=>{const t=e.dom.getParent(e.selection.getStart(),gs);if(t){const n=e.dom.createRng();n.selectNodeContents(t),e.selection.setRng(n)}}})})(e),(e=>{e.editorCommands.addCommands({mceCleanup:()=>{const t=e.selection.getBookmark();e.setContent(e.getContent()),e.selection.moveToBookmark(t)},insertImage:(t,n,o)=>{rL(e,e.dom.createHTML("img",{src:o}))},insertHorizontalRule:()=>{e.execCommand("mceInsertContent",!1,"<hr>")},insertText:(t,n,o)=>{rL(e,e.dom.encode(o))},insertHTML:(t,n,o)=>{rL(e,o)},mceInsertContent:(t,n,o)=>{rL(e,o)},mceSetContent:(t,n,o)=>{e.setContent(o)},mceReplaceContent:(t,n,o)=>{e.execCommand("mceInsertContent",!1,o.replace(/\{\$selection\}/g,e.selection.getContent({format:"text"})))},mceNewDocument:()=>{e.setContent(zm(e))}})})(e),(e=>{const t=(t,n,o)=>{if(e.mode.isReadOnly())return;const r=u(o)?{href:o}:o,s=e.dom.getParent(e.selection.getNode(),"a");f(r)&&u(r.href)&&(r.href=r.href.replace(/ /g,"%20").replace(/&amp;/g,"&"),s&&r.href||e.formatter.remove("link"),r.href&&e.formatter.apply("link",r,s))};e.editorCommands.addCommands({unlink:()=>{if(e.selection.isEditable()){if(e.selection.isCollapsed()){const t=e.dom.getParent(e.selection.getStart(),"a");return void(t&&e.dom.remove(t,!0))}e.formatter.remove("link")}},mceInsertLink:t,createLink:t})})(e),gL(e),(e=>{e.editorCommands.addCommands({InsertNewBlockBefore:()=>{(e=>{pL(e,!0)})(e)},InsertNewBlockAfter:()=>{(e=>{pL(e,!1)})(e)}})})(e),(e=>{e.editorCommands.addCommands({insertParagraph:()=>{QT(AT,e)},mceInsertNewLine:(t,n,o)=>{ZT(e,o)},InsertLineBreak:(t,n,o)=>{QT(IT,e)}})})(e),(e=>{(e=>{const t=(t,n)=>{e.formatter.toggle(t,n),e.nodeChanged()};e.editorCommands.addCommands({"Bold,Italic,Underline,Strikethrough,Superscript,Subscript":e=>{t(e)},"ForeColor,HiliteColor":(e,n,o)=>{t(e,{value:o})},BackColor:(e,n,o)=>{t("hilitecolor",{value:o})},FontName:(t,n,o)=>{((e,t)=>{const n=uL(e,t);e.formatter.toggle("fontname",{value:fL(n)}),e.nodeChanged()})(e,o)},FontSize:(t,n,o)=>{((e,t)=>{e.formatter.toggle("fontsize",{value:uL(e,t)}),e.nodeChanged()})(e,o)},LineHeight:(t,n,o)=>{((e,t)=>{e.formatter.toggle("lineheight",{value:String(t)}),e.nodeChanged()})(e,o)},Lang:(e,n,o)=>{t(e,{value:o.code,customValue:o.customCode??null})},RemoveFormat:t=>{e.formatter.remove(t)},mceBlockQuote:()=>{t("blockquote")},FormatBlock:(e,n,o)=>{t(u(o)?o:"p")},mceToggleFormat:(e,n,o)=>{t(o)}})})(e),(e=>{const t=t=>e.formatter.match(t);e.editorCommands.addCommands({"Bold,Italic,Underline,Strikethrough,Superscript,Subscript":e=>t(e),mceBlockQuote:()=>t("blockquote")},"state"),e.editorCommands.addQueryValueHandler("FontName",()=>(e=>mL(e,t=>cL(e.getBody(),t.dom)).getOr(""))(e)),e.editorCommands.addQueryValueHandler("FontSize",()=>(e=>mL(e,t=>lL(e.getBody(),t.dom)).getOr(""))(e)),e.editorCommands.addQueryValueHandler("LineHeight",()=>(e=>mL(e,t=>{const n=un.fromDom(e.getBody()),o=Or(t,e=>Vo(e,"line-height"),D(vn,n));return o.getOrThunk(()=>{const e=parseFloat($o(t,"line-height")),n=parseFloat($o(t,"font-size"));return String(e/n)})}).getOr(""))(e))})(e)})(e),(e=>{e.editorCommands.addCommands({mceRemoveNode:(t,n,o)=>{const r=o??e.selection.getNode();if(r!==e.getBody()){const t=e.selection.getBookmark();e.dom.remove(r,!0),e.selection.moveToBookmark(t)}},mcePrint:()=>{e.getWin().print()},mceFocus:(t,n,o)=>{((e,t)=>{if(e.removed)return;if(!0===t)return void Dp(e);const n=(e=>C(e)&&!b(e)?e:{scrollToSelection:!0})(t);((e,t)=>{const n=e.selection,o=e.getBody();let r=n.getRng();e.quirks.refreshContentEditable();const s=e=>{hp(e).each(t=>{e.selection.setRng(t),r=t})};!Rp(e)&&e.hasEditableRoot()&&s(e);const a=((e,t)=>e.dom.getParent(t,t=>"true"===e.dom.getContentEditable(t)))(e,n.getNode());if(a&&e.dom.isChildOf(a,o))return((e,t)=>null!==e.dom.getParent(t,t=>"false"===e.dom.getContentEditable(t)))(e,a)||Np(o,t),Np(a,t),e.hasEditableRoot()||s(e),kp(e,r),void Dp(e);e.inline||(Np(o,t),t?C(e.iframeElement)&&e.iframeElement.focus({preventScroll:!0}):e.getWin().focus()),(sn.browser.isFirefox()||e.inline)&&(Np(o,t),kp(e,r)),Dp(e)})(e,!1===n.scrollToSelection)})(e,o)},mceToggleVisualAid:()=>{e.hasVisual=!e.hasVisual,e.addVisual()}})})(e)},bL=["toggleview"],yL=e=>$(bL,e.toLowerCase());class vL{editor;commands={state:{},exec:{},value:{}};constructor(e){this.editor=e}execCommand(e,t=!1,n,o){const r=this.editor,s=e.toLowerCase(),a=o?.skip_focus;if(r.removed)return!1;if("mcefocus"!==s&&(/^(mceAddUndoLevel|mceEndUndoLevel|toggleview)$/i.test(s)||a?(e=>{hp(e).each(t=>e.selection.setRng(t))})(r):r.focus()),r.dispatch("BeforeExecCommand",{command:e,ui:t,value:n}).isDefaultPrevented())return!1;const i=this.commands.exec[s];return!!w(i)&&(i(s,t,n,o),r.dispatch("ExecCommand",{command:e,ui:t,value:n,args:o}),!0)}queryCommandState(e){if(!yL(e)&&this.editor.quirks.isHidden()||this.editor.removed)return!1;const t=e.toLowerCase(),n=this.commands.state[t];return!!w(n)&&n(t)}queryCommandValue(e){if(!yL(e)&&this.editor.quirks.isHidden()||this.editor.removed)return"";const t=e.toLowerCase(),n=this.commands.value[t];return w(n)?n(t):""}addCommands(e,t="exec"){const n=this.commands;he(e,(e,o)=>{q(o.toLowerCase().split(","),o=>{n[t][o]=e})})}addCommand(e,t,n){const o=e.toLowerCase();this.commands.exec[o]=(e,o,r,s)=>t.call(n??this.editor,o,r,s)}removeCommand(e,t){const n=e.toLowerCase();t?delete this.commands[t][n]:(delete this.commands.exec[n],delete this.commands.state[n],delete this.commands.value[n])}queryCommandSupported(e){const t=e.toLowerCase();return!!this.commands.exec[t]}addQueryStateHandler(e,t,n){this.commands.state[e.toLowerCase()]=()=>t.call(n??this.editor)}addQueryValueHandler(e,t,n){this.commands.value[e.toLowerCase()]=()=>t.call(n??this.editor)}}const CL=dn.makeMap("focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange mouseout mouseenter mouseleave wheel keydown keypress keyup input beforeinput contextmenu dragstart dragend dragover draggesture dragdrop drop drag submit compositionstart compositionend compositionupdate touchstart touchmove touchend touchcancel"," ");class wL{static isNative(e){return!!CL[e.toLowerCase()]}settings;scope;toggleEvent;bindings={};constructor(e){this.settings=e||{},this.scope=this.settings.scope||this,this.toggleEvent=this.settings.toggleEvent||L}fire(e,t){return this.dispatch(e,t)}dispatch(e,t){const n=e.toLowerCase(),o=Za(n,t??{},this.scope);this.settings.beforeFire&&this.settings.beforeFire(o);const r=this.bindings[n];if(r)for(let e=0,t=r.length;e<t;e++){const t=r[e];if(!t.removed){if(t.once&&this.off(n,t.func),o.isImmediatePropagationStopped())return o;if(!1===t.func.call(this.scope,o))return o.preventDefault(),o}}return o}on(e,t,n,o){if(!1===t&&(t=L),t){const r={func:t,removed:!1};o&&dn.extend(r,o);const s=e.toLowerCase().split(" ");let a=s.length;for(;a--;){const e=s[a];let t=this.bindings[e];t||(t=[],this.toggleEvent(e,!0)),t=n?[r,...t]:[...t,r],this.bindings[e]=t}}return this}off(e,t){if(e){const n=e.toLowerCase().split(" ");let o=n.length;for(;o--;){const r=n[o];let s=this.bindings[r];if(!r)return he(this.bindings,(e,t)=>{this.toggleEvent(t,!1),delete this.bindings[t]}),this;if(s){if(t){const e=K(s,e=>e.func===t);s=e.fail,this.bindings[r]=s,q(e.pass,e=>{e.removed=!0})}else s.length=0;s.length||(this.toggleEvent(e,!1),delete this.bindings[r])}}}else he(this.bindings,(e,t)=>{this.toggleEvent(t,!1)}),this.bindings={};return this}once(e,t,n){return this.on(e,t,n,{once:!0})}has(e){e=e.toLowerCase();const t=this.bindings[e];return!(!t||0===t.length)}}const SL=e=>(e._eventDispatcher||(e._eventDispatcher=new wL({scope:e,toggleEvent:(t,n)=>{wL.isNative(t)&&e.toggleNativeEvent&&e.toggleNativeEvent(t,n)}})),e._eventDispatcher),EL={fire(e,t,n){return IS("fire"),this.dispatch(e,t,n)},dispatch(e,t,n){const o=this;if(o.removed&&"remove"!==e&&"detach"!==e)return Za(e.toLowerCase(),t??{},o);const r=SL(o).dispatch(e,t);if(!1!==n&&o.parent){let t=o.parent();for(;t&&!r.isPropagationStopped();)t.dispatch(e,r,!1),t=t.parent?t.parent():void 0}return r},on(e,t,n){return SL(this).on(e,t,n)},off(e,t){return SL(this).off(e,t)},once(e,t){return SL(this).once(e,t)},hasEventListeners(e){return SL(this).has(e)}},xL=gi.DOM;let _L;const kL=(e,t)=>{if("selectionchange"===t)return e.getDoc();if(!e.inline&&/^(?:mouse|touch|click|contextmenu|drop|dragover|dragend)/.test(t))return e.getDoc().documentElement;const n=tm(e);return n?(e.eventRoot||(e.eventRoot=xL.select(n)[0]),e.eventRoot):e.getBody()},NL=(e,t,n)=>{(e=>!e.hidden&&!Ax(e))(e)?e.dispatch(t,n):Ax(e)&&((e,t)=>{if((e=>"click"===e.type)(t)&&!Tp.metaKeyPressed(t)){const n=un.fromDom(t.target);((e,t)=>fr(t,"a",t=>vn(t,un.fromDom(e.getBody()))).bind(e=>So(e,"href")))(e,n).fold(()=>{Px(e,n)&&t.preventDefault()},n=>{if(t.preventDefault(),/^#/.test(n)){const t=Ge(n,"#"),o=e.dom.select(`[id="${t}"],[name="${t}"]`);o.length&&e.selection.scrollIntoView(o[0],!0)}else window.open(n,"_blank","rel=noopener noreferrer,menubar=yes,toolbar=yes,location=yes,status=yes,resizable=yes,scrollbars=yes")})}else(e=>$(Bx,e.type))(t)&&e.dispatch(t.type,t)})(e,n)},RL=(e,t)=>{if(e.delegates||(e.delegates={}),e.delegates[t]||e.removed)return;const n=kL(e,t);if(tm(e)){if(_L||(_L={},e.editorManager.on("removeEditor",()=>{e.editorManager.activeEditor||_L&&(he(_L,(t,n)=>{e.dom.unbind(kL(e,n))}),_L=null)})),_L[t])return;const o=n=>{const o=n.target,r=e.editorManager.get();let s=r.length;for(;s--;){const e=r[s].getBody();(e===o||xL.isChildOf(o,e))&&NL(r[s],t,n)}};_L[t]=o,xL.bind(n,t,o)}else{const o=n=>{NL(e,t,n)};xL.bind(n,t,o),e.delegates[t]=o}},AL={...EL,bindPendingEventDelegates(){const e=this;dn.each(e._pendingNativeEvents,t=>{RL(e,t)})},toggleNativeEvent(e,t){const n=this;"focus"!==e&&"blur"!==e&&(n.removed||(t?n.initialized?RL(n,e):n._pendingNativeEvents?n._pendingNativeEvents.push(e):n._pendingNativeEvents=[e]:n.initialized&&n.delegates&&(n.dom.unbind(kL(n,e),e,n.delegates[e]),delete n.delegates[e])))},unbindAllNativeEvents(){const e=this,t=e.getBody(),n=e.dom;e.delegates&&(he(e.delegates,(t,n)=>{e.dom.unbind(kL(e,n),n,t)}),delete e.delegates),!e.inline&&t&&n&&(t.onload=null,n.unbind(e.getWin()),n.unbind(e.getDoc())),n&&(n.unbind(t),n.unbind(e.getContainer()))}},DL=e=>u(e)?{value:e.split(/[ ,]/),valid:!0}:E(e,u)?{value:e,valid:!0}:{valid:!1,message:"The value must be a string[] or a comma/space separated string."},TL=(e,t)=>e+(rt(t.message)?"":`. ${t.message}`),OL=e=>e.valid,BL=(e,t,n="")=>{const o=t(e);return b(o)?o?{value:e,valid:!0}:{valid:!1,message:n}:o},PL=e=>e.readonly,LL=["design","readonly"],ML=(e,t,n,o)=>{const r=n[t.get()],s=n[o];try{s.activate()}catch(e){return void console.error(`problem while activating editor mode ${o}:`,e)}r.deactivate(),r.editorReadOnly!==s.editorReadOnly&&((e,t)=>{const n=un.fromDom(e.getBody());t?(e.readonly=!0,e.hasEditableRoot()&&(n.dom.contentEditable="true"),Nx(e)):(e.readonly=!1,Rx(e))})(e,s.editorReadOnly),t.set(o),((e,t)=>{e.dispatch("SwitchMode",{mode:t})})(e,o)},IL=e=>{const t=Re("design"),n=Re({design:{activate:x,deactivate:x,editorReadOnly:!1},readonly:{activate:x,deactivate:x,editorReadOnly:!0}});return(e=>{const t=t=>{PL(e)&&(e=>H(e,e=>"characterData"===e.type||"childList"===e.type))(t)&&(e=>{const t=e.undoManager.add();C(t)&&(e.undoManager.undo(),e.undoManager.reset())})(e)},n=new MutationObserver(t);e.on("beforeinput paste cut dragend dragover draggesture dragdrop drop drag",t=>{PL(e)&&t.preventDefault()}),e.on("BeforeExecCommand",t=>{"Undo"!==t.command&&"Redo"!==t.command||!PL(e)||t.preventDefault()}),e.on("compositionstart",()=>{PL(e)&&n.observe(e.getBody(),{characterData:!0,childList:!0,subtree:!0})}),e.on("compositionend",()=>{if(PL(e)){const e=n.takeRecords();t(e)}n.disconnect()})})(e),(e=>{(e=>{e.serializer?Ox(e):e.on("PreInit",()=>{Ox(e)})})(e),(e=>{e.on("ShowCaret ObjectSelected",t=>{Ax(e)&&t.preventDefault()}),e.on("DisabledStateChange",t=>{t.isDefaultPrevented()||Tx(e,t.state)})})(e)})(e),{isReadOnly:()=>PL(e),set:o=>((e,t,n,o)=>{if(!(o===n.get()||e.initialized&&Ax(e))){if(!_e(t,o))throw new Error(`Editor mode '${o}' is invalid`);e.initialized?ML(e,n,t,o):e.on("init",()=>ML(e,n,t,o))}})(e,n.get(),t,o),get:()=>t.get(),register:(e,t)=>{n.set(((e,t,n)=>{if($(LL,t))throw new Error(`Cannot override default mode ${t}`);return{...e,[t]:{...n,deactivate:()=>{try{n.deactivate()}catch(e){console.error(`problem while deactivating editor mode ${t}:`,e)}}}}})(n.get(),e,t))}}},FL=dn.each,UL=dn.explode,zL={f1:112,f2:113,f3:114,f4:115,f5:116,f6:117,f7:118,f8:119,f9:120,f10:121,f11:122,f12:123},jL=dn.makeMap("alt,ctrl,shift,meta,access"),$L=e=>{const t={},n=sn.os.isMacOS()||sn.os.isiOS();FL(UL(e.toLowerCase(),"+"),e=>{(e=>e in jL)(e)?t[e]=!0:/^[0-9]{2,}$/.test(e)?t.keyCode=parseInt(e,10):(t.charCode=e.charCodeAt(0),t.keyCode=zL[e]||e.toUpperCase().charCodeAt(0))});const o=[t.keyCode];let r;for(r in jL)t[r]?o.push(r):t[r]=!1;return t.id=o.join(","),t.access&&(t.alt=!0,n?t.ctrl=!0:t.shift=!0),t.meta&&(n?t.meta=!0:(t.ctrl=!0,t.meta=!1)),t};class HL{editor;shortcuts={};pendingPatterns=[];constructor(e){this.editor=e;const t=this;e.on("keyup keypress keydown",e=>{!t.hasModifier(e)&&!t.isFunctionKey(e)||e.isDefaultPrevented()||(FL(t.shortcuts,n=>{t.matchShortcut(e,n)&&(t.pendingPatterns=n.subpatterns.slice(0),"keydown"===e.type&&t.executeShortcutAction(n))}),t.matchShortcut(e,t.pendingPatterns[0])&&(1===t.pendingPatterns.length&&"keydown"===e.type&&t.executeShortcutAction(t.pendingPatterns[0]),t.pendingPatterns.shift()))})}add(e,t,n,o){const r=this,s=r.normalizeCommandFunc(n);return FL(UL(dn.trim(e)),e=>{const n=r.createShortcut(e,t,s,o);r.shortcuts[n.id]=n}),!0}remove(e){const t=this.createShortcut(e);return!!this.shortcuts[t.id]&&(delete this.shortcuts[t.id],!0)}normalizeCommandFunc(e){const t=this,n=e;return"string"==typeof n?()=>{t.editor.execCommand(n,!1,null)}:dn.isArray(n)?()=>{t.editor.execCommand(n[0],n[1],n[2])}:n}createShortcut(e,t,n,o){const r=dn.map(UL(e,">"),$L);return r[r.length-1]=dn.extend(r[r.length-1],{func:n,scope:o||this.editor}),dn.extend(r[0],{desc:this.editor.translate(t),subpatterns:r.slice(1)})}hasModifier(e){return e.altKey||e.ctrlKey||e.metaKey}isFunctionKey(e){return"keydown"===e.type&&e.keyCode>=112&&e.keyCode<=123}matchShortcut(e,t){return!!t&&t.ctrl===e.ctrlKey&&t.meta===e.metaKey&&t.alt===e.altKey&&t.shift===e.shiftKey&&!!(e.keyCode===t.keyCode||e.charCode&&e.charCode===t.charCode)&&(e.preventDefault(),!0)}executeShortcutAction(e){return e.func?e.func.call(e.scope):null}}const VL=()=>{const e=(()=>{const e={},t={},n={},o={},r={},s={},a={},i={},l={},c=(e,t)=>(n,o)=>{e[n.toLowerCase()]={...o,type:t}};return{addButton:c(e,"button"),addGroupToolbarButton:c(e,"grouptoolbarbutton"),addToggleButton:c(e,"togglebutton"),addMenuButton:c(e,"menubutton"),addSplitButton:c(e,"splitbutton"),addMenuItem:c(t,"menuitem"),addNestedMenuItem:c(t,"nestedmenuitem"),addToggleMenuItem:c(t,"togglemenuitem"),addAutocompleter:c(n,"autocompleter"),addContextMenu:c(r,"contextmenu"),addContextToolbar:c(s,"contexttoolbar"),addContextForm:(d=s,(e,t)=>{d[e.toLowerCase()]={type:"contextform",...t}}),addSidebar:c(i,"sidebar"),addView:c(l,"views"),addIcon:(e,t)=>o[e.toLowerCase()]=t,addContext:(e,t)=>a[e.toLowerCase()]=t,getAll:()=>({buttons:e,menuItems:t,icons:o,popups:n,contextMenus:r,contextToolbars:s,sidebars:i,views:l,contexts:a})};var d})();return{addAutocompleter:e.addAutocompleter,addButton:e.addButton,addContextForm:e.addContextForm,addContextMenu:e.addContextMenu,addContextToolbar:e.addContextToolbar,addIcon:e.addIcon,addMenuButton:e.addMenuButton,addMenuItem:e.addMenuItem,addNestedMenuItem:e.addNestedMenuItem,addSidebar:e.addSidebar,addSplitButton:e.addSplitButton,addToggleButton:e.addToggleButton,addGroupToolbarButton:e.addGroupToolbarButton,addToggleMenuItem:e.addToggleMenuItem,addView:e.addView,addContext:e.addContext,getAll:e.getAll}},qL=gi.DOM,WL=dn.extend,KL=dn.each;class YL{baseUri;id;editorUid;plugins={};documentBaseURI;baseURI;contentCSS=[];contentStyles=[];ui;mode;options;editorUpload;userLookup;shortcuts;loadedCSS={};editorCommands;suffix;editorManager;hidden;inline;hasVisual;isNotDirty=!1;annotator;bodyElement;bookmark;composing=!1;container;contentAreaContainer;contentDocument;contentWindow;delegates;destroyed=!1;dom;editorContainer;eventRoot;formatter;formElement;formEventDelegate;hasHiddenInput=!1;iframeElement=null;iframeHTML;initialized=!1;notificationManager;orgDisplay;orgVisibility;parser;quirks;readonly=!1;removed=!1;schema;selection;serializer;startContent="";targetElm;theme;model;undoManager;windowManager;licenseKeyManager;_beforeUnload;_eventDispatcher;_nodeChangeDispatcher;_pendingNativeEvents=[];_selectionOverrides;_skinLoaded=!1;_editableRoot=!0;bindPendingEventDelegates;toggleNativeEvent;unbindAllNativeEvents;fire;dispatch;on;off;once;hasEventListeners;constructor(e,t,n){this.editorManager=n,WL(this,AL);const o=this;this.id=e,this.editorUid=Me(),this.hidden=!1;const r=((e,t)=>{const n=Ue(t);return tL(YP||GP,YP,n,e,n)})(n.defaultOptions,t);this.options=((e,t,n=t)=>{const o={},r={},s=(e,t,n)=>{const o=BL(t,n);return OL(o)?(r[e]=o.value,!0):(console.warn(TL(`Invalid value passed for the ${e} option`,o)),!1)},a=e=>_e(o,e);return{register:(e,n)=>{const a=(e=>u(e.processor))(n)?(e=>{const t=(()=>{switch(e){case"array":return p;case"boolean":return b;case"function":return w;case"number":return S;case"object":return f;case"string":return u;case"string[]":return DL;case"object[]":return e=>E(e,f);case"regexp":return e=>m(e,RegExp);default:return M}})();return n=>BL(n,t,`The value must be a ${e}.`)})(n.processor):n.processor,i=((e,t,n)=>{if(!y(t)){const o=BL(t,n);if(OL(o))return o.value;console.error(TL(`Invalid default value passed for the "${e}" option`,o))}})(e,n.default,a);o[e]={...n,default:i,processor:a},xe(r,e).orThunk(()=>xe(t,e)).each(t=>s(e,t,a))},isRegistered:a,get:e=>xe(r,e).orThunk(()=>xe(o,e).map(e=>e.default)).getOrUndefined(),set:(e,t)=>{if(a(e)){const n=o[e];return n.immutable?(console.error(`"${e}" is an immutable option and cannot be updated`),!1):s(e,t,n.processor)}return console.warn(`"${e}" is not a registered option. Ensure the option has been registered before setting a value.`),!1},unset:e=>{const t=a(e);return t&&delete r[e],t},isSet:e=>_e(r,e),debug:()=>{try{console.log(JSON.parse(JSON.stringify(n,(e,t)=>b(t)||S(t)||u(t)||h(t)||p(t)||g(t)?t:Object.prototype.toString.call(t))))}catch(e){console.error(e)}}}})(0,r,t),(e=>{const t=e.options.register;t("id",{processor:"string",default:e.id}),t("selector",{processor:"string"}),t("target",{processor:"object"}),t("suffix",{processor:"string"}),t("cache_suffix",{processor:"string"}),t("base_url",{processor:"string"}),t("referrer_policy",{processor:"string",default:""}),t("crossorigin",{processor:"function",default:N(void 0)}),t("language_load",{processor:"boolean",default:!0}),t("inline",{processor:"boolean",default:!1}),t("iframe_attrs",{processor:"object",default:{}}),t("doctype",{processor:"string",default:"<!DOCTYPE html>"}),t("document_base_url",{processor:"string",default:e.editorManager.documentBaseURL}),t("body_id",{processor:pd(e,"tinymce"),default:"tinymce"}),t("body_class",{processor:pd(e),default:""}),t("content_security_policy",{processor:"string",default:""}),t("br_in_pre",{processor:"boolean",default:!0}),t("forced_root_block",{processor:e=>{const t=u(e)&&ot(e);return t?{value:e,valid:t}:{valid:!1,message:"Must be a non-empty string."}},default:"p"}),t("forced_root_block_attrs",{processor:"object",default:{}}),t("newline_behavior",{processor:e=>{const t=$(["block","linebreak","invert","default"],e);return t?{value:e,valid:t}:{valid:!1,message:"Must be one of: block, linebreak, invert or default."}},default:"default"}),t("br_newline_selector",{processor:"string",default:".mce-toc h2,figcaption,caption"}),t("no_newline_selector",{processor:"string",default:""}),t("keep_styles",{processor:"boolean",default:!0}),t("end_container_on_empty_block",{processor:e=>b(e)||u(e)?{valid:!0,value:e}:{valid:!1,message:"Must be boolean or a string"},default:"blockquote"}),t("font_size_style_values",{processor:"string",default:"xx-small,x-small,small,medium,large,x-large,xx-large"}),t("font_size_legacy_values",{processor:"string",default:"xx-small,small,medium,large,x-large,xx-large,300%"}),t("font_size_classes",{processor:"string",default:""}),t("automatic_uploads",{processor:"boolean",default:!0}),t("images_reuse_filename",{processor:"boolean",default:!1}),t("images_replace_blob_uris",{processor:"boolean",default:!0}),t("icons",{processor:"string",default:""}),t("icons_url",{processor:"string",default:""}),t("images_upload_url",{processor:"string",default:""}),t("images_upload_base_path",{processor:"string",default:""}),t("images_upload_credentials",{processor:"boolean",default:!1}),t("images_upload_handler",{processor:"function"}),t("language",{processor:"string",default:"en"}),t("language_url",{processor:"string",default:""}),t("entity_encoding",{processor:"string",default:"named"}),t("indent",{processor:"boolean",default:!0}),t("indent_before",{processor:"string",default:"p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,tfoot,tbody,tr,section,details,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist"}),t("indent_after",{processor:"string",default:"p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,tfoot,tbody,tr,section,details,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist"}),t("indent_use_margin",{processor:"boolean",default:!1}),t("indentation",{processor:"string",default:"40px"}),t("content_css",{processor:e=>{const t=!1===e||u(e)||E(e,u);return t?u(e)?{value:V(e.split(","),et),valid:t}:p(e)?{value:e,valid:t}:!1===e?{value:[],valid:t}:{value:e,valid:t}:{valid:!1,message:"Must be false, a string or an array of strings."}},default:fm(e)?[]:["default"]}),t("content_style",{processor:"string"}),t("content_language",{processor:"string"}),t("content_css_cors",{processor:"boolean",default:!1}),t("font_css",{processor:e=>{const t=u(e)||E(e,u);return t?{value:p(e)?e:V(e.split(","),et),valid:t}:{valid:!1,message:"Must be a string or an array of strings."}},default:[]}),t("extended_mathml_attributes",{processor:"string[]"}),t("extended_mathml_elements",{processor:"string[]"}),t("inline_boundaries",{processor:"boolean",default:!0}),t("inline_boundaries_selector",{processor:"string",default:"a[href],code,span.mce-annotation"}),t("object_resizing",{processor:e=>{const t=b(e)||u(e);return t?!1===e||cd.isiPhone()||cd.isiPad()?{value:"",valid:t}:{value:!0===e?"table,img,figure.image,div,video,iframe":e,valid:t}:{valid:!1,message:"Must be boolean or a string"}},default:!dd}),t("resize_img_proportional",{processor:"boolean",default:!0}),t("event_root",{processor:"string"}),t("service_message",{processor:"string"}),t("onboarding",{processor:"boolean",default:!0}),t("tiny_cloud_entry_url",{processor:"string"}),t("theme",{processor:e=>!1===e||u(e)||w(e),default:"silver"}),t("theme_url",{processor:"string"}),t("formats",{processor:"object"}),t("format_empty_lines",{processor:"boolean",default:!1}),t("format_noneditable_selector",{processor:"string",default:""}),t("preview_styles",{processor:e=>{const t=!1===e||u(e);return t?{value:!1===e?"":e,valid:t}:{valid:!1,message:"Must be false or a string"}},default:"font-family font-size font-weight font-style text-decoration text-transform color background-color border border-radius outline text-shadow"}),t("custom_ui_selector",{processor:"string",default:""}),t("hidden_input",{processor:"boolean",default:!0}),t("submit_patch",{processor:"boolean",default:!0}),t("encoding",{processor:"string"}),t("add_form_submit_trigger",{processor:"boolean",default:!0}),t("add_unload_trigger",{processor:"boolean",default:!0}),t("custom_undo_redo_levels",{processor:"number",default:0}),t("disable_nodechange",{processor:"boolean",default:!1}),t("disabled",{processor:t=>b(t)?(e.initialized&&fu(e)!==t&&Promise.resolve().then(()=>{((e,t)=>{e.dispatch("DisabledStateChange",{state:t})})(e,t)}),{valid:!0,value:t}):{valid:!1,message:"The value must be a boolean."},default:!1}),t("readonly",{processor:"boolean",default:!1}),t("editable_root",{processor:"boolean",default:!0}),t("plugins",{processor:"string[]",default:[]}),t("external_plugins",{processor:"object"}),t("forced_plugins",{processor:"string[]"}),t("model",{processor:"string",default:e.hasPlugin("rtc")?"plugin":"dom"}),t("model_url",{processor:"string"}),t("block_unsupported_drop",{processor:"boolean",default:!0}),t("visual",{processor:"boolean",default:!0}),t("visual_table_class",{processor:"string",default:"mce-item-table"}),t("visual_anchor_class",{processor:"string",default:"mce-item-anchor"}),t("iframe_aria_text",{processor:"string",default:"Rich Text Area".concat(e.hasPlugin("help")?". Press ALT-0 for help.":"")}),t("setup",{processor:"function"}),t("init_instance_callback",{processor:"function"}),t("url_converter",{processor:"function",default:e.convertURL}),t("url_converter_scope",{processor:"object",default:e}),t("urlconverter_callback",{processor:"function"}),t("allow_conditional_comments",{processor:"boolean",default:!1}),t("allow_html_data_urls",{processor:"boolean",default:!1}),t("allow_svg_data_urls",{processor:"boolean"}),t("allow_html_in_named_anchor",{processor:"boolean",default:!1}),t("allow_html_in_comments",{processor:"boolean",default:!1}),t("allow_script_urls",{processor:"boolean",default:!1}),t("allow_unsafe_link_target",{processor:"boolean",default:!1}),t("allow_mathml_annotation_encodings",{processor:e=>{const t=E(e,u);return t?{value:e,valid:t}:{valid:!1,message:"Must be an array of strings."}},default:[]}),t("convert_fonts_to_spans",{processor:"boolean",default:!0,deprecated:!0}),t("fix_list_elements",{processor:"boolean",default:!1}),t("preserve_cdata",{processor:"boolean",default:!1}),t("remove_trailing_brs",{processor:"boolean",default:!0}),t("pad_empty_with_br",{processor:"boolean",default:!1}),t("inline_styles",{processor:"boolean",default:!0,deprecated:!0}),t("element_format",{processor:"string",default:"html"}),t("entities",{processor:"string"}),t("schema",{processor:"string",default:"html5"}),t("convert_urls",{processor:"boolean",default:!0}),t("relative_urls",{processor:"boolean",default:!0}),t("remove_script_host",{processor:"boolean",default:!0}),t("custom_elements",{processor:gd}),t("extended_valid_elements",{processor:"string"}),t("invalid_elements",{processor:"string"}),t("invalid_styles",{processor:gd}),t("valid_children",{processor:"string"}),t("valid_classes",{processor:gd}),t("valid_elements",{processor:"string"}),t("valid_styles",{processor:gd}),t("verify_html",{processor:"boolean",default:!0}),t("auto_focus",{processor:e=>u(e)||!0===e}),t("browser_spellcheck",{processor:"boolean",default:!1}),t("protect",{processor:"array"}),t("images_file_types",{processor:"string",default:"jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp"}),t("deprecation_warnings",{processor:"boolean",default:!0}),t("a11y_advanced_options",{processor:"boolean",default:!1}),t("api_key",{processor:"string"}),t("license_key",{processor:"string"}),t("paste_block_drop",{processor:"boolean",default:!1}),t("paste_data_images",{processor:"boolean",default:!0}),t("paste_preprocess",{processor:"function"}),t("paste_postprocess",{processor:"function"}),t("paste_webkit_styles",{processor:"string",default:"none"}),t("paste_remove_styles_if_webkit",{processor:"boolean",default:!0}),t("paste_merge_formats",{processor:"boolean",default:!0}),t("smart_paste",{processor:"boolean",default:!0}),t("paste_as_text",{processor:"boolean",default:!1}),t("paste_tab_spaces",{processor:"number",default:4}),t("text_patterns",{processor:e=>E(e,f)||!1===e?{value:td(!1===e?[]:e),valid:!0}:{valid:!1,message:"Must be an array of objects or false."},default:[{start:"*",end:"*",format:"italic"},{start:"**",end:"**",format:"bold"},{start:"#",format:"h1",trigger:"space"},{start:"##",format:"h2",trigger:"space"},{start:"###",format:"h3",trigger:"space"},{start:"####",format:"h4",trigger:"space"},{start:"#####",format:"h5",trigger:"space"},{start:"######",format:"h6",trigger:"space"},{start:"1.",cmd:"InsertOrderedList",trigger:"space"},{start:"*",cmd:"InsertUnorderedList",trigger:"space"},{start:"-",cmd:"InsertUnorderedList",trigger:"space"},{start:">",cmd:"mceBlockQuote",trigger:"space"},{start:"---",cmd:"InsertHorizontalRule",trigger:"space"}]}),t("text_patterns_lookup",{processor:e=>{return w(e)?{value:(t=e,e=>{const n=t(e);return td(n)}),valid:!0}:{valid:!1,message:"Must be a single function"};var t},default:e=>[]}),t("allow_noneditable",{processor:"boolean",default:!0}),t("noneditable_class",{processor:"string",default:"mceNonEditable"}),t("editable_class",{processor:"string",default:"mceEditable"}),t("noneditable_regexp",{processor:e=>E(e,ud)?{value:e,valid:!0}:ud(e)?{value:[e],valid:!0}:{valid:!1,message:"Must be a RegExp or an array of RegExp."},default:[]}),t("table_tab_navigation",{processor:"boolean",default:!0}),t("highlight_on_focus",{processor:"boolean",default:!0}),t("xss_sanitization",{processor:"boolean",default:!0}),t("details_initial_state",{processor:e=>{const t=$(["inherited","collapsed","expanded"],e);return t?{value:e,valid:t}:{valid:!1,message:"Must be one of: inherited, collapsed, or expanded."}},default:"inherited"}),t("details_serialized_state",{processor:e=>{const t=$(["inherited","collapsed","expanded"],e);return t?{value:e,valid:t}:{valid:!1,message:"Must be one of: inherited, collapsed, or expanded."}},default:"inherited"}),t("init_content_sync",{processor:"boolean",default:!1}),t("newdocument_content",{processor:"string",default:""}),t("sandbox_iframes",{processor:"boolean",default:!0}),t("sandbox_iframes_exclusions",{processor:"string[]",default:["youtube.com","youtu.be","vimeo.com","player.vimeo.com","dailymotion.com","embed.music.apple.com","open.spotify.com","giphy.com","dai.ly","codepen.io"]}),t("convert_unsafe_embeds",{processor:"boolean",default:!0}),t("user_id",{processor:"string",default:"Anonymous"}),t("content_id",{processor:"string"}),t("fetch_users",{processor:e=>void 0===e?{valid:!0,value:void 0}:w(e)?{valid:!0,value:e}:{valid:!1,message:"fetch_users must be a function that returns a Promise<ExpectedUser[]>"}});const n=Fc([Hc("mimeType"),(o="extensions",s=e=>u(e)?Te.value(e):Te.error("Extensions must be an array of strings"),r=xc(e=>s(e).fold(Cc,vc)),jc(o,o,{tag:"required",process:{}},Ic(r)))]);var o,r,s;t("documents_file_types",{processor:e=>Uc("documents_file_types",n,e).fold(e=>({valid:!1,message:"Must be a non-empty array of objects matching the configuration schema: https://www.tiny.cloud/docs/tinymce/latest/uploadcare-documents/#documents-file-types"}),e=>({valid:!0,value:e}))}),e.on("ScriptsLoaded",()=>{t("directionality",{processor:"string",default:Ci.isRtl()?"rtl":void 0}),t("placeholder",{processor:"string",default:md.getAttrib(e.getElement(),"placeholder")})}),t("lists_indent_on_tab",{processor:"boolean",default:!0}),t("list_max_depth",{processor:e=>{const t=S(e);if(t){if(e<0)throw new Error("list_max_depth cannot be set to lower than 0");return{value:e,valid:t}}return{valid:!1,message:"Must be a number"}}})})(o),this.userLookup=(e=>{const t=new Map,n=new Map,o=e=>I.from(t.get(e)),r=(e,t)=>I.from(n.get(e)).each(({reject:o})=>{o(t),n.delete(e)}),s=gu(e);return Object.freeze({userId:s,fetchUsers:s=>{const a=pu(e);if(!Array.isArray(s))return{};if(!a)return ae(s,e=>Promise.resolve({id:e,name:e,avatar:HP({id:e,name:e})}));const i=fe(Y(s,e=>!o(e).isSome()));return q(i,e=>{const o=new Promise((t,o)=>{n.set(e,{resolve:t,reject:o})});((e,n)=>{t.set(n,e)})(o,e)}),i.length>0&&a(i).then(WP).then(e=>{const t=new Set(V(e,e=>e.id));q(e,e=>((e,t)=>I.from(n.get(e)).each(({resolve:o})=>{o(t),n.delete(e)}))(e.id,e)),q(i,e=>{t.has(e)||r(e,new Error(`User ${e} not found`))})}).catch(e=>{q(i,t=>r(t,e instanceof Error?e:new Error("Network error")))}),X(s,(e,t)=>(e[t]=o(t).getOr(Promise.resolve({id:t,name:t,avatar:HP({id:t,name:t})})),e),{})}})})(this);const s=this.options.get;s("deprecation_warnings")&&((e,t)=>{((e,t)=>{const n=DS(e),o=BS(t),r=o.length>0,s=n.length>0,a="mobile"===t.theme;if(r||s||a){const e="\n- ",t=a?`\n\nThemes:${e}mobile`:"",i=r?`\n\nPlugins:${e}${o.join(e)}`:"",l=s?`\n\nOptions:${e}${n.join(e)}`:"";console.warn("The following deprecated features are currently enabled and have been removed in TinyMCE 8.0. These features will no longer work and should be removed from the TinyMCE configuration. See https://www.tiny.cloud/docs/tinymce/8/migration-from-7x/ for more information."+t+i+l)}})(e,t),((e,t)=>{const n=TS(e),o=PS(t),r=o.length>0,s=n.length>0;if(r||s){const e="\n- ",t=r?`\n\nPlugins:${e}${o.map(LS).join(e)}`:"",a=s?`\n\nOptions:${e}${n.join(e)}`:"";console.warn("The following deprecated features are currently enabled but will be removed soon."+t+a)}})(e,t)})(t,r);const a=s("suffix");a&&(n.suffix=a),this.suffix=n.suffix;const i=s("base_url");i&&n._setBaseUrl(i),this.baseUri=n.baseURI;const l=zd(o);l&&(hi.ScriptLoader._setReferrerPolicy(l),gi.DOM.styleSheetLoader._setReferrerPolicy(l)),hi.ScriptLoader._setCrossOrigin(e=>jd(o)(e,"script")),gi.DOM.styleSheetLoader._setCrossOrigin(e=>jd(o)(e,"stylesheet"));const c=Sm(o);C(c)&&gi.DOM.styleSheetLoader._setContentCssCors(c),wi.languageLoad=s("language_load"),wi.baseURL=n.baseURL,this.setDirty(!1),this.documentBaseURI=new eS(yd(o),{base_uri:this.baseUri}),this.baseURI=this.baseUri,this.inline=fm(o),this.hasVisual=km(o),this.shortcuts=new HL(this),this.editorCommands=new vL(this),hL(this);const d=s("cache_suffix");d&&(sn.cacheSuffix=d.replace(/^[\?\&]+/,"")),this.ui={registry:VL(),styleSheetLoader:void 0,show:x,hide:x,setEnabled:x,isEnabled:M},this.mode=IL(o),Object.defineProperty(this,"editorUid",{writable:!1,configurable:!1,enumerable:!0}),n.dispatch("SetupEditor",{editor:this});const v=Dm(o);w(v)&&v.call(o,o)}render(){(e=>{const t=e.id;Ci.setCode($d(e));const n=()=>{FP.unbind(window,"ready",n),e.render()};if(!ri.Event.domLoaded)return void FP.bind(window,"ready",n);if(!e.getElement())return;const o=un.fromDom(e.getElement()),r=ko(o);e.on("remove",()=>{W(o.dom.attributes,e=>xo(o,e.name)),Co(o,r)}),e.ui.styleSheetLoader=((e,t)=>sa.forElement(e,{contentCssCors:Sm(t),referrerPolicy:zd(t)}))(o,e),fm(e)?e.inline=!0:(e.orgVisibility=e.getElement().style.visibility,e.getElement().style.visibility="hidden");const s=e.getElement().form||FP.getParent(t,"form");s&&(e.formElement=s,gm(e)&&!rs(e.getElement())&&(FP.insertAfter(FP.create("input",{type:"hidden",name:t}),t),e.hasHiddenInput=!0),e.formEventDelegate=t=>{e.dispatch(t.type,t)},FP.bind(s,"submit reset",e.formEventDelegate),e.on("reset",()=>{e.resetContent()}),!pm(e)||s.submit.nodeType||s.submit.length||s._mceOldSubmit||(s._mceOldSubmit=s.submit,s.submit=()=>(e.editorManager.triggerSave(),e.setDirty(!1),s._mceOldSubmit(s)))),e.windowManager=sx(e),e.notificationManager=nx(e),(e=>"xml"===e.options.get("encoding"))(e)&&e.on("GetContent",e=>{e.save&&(e.content=FP.encode(e.content))}),hm(e)&&e.on("submit",()=>{e.initialized&&e.save()}),bm(e)&&(e._beforeUnload=()=>{!e.initialized||e.destroyed||e.isHidden()||e.save({format:"raw",no_events:!0,set_dirty:!1})},e.editorManager.on("BeforeUnload",e._beforeUnload)),e.editorManager.add(e),jP(e,e.suffix)})(this)}focus(e){this.execCommand("mceFocus",!1,e)}hasFocus(){return Rp(this)}translate(e){return Ci.translate(e)}getParam(e,t,n){const o=this.options;return o.isRegistered(e)||(C(n)?o.register(e,{processor:n,default:t}):o.register(e,{processor:M,default:t})),o.isSet(e)||y(t)?o.get(e):t}hasPlugin(e,t){return!(!$(Em(this),e)||t&&void 0===ox.get(e))}nodeChanged(e){this._nodeChangeDispatcher.nodeChanged(e)}addCommand(e,t,n){this.editorCommands.addCommand(e,t,n)}addQueryStateHandler(e,t,n){this.editorCommands.addQueryStateHandler(e,t,n)}addQueryValueHandler(e,t,n){this.editorCommands.addQueryValueHandler(e,t,n)}addShortcut(e,t,n,o){this.shortcuts.add(e,t,n,o)}execCommand(e,t,n,o){return this.editorCommands.execCommand(e,t,n,o)}queryCommandState(e){return this.editorCommands.queryCommandState(e)}queryCommandValue(e){return this.editorCommands.queryCommandValue(e)}queryCommandSupported(e){return this.editorCommands.queryCommandSupported(e)}show(){const e=this;e.hidden&&(e.hidden=!1,e.inline?e.getBody().contentEditable="true":(qL.show(e.getContainer()),qL.hide(e.id)),e.load(),e.dispatch("show"))}hide(){const e=this;e.hidden||(e.save(),e.inline?(e.getBody().contentEditable="false",e===e.editorManager.focusedEditor&&(e.editorManager.focusedEditor=null)):(qL.hide(e.getContainer()),qL.setStyle(e.id,"display",e.orgDisplay)),e.hidden=!0,e.dispatch("hide"))}isHidden(){return this.hidden}setProgressState(e,t){this.dispatch("ProgressState",{state:e,time:t})}load(e={}){const t=this,n=t.getElement();if(!t.removed&&n){const o={...e,load:!0},r=rs(n)?n.value:n.innerHTML;t.setContent(r,o),o.no_events||t.dispatch("LoadContent",{...o,element:n})}}save(e={}){const t=this;let n=t.getElement();if(!n||!t.initialized||t.removed)return"";const o={...e,save:!0,element:n};let r=t.getContent(o);const s={...o,content:r};if(s.no_events||t.dispatch("SaveContent",s),"raw"===s.format&&t.dispatch("RawSaveContent",s),r=s.content,rs(n))n.value=r;else{!e.is_removing&&t.inline||(n.innerHTML=r);const o=qL.getParent(t.id,"form");o&&KL(o.elements,e=>e.name!==t.id||(e.value=r,!1))}return s.element=o.element=n=null,!1!==s.set_dirty&&t.setDirty(!1),r}setContent(e,t){qE(this,e,t)}getContent(e){return((e,t={})=>{const n=((e,t)=>({...e,format:t,get:!0,getInner:!0}))(t,t.format?t.format:"html");return wS(e,n).fold(R,t=>{const n=((e,t)=>ME(e).editor.getContent(t))(e,t);return SS(e,n,t)})})(this,e)}insertContent(e,t){t&&(e=WL({content:e},t)),this.execCommand("mceInsertContent",!1,e)}resetContent(e){void 0===e?qE(this,this.startContent,{initial:!0,format:"raw"}):qE(this,e,{initial:!0}),this.undoManager.reset(),this.setDirty(!1),this.nodeChanged()}isDirty(){return!this.isNotDirty}setDirty(e){const t=!this.isNotDirty;this.isNotDirty=!e,e&&e!==t&&this.dispatch("dirty")}getContainer(){const e=this;return e.container||(e.container=e.editorContainer||qL.get(e.id+"_parent")),e.container}getContentAreaContainer(){return this.contentAreaContainer}getElement(){return this.targetElm||(this.targetElm=qL.get(this.id)),this.targetElm}getWin(){const e=this;if(!e.contentWindow){const t=e.iframeElement;t&&(e.contentWindow=t.contentWindow)}return e.contentWindow}getDoc(){const e=this;if(!e.contentDocument){const t=e.getWin();t&&(e.contentDocument=t.document)}return e.contentDocument}getBody(){const e=this.getDoc();return this.bodyElement??e?.body??null}convertURL(e,t,n){const o=this,r=o.options.get,s=Om(o);if(w(s))return s.call(o,e,n,!0,t);if(!r("convert_urls")||"link"===n||f(n)&&"LINK"===n.nodeName||0===e.indexOf("file:")||0===e.length)return e;const a=new eS(e);return"http"!==a.protocol&&"https"!==a.protocol&&""!==a.protocol?e:r("relative_urls")?o.documentBaseURI.toRelative(e):e=o.documentBaseURI.toAbsolute(e,r("remove_script_host"))}addVisual(e){((e,t)=>{((e,t)=>{IE(e).editor.addVisual(t)})(e,t)})(this,e)}setEditableRoot(e){((e,t)=>{e._editableRoot!==t&&(e._editableRoot=t,Ax(e)||(e.getBody().contentEditable=String(e.hasEditableRoot()),e.nodeChanged()),((e,t)=>{e.dispatch("EditableRootStateChange",{state:t})})(e,t))})(this,e)}hasEditableRoot(){return this._editableRoot}announce(e,t){ap.announce(e,t)}remove(){(e=>{if(!e.removed){const{_selectionOverrides:t,editorUpload:n}=e,o=e.getBody(),r=e.getElement();o&&e.save({is_removing:!0}),e.removed=!0,e.unbindAllNativeEvents(),e.hasHiddenInput&&C(r?.nextSibling)&&WE.remove(r.nextSibling),(e=>{e.dispatch("remove")})(e),e.editorManager.remove(e),!e.inline&&o&&(e=>{WE.setStyle(e.id,"display",e.orgDisplay)})(e),(e=>{e.dispatch("detach")})(e),WE.remove(e.getContainer()),KE(t),KE(n),e.destroy()}})(this)}destroy(e){((e,t)=>{const{selection:n,dom:o}=e;e.destroyed||(t||e.removed?(t||(e.editorManager.off("beforeunload",e._beforeUnload),e.theme&&e.theme.destroy&&e.theme.destroy(),KE(n),KE(o)),(e=>{const t=e.formElement;t&&(t._mceOldSubmit&&(t.submit=t._mceOldSubmit,delete t._mceOldSubmit),WE.unbind(t,"submit reset",e.formEventDelegate))})(e),(e=>{const t=e;t.contentAreaContainer=t.formElement=t.container=t.editorContainer=null,t.bodyElement=t.contentDocument=t.contentWindow=null,t.iframeElement=t.targetElm=null;const n=e.selection;if(n){const e=n.dom;t.selection=n.win=n.dom=e.doc=null}})(e),e.destroyed=!0):e.remove())})(this,e)}uploadImages(){return this.editorUpload.uploadImages()}_scanForImages(){return this.editorUpload.scanForImages()}}const GL=gi.DOM,XL=dn.each;let QL,ZL=!1,JL=[];const eM=e=>{const t=e.type;XL(rM.get(),n=>{switch(t){case"scroll":n.dispatch("ScrollWindow",e);break;case"resize":n.dispatch("ResizeWindow",e)}})},tM=e=>{if(e!==ZL){const t=gi.DOM;e?(t.bind(window,"resize",eM),t.bind(window,"scroll",eM)):(t.unbind(window,"resize",eM),t.unbind(window,"scroll",eM)),ZL=e}},nM=e=>{const t=JL;return JL=Y(JL,t=>e!==t),rM.activeEditor===e&&(rM.activeEditor=JL.length>0?JL[0]:null),rM.focusedEditor===e&&(rM.focusedEditor=null),t.length!==JL.length},oM="CSS1Compat"!==document.compatMode,rM={...EL,baseURI:null,baseURL:null,defaultOptions:{},documentBaseURL:null,suffix:null,pageUid:Me(),majorVersion:"8",minorVersion:"10.0",releaseDate:"2026-10-14",i18n:Ci,activeEditor:null,focusedEditor:null,setup(){const e=this;let t="",n="",o=eS.getDocumentBaseUrl(document.location);/^[^:]+:\/\/\/?[^\/]+\//.test(o)&&(o=o.replace(/[\?#].*$/,"").replace(/[\/\\][^\/]+$/,""),/[\/\\]$/.test(o)||(o+="/"));const r=window.tinymce||window.tinyMCEPreInit;if(r)t=r.base||r.baseURL,n=r.suffix;else{const e=document.getElementsByTagName("script");for(let o=0;o<e.length;o++){const r=e[o].src||"";if(""===r)continue;const s=r.substring(r.lastIndexOf("/"));if(/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(r)){-1!==s.indexOf(".min")&&(n=".min"),t=r.substring(0,r.lastIndexOf("/"));break}}if(!t&&document.currentScript){const e=document.currentScript.src;-1!==e.indexOf(".min")&&(n=".min"),t=e.substring(0,e.lastIndexOf("/"))}}var s;e.baseURL=new eS(o).toAbsolute(t),e.documentBaseURL=o,e.baseURI=new eS(e.baseURL),e.suffix=n,(s=e).on("AddEditor",D(xp,s)),s.on("RemoveEditor",D(_p,s)),q(["majorVersion","minorVersion","releaseDate","pageUid","_addLicenseKeyManager"],t=>Object.defineProperty(e,t,{writable:!1,configurable:!1,enumerable:!0}))},overrideDefaults(e){const t=e.base_url;t&&this._setBaseUrl(t);const n=e.suffix;n&&(this.suffix=n),this.defaultOptions=e;const o=e.plugin_base_urls;void 0!==o&&he(o,(e,t)=>{wi.PluginManager.urls[t]=e})},init(e){const t=this;let n;const o=dn.makeMap("area base basefont br col frame hr img input isindex link meta param embed source wbr track colgroup option table tbody tfoot thead tr th td script noscript style textarea video audio iframe object menu"," ");let r=e=>{n=e};const s=()=>{let n=0;const a=[];let i;GL.unbind(window,"ready",s),(()=>{const n=e.onpageload;n&&n.apply(t,[])})(),i=fe((e=>sn.browser.isIE()||sn.browser.isEdge()?(dx("TinyMCE does not support the browser you are using. For a list of supported browsers please see: https://www.tiny.cloud/docs/tinymce/8/support/#supportedwebbrowsers"),[]):oM?(dx("Failed to initialize the editor as the document is not in standards mode. TinyMCE requires standards mode."),[]):u(e.selector)?GL.select(e.selector):C(e.target)?[e.target]:[])(e)),dn.each(i,e=>{var n;(n=t.get(e.id))&&n.initialized&&!(n.getContainer()||n.getBody()).parentNode&&(nM(n),n.unbindAllNativeEvents(),n.destroy(!0),n.removed=!0)}),i=dn.grep(i,e=>!t.get(e.id)),0===i.length?r([]):XL(i,s=>{((e,t)=>e.inline&&t.tagName.toLowerCase()in o)(e,s)?dx("Could not initialize inline editor on invalid inline target element",s):((e,o,s)=>{const l=new YL(e,o,t);a.push(l),l.on("init",()=>{++n===i.length&&r(a)}),l.targetElm=l.targetElm||s,l.render()})((e=>{let t=e.id;return t||(t=xe(e,"name").filter(e=>!GL.get(e)).getOrThunk(GL.uniqueId),e.setAttribute("id",t)),t})(s),e,s)})};return GL.bind(window,"ready",s),new Promise(e=>{n?e(n):r=t=>{e(t)}})},get(e){return 0===arguments.length?JL.slice(0):u(e)?Z(JL,t=>t.id===e).getOr(null):S(e)&&JL[e]?JL[e]:null},add(e){const t=this,n=t.get(e.id);return n===e||(null===n&&JL.push(e),tM(!0),t.activeEditor=e,t.dispatch("AddEditor",{editor:e}),QL||(QL=e=>{const n=t.dispatch("BeforeUnload");if(n.returnValue)return e.preventDefault(),e.returnValue=n.returnValue,n.returnValue},window.addEventListener("beforeunload",QL))),e},createEditor(e,t){return this.add(new YL(e,t,this))},remove(e){const t=this;let n;if(e){if(!u(e))return n=e,h(t.get(n.id))?null:(nM(n)&&t.dispatch("RemoveEditor",{editor:n}),0===JL.length&&window.removeEventListener("beforeunload",QL),n.remove(),tM(JL.length>0),n);XL(GL.select(e),e=>{n=t.get(e.id),n&&t.remove(n)})}else for(let e=JL.length-1;e>=0;e--)t.remove(JL[e])},execCommand(e,t,n){const o=this,r=f(n)?n.id??n.index:n;switch(e){case"mceAddEditor":if(!o.get(r)){const e=n.options;new YL(r,e,o).render()}return!0;case"mceRemoveEditor":{const e=o.get(r);return e&&e.remove(),!0}case"mceToggleEditor":{const e=o.get(r);return e?(e.isHidden()?e.show():e.hide(),!0):(o.execCommand("mceAddEditor",!1,n),!0)}}return!!o.activeEditor&&o.activeEditor.execCommand(e,t,n)},triggerSave:()=>{XL(JL,e=>{e.save()})},addI18n:(e,t)=>{Ci.add(e,t)},translate:e=>Ci.translate(e),setActive(e){const t=this.activeEditor;this.activeEditor!==e&&(t&&t.dispatch("deactivate",{relatedTarget:e}),e.dispatch("activate",{relatedTarget:t})),this.activeEditor=e},_setBaseUrl(e){this.baseURL=new eS(this.documentBaseURL).toAbsolute(e.replace(/\/+$/,"")),this.baseURI=new eS(this.baseURL)},_addLicenseKeyManager:e=>xx.add(e)};rM.setup();const sM=(()=>{const e=Ke();return{FakeClipboardItem:e=>({items:e,types:ge(e),getType:t=>xe(e,t).getOrUndefined()}),write:t=>{e.set(t)},read:()=>e.get().getOrUndefined(),clear:e.clear}})(),aM=Math.min,iM=Math.max,lM=Math.round,cM=(e,t,n)=>{let o=t.x,r=t.y;const s=e.w,a=e.h,i=t.w,l=t.h,c=(n||"").split("");return"b"===c[0]&&(r+=l),"r"===c[1]&&(o+=i),"c"===c[0]&&(r+=lM(l/2)),"c"===c[1]&&(o+=lM(i/2)),"b"===c[3]&&(r-=a),"r"===c[4]&&(o-=s),"c"===c[3]&&(r-=lM(a/2)),"c"===c[4]&&(o-=lM(s/2)),dM(o,r,s,a)},dM=(e,t,n,o)=>({x:e,y:t,w:n,h:o}),mM={inflate:(e,t,n)=>dM(e.x-t,e.y-n,e.w+2*t,e.h+2*n),relativePosition:cM,findBestRelativePosition:(e,t,n,o)=>{for(let r=0;r<o.length;r++){const s=cM(e,t,o[r]);if(s.x>=n.x&&s.x+s.w<=n.w+n.x&&s.y>=n.y&&s.y+s.h<=n.h+n.y)return o[r]}return null},intersect:(e,t)=>{const n=iM(e.x,t.x),o=iM(e.y,t.y),r=aM(e.x+e.w,t.x+t.w),s=aM(e.y+e.h,t.y+t.h);return r-n<0||s-o<0?null:dM(n,o,r-n,s-o)},clamp:(e,t,n)=>{let o=e.x,r=e.y,s=e.x+e.w,a=e.y+e.h;const i=t.x+t.w,l=t.y+t.h,c=iM(0,t.x-o),d=iM(0,t.y-r),m=iM(0,s-i),u=iM(0,a-l);return o+=c,r+=d,n&&(s+=c,a+=d,o-=m,r-=u),s-=m,a-=u,dM(o,r,s-o,a-r)},create:dM,fromClientRect:e=>dM(e.left,e.top,e.width,e.height)},uM=(()=>{const e={},t={},n={};return{load:(n,o)=>{const r=`Script at URL "${o}" failed to load`,s=`Script at URL "${o}" did not call \`tinymce.Resource.add('${n}', data)\` within 1 second`;if(void 0!==e[n])return e[n];{const a=new Promise((e,a)=>{const i=((e,t,n=1e3)=>{let o=!1,r=null;const s=e=>(...t)=>{o||(o=!0,null!==r&&(window.clearTimeout(r),r=null),e.apply(null,t))},a=s(e),i=s(t);return{start:(...e)=>{o||null!==r||(r=window.setTimeout(()=>i.apply(null,e),n))},resolve:a,reject:i}})(e,a);t[n]=i.resolve,hi.ScriptLoader.loadScript(o).then(()=>i.start(s),()=>i.reject(r))});return e[n]=a,a}},add:(o,r)=>{void 0!==t[o]&&(t[o](r),delete t[o]),e[o]=Promise.resolve(r),n[o]=r},has:e=>e in n,get:e=>n[e],unload:t=>{delete e[t],delete n[t]}}})();let fM;try{const e="__storage_test__";fM=window.localStorage,fM.setItem(e,e),fM.removeItem(e)}catch{fM=(()=>{let e={},t=[];const n={getItem:t=>e[t]||null,setItem:(n,o)=>{t.push(n),e[n]=String(o)},key:e=>t[e],removeItem:n=>{t=t.filter(e=>e===n),delete e[n]},clear:()=>{t=[],e={}},length:0};return Object.defineProperty(n,"length",{get:()=>t.length,configurable:!1,enumerable:!1}),n})()}const gM={geom:{Rect:mM},util:{Delay:yp,Tools:dn,VK:Tp,URI:eS,EventDispatcher:wL,Observable:EL,I18n:Ci,LocalStorage:fM,ImageUploader:e=>{const t=Fx(),n=$x(e,t);return{upload:(t,o=!0)=>n.upload(t,o?jx(e):void 0)}}},dom:{EventUtils:ri,TreeWalker:Kr,TextSeeker:Pi,DOMUtils:gi,ScriptLoader:hi,RangeUtils:Gp,Serializer:VE,StyleSheetLoader:ra,ControlSelection:Ip,BookmarkManager:ip,Selection:jE,AriaAnnouncer:ap,Event:ri.Event},html:{Styles:Ga,Entities:Sa,Node:xh,Schema:Ua,DomParser:bS,Writer:$h,Serializer:Hh},Env:sn,AddOnManager:wi,Annotator:Jg,Formatter:e_,UndoManager:n_,EditorCommands:vL,WindowManager:sx,NotificationManager:nx,EditorObservable:AL,Shortcuts:HL,Editor:YL,FocusManager:bp,EditorManager:rM,DOM:gi.DOM,ScriptLoader:hi.ScriptLoader,PluginManager:ox,ThemeManager:rx,ModelManager:GE,IconManager:YE,Resource:uM,FakeClipboard:sM,trim:dn.trim,isArray:dn.isArray,is:dn.is,toArray:dn.toArray,makeMap:dn.makeMap,each:dn.each,map:dn.map,grep:dn.grep,inArray:dn.inArray,extend:dn.extend,walk:dn.walk,resolve:dn.resolve,explode:dn.explode,_addCacheSuffix:dn._addCacheSuffix},pM=dn.extend(rM,gM);(e=>{window.tinymce=e,window.tinyMCE=e})(pM),(e=>{if("object"==typeof module)try{module.exports=e}catch{}})(pM)}();